webpackJsonp([4],{

/***/ "./config/index.js":
/***/ (function(module, exports, __webpack_require__) {

// We don't want to include the contents of client.config.js in the production
// webpack build, as it will be modified by chef post-build.
//
// When this file is required server-side, it will use the values from
// client.config.js directly. When the file is required client-side,
// it will look for the values in __config global var that will be
// injected into HTML markup by the server.
module.exports =  true ? window.__config : require('./client.config');


/***/ }),

/***/ "./package.json":
/***/ (function(module, exports) {

module.exports = {"name":"jg-crowdfunding-website","version":"b9e8222","description":"The artist formerly known as Yimby","main":"index.js","scripts":{"start:docker":"node ./bin/server.js","start":"cross-env NODE_ENV=production node ./bin/server.js | bunyan -o short -L","start:inspect":"cross-env NODE_ENV=production node --inspect-brk ./bin/server.js | bunyan -o short -L","start:watch":"cross-env NODE_ENV=production nodemon --watch dist-server --watch stats.json --watch config --exec 'yarn start'","start:cypress":"cross-env NODE_ENV=development yarn run build:server:dev && cross-env APP_ENV=cypress NO_USER_CONFIG=true node ./bin/server.js | bunyan -o short -L","dev":"cross-env NODE_ENV=development yarn run build:server:dev && node ./bin/server.js | bunyan -o short -L","test":"jest","test:watch":"yarn run test -- --watch","test:clearCache":"rimraf $(./node_modules/jest/bin/jest.js --showConfig | json '.configs[0].cacheDirectory')","clean:client":"rimraf ./static/dist","clean:server":"rimraf ./dist-server","build":"yarn run build:server && yarn run build:client","build:client":"yarn run clean:client && cross-env NODE_ENV=production webpack --config ./config/webpack.prod.config.js","build:client:dev":"yarn run clean:client && cross-env NODE_ENV=development webpack --config ./config/webpack.prod.config.js","build:client:watch":"NODE_ENV=development webpack --config ./config/webpack.prod.config.js --watch","build:server":"cross-env NODE_ENV=production webpack --config ./config/webpack.server.config.js","build:server:dev":"cross-env NODE_ENV=development webpack --config ./config/webpack.server.config.js --display errors-only","build:server:watch":"cross-env NODE_ENV=production webpack --config ./config/webpack.server.config.js --watch","lint":"tslint -p tsconfig.json -t stylish -c ./tslint.ci.json","ts":"tsc --noEmit --pretty","ts:check":"echo \"Please use \\033[0;31myarn ts\\033[0m instead\"","ts:lint":"echo \"Please use \\033[0;31myarn lint\\033[0m instead\"","prepare-env":"node ./bin/prepare-env.js","cypress":"yarn cypress:install && yarn cypress:run","cypress:open":"cd cypress && yarn && node_modules/.bin/cypress open","cypress:install":"cd cypress && yarn && node_modules/.bin/cypress cache clear && node_modules/.bin/cypress install","cypress:run":"cd cypress && node_modules/.bin/cypress run","postinstall":"yarn prepare-env","prettier":"prettier --single-quote --trailing-comma es5 --parser typescript --write \"{src,tests}/**/*.{js,ts,tsx}\"","i18n:check":"i18n-cli check","i18n:extract":"i18n-cli extract"},"repository":{"type":"git","url":"git+https://github.com/JustGiving/JG.Crowdfunding.Website.git"},"keywords":["crowdfunding"],"author":"Crowdfunding Team <crowdfundingteam@justgiving.com>","license":"UNLICENSED","bugs":{"url":"https://justgiving.atlassian.net/secure/RapidBoard.jspa?rapidView=113"},"homepage":"https://github.com/JustGiving/JG.Crowdfunding.Website#readme","dependencies":{"@justgiving/alert":"^2.0.40","@justgiving/auth":"^5.1.3","@justgiving/character-count":"^1.0.25","@justgiving/chrome":"^3.0.0","@justgiving/chrome-react":"^2.0.0","@justgiving/copy-to-clipboard":"^1.0.41","@justgiving/date-picker":"^2.0.40","@justgiving/dna-button":"^0.37.2","@justgiving/dna-card":"^2.0.1","@justgiving/dna-core":"^0.72.2","@justgiving/dna-form":"0.14.1","@justgiving/dna-progress":"^2.0.1","@justgiving/dna-typography":"^0.10.0","@justgiving/donate-button":"^1.0.30","@justgiving/experiments":"1.4.0","@justgiving/icons":"^1.2.10","@justgiving/justgiving-bundle-global-css":"^0.2.3","@justgiving/justgiving-bundle-head-js":"^0.1.0","@justgiving/koala-front-end-analytics":"^2.0.28","@justgiving/koala-server":"^2.0.28","@justgiving/loading":"^1.0.25","@justgiving/local-tls-cert":"^1.2.2","@justgiving/logger":"^2.0.0","@justgiving/password-input":"^2.0.3","@justgiving/react-avatar-editor":"^9.1.6","@justgiving/responsive":"^1.0.24","@justgiving/select":"^1.0.45","@justgiving/selection-list":"^1.0.45","@justgiving/status":"^2.0.0","@justgiving/stick-to-footer":"^1.0.24","@justgiving/styles":"^7.0.0","@justgiving/svg":"^1.0.26","@justgiving/tooltip":"^1.1.39","@justgiving/totaliser":"^2.1.3","@types/set-cookie-parser":"^0.0.5","@vx/axis":"^0.0.158","@vx/grid":"^0.0.158","@vx/group":"^0.0.153","@vx/point":"^0.0.153","@vx/scale":"^0.0.153","@vx/shape":"^0.0.158","apollo-link":"^1.2.14","apollo-link-http":"^1.5.17","bluebird":"^3.5.0","bunyan-logstash-tcp":"^0.3.5","classnames":"^2.2.5","compression":"^1.6.2","continuation-local-storage":"^3.2.0","cookie-parser":"^1.4.3","cookies-js":"^1.2.3","core-js":"^2.5.1","cors":"^2.8.4","d3-array":"^1.2.1","d3-format":"^1.2.2","d3-time-format":"^2.1.1","date-fns":"^1.28.5","downshift":"^1.22.3","element-closest":"^2.0.1","express":"^4.15.2","formik":"^1.2.0","graphql":"^14.0.0","graphql-tag":"^2.10.3","history":"^4.6.2","hoist-non-react-statics":"^1.2.0","i18next":"^12.1.0","i18next-express-middleware":"^1.5.0","i18next-node-fs-backend":"^2.1.0","import-inspector":"^2.0.0","intl":"^1.2.5","isomorphic-fetch":"^2.2.1","jsonwebtoken":"^7.3.0","jwt-decode":"^2.2.0","lodash":"^4.17.21","moment":"^2.18.1","nock":"^9.2.5","node-uuid":"^1.4.8","pdfmake":"^0.1.36","prom-client":"^10.2.3","promise-retry":"^1.1.1","prop-types":"^15.6.0","pug":"^2.0.0-rc.3","qs":"^6.4.0","raven-for-redux":"^1.3.1","raven-js":"^3.25.2","rc-collapse":"^1.7.6","react":"^16.13.1","react-animate-height":"^0.9.9","react-clipboard.js":"^2.0.1","react-css-modules":"^4.7.11","react-datepicker":"^0.61.0","react-dates":"^15.3","react-dom":"^16.13.1","react-dropzone":"^3.6.0","react-geosuggest":"^2.5.0","react-helmet":"^5.0.2","react-hot-loader":"3.1.1","react-i18next":"^8.3.8","react-input-mask":"^1.0.7","react-intl":"^2.1.5","react-loadable":"^4.0.3","react-portal":"^4.0.0-beta.2","react-recaptcha":"^2.1.1","react-redux":"^5.0.6","react-router":"^4.1.1","react-router-config":"^1.0.0-beta.3","react-router-dom":"^4.1.1","react-router-redux":"^5.0.0-alpha.8","react-scroll":"^1.5.4","react-text-mask":"^5.0.2","react-waypoint":"^7.1.0","react-youtube":"^7.3.0","redbox-react":"^1.5.0","redis":"^2.7.1","redux":"^3.6.0","redux-co":"^1.0.0","redux-form":"7.3.0","redux-logger":"^2.6.1","redux-thunk":"^2.2.0","scriptjs":"^2.5.8","serialize-javascript":"^3.1.0","serve-favicon":"^2.4.2","set-cookie-parser":"^2.3.8","slate":"0.20.6","spin.js":"^2.3.2","statsd-client":"^0.2.4","superagent":"^3.5.2","url-join":"^1.1.0","webpack-flush-chunks":"^1.0.10","window.requestanimationframe":"^1.0.1"},"devDependencies":{"@justgiving/bundle-size-report":"^1.3.0","@justgiving/code-checks-sdk":"^1.1.1","@justgiving/i18n-cli":"^3.1.0","@testing-library/react":"9.0.0","@types/bluebird":"^3.5.8","@types/body-parser":"^1.16.8","@types/classnames":"^2.2.0","@types/compression":"^0.0.35","@types/continuation-local-storage":"^3.2.1","@types/cookie-parser":"^1.4.1","@types/cors":"^2.8.3","@types/d3-array":"^1.2.1","@types/d3-format":"^1.2.1","@types/d3-scale":"^2.0.0","@types/d3-time-format":"^2.1.0","@types/enzyme":"^3.1.13","@types/expect":"^1.20.1","@types/express":"^4.0.36","@types/facebook-js-sdk":"^3.3.0","@types/history":"^4.6.1","@types/i18next":"^12.1.0","@types/i18next-express-middleware":"^0.0.33","@types/i18next-node-fs-backend":"^0.0.30","@types/invariant":"^2.2.29","@types/jest":"^23.3.1","@types/jsonwebtoken":"7.2.0","@types/jwt-decode":"^2.2.1","@types/lodash":"^4.14.71","@types/mockdate":"^2.0.0","@types/moment":"^2.13.0","@types/nock":"^9.1.3","@types/node-fetch":"^1.6.7","@types/prop-types":"^15.5.2","@types/qs":"^6.5.0","@types/raven-for-redux":"^1.1.0","@types/react":"^16.9.34","@types/react-css-modules":"^4.6.2","@types/react-dates":"^17.1.5","@types/react-dom":"^16.9.6","@types/react-dropzone":"^3.13.1","@types/react-helmet":"^5.0.3","@types/react-i18next":"^8.1.0","@types/react-input-mask":"^0.7.7","@types/react-intl":"^2.2.6","@types/react-loadable":"^4.0.4","@types/react-modal":"^3.1.1","@types/react-redux":"^5.0.12","@types/react-router":"^4.0.14","@types/react-router-config":"^1.0.3","@types/react-router-dom":"^4.0.7","@types/react-router-redux":"^5.0.5","@types/react-scroll":"^1.5.1","@types/redis":"^2.6.0","@types/redux":"^3.6.0","@types/redux-form":"^7.2.6","@types/redux-mock-store":"^0.0.9","@types/serialize-javascript":"^1.3.1","@types/serve-favicon":"^2.2.30","@types/superagent":"^3.5.3","@types/url-join":"^0.8.2","@types/webpack":"^3.8.1","autoprefixer":"^7.1.2","body-parser":"^1.18.2","bunyan":"^1.8.12","chalk":"^1.1.3","cheerio":"^1.0.0-rc.2","cross-env":"^5.2.0","css-loader":"^0.28.7","enzyme":"^3.5.0","enzyme-adapter-react-16":"^1.0.0","enzyme-to-json":"^3.3.4","extract-text-webpack-plugin":"^3.0.0","file-loader":"^0.11.2","gzip-size":"^4.1.0","jest":"^23.5.0","jest-enzyme":"^6.0.4","jest-html-reporter":"^2.4.2","jest-junit":"^10.0.0","jest-watch-typeahead":"^0.2.0","jsdom":"^11.9.0","json":"^9.0.6","less":"^2.7.2","less-loader":"2.2.3","mockdate":"^2.0.2","node-gyp":"^6.1.0","node-sass":"4.13.1","nodemon":"^1.10.2","null-loader":"^0.1.1","path-to-regexp":"^1.7.0","postcss-loader":"^2.0.6","prettier":"^1.14.0","raw-loader":"^0.5.1","redux-mock-store":"^1.2.3","resolve-url-loader":"^2.1.0","rimraf":"^2.6.1","sass-loader":"^6.0.6","source-map-explorer":"^1.4.0","stats-webpack-plugin":"^0.6.1","style-loader":"^0.18.2","svg-inline-loader":"^0.8.0","ts-jest":"^22.4.2","ts-loader":"^3.5.0","tslint":"^5.11.0","tslint-config-prettier":"^1.14.0","tslint-eslint-rules":"^5.3.1","tslint-plugin-prettier":"^1.3.0","tslint-react":"^3.6.0","typescript":"^3.0.1","url-loader":"^0.5.9","webpack":"^3.4.1","webpack-bundle-analyzer":"^2.12.0","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.18.2","webpack-node-externals":"^1.6.0","xmlbuilder":"^8.2.2"},"resolutions":{"@types/history":"^4.6.1","rc-animate":"^2.4.1"},"jest":{"testURL":"https://www.local.justgiving.com:3000","watchPlugins":["jest-watch-typeahead/filename","jest-watch-typeahead/testname"],"moduleFileExtensions":["ts","tsx","js"],"moduleDirectories":["node_modules","<rootDir>"],"setupTestFrameworkScriptFile":"<rootDir>/node_modules/jest-enzyme/lib/index.js","transform":{"\\.(js|ts|tsx)$":"<rootDir>/node_modules/ts-jest/preprocessor.js","\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$":"<rootDir>/tests/infrastructure/jest-script-image-preprocessor.js","\\.(css|less|scss)$":"<rootDir>/tests/infrastructure/jest-script-styles-preprocessor.js"},"transformIgnorePatterns":["<rootDir>/node_modules/(?!@justgiving)"],"roots":["src","tests"],"globals":{"__CLIENT__":false,"__SERVER__":false,"__DEVELOPMENT__":false,"__TESTS__":true},"testRegex":"\\.spec\\.(js|ts|tsx)$","testPathIgnorePatterns":["cypress"],"testResultsProcessor":"<rootDir>/tests/infrastructure/jest-junit-reporter","setupFiles":["<rootDir>/tests/helpers/polyfill-jsdom.js","<rootDir>/tests/helpers/enzyme-config.js"],"collectCoverageFrom":["**/*.{js,ts,tsx}","!**/node_modules/**","!src/routes.{js,ts}"],"coveragePathIgnorePatterns":["<rootDir>/node_modules/","<rootDir>/tests"],"coverageThreshold":{"global":{"branches":30,"functions":35,"lines":45,"statements":35}},"snapshotSerializers":["<rootDir>/node_modules/enzyme-to-json/serializer"]},"prettier":{"singleQuote":true,"trailingComma":"es5"}}

/***/ }),

/***/ "./src/client.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js__ = __webpack_require__("./node_modules/core-js/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_requestanimationframe__ = __webpack_require__("./node_modules/window.requestanimationframe/requestanimationframe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_window_requestanimationframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_window_requestanimationframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__("./node_modules/url/url.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__("./node_modules/raven-js/src/singleton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__ = __webpack_require__("./node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_for_redux__ = __webpack_require__("./node_modules/raven-for-redux/built/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_for_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_for_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__client_createStore__ = __webpack_require__("./src/client/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_middleware__ = __webpack_require__("./src/redux/middleware/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__client_root__ = __webpack_require__("./src/client/root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__("./package.json");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_url_join__ = __webpack_require__("./node_modules/url-join/lib/url-join.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_url_join__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};













if (true) {
    __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.config(__WEBPACK_IMPORTED_MODULE_7_config__["SENTRY_URL"], {
        release: __WEBPACK_IMPORTED_MODULE_11__package_json___default.a.version,
        environment: 'production',
        whitelistUrls: [/justgiving\.com/, /jg-cdn\.com/],
        sampleRate: 0.1,
        ignoreErrors: [
            "this.onready is not a function. (In 'this.onready(a)', 'this.onready' is undefined)",
            'Blocked a frame with origin ',
            'twttr.conversion.trackPid',
        ],
    }).install();
}
function init() {
    if (__WEBPACK_IMPORTED_MODULE_7_config__["FEATURE"].PUSH_NOTIFICATIONS) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(__WEBPACK_IMPORTED_MODULE_12_url_join___default()(__WEBPACK_IMPORTED_MODULE_7_config__["CROWDFUNDING_BASE_URI"], '/serviceWorker.js'));
        }
    }
    var history = __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default()({
        basename: __WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(__WEBPACK_IMPORTED_MODULE_7_config__["CROWDFUNDING_BASE_URI"]).pathname,
    });
    __WEBPACK_IMPORTED_MODULE_9__redux_middleware__["a" /* default */].push(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["c" /* routerMiddleware */])(history));
    if (true) {
        __WEBPACK_IMPORTED_MODULE_9__redux_middleware__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_6_raven_for_redux___default()(__WEBPACK_IMPORTED_MODULE_4_raven_js___default.a));
    }
    var store = Object(__WEBPACK_IMPORTED_MODULE_8__client_createStore__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__redux_middleware__["a" /* default */], __assign({}, window.__data, window.__userData));
    Object(__WEBPACK_IMPORTED_MODULE_10__client_root__["a" /* default */])(store, history);
}
if (!window.Intl) {
    new Promise(function(resolve) { resolve(); }).then((function () {
        __webpack_require__("./node_modules/intl/index.js");
        __webpack_require__("./node_modules/intl/locale-data/jsonp/en.js");
        init();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}
else {
    init();
}


/***/ }),

/***/ "./src/client/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger__ = __webpack_require__("./node_modules/redux-logger/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_modules__ = __webpack_require__("./src/redux/modules/index.js");



function hmr(store) {
    if (false) {
        module.hot.accept('../redux/modules', function () {
            var nextRootReducer = require('../redux/modules').default;
            store.replaceReducer(nextRootReducer);
        });
    }
}
function create(middleware, data) {
    if (false) {
        middleware.push(createLogger({ collapsed: true }));
    }
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */];
    var enhancers = composeEnhancers(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */].apply(void 0, middleware));
    var store = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__redux_modules__["a" /* default */], data, enhancers);
    hmr(store);
    return store;
}


/***/ }),

/***/ "./src/client/polyfill.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl__ = __webpack_require__("./node_modules/intl/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_locale_data_jsonp_en__ = __webpack_require__("./node_modules/intl/locale-data/jsonp/en.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_locale_data_jsonp_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_locale_data_jsonp_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_GB__ = __webpack_require__("./node_modules/intl/locale-data/jsonp/en-GB.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_GB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_GB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_locale_data_jsonp_en_US__ = __webpack_require__("./node_modules/intl/locale-data/jsonp/en-US.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_locale_data_jsonp_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intl_locale_data_jsonp_en_US__);






/***/ }),

/***/ "./src/client/publicPath.ts":
/***/ (function(module, exports, __webpack_require__) {

// tslint:disable-next-line:no-var-requires
__webpack_require__.p = __webpack_require__("./config/index.js").PUBLIC_PATH;


/***/ }),

/***/ "./src/client/root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_hot_loader__ = __webpack_require__("./node_modules/react-hot-loader/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_containers_App__ = __webpack_require__("./src/containers/App.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_i18n_client__ = __webpack_require__("./src/i18n/client.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__justgiving_experiments__ = __webpack_require__("./node_modules/@justgiving/experiments/es/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_config__);











function renderApp(store, history) {
    var root = document.getElementById('content');
    var render = function (Component) {
        __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.hydrate(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__justgiving_experiments__["a" /* ExperimentContext */].Provider, { value: {
                abServiceUrl: __WEBPACK_IMPORTED_MODULE_10_config__["AB_API_URI"],
                analyticsCookieName: __WEBPACK_IMPORTED_MODULE_10_config__["JG_ANALYTICS_COOKIE_NAME"],
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["a" /* I18nextProvider */], { i18n: __WEBPACK_IMPORTED_MODULE_8_src_i18n_client__["a" /* default */] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* IntlProvider */], { locale: "en-GB", defaultLocale: "en-GB" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */], { store: store, key: "provider" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["a" /* ConnectedRouter */], { history: history },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_hot_loader__["AppContainer"], null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null))))))), root);
    };
    render(__WEBPACK_IMPORTED_MODULE_7_src_containers_App__["a" /* default */]);
    if (false) {
        module.hot.accept('../containers/App', function () {
            render(require('../containers/App').default);
        });
    }
    if (false) {
        window.React = React; // enable debugger
    }
}
if ('ReactIntlLocaleData' in window) {
    Object.keys(window.ReactIntlLocaleData).forEach(function (lang) {
        Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* addLocaleData */])(window.ReactIntlLocaleData[lang]);
    });
}


/***/ }),

/***/ "./src/components/AboutFundraiser/AboutFundraiser.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1EALr","content":"_1hvTk","avatar-container":"_27DeN","avatar-image":"_1wuEq","location-pin":"_9Klm_"};

/***/ }),

/***/ "./src/components/AboutFundraiser/AboutFundraiser.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContactOwner_ContactOwnerModal__ = __webpack_require__("./src/components/ContactOwner/ContactOwnerModal.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page_ReportPage__ = __webpack_require__("./src/components/Page/ReportPage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_map_pin_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/map-pin.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_map_pin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_map_pin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss__ = __webpack_require__("./src/components/AboutFundraiser/AboutFundraiser.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};










var AboutFundraiser = /** @class */ (function (_super) {
    __extends(AboutFundraiser, _super);
    function AboutFundraiser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { submissionError: false };
        _this.handleSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _a, clearRecaptcha, contactOwner, id, onMessageSent, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, clearRecaptcha = _a.clearRecaptcha, contactOwner = _a.contactOwner, id = _a.id, onMessageSent = _a.onMessageSent;
                        if (this.state.submissionError) {
                            this.setState({ submissionError: false });
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, contactOwner(__assign({ id: id, recaptcha: this.props.recaptcha }, data))];
                    case 2:
                        _b.sent();
                        clearRecaptcha();
                        if (onMessageSent) {
                            onMessageSent();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.setState({ submissionError: true });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleContactOwner = function () {
            var isFriend = false;
            _this.props.openContactOwner(_this.props.pageName + "/contact", 'page view > footer', 'page > footer', isFriend, __WEBPACK_IMPORTED_MODULE_7_i18next__["a" /* default */].t('ContactOwner.subject.placeholder', {
                defaultValue: '',
            }), __WEBPACK_IMPORTED_MODULE_7_i18next__["a" /* default */].t('ContactOwner.message.placeholder', {
                defaultValue: '',
            }));
        };
        return _this;
    }
    AboutFundraiser.prototype.render = function () {
        var _a = this.props, addCensure = _a.addCensure, closeContactOwner = _a.closeContactOwner, isContactingOwnerWindowOpen = _a.isContactingOwnerWindowOpen, contactOwnerPageViewSection = _a.contactOwnerPageViewSection, contactOwnerPageSection = _a.contactOwnerPageSection, contactOwnerSubjectPlaceHolder = _a.contactOwnerSubjectPlaceHolder, contactOwnerMessagePlaceholder = _a.contactOwnerMessagePlaceholder, location = _a.location, ownerBio = _a.ownerBio, ownerName = _a.ownerName, profileImage = _a.profileImage, recaptcha = _a.recaptcha, setRecaptcha = _a.setRecaptcha;
        return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scroll__["Element"], { name: "about-fundraiser", className: "" + __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss___default.a.container },
            isContactingOwnerWindowOpen && (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__ContactOwner_ContactOwnerModal__["a" /* default */], { closeContactOwner: closeContactOwner, onSubmit: this.handleSubmit, ownerName: ownerName, recaptcha: recaptcha, setRecaptcha: setRecaptcha, submissionError: this.state.submissionError, pageViewSection: contactOwnerPageViewSection, pageSection: contactOwnerPageSection, subjectPlaceHolder: contactOwnerSubjectPlaceHolder, messagePlaceholder: contactOwnerMessagePlaceholder })),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h5", { className: "jg-h5 jg-space-mbmd@md jg-space-mbsm" }, "About the fundraiser"),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "jg-display-flex " + __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss___default.a.content },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "" + __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss___default.a['avatar-container'] },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Avatar__["b" /* OwnerAvatar */], { className: "jg-space-mbsm", src: profileImage, alt: ownerName })),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h3", { className: "jg-h3 jg-display-i jg-space-mrmd" }, ownerName),
                        location && (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "jg-display-i" },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "jg-relative" },
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-display-i " + __WEBPACK_IMPORTED_MODULE_9__AboutFundraiser_scss___default.a['location-pin'], markup: __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_map_pin_svg___default.a }),
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("p", { className: "jg-space-mlmd jg-color--nobel jg-display-i" }, location)))),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("p", { className: "jg-text--large jg-space-mtsm@md" }, ownerBio),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "jg-space-mtsm" },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ClickableElement__["a" /* default */], { onClick: this.handleContactOwner, className: "jg-text--link jg-space-mrlg", inline: true, analyticsOptions: {
                                    event: 'link click',
                                    subtype: 'button',
                                    eventValue: 'Contact page owner',
                                    pageSection: 'page > footer',
                                } }, "Contact " + ownerName),
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Page_ReportPage__["a" /* default */], { className: "jg-text--link", addCensure: addCensure })))))));
    };
    return AboutFundraiser;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AboutFundraiser);


/***/ }),

/***/ "./src/components/AdditionalDetails/FullSSNForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var FullSSNForm = /** @class */ (function (_super) {
    __extends(FullSSNForm, _super);
    function FullSSNForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref1 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        _this.ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        _this.ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        _this.state = {
            ssn_1: '',
            ssn_2: '',
            ssn_3: '',
        };
        return _this;
    }
    FullSSNForm.prototype.handleInternalChange = function (field, val) {
        var _this = this;
        var _a;
        var newState = (_a = {}, _a[field] = val, _a);
        this.setState(newState, function () {
            if (_this.state.ssn_1 &&
                _this.state.ssn_2 &&
                _this.state.ssn_3.length === 4) {
                _this.props.handleValidation();
                _this.props.handleValidationStatus();
            }
        });
    };
    FullSSNForm.prototype.moveFocus = function (currentPosition, after, targetRef) {
        if (currentPosition === after) {
            if (targetRef && targetRef.current) {
                targetRef.current.focus();
            }
        }
    };
    FullSSNForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, additionalFirstInputClassName = _a.additionalFirstInputClassName, additionalSecondInputClassName = _a.additionalSecondInputClassName, additionalThirdInputClassName = _a.additionalThirdInputClassName, handleFocus = _a.handleFocus, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleValidation = _a.handleValidation;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-4" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "password", ref: this.ref1, className: "jg-form-control " + (additionalFirstInputClassName || ''), maxLength: 3, placeholder: "xxx", onChange: function (event) {
                        handleChange(event);
                        _this.handleInternalChange('ssn_1', event.target.value);
                        _this.moveFocus(event.target.value.length, 3, _this.ref2);
                    }, id: "personalIdNumber_1", name: "personalIdNumber_1", onFocus: function () { return handleFocus('personalIdNumber_1'); }, onBlur: handleBlur })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-4" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "password", ref: this.ref2, className: "jg-form-control " + (additionalSecondInputClassName ||
                        ''), maxLength: 2, placeholder: "xx", onChange: function (event) {
                        handleChange(event);
                        _this.handleInternalChange('ssn_2', event.target.value);
                        _this.moveFocus(event.target.value.length, 2, _this.ref3);
                    }, id: "personalIdNumber_2", name: "personalIdNumber_2", onFocus: function () { return handleFocus('personalIdNumber_2'); }, onBlur: handleBlur })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-4" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "password", ref: this.ref3, className: "jg-form-control " + (additionalThirdInputClassName || ''), maxLength: 4, placeholder: "xxxx", id: "personalIdNumber_3", name: "personalIdNumber_3", onFocus: function () { return handleFocus('personalIdNumber_3'); }, onChange: function (event) {
                        handleChange(event);
                        _this.handleInternalChange('ssn_3', event.target.value);
                    }, onBlur: function () { return handleValidation(); } }))));
    };
    return FullSSNForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FullSSNForm);


/***/ }),

/***/ "./src/components/AdditionalDetails/PersonalIdNumberForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__additionalStripeDetailsValidator__ = __webpack_require__("./src/components/AdditionalDetails/additionalStripeDetailsValidator.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FullSSNForm__ = __webpack_require__("./src/components/AdditionalDetails/FullSSNForm.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var PersonalIdNumberForm = /** @class */ (function (_super) {
    __extends(PersonalIdNumberForm, _super);
    function PersonalIdNumberForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isValidated: false };
        _this.handleSubmit = function (values, formikBag) { return __awaiter(_this, void 0, void 0, function () {
            var ssnValue, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ssnValue = {
                            personalIdNumber: values.personalIdNumber_1 + "-" + values.personalIdNumber_2 + "-" + values.personalIdNumber_3,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        formikBag.setStatus(null);
                        return [4 /*yield*/, this.props.updateStripeAccountDetails(ssnValue)];
                    case 2:
                        _a.sent();
                        this.props.onSubmit();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        formikBag.setSubmitting(false);
                        formikBag.setStatus(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleValidationStatus = function () {
            _this.setState({
                isValidated: true,
            });
        };
        return _this;
    }
    PersonalIdNumberForm.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "verify identity - full ssn", pageSection: "admin > verify identity", subtype: "admin" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container jg-space-phsm jg-space-ptsm jg-space-phxxl@md" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["c" /* Formik */], { initialValues: {
                        personalIdNumber_1: '',
                        personalIdNumber_2: '',
                        personalIdNumber_3: '',
                    }, onSubmit: this.handleSubmit, validate: __WEBPACK_IMPORTED_MODULE_4__additionalStripeDetailsValidator__["a" /* personalIdNumberValidation */], validateOnChange: false, validateOnBlur: false }, function (_a) {
                    var handleChange = _a.handleChange, handleBlur = _a.handleBlur, values = _a.values, errors = _a.errors, isSubmitting = _a.isSubmitting, isValid = _a.isValid, touched = _a.touched, setFieldTouched = _a.setFieldTouched, status = _a.status, validateForm = _a.validateForm;
                    var firstInputErrorDisplay = touched.personalIdNumber_1 && errors.personalIdNumber_1;
                    var secondInputErrorDisplay = touched.personalIdNumber_2 && errors.personalIdNumber_2;
                    var thirdInputErrorDisplay = touched.personalIdNumber_3 && errors.personalIdNumber_3;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["b" /* Form */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-text--center jg-space-mbmd" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--large" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.pleaseProvideText", defaultMessage: "Please provide your Social Security Number (SSN)" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.ssnMustMatchText", defaultMessage: "The SSN must match the name and address you previously entered" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-phlg@md" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-form-group" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "jg-form-label", htmlFor: "personalIdNumber_1" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.ssnFieldLabel", defaultMessage: "Your Social Security Number" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__FullSSNForm__["a" /* default */], { additionalFirstInputClassName: "" + (firstInputErrorDisplay ? 'jg-form-control--error' : ''), additionalSecondInputClassName: "" + (secondInputErrorDisplay
                                        ? 'jg-form-control--error'
                                        : ''), additionalThirdInputClassName: "" + (thirdInputErrorDisplay ? 'jg-form-control--error' : ''), handleFocus: setFieldTouched, handleChange: handleChange, handleBlur: handleBlur, handleValidation: validateForm, handleValidationStatus: _this.handleValidationStatus, values: values }),
                                Object.keys(errors).map(function (item) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "jg-form-error-copy jg-text--small", role: "alert", key: item }, errors[item])); })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                status && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mtsm jg-space-mbmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_Alert__["a" /* default */], { id: "ssn-last-four-alert", type: "red", displayType: "inline", persistent: true }, "An error has occurred. Please try again."))),
                                _this.state.isValidated && isValid ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { loading: isSubmitting, className: "jg-btn jg-btn--brand jg-space-mbms", value: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.confirmSSNButton", defaultMessage: "Confirm your SSN" }), analyticsOptions: {
                                        event: 'link click',
                                        subtype: 'button',
                                        eventValue: 'confirm ssn',
                                        pageSection: 'admin > verify identity',
                                    } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mvms" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["c" /* Button */], { qaClassName: "qa-confirm-identity-button", isDisabled: true }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.confirmSSNInactiveButton", defaultMessage: "Confirm your SSN" })))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--xsmall jg-color--nobel jg-text--center" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "PersonalIdNumberForm.disclaimerText", defaultMessage: "JustGiving and the third party that helps us with identity verification will keep your information secure and will only use it for the purposes of verifying your identity" }))))));
                }))));
    };
    return PersonalIdNumberForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PersonalIdNumberForm);


/***/ }),

/***/ "./src/components/AdditionalDetails/SSNLastFourForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__additionalStripeDetailsValidator__ = __webpack_require__("./src/components/AdditionalDetails/additionalStripeDetailsValidator.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var SSNLastFourForm = /** @class */ (function (_super) {
    __extends(SSNLastFourForm, _super);
    function SSNLastFourForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (values, formikBag) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formikBag.setStatus(null);
                        return [4 /*yield*/, this.props.updateStripeAccountDetails(values)];
                    case 1:
                        _a.sent();
                        this.props.onSubmit();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        formikBag.setSubmitting(false);
                        formikBag.setStatus(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    SSNLastFourForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "verify identity - 4 digit ssn", pageSection: "admin > verify identity", subtype: "admin" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container jg-space-phsm jg-space-ptsm jg-space-phxxl@md" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["c" /* Formik */], { initialValues: {
                        ssnLast4: '',
                    }, onSubmit: this.handleSubmit, validate: __WEBPACK_IMPORTED_MODULE_4__additionalStripeDetailsValidator__["b" /* ssnLastFourValidation */], validateOnChange: true }, function (_a) {
                    var handleChange = _a.handleChange, handleBlur = _a.handleBlur, values = _a.values, errors = _a.errors, isSubmitting = _a.isSubmitting, isValid = _a.isValid, setFieldValue = _a.setFieldValue, touched = _a.touched, setFieldTouched = _a.setFieldTouched, status = _a.status;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["b" /* Form */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-text--center jg-space-mbmd" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--large" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.pleaseProvideText", defaultMessage: "Please provide the last 4 digits of your Social Security Number (SSN)" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.ssnMustMatchText", defaultMessage: "The SSN must match the name and address you previously entered" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-phlg@md" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-form-group" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "jg-form-label", htmlFor: "ssnLast4" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.ssnFieldLabel", defaultMessage: "Last 4 digits of your SSN" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control " + (touched.ssnLast4 && errors.ssnLast4
                                        ? 'jg-form-control--error'
                                        : ''), type: "text", id: "ssnLast4", name: "ssnLast4", placeholder: "xxxx", maxLength: 4, onFocus: function () {
                                        setFieldTouched('ssnLast4');
                                    } }),
                                touched.ssnLast4 &&
                                    errors.ssnLast4 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.ssnLast4))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                status && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mtsm jg-space-mbmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_Alert__["a" /* default */], { id: "ssn-last-four-alert", type: "red", displayType: "inline", persistent: true }, "An error has occurred. Please try again."))),
                                !isValid ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mvms" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["c" /* Button */], { qaClassName: "qa-confirm-identity-button", isDisabled: true, analyticsOptions: {
                                            event: 'link click',
                                            subtype: 'button',
                                            eventValue: 'confirm last 4 digits of ssn',
                                            pageSection: 'admin > verify identity',
                                        } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.confirmSSNLastFourInactiveButton", defaultMessage: "Confirm last 4 digits of SSN" })))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { loading: isSubmitting, className: "jg-btn jg-btn--brand jg-space-mbms", value: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.confirmSSNLastFourButton", defaultMessage: "Confirm last 4 digits of SSN" }) })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--xsmall jg-color--nobel jg-text--center" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "SSNLastFourForm.disclaimerText", defaultMessage: "JustGiving and the third party that helps us with identity verification will keep your information secure and will only use it for the purposes of verifying your identity" }))))));
                }))));
    };
    return SSNLastFourForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SSNLastFourForm);


/***/ }),

/***/ "./src/components/AdditionalDetails/StripeVerificationDocumentForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StripeVerificationDocumentUpload__ = __webpack_require__("./src/components/AdditionalDetails/StripeVerificationDocumentUpload.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_CoverPhotoEditor_ImageEditor__ = __webpack_require__("./src/components/CoverPhotoEditor/ImageEditor/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_config__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var StripeVerificationDocumentForm = /** @class */ (function (_super) {
    __extends(StripeVerificationDocumentForm, _super);
    function StripeVerificationDocumentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (_, formikBag) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.submitStripeVerificationDocument(this.state.image, this.props.cropData)];
                    case 1:
                        _a.sent();
                        this.props.onSubmit();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        formikBag.setSubmitting(false);
                        formikBag.setStatus(error_1);
                        this.setState({ errorType: 'submitFailureAlert' });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.toggleTips = function () {
            _this.setState({ areTipsShowing: !_this.state.areTipsShowing });
        };
        _this.handleImage = function (pic) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_image__["i" /* processImage */])(pic, { maxSize: __WEBPACK_IMPORTED_MODULE_8_config___default.a.MAX_IMAGE_SIZE })];
                    case 1:
                        result = _a.sent();
                        if (result.success) {
                            this.setState({ image: result.image });
                        }
                        else {
                            this.setState({
                                errorType: 'imageTooLarge',
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.removeImage = function () {
            _this.props.removeImage();
            _this.setState({ image: '' });
        };
        _this.rotateImage = function (cropData) {
            _this.props.rotateImage(cropData);
        };
        _this.state = {
            areTipsShowing: false,
            image: '',
            errorType: '',
        };
        return _this;
    }
    StripeVerificationDocumentForm.prototype.render = function () {
        var _this = this;
        var hasUserSelectedImage = this.state.image.length > 1 ? true : false;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "verify identity - government-issued id", pageSection: "admin > verify identity", subtype: "admin" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container jg-space-phsm jg-space-ptsm jg-space-phxxl@md" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["c" /* Formik */], { initialValues: {
                        stripeVerificationDocument: null,
                    }, onSubmit: this.handleSubmit }, function (_a) {
                    var isSubmitting = _a.isSubmitting;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_formik__["b" /* Form */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-text--center jg-space-mbmd" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--large" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.pleaseUploadImage", defaultMessage: "Please upload a scan or photograph of a government-issued photo ID" }))),
                            !hasUserSelectedImage ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__StripeVerificationDocumentUpload__["a" /* default */], { areTipsShowing: _this.state.areTipsShowing, toggleTips: _this.toggleTips, error: _this.state.errorType, addPhoto: _this.handleImage, removeImage: _this.removeImage })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "verify identity - government-issued id > upload", pageSection: "admin > verify identity > government-issue id", subtype: "admin" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mtmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_CoverPhotoEditor_ImageEditor__["a" /* default */], { image: _this.state.image, position: _this.props.cropData.position, scale: _this.props.cropData.scale, rotate: _this.props.cropData.rotate, pageSection: "verify your identity > verification document", onCropChange: _this.props.updateCrop, onRemoveImage: _this.removeImage, onRotateImage: _this.rotateImage }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-phlg@md" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                _this.state.errorType === 'submitFailureAlert' && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mtsm jg-space-mvmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_Alert__["a" /* default */], { id: "stripe-verification-document-alert", type: "red", displayType: "inline", persistent: true },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.submitFailureAlert", defaultMessage: "An error has occurred. Please try again." })))),
                                hasUserSelectedImage && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { loading: isSubmitting, className: "jg-btn jg-btn--brand jg-space-mbms", value: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.saveAndContinue", defaultMessage: "Save and continue" }), analyticsOptions: {
                                        event: 'link click',
                                        eventValue: 'save and continue',
                                        pageSection: 'admin > verify identity > government-issue id',
                                        subtype: 'button',
                                    } })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "jg-text--xsmall jg-color--nobel jg-text--center" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.disclaimerText", defaultMessage: "JustGiving and the third party that helps us with identity verification will keep your information secure and will only use it for the purposes of verifying your identity" }))))));
                }))));
    };
    return StripeVerificationDocumentForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StripeVerificationDocumentForm);


/***/ }),

/***/ "./src/components/AdditionalDetails/StripeVerificationDocumentTips.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_icons_lib_tick_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/tick.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_icons_lib_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__justgiving_icons_lib_tick_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");




var StripeVerificationDocumentTips = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-tal" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-display-flex" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_2__justgiving_icons_lib_tick_svg___default.a, className: "jg-icon jg-fill--mountain-meadow jg-space-mrms" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.makeSureItsVisible", defaultMessage: "Make sure it's visible" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.makeSureItsVisibleIntro", defaultMessage: "Ensure your document's details are clear. We'll need to see: " })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "jg-list-style--disc jg-list-position--inside" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.yourFullName", defaultMessage: "Your full name" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.yourDoB", defaultMessage: "Your date of birth" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.yourHomeAddress", defaultMessage: "Your home address" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.docExpiryDate", defaultMessage: "The document's expiry date" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.docIssueNumber", defaultMessage: "The document's issue number" }))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-display-flex" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_2__justgiving_icons_lib_tick_svg___default.a, className: "jg-icon jg-fill--mountain-meadow jg-space-mrms" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.makeSureItsClear", defaultMessage: "Make sure it's clear" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.makeSureItsClearIntro", defaultMessage: "When taking a photo of your document, make sure it is well lit, the photo isn't blurry and nothing is covering any of the details." }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (StripeVerificationDocumentTips);


/***/ }),

/***/ "./src/components/AdditionalDetails/StripeVerificationDocumentUpload.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StripeVerificationDocumentTips__ = __webpack_require__("./src/components/AdditionalDetails/StripeVerificationDocumentTips.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var StripeVerificationDocumentUpload = /** @class */ (function (_super) {
    __extends(StripeVerificationDocumentUpload, _super);
    function StripeVerificationDocumentUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            event.preventDefault();
            _this.fileInput.click();
        };
        _this.handleUploadPhoto = function (e) {
            var pic = e.target.files && e.target.files[0];
            if (pic) {
                _this.props.addPhoto(pic);
            }
        };
        _this.removeImage = function () {
            _this.props.removeImage();
        };
        return _this;
    }
    StripeVerificationDocumentUpload.prototype.renderAction = function () {
        if (this.props.areTipsShowing) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentUpload.toggleIdTipsClose", defaultMessage: "Close" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "jg-space-plxs" }, "\u2715")));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentUpload.toggleIdTipsOpen", defaultMessage: "How to avoid your ID check being rejected" }));
    };
    StripeVerificationDocumentUpload.prototype.renderButtonText = function () {
        if (window.matchMedia('(max-width: 567px)').matches) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentUpload.uploadOrTakePhotoButton", defaultMessage: "Upload or take a photo" }));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentUpload.uploadPhotoButton", defaultMessage: "Upload a photo" }));
        }
    };
    StripeVerificationDocumentUpload.prototype.render = function () {
        var _this = this;
        var buttonText = this.renderButtonText();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentUpload.idTypeSuggestionText", defaultMessage: "This could be a photo or scan of your passport, your ID or driving licence." })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link jg-text--center jg-space-mtmd jg-space-mbml", onClick: this.props.toggleTips }, this.renderAction()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "jg-hidden qa-file-input", type: "file", name: "stripeVerificationDocument", id: "stripeVerificationDocument", ref: function (input) {
                    _this.fileInput = input;
                }, onChange: this.handleUploadPhoto, accept: "image/*" }),
            this.props.areTipsShowing && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__StripeVerificationDocumentTips__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-phlg@md" },
                this.props.error === 'imageTooLarge' && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jg-space-mbmd" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_Alert__["a" /* default */], { id: "photo-id-alert", type: "red", displayType: "inline", persistent: true },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeVerificationDocumentForm.imageTooLarge", defaultMessage: "Please upload a JPEG or PNG image that's smaller than 15mb" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--secondary", onClick: this.handleClick, analyticsOptions: {
                        event: 'link click',
                        eventValue: 'upload or take a photo',
                        pageSection: 'admin > verify identity',
                        subtype: 'button',
                    } }, buttonText))));
    };
    return StripeVerificationDocumentUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StripeVerificationDocumentUpload);


/***/ }),

/***/ "./src/components/AdditionalDetails/additionalStripeDetailsValidator.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ssnLastFourValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return personalIdNumberValidation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");

var ssnLastFourRule = {
    ssnLast4: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please enter the last 4 digits of your SSN',
            emptyValues: ['xxxx'],
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^\d{4}?$/, {
            message: 'Your SSN should only contain numbers. Please enter the last 4 digits of your SSN.',
        }),
    ],
};
var personalIdNumberRule = {
    personalIdNumber_1: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please enter your Social Security Number',
            emptyValues: ['xxx'],
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^[\d\- ]+$/, {
            message: 'Your SSN should only include numbers. Please enter your SSN.',
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^\d{3}?$/, {
            message: 'Please enter the first 3 digits of your SSN.',
        }),
    ],
    personalIdNumber_2: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please enter the 2 middle digits of your SSN.',
            emptyValues: ['xx'],
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^[\d\- ]+$/, {
            message: 'Your SSN should only include numbers. Please enter your SSN.',
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^\d{2}?$/, {
            message: 'Please enter the 2 middle digits of your SSN.',
        }),
    ],
    personalIdNumber_3: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please enter the last 4 digits of your SSN.',
            emptyValues: ['xxxx'],
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^[\d\- ]+$/, {
            message: 'Your SSN should only include numbers. Please enter your SSN.',
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["j" /* pattern */])(/^\d{4}?$/, {
            message: 'Please enter the last 4 digits of your SSN.',
        }),
    ],
};
var ssnLastFourValidation = Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(ssnLastFourRule);
var personalIdNumberValidation = Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(personalIdNumberRule);


/***/ }),

/***/ "./src/components/AdditionalDetails/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SSNLastFourForm__ = __webpack_require__("./src/components/AdditionalDetails/SSNLastFourForm.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonalIdNumberForm__ = __webpack_require__("./src/components/AdditionalDetails/PersonalIdNumberForm.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripeVerificationDocumentForm__ = __webpack_require__("./src/components/AdditionalDetails/StripeVerificationDocumentForm.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SSNLastFourForm__["a"]; });
/* unused harmony reexport SSNLastFourFormData */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__PersonalIdNumberForm__["a"]; });
/* unused harmony reexport PersonalIdNumberData */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__StripeVerificationDocumentForm__["a"]; });
/* unused harmony reexport SSNValue */






/***/ }),

/***/ "./src/components/Alert/Alert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_alert__ = __webpack_require__("./node_modules/@justgiving/alert/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_alert_src_Alert_scss__ = __webpack_require__("./node_modules/@justgiving/alert/src/Alert.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_alert_src_Alert_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__justgiving_alert_src_Alert_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var typeMap = {
    red: 'error',
    green: 'success',
    amber: 'warning',
    info: 'info',
};
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClose = function () {
            if (_this.props.page && Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])()) {
                localStorage.setItem("alert:" + _this.props.page.id + "_" + _this.props.id, 'true');
            }
            if (_this.props.analyticsClick) {
                _this.props.analyticsClick();
            }
            _this.props.onClose();
        };
        return _this;
    }
    Alert.prototype.render = function () {
        var _a = this.props, type = _a.type, onClose = _a.onClose, autoCloseMs = _a.autoCloseMs, _b = _a.displayType, displayType = _b === void 0 ? '' : _b, persistent = _a.persistent;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_alert__["a" /* default */], { type: typeMap[type], onClose: !persistent && onClose ? this.handleClose : undefined, autoClose: autoCloseMs && autoCloseMs > 0 ? autoCloseMs : undefined, displayType: displayType }, this.props.children)));
    };
    return Alert;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Alert);


/***/ }),

/***/ "./src/components/Alert/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alert__ = __webpack_require__("./src/components/Alert/Alert.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Alert__["a" /* default */]);


/***/ }),

/***/ "./src/components/AlternativeProjects/AlternativeProjects.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2MJNm","stories-list":"_1fpaC","story":"_3GXVh"};

/***/ }),

/***/ "./src/components/AlternativeProjects/AlternativeProjects.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RelatedStory__ = __webpack_require__("./src/components/AlternativeProjects/RelatedStory.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss__ = __webpack_require__("./src/components/AlternativeProjects/AlternativeProjects.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg__ = __webpack_require__("./static/images/default-avatar.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MAX_ALTERNATIVE_PROJECTS = 3;
var mapProjectToAnalyticsSpec = function (project, cardRank) { return ({
    projectId: project.projectId,
    cardCount: MAX_ALTERNATIVE_PROJECTS,
    cardUrl: project.projectUrl,
    cardRank: cardRank,
}); };
var AlternativeProjects = /** @class */ (function (_super) {
    __extends(AlternativeProjects, _super);
    function AlternativeProjects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlternativeProjects.prototype.componentDidMount = function () {
        var _a = this.props, alternativeProjects = _a.alternativeProjects, loadAvatars = _a.loadAvatars;
        if (true && alternativeProjects.items) {
            loadAvatars(alternativeProjects.items.map(function (p) { return p.ownerId; }));
        }
    };
    AlternativeProjects.prototype.render = function () {
        var _a = this.props, alternativeProjects = _a.alternativeProjects, avatars = _a.avatars, renderAlternativeProjectCard = _a.renderAlternativeProjectCard, clickOnAlternativeProjectCard = _a.clickOnAlternativeProjectCard;
        if (!alternativeProjects || alternativeProjects.items.length === 0) {
            return null;
        }
        var firstThreeAlternativeProjects = alternativeProjects.items.slice(0, MAX_ALTERNATIVE_PROJECTS);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bdt jg-bd--solid jg-bd--very-light-grey" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss___default.a.container },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2 jg-space-mvmd jg-space-mvlg@lg jg-space-plsm@lg" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "AlternativeProjects.storiesLikeThisHeading", defaultMessage: "Crowdfunding stories like this" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: __WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss___default.a['stories-list'] }, firstThreeAlternativeProjects.map(function (project, index) {
                    var amountRaised = project.amountRaised, progress = project.progress, pitch = project.pitch, owner = project.owner, ownerId = project.ownerId, numberOfSupporters = project.numberOfSupporters, projectImage = project.projectImage, projectId = project.projectId, projectUrl = project.projectUrl, targetCurrency = project.targetCurrency;
                    var analyticSpec = mapProjectToAnalyticsSpec(project, index + 1);
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: __WEBPACK_IMPORTED_MODULE_4__AlternativeProjects_scss___default.a.story, key: projectId },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RelatedStory__["a" /* default */], { percentage: progress || 0, title: pitch, owner: owner, numberOfSupporters: numberOfSupporters, totalRaised: new Intl.NumberFormat([], {
                                maximumFractionDigits: 0,
                            }).format(amountRaised) || 0, ownerAvatar: Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_image__["h" /* getImageUrlWithTemplate */])(avatars[ownerId], 'CrowdfundingSupporterAvatar') || __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg___default.a, pageImage: Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_image__["h" /* getImageUrlWithTemplate */])(projectImage.url, 'DiscoverCard'), currencySymbol: __WEBPACK_IMPORTED_MODULE_3_src_helpers_currencyMap__["e" /* default */][targetCurrency] || '£', onClick: function () {
                                clickOnAlternativeProjectCard(analyticSpec);
                            }, pageLink: projectUrl, id: projectId, componentDidMountCallback: function () {
                                renderAlternativeProjectCard(analyticSpec);
                            } })));
                })))));
    };
    return AlternativeProjects;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AlternativeProjects);


/***/ }),

/***/ "./src/components/AlternativeProjects/RelatedStory.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"related-story-image-container":"_3qs47","related-story-image":"_3Fzqk","project-title":"_3RcXS","avatar-container":"_3EaNq","avatar":"_3K749","card":"_1oq5r"};

/***/ }),

/***/ "./src/components/AlternativeProjects/RelatedStory.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Totaliser_Totaliser__ = __webpack_require__("./src/components/Totaliser/Totaliser.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss__ = __webpack_require__("./src/components/AlternativeProjects/RelatedStory.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var RelatedStory = /** @class */ (function (_super) {
    __extends(RelatedStory, _super);
    function RelatedStory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelatedStory.prototype.componentDidMount = function () {
        var _a = this.props, componentDidMountCallback = _a.componentDidMountCallback, id = _a.id;
        if (componentDidMountCallback) {
            componentDidMountCallback(id);
        }
    };
    RelatedStory.prototype.render = function () {
        var _a = this.props, id = _a.id, title = _a.title, owner = _a.owner, numberOfSupporters = _a.numberOfSupporters, totalRaised = _a.totalRaised, pageImage = _a.pageImage, ownerAvatar = _a.ownerAvatar, currencySymbol = _a.currencySymbol, pageLink = _a.pageLink, percentage = _a.percentage, onClick = _a.onClick;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-width-100pc jg-height-100pc jg-bd jg-bd--solid jg-bd--very-light-grey jg-background--white" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a.card, href: pageLink, onClick: function () { return onClick && onClick(id); } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a['related-story-image-container'] + " jg-width-100pc" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a['related-story-image'] + " jg-width-100pc", src: pageImage })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-pms" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a['project-title'] }, title),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a['avatar-container'] },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_3__RelatedStory_scss___default.a.avatar, src: ownerAvatar })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, owner)),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Totaliser_Totaliser__["a" /* default */], { percentage: percentage, requestedSize: "small" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mlsm jg-flex-g1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RelatedStory.amountRaisedBy", defaultMessage: "{amount} raised by", values: {
                                        amount: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--brand" },
                                            currencySymbol,
                                            totalRaised)),
                                    } })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RelatedStory." + id + ".supporterCount", defaultMessage: "{supporterCount} {supporterCount, plural, one {supporter} other {supporters}}", values: {
                                        supporterCount: new Intl.NumberFormat([], {
                                            maximumFractionDigits: 0,
                                        }).format(numberOfSupporters),
                                    } }))))))));
    };
    return RelatedStory;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RelatedStory);


/***/ }),

/***/ "./src/components/AlternativeProjects/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlternativeProjects__ = __webpack_require__("./src/components/AlternativeProjects/AlternativeProjects.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AlternativeProjects__["a" /* default */]);


/***/ }),

/***/ "./src/components/Analytics/AnalyticsLoadingButton/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnalyticsLoadingButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_LoadingButton___ = __webpack_require__("./src/components/LoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var AnalyticsLoadingButton = /** @class */ (function (_super) {
    __extends(AnalyticsLoadingButton, _super);
    function AnalyticsLoadingButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    AnalyticsLoadingButton.prototype.handleClick = function (event) {
        var _a = this.props, onClick = _a.onClick, analyticsClick = _a.analyticsClick, analyticsOptions = _a.analyticsOptions;
        if (onClick) {
            onClick(event);
        }
        if (analyticsOptions) {
            analyticsClick(analyticsOptions);
        }
    };
    AnalyticsLoadingButton.prototype.render = function () {
        var _a = this.props, color = _a.color, id = _a.id, loading = _a.loading, value = _a.value, className = _a.className, disabled = _a.disabled, type = _a.type;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_LoadingButton___["a" /* default */], { id: id, loading: loading, value: value, onClick: this.handleClick, className: className, disabled: disabled, color: color, type: type }));
    };
    return AnalyticsLoadingButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps)(AnalyticsLoadingButton));


/***/ }),

/***/ "./src/components/Analytics/AnalyticsPageView/AnalyticsPageView.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnalyticsPageView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        analyticsPageView: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_analytics__["b" /* analyticsPageView */],
    }, dispatch);
};
var AnalyticsPageView = /** @class */ (function (_super) {
    __extends(AnalyticsPageView, _super);
    function AnalyticsPageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnalyticsPageView.prototype.componentDidMount = function () {
        var analyticsOptions = {
            eventValue: this.props.eventValue,
            pageSection: this.props.pageSection,
            subtype: this.props.subtype,
        };
        this.props.analyticsPageView(!this.props.actorSource
            ? analyticsOptions
            : __assign({}, analyticsOptions, { actorSource: this.props.actorSource }));
    };
    AnalyticsPageView.prototype.render = function () {
        var children = this.props.children;
        return children;
    };
    return AnalyticsPageView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, mapDispatchToProps)(AnalyticsPageView));


/***/ }),

/***/ "./src/components/Analytics/Button/Button.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"disabled-trackable-button":"_1Sn9l"};

/***/ }),

/***/ "./src/components/Analytics/Button/Button.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TrackableButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button_scss__ = __webpack_require__("./src/components/Analytics/Button/Button.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Button_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var TrackableButton = /** @class */ (function (_super) {
    __extends(TrackableButton, _super);
    function TrackableButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    TrackableButton.prototype.handleClick = function (event) {
        var _a = this.props, onClick = _a.onClick, analyticsClick = _a.analyticsClick, analyticsOptions = _a.analyticsOptions;
        if (onClick) {
            onClick(event);
        }
        if (analyticsOptions) {
            analyticsClick(analyticsOptions);
        }
    };
    TrackableButton.prototype.render = function () {
        var _a = this.props, analyticsOptions = _a.analyticsOptions, children = _a.children, className = _a.className, isDisabled = _a.isDisabled, type = _a.type, value = _a.value, qaClassName = _a.qaClassName;
        if (isDisabled) {
            return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__["a" /* default */], { analyticsOptions: analyticsOptions, className: qaClassName + "-disabled" },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "" + __WEBPACK_IMPORTED_MODULE_5__Button_scss___default.a['disabled-trackable-button'] }, children)));
        }
        return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", { className: className + " " + (qaClassName || ''), onClick: this.handleClick, type: type, value: value }, children));
    };
    return TrackableButton;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, mapDispatchToProps)(TrackableButton));


/***/ }),

/***/ "./src/components/Analytics/Link/Link.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Analytics/Link/Link.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link_scss__ = __webpack_require__("./src/components/Analytics/Link/Link.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Link_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var TrackableLink = /** @class */ (function (_super) {
    __extends(TrackableLink, _super);
    function TrackableLink(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    TrackableLink.prototype.handleClick = function () {
        var _a = this.props, analyticsClick = _a.analyticsClick, analyticsOptions = _a.analyticsOptions, onClick = _a.onClick;
        if (analyticsOptions) {
            analyticsClick(analyticsOptions);
        }
        if (onClick) {
            onClick();
        }
    };
    TrackableLink.prototype.render = function () {
        var _a = this.props, activeClassName = _a.activeClassName, children = _a.children, className = _a.className, href = _a.href, isIndexLink = _a.isIndexLink, rel = _a.rel, target = _a.target, to = _a.to;
        if (isIndexLink) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* NavLink */], { activeClassName: activeClassName, className: className, onClick: this.handleClick, exact: true, to: to }, children));
        }
        if (href) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: className, href: href, onClick: this.handleClick, rel: rel, target: target }, children));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* NavLink */], { activeClassName: activeClassName, className: className, onClick: this.handleClick, to: to }, children));
    };
    return TrackableLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(TrackableLink, __WEBPACK_IMPORTED_MODULE_2__Link_scss___default.a)));


/***/ }),

/***/ "./src/components/Analytics/RadioButton/RadioButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radio-button-label":"_39Rg-"};

/***/ }),

/***/ "./src/components/Analytics/RadioButton/RadioButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadioButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadioButton_scss__ = __webpack_require__("./src/components/Analytics/RadioButton/RadioButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadioButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RadioButton_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    RadioButton.prototype.handleChange = function (e) {
        var _a = this.props, onChange = _a.onChange, analyticsClick = _a.analyticsClick, analyticsOptions = _a.analyticsOptions;
        if (onChange) {
            onChange(e);
        }
        if (analyticsOptions) {
            analyticsClick(analyticsOptions);
        }
    };
    RadioButton.prototype.render = function () {
        var _a = this.props, checked = _a.checked, id = _a.id, labelText = _a.labelText, name = _a.name, qaClassName = _a.qaClassName, value = _a.value;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { id: id, type: "radio", className: "jg-radio " + qaClassName, name: name, value: value, checked: checked, onChange: this.handleChange }),
            labelText && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-label jg-space-mbn " + __WEBPACK_IMPORTED_MODULE_5__RadioButton_scss___default.a['radio-button-label'], htmlFor: id }, labelText))));
    };
    return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(RadioButton, __WEBPACK_IMPORTED_MODULE_5__RadioButton_scss___default.a)));


/***/ }),

/***/ "./src/components/Analytics/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__("./src/components/Analytics/Button/Button.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link_Link__ = __webpack_require__("./src/components/Analytics/Link/Link.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsLoadingButton___ = __webpack_require__("./src/components/Analytics/AnalyticsLoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsPageView_AnalyticsPageView__ = __webpack_require__("./src/components/Analytics/AnalyticsPageView/AnalyticsPageView.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RadioButton_RadioButton__ = __webpack_require__("./src/components/Analytics/RadioButton/RadioButton.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AnalyticsLoadingButton___["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Link_Link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__AnalyticsPageView_AnalyticsPageView__["a"]; });
/* unused harmony reexport RadioButton */








/***/ }),

/***/ "./src/components/AppErrorBoundary/AppErrorBoundary.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Error_Error__ = __webpack_require__("./src/components/Error/Error.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__("./node_modules/raven-js/src/singleton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AppErrorBoundary = /** @class */ (function (_super) {
    __extends(AppErrorBoundary, _super);
    function AppErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
            error: null,
        };
        return _this;
    }
    AppErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ hasError: true, error: error });
        __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: errorInfo });
    };
    AppErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            if (false) {
                if (this.state.error) {
                    var RedBox = require('redbox-react').default;
                    return React.createElement(RedBox, { error: this.state.error });
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Error_Error__["a" /* default */], { error: "500" });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, this.props.children);
    };
    return AppErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AppErrorBoundary);


/***/ }),

/***/ "./src/components/AppErrorBoundary/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppErrorBoundary__ = __webpack_require__("./src/components/AppErrorBoundary/AppErrorBoundary.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AppErrorBoundary__["a" /* default */]);


/***/ }),

/***/ "./src/components/Avatar/Avatar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3TmQW","xxsmall":"_3U2jb","xsmall":"_2A9cy","small":"_25Dca","medium":"_2iwjn","large":"jbvvS","xlarge":"zvyIg","share-prompt-profile":"aeMH5","share-prompt-profile-mobile":"_2orok"};

/***/ }),

/***/ "./src/components/Avatar/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = OwnerAvatar;
/* harmony export (immutable) */ __webpack_exports__["c"] = SupporterAvatar;
/* harmony export (immutable) */ __webpack_exports__["a"] = Avatar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_default_avatar_svg__ = __webpack_require__("./static/images/default-avatar.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_default_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_default_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar_scss__ = __webpack_require__("./src/components/Avatar/Avatar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Avatar_scss__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




function OwnerAvatar(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Avatar, __assign({ template: "CrowdfundingOwnerAvatar" }, props));
}
function SupporterAvatar(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Avatar, __assign({ template: "CrowdfundingSupporterAvatar" }, props));
}
function Avatar(_a) {
    var src = _a.src, alt = _a.alt, _b = _a.size, size = _b === void 0 ? 'medium' : _b, template = _a.template, _c = _a.className, className = _c === void 0 ? '' : _c;
    var imagePath = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_image__["h" /* getImageUrlWithTemplate */])(src, template) || __WEBPACK_IMPORTED_MODULE_2__static_images_default_avatar_svg___default.a;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_3__Avatar_scss___default.a.avatar + " " + __WEBPACK_IMPORTED_MODULE_3__Avatar_scss___default.a[size] + " " + className, src: imagePath, alt: alt }));
}


/***/ }),

/***/ "./src/components/CharityEndorsed/CharityEndorsed.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo-wrapper":"_3NSqv","tick":"_3LdXR","small-tick":"_12wYI","opacity":"_2zekA","charity-info":"bEXTP","jg-tooltip-desktop":"_298tt","jg-tooltip-mobile":"q8B10","tooltip-modal-button":"_13PEL"};

/***/ }),

/***/ "./src/components/CharityEndorsed/CharityEndorsement.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_EndorsingCharityLogo__ = __webpack_require__("./src/components/CharityEndorsed/EndorsingCharityLogo.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_CharityEndorsed_CharityEndorsementTooltip__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsementTooltip.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_responsive__ = __webpack_require__("./node_modules/@justgiving/responsive/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var CharityEndorsement = /** @class */ (function (_super) {
    __extends(CharityEndorsement, _super);
    function CharityEndorsement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CharityEndorsement.prototype.render = function () {
        var charity = this.props.charity;
        var isMobile = !Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["d" /* isDesktopViewport */])();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex " + (!isMobile &&
                'jg-flex-aic') + " jg-space-mbml jg-space-plms jg-space-mtms" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__justgiving_responsive__["c" /* LessThanMedium */], null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md", smallIcon: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__justgiving_responsive__["d" /* Medium */], null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-space-mlms " + (isMobile ? 'jg-flex-column' : 'jg-flex-row') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: (!isMobile &&
                            'jg-text--small') + " jg-space-mbxs jg-space-mrsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsement.pageAssociatedWith", defaultMessage: "This page is associated with {charityName}", values: {
                                charityName: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsement.pageAssociatedWith.charity", defaultMessage: "{charity}", tagName: "b", values: { charity: charity.name } })),
                            } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: (isMobile ? 'jg-space-mbn' : 'jg-text--small') + " jg-text--light" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsement.charityRegistrationNumber", defaultMessage: "Charity Registration No. {registrationNumber}", values: {
                                registrationNumber: charity.registrationNumber,
                            } }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_CharityEndorsed_CharityEndorsementTooltip__["a" /* default */], { isMobile: isMobile })))));
    };
    return CharityEndorsement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CharityEndorsement);


/***/ }),

/***/ "./src/components/CharityEndorsed/CharityEndorsementTooltip.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_InfoWithTooltip_ConfigurableDesktopTooltip__ = __webpack_require__("./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_info_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/info.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var CharityEndorsementTooltip = /** @class */ (function (_super) {
    __extends(CharityEndorsementTooltip, _super);
    function CharityEndorsementTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isTooltipShowing: false,
        };
        _this.toggleTooltip = function () {
            _this.setState({ isTooltipShowing: !_this.state.isTooltipShowing });
        };
        _this.renderTooltipModal = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Modal__["a" /* default */], { isOpen: true, colorTheme: 'dark', onClose: _this.toggleTooltip, shouldCloseOnOverlayClick: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default.a['jg-tooltip-mobile'] + " jg-space-pvlg jg-space-phms jg-display-flex jg-flex-column jg-flex-jcb" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedTooltip.pageAssociatedWithCharity", defaultMessage: "This page is associated with a\u00A0charity" })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedTooltip.charitiesAreAssociatedWithPages", defaultMessage: "Charities are associated with pages where the cause is connected to their ongoing\u00A0mission." })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedTooltip.ownersCanContribute", defaultMessage: "Page owners can make a contribution at any time to support the great work the charity\u00A0does" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-flex-ase", onClick: _this.toggleTooltip },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedTooltip.gotItButton", defaultMessage: "Okay, got it!" })))));
        };
        return _this;
    }
    CharityEndorsementTooltip.prototype.render = function () {
        var isMobile = this.props.isMobile;
        if (isMobile) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__["a" /* default */], { inline: true, className: "qa-info-button", onClick: this.toggleTooltip },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_info_svg___default.a, className: "jg-icon jg-fill--empress" })),
                this.state.isTooltipShowing && this.renderTooltipModal()));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_InfoWithTooltip_ConfigurableDesktopTooltip__["a" /* default */], { displayInline: true, trigger: "hover", tooltipPosition: "right", arrowPosition: "left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-psm" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedTooltip.infoText", defaultMessage: "Charities are associated with pages where the cause is connected to their ongoing mission. Page owners can make a contribution at any time to support the great work the charity does." })))));
    };
    return CharityEndorsementTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CharityEndorsementTooltip);


/***/ }),

/***/ "./src/components/CharityEndorsed/EndorsingCharityLogo.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs_endorsed_tick_il_svg__ = __webpack_require__("./src/components/CharityEndorsed/svgs/endorsed-tick-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs_endorsed_tick_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svgs_endorsed_tick_il_svg__);




var EndorsingCharityLogo = function (_a) {
    var charityLogo = _a.charityLogo, displayTick = _a.displayTick, marginAuto = _a.marginAuto, smallIcon = _a.smallIcon, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default.a['logo-wrapper'] + " jg-bd jg-bd--solid jg-bd--very-light-grey jg-relative jg-background--white " + className + " " + (!marginAuto &&
                'jg-space-mn') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: charityLogo, className: "jg-space-phxs" }),
            displayTick && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svgs_endorsed_tick_il_svg___default.a, className: (smallIcon ? __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default.a['small-tick'] : __WEBPACK_IMPORTED_MODULE_1__CharityEndorsed_scss___default.a.tick) + " jg-fill--mountain-meadow " + (smallIcon ? 'jg-icon--medium-small' : 'jg-icon--medium') + " jg-display-absolute" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (EndorsingCharityLogo);


/***/ }),

/***/ "./src/components/CharityEndorsed/svgs/endorsed-tick-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs></defs><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Endorsed-tick\"><g id=\"Global-Alert-Green-Copy\"><g id=\"icon-/-success-/-med-/-grey\"><path d=\"M12,24 C5.4,24 0,18.6 0,12 C0,5.4 5.4,0 12,0 C18.6,0 24,5.4 24,12 C24,18.6 18.6,24 12,24 L12,24 Z\" id=\"Shape\" fill=\"#25CA76\"></path><path d=\"M9.475,16.975 L6.075,13.575 C5.975,13.475 5.975,13.175 6.075,13.075 L7.075,12.075 C7.175,11.975 7.475,11.975 7.575,12.075 L9.775,14.275 L16.975,7.075 C17.075,6.975 17.375,6.975 17.475,7.075 L18.475,8.075 C18.575,8.175 18.575,8.475 18.475,8.575 L9.975,17.075 C9.775,17.175 9.575,17.175 9.475,16.975 L9.475,16.975 Z\" id=\"Shape\" stroke=\"#FFFFFF\" stroke-width=\"0.5\" fill=\"#FFFFFF\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/ClickableElement/ClickableElement.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"clickable-element":"_36Ab9","clickable-element-block":"c-EQc","clickable-element-inline":"_1HOY9"};

/***/ }),

/***/ "./src/components/ClickableElement/ClickableElement.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss__ = __webpack_require__("./src/components/ClickableElement/ClickableElement.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var ClickableElement = /** @class */ (function (_super) {
    __extends(ClickableElement, _super);
    function ClickableElement(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ClickableElement.prototype.handleClick = function (event) {
        var _a = this.props, onClick = _a.onClick, analyticsClick = _a.analyticsClick, analyticsOptions = _a.analyticsOptions;
        if (onClick) {
            onClick(event);
        }
        if (analyticsOptions) {
            analyticsClick(analyticsOptions);
        }
    };
    ClickableElement.prototype.render = function () {
        var _a = this.props, id = _a.id, inline = _a.inline, children = _a.children, className = _a.className, isDisabled = _a.isDisabled, onMouseDown = _a.onMouseDown, onTouchStart = _a.onTouchStart;
        var style = inline
            ? __WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss___default.a['clickable-element-inline']
            : __WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss___default.a['clickable-element-block'];
        return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", { id: id, type: "button", className: style + " " + className, onClick: this.handleClick, disabled: isDisabled, "data-disabled": isDisabled, onMouseDown: onMouseDown, onTouchStart: onTouchStart }, children));
    };
    return ClickableElement;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(ClickableElement, __WEBPACK_IMPORTED_MODULE_5__ClickableElement_scss___default.a)));


/***/ }),

/***/ "./src/components/ClickableElement/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClickableElement__ = __webpack_require__("./src/components/ClickableElement/ClickableElement.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ClickableElement__["a" /* default */]);


/***/ }),

/***/ "./src/components/Collapse/Collapse.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollapsePanel__ = __webpack_require__("./src/components/Collapse/CollapsePanel.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(props) {
        var _this = _super.call(this, props) || this;
        _this.openPanel = function (key) {
            _this.setState({
                activePanels: _this.props.accordion
                    ? [key]
                    : _this.state.activePanels.concat([key]),
            });
        };
        _this.closePanel = function (key) {
            _this.setState({
                activePanels: _this.state.activePanels.filter(function (i) { return i !== key; }),
            });
        };
        _this.state = {
            activePanels: [],
        };
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(_this.props.children, function (child, index) {
            if (child.props.initialOpenPanel) {
                if (!_this.props.accordion || _this.state.activePanels.length === 0) {
                    _this.state.activePanels.push(index);
                }
            }
        });
        return _this;
    }
    Collapse.prototype.render = function () {
        var _this = this;
        var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child, index) {
            if (child.type.name !== __WEBPACK_IMPORTED_MODULE_1__CollapsePanel__["a" /* default */].name) {
                throw new Error('Collapse component can not handle this type of component');
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
                openPanel: _this.openPanel,
                closePanel: _this.closePanel,
                index: index,
                isActive: _this.state.activePanels.includes(index),
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children);
    };
    Collapse.defaultProps = {
        accordion: false,
    };
    return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Collapse);


/***/ }),

/***/ "./src/components/Collapse/CollapseBody.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height__ = __webpack_require__("./node_modules/react-animate-height/lib/AnimateHeight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_animate_height__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var CollapseBody = /** @class */ (function (_super) {
    __extends(CollapseBody, _super);
    function CollapseBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapseBody.prototype.render = function () {
        var _a = this.props, animationDuration = _a.animationDuration, children = _a.children, props = __rest(_a, ["animationDuration", "children"]);
        var height = !props.isActive ? 0 : 'auto';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_animate_height___default.a, { duration: animationDuration, height: height }, children(__assign({}, props))));
    };
    CollapseBody.defaultProps = {
        animationDuration: 500,
    };
    return CollapseBody;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CollapseBody);


/***/ }),

/***/ "./src/components/Collapse/CollapseHeader.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var CollapseHeader = /** @class */ (function (_super) {
    __extends(CollapseHeader, _super);
    function CollapseHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapseHeader.prototype.render = function () {
        var _a = this.props, children = _a.children, props = __rest(_a, ["children"]);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children(__assign({}, props)));
    };
    return CollapseHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CollapseHeader);


/***/ }),

/***/ "./src/components/Collapse/CollapsePanel.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CollapsePanel = /** @class */ (function (_super) {
    __extends(CollapsePanel, _super);
    function CollapsePanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsePanel.prototype.render = function () {
        var _this = this;
        var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
                togglePanel: _this.props.isActive
                    ? _this.props.closePanel.bind(null, _this.props.index)
                    : _this.props.openPanel.bind(null, _this.props.index),
                isActive: _this.props.isActive,
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: this.props.className || '' }, children);
    };
    return CollapsePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CollapsePanel);


/***/ }),

/***/ "./src/components/Collapse/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__("./src/components/Collapse/Collapse.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollapsePanel__ = __webpack_require__("./src/components/Collapse/CollapsePanel.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollapseHeader__ = __webpack_require__("./src/components/Collapse/CollapseHeader.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollapseBody__ = __webpack_require__("./src/components/Collapse/CollapseBody.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collapse__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__CollapsePanel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CollapseHeader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__CollapseBody__["a"]; });
/* unused harmony reexport Props */
/* unused harmony reexport State */







/***/ }),

/***/ "./src/components/ConfirmIdentityForm/AUAddress/AUAddress.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Select__ = __webpack_require__("./src/components/Select/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ausStates__ = __webpack_require__("./src/components/ConfirmIdentityForm/AUAddress/ausStates.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sortBy__ = __webpack_require__("./node_modules/lodash/sortBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sortBy__);





var sortedStates = __WEBPACK_IMPORTED_MODULE_4_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_3__ausStates__["a" /* default */], ['name']);
var AUAddress = function (_a) {
    var touched = _a.touched, errors = _a.errors;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "addressLine1" }, "Address line 1"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control " + (touched.addressLine1 && errors.addressLine1
                            ? 'jg-form-control--error'
                            : ''), type: "text", id: "addressLine1", name: "addressLine1" }),
                    touched.addressLine1 &&
                        errors.addressLine1 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.addressLine1))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "addressLine2" }, "Address line 2 (optional)"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control", type: "text", id: "addressLine2", name: "addressLine2" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "city" }, "City"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control " + (touched.city && errors.city ? 'jg-form-control--error' : ''), type: "text", id: "city", name: "city" }),
                    touched.city &&
                        errors.city && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.city))))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mn" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-6 col-md-4 jg-space-pn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "state" }, "State"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { name: "state" }, function (_a) {
                        var field = _a.field, form = _a.form;
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Select__["a" /* default */], { items: sortedStates.map(function (state) { return ({
                                value: state.abbreviation,
                                label: state.name,
                                isSelected: state.abbreviation === field.value,
                            }); }), placeholder: "Select a state", onChange: function (selectedState) {
                                form.setFieldValue('state', selectedState.value);
                            } }));
                    }),
                    touched.state &&
                        errors.state && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.state))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group jg-space-mbn" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "postalCode" }, "Postcode"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control " + (touched.postalCode && errors.postalCode
                            ? 'jg-form-control--error'
                            : ''), type: "text", id: "postalCode", name: "postalCode" }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 jg-space-pn" }, touched.postalCode &&
                errors.postalCode && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.postalCode))))));
};
/* harmony default export */ __webpack_exports__["a"] = (AUAddress);


/***/ }),

/***/ "./src/components/ConfirmIdentityForm/AUAddress/ausStates.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ausStates = [
    {
        name: 'New South Wales',
        abbreviation: 'NSW',
    },
    {
        name: 'Victoria',
        abbreviation: 'VIC',
    },
    {
        name: 'Queensland',
        abbreviation: 'QLD',
    },
    {
        name: 'Tasmania',
        abbreviation: 'TAS',
    },
    {
        name: 'South Australia',
        abbreviation: 'SA',
    },
    {
        name: 'Western Australia',
        abbreviation: 'WA',
    },
    {
        name: 'Northern Territory',
        abbreviation: 'NT',
    },
    {
        name: 'Australian Capital Territory',
        abbreviation: 'ACT',
    },
];
/* harmony default export */ __webpack_exports__["a"] = (ausStates);


/***/ }),

/***/ "./src/components/ConfirmIdentityForm/AUAddress/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AUAddress__ = __webpack_require__("./src/components/ConfirmIdentityForm/AUAddress/AUAddress.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AUAddress__["a"]; });




/***/ }),

/***/ "./src/components/ConfirmIdentityForm/GBAddress/GBAddress.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");


var GBAddress = function (_a) {
    var touched = _a.touched, errors = _a.errors;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mn" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 jg-space-pn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group jg-space-mbn" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "postalCode" }, "Postcode"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */], { className: "jg-form-control " + (touched.postalCode && errors.postalCode
                            ? 'jg-form-control--error'
                            : ''), type: "text", id: "postalCode", name: "postalCode" }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 jg-space-pn" }, touched.postalCode &&
                errors.postalCode && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-form-error-copy jg-text--small", role: "alert" }, errors.postalCode))))));
};
/* harmony default export */ __webpack_exports__["a"] = (GBAddress);


/***/ }),

/***/ "./src/components/ConfirmIdentityForm/GBAddress/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GBAddress__ = __webpack_require__("./src/components/ConfirmIdentityForm/GBAddress/GBAddress.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GBAddress__["a"]; });




/***/ }),

/***/ "./src/components/ContactOwner/ContactOwnerModal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContactOwnerModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Recaptcha__ = __webpack_require__("./src/components/Recaptcha/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_FormikFormFields_SingleLineInputWithTextLimit__ = __webpack_require__("./src/components/FormikFormFields/SingleLineInputWithTextLimit.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_TextareaWithCharacterCount__ = __webpack_require__("./src/components/TextareaWithCharacterCount/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sendEmail_il_svg__ = __webpack_require__("./src/components/ContactOwner/sendEmail-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sendEmail_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__sendEmail_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_ContactOwner_messageFormValidator__ = __webpack_require__("./src/components/ContactOwner/messageFormValidator.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};














var ContactOwnerModal = /** @class */ (function (_super) {
    __extends(ContactOwnerModal, _super);
    function ContactOwnerModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.verifyCallback = function (response) {
            if (response) {
                _this.props.setRecaptcha(response);
            }
        };
        return _this;
    }
    ContactOwnerModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeContactOwner = _a.closeContactOwner, onSubmit = _a.onSubmit, ownerName = _a.ownerName, submissionError = _a.submissionError, pageViewSection = _a.pageViewSection, pageSection = _a.pageSection, subjectPlaceHolder = _a.subjectPlaceHolder, messagePlaceholder = _a.messagePlaceholder;
        var closeAnalytics = {
            event: 'click',
            eventValue: 'close contact page owner',
            pageSection: pageSection,
            subtype: 'button',
        };
        return (__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Modal__["a" /* default */], { isOpen: true, colorTheme: 'dark', onClose: closeContactOwner, maintainPosition: true, closeAnalyticsTracking: __assign({}, closeAnalytics) },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "contact page owner", pageSection: pageViewSection, subtype: "cfp" },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", { id: "contact-fundraiser-modal", className: "jg-space-ptlg jg-space-pblg jg-space-phml" },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("header", null,
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_12__sendEmail_il_svg___default.a, className: "jg-svg-sm" }),
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2", { className: "jg-text--center" }, "Send email")),
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_formik__["c" /* Formik */], { initialValues: {
                            subject: '',
                            message: '',
                            email: '',
                        }, validate: __WEBPACK_IMPORTED_MODULE_13_src_components_ContactOwner_messageFormValidator__["a" /* default */], onSubmit: function (values) { return onSubmit(values); } }, function (_a) {
                        var errors = _a.errors, touched = _a.touched, values = _a.values, handleSubmit = _a.handleSubmit, handleChange = _a.handleChange, isSubmitting = _a.isSubmitting;
                        return (__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("form", { onSubmit: handleSubmit },
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", null,
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p", { className: "jg-text--center jg-space-mbmd" },
                                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.sendAMessage", defaultMessage: "Write {ownerName} a message", values: { ownerName: ownerName } })),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_FormikFormFields_SingleLineInputWithTextLimit__["a" /* default */], { error: errors.subject, labelText: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.subject", defaultMessage: "Subject" }), maxLength: 100, name: "subject", touched: touched.subject, placeholder: subjectPlaceHolder }),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_FormikFormFields_SingleLineInputWithTextLimit__["a" /* default */], { labelText: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.email", defaultMessage: "Email (optional)" }), maxLength: 100, name: "email" }),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: "message" }, "Message"),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_src_components_TextareaWithCharacterCount__["a" /* default */], { id: "message", characterLimit: 1000, error: errors.message, touched: touched.message, onChange: handleChange, value: values.message, placeholder: messagePlaceholder }),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_Recaptcha__["a" /* default */], { sitekey: __WEBPACK_IMPORTED_MODULE_6_config__["RECAPTCHA_ID"], verifyCallback: _this.verifyCallback })),
                            submissionError && (__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", { className: "jg-space-mtmd" },
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Alert__["a" /* default */], { id: "contact-owner-email-failure", type: "red", displayType: "inline", persistent: true },
                                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.submissionError", defaultMessage: "It looks like there's been a problem sending your message. Please try again." })))),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", { className: "jg-background--white ja-tac jg-space-phlg jg-space-ptmd" },
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { className: "jg-btn jg-btn--brand", disabled: !_this.props.recaptcha, loading: isSubmitting && !submissionError, value: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.sendButton", defaultMessage: "Send and close" }), analyticsOptions: {
                                        event: 'click',
                                        subtype: 'button',
                                        eventValue: 'message page owner',
                                        pageSection: pageSection,
                                    } }),
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link jg-text--center jg-space-ptmd", onClick: closeContactOwner, analyticsOptions: __assign({}, closeAnalytics) },
                                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "ContactOwnerModal.cancel", defaultMessage: "Cancel" })))));
                    })))));
    };
    return ContactOwnerModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (ContactOwnerModal);


/***/ }),

/***/ "./src/components/ContactOwner/messageFormValidator.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");

var rules = {
    message: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please write your message',
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["d" /* maxLength */])(1000, {
            message: 'Please write your message in 1000 characters, maximum',
        }),
    ],
    subject: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({
            message: 'Please write the subject of your message',
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["d" /* maxLength */])(100, {
            message: 'Please write the subject in 100 characters, maximum',
        }),
    ],
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(rules));


/***/ }),

/***/ "./src/components/ContactOwner/sendEmail-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 94 105\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"45\" cy=\"45\" r=\"45\"></circle><circle id=\"path-3\" cx=\"70\" cy=\"96\" r=\"20\"></circle><filter x=\"-17.5%\" y=\"-12.5%\" width=\"135.0%\" height=\"135.0%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\"><feOffset dx=\"0\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0.703096694 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix></filter></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"desktop_1-copy-5\" transform=\"translate(-676.000000, -208.000000)\"><g id=\"pictogram\" transform=\"translate(676.000000, 191.000000)\"><g id=\"PICTO-EMAIL\"><g id=\"MOUNTAIN\" transform=\"translate(0.000000, 17.280000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#BCE1FF\" xlink:href=\"#path-1\"></use><path d=\"M36.568917,57.3341027 C36.5712173,57.275534 36.5866115,57.2213888 36.5866115,57.1640587 C36.5866115,54.5445661 34.4636264,52.421581 31.8453724,52.421581 C30.7714937,52.421581 29.7906881,52.7926345 28.9976209,53.3946011 C28.1456312,52.1259061 26.6998143,51.2903722 25.0581193,51.2903722 C23.0011347,51.2903722 21.2660128,52.6093196 20.6106088,54.4419381 C20.3455453,54.3607204 20.070396,54.3060444 19.7798525,54.3060444 C18.2388392,54.3060444 16.9917314,55.527849 16.9344012,57.0568301 C15.145842,57.1461872 13.7086954,58.5100787 13.7086954,60.3195174 C13.7086954,62.1866401 15.2353762,63.6002531 17.102145,63.6002531 L35.2013097,63.6002531 C37.0682555,63.6002531 38.5947593,62.1866401 38.5947593,60.3195174 C38.5947593,58.9405856 37.7586946,57.8629911 36.568917,57.3341027\" id=\"Page-1\" fill=\"#FFFFFF\" mask=\"url(#mask-2)\"></path><g mask=\"url(#mask-2)\"><g transform=\"translate(12.240000, 49.680000)\"><path d=\"M78.308424,51.292368 C76.217544,29.881008 62.109144,17.284608 50.152104,10.357488 L0.094104,58.899888 L78.690744,58.867488 C78.685704,56.467008 78.566904,53.946288 78.308424,51.292368\" id=\"Fill-6\" fill=\"#DD44E7\"></path><path d=\"M78.308424,51.292368 C78.566904,53.946288 78.685704,56.467008 78.690744,58.867488 L121.182264,58.850208 L60.832584,0.000288 L50.152104,10.357488 C62.109144,17.284608 76.217544,29.881008 78.308424,51.292368\" id=\"Fill-12\" fill=\"#AD29B6\"></path></g></g></g><g id=\"aeroplane\" transform=\"translate(47.160000, 36.720000) rotate(21.000000) translate(-47.160000, -36.720000) translate(19.440000, 8.640000)\"><polygon id=\"Fill-1\" fill=\"#FFFFFF\" points=\"54.9880495 0.000182634146 54.4386895 0.914723122 54.4359404 0.918375805 26.3686385 47.5389378 45.478944 54.8762646\"></polygon><polygon id=\"Fill-2\" fill=\"#FFFFFF\" points=\"54.9876829 0.000182634146 -9.16363637e-05 37.4146139 13.2931375 42.496409 54.436032 0.918375805 54.4387811 0.914723122 54.9881411 0.000182634146\"></polygon><polygon id=\"Fill-3\" fill=\"#D4D4D4\" points=\"13.2929542 42.4961807 13.2764596 42.511248 21.1938415 56.1343856 26.3685469 47.539166 54.4363069 0.918147512\"></polygon></g></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/Countdown/Countdown.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Countdown = /** @class */ (function (_super) {
    __extends(Countdown, _super);
    function Countdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_date__["e" /* countdown */])(_this.props.endDate);
        return _this;
    }
    Countdown.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.tick) {
            this.intervalId = setInterval(function () { return _this.setState(Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_date__["e" /* countdown */])(_this.props.endDate)); }, this.props.tick);
        }
    };
    Countdown.prototype.componentWillUnmount = function () {
        if (this.props.tick) {
            clearInterval(this.intervalId);
        }
    };
    Countdown.prototype.render = function () {
        var children = this.props.children;
        return children(this.state);
    };
    return Countdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Countdown);


/***/ }),

/***/ "./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2XFF7","v-align-middle":"_1rToJ","button-container":"_3x5RJ"};

/***/ }),

/***/ "./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_react_avatar_editor__ = __webpack_require__("./node_modules/@justgiving/react-avatar-editor/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__justgiving_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Slider__ = __webpack_require__("./src/components/CoverPhotoEditor/Slider/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditor_scss__ = __webpack_require__("./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImageEditor_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_rotate_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/rotate.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_rotate_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_rotate_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_delete_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/delete.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_delete_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_delete_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var ImageEditor = /** @class */ (function (_super) {
    __extends(ImageEditor, _super);
    function ImageEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { minScale: 1, maxScale: 1, width: 0 };
        _this.scale = _this.scale.bind(_this);
        _this.rotate = _this.rotate.bind(_this);
        _this.onLoadSuccess = _this.onLoadSuccess.bind(_this);
        _this.handlePositionChange = _this.handlePositionChange.bind(_this);
        _this.adjustWidth = _this.adjustWidth.bind(_this);
        return _this;
    }
    ImageEditor.prototype.componentDidMount = function () {
        this.adjustWidth();
        window.addEventListener('resize', this.adjustWidth);
    };
    ImageEditor.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.adjustWidth);
    };
    ImageEditor.prototype.adjustWidth = function () {
        this.setState({ width: this.container ? this.container.offsetWidth : 0 });
    };
    ImageEditor.prototype.onLoadSuccess = function (imageState) {
        var _a = this.editor.getDimensions(), width = _a.width, height = _a.height;
        var minScale = Math.min(width / imageState.width, height / imageState.height, 1);
        var maxScale = Math.max(imageState.resource.width / imageState.width, imageState.resource.height / imageState.height, 1);
        this.setState({ minScale: minScale, maxScale: maxScale });
    };
    ImageEditor.prototype.handlePositionChange = function (position) {
        this.props.onCropChange({
            position: position,
            rotate: this.props.rotate,
            scale: this.props.scale,
        });
    };
    ImageEditor.prototype.rotate = function () {
        this.props.onRotateImage({
            position: this.props.position,
            rotate: this.props.rotate + 90,
            scale: this.props.scale,
        });
    };
    ImageEditor.prototype.scale = function (scale) {
        this.props.onCropChange({
            position: this.props.position,
            rotate: this.props.rotate,
            scale: scale,
        });
    };
    ImageEditor.prototype.render = function () {
        var _this = this;
        var _a = this.state, width = _a.width, minScale = _a.minScale, maxScale = _a.maxScale;
        var _b = this.props, image = _b.image, position = _b.position, rotate = _b.rotate, scale = _b.scale, onRemoveImage = _b.onRemoveImage;
        // width is the total width including border, which we want
        // to be 10% of the crop area width on every side
        var cropWidth = width / 1.1;
        var cropHeight = cropWidth / (16 / 9);
        var border = cropWidth * 0.05;
        var isVertical = rotate % 180 !== 0;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container", ref: function (r) {
                _this.container = r;
            } },
            width && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_react_avatar_editor___default.a, { ref: function (c) {
                    _this.editor = c;
                }, image: image, width: isVertical ? cropHeight : cropWidth, height: isVertical ? cropWidth : cropHeight, border: border, position: position, scale: scale, rotate: rotate, color: [204, 204, 204, 0.5], crossOrigin: "anonymous", onLoadSuccess: this.onLoadSuccess, onPositionChange: this.handlePositionChange })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                !(minScale === 1 && maxScale === 1) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Slider__["a" /* default */], { min: minScale, max: maxScale, value: scale, step: 0.001, onChange: this.scale }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center" }, scale < 1
                        ? 'Try zooming in so your photo fills the frame'
                        : 'Zoom and drag to get the crop you want'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mvmd jg-space-mbn@md jg-text--center", styleName: "button-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { inline: true, onClick: this.rotate, className: "jg-space-mbmd jg-space-mbn@sm jg-space-mrmd@xs jg-space-mrlg@md qa-rotate-button", analyticsOptions: {
                            event: 'click',
                            subtype: 'button',
                            eventValue: 'rotate',
                            pageSection: this.props.pageSection,
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_rotate_svg___default.a, className: "jg-icon jg-fill--nobel jg-space-mrsm jg-display-ib" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--link jg-display-ib", styleName: "v-align-middle" }, "Rotate photo")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { inline: true, onClick: onRemoveImage, className: "qa-remove-button", analyticsOptions: {
                            event: 'click',
                            subtype: 'button',
                            eventValue: 'remove',
                            pageSection: this.props.pageSection,
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_delete_svg___default.a, className: "jg-icon jg-fill--nobel jg-space-mrsm jg-display-ib" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--link jg-display-ib", styleName: "v-align-middle" }, "Remove photo"))))));
    };
    return ImageEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(ImageEditor, __WEBPACK_IMPORTED_MODULE_4__ImageEditor_scss___default.a));


/***/ }),

/***/ "./src/components/CoverPhotoEditor/ImageEditor/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageEditor__ = __webpack_require__("./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.tsx");
/* unused harmony reexport CropData */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ImageEditor__["a" /* default */]);



/***/ }),

/***/ "./src/components/CoverPhotoEditor/Slider/Slider.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slider":"_2cG0S"};

/***/ }),

/***/ "./src/components/CoverPhotoEditor/Slider/Slider.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider_scss__ = __webpack_require__("./src/components/CoverPhotoEditor/Slider/Slider.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Slider_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_minus_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/minus.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_minus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_plus_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/plus.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_plus_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = _this.handleChange.bind(_this);
        _this.increase = _this.increase.bind(_this);
        _this.decrease = _this.decrease.bind(_this);
        return _this;
    }
    Slider.prototype.handleChange = function (e) {
        this.props.onChange(parseFloat(e.target.value));
    };
    Slider.prototype.increase = function () {
        this.props.onChange(Math.min(this.props.max, this.props.value * 1.1));
    };
    Slider.prototype.decrease = function () {
        this.props.onChange(Math.max(this.props.min, this.props.value * 0.9));
    };
    Slider.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, value = _a.value, step = _a.step;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "slider" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: "qa-zoom-out", inline: true, onClick: this.decrease },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_minus_svg___default.a, className: "jg-icon--medium jg-fill--nobel jg-space-mrsm" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "range", min: min, max: max, value: value, step: step, onChange: this.handleChange }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: "qa-zoom-in", inline: true, onClick: this.increase },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_plus_svg___default.a, className: "jg-icon--medium jg-fill--nobel jg-space-mlsm" }))));
    };
    return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Slider, __WEBPACK_IMPORTED_MODULE_2__Slider_scss___default.a));


/***/ }),

/***/ "./src/components/CoverPhotoEditor/Slider/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__("./src/components/CoverPhotoEditor/Slider/Slider.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),

/***/ "./src/components/CrossSellBanner/CrossSellBanner.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2TcQq","action-create":"_3emed","action-about":"_1zUro","white":"_264Ju"};

/***/ }),

/***/ "./src/components/CrossSellBanner/CrossSellBanner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CrossSellBanner_scss__ = __webpack_require__("./src/components/CrossSellBanner/CrossSellBanner.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CrossSellBanner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CrossSellBanner_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrossSellBanner = /** @class */ (function (_super) {
    __extends(CrossSellBanner, _super);
    function CrossSellBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CrossSellBanner.prototype.componentDidMount = function () {
        this.props.crossSellBannerImpression();
    };
    CrossSellBanner.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h4 jg-space-mbmd" }, "Great people make things happen"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text" }, "Do you know anyone in need or maybe want to help a local community cause?"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text jg-space-mbmd" }, "Create you own page and don\u02BCt let that cause go unfunded!"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "white" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: __WEBPACK_IMPORTED_MODULE_3_config__["CROWDFUNDING_BASE_URI"] + "/create", className: "jg-btn jg-btn--brand", styleName: "action-create ", onClick: this.props.createPageLikeThis }, "Start a new Page")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: '/', styleName: "action-about" }, "About Crowdfunding")));
    };
    return CrossSellBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(CrossSellBanner, __WEBPACK_IMPORTED_MODULE_4__CrossSellBanner_scss___default.a));


/***/ }),

/***/ "./src/components/EncourageShare/DesktopEncourageShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SharePopup_DesktopSharePopup__ = __webpack_require__("./src/components/SharePopup/DesktopSharePopup.tsx");





var DesktopEncourageShare = function (_a) {
    var ownerName = _a.ownerName, closeModal = _a.closeModal, ownerProfileImage = _a.ownerProfileImage;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_SharePopup_DesktopSharePopup__["a" /* default */], { ownerProfileImage: ownerProfileImage, ownerName: ownerName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.title", defaultMessage: "Sharing with friends is powerful" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.didYouKnow", defaultMessage: "Did you know? Sharing this page with your friends could help {ownerName} get over \u00A3100* in donations.", values: {
                        ownerName: ownerName,
                    } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__["a" /* default */], { buttonText: "Share to Facebook", location: "page > share prompt", className: "jg-space-mbmd" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__["a" /* default */], { id: "skip-share-prompt", onClick: closeModal, className: "jg-text--link jg-text--center jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.maybeLater", defaultMessage: "Not now, maybe later." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--xsmall-light jg-text--center" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.basedOn", defaultMessage: "*Based on JustGiving data from 01/18 to 06/18." })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DesktopEncourageShare);


/***/ }),

/***/ "./src/components/EncourageShare/EncourageShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_responsive__ = __webpack_require__("./node_modules/@justgiving/responsive/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileEncourageShare__ = __webpack_require__("./src/components/EncourageShare/MobileEncourageShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DesktopEncourageShare__ = __webpack_require__("./src/components/EncourageShare/DesktopEncourageShare.tsx");





var EncourageShare = function (_a) {
    var ownerName = _a.ownerName, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, targetCurrency = _a.targetCurrency, onCloseModal = _a.onCloseModal, shareByWhatsApp = _a.shareByWhatsApp, shareBySms = _a.shareBySms, ownerProfileImage = _a.ownerProfileImage;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "share prompt", pageSection: "page > share prompt", subtype: "share prompt" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_responsive__["c" /* LessThanMedium */], null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MobileEncourageShare__["a" /* default */], { ownerName: ownerName, closeModal: onCloseModal, socialShareUrl: socialShareUrl, targetAmount: targetAmount, shareByWhatsApp: shareByWhatsApp, shareBySms: shareBySms, pitchFor: pitchFor, targetCurrency: targetCurrency, ownerProfileImage: ownerProfileImage })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_responsive__["d" /* Medium */], null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DesktopEncourageShare__["a" /* default */], { ownerName: ownerName, closeModal: onCloseModal, ownerProfileImage: ownerProfileImage }))));
};
/* harmony default export */ __webpack_exports__["a"] = (EncourageShare);


/***/ }),

/***/ "./src/components/EncourageShare/MobileEncourageShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_WhatsAppShare__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__ = __webpack_require__("./src/components/SocialShare/SmsShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SharePopup_MobileSharePopup__ = __webpack_require__("./src/components/SharePopup/MobileSharePopup.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MobileEncourageShare = /** @class */ (function (_super) {
    __extends(MobileEncourageShare, _super);
    function MobileEncourageShare() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileEncourageShare.prototype.render = function () {
        var _a = this.props, ownerName = _a.ownerName, closeModal = _a.closeModal, shareByWhatsApp = _a.shareByWhatsApp, shareBySms = _a.shareBySms, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, targetCurrency = _a.targetCurrency, ownerProfileImage = _a.ownerProfileImage;
        var socialShareButton = __WEBPACK_IMPORTED_MODULE_1_i18next__["a" /* default */].language === 'en-US' ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__["a" /* default */], { shareBySms: shareBySms, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isOwner: false, isActive: true, targetCurrency: targetCurrency, location: "page > share prompt", className: "jg-space-mbml jg-btn jg-btn--sms" })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_WhatsAppShare__["a" /* default */], { shareByWhatsApp: shareByWhatsApp, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: true, targetCurrency: targetCurrency, location: "page > share prompt", className: "jg-space-mbml jg-btn jg-btn--whatsapp", messageType: "supporterShare", buttonText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.whatsappButton", defaultMessage: "Share" }) }));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SharePopup_MobileSharePopup__["a" /* default */], { ownerName: ownerName, ownerProfileImage: ownerProfileImage },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-space-mtsm" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.title", defaultMessage: "Sharing with friends is powerful" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.didYouKnow", defaultMessage: "Sharing this page with your friends could help {ownerName} get over \u00A3100* in donations.", values: {
                            ownerName: ownerName,
                        } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-6" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_FacebookShare_FacebookShare__["a" /* default */], { buttonText: "Share", location: "page > share prompt", className: "jg-space-mbmd" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-6" }, socialShareButton)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__["a" /* default */], { id: "skip-share-prompt", onClick: closeModal, className: "jg-text--link jg-text--center jg-space-mbml" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.maybeLater", defaultMessage: "Not now, maybe later." })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--xsmall-light jg-text--center" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "DesktopEncourageShare.basedOn", defaultMessage: "*Based on JustGiving data as of 2018" })))));
    };
    return MobileEncourageShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MobileEncourageShare);


/***/ }),

/***/ "./src/components/Error/Error.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__less_error_less__ = __webpack_require__("./src/components/Error/less/error.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__less_error_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__less_error_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_404_svg__ = __webpack_require__("./src/components/Error/images/404.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_404_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_404_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_500_svg__ = __webpack_require__("./src/components/Error/images/500.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_500_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_500_svg__);





var Error = function (_a) {
    var error = _a.error;
    var imgSrc = error === '404' ? __WEBPACK_IMPORTED_MODULE_3__images_404_svg___default.a : __WEBPACK_IMPORTED_MODULE_4__images_500_svg___default.a;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "errors" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("object", { styleName: "errors-svg", data: imgSrc, type: "image/svg+xml" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { styleName: "errors-heading" }, error === '404'
            ? 'Weʼre really sorry but we canʼt find the page you were looking for.'
            : 'Weʼre really sorry but something unexpected happened.'),
        error === '404' && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { styleName: "errors-body" }, "This probably means that it has moved to a new location, or has been removed from the site. There is also a tiny possibility that you might have mistyped something so please check and have another go, or use the search function to find what you are looking for.")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { styleName: "errors-body" }, "Don\u02BCt forget to follow @JGhelp on Twitter for regular updates. If you\u02BCd like to get in touch, please email us at help@justgiving.com")));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Error, __WEBPACK_IMPORTED_MODULE_2__less_error_less___default.a));


/***/ }),

/***/ "./src/components/Error/images/404.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6618accb66d729430c8c764db2bf164.svg";

/***/ }),

/***/ "./src/components/Error/images/500.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43b3665f6ca042984178cfd12fab0db5.svg";

/***/ }),

/***/ "./src/components/Error/less/error.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"errors":"_3KkrI","errors-svg":"_2HPxi","errors-heading":"_2gs4r","errors-body":"T7-G1"};

/***/ }),

/***/ "./src/components/FacebookShare/FacebookShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_facebook__ = __webpack_require__("./src/helpers/facebook.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_media__ = __webpack_require__("./src/helpers/media.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var mapStateToProps = function (state, ownProps) { return ({
    page: state.page,
    isActive: ownProps.isActive || Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["c" /* isActive */])(state.page),
    isClosed: Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["d" /* isClosed */])(state.page),
    raised: (Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["d" /* isClosed */])(state.page)
        ? state.page.amountRaised
        : state.page.amountPledged) || 0,
}); };
var mapDispatchToProps = function (dispatch, ownProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        shareOnFacebook: __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_page__["u" /* shareOnFacebook */],
        shareOnFacebookOpened: function (data) {
            if (ownProps.shareOnFacebookOpened) {
                ownProps.shareOnFacebookOpened();
            }
            return Object(__WEBPACK_IMPORTED_MODULE_8_src_redux_modules_page__["w" /* shareOnFacebookOpened */])(data);
        },
        shareOnFacebookCancelled: __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_page__["v" /* shareOnFacebookCancelled */],
    }, dispatch);
};
var FacebookShare = /** @class */ (function (_super) {
    __extends(FacebookShare, _super);
    function FacebookShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFacebookShare = function () {
            var _a = _this.props, _b = _a.page, isOwnerRequested = _b.isOwnerRequested, facebookShareImage = _b.facebookShareImage, isUpdate = _a.isUpdate, shareOnFacebook = _a.shareOnFacebook, shareOnFacebookOpened = _a.shareOnFacebookOpened, shareOnFacebookCancelled = _a.shareOnFacebookCancelled, location = _a.location, shareHash = _a.shareHash, media = _a.media, quote = _a.quote, beforeSharingOnFacebook = _a.beforeSharingOnFacebook, eventValue = _a.eventValue;
            var hash = shareHash || Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__["a" /* generateHash */])();
            var sharePromise;
            if (isUpdate) {
                var shareVariation = _this.getUpdateShareVariation();
                sharePromise = _this.shareUpdateOnFacebookFeed({
                    name: shareVariation.name,
                    picture: media && media.length > 0
                        ? Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_media__["a" /* default */])(media[0])
                        : facebookShareImage,
                    description: shareVariation.description,
                    shareHash: hash,
                    quote: quote,
                });
            }
            else if (isOwnerRequested) {
                sharePromise = _this.sharePageOnFacebookFeed({
                    name: 'Donate to my Crowdfunding Page',
                    campaign: 'projectpage-share-owner',
                    shareHash: hash,
                });
            }
            else {
                var shareVariation = _this.getFacebookShareVariation();
                sharePromise = _this.supporterSharePageOnFacebookFeed({
                    id: shareVariation.id,
                    name: shareVariation.title,
                    reference: shareVariation.reference,
                    shareHash: hash,
                });
            }
            if (beforeSharingOnFacebook) {
                beforeSharingOnFacebook();
            }
            shareOnFacebook({
                shareHash: hash,
                location: location,
                eventValue: eventValue,
            });
            sharePromise.then(function () {
                shareOnFacebookOpened({
                    shareHash: hash,
                    location: location,
                    eventValue: eventValue,
                });
            }, function (error) {
                shareOnFacebookCancelled({ error: error });
            });
        };
        return _this;
    }
    FacebookShare.prototype.getFacebookShareVariation = function () {
        var _a = this.props.page, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, ownerName = _a.ownerName, targetCurrency = _a.targetCurrency;
        var variationId = Math.floor(Math.random() * 3 + 106);
        switch (variationId) {
            case 106:
                return {
                    id: variationId,
                    title: "Help raise " + (__WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                        '£') + targetAmount + " to " + pitchFor,
                    reference: 'CFPage_share_B',
                };
            case 107:
                return {
                    id: variationId,
                    title: ownerName + " needs your help",
                    reference: 'CFPage_share_C',
                };
            case 108:
                return {
                    id: variationId,
                    title: "Read " + ownerName + "'s amazing story",
                    reference: 'CFPage_share_D',
                };
            default:
                throw new Error("Unsupported share variation " + variationId);
        }
    };
    FacebookShare.prototype.getUpdateShareVariation = function () {
        var _a = this.props, _b = _a.page, targetAmount = _b.targetAmount, pitchFor = _b.pitchFor, targetCurrency = _b.targetCurrency, message = _a.message, isClosed = _a.isClosed, raised = _a.raised;
        if (isClosed) {
            return {
                name: "Together we've raised " + (__WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                    '£') + raised + " on JustGiving to " + pitchFor,
                description: message || 'Thank you for your support',
            };
        }
        return {
            name: "Help raise " + (__WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                '£') + targetAmount + " to " + pitchFor,
            description: message,
        };
    };
    FacebookShare.prototype.constructUrl = function (path) {
        var updateId = this.props.updateId;
        return path + updateId;
    };
    FacebookShare.prototype.shareUpdateOnFacebookFeed = function (options) {
        if (options === void 0) { options = {}; }
        var _a = this.props, socialShareUrl = _a.page.socialShareUrl, updateId = _a.updateId;
        var url = updateId
            ? socialShareUrl + "/updates/" + updateId.toString(16)
            : socialShareUrl;
        var shareUrl = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_url__["a" /* buildUrl */])(url, {
            utm_id: options.id,
            utm_term: options.shareHash,
        });
        return Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_facebook__["c" /* share */])({
            method: 'share',
            ref: 'projectpage',
            link: shareUrl,
            picture: options.picture,
            name: options.name,
            description: options.description,
            quote: options.quote,
        });
    };
    FacebookShare.prototype.sharePageOnFacebookFeed = function (options) {
        if (options === void 0) { options = {}; }
        var _a = this.props.page, socialShareUrl = _a.socialShareUrl, name = _a.name, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, pitchBecause = _a.pitchBecause, facebookShareImage = _a.facebookShareImage, targetCurrency = _a.targetCurrency;
        var shareUrl = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
            utm_source: 'Facebook',
            utm_medium: 'Yimbyprojectpage',
            utm_content: name,
            utm_campaign: options.campaign,
            utm_term: options.shareHash,
        });
        return Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_facebook__["c" /* share */])({
            method: 'feed',
            link: shareUrl,
            ref: 'projectpage',
            picture: facebookShareImage,
            name: options.name,
            description: options.description ||
                "We're raising " + (__WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                    '£') + targetAmount + " to " + pitchFor + " " + (pitchBecause ? " because " + pitchBecause : ''),
            quote: options.quote,
        });
    };
    FacebookShare.prototype.supporterSharePageOnFacebookFeed = function (options) {
        if (options === void 0) { options = {}; }
        var _a = this.props, _b = _a.page, socialShareUrl = _b.socialShareUrl, ownerName = _b.ownerName, facebookShareImage = _b.facebookShareImage, mobileIframe = _a.mobileIframe;
        var shareUrl = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
            utm_id: options.id,
            utm_term: options.shareHash,
        });
        return Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_facebook__["c" /* share */])({
            method: 'share',
            link: shareUrl,
            ref: options.reference,
            picture: facebookShareImage,
            name: options.name,
            description: ownerName + " is raising money on JustGiving Crowdfunding",
            mobileIframe: mobileIframe,
        });
    };
    FacebookShare.prototype.renderButton = function () {
        var _a = this.props, isActive = _a.isActive, buttonText = _a.buttonText, customStyle = _a.customStyle, _b = _a.className, className = _b === void 0 ? '' : _b;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: this.handleFacebookShare, type: "button", disabled: !isActive, className: customStyle || "jg-btn jg-btn--facebook " + className }, buttonText));
    };
    FacebookShare.prototype.render = function () {
        var renderButtonOnly = this.props.renderButtonOnly;
        if (renderButtonOnly) {
            return this.renderButton();
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-relative" }, this.renderButton());
    };
    FacebookShare.propTypes = {};
    FacebookShare.defaultProps = {
        renderButtonOnly: false,
    };
    return FacebookShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(FacebookShare));


/***/ }),

/***/ "./src/components/FeatureToggle/FeatureToggle.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureToggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var FeatureToggle = /** @class */ (function (_super) {
    __extends(FeatureToggle, _super);
    function FeatureToggle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureToggle.prototype.render = function () {
        var _a = this.props, featureFlag = _a.featureFlag, isTrue = _a.isTrue, children = _a.children;
        return featureFlag === isTrue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, children) : null;
    };
    return FeatureToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ "./src/components/FormatDate/FormatDate.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");



var FormatDate = function (_a) {
    var lng = _a.lng, date = _a.date;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_date__["g" /* formatDate */])(new Date(date), lng));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["c" /* withI18n */])()(FormatDate));


/***/ }),

/***/ "./src/components/FormatDate/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatDate__ = __webpack_require__("./src/components/FormatDate/FormatDate.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormatDate__["a"]; });



/***/ }),

/***/ "./src/components/FormattedCurrency/FormattedCurrency.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_formatter__ = __webpack_require__("./src/helpers/formatter.ts");
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var FormattedCurrency = function (_a) {
    var value = _a.value, children = _a.children, options = __rest(_a, ["value", "children"]);
    var formattedNumber = Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_formatter__["b" /* formatCurrency */])(value, options);
    if (typeof children === 'function') {
        return children(formattedNumber);
    }
    return formattedNumber;
};
/* harmony default export */ __webpack_exports__["a"] = (FormattedCurrency);


/***/ }),

/***/ "./src/components/FormattedCurrency/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/FormattedCurrency.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormattedCurrency__["a"]; });



/***/ }),

/***/ "./src/components/FormikFormFields/SingleLineInputWithTextLimit.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var SingleLineInputWithTextLimit = function (_a) {
    var error = _a.error, inputClassname = _a.inputClassname, labelText = _a.labelText, maxLength = _a.maxLength, name = _a.name, touched = _a.touched, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label", htmlFor: name }, labelText),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* Field */], { name: name, render: function (_a) {
                var field = _a.field;
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", __assign({}, field, { maxLength: maxLength, className: "jg-form-control " + (touched && error ? 'jg-form-control---error' : '') + " " + inputClassname, type: "text", placeholder: placeholder })));
            } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_helpers_validation__["a" /* ValidationResult */], { touched: touched, error: error })));
};
/* harmony default export */ __webpack_exports__["a"] = (SingleLineInputWithTextLimit);


/***/ }),

/***/ "./src/components/Helpers/MeasureSize.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var MeasureSize = /** @class */ (function (_super) {
    __extends(MeasureSize, _super);
    function MeasureSize(props) {
        return _super.call(this, props) || this;
    }
    MeasureSize.prototype.componentDidMount = function () {
        this.measure();
    };
    MeasureSize.prototype.componentDidUpdate = function () {
        if (this.size.width !== this.element.offsetWidth ||
            this.size.height !== this.element.offsetHeight) {
            this.measure();
        }
    };
    MeasureSize.prototype.componentWillUnmount = function () {
        this.props.onMeasure({ width: 0, height: 0 });
    };
    MeasureSize.prototype.measure = function () {
        var size = {
            width: this.element.offsetWidth,
            height: this.element.offsetHeight,
        };
        this.size = size;
        this.props.onMeasure(size);
    };
    MeasureSize.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onMeasure = _a.onMeasure, props = __rest(_a, ["children", "onMeasure"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ ref: function (r) {
                _this.element = r;
            } }, props), children));
    };
    return MeasureSize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MeasureSize);


/***/ }),

/***/ "./src/components/Helpers/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeasureSize__ = __webpack_require__("./src/components/Helpers/MeasureSize.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MeasureSize__["a"]; });



/***/ }),

/***/ "./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon-positioning":"_20igp","tooltip-click-wrapper":"_1JcAY","tooltip":"_1xzhV","tooltip--open":"_3sOyq","tooltip-hover-wrapper":"KeKQN","tooltip-right":"_3ts1Y","tooltip-left":"_1i7ZQ","tooltip-bottom":"Chgsa","tooltip-top":"_1yDAI","arrow-bottom":"k0QLI","arrow-top":"_2ABLl","arrow-right":"_1Z7j1","arrow-left":"_3liDF"};

/***/ }),

/***/ "./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss__ = __webpack_require__("./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipClickTrigger__ = __webpack_require__("./src/components/InfoWithTooltip/TooltipClickTrigger.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_info_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/info.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_InfoWithTooltip_TooltipHoverTrigger__ = __webpack_require__("./src/components/InfoWithTooltip/TooltipHoverTrigger.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var positionMap = {
    bottom: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['tooltip-bottom'],
    left: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['tooltip-left'],
    right: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['tooltip-right'],
    top: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['tooltip-top'],
};
var arrowMap = {
    bottom: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['arrow-bottom'],
    left: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['arrow-left'],
    right: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['arrow-right'],
    top: __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a['arrow-top'],
};
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props, analyticsOptions = _a.analyticsOptions, _b = _a.arrowPosition, arrowPosition = _b === void 0 ? null : _b, className = _a.className, displayInline = _a.displayInline, _c = _a.icon, icon = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_info_svg___default.a : _c, iconClassName = _a.iconClassName, onClick = _a.onClick, _d = _a.tooltipPosition, tooltipPosition = _d === void 0 ? null : _d, _e = _a.trigger, trigger = _e === void 0 ? 'click' : _e;
        var arrowStyles = arrowPosition !== null ? arrowMap[arrowPosition] : null;
        var positionStyles = tooltipPosition !== null ? positionMap[tooltipPosition] : positionMap.top;
        if (trigger === 'click') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipClickTrigger__["a" /* default */], { analyticsOptions: analyticsOptions, className: className, displayInline: displayInline, icon: icon, iconClassName: iconClassName, onClick: onClick, tooltipPosition: positionStyles, arrowPosition: arrowStyles }, this.props.children));
        }
        if (trigger === 'hover') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_InfoWithTooltip_TooltipHoverTrigger__["a" /* default */], { analyticsOptions: analyticsOptions, arrowPosition: arrowStyles, className: className, displayInline: displayInline, icon: icon, iconClassName: iconClassName, tooltipPosition: positionStyles }, this.props.children));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipClickTrigger__["a" /* default */], { analyticsOptions: analyticsOptions, className: className, displayInline: displayInline, icon: icon, iconClassName: iconClassName, onClick: onClick, tooltipPosition: positionStyles }, this.props.children));
    };
    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Tooltip, __WEBPACK_IMPORTED_MODULE_2__ConfigurableDesktopTooltip_scss___default.a));


/***/ }),

/***/ "./src/components/InfoWithTooltip/TooltipClickTrigger.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss__ = __webpack_require__("./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/ClickableElement.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TooltipClickTrigger = /** @class */ (function (_super) {
    __extends(TooltipClickTrigger, _super);
    function TooltipClickTrigger(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutsideTooltip = function (e) {
            if (_this.state.isTooltipShowing &&
                _this.tooltip &&
                !_this.tooltip.contains(e.target)) {
                _this.setState({ isTooltipShowing: false });
            }
        };
        _this.toggleTooltip = function () {
            if (_this.props.onClick) {
                _this.props.onClick();
            }
            _this.setState({
                isTooltipShowing: !_this.state.isTooltipShowing,
            });
        };
        _this.state = {
            isTooltipShowing: false,
        };
        return _this;
    }
    TooltipClickTrigger.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleClickOutsideTooltip);
    };
    TooltipClickTrigger.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutsideTooltip);
    };
    TooltipClickTrigger.prototype.render = function () {
        var _this = this;
        var _a = this.props, analyticsOptions = _a.analyticsOptions, arrowPosition = _a.arrowPosition, className = _a.className, displayInline = _a.displayInline, icon = _a.icon, iconClassName = _a.iconClassName, tooltipPosition = _a.tooltipPosition;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-relative " + __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a['tooltip-click-wrapper'] + " " + (displayInline ? 'jg-display-ib' : '') + " " + (className ? className : ''), ref: function (tooltip) {
                _this.tooltip = tooltip;
            }, id: "myId" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement_ClickableElement__["a" /* default */], { analyticsOptions: analyticsOptions, inline: true, className: "qa-info-button", onClick: this.toggleTooltip },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_svg__["a" /* default */], { markup: icon, className: "jg-icon jg-fill--empress " + (iconClassName &&
                        iconClassName) })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a.tooltip + " " + tooltipPosition + " " + arrowPosition + "\n        " + (this.state.isTooltipShowing ? __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a['tooltip--open'] : '') }, this.props.children)));
    };
    return TooltipClickTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(TooltipClickTrigger, __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a));


/***/ }),

/***/ "./src/components/InfoWithTooltip/TooltipHoverTrigger.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss__ = __webpack_require__("./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TooltipHoverTrigger = /** @class */ (function (_super) {
    __extends(TooltipHoverTrigger, _super);
    function TooltipHoverTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipHoverTrigger.prototype.render = function () {
        var _this = this;
        var _a = this.props, arrowPosition = _a.arrowPosition, className = _a.className, displayInline = _a.displayInline, icon = _a.icon, iconClassName = _a.iconClassName, tooltipPosition = _a.tooltipPosition;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-relative " + __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a['tooltip-hover-wrapper'] + " " + (displayInline ? 'jg-display-ib' : '') + " " + (className && className), ref: function (tooltip) {
                _this.tooltip = tooltip;
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_svg__["a" /* default */], { markup: icon, className: "jg-icon jg-fill--empress " + (iconClassName &&
                    iconClassName) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a.tooltip + " " + tooltipPosition + " " + arrowPosition }, this.props.children)));
    };
    return TooltipHoverTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(TooltipHoverTrigger, __WEBPACK_IMPORTED_MODULE_3__ConfigurableDesktopTooltip_scss___default.a));


/***/ }),

/***/ "./src/components/LastUpdated/LastUpdated.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_clock_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/clock.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_FormatDate__ = __webpack_require__("./src/components/FormatDate/index.ts");







var LastUpdated = function (_a) {
    var createdAt = _a.createdAt, activatedAt = _a.activatedAt, supporters = _a.supporters, updates = _a.updates;
    var lastUpdated = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_date__["k" /* getLastUpdated */])(createdAt, activatedAt, supporters, updates);
    var time = __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(lastUpdated, 'HH.mm');
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--small jg-color--empress jg-space-mlms jg-space-mbsm" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_clock_svg___default.a, className: "jg-display-i jg-icon--medium-small jg-fill--empress jg-space-mrxs" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-i" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */], { i18nKey: "LastUpdated.message" },
                "Page last updated on: ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_FormatDate__["a" /* default */], { date: lastUpdated }),
                " ",
                { time: time }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["c" /* withI18n */])()(LastUpdated));


/***/ }),

/***/ "./src/components/LiveStream/LiveStream.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stream":"_35B6A","stream--fixed":"cXYPP"};

/***/ }),

/***/ "./src/components/LiveStream/LiveStream.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStreamTitle */
/* unused harmony export getStreamUrl */
/* unused harmony export constructStreamSource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeLiveStreamGraphql__ = __webpack_require__("./src/components/LiveStream/executeLiveStreamGraphql.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LiveStream_scss__ = __webpack_require__("./src/components/LiveStream/LiveStream.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LiveStream_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LiveStream_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StickyHeader_Sticky__ = __webpack_require__("./src/components/StickyHeader/Sticky.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var nostream = {
    mediaId: '',
    entry: undefined,
};
var COVER_PHOTO_OFFSET = 430;
var LiveStream = /** @class */ (function (_super) {
    __extends(LiveStream, _super);
    function LiveStream(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, nostream);
        return _this;
    }
    LiveStream.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.props.pageId) {
            this.setState(__assign({}, nostream));
            return;
        }
        if (typeof window === 'undefined') {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__executeLiveStreamGraphql__["a" /* default */])(this.props.pageId)
            .then(function (_a) {
            var data = _a.data;
            if (data && data.livestream) {
                var _b = data.livestream, _c = _b.mediaId, mediaId = _c === void 0 ? '' : _c, _d = _b.entries, entries = _d === void 0 ? [] : _d;
                var entry = entries.find(function (e) { return e.mediaType === 'livestreamMedia'; });
                _this.setState({
                    mediaId: mediaId,
                    entry: entry,
                });
            }
            else {
                _this.setState(__assign({}, nostream));
            }
        })
            .catch(function () {
            _this.setState(__assign({}, nostream));
        });
    };
    LiveStream.prototype.render = function () {
        var entry = this.state.entry;
        return entry ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StickyHeader_Sticky__["a" /* default */], { offset: COVER_PHOTO_OFFSET, delay: 50 }, function (_a) {
            var sticky = _a.sticky;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { title: getStreamTitle(entry), src: constructStreamSource(entry), height: "400", width: "100%", frameBorder: "0", scrolling: "no", allowFullScreen: true, className: sticky ? __WEBPACK_IMPORTED_MODULE_3__LiveStream_scss___default.a['stream--fixed'] : __WEBPACK_IMPORTED_MODULE_3__LiveStream_scss___default.a.stream, "data-qa": "feature-image-stream" }));
        })) : null;
    };
    return LiveStream;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
function getStreamTitle(_a) {
    var streamType = _a.streamType;
    var s = streamType.charAt(0).toUpperCase() + streamType.slice(1);
    return s + " stream";
}
function getStreamUrl(streamUrl, streamId) {
    return streamUrl.replace('{streamId}', streamId);
}
function constructStreamSource(_a) {
    var streamType = _a.streamType, streamId = _a.streamId;
    var streamTypeUpperCase = streamType.toUpperCase();
    if (!(streamTypeUpperCase in __WEBPACK_IMPORTED_MODULE_1_config___default.a.STREAMS)) {
        throw new Error("Stream type '" + streamType + "' not recognised.");
    }
    var isTwitch = streamTypeUpperCase === 'TWITCH';
    var streamUrlTemplate = isTwitch
        ? "" + __WEBPACK_IMPORTED_MODULE_1_config___default.a.STREAMS[streamTypeUpperCase] + window.location.host
        : __WEBPACK_IMPORTED_MODULE_1_config___default.a.STREAMS[streamTypeUpperCase];
    return getStreamUrl(streamUrlTemplate, streamId);
}
/* harmony default export */ __webpack_exports__["a"] = (LiveStream);


/***/ }),

/***/ "./src/components/LiveStream/executeLiveStreamGraphql.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LIVESTREAM_QUERY */
/* harmony export (immutable) */ __webpack_exports__["a"] = executeLiveStreamGraphql;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__("./node_modules/apollo-link/lib/bundle.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__("./node_modules/apollo-link-http/lib/bundle.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__ = __webpack_require__("./src/helpers/auth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__("./node_modules/graphql-tag/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var LIVESTREAM_QUERY = __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query LiveStream($legacyId: String!) {\n    livestream(legacyId: $legacyId) {\n      pageId\n      mediaId\n      entries {\n        mediaType\n        streamId\n        streamType\n      }\n    }\n  }\n"], ["\n  query LiveStream($legacyId: String!) {\n    livestream(legacyId: $legacyId) {\n      pageId\n      mediaId\n      entries {\n        mediaType\n        streamId\n        streamType\n      }\n    }\n  }\n"])));
var auth = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["a" /* getAuth */])();
var httpLink = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* createHttpLink */])({
    uri: __WEBPACK_IMPORTED_MODULE_1_config__["GRAPHQL_API_URI"],
    credentials: 'include',
    headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        Authorization: "Bearer " + auth.getAccessToken(),
    }),
    fetch: fetch,
    fetchOptions: {
        mode: 'cors',
    },
});
function executeLiveStreamGraphql(legacyId, link) {
    if (link === void 0) { link = httpLink; }
    return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["e" /* makePromise */])(Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* execute */])(link, {
        query: LIVESTREAM_QUERY,
        variables: {
            legacyId: legacyId,
        },
    }));
}
var templateObject_1;


/***/ }),

/***/ "./src/components/LoadingButton/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spin_js__ = __webpack_require__("./node_modules/spin.js/spin.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



var LoadingButton = function (_a) {
    var id = _a.id, value = _a.value, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, type = _a.type, className = _a.className, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? 'white' : _d;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { id: id, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('jg-btn', className), onClick: onClick, disabled: disabled || loading, type: type }, loading ? (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "jg-loading--small jg-loading--" + color },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { className: "jg-loading__container", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle", { className: "jg-loading__circle", cx: "24", cy: "24", r: "20" })))) : (value)));
};
/* harmony default export */ __webpack_exports__["a"] = (LoadingButton);


/***/ }),

/***/ "./src/components/LoadingOverlay/LoadingOverlay.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1Bexs"};

/***/ }),

/***/ "./src/components/LoadingOverlay/LoadingOverlay.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_loading__ = __webpack_require__("./node_modules/@justgiving/loading/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__("./node_modules/react-portal/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingOverlay_scss__ = __webpack_require__("./src/components/LoadingOverlay/LoadingOverlay.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingOverlay_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LoadingOverlay_scss__);





var LoadingOverlay = function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */], null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "overlay" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_loading__["a" /* default */], { size: "medium" })))); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(LoadingOverlay, __WEBPACK_IMPORTED_MODULE_4__LoadingOverlay_scss___default.a));


/***/ }),

/***/ "./src/components/LoadingOverlay/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadingOverlay__ = __webpack_require__("./src/components/LoadingOverlay/LoadingOverlay.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LoadingOverlay__["a" /* default */]);


/***/ }),

/***/ "./src/components/Modal/Modal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"_9QpxU","modal--large":"_1YCcn","modal-background":"_2pASI _9QpxU","overlay":"_26LpG","close-button":"_2LBGk","light-close-button":"_2yaRD","dark-close-button":"_3nX6C"};

/***/ }),

/***/ "./src/components/Modal/Modal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Modal_ModalInner__ = __webpack_require__("./src/components/Modal/ModalInner.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        if (true) {
            _this.elem = document.createElement('div');
            document.body.appendChild(_this.elem);
        }
        return _this;
    }
    Modal.prototype.componentWillUnmount = function () {
        document.body.removeChild(this.elem);
    };
    Modal.prototype.render = function () {
        if (!this.props.isOpen || !this.elem) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Modal_ModalInner__["a" /* default */], __assign({}, this.props)), this.elem);
    };
    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Modal);


/***/ }),

/***/ "./src/components/Modal/ModalInner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_scss__ = __webpack_require__("./src/components/Modal/Modal.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
};
var ModalInner = /** @class */ (function (_super) {
    __extends(ModalInner, _super);
    function ModalInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyUp = function (e) {
            if (e.keyCode === 27) {
                _this.handleModalClose();
            }
        };
        _this.handleModalClose = function () {
            var _a = _this.props, onClose = _a.onClose, analyticsClick = _a.analyticsClick, closeAnalyticsTracking = _a.closeAnalyticsTracking;
            if (onClose) {
                onClose();
                if (closeAnalyticsTracking) {
                    analyticsClick(closeAnalyticsTracking);
                }
            }
        };
        _this.handleClickOutsideModal = function () {
            if (_this.props.isOpen) {
                _this.handleModalClose();
            }
        };
        _this.preventBodyToScroll = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    ModalInner.prototype.componentDidMount = function () {
        var scrollToTop = this.props.scrollToTop;
        document.body.classList.add(this.props.maintainPosition ? 'no-scroll' : 'body-fixed');
        if (scrollToTop) {
            window.scrollTo(0, 0);
            return;
        }
        document.addEventListener('keyup', this.handleKeyUp);
        document.body.addEventListener('touchmove', this.preventBodyToScroll);
    };
    ModalInner.prototype.componentWillUnmount = function () {
        var scrollToTopOnClose = this.props.scrollToTopOnClose;
        document.body.classList.remove(this.props.maintainPosition ? 'no-scroll' : 'body-fixed');
        if (scrollToTopOnClose) {
            window.scrollTo(0, 0);
        }
        document.removeEventListener('keyup', this.handleKeyUp);
        document.body.removeEventListener('touchmove', this.preventBodyToScroll);
    };
    ModalInner.prototype.render = function () {
        var _a = this.props, colorTheme = _a.colorTheme, contentLabel = _a.contentLabel, onClose = _a.onClose, noBackground = _a.noBackground, large = _a.large, classNames = _a.classNames;
        var hasClose = !!onClose;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a.overlay, onClick: this.props.shouldCloseOnOverlayClick
                ? this.handleModalClose
                : function () { } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "\n            " + (noBackground ? __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a.modal : __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a['modal-background']) + "\n            " + (large ? __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a['modal--large'] : '') + "\n            " + (classNames || '') + "\n          ", "aria-label": contentLabel, onClick: function (e) { return e.stopPropagation(); } },
                hasClose && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__["a" /* default */], { onClick: this.handleModalClose, className: __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a[colorTheme + "-close-button"] + " qa-close-button", inline: true }, "Close")),
                this.props.children)));
    };
    return ModalInner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(ModalInner, __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a)));


/***/ }),

/***/ "./src/components/Modal/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__("./src/components/Modal/Modal.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Modal__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/CoverImage.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image":"_2pRru"};

/***/ }),

/***/ "./src/components/Page/CoverImage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoverImage_scss__ = __webpack_require__("./src/components/Page/CoverImage.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoverImage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CoverImage_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var maxSize = { width: 1200 * 1.7, height: 400 * 1.7 };
var imageTemplate = 'Size800w';
var CoverImage = /** @class */ (function (_super) {
    __extends(CoverImage, _super);
    function CoverImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            imageUrl: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_image__["e" /* getCoverImageUrl */])(props.coverImage, maxSize, imageTemplate),
        };
        return _this;
    }
    CoverImage.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            imageUrl: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_image__["e" /* getCoverImageUrl */])(nextProps.coverImage, maxSize, imageTemplate),
        });
    };
    CoverImage.prototype.render = function () {
        var imageUrl = this.state.imageUrl;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "image", style: { backgroundImage: "url(" + imageUrl + ")" } }));
    };
    return CoverImage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(CoverImage, __WEBPACK_IMPORTED_MODULE_3__CoverImage_scss___default.a));


/***/ }),

/***/ "./src/components/Page/DonateButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fixed-donate-button":"_3iUpP"};

/***/ }),

/***/ "./src/components/Page/DonateButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DonateButton_scss__ = __webpack_require__("./src/components/Page/DonateButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DonateButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DonateButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_experiments__ = __webpack_require__("./src/constants/experiments.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_base64__ = __webpack_require__("./src/helpers/base64.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");








function DonateButton(_a) {
    var isActive = _a.isActive, name = _a.name, pageSection = _a.pageSection, donate = _a.donate, 
    // Pass all the experiments by default
    _b = _a.experiments, 
    // Pass all the experiments by default
    experiments = _b === void 0 ? Object.values(__WEBPACK_IMPORTED_MODULE_5_src_constants_experiments__["a" /* experiments */]) : _b, _c = _a.successType, successType = _c === void 0 ? 'StaticDonateButtonClick' : _c;
    var buttonClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('jg-btn', {
        'is-disabled': !isActive,
    });
    var buildQueryString = function () {
        var urlParams = new URLSearchParams();
        if (pageSection) {
            urlParams.append('pageSection', pageSection);
        }
        var trimmedSuccessType = successType.trim();
        var trimmedExperiments = experiments
            .map(function (e) { return e.trim(); })
            .filter(function (e) { return e !== ''; });
        if (trimmedExperiments &&
            trimmedExperiments.length > 0 &&
            trimmedSuccessType) {
            urlParams.append('experiments', Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_base64__["a" /* encodeBase64 */])(trimmedExperiments.join(',')));
            urlParams.append('successType', Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_base64__["a" /* encodeBase64 */])(trimmedSuccessType));
        }
        return urlParams.toString() ? "?" + urlParams.toString() : '';
    };
    var donateLink = isActive
        ? __WEBPACK_IMPORTED_MODULE_3_config___default.a.CROWDFUNDING_BASE_URI + "/" + name + "/donate" + buildQueryString()
        : null;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { "data-marker": "donate-button", onClick: function () { return donate({ pageSection: pageSection }); }, href: donateLink, className: buttonClass, styleName: "fixed-donate-button" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "Common.Donate" }, "Give Now")));
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(DonateButton, __WEBPACK_IMPORTED_MODULE_4__DonateButton_scss___default.a));


/***/ }),

/***/ "./src/components/Page/Meta/Meta.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1dWAS","meta-item":"_1ssAN","heading":"_1G9vq","value":"BZ4C-","icon":"e7cXw"};

/***/ }),

/***/ "./src/components/Page/Meta/Meta.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__("./node_modules/date-fns/difference_in_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_countdown__ = __webpack_require__("./src/helpers/countdown.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Meta_scss__ = __webpack_require__("./src/components/Page/Meta/Meta.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Meta_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Meta_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__justgiving_icons_lib_map_pin_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/map-pin.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__justgiving_icons_lib_map_pin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__justgiving_icons_lib_map_pin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__justgiving_icons_lib_care_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/care.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__justgiving_icons_lib_care_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__justgiving_icons_lib_care_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__justgiving_icons_lib_clock_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/clock.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__justgiving_icons_lib_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__justgiving_icons_lib_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var Meta = /** @class */ (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.getCountdownMessage = function () {
        var _a = this.props, finishedAt = _a.finishedAt, status = _a.status;
        if (status === 'FullyFunded' || status === 'ReportGenerated') {
            return "Funded on " + __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(finishedAt, 'dddd, Do MMMM YYYY');
        }
        if (status === 'TargetNotReached') {
            return "Closed on " + __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(finishedAt, 'dddd, Do MMMM YYYY');
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_countdown__["a" /* getTimeLeft */])(finishedAt) + " to go";
    };
    Meta.prototype.canEditField = function (value) {
        var _a = this.props, isOwner = _a.isOwner, status = _a.status;
        return !value && isOwner && Object(__WEBPACK_IMPORTED_MODULE_13_src_helpers_page__["c" /* isActive */])({ status: status });
    };
    Meta.prototype.shouldDisplayIcon = function (value) {
        return value || this.canEditField(value);
    };
    Meta.prototype.renderLocation = function () {
        var _a = this.props, location = _a.location, goEdit = _a.goEdit;
        if (this.canEditField(location)) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { onClick: function () { return goEdit('location'); }, inline: true, className: "jg-text--link" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "Meta.addLocation", defaultMessage: "Add location" })));
        }
        return location;
    };
    Meta.prototype.renderCategory = function () {
        var _a = this.props, categoryId = _a.categoryId, categories = _a.categories, goEdit = _a.goEdit;
        if (this.canEditField(categoryId)) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { onClick: function () { return goEdit('category'); }, inline: true, className: "jg-text--link" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "Meta.addCategory", defaultMessage: "Add category" })));
        }
        var category = categories.filter(function (c) { return c.id === categoryId; })[0];
        if (category) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { target: "_blank", rel: "noreferrer noopener", href: category.url, className: "jg-text--link" }, category.name));
        }
        return null;
    };
    Meta.prototype.render = function () {
        var _a = this.props, location = _a.location, categoryId = _a.categoryId, finishedAt = _a.finishedAt, supportsRecurringDonations = _a.supportsRecurringDonations;
        var daysRemaining = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(finishedAt, new Date());
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dl", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "meta-item" },
                this.shouldDisplayIcon(location) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", { styleName: "heading" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_10__justgiving_icons_lib_map_pin_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_6__Meta_scss___default.a.icon + " jg-fill--nobel jg-display-i" }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", { className: "jg-text--small", styleName: "value" }, this.renderLocation())),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "meta-item" },
                this.shouldDisplayIcon(categoryId) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", { styleName: "heading" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_11__justgiving_icons_lib_care_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_6__Meta_scss___default.a.icon + " jg-fill--nobel jg-display-i" }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", { className: "jg-text--small", styleName: "value" }, this.renderCategory())),
            (daysRemaining <= __WEBPACK_IMPORTED_MODULE_7_config__["MIN_PAGE_LIFE"] || supportsRecurringDonations) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "meta-item", id: "qa-countdown-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", { styleName: "heading" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_12__justgiving_icons_lib_clock_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_6__Meta_scss___default.a.icon + " jg-fill--nobel jg-display-i" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", { className: "jg-text--small", styleName: "value" }, this.getCountdownMessage())))));
    };
    return Meta;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Meta, __WEBPACK_IMPORTED_MODULE_6__Meta_scss___default.a));


/***/ }),

/***/ "./src/components/Page/Meta/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Meta__ = __webpack_require__("./src/components/Page/Meta/Meta.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Meta__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/Owner.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"owner":"_3AZeb","heading":"RzMYU","owner-info":"_2rWU_","owner-raising-for":"_3LqTv","name":"_3OxNC","avatar":"hrjS6"};

/***/ }),

/***/ "./src/components/Page/Owner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Owner_scss__ = __webpack_require__("./src/components/Page/Owner.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Owner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Owner_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pitch__ = __webpack_require__("./src/components/Page/Pitch.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var PageOwner = /** @class */ (function (_super) {
    __extends(PageOwner, _super);
    function PageOwner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageOwner.prototype.renderPitchMessage = function () {
        var _a = this.props, isClosed = _a.isClosed, raised = _a.raised, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor;
        if (isClosed) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Pitch__["b" /* PageClosedPitch */], { raised: raised, targetCurrency: targetCurrency, pitchFor: pitchFor }));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Pitch__["a" /* PageActivePitch */], { targetAmount: targetAmount, targetCurrency: targetCurrency, pitchFor: pitchFor }));
    };
    PageOwner.prototype.render = function () {
        var _a = this.props, ownerName = _a.ownerName, profileImage = _a.profileImage;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "owner" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "owner-info" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Link"], { to: "about-fundraiser", spy: true, smooth: true, offset: -60, duration: 500 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Avatar__["b" /* OwnerAvatar */], { src: profileImage, alt: ownerName, size: "large" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { styleName: "name" }, ownerName))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "owner-raising-for" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { id: "pitch", className: "jg-h1 jg-space-mbn" }, this.renderPitchMessage()))));
    };
    return PageOwner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(PageOwner, __WEBPACK_IMPORTED_MODULE_4__Owner_scss___default.a));


/***/ }),

/***/ "./src/components/Page/PageContent/PageContent.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"_8TAnM"};

/***/ }),

/***/ "./src/components/Page/PageContent/PageContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageContent_scss__ = __webpack_require__("./src/components/Page/PageContent/PageContent.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageContent_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageContent_scss__);


var PageContent = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__PageContent_scss___default.a.content }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (PageContent);


/***/ }),

/***/ "./src/components/Page/PageContent/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageContent__ = __webpack_require__("./src/components/Page/PageContent/PageContent.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PageContent__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/PageContentWrapper/PageContentWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2x2HD"};

/***/ }),

/***/ "./src/components/Page/PageContentWrapper/PageContentWrapper.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageContentWrapper_scss__ = __webpack_require__("./src/components/Page/PageContentWrapper/PageContentWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageContentWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageContentWrapper_scss__);


var PageContentWrapper = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__PageContentWrapper_scss___default.a.wrapper }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (PageContentWrapper);


/***/ }),

/***/ "./src/components/Page/PageContentWrapper/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageContentWrapper__ = __webpack_require__("./src/components/Page/PageContentWrapper/PageContentWrapper.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PageContentWrapper__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/PageFooter.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fixed-footer":"_3nhFE","fixed-share-button":"wk0tk"};

/***/ }),

/***/ "./src/components/Page/PageFooter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DonateButton__ = __webpack_require__("./src/components/Page/DonateButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageFooter_scss__ = __webpack_require__("./src/components/Page/PageFooter.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageFooter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageFooter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShareModal_ShareButton__ = __webpack_require__("./src/components/ShareModal/ShareButton.tsx");





var PageFooter = function (_a) {
    var donate = _a.donate, canPageReceiveDonations = _a.canPageReceiveDonations, page = _a.page, handleShareButtonClick = _a.handleShareButtonClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "fixed-footer" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DonateButton__["a" /* default */], { donate: donate, isActive: canPageReceiveDonations, name: page.name, pageSection: "page > sticky footer" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "fixed-share-button" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShareModal_ShareButton__["a" /* default */], { handleShareClick: handleShareButtonClick }))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(PageFooter, __WEBPACK_IMPORTED_MODULE_3__PageFooter_scss___default.a));


/***/ }),

/***/ "./src/components/Page/PageHeader/PageHeader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Kg8j","owner-meta-container":"_3PC6E","cover-image-container":"_3L2SI","progress-donate-container":"_1RlLY","owner":"_2Ot8h","crowdfunding-title-link":"_19AN-","title-wrapper":"tuA3h","title":"qquOT","countdown":"_1nBrW","meta":"n1lvr","progress":"_2CErZ","actions":"_20Tva","share-unavailable":"_3I2D5","recurring-donations":"_3o9qU","bottom-right":"_1Qt_b","link":"BpHwL"};

/***/ }),

/***/ "./src/components/Page/PageHeader/PageHeader.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_CharityEndorsement__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsement.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Page_CoverImage__ = __webpack_require__("./src/components/Page/CoverImage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Page_DonateButton__ = __webpack_require__("./src/components/Page/DonateButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Reminders__ = __webpack_require__("./src/components/Reminders/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_LiveStream_LiveStream__ = __webpack_require__("./src/components/LiveStream/LiveStream.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Page_Meta__ = __webpack_require__("./src/components/Page/Meta/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Page_Owner__ = __webpack_require__("./src/components/Page/Owner.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_RecurringDonations_PageSupportsRecurringDonations__ = __webpack_require__("./src/components/RecurringDonations/PageSupportsRecurringDonations.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Page_Progress__ = __webpack_require__("./src/components/Page/Progress.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Page_RecurringPaymentsButtons___ = __webpack_require__("./src/components/Page/RecurringPaymentsButtons/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_ReminderModal_ReminderModal__ = __webpack_require__("./src/components/ReminderModal/ReminderModal.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_ShareModal_ShareButton__ = __webpack_require__("./src/components/ShareModal/ShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_SupportersAvatar_SupportersAvatar__ = __webpack_require__("./src/components/SupportersAvatar/SupportersAvatar.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_SupportersAvatar_constructSupportersList__ = __webpack_require__("./src/components/SupportersAvatar/constructSupportersList.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss__ = __webpack_require__("./src/components/Page/PageHeader/PageHeader.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

















var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.donate = function () {
            var _a = _this.props, donate = _a.donate, canPageReceiveDonations = _a.canPageReceiveDonations;
            if (canPageReceiveDonations) {
                donate();
            }
        };
        _this.state = {
            isReminderModalOpen: false,
        };
        return _this;
    }
    PageHeader.prototype.componentWillMount = function () {
        var _a = this.props, isClosed = _a.isClosed, loadSupportersAvatar = _a.loadSupportersAvatar, id = _a.page.id;
        var loadDetails = {
            pageId: id,
            size: 15,
        };
        if (isClosed) {
            loadSupportersAvatar(loadDetails);
        }
    };
    PageHeader.prototype.renderDonate = function () {
        var _a = this.props, isClosed = _a.isClosed, canPageReceiveDonations = _a.canPageReceiveDonations, name = _a.page.name;
        if (isClosed) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Page_DonateButton__["a" /* default */], { donate: this.donate, isActive: canPageReceiveDonations, name: name, pageSection: "page > top" }));
    };
    PageHeader.prototype.renderSupporters = function () {
        var _a = this.props, isClosed = _a.isClosed, items = _a.supportersAvatar.items;
        if (!isClosed && items.length < 1) {
            return null;
        }
        var supportersList = Object(__WEBPACK_IMPORTED_MODULE_15_src_components_SupportersAvatar_constructSupportersList__["a" /* default */])(items);
        if (supportersList) {
            return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_src_components_SupportersAvatar_SupportersAvatar__["a" /* default */], { supportersList: supportersList });
        }
        return null;
    };
    PageHeader.prototype.toggleReminderModal = function (isOpen) {
        this.setState({ isReminderModalOpen: isOpen });
        this.props.handleReminderModalToggle(isOpen);
    };
    PageHeader.prototype.renderBeMyFirstDonorProgress = function () {
        var _a = this.props, profileImage = _a.profileImage, ownerName = _a.page.ownerName;
        var defaultMessage = 'Be the first to help {ownerName} reach their {target} target';
        var additionalProps = {
            shouldShowProfileImage: true,
            profileImage: profileImage,
            ownerName: ownerName,
        };
        return this.renderProgess(defaultMessage, additionalProps);
    };
    PageHeader.prototype.renderDefaultProgress = function () {
        var defaultMessage = 'raised of {target} target by {supporters}';
        return this.renderProgess(defaultMessage);
    };
    PageHeader.prototype.renderProgess = function (defaultMessage, additionalProps) {
        var _a = this.props, raised = _a.raised, _b = _a.page, targetAmount = _b.targetAmount, targetCurrency = _b.targetCurrency, totalCountSupporters = _a.totalCountSupporters;
        return (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_Page_Progress__["a" /* default */], __assign({ raised: raised, targetAmount: targetAmount, targetCurrency: targetCurrency, totalCountSupporters: totalCountSupporters, defaultMessage: defaultMessage }, additionalProps)));
    };
    PageHeader.prototype.renderShareButton = function () {
        if (!this.props.isActive && !this.props.isClosed) {
            return (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "share-unavailable" },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span", null, "This page isn\u2019t active yet.")));
        }
        return (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "jg-space-mtsm" },
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_src_components_ShareModal_ShareButton__["a" /* default */], { handleShareClick: this.props.handleShareButtonClick })));
    };
    PageHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, categories = _a.categories, charity = _a.charity, clearRecaptcha = _a.clearRecaptcha, contactOwner = _a.contactOwner, goEdit = _a.goEdit, isClosed = _a.isClosed, location = _a.location, _b = _a.page, categoryId = _b.categoryId, finishedAt = _b.finishedAt, id = _b.id, initialImage = _b.initialImage, isOwnerRequested = _b.isOwnerRequested, name = _b.name, ownerBio = _b.ownerBio, ownerName = _b.ownerName, pitchFor = _b.pitchFor, recurringDonationsPitch = _b.recurringDonationsPitch, status = _b.status, targetAmount = _b.targetAmount, targetCurrency = _b.targetCurrency, socialShareUrl = _b.socialShareUrl, profileImage = _a.profileImage, raised = _a.raised, recaptcha = _a.recaptcha, supportsRecurringDonations = _a.supportsRecurringDonations, isActive = _a.isActive, totalCountSupporters = _a.totalCountSupporters, canPageReceiveDonations = _a.canPageReceiveDonations;
        return (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "cover-image-container" },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Page_CoverImage__["a" /* default */], { coverImage: initialImage }),
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_LiveStream_LiveStream__["a" /* default */], { pageId: id })),
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "progress-donate-container" },
                totalCountSupporters === 0 && canPageReceiveDonations
                    ? this.renderBeMyFirstDonorProgress()
                    : this.renderDefaultProgress(),
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "actions", className: "jg-space-ptms jg-space-pbsm jg-space-phlg@xl jg-space-prml" },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "jg-display-b" },
                        this.renderDonate(),
                        supportsRecurringDonations && (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "jg-space-mtsm jg-space-mbmd jg-text--center" },
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_src_components_Page_RecurringPaymentsButtons___["a" /* default */], { donate: this.donate, name: name, pageSection: "page > top" })))),
                    this.renderSupporters(),
                    this.renderShareButton())),
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "owner-meta-container" },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "owner" },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_Page_Owner__["a" /* default */], { clearRecaptcha: clearRecaptcha, contactOwner: contactOwner, id: id, isOwner: isOwnerRequested, name: name, ownerBio: ownerBio, ownerName: ownerName, pitchFor: pitchFor, profileImage: profileImage, recaptcha: recaptcha, targetAmount: targetAmount, targetCurrency: targetCurrency, isClosed: isClosed, raised: raised })),
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { styleName: "meta" },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Page_Meta__["a" /* default */], { categories: categories, categoryId: categoryId, goEdit: goEdit, isOwner: isOwnerRequested, location: location, finishedAt: finishedAt, status: status, supportsRecurringDonations: supportsRecurringDonations })),
                charity && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_CharityEndorsement__["a" /* default */], { charity: charity })),
            supportsRecurringDonations && (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: "jg-space-mtsm jg-space-pbsm jg-text--center jg-bdb jg-bd--solid jg-bd--very-light-grey " + __WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss___default.a['recurring-donations'] },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_src_components_Page_RecurringPaymentsButtons___["a" /* default */], { donate: this.donate, name: name, pageSection: "page > top" }))),
            supportsRecurringDonations && (__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss___default.a['bottom-right'] + " jg-space-pmd" },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_RecurringDonations_PageSupportsRecurringDonations__["a" /* default */], { isOwnerRequested: isOwnerRequested, recurringDonationsPitch: recurringDonationsPitch }))),
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Reminders__["a" /* default */], { pageSection: "page > header", handleClick: function () { return _this.toggleReminderModal(true); } }),
            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_src_components_ReminderModal_ReminderModal__["a" /* default */], { handleModalClose: function () { return _this.toggleReminderModal(false); }, showModal: this.state.isReminderModalOpen, pageSection: "page > header", isActive: isActive, socialShareUrl: socialShareUrl, pitchFor: pitchFor, targetAmount: targetAmount, targetCurrency: targetCurrency, ownerName: ownerName })));
    };
    return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_css_modules___default()(PageHeader, __WEBPACK_IMPORTED_MODULE_16_src_components_Page_PageHeader_PageHeader_scss___default.a));


/***/ }),

/***/ "./src/components/Page/PageHeader/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageHeader__ = __webpack_require__("./src/components/Page/PageHeader/PageHeader.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PageHeader__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/PageSidebar/PageSidebar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"pic6c"};

/***/ }),

/***/ "./src/components/Page/PageSidebar/PageSidebar.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageSidebar_scss__ = __webpack_require__("./src/components/Page/PageSidebar/PageSidebar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageSidebar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageSidebar_scss__);


var PageSidebar = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__PageSidebar_scss___default.a.sidebar }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (PageSidebar);


/***/ }),

/***/ "./src/components/Page/PageSidebar/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageSidebar__ = __webpack_require__("./src/components/Page/PageSidebar/PageSidebar.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PageSidebar__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/PageWrapper/PageWrapper.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var PageWrapper = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "container jg-space-phn" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (PageWrapper);


/***/ }),

/***/ "./src/components/Page/PageWrapper/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper__ = __webpack_require__("./src/components/Page/PageWrapper/PageWrapper.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PageWrapper__["a" /* default */]);


/***/ }),

/***/ "./src/components/Page/Pitch.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = PageClosedPitch;
/* harmony export (immutable) */ __webpack_exports__["a"] = PageActivePitch;
/* unused harmony export Pitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_math__ = __webpack_require__("./src/helpers/math.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_formatter__ = __webpack_require__("./src/helpers/formatter.ts");



function PageClosedPitch(_a) {
    var raised = _a.raised, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pitch, { text: 'Weʼve raised', amount: raised, targetCurrency: targetCurrency, pitchFor: pitchFor }));
}
function PageActivePitch(_a) {
    var targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pitch, { text: 'Weʼre raising', amount: targetAmount, targetCurrency: targetCurrency, pitchFor: pitchFor }));
}
var Pitch = function (_a) {
    var text = _a.text, amount = _a.amount, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor;
    var formattedNumber = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_formatter__["b" /* formatCurrency */])(Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_math__["b" /* floor */])(amount, 0), {
        currency: targetCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
        text,
        " ",
        formattedNumber,
        " to ",
        pitchFor));
};


/***/ }),

/***/ "./src/components/Page/Progress.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"_3QKNe","totaliser-avatar-wrapper":"_2T7NA","target":"KDbqt","value":"msXxp","raised":"_24ROb"};

/***/ }),

/***/ "./src/components/Page/Progress.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_math__ = __webpack_require__("./src/helpers/math.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Totaliser_Totaliser__ = __webpack_require__("./src/components/Totaliser/Totaliser.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Progress_scss__ = __webpack_require__("./src/components/Page/Progress.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Progress_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Progress_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");








var Progress = function (_a) {
    var raised = _a.raised, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, totalCountSupporters = _a.totalCountSupporters, defaultMessage = _a.defaultMessage, shouldShowProfileImage = _a.shouldShowProfileImage, profileImage = _a.profileImage, ownerName = _a.ownerName;
    var percentage = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_math__["a" /* calculatePercentage */])(raised, targetAmount);
    var targetFloor = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_math__["b" /* floor */])(targetAmount, 0);
    var raisedFloor = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_math__["b" /* floor */])(raised, 0);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "progress" },
        shouldShowProfileImage && profileImage ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-center-block" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "totaliser-avatar-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Avatar__["b" /* OwnerAvatar */], { src: profileImage, alt: ownerName, size: "totaliser", template: "Size258w", className: "totaliser-avatar" })))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Totaliser_Totaliser__["a" /* default */], { percentage: percentage })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "target" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--brand-large", styleName: "raised" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_FormattedCurrency__["a" /* default */], { value: raisedFloor, currency: targetCurrency, minimumFractionDigits: 0, maximumFractionDigits: 0 })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "value", className: "jg-space-phlg@xl" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "Progress.raisedOf", defaultMessage: defaultMessage, values: {
                        target: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-color--primary" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_FormattedCurrency__["a" /* default */], { value: targetFloor, currency: targetCurrency, minimumFractionDigits: 0, maximumFractionDigits: 0 })))),
                        supporters: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "Progress.raisedOf.supporters", defaultMessage: "{supportersCount} {supportersCount, plural, one {supporter} other {supporters}}", values: {
                                    supportersCount: totalCountSupporters,
                                } }))),
                        ownerName: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, ownerName),
                    } })))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Progress, __WEBPACK_IMPORTED_MODULE_4__Progress_scss___default.a));


/***/ }),

/***/ "./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"_3Z47e","text":"oRFem"};

/***/ }),

/***/ "./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss__ = __webpack_require__("./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");




var RecurringPaymentsButtons = function (_a) {
    var name = _a.name, pageSection = _a.pageSection, donate = _a.donate;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss___default.a.text },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { "data-marker": "recurring-payments-buttons-donate-button", href: __WEBPACK_IMPORTED_MODULE_1_config___default.a.CROWDFUNDING_BASE_URI + "/" + name + "/donate?pageSection=" + pageSection + "&eventValue=single", className: __WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss___default.a.link },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "RecurringPaymentsButtons.donation", defaultMessage: "Make a donation" })),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "RecurringPaymentsButtons.divider", defaultMessage: "or" }),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { "data-marker": "recurring-payments-buttons-monthly-donate-button", href: __WEBPACK_IMPORTED_MODULE_1_config___default.a.CROWDFUNDING_BASE_URI + "/" + name + "/donate?pageSection=" + pageSection + "&paymentType=monthly&eventValue=monthly", className: __WEBPACK_IMPORTED_MODULE_2__RecurringPaymentsButtons_scss___default.a.link },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "RecurringPaymentsButtons.monthlyDonation", defaultMessage: "donate monthly" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (RecurringPaymentsButtons);


/***/ }),

/***/ "./src/components/Page/RecurringPaymentsButtons/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecurringPaymentsButtons__ = __webpack_require__("./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RecurringPaymentsButtons__["a"]; });



/***/ }),

/***/ "./src/components/Page/ReportPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ReportPage = /** @class */ (function (_super) {
    __extends(ReportPage, _super);
    function ReportPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCensure = function () {
            var addCensure = _this.props.addCensure;
            addCensure();
        };
        return _this;
    }
    ReportPage.prototype.render = function () {
        var className = this.props.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { target: "_blank", rel: "noreferrer noopener", onClick: this.handleCensure, href: "https://help.justgiving.com/hc/en-us/articles/202895531-JustGiving-Crowdfunding-Page-Guidelines", className: className }, "Report this Page"));
    };
    return ReportPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReportPage);


/***/ }),

/***/ "./src/components/PageOwner/PageOwnerNavbar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fixed":"_1MP7q","back-button":"_2kLVt","mobile-bar":"_5axfW"};

/***/ }),

/***/ "./src/components/PageOwner/PageOwnerNavbar.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageOwnerNavbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss__ = __webpack_require__("./src/components/PageOwner/PageOwnerNavbar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StickyHeader_Sticky__ = __webpack_require__("./src/components/StickyHeader/Sticky.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var CHROME_HEADER_OFFSET = 58;
var PageOwnerNavbar = /** @class */ (function (_super) {
    __extends(PageOwnerNavbar, _super);
    function PageOwnerNavbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageOwnerNavbar.prototype.render = function () {
        var _a = this.props, page = _a.page, pageSection = _a.pageSection, openSharePrompts = _a.openSharePrompts;
        var isMobile = !Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__["d" /* isDesktopViewport */])();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StickyHeader_Sticky__["a" /* default */], { offset: CHROME_HEADER_OFFSET, delay: 50 }, function (_a) {
            var sticky = _a.sticky;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: "jg-bdh jg-bdb jg-bd--solid jg-bd--solid jg-bd--very-light-grey jg-background--white jg-space-pvms\n            " + (sticky ? __WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss___default.a.fixed : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("menu", { className: "jg-page-owner-navbar container jg-space-phsm jg-jcb" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Analytics__["d" /* Link */], { className: "jg-btn jg-btn--ghost " + __WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss___default.a['back-button'], href: page.socialShareUrl + "/admin", analyticsOptions: {
                            event: 'click',
                            eventValue: 'back to dashboard',
                            pageSection: "admin > " + pageSection,
                            subtype: 'button',
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: isMobile
                                ? 'PageOwnerNavbar.backMobile'
                                : 'PageOwnerNavbar.back' }, isMobile ? 'Back' : 'Back to dashboard')),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-g1 jg-flex-jce " + __WEBPACK_IMPORTED_MODULE_2__PageOwnerNavbar_scss___default.a['mobile-bar'] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Analytics__["d" /* Link */], { className: "jg-btn jg-btn--ghost jg-space-mrms jg-hidden jg-show@lg", to: "/" + page.name + "/edit", analyticsOptions: {
                                event: 'click',
                                eventValue: 'edit page',
                                pageSection: "admin > " + pageSection,
                                subtype: 'button',
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: "PageOwnerNavbar.edit" }, "Edit page")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Analytics__["c" /* Button */], { className: "jg-btn", onClick: openSharePrompts, analyticsOptions: {
                                event: 'link click',
                                eventValue: 'share page',
                                pageSection: "admin > " + pageSection,
                                subtype: 'button',
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: isMobile
                                    ? 'PageOwnerNavbar.shareMobile'
                                    : 'PageOwnerNavbar.share' }, isMobile ? 'Share' : 'Share page'))))));
        }));
    };
    return PageOwnerNavbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ "./src/components/Prompt/ActivateYourPage/ActivateYourPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");





var ActivateYourPage = function (state, options) {
    var status = state.page.status;
    var actionKey = 'tip_publish';
    var completeActivation = function () {
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["a" /* activatePage */])());
    };
    var alreadyPublished = state.completedActions.keys.includes(actionKey);
    if ((status === 'Preview' || status === 'Approved') && !alreadyPublished) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-pvmd jg-space-phms@xs jg-space-phn@md row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center jg-background--white col-xs-12 col-md-4 offset-md-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1 jg-text--center jg-space-mbms" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ActivateYourPage.startReceivingDonations", defaultMessage: "Start receiving donations" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ActivateYourPage.changePageDuration", defaultMessage: "You can change your page duration at any time from {minPageLife} days up to one year from today.", values: { minPageLife: __WEBPACK_IMPORTED_MODULE_1_config___default.a.MIN_PAGE_LIFE } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { id: "crowdfunding-launch-button", loading: state.page.isActivating, value: "Activate your Page", onClick: completeActivation, analyticsOptions: {
                                event: 'link click',
                                subtype: 'button',
                                eventValue: 'launch page',
                                pageSection: 'page creation > preview and activate',
                            } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { target: "_blank", rel: "noreferrer noopener", href: "https://help.justgiving.com/hc/en-us/articles/204606811-Can-I-extend-my-Crowdfunding-page-" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ActivateYourPage.learnMoreLink", defaultMessage: "Learn more" })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (ActivateYourPage);


/***/ }),

/***/ "./src/components/Prompt/BankDetailsVerified/BankDetailsVerified.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BankDetailsVerifiedContent__ = __webpack_require__("./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");




var BankDetailsVerified = function (state, options) {
    var localStorageKey = 'prompt_bankDetailsVerified';
    var hasDismissedPrompt = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["j" /* isPropertyInLocalStorage */])("prompt:" + state.page.id + "_" + localStorageKey);
    var handleClose = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])()) {
            localStorage.setItem("prompt:" + state.page.id + "_" + localStorageKey, 'true');
        }
        options.closePrompt();
    };
    if (Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_page__["c" /* isActive */])({ status: state.page.status }) &&
        state.page.verificationStatus === 'Verified' &&
        !hasDismissedPrompt) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BankDetailsVerifiedContent__["a" /* default */], { onClose: handleClose }),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (BankDetailsVerified);


/***/ }),

/***/ "./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grey-cross":"OjSYq"};

/***/ }),

/***/ "./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_BankDetailsVerified_bankDetailsVerified_svg__ = __webpack_require__("./src/components/Prompt/BankDetailsVerified/bankDetailsVerified.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_BankDetailsVerified_bankDetailsVerified_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_BankDetailsVerified_bankDetailsVerified_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_BankDetailsVerified_BankDetailsVerifiedContent_scss__ = __webpack_require__("./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_BankDetailsVerified_BankDetailsVerifiedContent_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_BankDetailsVerified_BankDetailsVerifiedContent_scss__);





var BankDetailsVerifiedContent = function (_a) {
    var onClose = _a.onClose;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_BankDetailsVerified_BankDetailsVerifiedContent_scss___default.a['grey-cross'], onClick: onClose }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_BankDetailsVerified_bankDetailsVerified_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */], { i18nKey: "BankDetailsVerifiedContent.title" }, "Good news! Your payment details have been added")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */], { i18nKey: "BankDetailsVerifiedContent.subtitle" }, "You're all set to start receiving your funds.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["c" /* withI18n */])()(BankDetailsVerifiedContent));


/***/ }),

/***/ "./src/components/Prompt/BankDetailsVerified/bankDetailsVerified.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/AddBankDetailsImmediately/AddBankDetailsImmediately.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddBankDetailsImmediatelyContent__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/AddBankDetailsImmediately/AddBankDetailsImmediatelyContent.tsx");


var AddBankDetailsImmediately = function (state, options) {
    if (options) {
        var timeRemainingFrozen = options.timeRemainingFrozen;
        if (timeRemainingFrozen.daysRemaining === 0 &&
            !timeRemainingFrozen.hasCountdownFinished &&
            state.page.status !== 'Suspended') {
            return {
                matched: true,
                result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AddBankDetailsImmediatelyContent__["a" /* default */], { pageName: options.pageName, suspensionDate: options.frozenDate })),
            };
        }
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (AddBankDetailsImmediately);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/AddBankDetailsImmediately/AddBankDetailsImmediatelyContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/SuspensionCountdown.tsx");




var AddBankDetailsImmediatelyContent = function (_a) {
    var pageName = _a.pageName, suspensionDate = _a.suspensionDate;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6 offset-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__["a" /* default */], { suspensionDate: suspensionDate }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddBankDetailsImmediatelyContent.addBankImmediately", defaultMessage: "Please add your bank details immediately" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddBankDetailsImmediatelyContent.yourPageWillBeFrozen", defaultMessage: "If you don't add your bank details now, your Page will be frozen. This means that no one will be able to donate to it and we could end up refunding your existing donations." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/funds/account", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", analyticsOptions: {
                        event: 'link click',
                        eventValue: 'add my bank details now',
                        pageSection: 'admin > page view > prompt > add bank details immediately',
                        subtype: 'button',
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddBankDetailsImmediatelyContent.addBankDetailsButton", defaultMessage: "Add my bank details now" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (AddBankDetailsImmediatelyContent);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/AddYourBankDetails/AddYourBankDetails.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddYourBankDetailsContent__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/AddYourBankDetails/AddYourBankDetailsContent.tsx");


var AddYourBankDetails = function (state, options) {
    if (options &&
        options.timeRemainingFrozen.daysRemaining > 5 &&
        state.page.status !== 'Suspended') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AddYourBankDetailsContent__["a" /* default */], { pageName: options.pageName, suspensionDate: options.frozenDate })),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (AddYourBankDetails);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/AddYourBankDetails/AddYourBankDetailsContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/SuspensionCountdown.tsx");




var AddYourBankDetailsContent = function (_a) {
    var pageName = _a.pageName, suspensionDate = _a.suspensionDate;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6 offset-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__["a" /* default */], { suspensionDate: suspensionDate }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddYourBankDetailsContent.addBankDetails", defaultMessage: "You need to add your bank details" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddYourBankDetailsContent.addYourBankAccountPlease", defaultMessage: "Now your Page is up and running, it\u2019s time to let us know where you want the money you've raised to be sent. The timer above shows how long you've got left. To avoid your donations being refunded, add your bank details now." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/funds/account", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", analyticsOptions: {
                        event: 'link click',
                        eventValue: 'add my bank details now',
                        pageSection: 'admin > page view > prompt > add bank details',
                        subtype: 'button',
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "AddYourBankDetailsContent.addBankDetailsButton", defaultMessage: "Add my bank details now" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (AddYourBankDetailsContent);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/CountdownToRefunding.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days__ = __webpack_require__("./node_modules/date-fns/add_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_payment__ = __webpack_require__("./src/helpers/payment.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_countdownToRefundingEngine__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/countdownToRefundingEngine.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__("./node_modules/date-fns/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var CountdownToRefunding = function (state, options) {
    var _a = state.page, firstDonationDate = _a.firstDonationDate, activatedAt = _a.activatedAt;
    var appState = state;
    var accountConnected = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_payment__["a" /* isAccountConnected */])(state.page, state.paymentDetails);
    if (activatedAt &&
        firstDonationDate &&
        !accountConnected &&
        Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["isAfter"])(activatedAt, __WEBPACK_IMPORTED_MODULE_5_config__["ACQUISITION_DATE"])) {
        var frozenDate = __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(firstDonationDate, 30);
        var falseSuspensionDate = __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(firstDonationDate, 45);
        var refundDate = __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(firstDonationDate, 60);
        var timeRemainingFrozen = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_date__["e" /* countdown */])(frozenDate);
        var timeRemainingFalseSuspension = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_date__["e" /* countdown */])(falseSuspensionDate);
        var mergedOptions = __assign({ pageName: state.page.name, frozenDate: frozenDate,
            falseSuspensionDate: falseSuspensionDate,
            refundDate: refundDate,
            timeRemainingFrozen: timeRemainingFrozen,
            timeRemainingFalseSuspension: timeRemainingFalseSuspension }, options);
        try {
            var prompt = Object(__WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_countdownToRefundingEngine__["a" /* default */])(appState, mergedOptions);
            if (prompt) {
                return prompt;
            }
            return { matched: false };
        }
        catch (e) {
            return { matched: false };
        }
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (CountdownToRefunding);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/PageDeactivated/PageDeactivated.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageDeactivatedContent__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/PageDeactivated/PageDeactivatedContent.tsx");


var PageDeactivated = function (state, options) {
    if (options &&
        state.page.status === 'Suspended' &&
        options.timeRemainingFalseSuspension.hasCountdownFinished &&
        !state.page.refundedDate) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageDeactivatedContent__["a" /* default */], { pageName: options.pageName, refundDate: options.refundDate })),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageDeactivated);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/PageDeactivated/PageDeactivatedContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_deactivated_il_svg__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/svg/deactivated-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_deactivated_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_deactivated_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");





var PageDeactivatedContent = function (_a) {
    var pageName = _a.pageName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svg_deactivated_il_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageDeactivatedContent.pageDeactivated", defaultMessage: "Your Page has been deactivated" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageDeactivatedContent.noMoreDonations", defaultMessage: "As your bank details weren't added in time, your Page has been deactivated. Your donations will now be refunded unless you add your bank details immediately." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/funds/account", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", analyticsOptions: {
                        event: 'link click',
                        eventValue: 'last chance to add your bank details',
                        pageSection: 'admin > page view > prompt > page deactivated',
                        subtype: 'button',
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageDeactivatedContent.addBankDetailsButton", defaultMessage: "Last chance to add my bank details" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageDeactivatedContent);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/PageFrozen/PageFrozen.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageFrozenContent__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/PageFrozen/PageFrozenContent.tsx");


var PageFrozen = function (state, options) {
    if (options &&
        state.page.status === 'Suspended' &&
        !options.timeRemainingFalseSuspension.hasCountdownFinished) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageFrozenContent__["a" /* default */], { pageName: options.pageName, refundDate: options.refundDate })),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageFrozen);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/PageFrozen/PageFrozenContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_snowflake_svg__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/svg/snowflake.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_snowflake_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_snowflake_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Countdown_Countdown__ = __webpack_require__("./src/components/Countdown/Countdown.tsx");






var PageFrozenContent = function (_a) {
    var pageName = _a.pageName, refundDate = _a.refundDate;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svg_snowflake_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenContent.pageFrozen", defaultMessage: "Your Page has been frozen" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenContent.noMoreDonations", defaultMessage: "Your supporters can no longer donate to your Page. Add your bank details now to re-open your Page and continue to receive\u00A0donations." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Countdown_Countdown__["a" /* default */], { endDate: refundDate, tick: 60000 }, function (_a) {
                var daysRemaining = _a.daysRemaining, hoursRemaining = _a.hoursRemaining, minutesRemaining = _a.minutesRemaining;
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbml" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", { className: "jg-color--sunset-red jg-space-mbn" }, daysRemaining + "d " + hoursRemaining + "h " + minutesRemaining + "m"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-color--sunset-red" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozen.untilRefundingDonations", defaultMessage: "left before we refund your donations" })))));
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/funds/account", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", analyticsOptions: {
                        event: 'link click',
                        eventValue: 'add my bank details now',
                        pageSection: 'admin > page view > prompt > page frozen',
                        subtype: 'button',
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenContent.addBankDetailsButton", defaultMessage: "Add my bank details now" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageFrozenContent);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/SuspensionCountdown.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Countdown_Countdown__ = __webpack_require__("./src/components/Countdown/Countdown.tsx");


var SuspensionCountdown = function (_a) {
    var suspensionDate = _a.suspensionDate;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Countdown_Countdown__["a" /* default */], { endDate: suspensionDate, tick: 60000 }, function (_a) {
        var daysRemaining = _a.daysRemaining, hoursRemaining = _a.hoursRemaining, minutesRemaining = _a.minutesRemaining;
        var countdownColor = daysRemaining < 1
            ? 'jg-color--sunset-red'
            : daysRemaining <= 5
                ? 'jg-color--safety-orange'
                : 'jg-color--mountain-meadow';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: countdownColor + " jg-text--xlarge jg-space-mbmd" }, daysRemaining + "d " + hoursRemaining + "h " + minutesRemaining + "m")));
    }));
};
/* harmony default export */ __webpack_exports__["a"] = (SuspensionCountdown);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/TimeIsRunningOut/TimeIsRunningOut.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimeIsRunningOutContent__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/TimeIsRunningOut/TimeIsRunningOutContent.tsx");


var TimeIsRunningOut = function (state, options) {
    if (options &&
        options.timeRemainingFrozen.daysRemaining <= 5 &&
        options.timeRemainingFrozen.daysRemaining >= 1 &&
        state.page.status !== 'Suspended') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TimeIsRunningOutContent__["a" /* default */], { pageName: options.pageName, suspensionDate: options.frozenDate })),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (TimeIsRunningOut);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/TimeIsRunningOut/TimeIsRunningOutContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/SuspensionCountdown.tsx");




var TimeIsRunningOutContent = function (_a) {
    var suspensionDate = _a.suspensionDate, pageName = _a.pageName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6 offset-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SuspensionCountdown__["a" /* default */], { suspensionDate: suspensionDate }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "TimeIsRunningOutContent.timeRunningOut", defaultMessage: "Time is running out!" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "TimeIsRunningOutContent.addYourBankDetailsNow", defaultMessage: "We need to know where you want the money you've raised to be sent. To avoid your Page being frozen and your donations refunded, please add your bank details now." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/funds/account", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", analyticsOptions: {
                        event: 'link click',
                        eventValue: 'add my bank details now',
                        pageSection: 'admin > page view > prompt > time running out',
                        subtype: 'button',
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "TimeIsRunningOutContent.addBankDetailsButton", defaultMessage: "Add my bank details now" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (TimeIsRunningOutContent);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/countdownToRefundingEngine.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_rulesEngine__ = __webpack_require__("./src/helpers/rulesEngine.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__ = __webpack_require__("./src/components/Prompt/index.tsx");


var countdownToRefundingEngine = function (appState, _a) {
    var activatePromptTransition = _a.activatePromptTransition, closePrompt = _a.closePrompt, dispatch = _a.dispatch, pageName = _a.pageName, pageSection = _a.pageSection, promptTransitionActive = _a.promptTransitionActive, falseSuspensionDate = _a.falseSuspensionDate, frozenDate = _a.frozenDate, refundDate = _a.refundDate, timeRemainingFrozen = _a.timeRemainingFrozen, timeRemainingFalseSuspension = _a.timeRemainingFalseSuspension;
    try {
        var prompt = Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_rulesEngine__["b" /* rulesEngine */])([
            __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__["n" /* PageDeactivated */],
            __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__["o" /* PageFrozen */],
            __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__["b" /* AddBankDetailsImmediately */],
            __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__["w" /* TimeIsRunningOut */],
            __WEBPACK_IMPORTED_MODULE_1_src_components_Prompt__["c" /* AddYourBankDetails */],
        ], appState, {
            activatePromptTransition: activatePromptTransition,
            closePrompt: closePrompt,
            falseSuspensionDate: falseSuspensionDate,
            frozenDate: frozenDate,
            dispatch: dispatch,
            pageName: pageName,
            pageSection: pageSection,
            promptTransitionActive: promptTransitionActive,
            refundDate: refundDate,
            timeRemainingFrozen: timeRemainingFrozen,
            timeRemainingFalseSuspension: timeRemainingFalseSuspension,
        });
        if (prompt.matched && prompt.result) {
            return prompt;
        }
        return null;
    }
    catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (countdownToRefundingEngine);


/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/svg/deactivated-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 84 99\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"40\" cy=\"40\" r=\"40\"></circle><rect id=\"path-3\" x=\"5.76\" y=\"41.6\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-5\" x=\"5.76\" y=\"48\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-6\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-7\" x=\"13.44\" y=\"41.6\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-8\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-9\" x=\"13.44\" y=\"48\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-10\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-11\" x=\"21.12\" y=\"41.6\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-12\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-13\" x=\"21.12\" y=\"48\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-14\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-15\" x=\"28.8\" y=\"41.6\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-16\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-17\" x=\"28.8\" y=\"48\" width=\"6.56\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-7.6%\" y=\"-11.2%\" width=\"115.2%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-18\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-19\" x=\"5.76\" y=\"54.4\" width=\"29.6\" height=\"4.48\" rx=\"1\"></rect><filter x=\"-1.7%\" y=\"-11.2%\" width=\"103.4%\" height=\"144.6%\" filterUnits=\"objectBoundingBox\" id=\"filter-20\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix></filter><rect id=\"path-21\" x=\"0\" y=\"0\" width=\"42.88\" height=\"38.4\"></rect><ellipse id=\"path-23\" cx=\"3.92295365\" cy=\"3.71340659\" rx=\"3.92295365\" ry=\"3.71340659\"></ellipse><rect id=\"path-25\" x=\"0\" y=\"0\" width=\"7.46092365\" height=\"10.0149451\" rx=\"3.73046182\"></rect><circle id=\"path-27\" cx=\"62.2222222\" cy=\"75.5555556\" r=\"17.7777778\"></circle><filter x=\"-19.7%\" y=\"-14.1%\" width=\"139.4%\" height=\"139.4%\" filterUnits=\"objectBoundingBox\" id=\"filter-28\"><feOffset dx=\"0\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0.703096694 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix></filter></defs><g id=\"Website-journeys\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"PO_deactivatedpage\" transform=\"translate(-680.000000, -189.000000)\"><g id=\"Group\" transform=\"translate(0.000000, 139.000000)\"><g id=\"Deactivated\" transform=\"translate(680.000000, 50.000000)\"><g id=\"Group-42-Copy-2\"><g id=\"Group-5\"><g id=\"HAND-+-phoneALL-Mask\" transform=\"translate(0.000000, 8.960000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#98C6EC\" xlink:href=\"#path-1\"></use><g id=\"phoneALL\" mask=\"url(#mask-2)\"><g transform=\"translate(19.840000, -8.320000)\"><rect id=\"Rectangle-8\" fill=\"#4099FF\" fill-rule=\"evenodd\" x=\"0\" y=\"0\" width=\"40.96\" height=\"76.8\" rx=\"2\"></rect><rect id=\"Rectangle-8\" fill=\"#FFFFFF\" fill-rule=\"evenodd\" x=\"3.68\" y=\"4.48\" width=\"33.6\" height=\"57.6\" rx=\"1\"></rect><rect id=\"Rectangle-8\" fill=\"#EAEAEA\" fill-rule=\"evenodd\" x=\"3.68\" y=\"39.68\" width=\"33.6\" height=\"22.4\" rx=\"1\"></rect><g id=\"Rectangle-8\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-3\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-3\"></use></g><g id=\"Rectangle-8-Copy\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-6)\" xlink:href=\"#path-5\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-5\"></use></g><g id=\"Rectangle-8\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-8)\" xlink:href=\"#path-7\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-7\"></use></g><g id=\"Rectangle-8-Copy-2\" fill=\"none\" fill-opacity=\"1\"><use fill=\"black\" filter=\"url(#filter-10)\" xlink:href=\"#path-9\"></use></g><g id=\"Rectangle-8\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-12)\" xlink:href=\"#path-11\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-11\"></use></g><g id=\"Rectangle-8-Copy-3\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-14)\" xlink:href=\"#path-13\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-13\"></use></g><g id=\"Rectangle-8\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-16)\" xlink:href=\"#path-15\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-15\"></use></g><g id=\"Rectangle-8-Copy-4\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-18)\" xlink:href=\"#path-17\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-17\"></use></g><g id=\"Rectangle-8-Copy-4\" fill=\"none\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-20)\" xlink:href=\"#path-19\"></use><use fill=\"#CFCFD0\" fill-rule=\"evenodd\" xlink:href=\"#path-19\"></use></g></g></g><g id=\"HAND\" mask=\"url(#mask-2)\"><g transform=\"translate(25.600000, 41.600000)\" id=\"Group-10\"><g><path d=\"M6.95172414,3.99846154 L6.95172414,45.3738462 C6.95172414,47.5821355 8.74135006,49.3723077 10.9489655,49.3723077 C13.156581,49.3723077 14.9462069,47.5821355 14.9462069,45.3738462 L14.9462069,3.99846154 C14.9462069,1.79017221 13.156581,-1.23525122e-15 10.9489655,0 C8.74135006,1.23525122e-15 6.95172414,1.79017221 6.95172414,3.99846154 Z\" id=\"Line\" fill=\"#FBC595\" fill-rule=\"nonzero\"></path><path d=\"M9.02896552,5.83541748 C11.149739,5.83541748 12.8689655,4.96179095 12.8689655,3.27541748 C12.8689655,1.58904401 11.149739,0.715417481 9.02896552,0.715417481\" id=\"Oval-7\" fill=\"#FFFFFF\" opacity=\"0.650000036\" transform=\"translate(10.948966, 3.275417) rotate(-90.000000) translate(-10.948966, -3.275417) \"></path><path d=\"M15.6413793,21.3830769 L15.6413793,62.7584615 C15.6413793,64.9667509 17.4310052,66.7569231 19.6386207,66.7569231 C21.8462361,66.7569231 23.6358621,64.9667509 23.6358621,62.7584615 L23.6358621,21.3830769 C23.6358621,19.1747876 21.8462361,17.3846154 19.6386207,17.3846154 C17.4310052,17.3846154 15.6413793,19.1747876 15.6413793,21.3830769 Z\" id=\"Line\" fill=\"#FBC595\" fill-rule=\"nonzero\"></path><path d=\"M24.3310345,24.5123077 L24.3310345,65.8876923 C24.3310345,67.9999691 26.0428506,69.7123077 28.1544828,69.7123077 C30.2661149,69.7123077 31.977931,67.9999691 31.977931,65.8876923 L31.977931,24.5123077 C31.977931,22.4000309 30.2661149,20.6876923 28.1544828,20.6876923 C26.0428506,20.6876923 24.3310345,22.4000309 24.3310345,24.5123077 Z\" id=\"Line\" fill=\"#FBC595\" fill-rule=\"nonzero\"></path><path d=\"M33.0206897,27.2938462 L33.0206897,68.6692308 C33.0206897,70.6854949 34.6546959,72.32 36.6703448,72.32 C38.6859937,72.32 40.32,70.6854949 40.32,68.6692308 L40.32,27.2938462 C40.32,25.277582 38.6859937,23.6430769 36.6703448,23.6430769 C34.6546959,23.6430769 33.0206897,25.277582 33.0206897,27.2938462 Z\" id=\"Line\" fill=\"#FBC595\" fill-rule=\"nonzero\"></path><path d=\"M1.56694727e-11,25.0339341 C3.47193083,25.1315831 6.25655172,27.9835843 6.25655172,31.4658492 L6.25655172,47.1101767 C6.25655172,50.6022447 3.46513613,53.4445879 1.56694727e-11,53.5420905 L1.56692437e-11,25.0339341 Z\" id=\"Combined-Shape\" fill=\"#FBC595\"></path><polygon id=\"Rectangle-11\" fill=\"#FBC595\" points=\"11.817931 21.2092308 37.5393103 26.7723077 37.5393103 48.6769231 11.817931 48.6769231\"></polygon></g></g></g></g><g id=\"Group-7\" transform=\"translate(19.200000, 0.000000)\"><mask id=\"mask-22\" fill=\"white\"><use xlink:href=\"#path-21\"></use></mask><g id=\"Mask\"></g><g id=\"PHONE-TOP\" mask=\"url(#mask-22)\"><g transform=\"translate(0.640000, 0.640000)\" id=\"Rectangle-8\"><rect fill=\"#4099FF\" x=\"0\" y=\"0\" width=\"40.96\" height=\"76.8\" rx=\"2\"></rect><rect fill=\"#FFFFFF\" x=\"3.68\" y=\"4.48\" width=\"33.6\" height=\"57.6\" rx=\"1\"></rect></g></g></g></g><g id=\"AVATAR-Copy\" transform=\"translate(24.960000, 7.040000)\"><g id=\"Rectangle-16-Copy-2\" transform=\"translate(0.878303, 1.350330)\"><mask id=\"mask-24\" fill=\"white\"><use xlink:href=\"#path-23\"></use></mask><use id=\"Mask\" fill=\"#98C6EC\" xlink:href=\"#path-23\"></use><g id=\"BODY\" mask=\"url(#mask-24)\"><g transform=\"translate(0.202937, 3.327461)\"><mask id=\"mask-26\" fill=\"white\"><use xlink:href=\"#path-25\"></use></mask><use id=\"Mask\" stroke=\"none\" fill=\"#15CC5E\" fill-rule=\"evenodd\" xlink:href=\"#path-25\"></use><rect id=\"Rectangle-16-Copy-2\" stroke=\"none\" fill=\"#FBC595\" fill-rule=\"evenodd\" mask=\"url(#mask-26)\" x=\"2.61132328\" y=\"-0.703895254\" width=\"2.20097248\" height=\"1.75973813\" rx=\"0.879869067\"></rect></g></g></g><g id=\"AVATAR\" transform=\"translate(3.539927, 2.633741) scale(-1, 1) translate(-3.539927, -2.633741) translate(0.019927, 0.073741)\"><g id=\"GIRL-AVATAR\"><g id=\"HEAD\" transform=\"translate(0.002976, 0.052571)\"><path d=\"M4.12846337,3.34641305 C4.7296553,3.21003872 5.30260331,2.77371061 5.64629876,2.22925964 C5.98999421,1.68341352 6.27610141,0.702634439 5.67490948,0.293860226 C5.38843548,0.103075674 4.90095282,0.157485894 4.70067778,0.511849887 C4.41420377,1.02979332 4.7296553,1.54773676 4.70067778,2.09253652 C4.67243386,2.52886463 4.50040273,3.1008695 4.12846337,3.34641305\" id=\"Fill-57-Copy\" fill=\"#5C432D\" transform=\"translate(5.076397, 1.765984) scale(-1, 1) rotate(-2.000000) translate(-5.076397, -1.765984) \"></path><path d=\"M2.09371306,0.073925668 C2.11873075,0.0729612654 2.14307228,0.0703895254 2.16842804,0.0703895254 C2.17147073,0.0703895254 2.17451342,0.0707109929 2.17755612,0.0707109929 C2.18093688,0.0707109929 2.18397957,0.0703895254 2.18702227,0.0703895254 L2.18702227,0.0713539279 C3.04032816,0.0784262131 3.7719264,0.566092424 4.10019899,1.26303398 C4.21852588,1.51377864 4.28546509,1.79088363 4.28546509,2.08341907 C4.28546509,2.14996284 4.28174624,2.21586368 4.27498471,2.28080012 C4.1715332,3.2940657 3.27765809,4.08584018 2.18702227,4.0954842 L2.18702227,4.09612714 C2.18397957,4.09612714 2.18093688,4.09580567 2.17755612,4.09580567 C2.17451342,4.09580567 2.17147073,4.09612714 2.16842804,4.09612714 C2.14307228,4.09612714 2.11873075,4.09323393 2.09371306,4.092591 C0.960141486,4.0549793 0.0517290706,3.17126512 0.0517290706,2.08341907 C0.0517290706,0.995573016 0.960141486,0.111537367 2.09371306,0.073925668\" id=\"Fill-47\" fill=\"#FBC595\"></path><path d=\"M0.126338307,1.45624782 C0.368223913,0.652900511 1.17256227,0.0498274639 2.1122741,0 L2.19267358,0 C3.05164235,0 3.80203746,0.501810781 4.12500972,1.18010723 C4.20506561,1.35594995 4.25935244,1.55654568 4.28546509,1.73238841 C4.04426666,1.70763541 3.77558123,1.65716501 3.50758297,1.58226308 C2.56821472,1.30580102 1.84324508,0.82842177 1.57524683,0.35104252 C1.46839111,0.728445375 1.1193062,1.33087549 0.126338307,1.45624782\" id=\"Fill-51\" fill=\"#5C432D\" transform=\"translate(2.205902, 0.866194) scale(-1, 1) translate(-2.205902, -0.866194) \"></path></g><path d=\"M1.7329767,4.21993013 C2.22366188,4.21993013 2.62144082,3.82007556 2.62144082,3.32682995 C2.62144082,2.83358434 2.22366188,2.43372977 1.7329767,2.43372977\" id=\"MOUTH\" fill=\"#FFFFFF\" transform=\"translate(2.177209, 3.326830) rotate(-270.000000) translate(-2.177209, -3.326830) \"></path></g></g></g><g id=\"SPEECH-BUBBLE\" transform=\"translate(26.240000, 6.400000)\"><path d=\"M0.32,14.08 L26.56,14.08\" id=\"Line\" stroke=\"#CCCCCC\" stroke-width=\"2\" stroke-linecap=\"round\"></path><path d=\"M27.9771429,1.73714286 L27.9771429,0.822857143 C27.9771429,0.721867931 28.0590108,0.64 28.16,0.64 C28.2609892,0.64 28.3428571,0.721867931 28.3428571,0.822857143 L28.3428571,1.73714286 L29.2571429,1.73714286 C29.3581321,1.73714286 29.44,1.81901079 29.44,1.92 C29.44,2.02098921 29.3581321,2.10285714 29.2571429,2.10285714 L28.3428571,2.10285714 L28.3428571,3.01714286 C28.3428571,3.11813207 28.2609892,3.2 28.16,3.2 C28.0590108,3.2 27.9771429,3.11813207 27.9771429,3.01714286 L27.9771429,2.10285714 L27.0628571,2.10285714 C26.9618679,2.10285714 26.88,2.02098921 26.88,1.92 C26.88,1.81901079 26.9618679,1.73714286 27.0628571,1.73714286 L27.9771429,1.73714286 Z\" id=\"Combined-Shape\" fill=\"#CCCCCC\" fill-rule=\"nonzero\" transform=\"translate(28.160000, 1.920000) rotate(-45.000000) translate(-28.160000, -1.920000) \"></path><path d=\"M0.32,18.56 L26.56,18.56\" id=\"Line-Copy\" stroke=\"#CCCCCC\" stroke-width=\"2\" stroke-linecap=\"round\"></path><path d=\"M0.32,23.04 L19.52,23.04\" id=\"Line-Copy-2\" stroke=\"#CCCCCC\" stroke-width=\"2\" stroke-linecap=\"round\"></path></g></g><g id=\"Oval-2\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-28)\" xlink:href=\"#path-27\"></use><use fill=\"#FFFFFF\" fill-rule=\"evenodd\" xlink:href=\"#path-27\"></use></g><g id=\"•-Close\" transform=\"translate(53.333333, 67.555556)\" fill=\"#F7414B\" stroke=\"#F7414B\" stroke-width=\"0.5\"><path d=\"M18.45,0.15 C18.25,-0.05 17.85,-0.05 17.65,0.15 L9.95,7.95 L2.25,0.25 C2.05,0.05 1.65,0.05 1.45,0.25 L0.15,1.55 C-0.05,1.75 -0.05,2.15 0.15,2.35 L7.85,10.05 L0.15,17.75 C-0.05,17.95 -0.05,18.35 0.15,18.55 L1.45,19.85 C1.65,20.05 2.05,20.05 2.25,19.85 L9.95,12.15 L17.65,19.85 C17.85,20.05 18.25,20.05 18.45,19.85 L19.75,18.55 C19.95,18.35 19.95,17.95 19.75,17.75 L12.05,10.05 L19.75,2.35 C20.05,2.15 20.05,1.75 19.75,1.45 L18.45,0.15 Z\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/Prompt/CountdownToRefundingFlow/svg/snowflake.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/Prompt/DocumentsManualVerification/DocumentsManualVerification.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentsManualVerificationContent__ = __webpack_require__("./src/components/Prompt/DocumentsManualVerification/DocumentsManualVerificationContent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");



var DocumentsManualVerification = function (state) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_page__["c" /* isActive */])({ status: state.page.status }) &&
        state.page.verificationStatus === 'UnverifiedManual') {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DocumentsManualVerificationContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (DocumentsManualVerification);


/***/ }),

/***/ "./src/components/Prompt/DocumentsManualVerification/DocumentsManualVerificationContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_DocumentsManualVerification_clock_svg__ = __webpack_require__("./src/components/Prompt/DocumentsManualVerification/clock.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_DocumentsManualVerification_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_DocumentsManualVerification_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");




var DocumentsManualVerificationContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_DocumentsManualVerification_clock_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */], { i18nKey: "DocumentsManualVerificationContent.title" }, "We're currently checking your documents")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */], { i18nKey: "DocumentsManualVerificationContent.subtitle" }, "Our team is busy reviewing your documents and they'll get in touch with you soon. Make sure you check your emails regularly.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["c" /* withI18n */])()(DocumentsManualVerificationContent));


/***/ }),

/***/ "./src/components/Prompt/DocumentsManualVerification/clock.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/Prompt/DonationsRefunded/DonationsRefunded.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonationsRefundedContent__ = __webpack_require__("./src/components/Prompt/DonationsRefunded/DonationsRefundedContent.tsx");


var DonationsRefunded = function (state) {
    if (state.page.status === 'Suspended' && state.page.refundedDate) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DonationsRefundedContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (DonationsRefunded);


/***/ }),

/***/ "./src/components/Prompt/DonationsRefunded/DonationsRefundedContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_deactivated_il_svg__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/svg/deactivated-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_deactivated_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_deactivated_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");





var DonationsRefundedContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_deactivated_il_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedContent.pageDeactivated", defaultMessage: "Your Page has been deactivated" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedContent.noMoreDonations", defaultMessage: "Your bank details weren't added in time, so your page has now been deactivated. Your donations have been refunded." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { href: "https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=137829", target: "_blank", rel: "noreferrer noopener", analyticsOptions: {
                    event: 'link click',
                    eventValue: 'need help',
                    pageSection: 'admin > page view > prompt > donations refunded',
                    subtype: 'link',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedContent.needHelp", defaultMessage: "Need help? Contact our Customer Support Team" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DonationsRefundedContent);


/***/ }),

/***/ "./src/components/Prompt/DonationsRefundedSupporter/DonationsRefundedSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonationsRefundedSupporterContent__ = __webpack_require__("./src/components/Prompt/DonationsRefundedSupporter/DonationsRefundedSupporterContent.tsx");


var DonationsRefundedSupporter = function (state) {
    if (state.page.status === 'Suspended' && state.page.refundedDate) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DonationsRefundedSupporterContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (DonationsRefundedSupporter);


/***/ }),

/***/ "./src/components/Prompt/DonationsRefundedSupporter/DonationsRefundedSupporterContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CountdownToRefundingFlow_svg_deactivated_il_svg__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/svg/deactivated-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CountdownToRefundingFlow_svg_deactivated_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CountdownToRefundingFlow_svg_deactivated_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");





var DonationsRefundedSupporterContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__CountdownToRefundingFlow_svg_deactivated_il_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedSupporterContent.pageDeactivated", defaultMessage: "This Page has been deactivated" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedSupporterContent.pageClosed", defaultMessage: "Unfortunately this Page is now closed. Donations made to this Page will be refunded soon." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { href: "https://help.justgiving.com/hc/en-us/articles/360000300338", target: "_blank", rel: "noreferrer noopener", analyticsOptions: {
                    event: 'link click',
                    eventValue: 'learn more',
                    pageSection: 'admin > page view > supporter prompt > page deactivated',
                    subtype: 'button',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "DonationsRefundedSupporterContent.learnMoreLink", defaultMessage: "Learn more about this" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DonationsRefundedSupporterContent);


/***/ }),

/***/ "./src/components/Prompt/GiveFeedback/GiveFeedback.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"prompt":"_36LE8","people":"_1Qxvt","col-info":"_1-UDq","messages":"U77k5","col-feedback":"SZodW","col-btn-feedback":"_20NOM","btn-feedback":"_233yC","link-feedback":"_34yjX","grey-cross":"_2Gr7u","prompt-text":"_3IIi9"};

/***/ }),

/***/ "./src/components/Prompt/GiveFeedback/GiveFeedback.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_ShareWithFriendsPrompts_ThankYouForHelpingModal__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ThankYouForHelpingModal.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss__ = __webpack_require__("./src/components/Prompt/GiveFeedback/GiveFeedback.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss__);












var GiveFeedback = function (state, options) {
    var _a = state.page, id = _a.id, status = _a.status, name = _a.name, isFeedbackThankYouWindowOpen = _a.isFeedbackThankYouWindowOpen;
    var pageSection = 'page creation > give feedback';
    var localStorageKey = "prompt:" + id + "_giveFeedback:close";
    var dateFormat = 'YYYY-MM-DD HH:mm';
    var isInLocalStorage = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])() && Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["j" /* isPropertyInLocalStorage */])(localStorageKey);
    };
    var setInLocalStorage = function (value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])() && localStorage.setItem(localStorageKey, value);
    };
    var getFromLocalStorage = function () {
        return String(localStorage.getItem(localStorageKey));
    };
    var isPromptDismissed = function () {
        if (isInLocalStorage()) {
            var value = getFromLocalStorage();
            var dateValue = __WEBPACK_IMPORTED_MODULE_10_moment___default.a.utc(value, dateFormat);
            if (dateValue.isValid()) {
                return __WEBPACK_IMPORTED_MODULE_10_moment___default.a.utc().isBefore(dateValue);
            }
            return true;
        }
        return false;
    };
    var close = function () {
        setInLocalStorage('true');
        options.closePrompt();
    };
    var delay = function () {
        setInLocalStorage(__WEBPACK_IMPORTED_MODULE_10_moment___default.a
            .utc()
            .add(24, 'hours')
            .format(dateFormat)
            .toString());
        options.closePrompt();
    };
    var openContactOwnerModal = function () {
        var isFriend = true;
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["m" /* openContactOwner */])(state.page.name + "/feedback/contact", 'page view > send feedback', 'page creation > send feedback', isFriend, __WEBPACK_IMPORTED_MODULE_9_i18next__["a" /* default */].t('GiveFeedback.subject.placeholder', {
            defaultValue: '',
        }), __WEBPACK_IMPORTED_MODULE_9_i18next__["a" /* default */].t('GiveFeedback.message.placeholder', {
            defaultValue: 'Let them know what you think...',
        })));
    };
    var matched = function () {
        var routeMatched = state.routing
            .location.pathname.toLowerCase()
            .match(new RegExp("^/" + name.toLowerCase() + "/feedback[/|/contact|]*$"));
        return (status === 'Active' &&
            state.ab.growth_give_feedback_prompt === 'B' &&
            routeMatched &&
            !isPromptDismissed());
    };
    var donate = function (analytics) {
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_src_redux_modules_analytics__["a" /* analyticsClick */])(analytics));
    };
    var closeThankYouForHelpingModal = function () {
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["e" /* closeFeedbackThankYou */])());
    };
    if (matched()) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "prompt displayed", pageSection: "page view > give feedback", subtype: "cfp" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section", { className: __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a.prompt + " jg-bdb jg-bd--solid jg-bd--very-light-grey jg-text--center" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a.people + " row" },
                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-1 col-lg-3 col-xl-3" }),
                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-10 col-lg-7 col-xl-6 " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['col-info'] },
                                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "jg-background--white\n                                 jg-space-ptmd jg-space-ptml@md\n                                 jg-space-pbsm jg-space-pbml@md\n                                 jg-space-phsm jg-space-phml@md\n                                 jg-bd jg-bd--solid jg-bd--very-light-grey jg-bd--radius-3px" },
                                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_src_components_Analytics__["c" /* Button */], { className: __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['grey-cross'] + " jg-space-mrsm", onClick: close, analyticsOptions: {
                                            event: 'click',
                                            eventValue: 'x',
                                            pageSection: pageSection,
                                            subtype: 'button',
                                        } }),
                                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-column jg-flex-ais " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a.messages },
                                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", { className: "jg-h5" },
                                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "GiveFeedback.title" })),
                                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", { className: "jg-text--label " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['prompt-text'] },
                                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "GiveFeedback.text" }))),
                                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-row row" },
                                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-5 " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['col-btn-feedback'] },
                                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__["a" /* default */], { onClick: openContactOwnerModal, className: "jg-btn jg-space-mrms jg-text--large", inline: true, analyticsOptions: {
                                                    event: 'click',
                                                    subtype: 'button',
                                                    eventValue: 'give feedback',
                                                    pageSection: pageSection,
                                                } },
                                                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "GiveFeedback.button" }))),
                                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-3 " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['col-feedback'] },
                                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-text--large-regular " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['btn-feedback'], onClick: delay, analyticsOptions: {
                                                    event: 'click',
                                                    eventValue: 'skip',
                                                    pageSection: pageSection,
                                                    subtype: 'button',
                                                } },
                                                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "GiveFeedback.skip" })),
                                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link " + __WEBPACK_IMPORTED_MODULE_11__GiveFeedback_scss___default.a['link-feedback'], onClick: delay, analyticsOptions: {
                                                    event: 'click',
                                                    eventValue: 'skip',
                                                    pageSection: pageSection,
                                                    subtype: 'button',
                                                } },
                                                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* Trans */], { i18nKey: "GiveFeedback.skip" }))),
                                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-4" })))),
                            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "col-md-1 col-lg-2 col-xl-3" })))),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_ShareWithFriendsPrompts_ThankYouForHelpingModal__["a" /* default */], { pageName: state.page.name, donate: donate, canPageReceiveDonations: Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_page__["a" /* canPageReceiveDonations */])(state.page), isOpen: isFeedbackThankYouWindowOpen, onClose: closeThankYouForHelpingModal }))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (GiveFeedback);


/***/ }),

/***/ "./src/components/Prompt/PageClosedFullyFundedOwner/PageClosedFullyFundedOwner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss__ = __webpack_require__("./src/components/Prompt/PromptClosed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");







var PageClosedFullyFundedOwner = function (state) {
    var _a = state.page, amountRaised = _a.amountRaised, targetCurrency = _a.targetCurrency, finishedAt = _a.finishedAt, status = _a.status;
    var totalCount = state.supporters.totalCount;
    if (status === 'FullyFunded' || status === 'ReportGenerated') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default.a['container-funded'] + " jg-bdb jg-bd--solid jg-bd--very-light-grey" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1 jg-space-mbsm" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "PageClosedFullyFundedOwner.youDidIt", defaultMessage: "You did it!" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default.a.message },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "PageClosedFullyFundedOwner.youRaised", defaultMessage: "You raised {amountRaised} from {supporterCount}.", values: {
                            amountRaised: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_FormattedCurrency__["a" /* default */], { value: amountRaised, currency: targetCurrency || 'GBP', minimumFractionDigits: 0 }))),
                            supporterCount: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "PageClosedFullyFundedOwner.supporterCount", defaultMessage: "{totalCount} {totalCount, plural, one {supporter} other {supporters}}", values: { totalCount: totalCount }, tagName: "b" })),
                        } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "" + __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default.a.closed },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mbsm jg-space-mrxs " + __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default.a.timer, markup: __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default.a }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-text--small" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], { id: "PageClosedFullyFundedOwner.closedAt", defaultMessage: "Closed {date}", values: {
                                date: __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(finishedAt, 'DD/MM/YYYY'),
                            } }))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageClosedFullyFundedOwner);


/***/ }),

/***/ "./src/components/Prompt/PageClosedFullyFundedSupporter/GenericSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");









var GenericSupporter = function (props) {
    var page = props.page, totalCount = props.supporters.totalCount;
    var amountRaised = page.amountRaised, targetCurrency = page.targetCurrency, finishedAt = page.finishedAt, ownerName = page.ownerName;
    var fbButtonLocation = 'page > banner';
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "generic-supporter", className: __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default.a['container-funded'] + " jg-space-pmd jg-bdb jg-bd--solid jg-bd--very-light-grey row jg-text--center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-xl-6 offset-xl-3 jg-text--center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.weDidIt", defaultMessage: "We did it!" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.pageOwnerRaised", defaultMessage: "{ownerName} raised {amount} from {supporterCount}", values: {
                        ownerName: ownerName,
                        amount: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_FormattedCurrency__["a" /* default */], { value: amountRaised, currency: targetCurrency || 'GBP', minimumFractionDigits: 0 }))),
                        supporterCount: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.pageOwnerRaised.supporters", defaultMessage: "{totalCount} {totalCount, plural, one {supporter} other {supporters}}", values: {
                                totalCount: totalCount,
                            }, tagName: "b" })),
                    } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FacebookShare_FacebookShare__["a" /* default */], { location: fbButtonLocation, buttonText: "Inspire others with this story" }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--small " + __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default.a.breakline },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.or", defaultMessage: "or" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: __WEBPACK_IMPORTED_MODULE_7_config__["CROWDFUNDING_BASE_URI"] + "/create" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.startYourOwnPage", defaultMessage: "Start your own crowdfunding page" }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mbsm jg-space-mrxs " + __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default.a.timer, markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg___default.a }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-text--small" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "GenericSupporter.closedAt", defaultMessage: "Closed {date}", values: { date: __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(finishedAt, 'DD/MM/YYYY') } }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (GenericSupporter);


/***/ }),

/***/ "./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-funded":"_2I1b_","breakline":"_5Jqv9","timer":"_3IJ5e"};

/***/ }),

/***/ "./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericSupporter__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedSupporter/GenericSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecificSupporter__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedSupporter/SpecificSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");




var PageClosedFullyFundedSupporter = function (state) {
    var _a = state.page, amountRaised = _a.amountRaised, finishedAt = _a.finishedAt, targetCurrency = _a.targetCurrency, status = _a.status;
    var totalCount = state.supporters.totalCount;
    var supporterName =  true
        ? Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["b" /* getQueryFromUrl */])(window.location.href).supporterName
        : null;
    if (status === 'FullyFunded' || status === 'ReportGenerated') {
        if (supporterName) {
            return {
                matched: true,
                result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SpecificSupporter__["a" /* default */], { targetCurrency: targetCurrency, supporterName: supporterName, amountRaised: amountRaised, totalCountSupporters: totalCount, finishedAt: finishedAt })),
            };
        }
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GenericSupporter__["a" /* default */], { page: state.page, supporters: state.supporters })),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageClosedFullyFundedSupporter);


/***/ }),

/***/ "./src/components/Prompt/PageClosedFullyFundedSupporter/SpecificSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");








var SpecificSupporter = function (_a) {
    var supporterName = _a.supporterName, amountRaised = _a.amountRaised, targetCurrency = _a.targetCurrency, finishedAt = _a.finishedAt, totalCountSupporters = _a.totalCountSupporters;
    var otherSupportersCount = totalCountSupporters - 1;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "specific-supporter", className: __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default.a['container-funded'] + " jg-space-pmd jg-bdb jg-bd--solid jg-bd--very-light-grey row jg-text--center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6 offset-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.thankYou", defaultMessage: "Thank you, {supporterName}", values: { supporterName: supporterName } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.youHelpedRaise", defaultMessage: "Your donation helped raise {amount}{supporters}.", values: {
                        amount: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_FormattedCurrency__["a" /* default */], { value: amountRaised, currency: targetCurrency || 'GBP', minimumFractionDigits: 0 }))),
                        supporters: otherSupportersCount > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.youHelpedRaise.alongWith", defaultMessage: " along with {supporters}", values: {
                                supporters: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.youHelpedRaise.alongWith.others", defaultMessage: "{count} other {count, plural, one {supporter} other {supporters}}", values: {
                                        count: otherSupportersCount,
                                    }, tagName: "b" })),
                            } })) : null,
                    } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scroll__["Link"], { to: "updates" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { id: "button-read", className: "jg-btn jg-btn--brand", styleName: "action-link" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.seeMessage", defaultMessage: "See their message" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mbsm jg-space-mrxs " + __WEBPACK_IMPORTED_MODULE_3__PageClosedFullyFundedSupporter_scss___default.a.timer, markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_timer_svg___default.a }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-text--small" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], { id: "SpecificSupporter.closedAt", defaultMessage: "Closed {date}", values: { date: __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(finishedAt, 'DD/MM/YYYY') } }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SpecificSupporter);


/***/ }),

/***/ "./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReached.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"action-container":"_1odAi","breakline":"_3BE6b","timer":"_3g3ZM"};

/***/ }),

/***/ "./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReachedOwner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss__ = __webpack_require__("./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReached.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");






var PageClosedTargetNotReachedOwner = function (state) {
    var _a = state.page, finishedAt = _a.finishedAt, status = _a.status;
    if (status === 'TargetNotReached') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white-smoke jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-pmd row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center col-md-6 offset-md-3 col-xs-12" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1 jg-space-mbsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner.pageClosed", defaultMessage: "Page closed" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmn" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner.youDidNotHitTarget", defaultMessage: "Unfortunately you didn\u2019t hit your target." })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner.perhapsWeCouldHelp", defaultMessage: " If you'd like to try again perhaps we could help?" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss___default.a['action-container'] + " jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { id: "inspiration-link", target: "_blank", rel: "noreferrer noopener", href: "https://www.justgiving.com/discover" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner.getInspirationLink", defaultMessage: "Get inspiration from others" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss___default.a.breakline + " jg-space-mhms" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { id: "representative-link", target: "_blank", rel: "noreferrer noopener", href: "https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=137829" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner.speakToAdviser", defaultMessage: "Speak to a JustGiving adviser" })))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mbsm jg-space-mrxs " + __WEBPACK_IMPORTED_MODULE_3__PageClosedTargetNotReached_scss___default.a.timer, markup: __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default.a }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-text--small" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedOwner", defaultMessage: "Closed {date}", values: { date: __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(finishedAt, 'DD/MM/YYYY') } })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageClosedTargetNotReachedOwner);


/***/ }),

/***/ "./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReachedSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss__ = __webpack_require__("./src/components/Prompt/PromptClosed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");






var PageClosedTargetNotReachedSupporter = function (state) {
    var _a = state.page, finishedAt = _a.finishedAt, status = _a.status;
    if (status === 'TargetNotReached') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white-smoke jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-pmd row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center col-xs-12 col-md-6 offset-md-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1 jg-space-mbsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedSupporter.pageClosed", defaultMessage: "Page closed" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedSupporter.pageIsClosed", defaultMessage: "This page is now closed. Take a look at other inspiring pages on JustGiving" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { id: "discovery-link", target: "_blank", rel: "noreferrer noopener", href: "https://www.justgiving.com/discover", className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3 jg-text-dec--none jg-color--white" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedSupporter.discoverMoreLink", defaultMessage: "Browse more pages" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mbsm jg-space-mrxs " + __WEBPACK_IMPORTED_MODULE_2__PromptClosed_scss___default.a.timer, markup: __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_timer_svg___default.a }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-text--small" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageClosedTargetNotReachedSupporter.closedAt", defaultMessage: "Closed {date}", values: {
                                    date: __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(finishedAt, 'DD/MM/YYYY'),
                                } })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageClosedTargetNotReachedSupporter);


/***/ }),

/***/ "./src/components/Prompt/PageFrozenSupporter/PageFrozenSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageFrozenSupporterContent__ = __webpack_require__("./src/components/Prompt/PageFrozenSupporter/PageFrozenSupporterContent.tsx");


var PageFrozenSupporter = function (state) {
    if (state.page.status === 'Suspended' &&
        !state.page.isOwnerRequested &&
        !state.page.refundedDate) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageFrozenSupporterContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageFrozenSupporter);


/***/ }),

/***/ "./src/components/Prompt/PageFrozenSupporter/PageFrozenSupporterContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_snowflake_svg__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/svg/snowflake.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_snowflake_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_snowflake_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");





var PageFrozenSupporterContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3_src_components_Prompt_CountdownToRefundingFlow_svg_snowflake_svg___default.a, className: "jg-svg-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenSupporterContent.pageFrozen", defaultMessage: "This Page has been temporarily frozen" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenSupporterContent.weNeedMoreInfo", defaultMessage: "Looks like we still need a few details from the page owner before we can get this Page up and running again. If you've already donated, don't worry - your donation is safe. If you'd like to donate, please keep checking the Page for updates." })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { href: "https://help.justgiving.com/hc/en-us/articles/360000300338", target: "_blank", rel: "noreferrer noopener", analyticsOptions: {
                    event: 'link click',
                    eventValue: 'learn more',
                    pageSection: 'admin > page view > supporter prompt > page frozen',
                    subtype: 'button',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageFrozenSupporterContent.learnMoreLink", defaultMessage: "Learn more about this" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageFrozenSupporterContent);


/***/ }),

/***/ "./src/components/Prompt/PageLive/PageLive.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3OskZ","green-circle":"_2lq4d","tick-complete":"_1Xhky","tick-complete-animated":"_3oTrd","tick":"_1tFvH","grey-cross":"_3AMKX","complete":"_2xQbo"};

/***/ }),

/***/ "./src/components/Prompt/PageLive/PageLive.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss__ = __webpack_require__("./src/components/Prompt/PageLive/PageLive.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_completedActions__ = __webpack_require__("./src/redux/modules/completedActions.ts");







var PageLive = function (state, options) {
    var _a = state.page, name = _a.name, status = _a.status;
    var actionKey = 'prompt_pageLive';
    var hasUserClosedPrompt = state.completedActions.keys.includes(actionKey);
    var closePrompt = function () {
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_src_redux_modules_completedActions__["a" /* completeAction */])(state.page.id, actionKey));
        options.closePrompt();
    };
    var isShareWithFriendsFeatureDisabled = !state.ab.growth_share_with_friends_prompt ||
        state.ab.growth_share_with_friends_prompt === 'A';
    var showPrompt = status === 'Active' &&
        !hasUserClosedPrompt &&
        isShareWithFriendsFeatureDisabled;
    if (showPrompt) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "prompt displayed", pageSection: "admin > page creation > your page is ready", subtype: "admin" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "container-carousel jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd@xs" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "container", className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default.a.container + " jg-text--center jg-space-pvmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default.a['grey-cross'], onClick: closePrompt }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-6 offset-md-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default.a['green-circle'] },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", { width: "48px", height: "48px", viewBox: "0 0 48 48" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { className: "" + (Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["a" /* detectIE */])(Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["b" /* getUserAgent */])()) || Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["e" /* isEdgeUserAgent */])()
                                                ? __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default.a['tick-complete']
                                                : __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_PageLive_PageLive_scss___default.a['tick-complete-animated']), d: "M 5 30 L 17 40 L 43 10", strokeWidth: "8px", fill: "transparent", strokeLinecap: "butt" }))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h1 jg-text--center jg-space-mbms" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageLive.pageReady", defaultMessage: "Your Page is ready!" })),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageLive.sharePage", defaultMessage: "Invite friends and family to your Page and watch donations roll in" })),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mbmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--brand col-xs-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3", onClick: function () {
                                            return options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_src_redux_modules_sharePrompts__["c" /* openSharePrompts */])(options.pageSection));
                                        }, analyticsOptions: {
                                            event: 'click',
                                            subtype: 'button',
                                            eventValue: 'share page',
                                            pageSection: 'page creation > share your page',
                                        } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageLive.shareButton", defaultMessage: "Share your Page", tagName: "ladda-label" }))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: "/" + name + "/dashboard", className: "jg-text--link" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "PageLive.dashboardLink", defaultMessage: "Tips to improve your Page" })))))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageLive);


/***/ }),

/***/ "./src/components/Prompt/PageStranded/PageStranded.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageStrandedContent__ = __webpack_require__("./src/components/Prompt/PageStranded/PageStrandedContent.tsx");


var PageStranded = function (state) {
    if (state.page.status === 'Stranded' &&
        !state.page.isOwnerRequested &&
        !state.page.refundedDate) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageStrandedContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageStranded);


/***/ }),

/***/ "./src/components/Prompt/PageStranded/PageStrandedContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_PageStrandedPageOwner_svg_loudspeaker_svg__ = __webpack_require__("./src/components/Prompt/PageStrandedPageOwner/svg/loudspeaker.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_PageStrandedPageOwner_svg_loudspeaker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_PageStrandedPageOwner_svg_loudspeaker_svg__);



var PageStrandedContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_2_src_components_Prompt_PageStrandedPageOwner_svg_loudspeaker_svg___default.a, className: "jg-svg-sm", alt: "loudspeaker icon" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageStrandedSupporterContent.pageStranded", defaultMessage: "This page has now closed" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageStrandedSupporterContent.weNeedMoreInfo", defaultMessage: "We've closed this page and refunded the donations back to supporters. Where this isn't possible, we will always send the donations to a registered UK charity which is closely aligned with the goals of the page." })))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageStrandedContent);


/***/ }),

/***/ "./src/components/Prompt/PageStrandedPageOwner/PageStrandedPageOwner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageStrandedPageOwnerContent__ = __webpack_require__("./src/components/Prompt/PageStrandedPageOwner/PageStrandedPageOwnerContent.tsx");


var PageStrandedPageOwner = function (state) {
    if (state.page.status === 'Stranded' && state.page.isOwnerRequested) {
        return {
            matched: true,
            result: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageStrandedPageOwnerContent__["a" /* default */], null),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PageStrandedPageOwner);


/***/ }),

/***/ "./src/components/Prompt/PageStrandedPageOwner/PageStrandedPageOwnerContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_loudspeaker_svg__ = __webpack_require__("./src/components/Prompt/PageStrandedPageOwner/svg/loudspeaker.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_loudspeaker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_loudspeaker_svg__);



var PageStrandedPageOwnerContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-xs-12 col-md-8 offset-md-2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_2__svg_loudspeaker_svg___default.a, className: "jg-svg-sm", alt: "loudspeaker icon" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageStrandedPageOwnerContent.pageStranded", defaultMessage: "Your funds are no longer available" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbml" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "PageStrandedPageOwnerContent.details", defaultMessage: "We've tried to contact you several times about your page. Since we didn't hear from you, we're now closing this page and are unable to pay out your funds.\n\n            We'll be refunding the donations made to your page back to your supporters, or where that isn't possible, sending the donations to a registered UK charity which best aligns with the goals set out on your page." })))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageStrandedPageOwnerContent);


/***/ }),

/***/ "./src/components/Prompt/PageStrandedPageOwner/svg/loudspeaker.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "acc1f0f3f8780f2e855bfcadf9fe68cd.svg";

/***/ }),

/***/ "./src/components/Prompt/PromptClosed.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-funded":"PGZud","message":"_29WeX","action-container":"_1Llhd","action-link":"_30Gnh","discover":"_3eYhG","timer":"kWNY_","closed":"v0o7X"};

/***/ }),

/***/ "./src/components/Prompt/RecurringDonations/RecurringDonationsPrompt.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics___ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rocket_svg__ = __webpack_require__("./src/components/Prompt/RecurringDonations/rocket.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rocket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rocket_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_scroll__);






var RecurringDonationsPrompt = function (state, _a) {
    if (state.page.status === 'Active' &&
        state.settings.supportsRecurringDonations &&
        !state.page.recurringDonationsPitch) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: "jg-text--center jg-space-pvmd jg-position-relative col-xs-12 col-md-6 offset-md-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__rocket_svg___default.a, className: "jg-svg-sm" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-space-mbms" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPrompt.greatNews", defaultMessage: "Great news!" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd jg-space-phsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPrompt.encourageSupportersToDonate", defaultMessage: "You can now encourage your supporters to give a monthly donation. Help them understand why you need their ongoing support by adding a message below your story." })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scroll__["Link"], { to: "recurring-donations-awareness-banner", spy: true, smooth: true, offset: -150, duration: 500 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics___["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-width--300", analyticsOptions: {
                                event: 'click',
                                subtype: 'button',
                                eventValue: 'encourage donors now',
                                pageSection: 'page view > prompt > recurring donations',
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPrompt.okayGotIt", defaultMessage: "Encourage donors now" })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsPrompt);


/***/ }),

/***/ "./src/components/Prompt/RecurringDonations/rocket.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/Prompt/SayThanks/SayThanks.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics___ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__thankYou_il_svg__ = __webpack_require__("./src/components/Prompt/SayThanks/thankYou-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__thankYou_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__thankYou_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");






var SayThanks = function (state, options) {
    var _a = state.page, id = _a.id, status = _a.status;
    var localStorageKey = 'prompt_sayThanks';
    var isOnLocal = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__["j" /* isPropertyInLocalStorage */])("prompt:" + id + "_" + localStorageKey);
    var setLocalStorage = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__["g" /* isLocalStorageAvailable */])()) {
            localStorage.setItem("prompt:" + id + "_" + localStorageKey, 'true');
        }
    };
    var handleClose = function () {
        setLocalStorage();
        options.closePrompt();
    };
    if (status === 'Active' && !isOnLocal && state.supporters.totalCount > 0) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: "jg-text--center jg-space-pvmd jg-position-relative col-xs-12 col-md-6 offset-md-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__thankYou_il_svg___default.a, className: "jg-svg-sm" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-space-mbms" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "SayThanks.greatNews", defaultMessage: "Great news!" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd jg-space-phsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "SayThanks.youCanSayThanks", defaultMessage: "You can now thank your donors by sending them a message. Hit the 'Say thanks' button below their donation to get started." })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics___["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-width--300", onClick: handleClose, analyticsOptions: {
                            event: 'click',
                            subtype: 'button',
                            eventValue: 'okay got it',
                            pageSection: 'page view > headline message > thank supporter',
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "SayThanks.okayGotIt", defaultMessage: "Okay, got it" }))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (SayThanks);


/***/ }),

/***/ "./src/components/Prompt/SayThanks/thankYou-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 80 88\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"40\" cy=\"40\" r=\"40\"></circle><filter x=\"-3.5%\" y=\"-5.2%\" width=\"107.0%\" height=\"110.3%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\"><feOffset dx=\"0\" dy=\"0\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"0.5\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.766315901 0 0 0 0 0.766315901 0 0 0 0 0.766315901 0 0 0 0.7 0\" type=\"matrix\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"></feColorMatrix><feMerge><feMergeNode in=\"shadowMatrixOuter1\"></feMergeNode><feMergeNode in=\"SourceGraphic\"></feMergeNode></feMerge></filter><path d=\"M8.44990667,2.53667741 C7.67988222,1.07881075 6.20756889,0.0849197368 4.50212889,0.0849197368 C2.01212,0.0849197368 0.00374,2.19219247 0.00374,4.80380395 C0.00374,6.11660329 0.471655556,7.1904212 1.33808889,8.1575367 L8.44990667,14.9317412 L15.2450711,8.44966952 C16.2906089,7.3490761 16.8960733,6.27525819 16.8960733,4.80380395 C16.9097867,2.20578004 14.8876933,0.0849197368 12.3976844,0.0849197368 C10.6918289,0.0849197368 9.22034667,1.07881075 8.44990667,2.53667741 Z\" id=\"path-4\"></path></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Group-2-Copy-4\"><g id=\"Group-3\" transform=\"translate(0.000000, 8.000000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#BCE1FF\" xlink:href=\"#path-1\"></use><g id=\"Group-21\" mask=\"url(#mask-2)\"><g transform=\"translate(41.140000, 59.860000) scale(-1, 1) translate(-41.140000, -59.860000) translate(17.640000, 31.360000)\"><path d=\"M4.98530957,28.7715472 C3.91010075,30.3616575 1.97626798,32.179364 0,32.3794035 C2.8492207,32.9805428 5.84062688,32.532495 8.34099716,31.1301769 C10.0439163,30.2014218 12.0786016,28.4577096 12.8,26.6267352 C11.6906226,25.3555655 10.8049944,23.9307939 10.1734263,22.4039613 C9.57657797,22.373343 8.98468957,22.5208212 8.48538707,22.8254732 C6.23356583,24.2145235 6.32008955,26.7808473 4.98530957,28.7715472 Z\" id=\"Fill-755\" fill=\"#5C432D\"></path><path d=\"M38.8212009,32.4460806 C41.0900841,34.1088082 43.9217993,34.8332221 46.72,34.4670638 C44.8325445,34.0877343 43.1536241,32.0456772 42.2689458,30.3281576 C41.28,28.3345704 41.4614043,25.9616537 39.9287776,24.32 C38.9206806,26.2514193 37.5300919,27.9615631 35.84,29.3487499 C36.6358381,30.5536479 37.646063,31.6057604 38.8212009,32.4529296\" id=\"Fill-767\" fill=\"#5C432D\"></path><path d=\"M40.3996976,23.5507648 C40.4012325,23.5524434 40.4027662,23.5541232 40.4042987,23.5558041 L40.4184219,23.5558041 C39.3896014,25.5486471 37.9696771,27.3136589 36.2439314,28.7458959 C35.2406413,27.1652153 34.7642551,25.3925909 35.6817196,23.8760728 C35.712682,23.8282228 35.7458171,23.7814603 35.7794955,23.7357853 C36.3939324,22.9084494 37.3545098,22.4912413 38.3111188,22.5354256 C37.2928102,22.4862676 36.2753284,22.9618635 35.674495,23.8761271 C34.7570305,25.3926453 35.23396,27.1652696 36.2361636,28.7459503 C34.6152554,30.0966247 32.7515369,31.1259431 30.7460432,31.7784428 L30.7313768,31.7784428 L26.0385345,20.8499114 L30.7460432,31.8139497 C29.0588646,32.367487 27.2940084,32.6458869 25.5182883,32.6399056 L25.3694515,32.6399056 L25.6146542,14.637995 L25.3691799,32.6114131 C25.1703688,32.5760694 24.9851377,32.5760694 24.7857833,32.5760694 C15.8419986,32.1323696 8.85101707,24.6873475 8.96128663,15.7241759 C8.96834823,15.1559574 9.00365622,14.5877389 9.0677538,14.0227828 C9.18671455,12.9961832 9.40127848,11.9837211 9.70764317,10.9968152 C10.9901379,10.8304278 12.2481887,10.5123342 13.4557218,10.0501469 C17.1934797,8.77233485 20.059945,5.72951103 21.1159255,1.92 C22.2533311,3.96711948 23.8230823,5.74075913 25.7170977,7.11696189 C30.4744433,10.6435954 36.0547349,12.8909133 41.9261816,13.645638 L41.8832688,13.6592317 L41.8832688,13.5814755 L42.0397103,13.5814755 C42.0750183,13.6809817 42.0750183,13.7881004 42.0750183,13.8870629 L36.895132,16.1361073 L42.1038079,13.8945123 C42.2021271,14.6546745 42.2472126,15.4208179 42.2390646,16.1869614 C42.232003,16.7350612 42.1890903,17.2837047 42.1325975,17.8171232 C41.9079259,19.8178555 41.3210845,21.7610594 40.3996976,23.5507648 Z M38.3111188,22.5354256 C38.318501,22.535782 38.3258831,22.5361659 38.3332652,22.5365775 Z\" id=\"Combined-Shape\" fill=\"#CDA278\"></path><path d=\"M32.64,39.4594525 L32.64,38.9668277 L32.5897973,38.8586151 L32.3611569,38.7911111 C31.9131528,38.6653784 31.455872,38.5484058 30.9893146,38.4401932 L30.8250646,38.4 L30.8250646,38.5350081 L30.8250646,38.7174235 C30.6679084,40.8018035 27.8309123,42.4615781 24.3451013,42.4615781 C20.858199,42.4615781 18.0217485,40.8018035 17.8645924,38.7174235 L17.8645924,38.5350081 L17.8645924,38.4 L17.635952,38.467504 C17.1595724,38.5752013 16.70502,38.6926892 16.2712035,38.8184219 L16,38.8993237 L16,47.36 L32.64,47.36 L32.64,39.4594525 Z\" id=\"Fill-829\" fill=\"#FFFFFF\"></path><path d=\"M9.20600808,51.9802972 C10.1443876,52.3970699 11.1023634,52.7766213 12.0799354,53.12 L12.16,52.9071576 L12.16,39.68 L11.9405222,39.7900909 L11.7059273,39.920103 L11.3464764,40.1266544 C11.104603,40.2634817 10.8554509,40.4008332 10.6135774,40.551815 L10.3493082,40.7169513 C9.98313863,40.954433 9.62872678,41.1997784 9.28663257,41.4508905 L9.15449798,41.5473511 C8.40032301,42.1187752 7.69429879,42.745769 7.0437039,43.4209931 L6.82366622,43.6610961 C6.58907133,43.9174506 6.36175505,44.177999 6.14171736,44.4437898 L5.90712248,44.7389383 C5.70948048,44.9926715 5.5185572,45.2605593 5.34275101,45.521632 L5.19605922,45.727135 C4.99113863,46.1386652 4.50011306,47.3334134 3.84,49.0083676 C5.1899004,49.8885704 6.60082907,50.683846 8.06270794,51.3900004 C8.44399462,51.5755822 8.795607,51.7606397 9.22056528,51.9320669\" id=\"Fill-831\" fill=\"#FFFFFF\"></path><path d=\"M30.72,38.2789036 L30.6286827,38.2789036 L30.5792639,38.2789036 C30.1994914,38.2011671 29.8132729,38.1293722 29.418997,38.0645093 L29.2503286,38.0645093 L29.1799606,38.0645093 L29.138062,38.0645093 L28.9618733,38.0645093 L27.9068899,37.9288417 L27.6538873,37.8966578 L27.5974854,37.8966578 C27.1897805,37.8570469 26.7745554,37.824863 26.3523471,37.7986207 L26.1906618,37.7986207 L26.0010441,37.7986207 C25.4730152,37.7986207 24.9320945,37.76 24.3831164,37.76 C23.8771111,37.76 23.3775517,37.76 22.8855126,37.7986207 L22.6738713,37.7986207 L22.4348349,37.7986207 L22.301619,37.7986207 C21.8869311,37.7986207 21.478689,37.8511052 21.0779672,37.8966578 L20.9866499,37.8966578 L20.7191439,37.9288417 L20.107318,38.0060831 L19.5164413,38.0838196 L19.4530564,38.0838196 L19.3826883,38.0838196 L19.2064996,38.1164987 C18.8057778,38.1813616 18.4120391,38.2526614 18.0322666,38.3368347 L17.92,38.3368347 L17.92,38.4665606 L17.92,38.6413439 C18.0816853,40.6446684 20.8738462,42.24 24.2993193,42.24 C27.7242553,42.24 30.5233992,40.6387268 30.6781015,38.6413439 L30.6781015,38.4665606 L30.6781015,38.3368347 L30.72,38.2789036 Z\" id=\"Fill-835\" fill=\"#CDA278\"></path><path d=\"M16.3234604,39.0028799 C14.7482506,39.7719949 13.3369544,40.8343384 12.1671576,42.1324571 L12.1671576,40.138937 C13.0206011,39.6673866 13.9051882,39.2522054 14.813816,38.8971876 L14.8717322,38.8971876 C15.343257,38.6841769 15.8229775,38.5562621 16.3234604,38.4001626 L16.3234604,39.0028799 Z M37.0986912,40.1528667 L37.12,53.7497792 L37.12,54.2327119 C36.6976493,54.3817652 36.2829478,54.5237723 35.8540405,54.6581913 C28.723252,56.8739362 21.0794139,56.8739362 13.9486253,54.6581913 C13.3574436,54.4739072 12.7706328,54.2749888 12.1887395,54.0625201 L12.1887395,53.8072325 L13.776516,49.4494562 C13.776516,49.4494562 13.1186761,48.9741117 12.1816366,48.3708523 L12.1816366,42.1469288 C13.3514334,40.8488101 14.7627296,39.7859246 16.3379394,39.0173516 L16.3379394,47.2992947 L32.9636972,47.2992947 L32.9636972,39.0173516 L32.9636972,38.9327978 L32.9636972,38.4997302 L32.9636972,38.4 C33.4171915,38.5420071 33.8624901,38.6959385 34.3012322,38.8617942 L34.4875474,38.9327978 C35.3836085,39.2818535 36.2556289,39.6899885 37.0986912,40.1528667 Z M12.16,48.3706355 C13.1046888,48.9738949 13.7554258,49.4492394 13.7554258,49.4492394 L12.1671029,53.8070157 L12.16,53.8070157 L12.16,48.3706355 Z\" id=\"Combined-Shape\" fill=\"#3B72B7\"></path><path d=\"M13.3222263,10.5916192 L13.3360267,10.5707537 C12.1282213,10.9896676 10.8740469,11.2742936 9.6,11.4182117 C9.84840603,10.6092745 10.1647097,9.8228079 10.546703,9.06469685 L10.546703,9.02243096 C10.6769781,8.77044062 10.8216056,8.51791528 10.9656811,8.27288009 C13.9101206,3.2646391 19.3524206,0.123587616 25.2981569,0 L25.8910193,0 L25.7822727,7.70523308 C23.857954,6.35165443 22.2620832,4.60591248 21.1067192,2.59212986 C19.9491471,6.29387321 17.0676372,9.25516088 13.3222263,10.5916192 Z M26.042823,0.000107002265 C32.6073663,0.153655252 38.4857569,3.97791619 41.1194128,9.80686456 C41.6675621,11.1829137 42.0434832,12.617279 42.24,14.08 C40.178782,13.8381749 38.1429566,13.4256812 36.1540523,12.8473339 C32.4263059,11.7029447 28.9215728,9.96522791 25.7822727,7.70534008 L25.8915713,0.000107002265 L26.042823,0.000107002265 Z\" id=\"Combined-Shape\" fill=\"#5C432D\"></path><path d=\"M8.32,26.88 C8.09819847,27.0316553 7.88470229,27.1879667 7.68,27.3502646 C7.88519084,27.1853061 8.10259542,27.0369766 8.32,26.88\" id=\"Fill-969\" fill=\"#6D5644\"></path><path d=\"M7.34505567,27.52 L7.04,27.7208768 L7.34505567,27.52 Z\" id=\"Fill-971\" fill=\"#6D5644\"></path><path d=\"M5.30210295,30.08 L5.12,30.2542706 L5.30210295,30.08 Z\" id=\"Fill-999\" fill=\"#6D5644\"></path><path d=\"M6.04777582,28.8 L5.76,29.0261527 L6.04777582,28.8 Z\" id=\"Fill-1001\" fill=\"#6D5644\"></path><path d=\"M44.3007337,47.6424473 L43.4394709,45.848991 C43.2639587,45.5504214 43.067798,45.2589089 42.8716374,44.9749963 L42.6620552,44.6693696 C42.4369866,44.3615715 42.2114018,44.0575734 41.9863333,43.7590037 L41.8784449,43.624376 C41.6482142,43.3540348 41.3983675,43.0912935 41.1485207,42.8285523 L40.9250008,42.5864394 L40.8909308,42.5864394 C40.5806872,42.2813556 40.2559897,41.982786 39.9183868,41.6912735 L39.6948669,41.5061603 C39.4068205,41.2645904 39.1069011,41.0279061 38.7961413,40.7955646 L38.5462946,40.6175086 C38.2076593,40.3808243 37.8607646,40.1435972 37.5050944,39.9074558 L37.3564252,39.8146278 L37.12,39.68 L37.12,53.76 L37.2753799,53.7030003 L37.5727182,53.5819439 C39.7624907,51.2091298 42.6137519,50.4348874 44.3812628,47.6989041 L44.3007337,47.6424473 Z\" id=\"Fill-1063\" fill=\"#FFFFFF\"></path></g></g></g><g id=\"Group-Copy-2\" transform=\"translate(20.000000, 6.000000)\" fill=\"#999999\"><g id=\"Group-9\"><path d=\"M3.41011956,0.275289763 C2.0966752,0.275289763 0.200251995,0.90949071 0.200251995,2.20318018 L0.200251995,2.33507789 L0.200251995,11.0409011 L0.200251995,13.2351732 L0.200251995,15.1989835 L0.200251995,24.1096936 C0.200251995,25.403383 2.0966752,26.1950566 3.41011956,26.1950566 L18.9988136,26.4620029 L21.5763848,28.9743525 L24.1232356,26.4620029 L40.8368966,26.1950566 C42.1500506,26.1950566 42.9525175,25.403383 42.9525175,24.1096936 L42.9525175,2.33507789 C42.9525175,1.04110106 42.1500506,0.275289763 40.8368966,0.275289763 L3.41011956,0.275289763 Z\" id=\"Clip-8\"></path></g></g><g id=\"Group\" filter=\"url(#filter-3)\" transform=\"translate(19.000000, 5.000000)\"><g id=\"Group-9\" fill=\"#FFFFFF\"><path d=\"M3.41011956,0.275289763 C2.0966752,0.275289763 0.200251995,0.90949071 0.200251995,2.20318018 L0.200251995,2.33507789 L0.200251995,11.0409011 L0.200251995,13.2351732 L0.200251995,15.1989835 L0.200251995,24.1096936 C0.200251995,25.403383 2.0966752,26.1950566 3.41011956,26.1950566 L18.9988136,26.4620029 L21.5763848,28.9743525 L24.1232356,26.4620029 L40.8368966,26.1950566 C42.1500506,26.1950566 42.9525175,25.403383 42.9525175,24.1096936 L42.9525175,2.33507789 C42.9525175,1.04110106 42.1500506,0.275289763 40.8368966,0.275289763 L3.41011956,0.275289763 Z\" id=\"Clip-8\"></path></g><polygon id=\"Fill-11\" fill=\"#CCCCCC\" points=\"4.49253731 15.8258652 38.4989759 15.8258652 38.4989759 14.1777778 4.49253731 14.1777778\"></polygon><polygon id=\"Fill-12\" fill=\"#CCCCCC\" points=\"4.49253731 21.6258652 38.4989759 21.6258652 38.4989759 19.9777778 4.49253731 19.9777778\"></polygon></g><g id=\"Group-6\" transform=\"translate(32.000000, 0.000000)\"><g id=\"Group-37\"><mask id=\"mask-5\" fill=\"white\"><use xlink:href=\"#path-4\"></use></mask><g id=\"Clip-36\"></g><polygon id=\"Fill-35\" fill=\"#FF9EF6\" mask=\"url(#mask-5)\" points=\"-1.40956444 16.2912977 18.3093778 16.2912977 18.3093778 -1.27463684 -1.40956444 -1.27463684\"></polygon></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/Prompt/ShareWithFriends/ShareWithFriends.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"prompt":"_1gR_a","people":"VoH_f","col-info":"_1hf7x","messages":"_3Hc1d","col-share":"_1VbtW","col-btn-share":"_254wB","btn-share":"_1R9cq","link-share":"_9__xz","grey-cross":"_1Txiw","prompt-text":"_25QsR"};

/***/ }),

/***/ "./src/components/Prompt/ShareWithFriends/ShareWithFriends.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareWithFriendsButton__ = __webpack_require__("./src/components/Prompt/ShareWithFriends/ShareWithFriendsButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_shareWithFriendsPrompts__ = __webpack_require__("./src/redux/modules/shareWithFriendsPrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss__ = __webpack_require__("./src/components/Prompt/ShareWithFriends/ShareWithFriends.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");









var ShareWithFriends = function (state, options) {
    var _a = state.page, id = _a.id, status = _a.status;
    var pageSection = 'admin > page creation > share your page with friends';
    var localStorageKey = "prompt:" + id + "_shareWithFriends:close";
    var dateFormat = 'YYYY-MM-DD HH:mm';
    var isInLocalStorage = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])() && Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["j" /* isPropertyInLocalStorage */])(localStorageKey);
    };
    var setInLocalStorage = function (value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_browser__["g" /* isLocalStorageAvailable */])() && localStorage.setItem(localStorageKey, value);
    };
    var getFromLocalStorage = function () {
        return String(localStorage.getItem(localStorageKey));
    };
    var isPromptDismissed = function () {
        if (isInLocalStorage()) {
            var value = getFromLocalStorage();
            var dateValue = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(value, dateFormat);
            if (dateValue.isValid()) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc().isBefore(dateValue);
            }
            return true;
        }
        return false;
    };
    var close = function () {
        setInLocalStorage('true');
        options.closePrompt();
    };
    var delay = function () {
        setInLocalStorage(__WEBPACK_IMPORTED_MODULE_7_moment___default.a
            .utc()
            .add(24, 'hours')
            .format(dateFormat)
            .toString());
        options.closePrompt();
    };
    var openPrompt = function () {
        options.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_shareWithFriendsPrompts__["c" /* openShareWithFriendsPrompts */])(pageSection));
    };
    if (status === 'Active' &&
        state.ab.growth_share_with_friends_prompt === 'B' &&
        !isPromptDismissed()) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "prompt displayed", pageSection: pageSection, subtype: "admin" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a.prompt + " jg-bdb jg-bd--solid jg-bd--very-light-grey jg-text--center" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a.people + " row" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-1 col-lg-3 col-xl-3" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-10 col-lg-7 col-xl-6 " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['col-info'] },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white\n                                 jg-space-ptmd jg-space-ptml@md\n                                 jg-space-pbmd jg-space-pbml@md\n                                 jg-space-plml jg-space-prml\n                                 jg-bd jg-bd--solid jg-bd--very-light-grey jg-bd--radius-3px" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["c" /* Button */], { className: __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['grey-cross'] + " jg-space-mrsm", onClick: close, analyticsOptions: {
                                            event: 'click',
                                            eventValue: 'x',
                                            pageSection: pageSection,
                                            subtype: 'button',
                                        } }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-column jg-flex-ais " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a.messages },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-h5" },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriends.title" })),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--label " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['prompt-text'] },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriends.text" }))),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-row row" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-5 " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['col-btn-share'] },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ShareWithFriendsButton__["a" /* default */], { pageSection: pageSection, openShareWithFriendsPrompt: openPrompt })),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-3 " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['col-share'] },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-text--large-regular " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['btn-share'], onClick: delay, analyticsOptions: {
                                                    event: 'click',
                                                    eventValue: 'later',
                                                    pageSection: pageSection,
                                                    subtype: 'button',
                                                } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriends.later" })),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link " + __WEBPACK_IMPORTED_MODULE_4_src_components_Prompt_ShareWithFriends_ShareWithFriends_scss___default.a['link-share'], onClick: delay, analyticsOptions: {
                                                    event: 'click',
                                                    eventValue: 'later',
                                                    pageSection: pageSection,
                                                    subtype: 'button',
                                                } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriends.laterLink" }))),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-4" })))),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-1 col-lg-2 col-xl-3" })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (ShareWithFriends);


/***/ }),

/***/ "./src/components/Prompt/ShareWithFriends/ShareWithFriendsButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");



var ShareWithFriendsButton = function (_a) {
    var pageSection = _a.pageSection, openShareWithFriendsPrompt = _a.openShareWithFriendsPrompt;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_ClickableElement__["a" /* default */], { onClick: openShareWithFriendsPrompt, className: "jg-btn jg-space-mrms jg-text--large", inline: true, analyticsOptions: {
            event: 'click',
            subtype: 'button',
            eventValue: 'share with friends',
            pageSection: "" + pageSection,
        } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsButton.text" }, "Share with friends")));
};
/* harmony default export */ __webpack_exports__["a"] = (ShareWithFriendsButton);


/***/ }),

/***/ "./src/components/Prompt/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageLive_PageLive__ = __webpack_require__("./src/components/Prompt/PageLive/PageLive.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareWithFriends_ShareWithFriends__ = __webpack_require__("./src/components/Prompt/ShareWithFriends/ShareWithFriends.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GiveFeedback_GiveFeedback__ = __webpack_require__("./src/components/Prompt/GiveFeedback/GiveFeedback.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActivateYourPage_ActivateYourPage__ = __webpack_require__("./src/components/Prompt/ActivateYourPage/ActivateYourPage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageClosedFullyFundedOwner_PageClosedFullyFundedOwner__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedOwner/PageClosedFullyFundedOwner.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageClosedTargetNotReached_PageClosedTargetNotReachedOwner__ = __webpack_require__("./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReachedOwner.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageClosedTargetNotReached_PageClosedTargetNotReachedSupporter__ = __webpack_require__("./src/components/Prompt/PageClosedTargetNotReached/PageClosedTargetNotReachedSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SayThanks_SayThanks__ = __webpack_require__("./src/components/Prompt/SayThanks/SayThanks.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PageClosedFullyFundedSupporter_PageClosedFullyFundedSupporter__ = __webpack_require__("./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Prompt_CountdownToRefundingFlow_CountdownToRefunding__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/CountdownToRefunding.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CountdownToRefundingFlow_AddYourBankDetails_AddYourBankDetails__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/AddYourBankDetails/AddYourBankDetails.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CountdownToRefundingFlow_TimeIsRunningOut_TimeIsRunningOut__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/TimeIsRunningOut/TimeIsRunningOut.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CountdownToRefundingFlow_AddBankDetailsImmediately_AddBankDetailsImmediately__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/AddBankDetailsImmediately/AddBankDetailsImmediately.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CountdownToRefundingFlow_PageFrozen_PageFrozen__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/PageFrozen/PageFrozen.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CountdownToRefundingFlow_PageDeactivated_PageDeactivated__ = __webpack_require__("./src/components/Prompt/CountdownToRefundingFlow/PageDeactivated/PageDeactivated.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DonationsRefunded_DonationsRefunded__ = __webpack_require__("./src/components/Prompt/DonationsRefunded/DonationsRefunded.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DonationsRefundedSupporter_DonationsRefundedSupporter__ = __webpack_require__("./src/components/Prompt/DonationsRefundedSupporter/DonationsRefundedSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PageFrozenSupporter_PageFrozenSupporter__ = __webpack_require__("./src/components/Prompt/PageFrozenSupporter/PageFrozenSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Prompt_RecurringDonations_RecurringDonationsPrompt__ = __webpack_require__("./src/components/Prompt/RecurringDonations/RecurringDonationsPrompt.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Prompt_DocumentsManualVerification_DocumentsManualVerification__ = __webpack_require__("./src/components/Prompt/DocumentsManualVerification/DocumentsManualVerification.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Prompt_BankDetailsVerified_BankDetailsVerified__ = __webpack_require__("./src/components/Prompt/BankDetailsVerified/BankDetailsVerified.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PageStranded_PageStranded__ = __webpack_require__("./src/components/Prompt/PageStranded/PageStranded.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PageStrandedPageOwner_PageStrandedPageOwner__ = __webpack_require__("./src/components/Prompt/PageStrandedPageOwner/PageStrandedPageOwner.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ActivateYourPage_ActivateYourPage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__CountdownToRefundingFlow_AddBankDetailsImmediately_AddBankDetailsImmediately__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__CountdownToRefundingFlow_AddYourBankDetails_AddYourBankDetails__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9_src_components_Prompt_CountdownToRefundingFlow_CountdownToRefunding__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_15__DonationsRefunded_DonationsRefunded__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__DonationsRefundedSupporter_DonationsRefundedSupporter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__PageClosedFullyFundedOwner_PageClosedFullyFundedOwner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__PageClosedFullyFundedSupporter_PageClosedFullyFundedSupporter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__PageClosedTargetNotReached_PageClosedTargetNotReachedOwner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__PageClosedTargetNotReached_PageClosedTargetNotReachedSupporter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__CountdownToRefundingFlow_PageDeactivated_PageDeactivated__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__CountdownToRefundingFlow_PageFrozen_PageFrozen__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__PageFrozenSupporter_PageFrozenSupporter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__PageLive_PageLive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__ShareWithFriends_ShareWithFriends__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__GiveFeedback_GiveFeedback__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_18_src_components_Prompt_RecurringDonations_RecurringDonationsPrompt__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_7__SayThanks_SayThanks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__CountdownToRefundingFlow_TimeIsRunningOut_TimeIsRunningOut__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_19_src_components_Prompt_DocumentsManualVerification_DocumentsManualVerification__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_20_src_components_Prompt_BankDetailsVerified_BankDetailsVerified__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_21__PageStranded_PageStranded__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_22__PageStrandedPageOwner_PageStrandedPageOwner__["a"]; });


























/***/ }),

/***/ "./src/components/Recaptcha/Recaptcha.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_scriptLoader__ = __webpack_require__("./src/helpers/scriptLoader.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Recaptcha = /** @class */ (function (_super) {
    __extends(Recaptcha, _super);
    function Recaptcha(props) {
        var _this = _super.call(this, props) || this;
        _this.resetRecaptcha = function () {
            window.grecaptcha.reset(_this.state.id);
        };
        _this.verifyCallback = function () {
            var response = window.grecaptcha.getResponse(_this.state.id);
            _this.props.verifyCallback(response);
        };
        _this.state = {
            id: '',
        };
        return _this;
    }
    Recaptcha.prototype.componentDidMount = function () {
        var _this = this;
        if (window.grecaptcha) {
            this.renderRecaptcha();
        }
        else {
            window.onRecapchaLoad = function () {
                _this.renderRecaptcha();
            };
        }
    };
    Recaptcha.prototype.componentWillUnmount = function () {
        this.resetRecaptcha();
    };
    Recaptcha.prototype.renderRecaptcha = function () {
        this.setState({
            id: window.grecaptcha.render('html_element', {
                sitekey: this.props.sitekey,
                callback: this.verifyCallback,
            }),
        });
    };
    Recaptcha.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-recaptcha", id: "html_element" });
    };
    return Recaptcha;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_scriptLoader__["a" /* default */])('https://www.google.com/recaptcha/api.js?onload=onRecapchaLoad&render=explicit')(Recaptcha));


/***/ }),

/***/ "./src/components/Recaptcha/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recaptcha__ = __webpack_require__("./src/components/Recaptcha/Recaptcha.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Recaptcha__["a"]; });



/***/ }),

/***/ "./src/components/RecurringDonations/PageSupportsRecurringDonations.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ZfTE","image":"_1LsMp"};

/***/ }),

/***/ "./src/components/RecurringDonations/PageSupportsRecurringDonations.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_supports_recurring_donations_il_svg__ = __webpack_require__("./src/components/RecurringDonations/svg/supports-recurring-donations-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_supports_recurring_donations_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_supports_recurring_donations_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageSupportsRecurringDonations_scss__ = __webpack_require__("./src/components/RecurringDonations/PageSupportsRecurringDonations.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageSupportsRecurringDonations_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PageSupportsRecurringDonations_scss__);







var PageSupportsRecurringDonations = function (_a) {
    var isOwnerRequested = _a.isOwnerRequested, recurringDonationsPitch = _a.recurringDonationsPitch;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-text--center jg-space-pmd " + __WEBPACK_IMPORTED_MODULE_6__PageSupportsRecurringDonations_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_4__svg_supports_recurring_donations_il_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_6__PageSupportsRecurringDonations_scss___default.a.image + " jg-space-mbsm" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large-regular" }, isOwnerRequested ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "PageSupportsRecurringDonations.PO.pageAcceptsMonthlyDonations", defaultMessage: "Your Page accepts monthly donations" })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "PageSupportsRecurringDonations.Donor.pageAcceptsMonthlyDonations", defaultMessage: "This Page accepts monthly donations" }))),
        isOwnerRequested &&
            !recurringDonationsPitch && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Link"], { to: "recurring-donations-awareness-banner", spy: true, smooth: true, offset: -150, duration: 500 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link", inline: true, analyticsOptions: {
                    event: 'click',
                    subtype: 'hyperlink',
                    eventValue: 'find out more',
                    pageSection: 'page > recurring donations',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "PageSupportsRecurringDonations.boostDonations", defaultMessage: "Boost your donations now" })))),
        !isOwnerRequested && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Link"], { to: "recurring-donations-awareness-banner", spy: true, smooth: true, offset: -150, duration: 500 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link", inline: true, analyticsOptions: {
                    event: 'click',
                    subtype: 'hyperlink',
                    eventValue: 'find out more',
                    pageSection: 'page > recurring donations',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "PageSupportsRecurringDonations.findMore", defaultMessage: "Find out more" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageSupportsRecurringDonations);


/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image":"_4-Q-X"};

/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_monthly_supporters_il_svg__ = __webpack_require__("./src/components/RecurringDonations/svg/monthly-supporters-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_monthly_supporters_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_monthly_supporters_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurringDonationsAwarenessBanner_scss__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecurringDonationsAwarenessBanner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RecurringDonationsAwarenessBanner_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecurringDonationsPitchOwner__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsPitchOwner.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecurringDonationsPitchSupporter__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsPitchSupporter.tsx");







var RecurringDonationsAwarenessBanner = function (_a) {
    var isOwnerRequested = _a.isOwnerRequested, ownerName = _a.ownerName, ownerAvatarImage = _a.ownerAvatarImage, pageName = _a.pageName, recurringDonationsPitch = _a.recurringDonationsPitch, submitPitch = _a.submitPitch;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white jg-bd jg-bd--solid jg-bd--very-light-grey jg-space-pml@md jg-space-phsm@xs jg-space-pvmd@xs" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Element"], { name: "recurring-donations-awareness-banner" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svg_monthly_supporters_il_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_4__RecurringDonationsAwarenessBanner_scss___default.a.image + " jg-space-mbmd" }),
            isOwnerRequested ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RecurringDonationsPitchOwner__["a" /* default */], { ownerAvatarImage: ownerAvatarImage, ownerName: ownerName, recurringDonationsPitch: recurringDonationsPitch, submitPitch: submitPitch })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RecurringDonationsPitchSupporter__["a" /* default */], { ownerAvatarImage: ownerAvatarImage, ownerName: ownerName, pageName: pageName, pageSection: "page > story > recurring donations", recurringDonationsPitch: recurringDonationsPitch })))));
};
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsAwarenessBanner);


/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsPitch.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_SpeechBubbleWithAvatar_SpeechBubbleWithAvatar__ = __webpack_require__("./src/components/SpeechBubbleWithAvatar/SpeechBubbleWithAvatar.tsx");


var RecurringDonationsPitch = function (_a) {
    var ownerAvatarImage = _a.ownerAvatarImage, ownerName = _a.ownerName, recurringDonationsPitch = _a.recurringDonationsPitch;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_SpeechBubbleWithAvatar_SpeechBubbleWithAvatar__["a" /* default */], { avatarImage: ownerAvatarImage, message: recurringDonationsPitch, name: ownerName, arrowPosition: "left-top", showAvatar: true, showName: false }));
};
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsPitch);


/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsPitchForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_TextareaWithCharacterCount__ = __webpack_require__("./src/components/TextareaWithCharacterCount/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recurringDonationsPitchValidator__ = __webpack_require__("./src/components/RecurringDonations/recurringDonationsPitchValidator.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var RecurringDonationsPitchForm = /** @class */ (function (_super) {
    __extends(RecurringDonationsPitchForm, _super);
    function RecurringDonationsPitchForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecurringDonationsPitchForm.prototype.render = function () {
        var _a = this.props, recurringDonationsPitch = _a.recurringDonationsPitch, submitPitch = _a.submitPitch;
        var initialValues = {
            recurringDonationsPitch: recurringDonationsPitch || '',
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["c" /* Formik */], { initialValues: initialValues, enableReinitialize: false, onSubmit: submitPitch, validate: __WEBPACK_IMPORTED_MODULE_5__recurringDonationsPitchValidator__["a" /* default */], isInitialValid: Object.keys(Object(__WEBPACK_IMPORTED_MODULE_5__recurringDonationsPitchValidator__["a" /* default */])(initialValues))
                .length === 0, validateOnChange: true }, function (_a) {
            var values = _a.values, touched = _a.touched, errors = _a.errors, handleChange = _a.handleChange, isSubmitting = _a.isSubmitting, isValid = _a.isValid, status = _a.status;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--pull-left" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["b" /* Form */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: "jg-space-mbmd jg-text--center" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchForm.encourgeDonors", defaultMessage: "Encourage your supporters to give a monthly donation" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd jg-text--center" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchForm.helpDonorsUnderstand", defaultMessage: "It's important to let anyone donating to your page know how the money you raise will be used. You can help your supporters understand why you need their ongoing support here:" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_TextareaWithCharacterCount__["a" /* default */], { id: "recurringDonationsPitch", characterLimit: 500, error: errors.recurringDonationsPitch, touched: touched.recurringDonationsPitch, onChange: handleChange, value: values.recurringDonationsPitch, placeholder: "Briefly explain what monthly donations could help you achieve..." }),
                    status && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtsm jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Alert__["a" /* default */], { id: "recurring-donations-pitch-form-error", type: "red", displayType: "inline", persistent: true },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchForm.errorAlert", defaultMessage: "An error has occurred. Please try again." })))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-phsm@xs" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { className: "jg-btn jg-btn--brand col-xs-12 col-md-6 offset-md-3", loading: isSubmitting, disabled: !isValid, value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchForm.addMessage", defaultMessage: "Add a message" }) })))));
        }));
    };
    return RecurringDonationsPitchForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsPitchForm);


/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsPitchOwner.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecurringDonationsPitchForm__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsPitchForm.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecurringDonationsPitch__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsPitch.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var RecurringDonationsPitchOwner = /** @class */ (function (_super) {
    __extends(RecurringDonationsPitchOwner, _super);
    function RecurringDonationsPitchOwner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPitchBeingEdited: false,
        };
        _this.editPitch = function () {
            _this.setState({ isPitchBeingEdited: true });
        };
        _this.submitForm = function (payload, formikBag) { return __awaiter(_this, void 0, void 0, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.submitPitch(payload, formikBag)];
                    case 1:
                        success = _a.sent();
                        if (success && this.state.isPitchBeingEdited) {
                            this.setState({ isPitchBeingEdited: false });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    RecurringDonationsPitchOwner.prototype.render = function () {
        var _a = this.props, ownerAvatarImage = _a.ownerAvatarImage, ownerName = _a.ownerName, recurringDonationsPitch = _a.recurringDonationsPitch;
        if (recurringDonationsPitch && !this.state.isPitchBeingEdited) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: "jg-space-mbmd jg-text--center" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchOwner.youCanDonateMonthly", defaultMessage: "You can donate monthly to this page!" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RecurringDonationsPitch__["a" /* default */], { recurringDonationsPitch: recurringDonationsPitch, ownerAvatarImage: ownerAvatarImage, ownerName: ownerName }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-phsm@xs" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__["c" /* Button */], { className: "jg-btn jg-btn--ghost jg-space-mtmd col-xs-12 col-md-6 offset-md-3", onClick: this.editPitch },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchOwner.editMessage", defaultMessage: "Edit message" })))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RecurringDonationsPitchForm__["a" /* default */], { recurringDonationsPitch: recurringDonationsPitch, submitPitch: this.submitForm }));
    };
    return RecurringDonationsPitchOwner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsPitchOwner);


/***/ }),

/***/ "./src/components/RecurringDonations/RecurringDonationsPitchSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecurringDonationsPitch__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsPitch.tsx");




var RecurringDonationsPitchSupporter = function (_a) {
    var ownerAvatarImage = _a.ownerAvatarImage, ownerName = _a.ownerName, pageName = _a.pageName, pageSection = _a.pageSection, recurringDonationsPitch = _a.recurringDonationsPitch;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: "jg-space-mbmd jg-text--center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchSupporter.youCanDonateMonthly", defaultMessage: "You can donate monthly to this page!" })),
        recurringDonationsPitch ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecurringDonationsPitch__["a" /* default */], { recurringDonationsPitch: recurringDonationsPitch, ownerAvatarImage: ownerAvatarImage, ownerName: ownerName })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchSupporter.whyMonthlyDonations", defaultMessage: "Crowdfunding pages aren't always one-off projects. Some run for several months and need on-going funding to be successful. By giving monthly, you will be helping to support this page every month until it closes. You can of course cancel your monthly donation at any time." }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtmd jg-text--center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { "data-marker": "recurring-donations-awareness-donate-monthly-button", href: __WEBPACK_IMPORTED_MODULE_2_config__["CROWDFUNDING_BASE_URI"] + "/" + pageName + "/donate?pageSection=" + pageSection + "&paymentType=monthly&eventValue=monthly", className: "jg-btn jg-btn--brand jg-width--300" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "RecurringDonationsPitchSupporter.donateMonthly", defaultMessage: "Donate monthly" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (RecurringDonationsPitchSupporter);


/***/ }),

/***/ "./src/components/RecurringDonations/recurringDonationsPitchValidator.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");

var rules = {
    recurringDonationsPitch: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({ message: 'Please include a message for your supporters' }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["d" /* maxLength */])(500),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["f" /* minLength */])(2),
    ],
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(rules));


/***/ }),

/***/ "./src/components/RecurringDonations/svg/monthly-supporters-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 209 190\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><polygon id=\"path-1\" points=\"0 0.235769531 42.6715812 0.235769531 42.6715812 52.4086267 0 52.4086267\"></polygon><polygon id=\"path-5\" points=\"0.1246875 0.0185197289 9.94994505 0.0185197289 9.94994505 10.036916 0.1246875 10.036916\"></polygon><polyline id=\"path-7\" points=\"0.00996503497 11.0512921 1.96412025 11.6499455 5.30967314 0.890047809 3.35551792 0.291394336\"></polyline><polygon id=\"path-9\" points=\"9.78708791e-05 0.118824135 14.2735869 0.118824135 14.2735869 21.6718385 9.78708791e-05 21.6718385\"></polygon><polygon id=\"path-11\" points=\"3.26236264e-05 0.118824135 8.04730254 0.118824135 8.04730254 21.6717738 3.26236264e-05 21.6717738\"></polygon><path d=\"M12.4398734,4.05637401 C11.3212025,1.81232639 9.18291139,0.282440476 6.70537975,0.282440476 C3.08860759,0.282440476 0.171202532,3.52566964 0.171202532,7.54464286 C0.171202532,9.56428571 0.850949367,11.2166915 2.10949367,12.7059524 L12.4398734,23.1304563 L22.3107595,13.1550843 C23.8291139,11.4617312 24.7082278,9.8093254 24.7082278,7.54464286 C24.7281646,3.54630456 21.7908228,0.282440476 18.1743671,0.282440476 C15.6968354,0.282440476 13.5588608,1.81232639 12.4398734,4.05637401 Z\" id=\"path-13\"></path><path d=\"M3.91387034,1.35700253 C3.56191075,0.606288153 2.88915516,0.0944864653 2.10966672,0.0944864653 C0.971746999,0.0944864653 0.0538642547,1.1794629 0.0538642547,2.52395353 C0.0538642547,3.19959647 0.267728246,3.75238544 0.663695235,4.2505966 L3.91387034,7.73796692 L7.01947817,4.40084734 C7.4971874,3.83436 7.77377686,3.28157103 7.77377686,2.52395353 C7.78004941,1.18636602 6.85589412,0.0944864653 5.71807396,0.0944864653 C4.93858551,0.0944864653 4.2659295,0.606288153 3.91387034,1.35700253 Z\" id=\"path-15\"></path><path d=\"M1.31894317,0.469024678 C1.20033559,0.209553113 0.973622311,0.032657628 0.710940904,0.032657628 C0.32747101,0.032657628 0.0181518254,0.407661144 0.0181518254,0.872361296 C0.0181518254,1.1058857 0.0902222894,1.29694774 0.223660015,1.4691459 L1.31894317,2.6744957 L2.36550831,1.52107749 C2.52649252,1.32528084 2.61970097,1.13421881 2.61970097,0.872361296 C2.62181477,0.41004709 2.31038179,0.032657628 1.92694545,0.032657628 C1.66426404,0.032657628 1.43758431,0.209553113 1.31894317,0.469024678 Z\" id=\"path-17\"></path><path d=\"M1.31894317,0.469024678 C1.20033559,0.209553113 0.973622311,0.032657628 0.710940904,0.032657628 C0.32747101,0.032657628 0.0181518254,0.407661144 0.0181518254,0.872361296 C0.0181518254,1.1058857 0.0902222894,1.29694774 0.223660015,1.4691459 L1.31894317,2.6744957 L2.36550831,1.52107749 C2.52649252,1.32528084 2.61970097,1.13421881 2.61970097,0.872361296 C2.62181477,0.41004709 2.31038179,0.032657628 1.92694545,0.032657628 C1.66426404,0.032657628 1.43758431,0.209553113 1.31894317,0.469024678 Z\" id=\"path-19\"></path><path d=\"M2.45685267,0.801126585 C2.23591718,0.357931208 1.81360852,0.055781487 1.32430046,0.055781487 C0.609994455,0.055781487 0.0338121927,0.696313425 0.0338121927,1.49005342 C0.0338121927,1.88892926 0.168060972,2.21527643 0.416621213,2.50940279 L2.45685267,4.56822361 L4.40633495,2.59810554 C4.70620722,2.26367133 4.87983065,1.93732416 4.87983065,1.49005342 C4.88376811,0.700388785 4.30364838,0.055781487 3.58940487,0.055781487 C3.10009682,0.055781487 2.67785066,0.357931208 2.45685267,0.801126585 Z\" id=\"path-21\"></path></defs><g id=\"v2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"customisedmessage_donor\" transform=\"translate(-424.000000, -1180.000000)\"><g id=\"Group-3\" transform=\"translate(228.000000, 1151.000000)\"><g id=\"Group-116\" transform=\"translate(176.000000, 0.000000)\"><path d=\"M125,24.1680808 C176.767935,15.8861313 229.464286,62.6725225 229.464286,120.481115 C229.464286,178.289708 176.788312,231.227957 125,212.084069 C73.2116884,192.940181 20.5357143,178.289708 20.5357143,120.481115 C20.5357143,62.6725225 73.2320652,32.4500304 125,24.1680808 Z\" id=\"Combined-Shape-Copy\" fill=\"#F9F0FA\" fill-rule=\"nonzero\" transform=\"translate(125.000000, 119.642857) scale(-1, -1) rotate(-14.000000) translate(-125.000000, -119.642857) \"></path><path d=\"M190.178571,138.392857 C193.453047,145.115623 202.0848,145.034678 208.035714,144.324856\" id=\"Stroke-1\" stroke=\"#A67445\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"bevel\"></path><path d=\"M179.017857,209.821429 C177.291746,209.821429 175.892857,208.448749 175.892857,206.755712 L175.892857,156.637146 C175.892857,154.944108 177.291746,153.571429 179.017857,153.571429 C180.743968,153.571429 182.142857,154.944108 182.142857,156.637146 L182.142857,206.755712 C182.142857,208.448749 180.743968,209.821429 179.017857,209.821429\" id=\"Fill-3\" fill=\"#1D67BE\"></path><path d=\"M165.625,209.821429 C163.898889,209.821429 162.5,208.448749 162.5,206.755712 L162.5,156.637146 C162.5,154.944108 163.898889,153.571429 165.625,153.571429 C167.351111,153.571429 168.75,154.944108 168.75,156.637146 L168.75,206.755712 C168.75,208.448749 167.351111,209.821429 165.625,209.821429\" id=\"Fill-5\" fill=\"#1D67BE\"></path><path d=\"M158.815846,173.210412 C159.36324,173.181512 159.906559,172.993989 160.36838,172.638648 C161.54976,171.72895 161.744676,170.065548 160.804394,168.923005 C155.343698,162.289759 153.005728,155.564228 153.855683,148.93328 C155.264917,137.935779 164.898982,130.711063 164.995761,130.639141 C166.196156,129.753417 166.426727,128.093956 165.510895,126.933023 C164.594384,125.772089 162.878514,125.549427 161.678798,126.434823 C161.207129,126.78261 150.117648,135.104218 148.428944,148.283026 C147.391884,156.377046 150.11595,164.430014 156.526436,172.216968 C157.099298,172.912872 157.962156,173.255076 158.815846,173.210412\" id=\"Fill-7\" fill=\"#A67445\"></path><path d=\"M172.33693,82.6828352 C172.33693,82.6828352 143.256386,72.992383 154.280789,135.714286 L191.016352,134.500052 C191.016352,134.500052 206.853348,77.9684007 172.33693,82.6828352\" id=\"Fill-9\" fill=\"#5F3D27\"></path><path d=\"M155.357143,101.785714 C155.357143,111.154804 162.952266,118.75 172.321265,118.75 C181.690591,118.75 189.285714,111.154804 189.285714,101.785714 C189.285714,92.4166249 181.690591,84.8214286 172.321265,84.8214286 C162.952266,84.8214286 155.357143,92.4166249 155.357143,101.785714\" id=\"Fill-11\" fill=\"#A67445\"></path><path d=\"M158.928571,107.589286 C158.928571,109.808348 160.727367,111.607143 162.946429,111.607143 C165.165491,111.607143 166.964286,109.808348 166.964286,107.589286 C166.964286,105.370559 165.165491,103.571429 162.946429,103.571429 C160.727367,103.571429 158.928571,105.370559 158.928571,107.589286\" id=\"Fill-13\" fill-opacity=\"0.1\" fill=\"#F22C98\"></path><path d=\"M178.571429,107.589286 C178.571429,109.808348 180.370224,111.607143 182.589286,111.607143 C184.808348,111.607143 186.607143,109.808348 186.607143,107.589286 C186.607143,105.370559 184.808348,103.571429 182.589286,103.571429 C180.370224,103.571429 178.571429,105.370559 178.571429,107.589286\" id=\"Fill-15\" fill-opacity=\"0.1\" fill=\"#F22C98\"></path><path d=\"M174.905665,102.678571 C175.259681,102.678922 175.583057,102.428732 175.676972,102.051167 C175.862139,101.307968 176.501565,100.788641 177.232242,100.788641 C177.962919,100.788641 178.602344,101.307617 178.787511,102.050466 C178.899078,102.499263 179.335686,102.76805 179.761636,102.650148 C180.18792,102.532247 180.442691,102.072221 180.330792,101.623424 C179.96179,100.141938 178.687268,99.1071429 177.232242,99.1071429 C175.77655,99.1071429 174.502361,100.142289 174.133359,101.624477 C174.021793,102.073625 174.276564,102.5333 174.702847,102.651201 C174.770786,102.669799 174.838725,102.678571 174.905665,102.678571\" id=\"Fill-17\" fill=\"#1D1D1B\"></path><path d=\"M165.977192,102.678571 C166.331201,102.678922 166.654571,102.428732 166.748485,102.051167 C166.933649,101.307968 167.573063,100.788641 168.303727,100.788641 C169.03439,100.788641 169.673804,101.307617 169.858968,102.050466 C169.970533,102.499263 170.407133,102.76805 170.833076,102.650148 C171.259352,102.532247 171.514118,102.072221 171.402221,101.623424 C171.033225,100.141938 169.758727,99.1071429 168.303727,99.1071429 C166.848061,99.1071429 165.573895,100.142289 165.2049,101.624477 C165.093002,102.073625 165.348102,102.5333 165.774378,102.651201 C165.842315,102.669799 165.910253,102.678571 165.977192,102.678571\" id=\"Fill-19\" fill=\"#1D1D1B\"></path><g id=\"Group-25\" transform=\"translate(168.750000, 106.250000)\" fill=\"#1D1D1B\"><path d=\"M1.11267857,1.00136364 C1.35345238,2.00233766 2.18857143,2.74097403 3.18172619,2.74097403 C4.17488095,2.74097403 5.00970238,2.00298701 5.25047619,1.00201299 L1.11267857,1.00136364 Z\" id=\"Fill-21\"></path><path d=\"M2.49482143,1.77532468 C2.90583333,2.0211039 3.45702381,2.0211039 3.86803571,1.77597403 L2.49482143,1.77532468 Z M0.426369048,1.19772727 L0.193035714,0.226948052 L6.17041667,0.228571429 L5.93678571,1.19902597 C5.60821429,2.56266234 4.47547619,3.51461039 3.18172619,3.51461039 C1.88738095,3.51461039 0.754345238,2.56201299 0.426369048,1.19772727 Z\" id=\"Fill-23\"></path></g><path d=\"M154.464286,98.2142857 C154.464286,98.2142857 170.734412,92.9908636 172.518411,85.995743 C172.518411,85.995743 181.518999,95.8511448 190.178571,97.7276601 C190.178571,97.7276601 186.413091,84.2421163 172.26598,84.8407874 C172.26598,84.8407874 157.857448,85.4926884 154.464286,98.2142857\" id=\"Fill-26\" fill=\"#5F3D27\"></path><path d=\"M188.386351,139.051388 C188.26794,131.25342 182.855495,124.773879 175.666227,123.214286 C175.630769,125.076338 174.148023,126.574973 172.321429,126.574973 C170.494509,126.574973 169.012088,125.076338 168.976305,123.214286 C161.787363,124.773879 156.374592,131.25342 156.256506,139.051388 C156.25488,139.094358 156.25,139.136662 156.25,139.180299 L156.25,156.777523 C156.25,158.451371 157.587659,159.821429 159.222648,159.821429 L185.420209,159.821429 C187.055198,159.821429 188.392857,158.451371 188.392857,156.777523 L188.392857,139.180299 C188.392857,139.136662 188.387978,139.094358 188.386351,139.051388\" id=\"Fill-28\" fill=\"#76A4D8\"></path><path d=\"M171.875152,125.892857 C173.581631,125.892857 174.966569,124.454245 175,122.666772 C173.991612,122.442299 172.947058,122.321429 171.875152,122.321429 C170.803246,122.321429 169.758388,122.442299 168.75,122.666772 C168.783431,124.454245 170.168369,125.892857 171.875152,125.892857\" id=\"Fill-30\" fill=\"#A67445\"></path><path d=\"M188.220425,141.071429 C184.805692,134.391283 179.517058,130.444665 179.464286,130.405653 L182.331701,125.892857 C182.588296,126.080452 188.834103,130.519635 192.857143,138.390822 L188.220425,141.071429 Z\" id=\"Fill-32\" fill=\"#76A4D8\"></path><polygon id=\"Fill-34\" fill=\"#144784\" points=\"206.935382 148.214286 202.678571 148.025372 206.457475 65.1785714 210.714286 65.3678141\"></polygon><polygon id=\"Fill-36\" fill=\"#FFFFFF\" points=\"226.397326 104.464286 188.392857 102.754242 190.56696 54.4642857 228.571429 56.1746575\"></polygon><path d=\"M156.588113,141.964286 C159.805151,135.237302 165.125638,131.076791 165.178571,131.035262 L161.942676,126.785714 C161.684624,126.983391 155.576089,131.721981 151.785714,139.648314 L156.588113,141.964286 Z\" id=\"Fill-38\" fill=\"#76A4D8\"></path><path d=\"M53.5714286,138.392857 C50.2969534,145.115623 41.6652001,145.034678 35.7142857,144.324856\" id=\"Stroke-40\" stroke=\"#A67445\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"bevel\"></path><path d=\"M64.7321429,209.821429 C66.4582537,209.821429 67.8571429,208.448749 67.8571429,206.755712 L67.8571429,156.637146 C67.8571429,154.944108 66.4582537,153.571429 64.7321429,153.571429 C63.006032,153.571429 61.6071429,154.944108 61.6071429,156.637146 L61.6071429,206.755712 C61.6071429,208.448749 63.006032,209.821429 64.7321429,209.821429\" id=\"Fill-42\" fill=\"#1D1D1B\"></path><path d=\"M78.125,209.821429 C79.8511108,209.821429 81.25,208.448749 81.25,206.755712 L81.25,156.637146 C81.25,154.944108 79.8511108,153.571429 78.125,153.571429 C76.3988892,153.571429 75,154.944108 75,156.637146 L75,206.755712 C75,208.448749 76.3988892,209.821429 78.125,209.821429\" id=\"Fill-44\" fill=\"#1D1D1B\"></path><path d=\"M84.0412966,173.210412 C83.4939026,173.181512 82.9505836,172.993989 82.4887624,172.638648 C81.307383,171.72895 81.1124673,170.065548 82.0527488,168.923005 C87.5131053,162.289759 89.8510751,155.564228 89.0014599,148.93328 C87.5922261,137.935779 77.9581606,130.711063 77.8613819,130.639141 C76.6609864,129.753417 76.4304154,128.093956 77.3462476,126.933023 C78.2627589,125.772089 79.9786284,125.549427 81.1783447,126.434823 C81.649674,126.78261 92.739495,135.104218 94.4281985,148.283026 C95.4652587,156.377046 92.7411928,164.430014 86.3307072,172.216968 C85.7578452,172.912872 84.8949866,173.255076 84.0412966,173.210412\" id=\"Fill-46\" fill=\"#A67445\"></path><path d=\"M87.5,101.785714 C87.5,111.154804 79.904877,118.75 70.535878,118.75 C61.1665516,118.75 53.5714286,111.154804 53.5714286,101.785714 C53.5714286,92.4166249 61.1665516,84.8214286 70.535878,84.8214286 C79.904877,84.8214286 87.5,92.4166249 87.5,101.785714\" id=\"Fill-48\" fill=\"#A67445\"></path><path d=\"M79.9107143,111.607143 C77.6916524,111.607143 75.8928571,109.808348 75.8928571,107.589286 C75.8928571,105.370559 77.6916524,103.571429 79.9107143,103.571429 C82.1297762,103.571429 83.9285714,105.370559 83.9285714,107.589286 C83.9285714,109.808348 82.1297762,111.607143 79.9107143,111.607143 Z\" id=\"Fill-50\" fill-opacity=\"0.1\" fill=\"#F22C98\"></path><path d=\"M64.2857143,107.589286 C64.2857143,109.808348 62.4869191,111.607143 60.2678571,111.607143 C58.0487952,111.607143 56.25,109.808348 56.25,107.589286 C56.25,105.370559 58.0487952,103.571429 60.2678571,103.571429 C62.4869191,103.571429 64.2857143,105.370559 64.2857143,107.589286\" id=\"Fill-52\" fill-opacity=\"0.1\" fill=\"#F22C98\"></path><path d=\"M68.8442223,102.678571 C68.490207,102.678922 68.1668309,102.428732 68.0729152,102.051167 C67.8877482,101.307968 67.2483227,100.788641 66.5176457,100.788641 C65.7873018,100.788641 65.1475432,101.307617 64.9627092,102.050466 C64.8508098,102.499263 64.414202,102.76805 63.9882513,102.650148 C63.5619676,102.532247 63.3075295,102.072221 63.4190959,101.623424 C63.7884308,100.141938 65.0626195,99.1071429 66.5176457,99.1071429 C67.973338,99.1071429 69.2475267,100.142289 69.6165286,101.624477 C69.728428,102.073625 69.4733239,102.5333 69.0470401,102.651201 C68.9794342,102.669799 68.9111622,102.678571 68.8442223,102.678571\" id=\"Fill-54\" fill=\"#1D1D1B\"></path><path d=\"M76.8799339,102.678571 C76.5259174,102.678922 76.2025401,102.428732 76.1086242,102.051167 C75.9234566,101.307968 75.2840288,100.788641 74.5536824,100.788641 C73.823003,100.788641 73.1835752,101.307617 72.9984076,102.050466 C72.8865078,102.499263 72.4498985,102.76805 72.0239464,102.650148 C71.5979942,102.532247 71.3432222,102.072221 71.454789,101.623424 C71.8241252,100.141938 73.0983182,99.1071429 74.5536824,99.1071429 C76.0090466,99.1071429 77.2832396,100.142289 77.6522428,101.624477 C77.7641426,102.073625 77.5090376,102.5333 77.0827524,102.651201 C77.0151462,102.669799 76.946874,102.678571 76.8799339,102.678571\" id=\"Fill-56\" fill=\"#1D1D1B\"></path><g id=\"Group-62\" transform=\"translate(66.964286, 106.250000)\" fill=\"#1D1D1B\"><path d=\"M5.25928571,1.00136364 C5.0185119,2.00233766 4.18339286,2.74097403 3.1902381,2.74097403 C2.19708333,2.74097403 1.3622619,2.00298701 1.12119048,1.00201299 L5.25928571,1.00136364 Z\" id=\"Fill-58\"></path><path d=\"M2.50383929,1.77597403 C2.91485119,2.0211039 3.46604167,2.0211039 3.87705357,1.77532468 L2.50383929,1.77597403 Z M3.19014881,3.51461039 C1.89639881,3.51461039 0.763660714,2.56266234 0.435089286,1.19902597 L0.201458333,0.228571429 L6.17883929,0.226948052 L5.94550595,1.19772727 C5.61723214,2.56201299 4.48449405,3.51461039 3.19014881,3.51461039 Z\" id=\"Fill-60\"></path></g><path d=\"M88.3928571,98.2142857 C88.3928571,98.2142857 72.122731,92.9908636 70.3390648,85.995743 C70.3390648,85.995743 61.3381443,95.8511448 52.6785714,97.7276601 C52.6785714,97.7276601 56.444385,84.2421163 70.5914955,84.8407874 C70.5914955,84.8407874 84.9996953,85.4926884 88.3928571,98.2142857\" id=\"Fill-63\" fill=\"#5F3D27\"></path><path d=\"M54.4707918,139.051388 C54.588878,131.25342 60.0016482,124.773879 67.1909157,123.214286 C67.2263741,125.076338 68.7091199,126.574973 70.5357143,126.574973 C72.362634,126.574973 73.8447292,125.076338 73.8805129,123.214286 C81.0697804,124.773879 86.4822253,131.25342 86.6006367,139.051388 C86.6022633,139.094358 86.6071429,139.136662 86.6071429,139.180299 L86.6071429,156.777523 C86.6071429,158.451371 85.2694837,159.821429 83.6344946,159.821429 L57.436934,159.821429 C55.8019449,159.821429 54.4642857,158.451371 54.4642857,156.777523 L54.4642857,139.180299 C54.4642857,139.136662 54.4691653,139.094358 54.4707918,139.051388\" id=\"Fill-65\" fill=\"#1D67BE\"></path><path d=\"M70.0892857,125.892857 C68.3827233,125.892857 66.9977179,124.454245 66.9642857,122.666772 C67.9724189,122.442299 69.0173274,122.321429 70.0892857,122.321429 C71.161244,122.321429 72.2061526,122.442299 73.2142857,122.666772 C73.1808535,124.454245 71.7961521,125.892857 70.0892857,125.892857\" id=\"Fill-67\" fill=\"#A67445\"></path><path d=\"M53.7440677,141.071429 C57.1587201,134.391283 62.4472287,130.444665 62.5,130.405653 L59.6323366,125.892857 C59.3760639,126.080452 53.1304035,130.519635 49.1071429,138.390822 L53.7440677,141.071429 Z\" id=\"Fill-69\" fill=\"#1D67BE\"></path><polygon id=\"Fill-71\" fill=\"#144784\" points=\"33.9285714 147.782893 38.0515503 148.214286 46.4285714 65.6096347 42.3052681 65.1785714\"></polygon><g id=\"Group-75\" transform=\"translate(21.428571, 53.571429)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-74\"></g><polygon id=\"Fill-73\" fill=\"#FFFFFF\" mask=\"url(#mask-2)\" points=\"-6.54307525e-05 48.4965843 37.7315594 52.4086267 42.6715812 4.1474827 4.94028353 0.235769531\"></polygon></g><path d=\"M87.1622176,141.964286 C83.9451793,135.237302 78.624693,131.076791 78.5714286,131.035262 L81.8073244,126.785714 C82.0657065,126.983391 88.1742415,131.721981 91.9642857,139.648314 L87.1622176,141.964286 Z\" id=\"Fill-76\" fill=\"#1D67BE\"></path><path d=\"M129.910714,209.821429 C128.184938,209.821429 126.785714,208.448749 126.785714,206.755712 L126.785714,156.637146 C126.785714,154.944108 128.184938,153.571429 129.910714,153.571429 C131.636825,153.571429 133.035714,154.944108 133.035714,156.637146 L133.035714,206.755712 C133.035714,208.448749 131.636825,209.821429 129.910714,209.821429\" id=\"Fill-78\" fill=\"#144784\"></path><g id=\"Group-82\" transform=\"translate(109.821429, 150.892857)\"><g id=\"Clip-81\"></g><path d=\"M6.64043155,58.9286376 C5.28016369,58.9286376 4.03873512,58.0036577 3.68221726,56.6102287 C-3.88355655,27.0436457 3.41671131,3.44804976 3.73099702,2.45818218 C4.24793155,0.832018459 5.9709375,-0.0611797753 7.57739583,0.459576645 C9.18450893,0.981657303 10.0690923,2.72104334 9.55477679,4.34621388 C9.48340774,4.57265851 2.50102679,27.3075 9.6025744,55.0608708 C10.025878,56.7145124 9.04340774,58.40126 7.40846726,58.8293198 C7.1518006,58.8961938 6.8938244,58.9286376 6.64043155,58.9286376\" id=\"Fill-80\" fill=\"#144784\"></path></g><path d=\"M142.685223,99.6847359 C139.837613,91.1754575 133.245985,83.9090634 122.902971,83.9286108 C122.840688,83.9286108 122.77941,83.9325202 122.717127,83.9331718 C122.655178,83.932846 122.5939,83.9292624 122.531282,83.9292624 C112.188269,83.9484839 105.625438,91.2393121 102.811313,99.7590158 C101.345316,104.197237 99.1071429,109.772461 99.1071429,109.772461 C102.544099,113.499485 117.039653,114.296039 122.591221,114.285614 C122.653504,114.285288 122.714783,114.284311 122.776731,114.284311 C122.839014,114.284311 122.900627,114.284962 122.96291,114.284636 C128.514478,114.274537 143.006684,113.424228 146.428571,109.684172 C146.428571,109.684172 144.168632,104.117093 142.685223,99.6847359\" id=\"Fill-83\" fill=\"#76A4D8\"></path><path d=\"M113.416602,134.821429 C112.768438,134.821429 112.119285,134.583787 111.607941,134.104532 C111.416393,133.92415 106.854521,129.59166 102.274516,120.761854 C98.1056299,112.72507 93.0874714,99.1947277 92.8573502,80.3760344 C92.8392174,78.9045104 94.0129014,77.6964442 95.4786877,77.6789024 C95.489897,77.6785714 95.5011064,77.6785714 95.5123157,77.6785714 C96.9629364,77.6785714 98.1478298,78.8502302 98.1656328,80.310501 C98.3815775,97.9383388 103.010376,110.564782 106.85551,118.052807 C111.022748,126.168365 115.196909,130.176166 115.238449,130.215552 C116.302018,131.22437 116.354768,132.909705 115.352521,133.980085 C114.829638,134.538774 114.123779,134.821429 113.416602,134.821429\" id=\"Fill-85\" fill=\"#FBCE9D\"></path><path d=\"M111.452768,133.035714 C111.299147,132.901026 107.648123,129.663097 103.571429,123.117989 L108.275125,120.535714 C111.912952,126.376566 115.146426,129.274596 115.178571,129.303186 L111.452768,133.035714 Z\" id=\"Fill-87\" fill=\"#1D67BE\"></path><path d=\"M137.215168,173.214286 C136.679073,173.214286 136.137996,173.0543 135.667667,172.721768 C134.463945,171.869944 134.182279,170.207944 135.038237,169.010036 C140.008242,162.055619 141.923769,155.173263 140.730675,148.554023 C138.75204,137.575176 128.946883,130.821403 128.848234,130.754632 C127.627239,129.927599 127.311362,128.27188 128.142409,127.056783 C128.973788,125.842016 130.637542,125.527333 131.857872,126.354366 C132.337501,126.678965 143.624392,134.458101 145.995632,147.614273 C147.451459,155.694538 145.231681,163.931153 139.397081,172.095047 C138.875601,172.824899 138.051529,173.214286 137.215168,173.214286\" id=\"Fill-89\" fill=\"#FBCE9D\"></path><path d=\"M137.443964,141.964286 C133.983839,135.283991 128.624903,131.337284 128.571429,131.298272 L131.476961,126.785714 C131.736966,126.972974 137.887767,131.465177 141.964286,139.33654 L137.443964,141.964286 Z\" id=\"Fill-91\" fill=\"#1D67BE\"></path><path d=\"M137.5,102.678571 C137.5,111.554731 130.304479,118.75 121.428409,118.75 C112.552664,118.75 105.357143,111.554731 105.357143,102.678571 C105.357143,93.8024115 112.552664,86.6071429 121.428409,86.6071429 C130.304479,86.6071429 137.5,93.8024115 137.5,102.678571\" id=\"Fill-93\" fill=\"#FBCE9D\"></path><path d=\"M134.821429,107.589462 C134.821429,109.808491 133.022425,111.607143 130.803396,111.607143 C128.584366,111.607143 126.785714,109.808491 126.785714,107.589462 C126.785714,105.370081 128.584366,103.571429 130.803396,103.571429 C133.022425,103.571429 134.821429,105.370081 134.821429,107.589462\" id=\"Fill-95\" fill-opacity=\"0.1\" fill=\"#F42C9A\"></path><path d=\"M116.964286,107.589462 C116.964286,109.808491 115.165282,111.607143 112.946604,111.607143 C110.727575,111.607143 108.928571,109.808491 108.928571,107.589462 C108.928571,105.370081 110.727575,103.571429 112.946604,103.571429 C115.165282,103.571429 116.964286,105.370081 116.964286,107.589462\" id=\"Fill-97\" fill-opacity=\"0.1\" fill=\"#F42C9A\"></path><path d=\"M120.630011,102.678571 C120.275834,102.678571 119.952743,102.490892 119.858785,102.207717 C119.673662,101.650199 119.034117,101.26104 118.303408,101.26104 C117.573048,101.26104 116.933503,101.649923 116.748381,102.207165 C116.636609,102.54416 116.199999,102.745639 115.774218,102.657043 C115.347738,102.568724 115.093108,102.224001 115.20488,101.887006 C115.574076,100.775834 116.848277,100 118.303408,100 C119.759238,100 121.033438,100.77611 121.402285,101.88811 C121.514057,102.224553 121.259078,102.569276 120.832947,102.657871 C120.765185,102.671947 120.697074,102.678571 120.630011,102.678571\" id=\"Fill-99\" fill=\"#1D1D1B\"></path><path d=\"M127.772868,102.678571 C127.418691,102.678571 127.0956,102.490892 127.001642,102.207717 C126.816519,101.650199 126.176974,101.26104 125.446265,101.26104 C124.715905,101.26104 124.07636,101.649923 123.891238,102.207165 C123.779466,102.54416 123.342857,102.745639 122.917075,102.657043 C122.490595,102.568724 122.235965,102.224001 122.347737,101.887006 C122.716934,100.775834 123.991134,100 125.446265,100 C126.902095,100 128.176295,100.77611 128.545143,101.88811 C128.656915,102.224553 128.401935,102.569276 127.975804,102.657871 C127.908042,102.671947 127.839931,102.678571 127.772868,102.678571\" id=\"Fill-101\" fill=\"#1D1D1B\"></path><path d=\"M137.493494,139.944245 C137.375082,132.146611 131.962637,125.666736 124.77337,124.107476 C124.737912,125.969195 123.255166,127.46783 121.428571,127.46783 C119.601652,127.46783 118.119557,125.969195 118.083773,124.107143 C110.894505,125.666736 105.48206,132.146611 105.363649,139.944245 C105.362022,139.987548 105.357143,140.029853 105.357143,140.073156 L105.357143,157.67038 C105.357143,159.344562 106.694802,160.714286 108.329791,160.714286 L134.527352,160.714286 C136.162341,160.714286 137.5,159.344562 137.5,157.67038 L137.5,140.073156 C137.5,140.029853 137.49512,139.987548 137.493494,139.944245\" id=\"Fill-103\" fill=\"#1D67BE\"></path><path d=\"M121.875,127.678571 C123.581562,127.678571 124.966568,126.239959 125,124.452806 C123.991563,124.228013 122.946958,124.107143 121.875,124.107143 C120.803042,124.107143 119.758133,124.228013 118.75,124.452486 C118.783432,126.239959 120.168134,127.678571 121.875,127.678571\" id=\"Fill-105\" fill=\"#FBCE9D\"></path><g id=\"Group-111\" transform=\"translate(118.750000, 106.250000)\" fill=\"#1D1D1B\"><path d=\"M5.05939342,0.987727273 C4.81900227,1.94194805 3.98464853,2.64616883 2.99284014,2.64616883 C2.00071995,2.64616883 1.1669898,1.9425974 0.926286848,0.988376623 L5.05939342,0.987727273 Z\" id=\"Fill-107\"></path><path d=\"M2.30717971,1.7262013 C2.71749717,1.95996753 3.26812075,1.95996753 3.67875,1.72587662 L2.30717971,1.7262013 Z M2.99280896,3.38431818 C1.70043367,3.38431818 0.568942744,2.47652597 0.240938209,1.1762013 L0.00740646259,0.250876623 L5.97789966,0.249577922 L5.74467971,1.1749026 C5.41729875,2.47587662 4.28549603,3.38431818 2.99280896,3.38431818 Z\" id=\"Fill-109\"></path></g><path d=\"M121.428571,85.7852176 C121.428571,85.7852176 117.805965,94.8447259 104.464286,99.1071429 C104.464286,99.1071429 108.655565,84.5810604 121.428571,85.7852176\" id=\"Fill-112\" fill=\"#76A4D8\"></path><path d=\"M122.321429,85.7912152 C122.321429,85.7912152 125.968595,94.8760541 139.285714,99.1071429 C139.285714,99.1071429 135.049908,84.5337924 122.321429,85.7912152\" id=\"Fill-114\" fill=\"#76A4D8\"></path><g id=\"Group-25\" transform=\"translate(78.571429, 50.000000)\"><g id=\"Group-10\" transform=\"translate(9.787088, 7.327920)\"><path d=\"M3.70855598,16.3201549 C3.5297785,16.8951731 3.85405735,17.507425 4.43410543,17.6851755 L5.74622768,18.0869759 C6.32431834,18.2640789 6.94155735,17.9403074 7.12033482,17.3652893 L7.32651614,16.7018815 C7.50627232,16.1245969 7.17970982,15.5136402 6.60129293,15.3365372 L5.28917067,14.9347367 C4.7091226,14.7569862 4.09449348,15.0794626 3.91473729,15.6567472 L3.70855598,16.3201549 Z\" id=\"Fill-1\" fill=\"#1977B9\"></path><g id=\"Group-5\" transform=\"translate(3.262363, 15.541031)\"><mask id=\"mask-6\" fill=\"white\"><use xlink:href=\"#path-5\"></use></mask><g id=\"Clip-4\"></g><polyline id=\"Fill-3\" fill=\"#1977B9\" mask=\"url(#mask-6)\" points=\"4.49788462 10.0369808 9.94994505 2.2010633 2.82331387 0.0185197289 0.1246875 8.69753813\"></polyline></g><polyline id=\"Fill-6\" fill=\"#144784\" points=\"7.06157967 25.3639343 12.5129876 17.5280168 6.78460508 15.7734992 4.08597871 24.4528413\"></polyline><polygon id=\"Fill-8\" fill=\"#76A4D8\" points=\"0.21410886 13.8090481 18.1375292 19.297946 22.4099193 5.55773178 4.48649897 0.068510046\"></polygon></g><g id=\"Group-13\" transform=\"translate(28.364760, 14.127121)\"><mask id=\"mask-8\" fill=\"white\"><use xlink:href=\"#path-7\"></use></mask><g id=\"Clip-12\"></g><path d=\"M-5.1365099,3.58020031 C-5.85292473,5.88448197 -4.55189451,8.32571895 -2.2352908,9.03542605 C0.0822916146,9.74513314 2.54374422,8.45619886 3.26015906,6.15159344 C3.97494271,3.85313968 2.67326002,1.41190269 0.355677604,0.701871823 C-1.96059987,-0.00718772694 -4.42172624,1.28142278 -5.1365099,3.58020031\" id=\"Fill-11\" fill=\"#1977B9\" mask=\"url(#mask-8)\"></path></g><g id=\"Group-24\" transform=\"translate(0.000000, 0.204947)\"><g id=\"Group-16\"><mask id=\"mask-10\" fill=\"white\"><use xlink:href=\"#path-9\"></use></mask><g id=\"Clip-15\"></g><polygon id=\"Fill-14\" fill=\"#76A4D8\" mask=\"url(#mask-10)\" points=\"10.0011968 20.9320207 14.2735869 7.19148269 6.7016432 0.118694626 9.78708791e-05 21.6718385\"></polygon></g><polyline id=\"Fill-17\" fill=\"#E8EFF8\" points=\"27.0894196 15.0462436 26.0689526 18.3283152 14.8170639 14.8820915 15.8375309 11.6003437\"></polyline><polyline id=\"Fill-19\" fill=\"#144784\" points=\"27.0521308 15.270423 25.1185285 21.4884544 13.8372785 18.0334889 15.7705546 11.8154575\"></polyline><g id=\"Group-23\"><mask id=\"mask-12\" fill=\"white\"><use xlink:href=\"#path-11\"></use></mask><g id=\"Clip-22\"></g><polygon id=\"Fill-21\" fill=\"#144784\" mask=\"url(#mask-12)\" points=\"6.70157795 0.118629872 8.04730254 1.37486323 1.77802026 21.5377324 3.26236264e-05 21.6717738\"></polygon></g></g></g><g id=\"Group-65\" transform=\"translate(42.857143, 81.250000) rotate(6.000000) translate(-42.857143, -81.250000) translate(30.357143, 69.642857)\"><mask id=\"mask-14\" fill=\"white\"><use xlink:href=\"#path-13\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#FF9EF6\" mask=\"url(#mask-14)\" points=\"-1.88196203 25.2226438 26.7617089 25.2226438 26.7617089 -1.8094246 -1.88196203 -1.8094246\"></polygon></g><g id=\"Group-65-Copy\" transform=\"translate(75.446429, 58.482143) rotate(-70.000000) translate(-75.446429, -58.482143) translate(71.428571, 54.464286)\"><mask id=\"mask-16\" fill=\"white\"><use xlink:href=\"#path-15\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#FF9EF6\" mask=\"url(#mask-16)\" points=\"-0.592108545 8.43787865 8.41984922 8.43787865 8.41984922 -0.605317401 -0.592108545 -0.605317401\"></polygon></g><g id=\"Group-65-Copy-3\" transform=\"translate(73.660714, 64.732143) rotate(-91.000000) translate(-73.660714, -64.732143) translate(72.321429, 63.392857)\"><mask id=\"mask-18\" fill=\"white\"><use xlink:href=\"#path-17\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#FF9EF6\" mask=\"url(#mask-18)\" points=\"-0.19953587 2.9164082 2.83742222 2.9164082 2.83742222 -0.209217589 -0.19953587 -0.209217589\"></polygon></g><g id=\"Group-65-Copy-4\" transform=\"translate(79.017857, 52.232143) rotate(-46.000000) translate(-79.017857, -52.232143) translate(77.678571, 50.892857)\"><mask id=\"mask-20\" fill=\"white\"><use xlink:href=\"#path-19\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#FF9EF6\" mask=\"url(#mask-20)\" points=\"-0.19953587 2.9164082 2.83742222 2.9164082 2.83742222 -0.209217589 -0.19953587 -0.209217589\"></polygon></g><g id=\"calendat\" transform=\"translate(208.461799, 77.739630) rotate(3.000000) translate(-208.461799, -77.739630) translate(194.825436, 62.966903)\"><rect id=\"Rectangle-36\" fill-opacity=\"0.159999996\" fill=\"#000000\" x=\"0\" y=\"2.27272727\" width=\"27.2727273\" height=\"27.2727273\" rx=\"2\"></rect><rect id=\"Rectangle-36\" fill=\"#FFFFFF\" x=\"0\" y=\"2.27272727\" width=\"27.2727273\" height=\"27.2727273\" rx=\"2\"></rect><g id=\"Group-67\" transform=\"translate(1.136364, 9.090909)\"><g id=\"rowOne\"><g id=\"squaresRowOne\" fill=\"#F1F1F1\"><rect id=\"Rectangle-37\" x=\"0\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy\" x=\"5.08905852\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-2\" x=\"10.178117\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-3\" x=\"15.2671756\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-4\" x=\"20.3562341\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect></g><g id=\"rowOneX\" transform=\"translate(0.636132, 0.596051)\" fill=\"#CCCCCC\" fill-rule=\"nonzero\"><path d=\"M1.4115467,1.04162794 L2.46111148,0.0581931471 C2.54391985,-0.0193977157 2.67817875,-0.0193977157 2.76098712,0.0581931471 C2.8437955,0.13578401 2.8437955,0.261583654 2.76098712,0.339174517 L1.71142235,1.32260931 L2.76098712,2.30604411 C2.8437955,2.38363497 2.8437955,2.50943461 2.76098712,2.58702548 C2.67817875,2.66461634 2.54391985,2.66461634 2.46111148,2.58702548 L1.4115467,1.60359068 L0.36198193,2.58702548 C0.279173556,2.66461634 0.144914654,2.66461634 0.0621062805,2.58702548 C-0.0207020935,2.50943461 -0.0207020935,2.38363497 0.0621062805,2.30604411 L1.11167105,1.32260931 L0.0621062805,0.339174517 C-0.0207020935,0.261583654 -0.0207020935,0.13578401 0.0621062805,0.0581931471 C0.144914654,-0.0193977157 0.279173556,-0.0193977157 0.36198193,0.0581931471 L1.4115467,1.04162794 Z\" id=\"Combined-Shape\"></path><path d=\"M6.46734521,1.04162794 L7.51690998,0.0581931471 C7.59971835,-0.0193977157 7.73397726,-0.0193977157 7.81678563,0.0581931471 C7.899594,0.13578401 7.899594,0.261583654 7.81678563,0.339174517 L6.76722086,1.32260931 L7.81678563,2.30604411 C7.899594,2.38363497 7.899594,2.50943461 7.81678563,2.58702548 C7.73397726,2.66461634 7.59971835,2.66461634 7.51690998,2.58702548 L6.46734521,1.60359068 L5.41778044,2.58702548 C5.33497206,2.66461634 5.20071316,2.66461634 5.11790479,2.58702548 C5.03509641,2.50943461 5.03509641,2.38363497 5.11790479,2.30604411 L6.16746956,1.32260931 L5.11790479,0.339174517 C5.03509641,0.261583654 5.03509641,0.13578401 5.11790479,0.0581931471 C5.20071316,-0.0193977157 5.33497206,-0.0193977157 5.41778044,0.0581931471 L6.46734521,1.04162794 Z\" id=\"Combined-Shape-Copy-3\"></path><path d=\"M11.5564037,1.04162794 L12.6059685,0.0581931471 C12.6887769,-0.0193977157 12.8230358,-0.0193977157 12.9058442,0.0581931471 C12.9886525,0.13578401 12.9886525,0.261583654 12.9058442,0.339174517 L11.8562794,1.32260931 L12.9058442,2.30604411 C12.9886525,2.38363497 12.9886525,2.50943461 12.9058442,2.58702548 C12.8230358,2.66461634 12.6887769,2.66461634 12.6059685,2.58702548 L11.5564037,1.60359068 L10.506839,2.58702548 C10.4240306,2.66461634 10.2897717,2.66461634 10.2069633,2.58702548 C10.1241549,2.50943461 10.1241549,2.38363497 10.2069633,2.30604411 L11.2565281,1.32260931 L10.2069633,0.339174517 C10.1241549,0.261583654 10.1241549,0.13578401 10.2069633,0.0581931471 C10.2897717,-0.0193977157 10.4240306,-0.0193977157 10.506839,0.0581931471 L11.5564037,1.04162794 Z\" id=\"Combined-Shape-Copy-4\"></path><path d=\"M16.6454623,1.04162794 L17.695027,0.0581931471 C17.7778354,-0.0193977157 17.9120943,-0.0193977157 17.9949027,0.0581931471 C18.0777111,0.13578401 18.0777111,0.261583654 17.9949027,0.339174517 L16.9453379,1.32260931 L17.9949027,2.30604411 C18.0777111,2.38363497 18.0777111,2.50943461 17.9949027,2.58702548 C17.9120943,2.66461634 17.7778354,2.66461634 17.695027,2.58702548 L16.6454623,1.60359068 L15.5958975,2.58702548 C15.5130891,2.66461634 15.3788302,2.66461634 15.2960218,2.58702548 C15.2132135,2.50943461 15.2132135,2.38363497 15.2960218,2.30604411 L16.3455866,1.32260931 L15.2960218,0.339174517 C15.2132135,0.261583654 15.2132135,0.13578401 15.2960218,0.0581931471 C15.3788302,-0.0193977157 15.5130891,-0.0193977157 15.5958975,0.0581931471 L16.6454623,1.04162794 Z\" id=\"Combined-Shape-Copy-5\"></path><path d=\"M21.7345208,1.04162794 L22.7840856,0.0581931471 C22.8668939,-0.0193977157 23.0011528,-0.0193977157 23.0839612,0.0581931471 C23.1667696,0.13578401 23.1667696,0.261583654 23.0839612,0.339174517 L22.0343964,1.32260931 L23.0839612,2.30604411 C23.1667696,2.38363497 23.1667696,2.50943461 23.0839612,2.58702548 C23.0011528,2.66461634 22.8668939,2.66461634 22.7840856,2.58702548 L21.7345208,1.60359068 L20.684956,2.58702548 C20.6021476,2.66461634 20.4678887,2.66461634 20.3850804,2.58702548 C20.302272,2.50943461 20.302272,2.38363497 20.3850804,2.30604411 L21.4346451,1.32260931 L20.3850804,0.339174517 C20.302272,0.261583654 20.302272,0.13578401 20.3850804,0.0581931471 C20.4678887,-0.0193977157 20.6021476,-0.0193977157 20.684956,0.0581931471 L21.7345208,1.04162794 Z\" id=\"Combined-Shape-Copy-6\"></path></g></g><g id=\"rowTwo\" transform=\"translate(0.000000, 4.967096)\"><g id=\"squaresRowOne\" fill=\"#F1F1F1\"><rect id=\"Rectangle-37\" x=\"0\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy\" x=\"5.08905852\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-2\" x=\"10.178117\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-3\" x=\"15.2671756\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-4\" x=\"20.3562341\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect></g><g id=\"rowOneX\" transform=\"translate(0.636132, 0.596051)\" fill=\"#CCCCCC\" fill-rule=\"nonzero\"><path d=\"M1.4115467,1.04162794 L2.46111148,0.0581931471 C2.54391985,-0.0193977157 2.67817875,-0.0193977157 2.76098712,0.0581931471 C2.8437955,0.13578401 2.8437955,0.261583654 2.76098712,0.339174517 L1.71142235,1.32260931 L2.76098712,2.30604411 C2.8437955,2.38363497 2.8437955,2.50943461 2.76098712,2.58702548 C2.67817875,2.66461634 2.54391985,2.66461634 2.46111148,2.58702548 L1.4115467,1.60359068 L0.36198193,2.58702548 C0.279173556,2.66461634 0.144914654,2.66461634 0.0621062805,2.58702548 C-0.0207020935,2.50943461 -0.0207020935,2.38363497 0.0621062805,2.30604411 L1.11167105,1.32260931 L0.0621062805,0.339174517 C-0.0207020935,0.261583654 -0.0207020935,0.13578401 0.0621062805,0.0581931471 C0.144914654,-0.0193977157 0.279173556,-0.0193977157 0.36198193,0.0581931471 L1.4115467,1.04162794 Z\" id=\"Combined-Shape\"></path><path d=\"M6.46734521,1.04162794 L7.51690998,0.0581931471 C7.59971835,-0.0193977157 7.73397726,-0.0193977157 7.81678563,0.0581931471 C7.899594,0.13578401 7.899594,0.261583654 7.81678563,0.339174517 L6.76722086,1.32260931 L7.81678563,2.30604411 C7.899594,2.38363497 7.899594,2.50943461 7.81678563,2.58702548 C7.73397726,2.66461634 7.59971835,2.66461634 7.51690998,2.58702548 L6.46734521,1.60359068 L5.41778044,2.58702548 C5.33497206,2.66461634 5.20071316,2.66461634 5.11790479,2.58702548 C5.03509641,2.50943461 5.03509641,2.38363497 5.11790479,2.30604411 L6.16746956,1.32260931 L5.11790479,0.339174517 C5.03509641,0.261583654 5.03509641,0.13578401 5.11790479,0.0581931471 C5.20071316,-0.0193977157 5.33497206,-0.0193977157 5.41778044,0.0581931471 L6.46734521,1.04162794 Z\" id=\"Combined-Shape-Copy-3\"></path><path d=\"M11.5564037,1.04162794 L12.6059685,0.0581931471 C12.6887769,-0.0193977157 12.8230358,-0.0193977157 12.9058442,0.0581931471 C12.9886525,0.13578401 12.9886525,0.261583654 12.9058442,0.339174517 L11.8562794,1.32260931 L12.9058442,2.30604411 C12.9886525,2.38363497 12.9886525,2.50943461 12.9058442,2.58702548 C12.8230358,2.66461634 12.6887769,2.66461634 12.6059685,2.58702548 L11.5564037,1.60359068 L10.506839,2.58702548 C10.4240306,2.66461634 10.2897717,2.66461634 10.2069633,2.58702548 C10.1241549,2.50943461 10.1241549,2.38363497 10.2069633,2.30604411 L11.2565281,1.32260931 L10.2069633,0.339174517 C10.1241549,0.261583654 10.1241549,0.13578401 10.2069633,0.0581931471 C10.2897717,-0.0193977157 10.4240306,-0.0193977157 10.506839,0.0581931471 L11.5564037,1.04162794 Z\" id=\"Combined-Shape-Copy-4\"></path><path d=\"M16.6454623,1.04162794 L17.695027,0.0581931471 C17.7778354,-0.0193977157 17.9120943,-0.0193977157 17.9949027,0.0581931471 C18.0777111,0.13578401 18.0777111,0.261583654 17.9949027,0.339174517 L16.9453379,1.32260931 L17.9949027,2.30604411 C18.0777111,2.38363497 18.0777111,2.50943461 17.9949027,2.58702548 C17.9120943,2.66461634 17.7778354,2.66461634 17.695027,2.58702548 L16.6454623,1.60359068 L15.5958975,2.58702548 C15.5130891,2.66461634 15.3788302,2.66461634 15.2960218,2.58702548 C15.2132135,2.50943461 15.2132135,2.38363497 15.2960218,2.30604411 L16.3455866,1.32260931 L15.2960218,0.339174517 C15.2132135,0.261583654 15.2132135,0.13578401 15.2960218,0.0581931471 C15.3788302,-0.0193977157 15.5130891,-0.0193977157 15.5958975,0.0581931471 L16.6454623,1.04162794 Z\" id=\"Combined-Shape-Copy-5\"></path><path d=\"M21.7345208,1.04162794 L22.7840856,0.0581931471 C22.8668939,-0.0193977157 23.0011528,-0.0193977157 23.0839612,0.0581931471 C23.1667696,0.13578401 23.1667696,0.261583654 23.0839612,0.339174517 L22.0343964,1.32260931 L23.0839612,2.30604411 C23.1667696,2.38363497 23.1667696,2.50943461 23.0839612,2.58702548 C23.0011528,2.66461634 22.8668939,2.66461634 22.7840856,2.58702548 L21.7345208,1.60359068 L20.684956,2.58702548 C20.6021476,2.66461634 20.4678887,2.66461634 20.3850804,2.58702548 C20.302272,2.50943461 20.302272,2.38363497 20.3850804,2.30604411 L21.4346451,1.32260931 L20.3850804,0.339174517 C20.302272,0.261583654 20.302272,0.13578401 20.3850804,0.0581931471 C20.4678887,-0.0193977157 20.6021476,-0.0193977157 20.684956,0.0581931471 L21.7345208,1.04162794 Z\" id=\"Combined-Shape-Copy-6\"></path></g></g><g id=\"rowThree\" transform=\"translate(0.000000, 9.735508)\"><g id=\"squaresRowOne\" fill=\"#F1F1F1\"><rect id=\"Rectangle-37\" x=\"0\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy\" x=\"5.08905852\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-2\" x=\"10.178117\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-3\" x=\"15.2671756\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-4\" x=\"20.3562341\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect></g><g id=\"rowOneX\" transform=\"translate(0.636132, 0.596051)\" fill=\"#CCCCCC\" fill-rule=\"nonzero\"><path d=\"M1.4115467,1.04162794 L2.46111148,0.0581931471 C2.54391985,-0.0193977157 2.67817875,-0.0193977157 2.76098712,0.0581931471 C2.8437955,0.13578401 2.8437955,0.261583654 2.76098712,0.339174517 L1.71142235,1.32260931 L2.76098712,2.30604411 C2.8437955,2.38363497 2.8437955,2.50943461 2.76098712,2.58702548 C2.67817875,2.66461634 2.54391985,2.66461634 2.46111148,2.58702548 L1.4115467,1.60359068 L0.36198193,2.58702548 C0.279173556,2.66461634 0.144914654,2.66461634 0.0621062805,2.58702548 C-0.0207020935,2.50943461 -0.0207020935,2.38363497 0.0621062805,2.30604411 L1.11167105,1.32260931 L0.0621062805,0.339174517 C-0.0207020935,0.261583654 -0.0207020935,0.13578401 0.0621062805,0.0581931471 C0.144914654,-0.0193977157 0.279173556,-0.0193977157 0.36198193,0.0581931471 L1.4115467,1.04162794 Z\" id=\"Combined-Shape\"></path><path d=\"M6.46734521,1.04162794 L7.51690998,0.0581931471 C7.59971835,-0.0193977157 7.73397726,-0.0193977157 7.81678563,0.0581931471 C7.899594,0.13578401 7.899594,0.261583654 7.81678563,0.339174517 L6.76722086,1.32260931 L7.81678563,2.30604411 C7.899594,2.38363497 7.899594,2.50943461 7.81678563,2.58702548 C7.73397726,2.66461634 7.59971835,2.66461634 7.51690998,2.58702548 L6.46734521,1.60359068 L5.41778044,2.58702548 C5.33497206,2.66461634 5.20071316,2.66461634 5.11790479,2.58702548 C5.03509641,2.50943461 5.03509641,2.38363497 5.11790479,2.30604411 L6.16746956,1.32260931 L5.11790479,0.339174517 C5.03509641,0.261583654 5.03509641,0.13578401 5.11790479,0.0581931471 C5.20071316,-0.0193977157 5.33497206,-0.0193977157 5.41778044,0.0581931471 L6.46734521,1.04162794 Z\" id=\"Combined-Shape-Copy-3\"></path><path d=\"M11.5564037,1.04162794 L12.6059685,0.0581931471 C12.6887769,-0.0193977157 12.8230358,-0.0193977157 12.9058442,0.0581931471 C12.9886525,0.13578401 12.9886525,0.261583654 12.9058442,0.339174517 L11.8562794,1.32260931 L12.9058442,2.30604411 C12.9886525,2.38363497 12.9886525,2.50943461 12.9058442,2.58702548 C12.8230358,2.66461634 12.6887769,2.66461634 12.6059685,2.58702548 L11.5564037,1.60359068 L10.506839,2.58702548 C10.4240306,2.66461634 10.2897717,2.66461634 10.2069633,2.58702548 C10.1241549,2.50943461 10.1241549,2.38363497 10.2069633,2.30604411 L11.2565281,1.32260931 L10.2069633,0.339174517 C10.1241549,0.261583654 10.1241549,0.13578401 10.2069633,0.0581931471 C10.2897717,-0.0193977157 10.4240306,-0.0193977157 10.506839,0.0581931471 L11.5564037,1.04162794 Z\" id=\"Combined-Shape-Copy-4\"></path><path d=\"M16.6454623,1.04162794 L17.695027,0.0581931471 C17.7778354,-0.0193977157 17.9120943,-0.0193977157 17.9949027,0.0581931471 C18.0777111,0.13578401 18.0777111,0.261583654 17.9949027,0.339174517 L16.9453379,1.32260931 L17.9949027,2.30604411 C18.0777111,2.38363497 18.0777111,2.50943461 17.9949027,2.58702548 C17.9120943,2.66461634 17.7778354,2.66461634 17.695027,2.58702548 L16.6454623,1.60359068 L15.5958975,2.58702548 C15.5130891,2.66461634 15.3788302,2.66461634 15.2960218,2.58702548 C15.2132135,2.50943461 15.2132135,2.38363497 15.2960218,2.30604411 L16.3455866,1.32260931 L15.2960218,0.339174517 C15.2132135,0.261583654 15.2132135,0.13578401 15.2960218,0.0581931471 C15.3788302,-0.0193977157 15.5130891,-0.0193977157 15.5958975,0.0581931471 L16.6454623,1.04162794 Z\" id=\"Combined-Shape-Copy-5\"></path><path d=\"M21.7345208,1.04162794 L22.7840856,0.0581931471 C22.8668939,-0.0193977157 23.0011528,-0.0193977157 23.0839612,0.0581931471 C23.1667696,0.13578401 23.1667696,0.261583654 23.0839612,0.339174517 L22.0343964,1.32260931 L23.0839612,2.30604411 C23.1667696,2.38363497 23.1667696,2.50943461 23.0839612,2.58702548 C23.0011528,2.66461634 22.8668939,2.66461634 22.7840856,2.58702548 L21.7345208,1.60359068 L20.684956,2.58702548 C20.6021476,2.66461634 20.4678887,2.66461634 20.3850804,2.58702548 C20.302272,2.50943461 20.302272,2.38363497 20.3850804,2.30604411 L21.4346451,1.32260931 L20.3850804,0.339174517 C20.302272,0.261583654 20.302272,0.13578401 20.3850804,0.0581931471 C20.4678887,-0.0193977157 20.6021476,-0.0193977157 20.684956,0.0581931471 L21.7345208,1.04162794 Z\" id=\"Combined-Shape-Copy-6\"></path></g></g><g id=\"rowFour\" transform=\"translate(0.000000, 14.702604)\"><g id=\"squaresRowOne\" fill=\"#F1F1F1\"><rect id=\"Rectangle-37\" x=\"0\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy\" x=\"5.08905852\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-2\" x=\"10.178117\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-3\" x=\"15.2671756\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect><rect id=\"Rectangle-37-Copy-4\" x=\"20.3562341\" y=\"0\" width=\"4.028838\" height=\"3.77499281\"></rect></g><g id=\"rowOneX\" transform=\"translate(0.636132, 0.596051)\" fill=\"#CCCCCC\" fill-rule=\"nonzero\"><path d=\"M1.4115467,1.04162794 L2.46111148,0.0581931471 C2.54391985,-0.0193977157 2.67817875,-0.0193977157 2.76098712,0.0581931471 C2.8437955,0.13578401 2.8437955,0.261583654 2.76098712,0.339174517 L1.71142235,1.32260931 L2.76098712,2.30604411 C2.8437955,2.38363497 2.8437955,2.50943461 2.76098712,2.58702548 C2.67817875,2.66461634 2.54391985,2.66461634 2.46111148,2.58702548 L1.4115467,1.60359068 L0.36198193,2.58702548 C0.279173556,2.66461634 0.144914654,2.66461634 0.0621062805,2.58702548 C-0.0207020935,2.50943461 -0.0207020935,2.38363497 0.0621062805,2.30604411 L1.11167105,1.32260931 L0.0621062805,0.339174517 C-0.0207020935,0.261583654 -0.0207020935,0.13578401 0.0621062805,0.0581931471 C0.144914654,-0.0193977157 0.279173556,-0.0193977157 0.36198193,0.0581931471 L1.4115467,1.04162794 Z\" id=\"Combined-Shape\"></path><path d=\"M6.46734521,1.04162794 L7.51690998,0.0581931471 C7.59971835,-0.0193977157 7.73397726,-0.0193977157 7.81678563,0.0581931471 C7.899594,0.13578401 7.899594,0.261583654 7.81678563,0.339174517 L6.76722086,1.32260931 L7.81678563,2.30604411 C7.899594,2.38363497 7.899594,2.50943461 7.81678563,2.58702548 C7.73397726,2.66461634 7.59971835,2.66461634 7.51690998,2.58702548 L6.46734521,1.60359068 L5.41778044,2.58702548 C5.33497206,2.66461634 5.20071316,2.66461634 5.11790479,2.58702548 C5.03509641,2.50943461 5.03509641,2.38363497 5.11790479,2.30604411 L6.16746956,1.32260931 L5.11790479,0.339174517 C5.03509641,0.261583654 5.03509641,0.13578401 5.11790479,0.0581931471 C5.20071316,-0.0193977157 5.33497206,-0.0193977157 5.41778044,0.0581931471 L6.46734521,1.04162794 Z\" id=\"Combined-Shape-Copy-3\"></path><path d=\"M11.5564037,1.04162794 L12.6059685,0.0581931471 C12.6887769,-0.0193977157 12.8230358,-0.0193977157 12.9058442,0.0581931471 C12.9886525,0.13578401 12.9886525,0.261583654 12.9058442,0.339174517 L11.8562794,1.32260931 L12.9058442,2.30604411 C12.9886525,2.38363497 12.9886525,2.50943461 12.9058442,2.58702548 C12.8230358,2.66461634 12.6887769,2.66461634 12.6059685,2.58702548 L11.5564037,1.60359068 L10.506839,2.58702548 C10.4240306,2.66461634 10.2897717,2.66461634 10.2069633,2.58702548 C10.1241549,2.50943461 10.1241549,2.38363497 10.2069633,2.30604411 L11.2565281,1.32260931 L10.2069633,0.339174517 C10.1241549,0.261583654 10.1241549,0.13578401 10.2069633,0.0581931471 C10.2897717,-0.0193977157 10.4240306,-0.0193977157 10.506839,0.0581931471 L11.5564037,1.04162794 Z\" id=\"Combined-Shape-Copy-4\"></path></g></g></g><path d=\"M0,4.27966118 C0,3.17126219 0.891906887,2.27272727 2.00542875,2.27272727 L25.2672985,2.27272727 C26.3748662,2.27272727 27.2727273,3.17076282 27.2727273,4.27966118 L27.2727273,6.81818182 L0,6.81818182 L0,4.27966118 Z\" id=\"Rectangle-36\" fill=\"#00CF62\"></path><g id=\"Group-70\" transform=\"translate(4.545455, 0.000000)\"><ellipse id=\"Oval-17\" fill=\"#B2E2FE\" cx=\"1.68533756\" cy=\"4.47065593\" rx=\"1.68533756\" ry=\"1.570771\"></ellipse><path d=\"M0.0110977641,4.65189873 C0.0037672611,4.59243131 -1.3500312e-13,4.53195366 -1.3500312e-13,4.47065593 C-1.3500312e-13,3.60314306 0.754551329,2.89988493 1.68533756,2.89988493 C2.6161238,2.89988493 3.37067513,3.60314306 3.37067513,4.47065593 C3.37067513,4.53195366 3.36690787,4.59243131 3.35957736,4.65189873 C3.26316331,3.86975658 2.55035522,3.26237054 1.68533756,3.26237054 C0.820319902,3.26237054 0.107511816,3.86975658 0.0110977641,4.65189873 Z\" id=\"Combined-Shape\" fill=\"#078E60\"></path><ellipse id=\"Oval-17-Copy-2\" fill=\"#B2E2FE\" cx=\"16.4557784\" cy=\"4.47065593\" rx=\"1.68533756\" ry=\"1.570771\"></ellipse><rect id=\"Rectangle-38\" fill=\"#078E60\" x=\"0.210667195\" y=\"0\" width=\"2.94934074\" height=\"5.10500575\" rx=\"1.47467037\"></rect><rect id=\"Rectangle-38-Copy\" fill=\"#078E60\" x=\"14.9618216\" y=\"0\" width=\"2.94934074\" height=\"5.10500575\" rx=\"1.47467037\"></rect><path d=\"M14.7815386,4.65189873 C14.7742081,4.59243131 14.7704408,4.53195366 14.7704408,4.47065593 C14.7704408,3.60314306 15.5249922,2.89988493 16.4557784,2.89988493 C17.3865646,2.89988493 18.141116,3.60314306 18.141116,4.47065593 C18.141116,4.53195366 18.1373487,4.59243131 18.1300182,4.65189873 C18.0336041,3.86975658 17.3207961,3.26237054 16.4557784,3.26237054 C15.5907607,3.26237054 14.8779526,3.86975658 14.7815386,4.65189873 Z\" id=\"Combined-Shape-Copy-7\" fill=\"#078E60\"></path></g></g><g id=\"Group-65-Copy\" transform=\"translate(213.165598, 89.301961) rotate(2.000000) translate(-213.165598, -89.301961) translate(210.324688, 86.461052)\"><mask id=\"mask-22\" fill=\"white\"><use xlink:href=\"#path-21\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#FF9EF6\" mask=\"url(#mask-22)\" points=\"-0.371684122 4.98142688 5.28538946 4.98142688 5.28538946 -0.357358111 -0.371684122 -0.357358111\"></polygon></g></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/RecurringDonations/svg/supports-recurring-donations-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 167 128\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M9.59508359,3.15693643 C8.73223392,1.41047132 7.082934,0.219813712 5.17197218,0.219813712 C2.38229498,0.219813712 0.132051392,2.74390747 0.132051392,5.87173614 C0.132051392,7.44355474 0.656351559,8.72956533 1.62708795,9.88860589 L9.59508359,18.0016389 L17.208664,10.2381498 C18.3797963,8.92027129 19.0578717,7.6342607 19.0578717,5.87173614 C19.0732492,2.75996692 16.8076281,0.219813712 14.018195,0.219813712 C12.1072332,0.219813712 10.4581773,1.41047132 9.59508359,3.15693643 Z\" id=\"path-1\"></path><path d=\"M0.077874115,3.08586943 L0.077874115,17.8941879 L7.91351732,10.1494766 C9.11880766,8.83507847 9.81666021,7.55221987 9.81666021,5.79401522 C9.83248624,2.67385279 7.50078452,0.155695229 4.62999295,0.155695229 C2.66329473,0.155695229 0.96614144,1.34368487 0.077874115,3.08586943 Z\" id=\"path-3\"></path></defs><g id=\"CF-RegularPaymentsSelectedDT-Copy-29\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-611.000000, -157.000000)\"><g id=\"MODAL\" transform=\"translate(370.000000, 98.000000)\"><g id=\"XL---One-last-thing-MODAL\"><g id=\"Group-2\"><g id=\"MODAL\"><g id=\"Group-2\" transform=\"translate(241.000000, 59.000000)\"><ellipse id=\"Oval\" fill=\"#EECFF1\" fill-rule=\"nonzero\" cx=\"77.9444068\" cy=\"64.0054237\" rx=\"63.6854237\" ry=\"63.5552542\"></ellipse><path d=\"M16.283292,80.6508475 L139.290945,80.6508475 C131.992334,107.724911 107.221706,127.652881 77.7871186,127.652881 C48.3525308,127.652881 23.5819029,107.724911 16.283292,80.6508475 Z\" id=\"Combined-Shape\" fill=\"#88288F\" fill-rule=\"nonzero\"></path><rect id=\"Rectangle-path\" fill=\"#F9F0F7\" fill-rule=\"nonzero\" x=\"54.0691525\" y=\"36.2738983\" width=\"3.42779661\" height=\"3.42237288\"></rect><rect id=\"Rectangle-path\" fill=\"#FB9A7A\" fill-rule=\"nonzero\" x=\"63.9240678\" y=\"36.5342373\" width=\"3.2759322\" height=\"3.21084746\"></rect><rect id=\"Rectangle-path\" fill=\"#FB9A7A\" fill-rule=\"nonzero\" x=\"69.9444068\" y=\"64.8189831\" width=\"3.24881356\" height=\"3.20542373\"></rect><rect id=\"Rectangle-path\" fill=\"#FB9A7A\" fill-rule=\"nonzero\" x=\"78.2644068\" y=\"64.8189831\" width=\"3.24338983\" height=\"3.20542373\"></rect><rect id=\"Rectangle-path\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" x=\"39.5877966\" y=\"45.4888136\" width=\"75.080678\" height=\"55.739661\"></rect><path d=\"M39.7016949,39.4305085 L39.7016949,99.4061017 C39.3871186,105.274576 41.1715254,105.822373 45.1959322,106.039322 L113.486102,106.039322 C117.776271,106.039322 119.04,105.583729 118.974915,99.4061017 L118.974915,39.4305085 L39.7016949,39.4305085 Z M59.0589831,100.56678 L44.5830508,100.56678 L44.5830508,86.1125424 L59.0589831,86.1125424 L59.0589831,100.56678 Z M59.0589831,82.4569492 L44.5830508,82.4569492 L44.5830508,68.0081356 L59.0589831,68.0081356 L59.0589831,82.4569492 Z M59.0589831,64.4772881 L44.5830508,64.4772881 L44.5830508,50.0284746 L59.0589831,50.0284746 L59.0589831,64.4772881 Z M77.2067797,100.56678 L62.72,100.56678 L62.72,86.1125424 L77.2067797,86.1125424 L77.2067797,100.56678 Z M77.2067797,82.4569492 L62.72,82.4569492 L62.72,68.0081356 L77.2067797,68.0081356 L77.2067797,82.440678 L77.2067797,82.4569492 Z M77.2067797,64.4772881 L62.72,64.4772881 L62.72,50.0284746 L77.2067797,50.0284746 L77.2067797,64.4772881 Z M95.3437288,100.56678 L80.8623729,100.56678 L80.8623729,86.1125424 L95.3437288,86.1125424 L95.3437288,100.56678 Z M95.3437288,82.4569492 L80.8623729,82.4569492 L80.8623729,68.0081356 L95.3437288,68.0081356 L95.3437288,82.440678 L95.3437288,82.4569492 Z M95.3437288,64.4772881 L80.8623729,64.4772881 L80.8623729,50.0284746 L95.3437288,50.0284746 L95.3437288,64.4772881 Z M113.486102,100.56678 L99.0047458,100.56678 L99.0047458,86.1125424 L113.486102,86.1125424 L113.486102,100.56678 Z M113.486102,82.4569492 L99.0047458,82.4569492 L99.0047458,68.0081356 L113.486102,68.0081356 L113.486102,82.4569492 Z M113.486102,64.4772881 L99.0047458,64.4772881 L99.0047458,50.0284746 L113.486102,50.0284746 L113.486102,64.4772881 Z\" id=\"Shape\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path><path d=\"M60.8759322,40.6779661 C58.5821857,40.6875226 56.5571141,39.1827432 55.9044562,36.9837884 C55.2517984,34.7848337 56.1280385,32.4189344 58.0555932,31.1755932 L58.0555932,33.6271186 C58.0555932,35.5037288 59.319322,37.0386441 60.8759322,37.0386441 C62.4325424,37.0386441 63.6962712,35.5037288 63.6962712,33.6271186 L63.6962712,31.1864407 C65.6107581,32.4318856 66.4795608,34.7871407 65.8324668,36.9774975 C65.1853729,39.1678543 63.1761402,40.6728555 60.8922034,40.6779661 L60.8759322,40.6779661 Z M97.1552542,40.6779661 C94.8753136,40.6633478 92.8748486,39.1550889 92.2334761,36.9671711 C91.5921036,34.7792533 92.4616685,32.4296657 94.3728814,31.1864407 L94.3728814,33.6271186 C94.3728814,35.5037288 95.6311864,37.0386441 97.1932203,37.0386441 C98.7552542,37.0386441 100.013559,35.5037288 100.013559,33.6271186 L100.013559,31.1864407 C101.933989,32.4356983 102.801594,34.8010122 102.14443,36.9957401 C101.487266,39.190468 99.4624984,40.6897228 97.1715254,40.6779661 L97.1552542,40.6779661 Z\" id=\"Shape\" fill=\"#198D52\" fill-rule=\"nonzero\"></path><path d=\"M58.0718644,25.6759322 L45.1959322,25.6759322 C42.1640678,25.6759322 39.7016949,28.6481356 39.7016949,32.3091525 L39.7016949,41.9633898 L118.969492,41.9633898 L118.969492,32.3091525 C118.969492,28.6481356 116.517966,25.6759322 113.486102,25.6759322 L99.9918644,25.6759322 L58.0718644,25.6759322 Z M94.3566102,25.6759322 L63.7125424,25.6759322 L94.3566102,25.6759322 Z M60.8922034,38.1505085 C58.6018652,38.1563095 56.581417,36.6526474 55.9293906,34.4570736 C55.2773641,32.2614999 56.1496028,29.8987874 58.0718644,28.6535593 L58.0718644,31.0942373 C58.0718644,32.9762712 59.3355932,34.5111864 60.8922034,34.5111864 C62.4488136,34.5111864 63.7125424,32.9762712 63.7125424,31.0942373 L63.7125424,28.6535593 C65.6430238,29.89428 66.5216478,32.2611815 65.8683507,34.4610336 C65.2150537,36.6608857 63.1869689,38.1645727 60.8922034,38.1505085 Z M97.1715254,38.1505085 C94.8842087,38.1511054 92.869693,36.6452469 92.2227962,34.4513138 C91.5758993,32.2573807 92.4511504,29.8994539 94.3728814,28.6589831 L94.3728814,31.099661 C94.3728814,32.9816949 95.6311864,34.5166102 97.1932203,34.5166102 C98.7552542,34.5166102 100.013559,32.9816949 100.013559,31.099661 L100.013559,28.6589831 C101.93668,29.9047512 102.808755,32.2689074 102.155287,34.4651111 C101.501819,36.6613148 99.4791419,38.1641541 97.1877966,38.1559322 L97.1715254,38.1505085 Z\" id=\"Shape\" fill=\"#25CA76\" fill-rule=\"nonzero\"></path><rect id=\"Rectangle-path\" fill=\"#25CA76\" fill-rule=\"nonzero\" x=\"50.3972881\" y=\"27.5037288\" width=\"18.0176271\" height=\"12.5884746\"></rect><rect id=\"Rectangle-path\" fill=\"#25CA76\" fill-rule=\"nonzero\" x=\"86.4325424\" y=\"27.5037288\" width=\"18.0176271\" height=\"12.5884746\"></rect><g id=\"Group\" opacity=\"0.25\" transform=\"translate(96.000000, 22.779661)\" fill=\"#39435D\" fill-rule=\"nonzero\"><rect id=\"Rectangle-path\" x=\"0.0216949153\" y=\"0.0542372881\" width=\"7.6040678\" height=\"15.1755932\" rx=\"0.55\"></rect></g><rect id=\"Rectangle-path\" fill=\"#198D52\" fill-rule=\"nonzero\" x=\"96.0216949\" y=\"20.3064407\" width=\"7.6040678\" height=\"15.1755932\" rx=\"0.55\"></rect><g id=\"Group\" opacity=\"0.25\" transform=\"translate(55.322034, 22.779661)\" fill=\"#39435D\" fill-rule=\"nonzero\"><rect id=\"Rectangle-path\" x=\"0.13559322\" y=\"0.0542372881\" width=\"7.6040678\" height=\"15.1755932\" rx=\"0.55\"></rect></g><rect id=\"Rectangle-path\" fill=\"#198D52\" fill-rule=\"nonzero\" x=\"55.4576271\" y=\"20.3064407\" width=\"7.6040678\" height=\"15.1755932\" rx=\"0.55\"></rect><rect id=\"Rectangle-path\" fill=\"#E5E5E5\" fill-rule=\"nonzero\" x=\"60.1166102\" y=\"50.88\" width=\"2.99389831\" height=\"50.3484746\"></rect><rect id=\"Rectangle-path\" fill=\"#E5E5E5\" fill-rule=\"nonzero\" x=\"78.1342373\" y=\"50.88\" width=\"2.99389831\" height=\"50.3484746\"></rect><rect id=\"Rectangle-path\" fill=\"#E5E5E5\" fill-rule=\"nonzero\" x=\"96.1464407\" y=\"50.88\" width=\"2.40271186\" height=\"50.3484746\"></rect><rect id=\"Rectangle-path\" fill=\"#E5E5E5\" fill-rule=\"nonzero\" x=\"44.9898305\" y=\"65.2637288\" width=\"68.4691525\" height=\"2.99932203\"></rect><rect id=\"Rectangle-path\" fill=\"#E5E5E5\" fill-rule=\"nonzero\" x=\"44.9898305\" y=\"83.2488136\" width=\"68.4691525\" height=\"2.99932203\"></rect><path d=\"M133.749153,68.4528814 C133.751346,73.6787524 130.605046,78.3912703 125.7776,80.3926449 C120.950155,82.3940195 115.392434,81.2900363 111.69641,77.5955631 C108.000385,73.9010898 106.894068,68.3438338 108.893415,63.5155481 C110.892763,58.6872624 115.603959,55.5389835 120.829831,55.5389831 C124.255749,55.5375442 127.541843,56.8974765 129.964842,59.3194582 C132.387841,61.7414399 133.749153,65.0269626 133.749153,68.4528814\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M120.829831,55.5389831 C116.369128,55.537062 112.22327,57.837351 109.864162,61.623178 C107.505055,65.409005 107.266767,70.1442645 109.233898,74.1477966 C111.477954,78.5576186 116.001215,81.3406807 120.949153,81.3559322 L120.949153,79.6583051 L120.851525,79.6583051 C116.798228,79.7475828 113.014029,77.6362345 110.961169,74.1400997 C108.908309,70.643965 108.908309,66.3106113 110.961169,62.8144765 C113.014029,59.3183417 116.798228,57.2069935 120.851525,57.2962712 L120.949153,57.2962712 L120.949153,55.560678 L120.851525,55.560678\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M132.013559,68.4528814 C132.013559,62.2762785 127.006433,57.2691525 120.829831,57.2691525 C114.653228,57.2691525 109.646102,62.2762785 109.646102,68.4528814 C109.646102,74.6294842 114.653228,79.6366102 120.829831,79.6366102 C127.006433,79.6366102 132.013559,74.6294842 132.013559,68.4528814\" id=\"Shape\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M120.775593,59.3518644 C115.773204,59.3518644 111.717966,63.4071022 111.717966,68.4094915 C111.717966,73.4118809 115.773204,77.4671186 120.775593,77.4671186 C125.777983,77.4671186 129.83322,73.4118809 129.83322,68.4094915 C129.83322,66.0072595 128.878937,63.7034166 127.180303,62.004782 C125.481668,60.3061474 123.177825,59.3518644 120.775593,59.3518644\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M120.829831,57.2745763 C116.776533,57.1852985 112.992334,59.2966468 110.939474,62.7927816 C108.886614,66.2889164 108.886614,70.62227 110.939474,74.1184048 C112.992334,77.6145396 116.776533,79.7258879 120.829831,79.6366102 L120.949153,79.6366102 L120.949153,77.4671186 L120.797288,77.4671186 C115.794899,77.4671185 111.739661,73.4118807 111.739661,68.4094915 C111.739661,63.4071023 115.794899,59.3518646 120.797288,59.3518644 L120.949153,59.3518644 L120.949153,57.2745763 L120.851525,57.2745763\" id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><path d=\"M120.775593,59.3518644 C115.773204,59.3518644 111.717966,63.4071022 111.717966,68.4094915 C111.717966,73.4118809 115.773204,77.4671186 120.775593,77.4671186 L120.949153,77.4671186 L120.949153,59.3572881 L120.797288,59.3572881\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M127.951186,68.4094915 C127.951311,67.8971277 127.896765,67.3862131 127.788475,66.8854237 L122.88,66.8854237 L120.91661,68.8433898 L120.91661,69.7708475 L123.948475,69.7708475 C123.414727,70.959853 122.23076,71.7229483 120.927458,71.7179661 L120.927458,75.4332203 C124.80886,75.4332617 127.960391,72.2962762 127.978305,68.4149153\" id=\"Fill-24\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M120.949153,65.1172852 C121.587265,65.1217521 122.210564,65.3100611 122.744407,65.659661 L125.402034,63.0074432 C124.143553,61.9758955 122.565522,61.4140903 120.938305,61.4182588 L120.938305,65.1335565\" id=\"Fill-26\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M117.624407,68.4149153 C117.639109,66.6019207 119.103642,65.1349746 120.91661,65.1172881 L120.91661,61.4020339 C118.365625,61.3310705 115.977453,62.6514636 114.681034,64.8496126 C113.384615,67.0477616 113.384615,69.7766451 114.681034,71.9747942 C115.977453,74.1729432 118.365625,75.4933363 120.91661,75.4223729 L120.91661,71.7125424 C119.103642,71.6948559 117.639109,70.2279098 117.624407,68.4149153\" id=\"Fill-28\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><polygon id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\" points=\"120.91661 69.7708475 120.016271 69.7708475 120.91661 68.8433898\"></polygon><path d=\"M26.3701695,53.5267797 C26.3723634,58.7526507 23.226063,63.4651686 18.3986173,65.4665432 C13.5711715,67.4679178 8.01345145,66.3639346 4.31742656,62.6694614 C0.62140167,58.9749881 -0.484915131,53.4177321 1.51443224,48.5894464 C3.51377961,43.7611607 8.224976,40.6128818 13.4508475,40.6128814 C16.8767659,40.6114425 20.16286,41.9713748 22.5858589,44.3933565 C25.0088578,46.8153382 26.3701698,50.100861 26.3701695,53.5267797\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M13.4508475,40.6128814 C8.99014447,40.6109604 4.84428702,42.9112493 2.48517942,46.6970763 C0.12607183,50.4829033 -0.112216015,55.2181628 1.85491525,59.2216949 C4.10315791,63.6196363 8.62006558,66.3929925 13.559322,66.4081356 L13.559322,64.7105085 L13.4508475,64.7105085 C9.39754986,64.7997862 5.61335084,62.6884379 3.560491,59.1923031 C1.50763116,55.6961683 1.50763116,51.3628147 3.560491,47.8666799 C5.61335084,44.3705451 9.39754986,42.2591968 13.4508475,42.3484746 L13.559322,42.3484746 L13.559322,40.6128802 L13.4508475,40.6128814\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M24.6345763,53.5267797 C24.6345763,47.3501768 19.6274503,42.3430508 13.4508475,42.3430508 C7.27424459,42.3430508 2.26711864,47.3501768 2.26711864,53.5267797 C2.26711864,59.7033825 7.27424459,64.7105085 13.4508475,64.7105085 C16.4169568,64.7105085 19.2615819,63.5322261 21.3589379,61.4348701 C23.4562939,59.3375141 24.6345763,56.492889 24.6345763,53.5267797\" id=\"Shape\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M13.4020339,44.4257627 C9.73807293,44.4235687 6.4336692,46.6289971 5.03001154,50.0134262 C3.62635388,53.3978552 4.39994668,57.2945914 6.98998275,59.8861793 C9.58001882,62.4777672 13.4762909,63.253694 16.8615601,61.8520638 C20.2468293,60.4504336 22.4542366,57.1473515 22.4542373,53.4833898 C22.4542382,48.4831178 18.402305,44.4287569 13.4020339,44.4257627\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M13.4508475,42.3484746 C9.39754986,42.2591968 5.61335084,44.3705451 3.560491,47.8666799 C1.50763116,51.3628147 1.50763116,55.6961683 3.560491,59.1923031 C5.61335084,62.6884379 9.39754986,64.7997862 13.4508475,64.7105085 L13.559322,64.7105085 L13.559322,62.5410169 L13.4128814,62.5410169 C8.41049203,62.5410169 4.35525424,58.4857792 4.35525424,53.4833898 C4.35525424,48.4810005 8.41049203,44.4257627 13.4128814,44.4257627 L13.559322,44.4257627 L13.559322,42.3484746 L13.4508475,42.3484746\" id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><path d=\"M13.4020339,44.4257627 C8.39964457,44.4257627 4.34440678,48.4810005 4.34440678,53.4833898 C4.34440678,58.4857792 8.39964457,62.5410169 13.4020339,62.5410169 L13.559322,62.5410169 L13.559322,44.4311864 L13.4128814,44.4311864\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M20.5776271,53.4833898 C20.5777514,52.971026 20.5232053,52.4601114 20.4149153,51.959322 L15.5010169,51.959322 L13.559322,53.9172881 L13.559322,54.8447458 L16.5911864,54.8447458 C16.052543,56.0345161 14.8653328,56.7969641 13.559322,56.7918644 L13.559322,60.5071186 C17.4407243,60.50716 20.5922553,57.3701745 20.6101695,53.4888136\" id=\"Fill-24-2\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M13.559322,50.1911864 C14.1974341,50.1956533 14.8207335,50.3839613 15.3545763,50.7335593 L18.0122034,48.0813559 C16.7588245,47.0463257 15.1848182,46.4788399 13.559322,46.4759322 L13.559322,50.1911864\" id=\"Fill-26-2\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M10.2454237,53.4888136 C10.2602711,51.6674272 11.7378847,50.1970687 13.559322,50.1911864 L13.559322,46.4759322 C11.0083369,46.4049688 8.6201645,47.7253619 7.3237456,49.9235109 C6.02732669,52.1216599 6.02732669,54.8505434 7.3237456,57.0486925 C8.6201645,59.2468415 11.0083369,60.5672346 13.559322,60.4962712 L13.559322,56.7864407 C11.7442358,56.7716951 10.2764405,55.3038998 10.2616949,53.4888136\" id=\"Fill-28-2\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><polygon id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\" points=\"13.5430508 54.8501695 12.6372881 54.8501695 13.5430508 53.9172881\"></polygon><path d=\"M150.101695,42.0501695 C150.101694,45.9598248 147.746285,49.4844081 144.134024,50.9800612 C140.521764,52.4757143 136.364213,51.6478161 133.600445,48.8824965 C130.836678,46.117177 130.011113,41.9591624 131.508794,38.347742 C133.006474,34.7363215 136.532379,32.3828908 140.442034,32.3850847 C143.004875,32.3850843 145.46267,33.4035402 147.274364,35.2162513 C149.086058,37.0289623 150.103134,39.4873285 150.101695,42.0501695\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M140.442034,32.3850847 C137.10497,32.3846745 134.003761,34.1057497 132.238594,36.9377411 C130.473426,39.7697325 130.294037,43.3119657 131.764068,46.3077966 C133.4466,49.5935751 136.821065,51.6667894 140.512542,51.6827119 L140.512542,50.440678 L140.442034,50.440678 C135.823061,50.440678 132.078644,46.6962608 132.078644,42.0772881 C132.078644,37.4583155 135.823061,33.7138983 140.442034,33.7138983 L140.512542,33.7138983 L140.512542,32.4122034 L140.442034,32.4122034\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M148.805424,42.0501695 C148.793446,37.4303388 145.040213,33.6940907 140.420375,33.7030684 C135.800538,33.7120461 132.061854,37.462853 132.067832,42.0826954 C132.07381,46.7025378 135.822189,50.4436565 140.442034,50.440678 C145.061007,50.440678 148.805424,46.6962608 148.805424,42.0772881\" id=\"Shape\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M140.398644,35.2542373 C137.658721,35.2542373 135.188588,36.9047272 134.140065,39.4360862 C133.091542,41.9674452 133.671117,44.8811654 135.608535,46.8185837 C137.545953,48.756002 140.459673,49.335577 142.991032,48.2870538 C145.522391,47.2385305 147.172881,44.7683978 147.172881,42.0284746 C147.172881,38.2871666 144.139952,35.2542373 140.398644,35.2542373\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M140.442034,33.6867797 C135.823061,33.6867797 132.078644,37.4311968 132.078644,42.0501695 C132.078644,46.6691422 135.823061,50.4135593 140.442034,50.4135593 L140.512542,50.4135593 L140.512542,48.8135593 L140.398644,48.8135593 C136.654341,48.8135593 133.618983,45.7782017 133.618983,42.0338983 C133.618983,38.2895949 136.654341,35.2542373 140.398644,35.2542373 L140.512542,35.2542373 L140.512542,33.6867797 L140.442034,33.6867797\" id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><path d=\"M140.398644,35.2542373 C136.654341,35.2542373 133.618983,38.2895949 133.618983,42.0338983 C133.618983,45.7782017 136.654341,48.8135593 140.398644,48.8135593 L140.512542,48.8135593 L140.512542,35.2542373 L140.398644,35.2542373\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M145.768136,42.0122034 C145.766587,41.6295054 145.726612,41.2479302 145.648814,40.8732203 L141.971525,40.8732203 L140.507119,42.3376271 L140.507119,43.0318644 L142.774237,43.0318644 C142.369295,43.9153821 141.484424,44.4798319 140.512542,44.4745763 L140.512542,47.2515254 C143.413891,47.2515316 145.767577,44.9026983 145.773559,42.0013559\" id=\"Fill-24-3\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M140.512542,39.5498305 C140.989799,39.5486665 141.45711,39.6862216 141.857627,39.9457627 L143.842712,37.9661017 C142.903058,37.1938777 141.723366,36.7737923 140.507119,36.7783051 L140.507119,39.5552542\" id=\"Fill-26-3\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M138.039322,42.0176271 C138.051106,40.6596117 139.149103,39.5616144 140.507119,39.5498305 L140.507119,36.7728814 C137.610526,36.7728814 135.262373,39.121034 135.262373,42.0176271 C135.262373,44.9142202 137.610526,47.2623729 140.507119,47.2623729 L140.507119,44.4745763 C139.149103,44.4627924 138.051106,43.3647951 138.039322,42.0067797\" id=\"Fill-28-3\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><polygon id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\" points=\"140.507119 43.0318644 139.829153 43.0318644 140.507119 42.3376271\"></polygon><path d=\"M166.578983,61.4020339 C166.578983,66.0210066 162.834566,69.7654237 158.215593,69.7654237 C153.596621,69.7654237 149.852203,66.0210066 149.852203,61.4020339 C149.852203,56.7830612 153.596621,53.0386441 158.215593,53.0386441 C160.434143,53.0372039 162.562241,53.9178818 164.130993,55.4866339 C165.699745,57.055386 166.580423,59.1834838 166.578983,61.4020339\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M158.215593,53.0386441 C155.330108,53.0424969 152.650139,54.5325472 151.124106,56.9814779 C149.598072,59.4304086 149.441256,62.4927432 150.709153,65.0847458 C152.168008,67.9357403 155.099808,69.7304207 158.302373,69.7328814 L158.302373,68.6481356 L158.237288,68.6481356 C154.317016,68.5408114 151.194762,65.3319103 151.194762,61.4101695 C151.194762,57.4884287 154.317016,54.2795276 158.237288,54.1722034 L158.302373,54.1722034 L158.302373,53.0386441 L158.237288,53.0386441\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M165.456271,61.4020339 C165.458465,58.4729605 163.695722,55.8310824 160.990241,54.7086539 C158.284759,53.5862254 155.169526,54.2043676 153.097581,56.2747597 C151.025637,58.3451519 150.405161,61.4599216 151.525562,64.1662435 C152.645963,66.8725653 155.286519,68.6372873 158.215593,68.6372881 C162.212392,68.6372893 165.453277,65.3988317 165.456271,61.4020339\" id=\"Shape\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M158.183051,55.5118644 C155.811175,55.5118654 153.672951,56.9409395 152.765781,59.1324773 C151.858611,61.3240152 152.361224,63.8462429 154.039169,65.5226363 C155.717115,67.1990296 158.239807,67.6993077 160.430504,66.7901097 C162.621201,65.8809117 164.048296,63.7413666 164.046102,61.3694915 C164.046102,59.815012 163.428217,58.3242791 162.328525,57.2256049 C161.228834,56.1269307 159.73753,55.5104251 158.183051,55.5118644\" id=\"Shape\" fill=\"#FFBB72\" fill-rule=\"nonzero\"></path><path d=\"M158.215593,54.1613559 C154.295321,54.2686801 151.173067,57.4775812 151.173067,61.399322 C151.173067,65.3210628 154.295321,68.529964 158.215593,68.6372881 L158.280678,68.6372881 L158.280678,67.2542373 L158.183051,67.2542373 C156.04684,67.3192326 154.044488,66.2166913 152.957178,64.376752 C151.869869,62.5368126 151.869869,60.250984 152.957178,58.4110446 C154.044488,56.5711053 156.04684,55.468564 158.183051,55.5335593 L158.280678,55.5335593 L158.280678,54.1830508 L158.215593,54.1830508\" id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><path d=\"M158.183051,55.5118644 C156.04684,55.4468691 154.044488,56.5494103 152.957178,58.3893497 C151.869869,60.2292891 151.869869,62.5151177 152.957178,64.3550571 C154.044488,66.1949964 156.04684,67.2975377 158.183051,67.2325424 L158.280678,67.2325424 L158.280678,55.5118644 L158.183051,55.5118644\" id=\"Shape\" fill=\"#FFC58E\" fill-rule=\"nonzero\"></path><path d=\"M162.825763,61.3694915 C162.826657,61.0377214 162.792111,60.7068047 162.722712,60.3823729 L159.544407,60.3823729 L158.275254,61.6515254 L158.275254,62.2535593 L160.238644,62.2535593 C159.885241,63.0172113 159.122129,63.5076319 158.280678,63.5118644 L158.280678,65.9145763 C160.789624,65.9145834 162.825206,63.8838545 162.831186,61.3749153\" id=\"Fill-24-4\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M158.280678,59.2379637 C158.692588,59.2364205 159.095986,59.3551788 159.441356,59.579661 L161.160678,57.8657508 C160.348261,57.1966419 159.327733,56.8321652 158.275254,56.835216 L158.275254,59.2379637\" id=\"Fill-26-4\" fill=\"#FF9710\" fill-rule=\"nonzero\"></path><path d=\"M156.143729,61.3749153 C156.161116,60.2040919 157.104479,59.2583287 158.275254,59.2379661 L158.275254,56.8352542 C156.616947,56.7779091 155.059467,57.6298857 154.213316,59.0572252 C153.367165,60.4845648 153.367165,62.259842 154.213316,63.6871815 C155.059467,65.1145211 156.616947,65.9664977 158.275254,65.9091525 L158.275254,63.5064407 C157.106548,63.4861612 156.164008,62.5436211 156.143729,61.3749153\" id=\"Fill-28-4\" fill=\"#FFA840\" fill-rule=\"nonzero\"></path><polygon id=\"Shape\" fill=\"#FFA840\" fill-rule=\"nonzero\" points=\"158.275254 62.2535593 157.689492 62.2535593 158.275254 61.6515254\"></polygon><g id=\"Group-13\" transform=\"translate(78.644068, 66.711864)\"><g id=\"Group-65\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-64\"></g><polygon id=\"Fill-63\" fill=\"#F7414B\" mask=\"url(#mask-2)\" points=\"-1.45158896 19.6299165 20.6417561 19.6299165 20.6417561 -1.40821296 -1.45158896 -1.40821296\"></polygon></g><g id=\"Group-68\" transform=\"translate(9.762712, 0.000000)\"><mask id=\"mask-4\" fill=\"white\"><use xlink:href=\"#path-3\"></use></mask><g id=\"Clip-67\"></g><polygon id=\"Fill-66\" fill-opacity=\"0.2\" fill=\"#FFFFFF\" mask=\"url(#mask-4)\" points=\"-11.2909931 19.5184746 11.4467413 19.5184746 11.4467413 -1.46834118 -11.2909931 -1.46834118\"></polygon></g></g></g></g></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/ReminderModal/AddToCalendarButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"reminder":"_1t1zD"};

/***/ }),

/***/ "./src/components/ReminderModal/AddToCalendarButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddToCalendarButton_scss__ = __webpack_require__("./src/components/ReminderModal/AddToCalendarButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddToCalendarButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddToCalendarButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__ = __webpack_require__("./src/components/ReminderModal/helpers/addToCalendar.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_apple_calendar_icon_svg__ = __webpack_require__("./src/components/ReminderModal/images/apple-calendar-icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_apple_calendar_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_apple_calendar_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_google_calendar_icon_svg__ = __webpack_require__("./src/components/ReminderModal/images/google-calendar-icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_google_calendar_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_google_calendar_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_outlook_calendar_icon_svg__ = __webpack_require__("./src/components/ReminderModal/images/outlook-calendar-icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_outlook_calendar_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_outlook_calendar_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_outlook_web_calendar_icon_svg__ = __webpack_require__("./src/components/ReminderModal/images/outlook-web-calendar-icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_outlook_web_calendar_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_outlook_web_calendar_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_yahoo_calendar_icon_svg__ = __webpack_require__("./src/components/ReminderModal/images/yahoo-calendar-icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_yahoo_calendar_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_yahoo_calendar_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");














var AddToCalendarButton = function (_a) {
    var pageSection = _a.pageSection, ownerName = _a.ownerName, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor, isActive = _a.isActive, calendarType = _a.calendarType, startTime = _a.startTime, endTime = _a.endTime, buttonText = _a.buttonText, classNames = _a.classNames, socialShareUrl = _a.socialShareUrl;
    var handleButtonClick = function () {
        var currentDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
        var firstDayOfMonth = currentDate.date() >= 28
            ? currentDate.startOf('month').add('1', 'month')
            : currentDate.startOf('month');
        var defaultReminderDate = firstDayOfMonth
            .add('27', 'days')
            .hour(12)
            .minute(0)
            .second(0);
        var targetAmountFormatted = "" + (__WEBPACK_IMPORTED_MODULE_12__helpers_currencyMap__["e" /* default */][targetCurrency] ||
            '£') + targetAmount;
        var shareHash = Object(__WEBPACK_IMPORTED_MODULE_13__helpers_hashId__["a" /* generateHash */])();
        var url = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_url__["a" /* buildUrl */])(socialShareUrl, {
            utm_source: calendarType.toLowerCase() + "-reminder",
            utm_term: shareHash,
        });
        var doubleLineSpacing = calendarType === __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Apple ||
            calendarType === __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Outlook
            ? '\\n\\n'
            : '\n\n';
        var event = {
            startTime: startTime || defaultReminderDate.toDate(),
            endTime: endTime || defaultReminderDate.add('2', 'hours').toDate(),
            location: 'JustGiving',
            title: "Donate to " + ownerName + " \uD83C\uDF97\uFE0F",
            description: "Reminder to donate to " + ownerName + " who is raising " + targetAmountFormatted + " to " + pitchFor + "." + doubleLineSpacing + url,
        };
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["b" /* addToCalendarHandler */])(event, calendarType);
    };
    var getCalendarIcon = function () {
        switch (calendarType) {
            case __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Apple:
                return __WEBPACK_IMPORTED_MODULE_7__images_apple_calendar_icon_svg___default.a;
            case __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Google:
                return __WEBPACK_IMPORTED_MODULE_8__images_google_calendar_icon_svg___default.a;
            case __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Outlook:
                return __WEBPACK_IMPORTED_MODULE_9__images_outlook_calendar_icon_svg___default.a;
            case __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].OutlookWeb:
                return __WEBPACK_IMPORTED_MODULE_10__images_outlook_web_calendar_icon_svg___default.a;
            case __WEBPACK_IMPORTED_MODULE_5__helpers_addToCalendar__["a" /* CalendarType */].Yahoo:
                return __WEBPACK_IMPORTED_MODULE_11__images_yahoo_calendar_icon_svg___default.a;
            default:
                return '';
        }
    };
    var label = buttonText || calendarType;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Analytics__["c" /* Button */], { type: "button", onClick: handleButtonClick, className: __WEBPACK_IMPORTED_MODULE_3__AddToCalendarButton_scss___default.a.reminder + " " + (classNames || ''), isDisabled: !isActive, analyticsOptions: {
            event: 'click',
            eventValue: "add " + calendarType.toLowerCase() + " reminder",
            pageSection: pageSection,
            subtype: 'button',
        } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: getCalendarIcon(), alt: label + " logo" }),
        label));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(AddToCalendarButton, __WEBPACK_IMPORTED_MODULE_3__AddToCalendarButton_scss___default.a));


/***/ }),

/***/ "./src/components/ReminderModal/ReminderModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"SZOeq","modal-background":"AVzuL","title":"_3iRYG","description":"_1HSEf","button-container":"_1MEvR","close":"_9GvDt"};

/***/ }),

/***/ "./src/components/ReminderModal/ReminderModal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss__ = __webpack_require__("./src/components/ReminderModal/ReminderModal.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_close_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/close.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__ = __webpack_require__("./src/components/ReminderModal/AddToCalendarButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__ = __webpack_require__("./src/components/ReminderModal/helpers/addToCalendar.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var ReminderModal = /** @class */ (function (_super) {
    __extends(ReminderModal, _super);
    function ReminderModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReminderModal.prototype.render = function () {
        var _a = this.props, showModal = _a.showModal, pageSection = _a.pageSection, handleModalClose = _a.handleModalClose, pitchFor = _a.pitchFor, ownerName = _a.ownerName, socialShareUrl = _a.socialShareUrl, targetCurrency = _a.targetCurrency, targetAmount = _a.targetAmount, isActive = _a.isActive;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */], { isOpen: showModal, shouldCloseOnOverlayClick: false, classNames: __WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss___default.a.modal },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Analytics__["b" /* AnalyticsPageView */], { eventValue: "reminder modal", pageSection: pageSection, subtype: "cfp" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ClickableElement__["a" /* default */], { onClick: handleModalClose, inline: true, className: __WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss___default.a.close, analyticsOptions: {
                            event: 'click',
                            eventValue: 'close reminder modal',
                            pageSection: pageSection,
                            subtype: 'button',
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_close_svg___default.a, className: "jg-icon--medium jg-fill--nobel" }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-mhn" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "description" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2", styleName: "title" }, "Add a reminder"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Don't worry if you're not ready to donate right now, we can remind you before the fundraising ends"))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "button-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__["a" /* default */], { pageSection: pageSection, ownerName: ownerName, isActive: isActive, calendarType: __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__["a" /* CalendarType */].Apple, pitchFor: pitchFor, targetCurrency: targetCurrency, socialShareUrl: socialShareUrl, targetAmount: targetAmount }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__["a" /* default */], { pageSection: pageSection, ownerName: ownerName, isActive: isActive, calendarType: __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__["a" /* CalendarType */].Google, pitchFor: pitchFor, targetCurrency: targetCurrency, socialShareUrl: socialShareUrl, targetAmount: targetAmount }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__["a" /* default */], { pageSection: pageSection, ownerName: ownerName, isActive: isActive, calendarType: __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__["a" /* CalendarType */].Outlook, pitchFor: pitchFor, targetCurrency: targetCurrency, socialShareUrl: socialShareUrl, targetAmount: targetAmount }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__["a" /* default */], { pageSection: pageSection, ownerName: ownerName, isActive: isActive, calendarType: __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__["a" /* CalendarType */].OutlookWeb, buttonText: "Outlook Web", pitchFor: pitchFor, targetCurrency: targetCurrency, socialShareUrl: socialShareUrl, targetAmount: targetAmount }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddToCalendarButton__["a" /* default */], { pageSection: pageSection, ownerName: ownerName, isActive: isActive, calendarType: __WEBPACK_IMPORTED_MODULE_9__helpers_addToCalendar__["a" /* CalendarType */].Yahoo, pitchFor: pitchFor, targetCurrency: targetCurrency, socialShareUrl: socialShareUrl, targetAmount: targetAmount })))));
    };
    return ReminderModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(ReminderModal, __WEBPACK_IMPORTED_MODULE_4__ReminderModal_scss___default.a));


/***/ }),

/***/ "./src/components/ReminderModal/helpers/addToCalendar.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addToCalendarHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");


var CalendarType;
(function (CalendarType) {
    CalendarType["Google"] = "Google";
    CalendarType["Apple"] = "Apple";
    CalendarType["Outlook"] = "Outlook";
    CalendarType["OutlookWeb"] = "Outlook-Web";
    CalendarType["Yahoo"] = "Yahoo";
})(CalendarType || (CalendarType = {}));
var isMobile = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["h" /* isMobileUserAgent */])();
function formatTime(date) {
    var formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(date).format('YYYYMMDDTHHmmssZ');
    return formattedDate.replace('+00:00', 'Z');
}
function calculateDuration(startTime, endTime) {
    var end = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(endTime).format('DD/MM/YYYY HH:mm:ss');
    var start = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(startTime).format('DD/MM/YYYY HH:mm:ss');
    var difference = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end, 'DD/MM/YYYY HH:mm:ss').diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start, 'DD/MM/YYYY HH:mm:ss'));
    var duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(difference);
    var zeroSuffixedHours = ('0' + Math.floor(duration.asHours())).slice(-2);
    var minutes = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(difference).format('mm');
    return zeroSuffixedHours + minutes;
}
function getRandomKey() {
    var rand = Math.floor(Math.random() * 999999999999).toString();
    return new Date().getTime().toString() + '_' + rand;
}
function buildEventUrl(event, type) {
    var calendarUrl = '';
    var formattedStartTime = formatTime(event.startTime);
    var formattedEndTime = formatTime(event.endTime);
    var encodedLocation = encodeURIComponent(event.location);
    var encodedTitle = encodeURIComponent(event.title);
    var encodedDescription = encodeURIComponent(event.description);
    switch (type) {
        case CalendarType.Google:
            calendarUrl = "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" + formattedStartTime + "/" + formattedEndTime + "&location=" + encodedLocation + "&text=" + encodedTitle + "&details=" + encodedDescription;
            break;
        case CalendarType.Yahoo:
            var duration = calculateDuration(event.startTime, event.endTime);
            calendarUrl = "https://calendar.yahoo.com/?v=60&view=d&type=20&title=" + encodedTitle + "&st=" + formattedStartTime + "&dur=" + duration + "&desc=" + encodedDescription + "&in_loc=" + encodedLocation;
            break;
        case CalendarType.OutlookWeb:
            calendarUrl = "https://outlook.live.com/owa/?rru=addevent&startdt=" + formattedStartTime + "&enddt=" + formattedEndTime + "&subject=" + encodedTitle + "&location=" + encodedLocation + "&body=" + encodedDescription + "&allday=false&uid=" + getRandomKey() + "&path=/calendar/view/Month";
            break;
        default:
            calendarUrl = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'BEGIN:VEVENT',
                'URL:' + document.URL,
                'DTSTART:' + formatTime(event.startTime),
                'DTEND:' + formatTime(event.endTime),
                'SUMMARY:' + event.title,
                'DESCRIPTION:' + event.description,
                'LOCATION:' + event.location,
                'END:VEVENT',
                'END:VCALENDAR',
            ].join('\n');
            if (Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["h" /* isMobileUserAgent */])()) {
                calendarUrl = encodeURI('data:text/calendar;charset=utf8,' + calendarUrl);
            }
    }
    return calendarUrl;
}
function addToCalendarHandler(event, type) {
    var isOldIE = false;
    if (typeof window !== 'undefined' &&
        window.navigator.msSaveOrOpenBlob &&
        window.Blob) {
        isOldIE = true;
    }
    var url = buildEventUrl(event, type);
    if (!isMobile && (url.startsWith('data') || url.startsWith('BEGIN'))) {
        var filename = 'reminder.ics';
        var blob = new Blob([url], { type: 'text/calendar;charset=utf-8' });
        if (isOldIE) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    else {
        window.open(url, '_blank');
    }
}


/***/ }),

/***/ "./src/components/ReminderModal/images/apple-calendar-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAwIDExODcuMTk4Ij4KICAgIDxwYXRoIGQ9Ik05NzkuMDQyIDkyNS4xODhjLTE3Ljk1NCA0MS40NzctMzkuMjA2IDc5LjY1Ny02My44MjggMTE0Ljc1OS0zMy41NjMgNDcuODUzLTYxLjA0NCA4MC45NzYtODIuMjIyIDk5LjM3LTMyLjgzIDMwLjE5Mi02OC4wMDYgNDUuNjU0LTEwNS42NzIgNDYuNTMzLTI3LjA0MSAwLTU5LjY1Mi03LjY5NC05Ny42MTEtMjMuMzAzLTM4LjA4NS0xNS41MzYtNzMuMDg0LTIzLjIzLTEwNS4wODYtMjMuMjMtMzMuNTYzIDAtNjkuNTYgNy42OTQtMTA4LjA2MSAyMy4yMy0zOC41NjEgMTUuNjA5LTY5LjYyNSAyMy43NDMtOTMuMzc2IDI0LjU1LTM2LjEyIDEuNTM4LTcyLjEyMy0xNC4zNjQtMTA4LjA2LTQ3Ljc4LTIyLjkzOC0yMC4wMDYtNTEuNjI3LTU0LjMwMi04NS45OTctMTAyLjg4OC0zNi44NzUtNTEuODgzLTY3LjE5MS0xMTIuMDQ3LTkwLjk0Mi0xODAuNjM5QzEyLjc1MSA3ODEuNzAzIDAgNzA5Ljk2IDAgNjQwLjUwNGMwLTc5LjU2MiAxNy4xOTItMTQ4LjE4MyA1MS42MjctMjA1LjY4NyAyNy4wNjMtNDYuMTkgNjMuMDY2LTgyLjYyNSAxMDguMTI3LTEwOS4zNzMgNDUuMDYtMjYuNzQ4IDkzLjc0OS00MC4zNzggMTQ2LjE4Mi00MS4yNSAyOC42OSAwIDY2LjMxMiA4Ljg3NCAxMTMuMDY2IDI2LjMxNSA0Ni42MjIgMTcuNSA3Ni41NTcgMjYuMzc0IDg5LjY4MiAyNi4zNzQgOS44MTIgMCA0My4wNjgtMTAuMzc2IDk5LjQ0My0zMS4wNjQgNTMuMzEzLTE5LjE4NSA5OC4zMDctMjcuMTI5IDEzNS4xNjgtMjQgOTkuODgzIDguMDYyIDE3NC45MjMgNDcuNDM2IDIyNC44MjggMTE4LjM3Mi04OS4zMyA1NC4xMjYtMTMzLjUyIDEyOS45MzYtMTMyLjY0IDIyNy4xODguODA2IDc1Ljc1MSAyOC4yODcgMTM4Ljc4OCA4Mi4yOTUgMTg4Ljg0IDI0LjQ3NiAyMy4yMyA1MS44MSA0MS4xODMgODIuMjIyIDUzLjkzNC02LjU5NSAxOS4xMjctMTMuNTU3IDM3LjQ0Ny0yMC45NTggNTUuMDM1ek03NDkuOTY0IDIzLjc1YzAgNTkuMzc0LTIxLjY5MiAxMTQuODEtNjQuOTI4IDE2Ni4xMjItNTIuMTc2IDYxLTExNS4yODYgOTYuMjQ4LTE4My43MjQgOTAuNjg2YTE4NC44MzYgMTg0LjgzNiAwIDAxLTEuMzc4LTIyLjQ5N2MwLTU2Ljk5OSAyNC44MTMtMTE3Ljk5OCA2OC44NzgtMTY3Ljg3NCAyMS45OTktMjUuMjUzIDQ5Ljk3OC00Ni4yNSA4My45MDctNjMgMzMuODU2LTE2LjUgNjUuODgtMjUuNjI1IDk1Ljk5OS0yNy4xODcuODggNy45MzcgMS4yNDYgMTUuODc1IDEuMjQ2IDIzLjc1eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/ReminderModal/images/google-calendar-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MzMuNSA1NDQuMyI+CiAgICA8cGF0aCBkPSJNNTMzLjUgMjc4LjRjMC0xOC41LTEuNS0zNy4xLTQuNy01NS4zSDI3Mi4xdjEwNC44aDE0N2MtNi4xIDMzLjgtMjUuNyA2My43LTU0LjQgODIuN3Y2OGg4Ny43YzUxLjUtNDcuNCA4MS4xLTExNy40IDgxLjEtMjAwLjJ6IiBmaWxsPSIjNDI4NWY0Ii8+CiAgICA8cGF0aCBkPSJNMjcyLjEgNTQ0LjNjNzMuNCAwIDEzNS4zLTI0LjEgMTgwLjQtNjUuN2wtODcuNy02OGMtMjQuNCAxNi42LTU1LjkgMjYtOTIuNiAyNi03MSAwLTEzMS4yLTQ3LjktMTUyLjgtMTEyLjNIMjguOXY3MC4xYzQ2LjIgOTEuOSAxNDAuMyAxNDkuOSAyNDMuMiAxNDkuOXoiIGZpbGw9IiMzNGE4NTMiLz4KICAgIDxwYXRoIGQ9Ik0xMTkuMyAzMjQuM2MtMTEuNC0zMy44LTExLjQtNzAuNCAwLTEwNC4yVjE1MEgyOC45Yy0zOC42IDc2LjktMzguNiAxNjcuNSAwIDI0NC40bDkwLjQtNzAuMXoiIGZpbGw9IiNmYmJjMDQiLz4KICAgIDxwYXRoIGQ9Ik0yNzIuMSAxMDcuN2MzOC44LS42IDc2LjMgMTQgMTA0LjQgNDAuOGw3Ny43LTc3LjdDNDA1IDI0LjYgMzM5LjctLjggMjcyLjEgMCAxNjkuMiAwIDc1LjEgNTggMjguOSAxNTBsOTAuNCA3MC4xYzIxLjUtNjQuNSA4MS44LTExMi40IDE1Mi44LTExMi40eiIgZmlsbD0iI2VhNDMzNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/ReminderModal/images/outlook-calendar-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMyAyNCI+CiAgICA8ZyBmaWxsPSIjREFBNjAyIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgIDxwYXRoIGQ9Ik0xNC4zOTMgNS40M3Y0LjQxMmwxLjU0MS45NzFjLjA0MS4wMTIuMTMuMDEzLjE3IDBsNi42MzUtNC40NzNjMC0uNTMtLjQ5NC0uOTEtLjc3Mi0uOTFoLTcuNTc0eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNC4zOTMgMTEuNDg4bDEuNDA3Ljk2N2MuMTk4LjE0NS40MzcgMCAuNDM3IDAtLjIzOC4xNDUgNi41MDMtNC4zMzIgNi41MDMtNC4zMzJ2OC4xMDhjMCAuODgzLS41NjUgMS4yNTMtMS4yIDEuMjUzaC03LjE0OHYtNS45OTZ6TTcuMTA4IDkuNDU0Yy0uNDggMC0uODYyLjIyNi0xLjE0NC42NzUtLjI4Mi40NS0uNDI0IDEuMDQ2LS40MjQgMS43ODcgMCAuNzUyLjE0MiAxLjM0Ny40MjQgMS43ODQuMjgyLjQzOC42NTIuNjU2IDEuMTEuNjU2LjQ3MiAwIC44NDYtLjIxMyAxLjEyMi0uNjM4LjI3Ni0uNDI1LjQxNS0xLjAxNi40MTUtMS43NyAwLS43ODgtLjEzNC0xLjQtLjQwMi0xLjgzOC0uMjY5LS40MzctLjYzNS0uNjU2LTEuMTAxLS42NTZ6Ii8+CiAgICAgICAgPHBhdGggZD0iTS40MzIgMy4xOXYxNy4yNmwxMy4xMyAyLjc1M1YuNjQ5TC40MzMgMy4xOXpNOS4yMiAxNC43MzhjLS41NTUuNzMtMS4yNzkgMS4wOTYtMi4xNzIgMS4wOTYtLjg3IDAtMS41NzgtLjM1NC0yLjEyNi0xLjA2Mi0uNTQ3LS43MDgtLjgyMS0xLjYzLS44MjEtMi43NjYgMC0xLjIuMjc3LTIuMTcxLjgzNC0yLjkxMy41NTctLjc0IDEuMjkzLTEuMTEyIDIuMjEtMS4xMTIuODY3IDAgMS41NjkuMzU0IDIuMTAzIDEuMDY0LjUzNi43MS44MDMgMS42NDUuODAzIDIuODA3LjAwMSAxLjE5My0uMjc3IDIuMTU2LS44MzEgMi44ODZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "./src/components/ReminderModal/images/outlook-web-calendar-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDMuMTczIDEwNC4zMTMiPgogICAgPHBhdGggZD0iTTY0LjU2NyAyMi4xMTZ2MjAuNDA1bDcuMTMgNC40OWMuMTg4LjA1NC41OTYuMDU4Ljc4NCAwbDMwLjY4OC0yMC42OWMwLTIuNDUtMi4yODQtNC4yMDUtMy41NzMtNC4yMDVoLTM1LjAzeiIgZmlsbD0iIzAwNzJjNiIvPgogICAgPHBhdGggZD0iTTY0LjU2NyA1MC4xMzNsNi41MDcgNC40N2MuOTE3LjY3NCAyLjAyMiAwIDIuMDIyIDAtMS4xMDEuNjc0IDMwLjA3Ny0yMC4wMzYgMzAuMDc3LTIwLjAzNlY3Mi4wN2MwIDQuMDgzLTIuNjEzIDUuNzk1LTUuNTUxIDUuNzk1aC0zMy4wNnYtMjcuNzN6IiBmaWxsPSIjMDA3MmM2Ii8+CiAgICA8ZyBmaWxsPSIjMDA3MmM2Ij4KICAgICAgICA8cGF0aCBkPSJNMzAuODczIDQwLjcyNmMtMi4yMTggMC0zLjk4NSAxLjA0Mi01LjI5IDMuMTIzLTEuMzA0IDIuMDgtMS45NTggNC44MzQtMS45NTggOC4yNjMgMCAzLjQ3OS42NTQgNi4yMjkgMS45NTkgOC4yNSAxLjMwNCAyLjAyNiAzLjAxNiAzLjAzMyA1LjEzMiAzLjAzMyAyLjE4MiAwIDMuOTE0LS45ODMgNS4xOTEtMi45NSAxLjI3OC0xLjk2NyAxLjkyLTQuNjk4IDEuOTItOC4xODggMC0zLjY0LS42MTktNi40NzMtMS44NjEtOC40OTgtMS4yNDItMi4wMjItMi45MzgtMy4wMzMtNS4wOTMtMy4wMzN6Ii8+CiAgICAgICAgPHBhdGggZD0iTTAgMTEuNzU0VjkxLjU4bDYwLjcyNyAxMi43MzNWMEwwIDExLjc1NHptNDAuNjM2IDUzLjQwOGMtMi41NjYgMy4zNzctNS45MTIgNS4wNy0xMC4wNDEgNS4wNy00LjAyNCAwLTcuMy0xLjYzOC05LjgzNC00LjkxLTIuNTMxLTMuMjc1LTMuOC03LjUzNy0zLjgtMTIuNzk1IDAtNS41NTIgMS4yODUtMTAuMDQyIDMuODU5LTEzLjQ3IDIuNTc0LTMuNDI4IDUuOTgyLTUuMTQ0IDEwLjIyNS01LjE0NCA0LjAwOCAwIDcuMjUyIDEuNjM4IDkuNzI0IDQuOTIgMi40NzYgMy4yODQgMy43MTUgNy42MSAzLjcxNSAxMi45OC4wMDMgNS41MjEtMS4yODIgOS45NzItMy44NDggMTMuMzQ5eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/ReminderModal/images/yahoo-calendar-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwODAgMTAwMCI+CiAgICA8cGF0aCBkPSJNNjc1LjIgMjQ1LjU5TDM2MSAxMDAwSDE0OS42M2w4Ny45MS0xOTguNDNMMCAyNDUuNTloMjE1LjA5bDEyMy40NSAzMTguMjQgMTI3LjE4LTMxOC4yNHpNODQ4Ljg4IDBMNjQwLjM5IDUwMC41NmgyMzEuMTJMMTA4MCAwem0tMTEwLjQgMjg2LjcybC0zOC43NSAyNjIuNjZBMTI5LjE4IDEyOS4xOCAwIDEwODI4LjggNjc4LjU2YTEyOS4xMiAxMjkuMTIgMCAwMC0xMjkuMDctMTI5LjE4eiIgZmlsbD0iIzVmMDFkMSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/components/Reminders/DonationReminder.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1FteZ","owner-meta-container":"_1r-Cw","cover-image-container":"_1K6dD","progress-donate-container":"_2p9hq","owner":"_1K0Xr","crowdfunding-title-link":"_2d9Zt","title-wrapper":"_11AL7","title":"d6jEa","countdown":"_1d0Ds","meta":"n2OjD","progress":"_1_Jra","actions":"_3VWTR","share-unavailable":"_1h6Pv","recurring-donations":"_1Shug","bottom-right":"_1sHWO","link":"BTn-Q","body":"_3_0Xs","image":"_17et6"};

/***/ }),

/***/ "./src/components/Reminders/DonationReminder.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecurringDonations_svg_supports_recurring_donations_il_svg__ = __webpack_require__("./src/components/RecurringDonations/svg/supports-recurring-donations-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecurringDonations_svg_supports_recurring_donations_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RecurringDonations_svg_supports_recurring_donations_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/ClickableElement.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss__ = __webpack_require__("./src/components/Reminders/DonationReminder.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss__);






var DonationReminder = function (_a) {
    var pageSection = _a.pageSection, handleClick = _a.handleClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center jg-space-pmd " + __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss___default.a['bottom-right'] + " " + __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-pmd " + __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss___default.a.body },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__RecurringDonations_svg_supports_recurring_donations_il_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_5__DonationReminder_scss___default.a.image + " jg-space-mbsm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large-regular" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "DonationReminder.donor.pageAcceptsDonationReminder", defaultMessage: "Don't have time to donate right now?" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement_ClickableElement__["a" /* default */], { className: 'jg-text--link', inline: true, analyticsOptions: {
                    event: 'link click',
                    subtype: 'button',
                    eventValue: 'Set donation reminder',
                    pageSection: pageSection,
                }, onClick: handleClick },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "DonationReminder.Link", defaultMessage: "Set up a reminder" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DonationReminder);


/***/ }),

/***/ "./src/components/Reminders/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DonationReminder__ = __webpack_require__("./src/components/Reminders/DonationReminder.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DonationReminder__["a"]; });



/***/ }),

/***/ "./src/components/RichEditor/RichEditor.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"editor":"tP1Ms","toolbar":"_3ieR6","toolbar-tooltip":"_2tNKj","grey-cross":"_20kex","toolbar-icon":"ZBaha","is-active":"_3OjF9","toolbar-icon-disabled":"_3vVQv","toolbar-icon-tooltip":"DwlRO","button-inner-wrapper":"y72rJ","button-wrapper":"BPIlG","quote":"_2Fu08","quote-marks":"_22jDy","quote-container":"_1qEQq","tooltip":"_2uaSj"};

/***/ }),

/***/ "./src/components/RichEditor/RichQuoteNode.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs_quote_il_svg__ = __webpack_require__("./src/components/RichEditor/svgs/quote-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs_quote_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svgs_quote_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichEditor_scss__ = __webpack_require__("./src/components/RichEditor/RichEditor.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichEditor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichEditor_scss__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var RichQuoteNode = function (_a) {
    var children = _a.children, attributes = __rest(_a, ["children"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__RichEditor_scss___default.a.quote + " jg-space-mbml" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svgs_quote_il_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_4__RichEditor_scss___default.a['quote-marks'] + " jg-icon jg-display-i" }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", __assign({ className: "jg-space-mbn" }, attributes), children)));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_css_modules___default()(RichQuoteNode, __WEBPACK_IMPORTED_MODULE_4__RichEditor_scss___default.a));


/***/ }),

/***/ "./src/components/RichEditor/svgs/quote-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 16\"><g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"><g transform=\"translate(-114.000000, -23.000000)\"><g transform=\"translate(32.000000, 22.000000)\"><g transform=\"translate(82.000000, 1.000000)\"><g transform=\"translate(-0.077539, 0.000000)\"><g transform=\"translate(0.623738, 0.788759)\"><g transform=\"translate(11.777418, 0.000000)\"><path d=\"M9.42193435,10.4253394 C9.42193435,12.9845312 7.31295486,15.0588235 4.71096718,15.0588235 C2.10897949,15.0588235 0,12.9845312 0,10.4253394 C0,7.86614753 2.10897949,5.7918552 4.71096718,5.7918552 C7.31295486,5.7918552 9.42193435,7.86614753 9.42193435,10.4253394\"></path><path d=\"M0.135712954,11.5837104 C0.135712954,11.5837104 -0.926475806,7.07688615 2.89236789,3.4254889 C6.16566249,0.296800087 6.68043703,0 7.20640232,0 C7.73143504,0 8.45790128,1.26187298 8.18466045,1.66831896 C7.91141961,2.07381972 4.00398247,4.91327023 4.62693426,7.16668236 L0.135712954,11.5837104 Z\"></path></g><g><path d=\"M9.42193435,10.4253394 C9.42193435,12.9845312 7.31295486,15.0588235 4.71096718,15.0588235 C2.10897949,15.0588235 0,12.9845312 0,10.4253394 C0,7.86614753 2.10897949,5.7918552 4.71096718,5.7918552 C7.31295486,5.7918552 9.42193435,7.86614753 9.42193435,10.4253394\"></path><path d=\"M0.135712954,11.5837104 C0.135712954,11.5837104 -0.926475806,7.07688615 2.89236789,3.4254889 C6.16566249,0.296800087 6.68043703,0 7.20640232,0 C7.73143504,0 8.45790128,1.26187298 8.18466045,1.66831896 C7.91141961,2.07381972 4.00398247,4.91327023 4.62693426,7.16668236 L0.135712954,11.5837104 Z\"></path></g></g></g></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/RichStory/RichStory.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_13gFX","story":"JNuQO","video":"_15sNx","image-container":"_1z2rR"};

/***/ }),

/***/ "./src/components/RichStory/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_youtube__ = __webpack_require__("./node_modules/react-youtube/es/YouTube.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_RichEditor_RichQuoteNode__ = __webpack_require__("./src/components/RichEditor/RichQuoteNode.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichStory_scss__ = __webpack_require__("./src/components/RichStory/RichStory.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichStory_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichStory_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_youTubeParser__ = __webpack_require__("./src/helpers/youTubeParser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("./node_modules/lodash/flatten.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");









var renderRanges = function (ranges) {
    return __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(ranges.map(function (range, index) {
        var lines = (range.text || '').split('\n');
        if (lines.length > 1) {
            return lines.map(function (item, i) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: "richstory_lines_" + i },
                item,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null))); });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: "richstory_ranges_" + index }, lines[0] || '');
        }
    }));
};
var renderNode = function (node, index) {
    switch (node.type) {
        case 'header':
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { key: "richstory_header_" + index }, node.text);
        case 'quote':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mhml", key: "richstory_quote_" + index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_RichEditor_RichQuoteNode__["a" /* default */], null, node.text)));
        case 'image':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "image-container", key: "richstory_image_" + index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_5_config___default.a.IMAGE_BASE_URI + "/" + node.name + "?template=CrowdfundingStoryImage" })));
        case 'video':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "video", key: "richstory_video_" + index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_youtube__["a" /* default */], { videoId: Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_youTubeParser__["b" /* getVideoId */])(node.url) })));
        case 'paragraph':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { key: "richstory_paragraph_" + index, className: "jg-s-story" }, node.nodes.map(renderNode)));
        case 'link':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: node.url, key: "richstory_link_" + index, target: "_blank", rel: "noreferrer noopener" }, renderRanges(node.ranges)));
        case 'text':
            return renderRanges(node.ranges);
        default:
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: index }, '');
    }
};
var RichStory = function (_a) {
    var _b = _a.storyNodes, storyNodes = _b === void 0 ? [] : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container", className: "jg-bdt jg-bd--solid jg-bd--very-light-grey" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "RichStory.story", defaultMessage: "Story" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "story" }, storyNodes.map(renderNode))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichStory, __WEBPACK_IMPORTED_MODULE_4__RichStory_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdateNavLink/RichUpdateNavLink.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdateNavLink/RichUpdateNavLink.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesNavIcon__ = __webpack_require__("./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdateNavLink_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdateNavLink/RichUpdateNavLink.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdateNavLink_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichUpdateNavLink_scss__);





var RichUpdateNavLink = function (_a) {
    var path = _a.path, disabled = _a.disabled, pageSection = _a.pageSection;
    return disabled ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RichUpdatesNavIcon__["a" /* default */], { isActive: false }))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: path, analyticsOptions: {
            event: 'link click',
            subtype: 'button',
            eventValue: 'post an update',
            pageSection: "admin > " + pageSection,
        } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RichUpdatesNavIcon__["a" /* default */], { isActive: true })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdateNavLink, __WEBPACK_IMPORTED_MODULE_4__RichUpdateNavLink_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"update-link":"bngEi","active":"_3BUcV","inactive":"_1ZODS","icon":"zQWkW"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdateNavLink/RichUpdatesNavIcon.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_update_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/update.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_update_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_update_svg__);





var RichUpdatesNavIcon = function (_a) {
    var isActive = _a.isActive;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mrms " + __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default.a['update-link'] + " " + (isActive ? __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default.a.inactive) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { className: "jg-fill--white " + __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default.a.icon, markup: __WEBPACK_IMPORTED_MODULE_4__justgiving_icons_lib_update_svg___default.a })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesNavIcon, __WEBPACK_IMPORTED_MODULE_2__RichUpdatesNavIcon_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdateNavLink/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdateNavLink__ = __webpack_require__("./src/components/RichUpdates/RichUpdateNavLink/RichUpdateNavLink.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RichUpdateNavLink__["a"]; });



/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"_1luxT","footer":"trBjT","avatar":"g1o3v","avatar-container":"_3vfBH","placeholder":"_3J3Tg","action-container":"_3N_Im","action":"_1SYmk"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_update_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/update.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_update_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_update_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_care_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/care.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_care_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_care_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_progress_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/progress.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_progress_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_progress_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss__);










var RichUpdatesCreator = function (_a) {
    var pageName = _a.pageName, avatarImageUrl = _a.avatarImageUrl;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        !__WEBPACK_IMPORTED_MODULE_2_config___default.a.RICH_UPDATES_UPDATE_ONLY && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bdb jg-bd--solid jg-bd--very-light-grey" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-pmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-4 " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.link },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink__["a" /* default */], { path: "/" + pageName + "/update", exact: true, type: "update", title: "Update", icon: __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_update_svg___default.a })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-4 " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.link },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink__["a" /* default */], { path: "/" + pageName + "/update/thank", type: "thank", title: "Thanks", icon: __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_care_svg___default.a })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-4 " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.link },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink__["a" /* default */], { path: "/" + pageName + "/update/milestone", type: "milestone", title: "Milestone", icon: __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_progress_svg___default.a }))))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__["d" /* Link */], { to: "/" + pageName + "/update", className: "row jg-space-pmd " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.footer, isIndexLink: true, analyticsOptions: {
                event: 'link click',
                subtype: 'button',
                eventValue: 'post an update',
                pageSection: 'admin > page view > updates',
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-12 col-md-7 " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a['avatar-container'] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Avatar__["b" /* OwnerAvatar */], { className: "jg-space-mrmd " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.avatar, src: avatarImageUrl, alt: "Owner avatar" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--light jg-text--large jg-space-mbn " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.placeholder }, "Tell your supporters how you're getting on...")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-5 jg-space-prxs " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a['action-container'] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "jg-btn is-disabled jg-pull-right " + __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a.action }, "Post")))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesCreator, __WEBPACK_IMPORTED_MODULE_9__RichUpdatesCreator_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"col":"_32HD_","icon-container":"Oe_WR","update":"_3eB_D","thank":"zBXId","milestone":"_3xSLP","icon":"_3HL8z","title":"_1kPNL"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss__);





var RichUpdatesCreatorLink = function (_a) {
    var path = _a.path, type = _a.type, title = _a.title, icon = _a.icon, _b = _a.exact, exact = _b === void 0 ? false : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["d" /* Link */], { to: path, className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a[type], isIndexLink: exact, analyticsOptions: {
            event: 'link click',
            eventValue: type,
            pageSection: 'admin > page view > updates',
            subtype: 'button',
        } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "" + __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a.col },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbxs " + __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a['icon-container'] + " " + __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a[type] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__justgiving_svg__["a" /* default */], { markup: icon, className: "jg-icon " + __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a.icon })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a.title + " jg-space-mbn" }, title))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesCreatorLink, __WEBPACK_IMPORTED_MODULE_4__RichUpdatesCreatorLink_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesCreator/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesCreator__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesCreator__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"_1dXBS","info-container":"_3PyII","avatar-wrapper":"_2dD6N","avatar":"_54bOA","owner-name":"_9L9ul","date":"_114jC","message":"_1Z7yQ","media-container":"NLZsw"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemTooltip___ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemMedia__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RichUpdatesItemShareAlert___ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RichUpdatesItemShare___ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var RichUpdatesItem = /** @class */ (function (_super) {
    __extends(RichUpdatesItem, _super);
    function RichUpdatesItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RichUpdatesItem.prototype.displayMedia = function () {
        var _a = this.props, media = _a.media, watchingVideoToggle = _a.watchingVideoToggle;
        if (!media || media.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a['media-container'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemMedia__["a" /* default */], { type: media[0].type, path: media[0].path, watchingVideoToggle: watchingVideoToggle })));
    };
    RichUpdatesItem.prototype.render = function () {
        var _a = this.props, date = _a.date, deleteRichUpdate = _a.deleteRichUpdate, id = _a.id, isLowReachAlertVisible = _a.isLowReachAlertVisible, isOwner = _a.isOwner, message = _a.message, ownerProfileImageUrl = _a.ownerProfileImageUrl, ownerName = _a.ownerName, type = _a.type;
        var updateTypes = ['update', 'thank', 'milestone'];
        var stringType = type === undefined ? updateTypes[0] : updateTypes[type - 1];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a.content },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a['info-container'] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1 " + __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a['avatar-wrapper'] },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__["b" /* OwnerAvatar */], { src: ownerProfileImageUrl, alt: ownerName, className: __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a.avatar }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-h5 " + __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a['owner-name'] }, ownerName),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall-light " + __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a.date }, date))),
                        isOwner && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemTooltip___["a" /* default */], { updateId: id, deleteRichUpdate: deleteRichUpdate }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-ptsm@lg" },
                        type !== 1 && this.displayMedia(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a.message }, message),
                        type === 1 && this.displayMedia()))),
            isLowReachAlertVisible ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RichUpdatesItemShareAlert___["a" /* default */], { updateId: id, message: message, type: stringType })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RichUpdatesItemShare___["a" /* default */], { updateId: id, message: message, type: stringType }))));
    };
    return RichUpdatesItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesItem, __WEBPACK_IMPORTED_MODULE_7__RichUpdatesItem_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"medium":"_2-oPj","wrapper":"e74iI"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_youtube__ = __webpack_require__("./node_modules/react-youtube/es/YouTube.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_api_updates__ = __webpack_require__("./src/helpers/api/updates.ts");





var RichUpdatesItemMedia = function (_a) {
    var type = _a.type, path = _a.path, watchingVideoToggle = _a.watchingVideoToggle;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss___default.a.medium }, type === __WEBPACK_IMPORTED_MODULE_4_src_helpers_api_updates__["a" /* UpdateMediaType */].Image ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss___default.a.wrapper },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: path + "?template=CrowdfundingStoryImage", alt: "Update from the Page owner" }))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_youtube__["a" /* default */], { videoId: path, onPlay: watchingVideoToggle, onEnd: watchingVideoToggle, onPause: watchingVideoToggle, opts: {
            height: '320px',
            width: '100%',
            playerVars: {
                autoplay: 0,
            },
        } }))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesItemMedia, __WEBPACK_IMPORTED_MODULE_3__RichUpdatesItemMedia_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemMedia__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/RichUpdatesItemMedia.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemMedia__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3f6SC","text":"z5Z5e","facebook-container":"_2jDzj"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss__);





var RichUpdatesItemShare = function (_a) {
    var updateId = _a.updateId, message = _a.message;
    var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__["a" /* generateHash */])();
    return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss___default.a.text }, "Share this update to help us raise more"),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss___default.a['facebook-container'] },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__["a" /* default */], { customStyle: "jg-btn jg-btn--facebook", isActive: true, isUpdate: true, location: "updates", buttonText: "Share", updateId: updateId, quote: message, shareHash: shareHash }))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_css_modules___default()(RichUpdatesItemShare, __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShare_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemShare__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemShare__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"G4NFU","facebook-container":"_3uD37"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss__);





var RichUpdatesItemShareAlert = function (_a) {
    var updateId = _a.updateId, message = _a.message;
    var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__["a" /* generateHash */])();
    return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", { className: "jg-text--regular" }, "Spread the word even further"),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", { className: "jg-space-mbmd" }, "The more you share the more you raise!"),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss___default.a['facebook-container'] },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_FacebookShare_FacebookShare__["a" /* default */], { customStyle: "jg-btn jg-btn--facebook", isActive: true, isUpdate: true, location: "updates", buttonText: "Share on Facebook", updateId: updateId, quote: message, shareHash: shareHash }))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_css_modules___default()(RichUpdatesItemShareAlert, __WEBPACK_IMPORTED_MODULE_4__RichUpdatesItemShareAlert_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemShareAlert__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemShareAlert__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_21PsZ","tooltip-container":"I-zDe","tooltip-open":"_3FjN1","tooltip-trigger":"_2Xc9E","tooltip-delete":"_1sJw7"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RichUpdatesItemTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_chevron_down_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/chevron-down.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_chevron_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_chevron_down_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var RichUpdatesItemTooltip = /** @class */ (function (_super) {
    __extends(RichUpdatesItemTooltip, _super);
    function RichUpdatesItemTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleTooltip = function () {
            _this.setState({
                isOpen: !_this.state.isOpen,
            });
        };
        _this.handleClickOutsideTooltip = function (e) {
            if (_this.state.isOpen &&
                _this.tooltip &&
                !_this.tooltip.contains(e.target)) {
                _this.toggleTooltip();
            }
        };
        _this.handleDeleteUpdate = function () {
            var _a = _this.props, updateId = _a.updateId, deleteRichUpdate = _a.deleteRichUpdate;
            deleteRichUpdate(updateId);
            _this.toggleTooltip();
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    RichUpdatesItemTooltip.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleClickOutsideTooltip);
    };
    RichUpdatesItemTooltip.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutsideTooltip);
    };
    RichUpdatesItemTooltip.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: this.state.isOpen ? 'tooltip-open' : 'tooltip' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss___default.a['tooltip-trigger'], onClick: this.toggleTooltip },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { className: "jg-fill--nobel jg-icon--medium-small jg-space-mrxs", markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_chevron_down_svg___default.a })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "tooltip-container", ref: function (tooltip) {
                    _this.tooltip = tooltip;
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss___default.a['tooltip-delete'] + " qa-delete-button", onClick: this.handleDeleteUpdate }, "Delete post"))));
    };
    return RichUpdatesItemTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesItemTooltip, __WEBPACK_IMPORTED_MODULE_2__RichUpdatesItemTooltip_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemTooltip__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesItemTooltip__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesItem/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesItem__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesItem__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3oH0r","image":"_2hO_9"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss__);



var RichUpdatesPlaceholder = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-plg " + __WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss___default.a.image }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, title),
        subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mtxs" }, subtitle)));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesPlaceholder, __WEBPACK_IMPORTED_MODULE_2__RichUpdatesPlaceholder_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesPlaceholder/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesPlaceholder__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesPlaceholder/RichUpdatesPlaceholder.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesPlaceholder__["a" /* default */]);


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_9AJnV","avatar-wrapper":"_38bB9","avatar":"_1yCh5","date":"_3LUF5","content-wrapper":"_1pKrG"};

/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss__);




var RichUpdatesTimelineItem = function (_a) {
    var ownerProfileImageUrl = _a.ownerProfileImageUrl, ownerName = _a.ownerName, date = _a.date, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a['avatar-wrapper'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__["b" /* OwnerAvatar */], { src: ownerProfileImageUrl, alt: ownerName, className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a.avatar }),
            date && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall-light " + __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a.date }, date))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a['content-wrapper'] }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(RichUpdatesTimelineItem, __WEBPACK_IMPORTED_MODULE_3__RichUpdatesTimelineItem_scss___default.a));


/***/ }),

/***/ "./src/components/RichUpdates/RichUpdatesTimelineItem/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichUpdatesTimelineItem__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RichUpdatesTimelineItem__["a" /* default */]);


/***/ }),

/***/ "./src/components/Select/Select.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasTouchSupport */
/* unused harmony export Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downshift__ = __webpack_require__("./node_modules/downshift/dist/downshift.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_icons_lib_chevron_down_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/chevron-down.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__justgiving_icons_lib_chevron_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__justgiving_icons_lib_chevron_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var hasTouchSupport = function () {
    if (typeof window === 'undefined') {
        return false;
    }
    return (typeof window.ontouchstart !== 'undefined' ||
        (window.navigator && window.navigator.msMaxTouchPoints !== undefined));
};
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStateChange = function (changes) {
            if (changes.highlightedIndex !== null &&
                changes.highlightedIndex !== undefined) {
                _this.setState({
                    highlightedIndex: changes.highlightedIndex,
                });
            }
        };
        var defaultSelectedItemIndex = _this.props.items.findIndex(function (item) { return item.isSelected; });
        _this.state = {
            highlightedIndex: defaultSelectedItemIndex !== -1 ? defaultSelectedItemIndex : undefined,
            touchSupport: hasTouchSupport(),
            defaultSelectedItem: defaultSelectedItemIndex !== -1
                ? _this.props.items[defaultSelectedItemIndex]
                : undefined,
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_downshift__["a" /* default */], { onStateChange: this.handleStateChange, defaultHighlightedIndex: this.state.highlightedIndex, onChange: this.props.onChange, defaultSelectedItem: this.state.defaultSelectedItem, itemToString: function (item) {
                if (item) {
                    return item.value;
                }
                else {
                    return '';
                }
            } }, function (_a) {
            var isOpen = _a.isOpen, getButtonProps = _a.getButtonProps, getItemProps = _a.getItemProps, highlightedIndex = _a.highlightedIndex, selectedItem = _a.selectedItem, selectItem = _a.selectItem;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-select jg-background--white" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", __assign({ tabIndex: "0", className: "jg-select__btn " + (!selectedItem ? 'jg-select__btn--placeholder' : '') }, getButtonProps()), (selectedItem && selectedItem.label) || _this.props.placeholder),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__justgiving_icons_lib_chevron_down_svg___default.a, className: "jg-icon--medium-small jg-fill--nobel jg-select__chevron " + (isOpen ? 'jg-select__chevron--open' : '') }),
                isOpen ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-select__dropdown jg-display-ib jg-bd jg-bd--solid jg-bd--brand-secondary jg-background--white" }, _this.props.items.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({}, getItemProps({ item: item }), { key: item.value, className: "jg-select__option " + (highlightedIndex === index
                        ? 'jg-select__option--selected'
                        : '') }), item.label)); }))) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", { className: "jg-select__select " + (!_this.state.touchSupport ? 'jg-hidden' : ''), onChange: function (e) {
                        var value = e.target.value;
                        var itemIndex = _this.props.items.findIndex(function (i) { return i.value === value; });
                        /* istanbul ignore else */
                        if (itemIndex !== -1) {
                            var item = _this.props.items[itemIndex];
                            selectItem(item);
                            _this.setState({
                                highlightedIndex: itemIndex,
                            });
                        }
                    }, value: (selectedItem && selectedItem.value) || _this.props.placeholder },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { value: _this.props.placeholder, disabled: true }, _this.props.placeholder),
                    _this.props.items.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: item.value, value: item.value }, item.label)); }))));
        }));
    };
    Select.propTypes = {
        placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
        items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
            label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
            value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
            isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
        })).isRequired,
        onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    };
    return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (Select);


/***/ }),

/***/ "./src/components/Select/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__("./src/components/Select/Select.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),

/***/ "./src/components/ShareModal/CopyLinkShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3s-Dq","share-button":"_1JyeN","copy":"_19i2G","url":"ncSxX"};

/***/ }),

/***/ "./src/components/ShareModal/CopyLinkShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_clipboard_js__ = __webpack_require__("./node_modules/react-clipboard.js/dist/react-clipboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/link.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss__ = __webpack_require__("./src/components/ShareModal/CopyLinkShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var CopyLinkShareButton = /** @class */ (function (_super) {
    __extends(CopyLinkShareButton, _super);
    function CopyLinkShareButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onCopyUrlToClipboardSuccess = function () {
            var _a = _this.props, pageSection = _a.pageSection, sharePageLink = _a.sharePageLink;
            var copyLinkUtmTerm = _this.state.copyLinkUtmTerm;
            sharePageLink({ shareHash: copyLinkUtmTerm, location: pageSection });
            _this.setState({ copied: true });
            setTimeout(function () {
                _this.setState(__assign({ copied: false }, _this.generateCopyLinkState()));
            }, 5000);
        };
        _this.generateCopyLinkState = function () {
            var socialShareUrl = _this.props.socialShareUrl;
            var utmTerm = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__["a" /* generateHash */])();
            var url = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, { utm_term: utmTerm });
            return { copyLinkUrl: url, copyLinkUtmTerm: utmTerm };
        };
        _this.state = __assign({ copied: false }, _this.generateCopyLinkState());
        return _this;
    }
    CopyLinkShareButton.prototype.render = function () {
        var _a = this.props, copyText = _a.copyText, copiedText = _a.copiedText, isDisabled = _a.isDisabled;
        var buttonText = !this.state.copied ? copyText : copiedText;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss___default.a.copy },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg___default.a, className: "jg-icon jg-fill--nobel jg-position-absolute" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss___default.a.url }, this.state.copyLinkUrl),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_clipboard_js___default.a, { "button-disabled": isDisabled, "data-clipboard-text": this.state.copyLinkUrl, onSuccess: this.onCopyUrlToClipboardSuccess }, buttonText)));
    };
    return CopyLinkShareButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(CopyLinkShareButton, __WEBPACK_IMPORTED_MODULE_6__CopyLinkShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/EmailShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_1rdod","share-button":"_4FHj-","email":"_2LrRr"};

/***/ }),

/***/ "./src/components/ShareModal/EmailShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailShareButton_scss__ = __webpack_require__("./src/components/ShareModal/EmailShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EmailShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_EmailShare__ = __webpack_require__("./src/components/SocialShare/EmailShare.tsx");




var EmailShareButton = function (_a) {
    var pageSection = _a.pageSection, shareByEmail = _a.shareByEmail, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, isActive = _a.isActive, isOwner = _a.isOwner, targetCurrency = _a.targetCurrency, ownerName = _a.ownerName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_EmailShare__["a" /* default */], { shareByEmail: shareByEmail, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, buttonText: "Email", className: __WEBPACK_IMPORTED_MODULE_1__EmailShareButton_scss___default.a.email, messageType: isOwner ? 'ownerShare' : 'supporterShare' })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(EmailShareButton, __WEBPACK_IMPORTED_MODULE_1__EmailShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/FacebookShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3mSn7","share-button":"_32mKB","fb":"_3BCKl"};

/***/ }),

/***/ "./src/components/ShareModal/FacebookShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FacebookShareButton_scss__ = __webpack_require__("./src/components/ShareModal/FacebookShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FacebookShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FacebookShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");




var FacebookShareButton = function (_a) {
    var pageSection = _a.pageSection;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FacebookShare_FacebookShare__["a" /* default */], { buttonText: "Facebook", location: pageSection, customStyle: __WEBPACK_IMPORTED_MODULE_1__FacebookShareButton_scss___default.a.fb, showCounter: true, renderButtonOnly: true })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FacebookShareButton, __WEBPACK_IMPORTED_MODULE_1__FacebookShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/LinkedInShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_1lmok","share-button":"_3GxM9","linkedin":"_3JB3h"};

/***/ }),

/***/ "./src/components/ShareModal/LinkedInShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinkedInShareButton_scss__ = __webpack_require__("./src/components/ShareModal/LinkedInShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinkedInShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LinkedInShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_window__ = __webpack_require__("./src/helpers/window.ts");






var LinkedInShareButton = function (_a) {
    var pageSection = _a.pageSection, shareOnLinkedIn = _a.shareOnLinkedIn, socialShareUrl = _a.socialShareUrl, isActive = _a.isActive, buttonText = _a.buttonText;
    var handleLinkedInShare = function () {
        var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_hashId__["a" /* generateHash */])();
        shareOnLinkedIn({
            shareHash: shareHash,
            location: pageSection,
        });
        var pageUrl = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
            utm_term: shareHash,
        });
        if (true) {
            Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_window__["a" /* openCenteredPopup */])("https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(pageUrl), 1000, 760);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: __WEBPACK_IMPORTED_MODULE_1__LinkedInShareButton_scss___default.a.linkedin, onClick: handleLinkedInShare }, buttonText || 'LinkedIn')));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(LinkedInShareButton, __WEBPACK_IMPORTED_MODULE_1__LinkedInShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/MessengerShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_2ijy4","share-button":"_5DS8B","messenger":"_39GWW"};

/***/ }),

/***/ "./src/components/ShareModal/MessengerShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessengerShareButton_scss__ = __webpack_require__("./src/components/ShareModal/MessengerShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessengerShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MessengerShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_MessengerShare__ = __webpack_require__("./src/components/SocialShare/MessengerShare.tsx");




var MessengerShareButton = function (_a) {
    var pageSection = _a.pageSection, shareOnMessenger = _a.shareOnMessenger, socialShareUrl = _a.socialShareUrl, isActive = _a.isActive;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_MessengerShare__["a" /* default */], { shareOnMessenger: shareOnMessenger, socialShareUrl: socialShareUrl, isActive: isActive, location: pageSection, className: __WEBPACK_IMPORTED_MODULE_1__MessengerShareButton_scss___default.a.messenger, buttonText: "Messenger" })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(MessengerShareButton, __WEBPACK_IMPORTED_MODULE_1__MessengerShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/QRCodeShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_39a97","share-button":"_88Dko","qr":"_3ZHrK"};

/***/ }),

/***/ "./src/components/ShareModal/QRCodeShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QRCodeShareButton_scss__ = __webpack_require__("./src/components/ShareModal/QRCodeShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QRCodeShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__QRCodeShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_QRCodeShare__ = __webpack_require__("./src/components/SocialShare/QRCodeShare.tsx");




var QRCodeShareButton = function (_a) {
    var pageSection = _a.pageSection, handleClick = _a.handleClick, shareQrCode = _a.shareQrCode, isActive = _a.isActive;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_QRCodeShare__["a" /* default */], { shareQrCode: shareQrCode, isActive: isActive, location: pageSection, buttonText: "QR Code", classNames: __WEBPACK_IMPORTED_MODULE_1__QRCodeShareButton_scss___default.a.qr, handleClick: handleClick })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(QRCodeShareButton, __WEBPACK_IMPORTED_MODULE_1__QRCodeShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/ShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button":"yh15z"};

/***/ }),

/***/ "./src/components/ShareModal/ShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareButton_scss__ = __webpack_require__("./src/components/ShareModal/ShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);



var ShareButton = function (_a) {
    var handleShareClick = _a.handleShareClick;
    var handleShareButtonClick = function () {
        handleShareClick();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", className: "jg-btn", styleName: "share-button", onClick: function () { return handleShareButtonClick(); } }, "Share"));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(ShareButton, __WEBPACK_IMPORTED_MODULE_1__ShareButton_scss___default.a, { allowMultiple: true }));


/***/ }),

/***/ "./src/components/ShareModal/ShareModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1rG-n","modal-background":"_1hUjJ","top-container":"gS7mu","title":"XZRrc","close":"_28cC4","description":"fKuFC","avatar":"_1D2z5","button-container":"_2Li3_"};

/***/ }),

/***/ "./src/components/ShareModal/ShareModal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShareModal_scss__ = __webpack_require__("./src/components/ShareModal/ShareModal.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShareModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShareModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_close_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/close.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FacebookShareButton__ = __webpack_require__("./src/components/ShareModal/FacebookShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TwitterShareButton__ = __webpack_require__("./src/components/ShareModal/TwitterShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EmailShareButton__ = __webpack_require__("./src/components/ShareModal/EmailShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WhatsAppShareButton__ = __webpack_require__("./src/components/ShareModal/WhatsAppShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MessengerShareButton__ = __webpack_require__("./src/components/ShareModal/MessengerShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CopyLinkShareButton__ = __webpack_require__("./src/components/ShareModal/CopyLinkShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__QRCodeShareButton__ = __webpack_require__("./src/components/ShareModal/QRCodeShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SmsShareButton__ = __webpack_require__("./src/components/ShareModal/SmsShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LinkedInShareButton__ = __webpack_require__("./src/components/ShareModal/LinkedInShareButton.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



















var ShareModal = /** @class */ (function (_super) {
    __extends(ShareModal, _super);
    function ShareModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleQrCodeShare = function () {
            var _a = _this.props, closeSharePrompts = _a.closeSharePrompts, pageName = _a.pageName;
            closeSharePrompts();
            _this.props.push("/" + pageName + "/qrcode");
        };
        return _this;
    }
    ShareModal.prototype.createEmailShareButton = function (socialShareSection) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EmailShareButton__["a" /* default */], { shareByEmail: this.props.shareByEmail, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isActive: this.props.isActive, targetCurrency: this.props.targetCurrency, pageSection: socialShareSection, isOwner: this.props.isOwner }));
    };
    ShareModal.prototype.render = function () {
        var _a = this.props, showModal = _a.showModal, ownerName = _a.ownerName, ownerProfileImageUrl = _a.ownerProfileImageUrl, handleModalClose = _a.handleModalClose, pageSection = _a.pageSection, shareOnTwitter = _a.shareOnTwitter, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, pitchFor = _a.pitchFor, socialShareUrl = _a.socialShareUrl, isOwner = _a.isOwner, isActive = _a.isActive, shareByWhatsApp = _a.shareByWhatsApp, shareOnMessenger = _a.shareOnMessenger, shareBySms = _a.shareBySms, shareOnLinkedIn = _a.shareOnLinkedIn;
        var socialShareSection = pageSection + " > share modal";
        var isMobile = !Object(__WEBPACK_IMPORTED_MODULE_17_src_helpers_browser__["d" /* isDesktopViewport */])();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */], { classNames: __WEBPACK_IMPORTED_MODULE_2__ShareModal_scss___default.a.modal, isOpen: showModal, shouldCloseOnOverlayClick: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Analytics__["b" /* AnalyticsPageView */], { eventValue: "share modal", pageSection: pageSection, subtype: "cfp" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ClickableElement__["a" /* default */], { onClick: handleModalClose, inline: true, className: __WEBPACK_IMPORTED_MODULE_2__ShareModal_scss___default.a.close },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_close_svg___default.a, className: "jg-icon--medium jg-fill--nobel" }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row", styleName: "top-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "avatar" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Avatar__["b" /* OwnerAvatar */], { src: ownerProfileImageUrl, alt: ownerName, size: "xlarge" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-9", styleName: "description" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2", styleName: "title" }, "Help " + ownerName),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Sharing this page with your friends could help raise up to 3x more in donations"))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "button-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FacebookShareButton__["a" /* default */], { pageSection: socialShareSection }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TwitterShareButton__["a" /* default */], { pageSection: socialShareSection, shareOnTwitter: shareOnTwitter, targetAmount: targetAmount, targetCurrency: targetCurrency, isActive: isActive, pitchFor: pitchFor, socialShareUrl: socialShareUrl, isOwner: isOwner }),
                    !isMobile && this.createEmailShareButton(socialShareSection),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__WhatsAppShareButton__["a" /* default */], { shareByWhatsApp: shareByWhatsApp, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, pageSection: socialShareSection, isOwner: isOwner }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__MessengerShareButton__["a" /* default */], { shareOnMessenger: shareOnMessenger, socialShareUrl: socialShareUrl, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, pageSection: socialShareSection }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__LinkedInShareButton__["a" /* default */], { shareOnLinkedIn: shareOnLinkedIn, socialShareUrl: socialShareUrl, ownerName: ownerName, isActive: isActive, pageSection: pageSection }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CopyLinkShareButton__["a" /* default */], { copyText: "Copy link", copiedText: "Copied", isDisabled: !this.props.isActive, pageSection: socialShareSection, socialShareUrl: this.props.socialShareUrl, sharePageLink: this.props.sharePageLink }),
                    isMobile && this.createEmailShareButton(socialShareSection),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__QRCodeShareButton__["a" /* default */], { isActive: isActive, handleClick: this.handleQrCodeShare, shareQrCode: this.props.shareQrCode, pageSection: socialShareSection }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SmsShareButton__["a" /* default */], { shareBySms: shareBySms, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isOwner: isOwner, targetCurrency: targetCurrency, isActive: isActive, pageSection: socialShareSection })))));
    };
    return ShareModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(ShareModal, __WEBPACK_IMPORTED_MODULE_2__ShareModal_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/SmsShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_2R30X","share-button":"_3bUf3","sms":"_37e5_"};

/***/ }),

/***/ "./src/components/ShareModal/SmsShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmsShareButton_scss__ = __webpack_require__("./src/components/ShareModal/SmsShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmsShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SmsShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_SmsShare__ = __webpack_require__("./src/components/SocialShare/SmsShare.tsx");




var SmsShareButton = function (_a) {
    var shareBySms = _a.shareBySms, pageSection = _a.pageSection, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, isActive = _a.isActive, isOwner = _a.isOwner, targetCurrency = _a.targetCurrency, ownerName = _a.ownerName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_SmsShare__["a" /* default */], { shareBySms: shareBySms, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isOwner: isOwner, isActive: isActive, location: pageSection, buttonText: "Text", className: __WEBPACK_IMPORTED_MODULE_1__SmsShareButton_scss___default.a.sms, targetCurrency: targetCurrency })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(SmsShareButton, __WEBPACK_IMPORTED_MODULE_1__SmsShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/TwitterShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"ezTR0","share-button":"_1j3xG","twitter":"Euwq1"};

/***/ }),

/***/ "./src/components/ShareModal/TwitterShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TwitterShareButton_scss__ = __webpack_require__("./src/components/ShareModal/TwitterShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TwitterShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TwitterShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_TwitterShare__ = __webpack_require__("./src/components/SocialShare/TwitterShare.tsx");




var TwitterShareButton = function (_a) {
    var pageSection = _a.pageSection, shareOnTwitter = _a.shareOnTwitter, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, isActive = _a.isActive, isOwner = _a.isOwner, targetCurrency = _a.targetCurrency;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_TwitterShare__["a" /* default */], { shareOnTwitter: shareOnTwitter, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, isActive: isActive, isOwner: isOwner, targetCurrency: targetCurrency, location: pageSection, className: __WEBPACK_IMPORTED_MODULE_1__TwitterShareButton_scss___default.a.twitter, buttonText: "Twitter" })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(TwitterShareButton, __WEBPACK_IMPORTED_MODULE_1__TwitterShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareModal/WhatsAppShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3KIRQ","share-button":"_1_Ruy","whatsapp":"_3snq1"};

/***/ }),

/***/ "./src/components/ShareModal/WhatsAppShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WhatsAppShareButton_scss__ = __webpack_require__("./src/components/ShareModal/WhatsAppShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WhatsAppShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WhatsAppShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialShare_WhatsAppShare__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.tsx");




var WhatsAppShareButton = function (_a) {
    var pageSection = _a.pageSection, shareByWhatsApp = _a.shareByWhatsApp, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, isActive = _a.isActive, targetCurrency = _a.targetCurrency, ownerName = _a.ownerName, isOwner = _a.isOwner;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "share-button-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialShare_WhatsAppShare__["a" /* default */], { ownerName: ownerName, shareByWhatsApp: shareByWhatsApp, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, className: __WEBPACK_IMPORTED_MODULE_1__WhatsAppShareButton_scss___default.a.whatsapp, buttonText: "WhatsApp", messageType: isOwner ? 'ownerShare' : 'supporterShare' })));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(WhatsAppShareButton, __WEBPACK_IMPORTED_MODULE_1__WhatsAppShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/SharePopup/DesktopSharePopup.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__desktop_share_svg__ = __webpack_require__("./src/components/SharePopup/desktop_share.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__desktop_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__desktop_share_svg__);



var DesktopSharePopup = function (_a) {
    var children = _a.children, ownerProfileImage = _a.ownerProfileImage, ownerName = _a.ownerName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-phlg jg-space-ptlg jg-space-pbmd jg-space-mhn" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-6" }, children),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-5 offset-md-1 jg-display-flex jg-flex-aic jg-space-mblg" }, ownerProfileImage ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Avatar__["b" /* OwnerAvatar */], { template: "Size258w", src: ownerProfileImage, alt: ownerName, size: "share-prompt-profile" })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_2__desktop_share_svg___default.a, alt: "People sharing the page via Facebook" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DesktopSharePopup);


/***/ }),

/***/ "./src/components/SharePopup/MobileSharePopup.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mobile_share_svg__ = __webpack_require__("./src/components/SharePopup/mobile_share.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mobile_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mobile_share_svg__);



var MobileSharePopup = function (_a) {
    var children = _a.children, ownerProfileImage = _a.ownerProfileImage, ownerName = _a.ownerName;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-phsm jg-space-ptlg jg-display-flex jg-flex-aic", style: { height: '100vh' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-12 jg-text--center" },
            ownerProfileImage ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Avatar__["b" /* OwnerAvatar */], { template: "Size258w", src: ownerProfileImage, alt: ownerName, size: "share-prompt-profile-mobile" })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_2__mobile_share_svg___default.a, alt: "People sharing the page via Whatsapp", className: "jg-space-mbmd" })),
            children)));
};
/* harmony default export */ __webpack_exports__["a"] = (MobileSharePopup);


/***/ }),

/***/ "./src/components/SharePopup/desktop_share.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/SharePopup/mobile_share.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "117ab5dbf4a333cc9e4a950c7a52661c.svg";

/***/ }),

/***/ "./src/components/SharePrompts/SharePrompts.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"d1M1C","body":"_Bln1","social-actions":"_2tVh1","copy-url-action":"_3nvU3","copy-url":"_3QCBL","facebook-container":"tHCBw"};

/***/ }),

/***/ "./src/components/SharePrompts/SharePrompts.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_TwitterShare__ = __webpack_require__("./src/components/SocialShare/TwitterShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_SocialShare_EmailShare__ = __webpack_require__("./src/components/SocialShare/EmailShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__ = __webpack_require__("./src/components/SocialShare/SmsShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_SocialShare_WhatsAppShare__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_SocialShare_QRCodeShare__ = __webpack_require__("./src/components/SocialShare/QRCodeShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SharePrompts_scss__ = __webpack_require__("./src/components/SharePrompts/SharePrompts.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SharePrompts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SharePrompts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var SharePrompts = /** @class */ (function (_super) {
    __extends(SharePrompts, _super);
    function SharePrompts(props) {
        var _this = _super.call(this, props) || this;
        _this.copyLink = function (e) {
            var _a = _this.props, pageSection = _a.pageSection, sharePageLink = _a.sharePageLink;
            var copyLinkUtmTerm = _this.state.copyLinkUtmTerm;
            e.preventDefault();
            _this.textInput.focus();
            _this.textInput.setSelectionRange(0, _this.textInput.value.length);
            document.execCommand('copy');
            sharePageLink({ shareHash: copyLinkUtmTerm, location: pageSection });
            _this.setState(_this.generateCopyLinkState());
        };
        _this.generateCopyLinkState = function () {
            var socialShareUrl = _this.props.socialShareUrl;
            var utmTerm = Object(__WEBPACK_IMPORTED_MODULE_10_src_helpers_hashId__["a" /* generateHash */])();
            var url = Object(__WEBPACK_IMPORTED_MODULE_11_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, { utm_term: utmTerm });
            return { copyLinkUrl: url, copyLinkUtmTerm: utmTerm };
        };
        _this.handleQRCodeDisplay = function () {
            var _a = _this.props, closeSharePrompts = _a.closeSharePrompts, pageName = _a.pageName;
            closeSharePrompts();
            _this.props.push("/" + pageName + "/qrcode");
        };
        _this.getEmailMessageType = function () {
            if (_this.props.isOwner) {
                return 'ownerShare';
            }
            return 'supporterShare';
        };
        _this.getWhatsAppMessageType = function () {
            if (_this.props.isOwner) {
                return 'ownerShare';
            }
            return 'supporterShare';
        };
        _this.state = _this.generateCopyLinkState();
        return _this;
    }
    SharePrompts.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeSharePrompts = _a.closeSharePrompts, currencySymbol = _a.currencySymbol, isActive = _a.isActive, isOwner = _a.isOwner, ownerName = _a.ownerName, pageSection = _a.pageSection, pitchFor = _a.pitchFor, shareByEmail = _a.shareByEmail, shareBySms = _a.shareBySms, shareByWhatsApp = _a.shareByWhatsApp, shareOnTwitter = _a.shareOnTwitter, shareQrCode = _a.shareQrCode, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency;
        var copyLinkUrl = this.state.copyLinkUrl;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Modal__["a" /* default */], { isOpen: true, contentLabel: "Share your page", onClose: closeSharePrompts, colorTheme: "dark", maintainPosition: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "share your page with friends", pageSection: "admin > page creation > your page is ready", subtype: "admin" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", { className: "jg-background--white-smoke jg-space-pms jg-bdb jg-bd--solid jg-bd--very-light-grey" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h3 jg-space-mbsm" }, "Share your Page"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Let everyone know about your Page."),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "Sharing your Page to facebook can boost your donations by an average of ",
                                currencySymbol,
                                "100.")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "social-actions" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_FacebookShare_FacebookShare__["a" /* default */], { isActive: isActive, location: pageSection, buttonText: "Share on Facebook" })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_SocialShare_EmailShare__["a" /* default */], { shareByEmail: shareByEmail, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, className: "dna-button dna-space-mbm", buttonText: "Share via email", customStyle: "email", messageType: this.getEmailMessageType() }),
                            !Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_browser__["d" /* isDesktopViewport */])() && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__["a" /* default */], { shareBySms: shareBySms, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, isOwner: isOwner, targetCurrency: targetCurrency, location: pageSection, className: "dna-button dna-space-mbm", buttonText: "Share via SMS", customStyle: "sms" })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_SocialShare_WhatsAppShare__["a" /* default */], { shareByWhatsApp: shareByWhatsApp, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, className: "dna-button-whatsapp dna-space-mbm", buttonText: "Share on WhatsApp", messageType: this.getWhatsAppMessageType() }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_TwitterShare__["a" /* default */], { shareOnTwitter: shareOnTwitter, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, isActive: isActive, isOwner: isOwner, targetCurrency: targetCurrency, location: pageSection, className: "dna-button dna-button-twitter dna-space-mbm", buttonText: "Share on Twitter" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "jg-text--large-regular", styleName: "copy-url-action", onClick: this.copyLink }, "Copy Link"),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { ref: function (c) {
                                        _this.textInput = c;
                                    }, styleName: "copy-url", type: "text", readOnly: true, value: copyLinkUrl })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_SocialShare_QRCodeShare__["a" /* default */], { shareQrCode: shareQrCode, isActive: isActive, buttonText: "Share my QR Code", location: pageSection, handleClick: this.handleQRCodeDisplay })))))));
    };
    return SharePrompts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(SharePrompts, __WEBPACK_IMPORTED_MODULE_12__SharePrompts_scss___default.a));


/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1RbJR","body":"_2QHj8","social-actions":"_2ArNj","copy-to-clipboard-button":"_3ekLB","copy-to-clipboard-input":"_3LpHi"};

/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_SocialShare_EmailShare__ = __webpack_require__("./src/components/SocialShare/EmailShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_WhatsAppShare__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SocialShare_MessengerShareButton__ = __webpack_require__("./src/components/SocialShare/MessengerShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__justgiving_copy_to_clipboard__ = __webpack_require__("./node_modules/@justgiving/copy-to-clipboard/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShowMoreOptionsButton__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ShowMoreOptionsButton.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var SharePrompts = /** @class */ (function (_super) {
    __extends(SharePrompts, _super);
    function SharePrompts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            copyLinkUrl: '',
            copyLinkUtmTerm: '',
            linkCopied: false,
        };
        _this.onCopied = function () {
            var _a = _this.props, pageSection = _a.pageSection, sharePageLink = _a.sharePageLink;
            var copyLinkUtmTerm = _this.state.copyLinkUtmTerm;
            sharePageLink({ shareHash: copyLinkUtmTerm, location: pageSection });
            _this.generateCopyLinkState(true);
        };
        _this.generateCopyLinkState = function (linkCopied) {
            var copyLinkUtmTerm = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_hashId__["a" /* generateHash */])();
            var copyLinkUrl = Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_url__["a" /* buildUrl */])(_this.getSocialShareUrl(), {
                utm_term: copyLinkUtmTerm,
            });
            _this.setState({ copyLinkUrl: copyLinkUrl, copyLinkUtmTerm: copyLinkUtmTerm, linkCopied: linkCopied });
        };
        _this.getTargetAmountFormatted = function () {
            return "" + (__WEBPACK_IMPORTED_MODULE_8__helpers_currencyMap__["e" /* default */][_this.props.targetCurrency] || __WEBPACK_IMPORTED_MODULE_8__helpers_currencyMap__["e" /* default */].GBP) + _this.props.targetAmount;
        };
        _this.getSocialShareUrl = function () {
            return _this.props.socialShareUrl + "/feedback";
        };
        return _this;
    }
    SharePrompts.prototype.componentDidMount = function () {
        this.generateCopyLinkState(false);
    };
    SharePrompts.prototype.render = function () {
        var _a = this.props, closeSharePrompts = _a.closeSharePrompts, isActive = _a.isActive, ownerName = _a.ownerName, pageSection = _a.pageSection, pitchFor = _a.pitchFor, shareByEmail = _a.shareByEmail, shareByWhatsApp = _a.shareByWhatsApp, shareOnTwitter = _a.shareOnTwitter, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, shareOnMessenger = _a.shareOnMessenger;
        var _b = this.state, copyLinkUrl = _b.copyLinkUrl, linkCopied = _b.linkCopied;
        var socialShareUrl = this.getSocialShareUrl();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Modal__["a" /* default */], { isOpen: true, contentLabel: "Share your Page", onClose: closeSharePrompts, colorTheme: "dark", maintainPosition: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "share your page with friends", pageSection: pageSection, subtype: "admin" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", { className: "jg-background--white-smoke jg-space-pms jg-bdb jg-bd--solid jg-bd--very-light-grey" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h3 jg-space-mbsm" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsModal.title" })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { styleName: "social-actions" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsModal.subTitle" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "social-actions", className: "jg-space-pml" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_SocialShare_EmailShare__["a" /* default */], { shareByEmail: shareByEmail, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, className: "dna-button dna-space-mbm", buttonText: "Email", customStyle: "email", messageType: "shareWithFriends" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_WhatsAppShare__["a" /* default */], { shareByWhatsApp: shareByWhatsApp, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, ownerName: ownerName, isActive: isActive, targetCurrency: targetCurrency, location: pageSection, className: "dna-button-whatsapp dna-space-mbm", buttonText: "WhatsApp", messageType: "shareWithFriends" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SocialShare_MessengerShareButton__["a" /* default */], { socialShareUrl: socialShareUrl, location: pageSection, shareOnMessenger: shareOnMessenger })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__justgiving_copy_to_clipboard__["a" /* default */], { text: copyLinkUrl, copyMessage: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsModal.copyLink" }), copiedMessage: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsModal.copyLink" }), buttonClassName: "jg-btn jg-text--large-regular " + __WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss___default.a['copy-to-clipboard-button'], inputClassName: "jg-form-control " + __WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss___default.a['copy-to-clipboard-input'], onCopy: this.onCopied, copied: linkCopied })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ShowMoreOptionsButton__["a" /* default */], { socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, targetCurrency: targetCurrency, shareOnTwitter: shareOnTwitter })))))));
    };
    return SharePrompts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(SharePrompts, __WEBPACK_IMPORTED_MODULE_7__ShareWithFriendsPrompts_scss___default.a));


/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ShowMoreOptionsButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ShowMoreOptionsButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowMoreOptionsButton_scss__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ShowMoreOptionsButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowMoreOptionsButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ShowMoreOptionsButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialShare_TwitterShare__ = __webpack_require__("./src/components/SocialShare/TwitterShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ShowMoreOptionsButton = /** @class */ (function (_super) {
    __extends(ShowMoreOptionsButton, _super);
    function ShowMoreOptionsButton(props, state) {
        var _this = _super.call(this, props, state) || this;
        _this.onClick = function (e) {
            _this.setState({ isOpen: true });
        };
        _this.state = { isOpen: false };
        return _this;
    }
    ShowMoreOptionsButton.prototype.render = function () {
        var _a = this.props, pitchFor = _a.pitchFor, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, socialShareUrl = _a.socialShareUrl, shareOnTwitter = _a.shareOnTwitter;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, !this.state.isOpen ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ClickableElement__["a" /* default */], { onClick: this.onClick, className: "jg-text--link jg-text--center", analyticsOptions: {
                event: 'click',
                subtype: 'button',
                eventValue: 'show more options',
                pageSection: 'admin > page creation > share your page with friends',
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "ShareWithFriendsModal.showMoreOptionsButton.title" }))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FacebookShare_FacebookShare__["a" /* default */], { buttonText: "Facebook", location: "admin > page creation > share your page with friends" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SocialShare_TwitterShare__["a" /* default */], { className: "jg-btn jg-btn--twitter", shareOnTwitter: shareOnTwitter, socialShareUrl: socialShareUrl, targetAmount: targetAmount, isOwner: true, pitchFor: pitchFor, isActive: true, location: "admin > page creation > share your page with friends", targetCurrency: targetCurrency }))))));
    };
    return ShowMoreOptionsButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(ShowMoreOptionsButton, __WEBPACK_IMPORTED_MODULE_3__ShowMoreOptionsButton_scss___default.a));


/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ThankYouForHelpingModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"thank-you-for-helping-modal":"_3skcl","high-five":"_3aSJm","title":"ojJQy","subtitle":"_2GSwg","button-container":"_1UIwh"};

/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/ThankYouForHelpingModal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThankYouForHelpingModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Page_DonateButton__ = __webpack_require__("./src/components/Page/DonateButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__high_five_svg__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/high-five.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__high_five_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__high_five_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ThankYouForHelpingModal.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};










var ThankYouForHelpingModal = /** @class */ (function (_super) {
    __extends(ThankYouForHelpingModal, _super);
    function ThankYouForHelpingModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSection = 'page view > send feedback > thanks';
        _this.donate = function () {
            var _a = _this.props, donate = _a.donate, canPageReceiveDonations = _a.canPageReceiveDonations;
            if (canPageReceiveDonations) {
                donate({
                    event: 'click',
                    eventValue: 'donate',
                    pageSection: _this.pageSection,
                    subtype: 'button',
                });
            }
        };
        return _this;
    }
    ThankYouForHelpingModal.prototype.render = function () {
        var _a = this.props, pageName = _a.pageName, canPageReceiveDonations = _a.canPageReceiveDonations;
        var pageSection = this.pageSection;
        var closeAnalytics = {
            event: 'click',
            eventValue: 'close modal',
            pageSection: pageSection,
            subtype: 'button',
        };
        var modalClassName = 'thank-you-for-helping-modal';
        var titleClassName = 'title';
        var subtitleClassName = 'subtitle';
        var highFiveImageClassName = 'high-five';
        var buttonContainerClassName = 'button-container';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Modal__["a" /* default */], { isOpen: this.props.isOpen, shouldCloseOnOverlayClick: true, closeAnalyticsTracking: __assign({}, closeAnalytics), onClose: this.props.onClose, maintainPosition: true, colorTheme: 'dark' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "modal displayed", pageSection: pageSection, subtype: "cfp" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "" + __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a[modalClassName], className: "jg-space-ptlg jg-space-pblg jg-space-phml" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_8__high_five_svg___default.a, className: "jg-svg-sm jg-center-block " + __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a[highFiveImageClassName] }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center " + __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a[titleClassName] },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: "ThankYouForHelpingModal.title" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--center subtitle " + __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a[subtitleClassName] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: "ThankYouForHelpingModal.body" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-background--white ja-tac jg-space-ptmd jg-center-block " + __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a[buttonContainerClassName] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Page_DonateButton__["a" /* default */], { isActive: canPageReceiveDonations, donate: this.donate, pageSection: pageSection, name: pageName }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ClickableElement__["a" /* default */], { className: "jg-text--link jg-text--center jg-space-ptmd", onClick: this.props.onClose, analyticsOptions: __assign({}, closeAnalytics) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* Trans */], { i18nKey: "ThankYouForHelpingModal.laterButton" })))))));
    };
    return ThankYouForHelpingModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(ThankYouForHelpingModal, __WEBPACK_IMPORTED_MODULE_9__ThankYouForHelpingModal_scss___default.a));


/***/ }),

/***/ "./src/components/ShareWithFriendsPrompts/high-five.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/SocialShare/CopyLink.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_clipboard_js__ = __webpack_require__("./node_modules/react-clipboard.js/dist/react-clipboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/link.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_tick_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/tick.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_tick_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







var CopyLink = /** @class */ (function (_super) {
    __extends(CopyLink, _super);
    function CopyLink(props) {
        var _this = _super.call(this, props) || this;
        _this.onCopyUrlToClipboardSuccess = function () {
            var _a = _this.props, pageSection = _a.pageSection, sharePageLink = _a.sharePageLink;
            var copyLinkUtmTerm = _this.state.copyLinkUtmTerm;
            sharePageLink({ shareHash: copyLinkUtmTerm, location: pageSection });
            _this.setState({ copied: true });
            setTimeout(function () {
                _this.setState(__assign({ copied: false }, _this.generateCopyLinkState()));
            }, 5000);
        };
        _this.generateCopyLinkState = function () {
            var socialShareUrl = _this.props.socialShareUrl;
            var utmTerm = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__["a" /* generateHash */])();
            var url = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, { utm_term: utmTerm });
            return { copyLinkUrl: url, copyLinkUtmTerm: utmTerm };
        };
        _this.state = __assign({ copied: false }, _this.generateCopyLinkState());
        return _this;
    }
    CopyLink.prototype.render = function () {
        var _a = this.props, copyText = _a.copyText, copiedText = _a.copiedText, className = _a.className, isDisabled = _a.isDisabled;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: className },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_clipboard_js___default.a, { className: "jg-btn jg-btn--ghost", "button-disabled": isDisabled, "data-clipboard-text": this.state.copyLinkUrl, onSuccess: this.onCopyUrlToClipboardSuccess }, !this.state.copied ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_5__justgiving_icons_lib_link_svg___default.a, className: "jg-icon jg-fill--nobel jg-icon--medium jg-display-flex jg-position-absolute" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" }, copyText))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_6__justgiving_icons_lib_tick_svg___default.a, className: "jg-icon jg-fill--mountain-meadow jg-icon--medium jg-display-flex jg-position-absolute" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--large" }, copiedText))))));
    };
    return CopyLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CopyLink);


/***/ }),

/***/ "./src/components/SocialShare/Email.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Email; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");

var Email = /** @class */ (function () {
    function Email() {
    }
    Email.prototype.i18nWithEnrichment = function (key, defaultValue) {
        return __WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].t(key, {
            defaultValue: defaultValue,
            targetAmountFormatted: this.targetAmountFormatted,
            pitchFor: this.pitchFor,
            pageUrl: this.pageUrl,
            ownerName: this.ownerName,
            homeUrl: this.homeUrl,
        });
    };
    return Email;
}());



/***/ }),

/***/ "./src/components/SocialShare/EmailShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"email":"_3Lj7u"};

/***/ }),

/***/ "./src/components/SocialShare/EmailShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailShare_scss__ = __webpack_require__("./src/components/SocialShare/EmailShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EmailShare_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OwnerShareEmail__ = __webpack_require__("./src/components/SocialShare/OwnerShareEmail.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SupporterShareEmail__ = __webpack_require__("./src/components/SocialShare/SupporterShareEmail.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShareWithFriendsEmail__ = __webpack_require__("./src/components/SocialShare/ShareWithFriendsEmail.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_config__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var EmailShare = /** @class */ (function (_super) {
    __extends(EmailShare, _super);
    function EmailShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTargetAmountFormatted = function () {
            return "" + (__WEBPACK_IMPORTED_MODULE_4_src_helpers_currencyMap__["e" /* default */][_this.props.targetCurrency] || __WEBPACK_IMPORTED_MODULE_4_src_helpers_currencyMap__["e" /* default */].GBP) + _this.props.targetAmount;
        };
        _this.handleEmailShare = function () {
            var _a = _this.props, messageType = _a.messageType, location = _a.location, shareByEmail = _a.shareByEmail, eventValue = _a.eventValue, socialShareUrl = _a.socialShareUrl, pitchFor = _a.pitchFor, ownerName = _a.ownerName;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_hashId__["a" /* generateHash */])();
            var email;
            switch (messageType) {
                case 'ownerShare': {
                    email = new __WEBPACK_IMPORTED_MODULE_6__OwnerShareEmail__["a" /* OwnerShareEmail */]();
                    email.pageUrl = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
                        utm_id: 1,
                        utm_term: shareHash,
                    });
                    break;
                }
                case 'shareWithFriends': {
                    email = new __WEBPACK_IMPORTED_MODULE_8__ShareWithFriendsEmail__["a" /* ShareWithFriendsEmail */]();
                    email.pageUrl = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
                        utm_term: shareHash,
                    });
                    break;
                }
                default: {
                    email = new __WEBPACK_IMPORTED_MODULE_7__SupporterShareEmail__["a" /* SupporterShareEmail */]();
                    email.pageUrl = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
                        utm_id: 2,
                        utm_term: shareHash,
                    });
                    break;
                }
            }
            email.homeUrl = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_url__["a" /* buildUrl */])(__WEBPACK_IMPORTED_MODULE_9_config__["HOME_URI"], {
                utm_id: 3,
                utm_term: shareHash,
            });
            email.pitchFor = pitchFor;
            email.targetAmountFormatted = _this.getTargetAmountFormatted();
            email.ownerName = ownerName;
            shareByEmail({
                shareHash: shareHash,
                location: location,
                eventValue: eventValue,
            });
            if (window && window.location) {
                window.location.href = "mailto:?subject=" + encodeURIComponent(email.getSubject()) + "&body=" + encodeURIComponent(email.getBody());
            }
        };
        return _this;
    }
    EmailShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: className, styleName: customStyle, onClick: this.handleEmailShare }, buttonText || 'Email'));
    };
    return EmailShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(EmailShare, __WEBPACK_IMPORTED_MODULE_5__EmailShare_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/MessengerShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MessengerShare = /** @class */ (function (_super) {
    __extends(MessengerShare, _super);
    function MessengerShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMessengerShare = function () {
            var _a = _this.props, socialShareUrl = _a.socialShareUrl, shareOnMessenger = _a.shareOnMessenger, location = _a.location;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_hashId__["a" /* generateHash */])();
            shareOnMessenger({
                shareHash: shareHash,
                location: location,
            });
            if (true) {
                window.location.href = "fb-messenger://share?link=" + encodeURIComponent(socialShareUrl) + "&app_id=" + __WEBPACK_IMPORTED_MODULE_2_config__["FB_APP_ID"];
            }
        };
        return _this;
    }
    MessengerShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: className || '', styleName: customStyle, onClick: this.handleMessengerShare }, buttonText || 'Messenger'));
    };
    MessengerShare.propTypes = {
        shareOnMessenger: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        socialShareUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        customStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        buttonText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    };
    return MessengerShare;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MessengerShare);


/***/ }),

/***/ "./src/components/SocialShare/MessengerShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page-owner-messenger-share-button":"_1aaHh"};

/***/ }),

/***/ "./src/components/SocialShare/MessengerShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MessengerShareButton_scss__ = __webpack_require__("./src/components/SocialShare/MessengerShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MessengerShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MessengerShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MessengerShareButton = /** @class */ (function (_super) {
    __extends(MessengerShareButton, _super);
    function MessengerShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMessengerShare = function () {
            var _a = _this.props, socialShareUrl = _a.socialShareUrl, shareOnMessenger = _a.shareOnMessenger, location = _a.location;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_hashId__["a" /* generateHash */])();
            shareOnMessenger({
                shareHash: shareHash,
                location: location,
            });
            var pageUrl = Object(__WEBPACK_IMPORTED_MODULE_7_src_helpers_url__["a" /* buildUrl */])(socialShareUrl, {
                utm_term: shareHash,
            });
            if (true) {
                var isMobile = !Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__["d" /* isDesktopViewport */])();
                if (isMobile) {
                    window.location.href = "fb-messenger://share?link=" + encodeURIComponent(pageUrl) + "&app_id=" + __WEBPACK_IMPORTED_MODULE_2_config__["FB_APP_ID"];
                }
                else {
                    FB.ui({
                        method: 'send',
                        link: pageUrl,
                    }, function () { });
                }
            }
        };
        return _this;
    }
    MessengerShareButton.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { type: "button", className: "jg-btn jg-btn--messenger", onClick: this.handleMessengerShare, styleName: "page-owner-messenger-share-button" }, "Messenger"));
    };
    MessengerShareButton.propTypes = {
        shareOnMessenger: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        socialShareUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    };
    return MessengerShareButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(MessengerShareButton, __WEBPACK_IMPORTED_MODULE_5__MessengerShareButton_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/OwnerShareEmail.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OwnerShareEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Email__ = __webpack_require__("./src/components/SocialShare/Email.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var OwnerShareEmail = /** @class */ (function (_super) {
    __extends(OwnerShareEmail, _super);
    function OwnerShareEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSubject = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.owner.subject', 'Please donate to my Crowdfunding Page');
        };
        _this.getBody = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.owner.body', "Hello,\nWe're raising {{targetAmountFormatted}} to {{pitchFor}}.\nPlease donate to my JustGiving Crowdfunding Page and help make it happen:\n\n{{- pageUrl}}\n\nThanks for your support\n\n\nPS. With JustGiving Crowdfunding anyone can raise money to fund their own project - anything from setting up a foodbank, to buying a wheelchair for a relative or even saving a local football club. Want to raise money to make good things happen? Start your Crowdfunding Page today.\n\n{{- homeUrl}}");
        };
        return _this;
    }
    return OwnerShareEmail;
}(__WEBPACK_IMPORTED_MODULE_0__Email__["a" /* Email */]));



/***/ }),

/***/ "./src/components/SocialShare/QRCodeShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_qrcode_svg__ = __webpack_require__("./src/components/SocialShare/images/qrcode.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_qrcode_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_qrcode_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var QRCodeShare = /** @class */ (function (_super) {
    __extends(QRCodeShare, _super);
    function QRCodeShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleQrCodeShare = function () {
            var _a = _this.props, handleClick = _a.handleClick, location = _a.location;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_hashId__["a" /* generateHash */])();
            _this.props.shareQrCode({ location: location, shareHash: shareHash });
            handleClick();
        };
        return _this;
    }
    QRCodeShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, classNames = _a.classNames;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: classNames || 'jg-btn jg-btn--ghost jg-space-mbms jg-text--large', styleName: customStyle, onClick: this.handleQrCodeShare },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_2__images_qrcode_svg___default.a, className: "jg-icon jg-fill--nobel jg-icon--medium jg-display-flex jg-position-absolute" }),
            buttonText || 'QR Code'));
    };
    return QRCodeShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (QRCodeShare);


/***/ }),

/***/ "./src/components/SocialShare/ShareWithFriendsEmail.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareWithFriendsEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Email__ = __webpack_require__("./src/components/SocialShare/Email.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ShareWithFriendsEmail = /** @class */ (function (_super) {
    __extends(ShareWithFriendsEmail, _super);
    function ShareWithFriendsEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSubject = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.friend.subject', 'Please help me get started with my JustGiving Page');
        };
        _this.getBody = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.friend.body', "Hello,\n\nI've created a JustGiving page to raise {{targetAmountFormatted}} to {{pitchFor}} and it would be great if you could help me get started:\n\n{{- pageUrl}}\n\nPlease donate and share, and let me know if you have any suggestions.\n\nThank you for your support\n\n{{ownerName}}");
        };
        return _this;
    }
    return ShareWithFriendsEmail;
}(__WEBPACK_IMPORTED_MODULE_0__Email__["a" /* Email */]));



/***/ }),

/***/ "./src/components/SocialShare/SmsShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sms":"JdDuH"};

/***/ }),

/***/ "./src/components/SocialShare/SmsShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SmsShare_scss__ = __webpack_require__("./src/components/SocialShare/SmsShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SmsShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SmsShare_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var SmsShare = /** @class */ (function (_super) {
    __extends(SmsShare, _super);
    function SmsShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSmsShare = function () {
            var _a = _this.props, ownerName = _a.ownerName, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, socialShareUrl = _a.socialShareUrl, isOwner = _a.isOwner, shareBySms = _a.shareBySms, location = _a.location, targetCurrency = _a.targetCurrency;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_hashId__["a" /* generateHash */])();
            var target = "" + (__WEBPACK_IMPORTED_MODULE_4__helpers_currencyMap__["e" /* default */][targetCurrency] || '£') + targetAmount;
            var body;
            if (isOwner) {
                var pageUrl = socialShareUrl + "?" + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                    utm_id: 92,
                    utm_term: shareHash,
                });
                body = "Can you help me raise " + target + " to " + pitchFor + ". Please donate to my JustGiving Crowdfunding Page: " + pageUrl;
            }
            else {
                var pageUrl = socialShareUrl + "?" + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                    utm_id: 102,
                    utm_term: shareHash,
                });
                body = "Can you help " + ownerName + " raise " + target + " to " + pitchFor + ". Please donate to their JustGiving Crowdfunding Page: " + pageUrl;
            }
            shareBySms({ shareHash: shareHash, location: location });
            if (true) {
                _this.share(body);
            }
        };
        return _this;
    }
    SmsShare.prototype.share = function (body) {
        var getUserAgentInfo = function () {
            var userAgent = navigator.userAgent;
            var info = { android: false, ios: false, version: 0 };
            if (userAgent.match(/iPad/i) ||
                userAgent.match(/iPhone/i) ||
                userAgent.match(/iPod/i)) {
                info.ios = true;
                var match = userAgent.match(/os (\d+)_/i);
                if (match) {
                    info.version = parseInt(match[1], 10);
                }
            }
            var androidMatches = userAgent.match(/Android/i);
            info.android = Array.isArray(androidMatches) && androidMatches.length > 0;
            return info;
        };
        var userAgentInfo = getUserAgentInfo();
        var bodySeparator = userAgentInfo.ios
            ? userAgentInfo.version >= 8
                ? '&'
                : ';'
            : '?';
        var bodyString = encodeURIComponent(body);
        var encodedAmp = encodeURIComponent('&');
        // FIX for https://stackoverflow.com/questions/19022537/html-sms-message-body-everything-after-symbol-disappears by double encoding on Android
        var smsBody = userAgentInfo.android
            ? bodyString.replace(encodedAmp, encodeURIComponent(encodedAmp))
            : bodyString;
        window.location.assign("sms:" + bodySeparator + "body=" + smsBody);
    };
    SmsShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: className, styleName: customStyle, onClick: this.handleSmsShare }, buttonText || 'SMS'));
    };
    return SmsShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(SmsShare, __WEBPACK_IMPORTED_MODULE_5__SmsShare_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/SocialShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_5dgpD","title":"_3LJ0t","mobile-only":"spbXb","mobile-button-container":"_39MaO","desktop-button-container":"RInHF","social-button-wrapper":"_2oyXL","button":"_166d9","social-button":"_2iqqI","button-facebook":"_3KS-I","button-twitter":"u6xYU","button-email":"_2qO_7","button-whatsapp":"_3ObkP","button-sms":"_1oeaj","button-no-padding":"_2xlA8","button-sms-block":"_29yHZ","button-messenger":"_3_Njq","whatsapp-styles":"_2fukZ","sms-styles":"_3tNOo"};

/***/ }),

/***/ "./src/components/SocialShare/SocialShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_SocialShare_CopyLink__ = __webpack_require__("./src/components/SocialShare/CopyLink.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_SocialShare_EmailShare__ = __webpack_require__("./src/components/SocialShare/EmailShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_FacebookShare_FacebookShare__ = __webpack_require__("./src/components/FacebookShare/FacebookShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__ = __webpack_require__("./src/components/SocialShare/SmsShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_SocialShare_TwitterShare__ = __webpack_require__("./src/components/SocialShare/TwitterShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_SocialShare_WhatsAppShare__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss__ = __webpack_require__("./src/components/SocialShare/SocialShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var shareLocation = 'page > social share';
var SocialShare = /** @class */ (function (_super) {
    __extends(SocialShare, _super);
    function SocialShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getEmailMessageType = function () {
            if (_this.props.isOwner) {
                return 'ownerShare';
            }
            return 'supporterShare';
        };
        _this.getWhatsAppMessageType = function () {
            if (_this.props.isOwner) {
                return 'ownerShare';
            }
            return 'supporterShare';
        };
        return _this;
    }
    SocialShare.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scroll__["Element"], { name: "share-story" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "container" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h1", { className: "jg-h4", styleName: "title" }, "Share this story"),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "mobile-only" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "mobile-button-container" },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_FacebookShare_FacebookShare__["a" /* default */], { isActive: this.props.isActive, buttonText: "Facebook", location: shareLocation, customStyle: __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a['button-facebook'] }),
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_SocialShare_EmailShare__["a" /* default */], { shareByEmail: this.props.shareByEmail, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isActive: this.props.isActive, targetCurrency: this.props.page.targetCurrency, location: shareLocation, className: __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a['button-email'], messageType: this.getEmailMessageType() }),
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_SocialShare_SmsShare__["a" /* default */], { shareBySms: this.props.shareBySms, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isActive: this.props.isActive, isOwner: this.props.isOwner, targetCurrency: this.props.page.targetCurrency, location: shareLocation, className: __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a['button-sms'] }),
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_SocialShare_WhatsAppShare__["a" /* default */], { shareByWhatsApp: this.props.shareByWhatsApp, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isActive: this.props.isActive, targetCurrency: this.props.page.targetCurrency, location: shareLocation, className: __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a['button-whatsapp'], messageType: this.getWhatsAppMessageType() }),
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_SocialShare_TwitterShare__["a" /* default */], { shareOnTwitter: this.props.shareOnTwitter, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, isActive: this.props.isActive, isOwner: this.props.isOwner, targetCurrency: this.props.page.targetCurrency, location: shareLocation, className: __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a['button-twitter'] })),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_SocialShare_CopyLink__["a" /* default */], { className: "jg-space-mtsm jg-space-mhsm jg-space-mhxl@md", copyText: "Copy link", copiedText: "Link copied", isDisabled: !this.props.isActive, pageSection: shareLocation, socialShareUrl: this.props.socialShareUrl, sharePageLink: this.props.sharePageLink })),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "desktop-button-container" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "social-button-wrapper" },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_FacebookShare_FacebookShare__["a" /* default */], { isActive: this.props.isActive, location: shareLocation, buttonText: "Facebook", customStyle: "jg-btn jg-btn--facebook" })),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "social-button-wrapper" },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_SocialShare_EmailShare__["a" /* default */], { shareByEmail: this.props.shareByEmail, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isActive: this.props.isActive, targetCurrency: this.props.page.targetCurrency, location: shareLocation, buttonText: "Email", className: "jg-btn jg-btn--ghost", messageType: this.getEmailMessageType() })),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "social-button-wrapper" },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_SocialShare_TwitterShare__["a" /* default */], { shareOnTwitter: this.props.shareOnTwitter, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, isActive: this.props.isActive, isOwner: this.props.isOwner, targetCurrency: this.props.page.targetCurrency, location: shareLocation, buttonText: "Twitter", className: "jg-btn jg-btn--twitter" }))))));
    };
    return SocialShare;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_css_modules___default()(SocialShare, __WEBPACK_IMPORTED_MODULE_9_src_components_SocialShare_SocialShare_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/SupporterShareEmail.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SupporterShareEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Email__ = __webpack_require__("./src/components/SocialShare/Email.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SupporterShareEmail = /** @class */ (function (_super) {
    __extends(SupporterShareEmail, _super);
    function SupporterShareEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSubject = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.supporter.subject', "Donate to {{ownerName}}'s Crowdfunding Page to {{pitchFor}}");
        };
        _this.getBody = function () {
            return _super.prototype.i18nWithEnrichment.call(_this, 'Share.email.supporter.body', 'Hello,\nCan you help {{ownerName}} raise {{targetAmountFormatted}} to {{pitchFor}}? Please donate to their JustGiving Crowdfunding Page:\n\n{{- pageUrl}}\n\nThanks for your support\n\n\nPS. With JustGiving Crowdfunding anyone can raise money to fund their own project - anything from setting up a foodbank, to buying a wheelchair for a relative or even saving a local football club. Want to raise money to make good things happen? Start your Crowdfunding Page today.\n\n{{- homeUrl}}');
        };
        return _this;
    }
    return SupporterShareEmail;
}(__WEBPACK_IMPORTED_MODULE_0__Email__["a" /* Email */]));



/***/ }),

/***/ "./src/components/SocialShare/TwitterShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/SocialShare/TwitterShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwitterShare_scss__ = __webpack_require__("./src/components/SocialShare/TwitterShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwitterShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TwitterShare_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var TwitterShare = /** @class */ (function (_super) {
    __extends(TwitterShare, _super);
    function TwitterShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTwitterShare = function () {
            var _a = _this.props, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, shareOnTwitter = _a.shareOnTwitter, socialShareUrl = _a.socialShareUrl, location = _a.location, isOwner = _a.isOwner, onClickCallback = _a.onClickCallback, targetCurrency = _a.targetCurrency;
            if (onClickCallback) {
                onClickCallback();
            }
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_hashId__["a" /* generateHash */])();
            var target = "" + (__WEBPACK_IMPORTED_MODULE_4__helpers_currencyMap__["e" /* default */][targetCurrency] || '£') + targetAmount;
            var text = isOwner
                ? "Help me raise " + target + " to " + pitchFor + ". Please #donate on @justgiving and RT. Thanks!"
                : "Help raise " + target + " to " + _this.truncate(pitchFor, 55) + " Please #donate on @justgiving and RT";
            var utmId = isOwner ? 60 : 66;
            var url = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_url__["a" /* buildUrl */])('https://twitter.com/share', {
                text: text,
                url: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_url__["a" /* buildUrl */])(socialShareUrl, { utm_id: utmId, utm_term: shareHash }),
            });
            shareOnTwitter({
                shareHash: shareHash,
                location: location,
            });
            if (true) {
                window.open(url, 'twitterShareWindow', 'status=1, height=300, width=640, resizable=1');
            }
        };
        return _this;
    }
    TwitterShare.prototype.truncate = function (str, length) {
        return str.length > length ? str.substring(0, length) + ".." : str;
    };
    TwitterShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: className, styleName: customStyle, onClick: this.handleTwitterShare }, buttonText || 'Twitter'));
    };
    return TwitterShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(TwitterShare, __WEBPACK_IMPORTED_MODULE_5__TwitterShare_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/WhatsAppShare.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/SocialShare/WhatsAppShare.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WhatsAppShare_scss__ = __webpack_require__("./src/components/SocialShare/WhatsAppShare.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WhatsAppShare_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WhatsAppShare_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var WhatsAppShare = /** @class */ (function (_super) {
    __extends(WhatsAppShare, _super);
    function WhatsAppShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleWhatsAppShare = function () {
            var _a = _this.props, location = _a.location, shareByWhatsApp = _a.shareByWhatsApp;
            var shareHash = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_hashId__["a" /* generateHash */])();
            shareByWhatsApp({ shareHash: shareHash, location: location });
            var message = _this.buildMessage(shareHash);
            if (true) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__["h" /* isMobileUserAgent */])()) {
                    window.location.href = "whatsapp://send?text=" + encodeURIComponent(message);
                }
                else {
                    window.open("https://web.whatsapp.com/send?text=" + encodeURIComponent(message), '_blank');
                }
            }
        };
        _this.buildMessage = function (shareHash) {
            var _a = _this.props, messageType = _a.messageType, ownerName = _a.ownerName, pitchFor = _a.pitchFor;
            var message;
            switch (messageType) {
                case 'shareWithFriends':
                    message = __WEBPACK_IMPORTED_MODULE_6_i18next__["a" /* default */].t('Share.whatsApp.friend.message', {
                        defaultValue: "I've created a JustGiving page to raise {{targetAmountFormatted}} to {{pitchFor}} and it would be great if you could help me get started:\n\n{{- pageUrl}}\n\nPlease donate and share, and let me know if you have any suggestions.",
                        targetAmountFormatted: _this.getTargetAmountFormatted(),
                        pitchFor: pitchFor,
                        pageUrl: _this.getPageUrl(shareHash),
                        ownerName: ownerName,
                    });
                case 'ownerShare':
                    message = __WEBPACK_IMPORTED_MODULE_6_i18next__["a" /* default */].t('Share.whatsApp.owner.message', {
                        defaultValue: "Can you help me raise {{targetAmountFormatted}} to {{pitchFor}}. Please donate to my JustGiving Crowdfunding Page: {{- pageUrl}}",
                        targetAmountFormatted: _this.getTargetAmountFormatted(),
                        pitchFor: pitchFor,
                        pageUrl: _this.getPageUrl(shareHash),
                        ownerName: ownerName,
                    });
                default:
                    message = __WEBPACK_IMPORTED_MODULE_6_i18next__["a" /* default */].t('Share.whatsApp.supporter.message', {
                        defaultValue: "Can you help {{ownerName}} raise {{targetAmountFormatted}} to {{pitchFor}}. Please donate to their JustGiving Crowdfunding Page: {{- pageUrl}}",
                        targetAmountFormatted: _this.getTargetAmountFormatted(),
                        pitchFor: pitchFor,
                        pageUrl: _this.getPageUrl(shareHash),
                        ownerName: ownerName,
                    });
            }
            return message;
        };
        _this.getTargetAmountFormatted = function () {
            return "" + (__WEBPACK_IMPORTED_MODULE_3__helpers_currencyMap__["e" /* default */][_this.props.targetCurrency] || __WEBPACK_IMPORTED_MODULE_3__helpers_currencyMap__["e" /* default */].GBP) + _this.props.targetAmount;
        };
        _this.getPageUrl = function (shareHash) {
            return _this.props.socialShareUrl + "?utm_term=" + shareHash;
        };
        return _this;
    }
    WhatsAppShare.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, customStyle = _a.customStyle, buttonText = _a.buttonText, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", disabled: !isActive, className: className, styleName: customStyle, onClick: this.handleWhatsAppShare }, buttonText || 'WhatsApp'));
    };
    WhatsAppShare.propTypes = {};
    return WhatsAppShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(WhatsAppShare, __WEBPACK_IMPORTED_MODULE_4__WhatsAppShare_scss___default.a));


/***/ }),

/***/ "./src/components/SocialShare/images/qrcode.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/SpeechBubbleWithAvatar/AvatarAndName.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");


var AvatarAndName = function (_a) {
    var avatarImage = _a.avatarImage, name = _a.name, namePosition = _a.namePosition, showName = _a.showName;
    if (!showName) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" }));
    }
    switch (namePosition) {
        case 'above':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--xsmall jg-color--nobel jg-space-mbn" }, name),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" })));
        case 'below':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--xsmall jg-color--nobel jg-space-mbn" }, name)));
        case 'left':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall jg-color--nobel jg-space-mrxs" }, name),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" })));
        case 'right':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall jg-color--nobel jg-space-mlxs" }, name)));
        default:
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Avatar__["b" /* OwnerAvatar */], { src: avatarImage, alt: "image of crowdfunder", size: "xxsmall" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--xsmall jg-color--nobel jg-space-mbn" }, name)));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (AvatarAndName);


/***/ }),

/***/ "./src/components/SpeechBubbleWithAvatar/MessageBox.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpeechBubbleWithAvatar_scss__ = __webpack_require__("./src/components/SpeechBubbleWithAvatar/SpeechBubbleWithAvatar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SpeechBubbleWithAvatar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SpeechBubbleWithAvatar_scss__);


var MessageBox = function (_a) {
    var arrowPosition = _a.arrowPosition, message = _a.message;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bd jg-bd--solid jg-bd--very-light-grey jg-bd--radius-3px jg-space-pms jg-position-relative jg-preserve-whitespace " + __WEBPACK_IMPORTED_MODULE_1__SpeechBubbleWithAvatar_scss___default.a["supporter-message-box-" + arrowPosition] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--light jg-space-mbn" }, message)));
};
/* harmony default export */ __webpack_exports__["a"] = (MessageBox);


/***/ }),

/***/ "./src/components/SpeechBubbleWithAvatar/SpeechBubbleWithAvatar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"supporter-message-box-bottom":"_2V6BY","supporter-message-box-bottom-left":"_2qHBa","bottom-right":"_21jLE","supporter-message-box-bottom-right":"_5cP5k","supporter-message-box-left":"wtCBr","supporter-message-box-left-top":"_1AG9f","left-bottom":"_2c89Y","supporter-message-box-left-bottom":"_2MJB1","supporter-message-box-right":"_3M0o9","right-bottom":"_2PcJQ","supporter-message-box-right-bottom":"_3bEmH","supporter-message-box-right-top":"_1jAmx","supporter-message-box-top":"_19miy","supporter-message-box-top-left":"_2lP0f","top-right":"_2ecj1","supporter-message-box-top-right":"_3WuwN"};

/***/ }),

/***/ "./src/components/SpeechBubbleWithAvatar/SpeechBubbleWithAvatar.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvatarAndName__ = __webpack_require__("./src/components/SpeechBubbleWithAvatar/AvatarAndName.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageBox__ = __webpack_require__("./src/components/SpeechBubbleWithAvatar/MessageBox.tsx");



var SpeechBubbleWithAvatar = function (_a) {
    var _b = _a.arrowPosition, arrowPosition = _b === void 0 ? 'bottom' : _b, avatarImage = _a.avatarImage, message = _a.message, name = _a.name, _c = _a.namePosition, namePosition = _c === void 0 ? 'below' : _c, _d = _a.showAvatar, showAvatar = _d === void 0 ? true : _d, _e = _a.showName, showName = _e === void 0 ? false : _e;
    var avatarAndName = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AvatarAndName__["a" /* default */], { avatarImage: avatarImage, name: name, namePosition: namePosition, showName: showName }));
    var messageBox = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MessageBox__["a" /* default */], { arrowPosition: arrowPosition, message: message }));
    switch (arrowPosition) {
        case 'bottom':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtms jg-text--center" }, showAvatar && avatarAndName)));
        case 'bottom-left':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtms jg-space-plsm jg-text--pull-left" }, showAvatar && avatarAndName)));
        case 'bottom-right':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtms jg-space-prmd jg-text--pull-right" }, showAvatar && avatarAndName)));
        case 'left':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-display-flex jg-flex-aic" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mrms jg-flex-s0" }, showAvatar && avatarAndName),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox)));
        case 'left-top':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-ais" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mrms jg-space-ptsm jg-flex-s0" }, showAvatar && avatarAndName),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox)));
        case 'left-bottom':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-aie" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mrms jg-flex-s0 " + (showName ? '' : 'jg-space-pbmd') }, showAvatar && avatarAndName),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox)));
        case 'right':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mlms jg-display-flex jg-flex-aic jg-flex-s0" }, showAvatar && avatarAndName)));
        case 'right-bottom':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-aie" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mlms jg-flex-s0 " + (showName ? '' : 'jg-space-pbmd') }, showAvatar && avatarAndName)));
        case 'right-top':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-ais" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-flex-g1" }, messageBox),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mlms jg-space-ptsm jg-flex-s0" }, showAvatar && avatarAndName)));
        case 'top':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--center " + (showName ? 'jg-space-mbms' : 'jg-space-pbmd') }, showAvatar && avatarAndName),
                messageBox));
        case 'top-left':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--pull-left jg-space-plsm jg-space-mbms" }, showAvatar && avatarAndName),
                messageBox));
        case 'top-right':
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--pull-right jg-space-prmd " + (showName ? 'jg-space-mbms' : 'jg-space-pbmd') }, showAvatar && avatarAndName),
                messageBox));
        default:
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtms jg-text--center" }, showAvatar && avatarAndName)));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (SpeechBubbleWithAvatar);


/***/ }),

/***/ "./src/components/StickyHeader/Sticky.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__("./node_modules/lodash/throttle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Sticky = /** @class */ (function (_super) {
    __extends(Sticky, _super);
    function Sticky() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sticky: false,
        };
        _this.handleScroll = __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            var pastOffset = scrollPosition > _this.props.offset;
            if (_this.state.sticky !== pastOffset) {
                _this.setState({
                    sticky: pastOffset,
                });
            }
        }, _this.props.delay || 750);
        return _this;
    }
    Sticky.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.handleScroll);
    };
    Sticky.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleScroll);
    };
    Sticky.prototype.render = function () {
        return this.props.children({
            sticky: this.state.sticky,
        });
    };
    return Sticky;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Sticky);


/***/ }),

/***/ "./src/components/StickyHeader/StickyHeader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_3x32h","header--show":"_10f-5"};

/***/ }),

/***/ "./src/components/StickyHeader/StickyHeaderDonor.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_responsive__ = __webpack_require__("./node_modules/@justgiving/responsive/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Page_DonateButton__ = __webpack_require__("./src/components/Page/DonateButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StickyHeader_scss__ = __webpack_require__("./src/components/StickyHeader/StickyHeader.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StickyHeader_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StickyHeader_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_StickyHeader_Sticky__ = __webpack_require__("./src/components/StickyHeader/Sticky.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShareModal_ShareButton__ = __webpack_require__("./src/components/ShareModal/ShareButton.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var StickyHeader = /** @class */ (function (_super) {
    __extends(StickyHeader, _super);
    function StickyHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StickyHeader.prototype.calculateWindowHeight = function () {
        return (window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight);
    };
    StickyHeader.prototype.render = function () {
        var _a = this.props, ownerName = _a.ownerName, ownerProfileImageUrl = _a.ownerProfileImageUrl, pageName = _a.pageName, canPageReceiveDonations = _a.canPageReceiveDonations, donate = _a.donate, handleShareButtonClick = _a.handleShareButtonClick, disableShare = _a.disableShare;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_responsive__["d" /* Medium */], null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_StickyHeader_Sticky__["a" /* default */], { offset:  true ? this.calculateWindowHeight() * 0.5 : 0 }, function (_a) {
                var sticky = _a.sticky;
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bdb jg-bd--solid jg-bd--very-light-grey jg-background--white " + __WEBPACK_IMPORTED_MODULE_5__StickyHeader_scss___default.a.header + " " + (sticky ? __WEBPACK_IMPORTED_MODULE_5__StickyHeader_scss___default.a['header--show'] : '') },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: "container jg-space-pvms" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-space-phsm@md jg-space-ph@lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-lg-6 col-xl-8" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row jg-flex-aic jg-flex-nowrap" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Avatar__["b" /* OwnerAvatar */], { src: ownerProfileImageUrl, alt: ownerName, size: "small" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn jg-space-mlmd" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", { className: "jg-display-i" }, ownerName),
                                        ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "StickyHeader.isCrowdfunding", defaultMessage: "is crowdfunding" })))),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-lg-6 col-xl-4" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-6" }, canPageReceiveDonations && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Page_DonateButton__["a" /* default */], { donate: donate, isActive: canPageReceiveDonations, name: pageName, pageSection: "page > share and donate fixed header" }))),
                                    !disableShare && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-md-6" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ShareModal_ShareButton__["a" /* default */], { handleShareClick: handleShareButtonClick })))))))));
            })));
    };
    return StickyHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (StickyHeader);


/***/ }),

/***/ "./src/components/SupportMessage/SupportMessage.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Ma9i","title":"_1RpFZ","comments":"_1gNlM"};

/***/ }),

/***/ "./src/components/SupportMessage/SupportMessage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupportMessage_scss__ = __webpack_require__("./src/components/SupportMessage/SupportMessage.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupportMessage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SupportMessage_scss__);
/* global FB */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




if (true) {
    window.addEventListener('onload', function () {
        (function fbLoad(d, s, id) {
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            var js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v5.0&appId=" + __WEBPACK_IMPORTED_MODULE_2_config___default.a.FB_APP_ID;
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    });
}
var SupportMessage = /** @class */ (function (_super) {
    __extends(SupportMessage, _super);
    function SupportMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SupportMessage.prototype.componentDidMount = function () {
        try {
            // todo: move FB API call to a helper function
            if (typeof FB !== 'undefined' && FB.XFBML && FB.XFBML.parse) {
                FB.XFBML.parse();
            }
        }
        catch (e) {
            // try catch to prevent page failing to load
            // { innerError: undefined, message: 'init not called with valid version' }
        }
    };
    SupportMessage.prototype.render = function () {
        var socialShareUrl = this.props.socialShareUrl;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "jg-h2", styleName: "title" }, "Leave a message of support"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "comments" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "fb-comments", "data-colorscheme": "light", "data-href": socialShareUrl, "data-numposts": "3", "data-width": "100%" }))));
    };
    return SupportMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(SupportMessage, __WEBPACK_IMPORTED_MODULE_3__SupportMessage_scss___default.a));


/***/ }),

/***/ "./src/components/Supporters/BecomeSupporter.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_1d5Oo","donate":"_3uA1v","become-supporter-container":"_3ssrm","become-supporter-header":"_2OiYX","become-supporter-paragraph":"A9NAs","become-supporter-text":"_2AwfJ"};

/***/ }),

/***/ "./src/components/Supporters/BecomeSupporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BecomeSupporter_scss__ = __webpack_require__("./src/components/Supporters/BecomeSupporter.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BecomeSupporter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BecomeSupporter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Page_DonateButton__ = __webpack_require__("./src/components/Page/DonateButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BecomeSupporter = /** @class */ (function (_super) {
    __extends(BecomeSupporter, _super);
    function BecomeSupporter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.donate = function () {
            var _a = _this.props, donate = _a.donate, canPageReceiveDonations = _a.canPageReceiveDonations;
            if (canPageReceiveDonations) {
                donate();
            }
        };
        return _this;
    }
    BecomeSupporter.prototype.render = function () {
        var _a = this.props, profileImage = _a.profileImage, canPageReceiveDonations = _a.canPageReceiveDonations, ownerName = _a.ownerName, name = _a.page.name;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "become-supporter-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Avatar__["b" /* OwnerAvatar */], { src: profileImage, alt: ownerName }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "become-supporter-text" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { styleName: "become-supporter-header" }, "Become a supporter"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { styleName: "become-supporter-paragraph" },
                        "Help ",
                        ownerName,
                        " raise more"))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "donate" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Page_DonateButton__["a" /* default */], { donate: this.donate, isActive: canPageReceiveDonations, name: name, pageSection: "page > supporters > become supporter" }))));
    };
    return BecomeSupporter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(BecomeSupporter, __WEBPACK_IMPORTED_MODULE_2__BecomeSupporter_scss___default.a));


/***/ }),

/***/ "./src/components/Supporters/LaunchYourPage.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"launch-your-page-container":"_2DzWM","launch-your-page-header":"_2vI5b","launch-your-page-paragraph":"_12IEb","launch-your-page-text":"_4P2tp"};

/***/ }),

/***/ "./src/components/Supporters/LaunchYourPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LaunchYourPage_scss__ = __webpack_require__("./src/components/Supporters/LaunchYourPage.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LaunchYourPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LaunchYourPage_scss__);



var LaunchYourPage = function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "launch-your-page-container" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "launch-your-page-text" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { styleName: "launch-your-page-header" }, "No supporters yet"),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { styleName: "launch-your-page-paragraph" }, "Launch your page to start receiving donations")))); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(LaunchYourPage, __WEBPACK_IMPORTED_MODULE_2__LaunchYourPage_scss___default.a));


/***/ }),

/***/ "./src/components/Supporters/Supporter.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"donation":"_24jUf","avatar":"_2OgA8","information":"_1PUNL","date":"_25aFt","supporter":"_2jatY","message":"_3HOJA"};

/***/ }),

/***/ "./src/components/Supporters/Supporter.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Supporter_scss__ = __webpack_require__("./src/components/Supporters/Supporter.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Supporter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_FormattedCurrency__ = __webpack_require__("./src/components/FormattedCurrency/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_comment_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/comment.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_comment_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_comment_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_tick_svg__ = __webpack_require__("./node_modules/@justgiving/icons/lib/tick.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_tick_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_ThankingDonors_ThankDonorModal__ = __webpack_require__("./src/components/ThankingDonors/ThankDonorModal.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var Supporter = /** @class */ (function (_super) {
    __extends(Supporter, _super);
    function Supporter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModalOpen: false,
        };
        _this.openModal = function () {
            _this.setState({ isModalOpen: true });
        };
        _this.closeModal = function () {
            _this.setState({ isModalOpen: false });
        };
        return _this;
    }
    Supporter.prototype.render = function () {
        var _a = this.props, isOwner = _a.isOwner, pageId = _a.pageId, profileImage = _a.profileImage, supporter = _a.supporter, targetCurrency = _a.targetCurrency, thankSupporter = _a.thankSupporter;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            this.state.isModalOpen && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_src_components_ThankingDonors_ThankDonorModal__["a" /* default */], { closeModal: this.closeModal, pageId: pageId, profileImage: profileImage, supporter: supporter, targetCurrency: targetCurrency, thankSupporter: thankSupporter })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default.a.donation },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Avatar__["c" /* SupporterAvatar */], { src: supporter.imageProfile, alt: supporter.name, size: "medium" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default.a.information },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default.a.supporter }, supporter.name),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default.a.date }, supporter.createdAt &&
                        __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(supporter.createdAt, 'MMM D, YYYY')),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_3__Supporter_scss___default.a.message }, supporter.message),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mtsm" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--brand jg-space-mbn" }, supporter.donationAmount && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_FormattedCurrency__["a" /* default */], { value: supporter.donationAmount, currency: supporter.donationCurrency || targetCurrency || 'GBP' }))),
                        isOwner && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, supporter.thankYouMessage ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-space-mtsm" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_8__justgiving_icons_lib_tick_svg___default.a, className: "jg-icon jg-fill--nobel jg-space-mrxs" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--light jg-space-mbn" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "Supporter.thanked", defaultMessage: "Thanked" })))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_ClickableElement__["a" /* default */], { className: "jg-display-flex jg-flex-aic jg-space-mtsm", onClick: this.openModal, analyticsOptions: {
                                event: 'link click',
                                eventValue: 'say thanks',
                                pageSection: 'admin > page view > supporters',
                                subtype: 'button',
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_7__justgiving_icons_lib_comment_svg___default.a, className: "jg-icon jg-fill--brand-secondary jg-space-mrxs" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--link jg-space-mbn" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], { id: "Supporter.sayThanks", defaultMessage: "Say thanks" })))))))))));
    };
    return Supporter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Supporter);


/***/ }),

/***/ "./src/components/Supporters/Supporters.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2UeBF","donation-list":"_2FwaL","action":"_3ftW7","show-more-button-container":"_3B4bB"};

/***/ }),

/***/ "./src/components/Supporters/Supporters.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_LoadingButton___ = __webpack_require__("./src/components/LoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupportersHeader_SupportersHeader__ = __webpack_require__("./src/components/Supporters/SupportersHeader/SupportersHeader.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Supporters_scss__ = __webpack_require__("./src/components/Supporters/Supporters.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Supporters_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Supporters_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Supporter__ = __webpack_require__("./src/components/Supporters/Supporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BecomeSupporter__ = __webpack_require__("./src/components/Supporters/BecomeSupporter.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LaunchYourPage__ = __webpack_require__("./src/components/Supporters/LaunchYourPage.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var Supporters = /** @class */ (function (_super) {
    __extends(Supporters, _super);
    function Supporters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleLoadSupporters = function () {
            var _a = _this.props, pageId = _a.pageId, supporterPageNo = _a.supporterPageNo, loadSupporters = _a.loadSupporters;
            var pageSize = 7;
            var loadDetails = {
                pageId: pageId,
                pageNo: (supporterPageNo || 1) + 1,
                pageSize: pageSize,
            };
            loadSupporters(loadDetails);
        };
        return _this;
    }
    Supporters.prototype.renderShowMore = function () {
        var isLoading = this.props.supporters.isLoading;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_LoadingButton___["a" /* default */], { loading: isLoading, onClick: this.handleLoadSupporters, color: "purple", className: ['jg-btn--ghost', __WEBPACK_IMPORTED_MODULE_4__Supporters_scss___default.a.action], value: "Show more" }));
    };
    Supporters.prototype.renderAppeal = function () {
        var _a = this.props, isActive = _a.isActive, isClosed = _a.isClosed, profileImage = _a.profileImage, donate = _a.donate, ownerName = _a.ownerName, isOwner = _a.isOwner, canPageReceiveDonations = _a.canPageReceiveDonations;
        if (!isActive && !isClosed && isOwner) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LaunchYourPage__["a" /* default */], null);
        }
        if (!isClosed) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BecomeSupporter__["a" /* default */], { donate: donate, canPageReceiveDonations: canPageReceiveDonations, ownerName: ownerName, profileImage: profileImage, page: this.props.page }));
        }
        return null;
    };
    Supporters.prototype.render = function () {
        var _a = this.props, isOwner = _a.isOwner, pageId = _a.pageId, profileImage = _a.profileImage, _b = _a.supporters, items = _b.items, totalCount = _b.totalCount, targetCurrency = _a.targetCurrency, thankSupporter = _a.thankSupporter, totalCountSupporters = _a.totalCountSupporters;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container", className: "jg-space-phms" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-pln" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SupportersHeader_SupportersHeader__["a" /* default */], { totalCountSupporters: totalCountSupporters }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "donation-list" }, items.map(function (supporter) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Supporter__["a" /* default */], { key: supporter.id, pageId: pageId, profileImage: profileImage, supporter: supporter, targetCurrency: targetCurrency, thankSupporter: thankSupporter, isOwner: isOwner })); })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "show-more-button-container" }, items.length < totalCount && this.renderShowMore()),
                this.renderAppeal())));
    };
    return Supporters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Supporters, __WEBPACK_IMPORTED_MODULE_4__Supporters_scss___default.a));


/***/ }),

/***/ "./src/components/Supporters/SupportersHeader/SupportersHeader.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SupportersHeader = function (_a) {
    var totalCountSupporters = _a.totalCountSupporters;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-space-pbms" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2 jg-flex-g1" }, "Supporters"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2" }, totalCountSupporters))));
};
/* harmony default export */ __webpack_exports__["a"] = (SupportersHeader);


/***/ }),

/***/ "./src/components/SupportersAvatar/SupportersAvatar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3p5re","supporters-container":"KM65o","supporter-avatar-container":"Yxbyx","supporter-avatar":"_23Bjf"};

/***/ }),

/***/ "./src/components/SupportersAvatar/SupportersAvatar.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupportersAvatar_scss__ = __webpack_require__("./src/components/SupportersAvatar/SupportersAvatar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupportersAvatar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SupportersAvatar_scss__);




function SupportersAvatar(_a) {
    var supportersList = _a.supportersList;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "supporters-container" }, supportersList.map(function (supporter, id) {
            var imageSrc = supporter ? supporter.imageProfile : undefined;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { styleName: "supporter-avatar-container", key: id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Avatar__["c" /* SupporterAvatar */], { src: imageSrc, alt: "image of supporter", size: "xxsmall" })));
        }))));
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(SupportersAvatar, __WEBPACK_IMPORTED_MODULE_3__SupportersAvatar_scss___default.a));


/***/ }),

/***/ "./src/components/SupportersAvatar/constructSupportersList.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constructSupportersList;
function constructSupportersList(list) {
    var newList = [];
    if (list === null) {
        return newList;
    }
    var supportersWithImageProfile = list.filter(function (s) { return s.imageProfile; });
    if (supportersWithImageProfile.length < 3) {
        return newList;
    }
    newList.push.apply(newList, supportersWithImageProfile.splice(0, 5));
    if (newList.length >= list.length) {
        return newList;
    }
    while (newList.length < 5 && newList.length < list.length) {
        newList.push({});
    }
    return newList;
}


/***/ }),

/***/ "./src/components/TabView/TabLink.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabView_scss__ = __webpack_require__("./src/components/TabView/TabView.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TabView_scss__);





var TabLink = function (_a) {
    var badgeCount = _a.badgeCount, path = _a.path, heading = _a.heading, _b = _a.exact, exact = _b === void 0 ? false : _b, _c = _a.strict, strict = _c === void 0 ? false : _c;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */], { path: path, exact: exact, strict: strict, children: function (_a) {
            var match = _a.match;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__TabView_scss___default.a.item, match && __WEBPACK_IMPORTED_MODULE_4__TabView_scss___default.a.active) },
                !!badgeCount &&
                    badgeCount > 0 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_4__TabView_scss___default.a.badge + " jg-text--small" }, badgeCount)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: path }, heading)));
        } }));
};
/* harmony default export */ __webpack_exports__["a"] = (TabLink);


/***/ }),

/***/ "./src/components/TabView/TabShareButton/TabShareButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"akzId"};

/***/ }),

/***/ "./src/components/TabView/TabShareButton/TabShareButton.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabShareButton_scss__ = __webpack_require__("./src/components/TabView/TabShareButton/TabShareButton.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabShareButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TabShareButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");




var TabShareButton = function (_a) {
    var isActive = _a.isActive, openSharePrompt = _a.openSharePrompt, pageSection = _a.pageSection;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_ClickableElement__["a" /* default */], { onClick: openSharePrompt, className: "jg-btn jg-btn--secondary " + __WEBPACK_IMPORTED_MODULE_1__TabShareButton_scss___default.a.button, inline: true, isDisabled: !isActive, analyticsOptions: {
            event: 'link click',
            subtype: 'button',
            eventValue: 'share your page',
            pageSection: "admin > " + pageSection,
        } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "TabShareButton.shareYourPage", defaultMessage: "Share your page" })));
};
/* harmony default export */ __webpack_exports__["a"] = (TabShareButton);


/***/ }),

/***/ "./src/components/TabView/TabView.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu":"PWr0V","item":"_3ukG9","active":"_2g_FF","panel":"_1yuN0","badge":"_1yoDi"};

/***/ }),

/***/ "./src/components/TabView/TabViewContent.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"panel":"_2_Ryh"};

/***/ }),

/***/ "./src/components/TabView/TabViewContent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabViewContent_scss__ = __webpack_require__("./src/components/TabView/TabViewContent.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabViewContent_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TabViewContent_scss__);



var TabViewContent = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "panel", className: "jg-background--white-smoke" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(TabViewContent, __WEBPACK_IMPORTED_MODULE_2__TabViewContent_scss___default.a));


/***/ }),

/***/ "./src/components/TabView/TabViewLinks/TabViewLinks.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nav-bar":"_2o0Iy","nav-bar-container":"_2eafN","fixed":"sS7mc"};

/***/ }),

/***/ "./src/components/TabView/TabViewLinks/TabViewLinks.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss__ = __webpack_require__("./src/components/TabView/TabViewLinks/TabViewLinks.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_StickyHeader_Sticky__ = __webpack_require__("./src/components/StickyHeader/Sticky.tsx");



var CHROME_HEADER_OFFSET = 58;
var TabViewLinks = function (_a) {
    var children = _a.children;
    if (!children) {
        throw new Error('TabView must contain at least one TabPanel.');
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_StickyHeader_Sticky__["a" /* default */], { offset: CHROME_HEADER_OFFSET, delay: 50 }, function (_a) {
        var sticky = _a.sticky;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bdh jg-bdb jg-bd--solid jg-bd--very-light-grey jg-background--white " + (sticky ? __WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss___default.a.fixed : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "container jg-background--white" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss___default.a['nav-bar'] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "" + __WEBPACK_IMPORTED_MODULE_1__TabViewLinks_scss___default.a['nav-bar-container'] }, children)))),
            sticky && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: 80 } })) /* used to ensure page does not jump when sticky header is fixed */));
    }));
};
/* harmony default export */ __webpack_exports__["a"] = (TabViewLinks);


/***/ }),

/***/ "./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"character-count":"_1fLU3"};

/***/ }),

/***/ "./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_character_count__ = __webpack_require__("./node_modules/@justgiving/character-count/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaWithCharacterCount_scss__ = __webpack_require__("./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaWithCharacterCount_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TextareaWithCharacterCount_scss__);






var TextareaWithCharacterCount = function (_a) {
    var characterLimit = _a.characterLimit, error = _a.error, id = _a.id, labelClassName = _a.labelClassName, labelDefaultMessage = _a.labelDefaultMessage, labelId = _a.labelId, _b = _a.textareaClassName, textareaClassName = _b === void 0 ? '' : _b, touched = _a.touched, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.showLabel, showLabel = _d === void 0 ? true : _d, _e = _a.rows, rows = _e === void 0 ? 10 : _e, _f = _a.hideTextAreaBorder, hideTextAreaBorder = _f === void 0 ? false : _f, _g = _a.placeholder, placeholder = _g === void 0 ? '' : _g;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group" },
        showLabel &&
            labelId && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "jg-form-label " + labelClassName, htmlFor: id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: labelId, defaultMessage: labelDefaultMessage }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_character_count__["a" /* default */], { maxLength: characterLimit, value: value }, function (_a) {
            var charactersRemaining = _a.charactersRemaining, isValid = _a.isValid;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-relative" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_formik__["a" /* Field */], { id: id, name: id, component: "textarea", className: "jg-form-control " + textareaClassName + " " + (touched && error ? 'jg-form-control--error' : '') + "\n                " + (hideTextAreaBorder ? 'jg-bdn' : ''), rows: rows, placeholder: placeholder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "\n                jg-text--small-light jg-text--pull-right\n                 " + __WEBPACK_IMPORTED_MODULE_5__TextareaWithCharacterCount_scss___default.a['character-count'] + "\n                 " + (!isValid ? 'jg-color--safety-orange' : '') + "\n                " }, charactersRemaining)));
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_helpers_validation__["a" /* ValidationResult */], { touched: touched, error: error ? error : undefined })));
};
/* harmony default export */ __webpack_exports__["a"] = (TextareaWithCharacterCount);


/***/ }),

/***/ "./src/components/TextareaWithCharacterCount/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextareaWithCharacterCount__ = __webpack_require__("./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.tsx");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TextareaWithCharacterCount__["a" /* default */]);


/***/ }),

/***/ "./src/components/ThankingDonors/SpeechBubbleWithAvatar.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThankingDonors_scss__ = __webpack_require__("./src/components/ThankingDonors/ThankingDonors.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThankingDonors_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ThankingDonors_scss__);




var SpeechBubbleWithAvatar = function (_a) {
    var avatarImage = _a.avatarImage, donationAmount = _a.donationAmount, message = _a.message, name = _a.name, targetCurrency = _a.targetCurrency;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bd jg-bd--solid jg-bd--very-light-grey jg-bd--radius-3px jg-space-pms " + __WEBPACK_IMPORTED_MODULE_3__ThankingDonors_scss___default.a['supporter-message-box'] },
            donationAmount &&
                targetCurrency && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-color--primary " + (!message &&
                    'jg-space-mbn') },
                __WEBPACK_IMPORTED_MODULE_1_src_helpers_currencyMap__["e" /* default */][targetCurrency],
                donationAmount)),
            message && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--small jg-text--center jg-space-mbn" }, message))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-flex-aic jg-flex-jcc jg-space-mtms" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Avatar__["c" /* SupporterAvatar */], { src: avatarImage, alt: "image of supporter", size: "xxsmall" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall jg-color--nobel jg-space-mlxs" }, name))));
};
/* harmony default export */ __webpack_exports__["a"] = (SpeechBubbleWithAvatar);


/***/ }),

/***/ "./src/components/ThankingDonors/ThankDonorMessageForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__("./node_modules/formik/dist/formik.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Collapse__ = __webpack_require__("./src/components/Collapse/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ThankingDonors_SpeechBubbleWithAvatar__ = __webpack_require__("./src/components/ThankingDonors/SpeechBubbleWithAvatar.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThankingDonors_scss__ = __webpack_require__("./src/components/ThankingDonors/ThankingDonors.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThankingDonors_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThankingDonors_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_thankYou_il_svg__ = __webpack_require__("./src/components/ThankingDonors/svg/thankYou-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_thankYou_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_thankYou_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_TextareaWithCharacterCount__ = __webpack_require__("./src/components/TextareaWithCharacterCount/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__thankMessageValidation__ = __webpack_require__("./src/components/ThankingDonors/thankMessageValidation.ts");











var ThankDonorMessageForm = function (_a) {
    var submitForm = _a.submitForm, supporter = _a.supporter, targetCurrency = _a.targetCurrency;
    var isAnonymous = supporter.name === 'Anonymous';
    var closePanel = function (isActive, togglePanel) {
        if (isActive && (supporter.message || supporter.donationAmount)) {
            togglePanel();
        }
        return;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "thank donor", pageSection: "admin > page view > supporters > thank supporter", subtype: "admin" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_8__svg_thankYou_il_svg___default.a, className: "jg-svg-sm" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-space-mbmd" }, isAnonymous ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorModal.thankAnonymousDonor", defaultMessage: "Say thanks to this donor" })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorModal.thankNamedDonor", defaultMessage: "Say thanks to {donorName}", values: { donorName: supporter.name } }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Collapse__["a" /* Collapse */], null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Collapse__["d" /* CollapsePanel */], { initialOpenPanel: !!supporter.message || !!supporter.donationAmount },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Collapse__["b" /* CollapseBody */], null, function () {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ThankingDonors_SpeechBubbleWithAvatar__["a" /* default */], { avatarImage: supporter.imageProfile, name: supporter.name, donationAmount: supporter.donationAmount, message: supporter.message, targetCurrency: targetCurrency }));
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Collapse__["c" /* CollapseHeader */], null, function (collapseHeaderProps) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["c" /* Formik */], { initialValues: {
                            thankYouMessage: '',
                        }, onSubmit: submitForm, validate: function (values) { return Object(__WEBPACK_IMPORTED_MODULE_10__thankMessageValidation__["a" /* default */])(values); } }, function (_a) {
                        var handleSubmit = _a.handleSubmit, handleChange = _a.handleChange, errors = _a.errors, touched = _a.touched, values = _a.values, isSubmitting = _a.isSubmitting;
                        var isValid = values.thankYouMessage.length >= 3 &&
                            values.thankYouMessage.length <= 200;
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", { onSubmit: handleSubmit },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-bdt jg-bd--solid jg-bd--very-light-grey jg-space-ptms jg-space-mvms", onClick: function () {
                                    return closePanel(collapseHeaderProps.isActive, collapseHeaderProps.togglePanel);
                                } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_TextareaWithCharacterCount__["a" /* default */], { characterLimit: 200, error: errors.thankYouMessage, id: "thankYouMessage", labelClassName: __WEBPACK_IMPORTED_MODULE_7__ThankingDonors_scss___default.a.label, labelDefaultMessage: "to", labelId: "PitchFor.label", onChange: handleChange, touched: touched.thankYouMessage, value: values.thankYouMessage, rows: 5, showLabel: false, hideTextAreaBorder: true, placeholder: "Write your message here..." })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "row" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { className: "col-sm-12 col-md-8 offset-md-2", id: "send-message", loading: isSubmitting, disabled: !isValid, value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorModal.sendMessageButton", defaultMessage: "Send message" }), analyticsOptions: {
                                        event: 'link click',
                                        eventValue: 'send message',
                                        pageSection: 'admin > page view > supporters > thank supporter',
                                        subtype: 'button',
                                    } }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-width-100pc jg-text--center jg-text--small jg-color--nobel jg-space-mtmd" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorModal.footNote", defaultMessage: "Some of your supporters may have chosen not to share their email address with us when making a donation to your page through our 'guest checkout'. This means that they won't receive your thank you message, so we'd recommend posting an update on your page so no-one gets missed. Please note, you can only thank each donor once.", values: { donorName: supporter.name } })))));
                    }));
                })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ThankDonorMessageForm);


/***/ }),

/***/ "./src/components/ThankingDonors/ThankDonorMessageSendFailure.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_thankError_il_svg__ = __webpack_require__("./src/components/ThankingDonors/svg/thankError-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_thankError_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_thankError_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_SpeechBubbleWithAvatar__ = __webpack_require__("./src/components/ThankingDonors/SpeechBubbleWithAvatar.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThankingDonors_scss__ = __webpack_require__("./src/components/ThankingDonors/ThankingDonors.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThankingDonors_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ThankingDonors_scss__);







var ThankDonorMessageSendFailure = function (_a) {
    var isSubmitting = _a.isSubmitting, ownerName = _a.ownerName, profileImage = _a.profileImage, thankYouMessage = _a.thankYouMessage, submitForm = _a.submitForm;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "thank donor failure", pageSection: "admin > page view > supporters > thank supporter", subtype: "admin" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__node_modules_justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svg_thankError_il_svg___default.a, className: "jg-svg-sm" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-space-mbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorMessageSendFailure.somethingWentWrong", defaultMessage: "Looks like something went wrong..." })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--center jg-space-mbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorMessageSendFailure.weAreSorry", defaultMessage: "We're sorry we weren't able to send your message. It's probably just a glitch, so please try again." })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-pbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_SpeechBubbleWithAvatar__["a" /* default */], { avatarImage: profileImage, name: ownerName, message: thankYouMessage })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_6__ThankingDonors_scss___default.a.footer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["a" /* AnalyticsLoadingButton */], { id: "send-message", loading: isSubmitting, value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorMessageSendFailure.tryAgainButton", defaultMessage: "Try again" }), className: "jg-btn jg-btn--ghost", analyticsOptions: {
                    event: 'link click',
                    eventValue: 'try again',
                    pageSection: 'admin > page view > supporters > thank supporter',
                    subtype: 'button',
                }, onClick: submitForm, color: "purple" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ThankDonorMessageSendFailure);


/***/ }),

/***/ "./src/components/ThankingDonors/ThankDonorMessageSendSuccess.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_svg__ = __webpack_require__("./node_modules/@justgiving/svg/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_thankSent_il_svg__ = __webpack_require__("./src/components/ThankingDonors/svg/thankSent-il.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_thankSent_il_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_thankSent_il_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_SpeechBubbleWithAvatar__ = __webpack_require__("./src/components/ThankingDonors/SpeechBubbleWithAvatar.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");






var ThankDonorMessageSendSuccess = function (_a) {
    var ownerName = _a.ownerName, profileImage = _a.profileImage, thankYouMessage = _a.thankYouMessage;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "thank donor success", pageSection: "admin > page view > supporters > thank supporter", subtype: "admin" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__justgiving_svg__["a" /* default */], { markup: __WEBPACK_IMPORTED_MODULE_3__svg_thankSent_il_svg___default.a, className: "jg-svg-sm" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-text--center jg-space-mbmd" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "ThankDonorMessageSendSuccess.yourMessageHasBeenSent", defaultMessage: "Your message has been sent!" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_SpeechBubbleWithAvatar__["a" /* default */], { avatarImage: profileImage, name: ownerName, message: thankYouMessage })));
};
/* harmony default export */ __webpack_exports__["a"] = (ThankDonorMessageSendSuccess);


/***/ }),

/***/ "./src/components/ThankingDonors/ThankDonorModal.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_activities__ = __webpack_require__("./src/helpers/api/activities.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_ThankingDonors_ThankDonorMessageForm__ = __webpack_require__("./src/components/ThankingDonors/ThankDonorMessageForm.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_ThankDonorMessageSendSuccess__ = __webpack_require__("./src/components/ThankingDonors/ThankDonorMessageSendSuccess.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ThankingDonors_ThankDonorMessageSendFailure__ = __webpack_require__("./src/components/ThankingDonors/ThankDonorMessageSendFailure.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var ThankDonorModal = /** @class */ (function (_super) {
    __extends(ThankDonorModal, _super);
    function ThankDonorModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            hasSentThankYouMessage: null,
            isFormSubmitting: false,
            thankYouMessage: '',
        };
        _this.handleSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
            var _a, supporter, pageId, payload, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, supporter = _a.supporter, pageId = _a.pageId;
                        this.setState({
                            isFormSubmitting: true,
                            thankYouMessage: values.thankYouMessage,
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        payload = {
                            pageId: pageId,
                            activityId: supporter.id,
                            thankYouMessage: values.thankYouMessage,
                        };
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_activities__["c" /* setSupporterThankYouMessage */])(payload)];
                    case 2:
                        _b.sent();
                        this.props.thankSupporter(supporter.id, values.thankYouMessage);
                        this.setState({
                            hasSentThankYouMessage: true,
                            isFormSubmitting: false,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.setState({ hasSentThankYouMessage: false, isFormSubmitting: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ThankDonorModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeModal = _a.closeModal, profileImage = _a.profileImage, supporter = _a.supporter, targetCurrency = _a.targetCurrency;
        var _b = this.state, hasSentThankYouMessage = _b.hasSentThankYouMessage, isFormSubmitting = _b.isFormSubmitting, thankYouMessage = _b.thankYouMessage;
        var displayForm = hasSentThankYouMessage === null;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Modal__["a" /* default */], { isOpen: true, maintainPosition: true, colorTheme: "dark", onClose: closeModal },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-phmd@xs jg-space-phxl@md jg-space-ptlg jg-space-pbmd" },
                displayForm && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_ThankingDonors_ThankDonorMessageForm__["a" /* default */], { supporter: supporter, targetCurrency: targetCurrency, submitForm: this.handleSubmit })),
                hasSentThankYouMessage &&
                    !displayForm && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_ThankingDonors_ThankDonorMessageSendSuccess__["a" /* default */], { thankYouMessage: thankYouMessage, ownerName: "You", profileImage: profileImage })),
                !hasSentThankYouMessage &&
                    !displayForm && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ThankingDonors_ThankDonorMessageSendFailure__["a" /* default */], { thankYouMessage: thankYouMessage, ownerName: "You", profileImage: profileImage, submitForm: function () {
                        return _this.handleSubmit({
                            thankYouMessage: _this.state.thankYouMessage,
                        });
                    }, isSubmitting: isFormSubmitting })))));
    };
    return ThankDonorModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ThankDonorModal);


/***/ }),

/***/ "./src/components/ThankingDonors/ThankingDonors.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"supporter-message-box":"_3ZqFd"};

/***/ }),

/***/ "./src/components/ThankingDonors/svg/thankError-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 94 105\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"45\" cy=\"45\" r=\"45\"></circle><circle id=\"path-3\" cx=\"70\" cy=\"96\" r=\"20\"></circle><filter x=\"-17.5%\" y=\"-12.5%\" width=\"135.0%\" height=\"135.0%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\"><feOffset dx=\"0\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0.703096694 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix></filter></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"desktop_1-copy-6\" transform=\"translate(-675.000000, -208.000000)\"><g id=\"Group\" transform=\"translate(675.000000, 191.000000)\"><g id=\"PICTO-EMAIL\"><g id=\"MOUNTAIN\" transform=\"translate(0.000000, 17.280000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#BCE1FF\" xlink:href=\"#path-1\"></use><path d=\"M36.568917,57.3341027 C36.5712173,57.275534 36.5866115,57.2213888 36.5866115,57.1640587 C36.5866115,54.5445661 34.4636264,52.421581 31.8453724,52.421581 C30.7714937,52.421581 29.7906881,52.7926345 28.9976209,53.3946011 C28.1456312,52.1259061 26.6998143,51.2903722 25.0581193,51.2903722 C23.0011347,51.2903722 21.2660128,52.6093196 20.6106088,54.4419381 C20.3455453,54.3607204 20.070396,54.3060444 19.7798525,54.3060444 C18.2388392,54.3060444 16.9917314,55.527849 16.9344012,57.0568301 C15.145842,57.1461872 13.7086954,58.5100787 13.7086954,60.3195174 C13.7086954,62.1866401 15.2353762,63.6002531 17.102145,63.6002531 L35.2013097,63.6002531 C37.0682555,63.6002531 38.5947593,62.1866401 38.5947593,60.3195174 C38.5947593,58.9405856 37.7586946,57.8629911 36.568917,57.3341027\" id=\"Page-1\" fill=\"#FFFFFF\" mask=\"url(#mask-2)\"></path><g mask=\"url(#mask-2)\"><g transform=\"translate(12.240000, 49.680000)\"><path d=\"M78.308424,51.292368 C76.217544,29.881008 62.109144,17.284608 50.152104,10.357488 L0.094104,58.899888 L78.690744,58.867488 C78.685704,56.467008 78.566904,53.946288 78.308424,51.292368\" id=\"Fill-6\" fill=\"#DD44E7\"></path><path d=\"M78.308424,51.292368 C78.566904,53.946288 78.685704,56.467008 78.690744,58.867488 L121.182264,58.850208 L60.832584,0.000288 L50.152104,10.357488 C62.109144,17.284608 76.217544,29.881008 78.308424,51.292368\" id=\"Fill-12\" fill=\"#AD29B6\"></path></g></g></g><g id=\"aeroplane\" transform=\"translate(47.160000, 36.720000) rotate(21.000000) translate(-47.160000, -36.720000) translate(19.440000, 8.640000)\"><polygon id=\"Fill-1\" fill=\"#FFFFFF\" points=\"54.9880495 0.000182634146 54.4386895 0.914723122 54.4359404 0.918375805 26.3686385 47.5389378 45.478944 54.8762646\"></polygon><polygon id=\"Fill-2\" fill=\"#FFFFFF\" points=\"54.9876829 0.000182634146 -9.16363637e-05 37.4146139 13.2931375 42.496409 54.436032 0.918375805 54.4387811 0.914723122 54.9881411 0.000182634146\"></polygon><polygon id=\"Fill-3\" fill=\"#D4D4D4\" points=\"13.2929542 42.4961807 13.2764596 42.511248 21.1938415 56.1343856 26.3685469 47.539166 54.4363069 0.918147512\"></polygon></g></g><g id=\"Oval-2\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-3\"></use><use fill=\"#FFFFFF\" fill-rule=\"evenodd\" xlink:href=\"#path-3\"></use></g><g id=\"•-Close\" transform=\"translate(60.000000, 87.000000)\" fill=\"#F7414B\" stroke=\"#F7414B\" stroke-width=\"0.5\"><path d=\"M18.45,0.15 C18.25,-0.05 17.85,-0.05 17.65,0.15 L9.95,7.95 L2.25,0.25 C2.05,0.05 1.65,0.05 1.45,0.25 L0.15,1.55 C-0.05,1.75 -0.05,2.15 0.15,2.35 L7.85,10.05 L0.15,17.75 C-0.05,17.95 -0.05,18.35 0.15,18.55 L1.45,19.85 C1.65,20.05 2.05,20.05 2.25,19.85 L9.95,12.15 L17.65,19.85 C17.85,20.05 18.25,20.05 18.45,19.85 L19.75,18.55 C19.95,18.35 19.95,17.95 19.75,17.75 L12.05,10.05 L19.75,2.35 C20.05,2.15 20.05,1.75 19.75,1.45 L18.45,0.15 Z\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/ThankingDonors/svg/thankSent-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 94 105\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"45\" cy=\"45\" r=\"45\"></circle><circle id=\"path-3\" cx=\"70\" cy=\"96\" r=\"20\"></circle><filter x=\"-17.5%\" y=\"-12.5%\" width=\"135.0%\" height=\"135.0%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\"><feOffset dx=\"0\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0 0.898039216 0 0 0 0.703096694 0\" type=\"matrix\" in=\"shadowBlurOuter1\"></feColorMatrix></filter></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"desktop_1-copy-5\" transform=\"translate(-676.000000, -208.000000)\"><g id=\"pictogram\" transform=\"translate(676.000000, 191.000000)\"><g id=\"PICTO-EMAIL\"><g id=\"MOUNTAIN\" transform=\"translate(0.000000, 17.280000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#BCE1FF\" xlink:href=\"#path-1\"></use><path d=\"M36.568917,57.3341027 C36.5712173,57.275534 36.5866115,57.2213888 36.5866115,57.1640587 C36.5866115,54.5445661 34.4636264,52.421581 31.8453724,52.421581 C30.7714937,52.421581 29.7906881,52.7926345 28.9976209,53.3946011 C28.1456312,52.1259061 26.6998143,51.2903722 25.0581193,51.2903722 C23.0011347,51.2903722 21.2660128,52.6093196 20.6106088,54.4419381 C20.3455453,54.3607204 20.070396,54.3060444 19.7798525,54.3060444 C18.2388392,54.3060444 16.9917314,55.527849 16.9344012,57.0568301 C15.145842,57.1461872 13.7086954,58.5100787 13.7086954,60.3195174 C13.7086954,62.1866401 15.2353762,63.6002531 17.102145,63.6002531 L35.2013097,63.6002531 C37.0682555,63.6002531 38.5947593,62.1866401 38.5947593,60.3195174 C38.5947593,58.9405856 37.7586946,57.8629911 36.568917,57.3341027\" id=\"Page-1\" fill=\"#FFFFFF\" mask=\"url(#mask-2)\"></path><g mask=\"url(#mask-2)\"><g transform=\"translate(12.240000, 49.680000)\"><path d=\"M78.308424,51.292368 C76.217544,29.881008 62.109144,17.284608 50.152104,10.357488 L0.094104,58.899888 L78.690744,58.867488 C78.685704,56.467008 78.566904,53.946288 78.308424,51.292368\" id=\"Fill-6\" fill=\"#DD44E7\"></path><path d=\"M78.308424,51.292368 C78.566904,53.946288 78.685704,56.467008 78.690744,58.867488 L121.182264,58.850208 L60.832584,0.000288 L50.152104,10.357488 C62.109144,17.284608 76.217544,29.881008 78.308424,51.292368\" id=\"Fill-12\" fill=\"#AD29B6\"></path></g></g></g><g id=\"aeroplane\" transform=\"translate(47.160000, 36.720000) rotate(21.000000) translate(-47.160000, -36.720000) translate(19.440000, 8.640000)\"><polygon id=\"Fill-1\" fill=\"#FFFFFF\" points=\"54.9880495 0.000182634146 54.4386895 0.914723122 54.4359404 0.918375805 26.3686385 47.5389378 45.478944 54.8762646\"></polygon><polygon id=\"Fill-2\" fill=\"#FFFFFF\" points=\"54.9876829 0.000182634146 -9.16363637e-05 37.4146139 13.2931375 42.496409 54.436032 0.918375805 54.4387811 0.914723122 54.9881411 0.000182634146\"></polygon><polygon id=\"Fill-3\" fill=\"#D4D4D4\" points=\"13.2929542 42.4961807 13.2764596 42.511248 21.1938415 56.1343856 26.3685469 47.539166 54.4363069 0.918147512\"></polygon></g></g><g id=\"Oval-2\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-3\"></use><use fill=\"#FFFFFF\" fill-rule=\"evenodd\" xlink:href=\"#path-3\"></use></g><g id=\"•-Tick\" transform=\"translate(59.000000, 88.000000)\" fill=\"#25CA76\"><path d=\"M6.125,17.325 L0.225,11.425 C-0.075,11.125 -0.075,10.725 0.225,10.525 L1.625,9.125 C1.925,8.825 2.325,8.825 2.525,9.125 L6.325,12.925 C6.425,13.025 6.625,13.025 6.825,12.925 L19.525,0.225 C19.825,-0.075 20.225,-0.075 20.425,0.225 L21.825,1.625 C22.125,1.925 22.125,2.325 21.825,2.525 L7.025,17.325 C6.825,17.525 6.425,17.525 6.125,17.325 L6.125,17.325 Z\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/ThankingDonors/svg/thankYou-il.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 80 88\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"40\" cy=\"40\" r=\"40\"></circle><filter x=\"-3.5%\" y=\"-5.2%\" width=\"107.0%\" height=\"110.3%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\"><feOffset dx=\"0\" dy=\"0\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset><feGaussianBlur stdDeviation=\"0.5\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur><feColorMatrix values=\"0 0 0 0 0.766315901 0 0 0 0 0.766315901 0 0 0 0 0.766315901 0 0 0 0.7 0\" type=\"matrix\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"></feColorMatrix><feMerge><feMergeNode in=\"shadowMatrixOuter1\"></feMergeNode><feMergeNode in=\"SourceGraphic\"></feMergeNode></feMerge></filter><path d=\"M8.44990667,2.53667741 C7.67988222,1.07881075 6.20756889,0.0849197368 4.50212889,0.0849197368 C2.01212,0.0849197368 0.00374,2.19219247 0.00374,4.80380395 C0.00374,6.11660329 0.471655556,7.1904212 1.33808889,8.1575367 L8.44990667,14.9317412 L15.2450711,8.44966952 C16.2906089,7.3490761 16.8960733,6.27525819 16.8960733,4.80380395 C16.9097867,2.20578004 14.8876933,0.0849197368 12.3976844,0.0849197368 C10.6918289,0.0849197368 9.22034667,1.07881075 8.44990667,2.53667741 Z\" id=\"path-4\"></path></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Group-2-Copy-4\"><g id=\"Group-3\" transform=\"translate(0.000000, 8.000000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Mask\" fill=\"#BCE1FF\" xlink:href=\"#path-1\"></use><g id=\"Group-21\" mask=\"url(#mask-2)\"><g transform=\"translate(41.140000, 59.860000) scale(-1, 1) translate(-41.140000, -59.860000) translate(17.640000, 31.360000)\"><path d=\"M4.98530957,28.7715472 C3.91010075,30.3616575 1.97626798,32.179364 0,32.3794035 C2.8492207,32.9805428 5.84062688,32.532495 8.34099716,31.1301769 C10.0439163,30.2014218 12.0786016,28.4577096 12.8,26.6267352 C11.6906226,25.3555655 10.8049944,23.9307939 10.1734263,22.4039613 C9.57657797,22.373343 8.98468957,22.5208212 8.48538707,22.8254732 C6.23356583,24.2145235 6.32008955,26.7808473 4.98530957,28.7715472 Z\" id=\"Fill-755\" fill=\"#5C432D\"></path><path d=\"M38.8212009,32.4460806 C41.0900841,34.1088082 43.9217993,34.8332221 46.72,34.4670638 C44.8325445,34.0877343 43.1536241,32.0456772 42.2689458,30.3281576 C41.28,28.3345704 41.4614043,25.9616537 39.9287776,24.32 C38.9206806,26.2514193 37.5300919,27.9615631 35.84,29.3487499 C36.6358381,30.5536479 37.646063,31.6057604 38.8212009,32.4529296\" id=\"Fill-767\" fill=\"#5C432D\"></path><path d=\"M40.3996976,23.5507648 C40.4012325,23.5524434 40.4027662,23.5541232 40.4042987,23.5558041 L40.4184219,23.5558041 C39.3896014,25.5486471 37.9696771,27.3136589 36.2439314,28.7458959 C35.2406413,27.1652153 34.7642551,25.3925909 35.6817196,23.8760728 C35.712682,23.8282228 35.7458171,23.7814603 35.7794955,23.7357853 C36.3939324,22.9084494 37.3545098,22.4912413 38.3111188,22.5354256 C37.2928102,22.4862676 36.2753284,22.9618635 35.674495,23.8761271 C34.7570305,25.3926453 35.23396,27.1652696 36.2361636,28.7459503 C34.6152554,30.0966247 32.7515369,31.1259431 30.7460432,31.7784428 L30.7313768,31.7784428 L26.0385345,20.8499114 L30.7460432,31.8139497 C29.0588646,32.367487 27.2940084,32.6458869 25.5182883,32.6399056 L25.3694515,32.6399056 L25.6146542,14.637995 L25.3691799,32.6114131 C25.1703688,32.5760694 24.9851377,32.5760694 24.7857833,32.5760694 C15.8419986,32.1323696 8.85101707,24.6873475 8.96128663,15.7241759 C8.96834823,15.1559574 9.00365622,14.5877389 9.0677538,14.0227828 C9.18671455,12.9961832 9.40127848,11.9837211 9.70764317,10.9968152 C10.9901379,10.8304278 12.2481887,10.5123342 13.4557218,10.0501469 C17.1934797,8.77233485 20.059945,5.72951103 21.1159255,1.92 C22.2533311,3.96711948 23.8230823,5.74075913 25.7170977,7.11696189 C30.4744433,10.6435954 36.0547349,12.8909133 41.9261816,13.645638 L41.8832688,13.6592317 L41.8832688,13.5814755 L42.0397103,13.5814755 C42.0750183,13.6809817 42.0750183,13.7881004 42.0750183,13.8870629 L36.895132,16.1361073 L42.1038079,13.8945123 C42.2021271,14.6546745 42.2472126,15.4208179 42.2390646,16.1869614 C42.232003,16.7350612 42.1890903,17.2837047 42.1325975,17.8171232 C41.9079259,19.8178555 41.3210845,21.7610594 40.3996976,23.5507648 Z M38.3111188,22.5354256 C38.318501,22.535782 38.3258831,22.5361659 38.3332652,22.5365775 Z\" id=\"Combined-Shape\" fill=\"#CDA278\"></path><path d=\"M32.64,39.4594525 L32.64,38.9668277 L32.5897973,38.8586151 L32.3611569,38.7911111 C31.9131528,38.6653784 31.455872,38.5484058 30.9893146,38.4401932 L30.8250646,38.4 L30.8250646,38.5350081 L30.8250646,38.7174235 C30.6679084,40.8018035 27.8309123,42.4615781 24.3451013,42.4615781 C20.858199,42.4615781 18.0217485,40.8018035 17.8645924,38.7174235 L17.8645924,38.5350081 L17.8645924,38.4 L17.635952,38.467504 C17.1595724,38.5752013 16.70502,38.6926892 16.2712035,38.8184219 L16,38.8993237 L16,47.36 L32.64,47.36 L32.64,39.4594525 Z\" id=\"Fill-829\" fill=\"#FFFFFF\"></path><path d=\"M9.20600808,51.9802972 C10.1443876,52.3970699 11.1023634,52.7766213 12.0799354,53.12 L12.16,52.9071576 L12.16,39.68 L11.9405222,39.7900909 L11.7059273,39.920103 L11.3464764,40.1266544 C11.104603,40.2634817 10.8554509,40.4008332 10.6135774,40.551815 L10.3493082,40.7169513 C9.98313863,40.954433 9.62872678,41.1997784 9.28663257,41.4508905 L9.15449798,41.5473511 C8.40032301,42.1187752 7.69429879,42.745769 7.0437039,43.4209931 L6.82366622,43.6610961 C6.58907133,43.9174506 6.36175505,44.177999 6.14171736,44.4437898 L5.90712248,44.7389383 C5.70948048,44.9926715 5.5185572,45.2605593 5.34275101,45.521632 L5.19605922,45.727135 C4.99113863,46.1386652 4.50011306,47.3334134 3.84,49.0083676 C5.1899004,49.8885704 6.60082907,50.683846 8.06270794,51.3900004 C8.44399462,51.5755822 8.795607,51.7606397 9.22056528,51.9320669\" id=\"Fill-831\" fill=\"#FFFFFF\"></path><path d=\"M30.72,38.2789036 L30.6286827,38.2789036 L30.5792639,38.2789036 C30.1994914,38.2011671 29.8132729,38.1293722 29.418997,38.0645093 L29.2503286,38.0645093 L29.1799606,38.0645093 L29.138062,38.0645093 L28.9618733,38.0645093 L27.9068899,37.9288417 L27.6538873,37.8966578 L27.5974854,37.8966578 C27.1897805,37.8570469 26.7745554,37.824863 26.3523471,37.7986207 L26.1906618,37.7986207 L26.0010441,37.7986207 C25.4730152,37.7986207 24.9320945,37.76 24.3831164,37.76 C23.8771111,37.76 23.3775517,37.76 22.8855126,37.7986207 L22.6738713,37.7986207 L22.4348349,37.7986207 L22.301619,37.7986207 C21.8869311,37.7986207 21.478689,37.8511052 21.0779672,37.8966578 L20.9866499,37.8966578 L20.7191439,37.9288417 L20.107318,38.0060831 L19.5164413,38.0838196 L19.4530564,38.0838196 L19.3826883,38.0838196 L19.2064996,38.1164987 C18.8057778,38.1813616 18.4120391,38.2526614 18.0322666,38.3368347 L17.92,38.3368347 L17.92,38.4665606 L17.92,38.6413439 C18.0816853,40.6446684 20.8738462,42.24 24.2993193,42.24 C27.7242553,42.24 30.5233992,40.6387268 30.6781015,38.6413439 L30.6781015,38.4665606 L30.6781015,38.3368347 L30.72,38.2789036 Z\" id=\"Fill-835\" fill=\"#CDA278\"></path><path d=\"M16.3234604,39.0028799 C14.7482506,39.7719949 13.3369544,40.8343384 12.1671576,42.1324571 L12.1671576,40.138937 C13.0206011,39.6673866 13.9051882,39.2522054 14.813816,38.8971876 L14.8717322,38.8971876 C15.343257,38.6841769 15.8229775,38.5562621 16.3234604,38.4001626 L16.3234604,39.0028799 Z M37.0986912,40.1528667 L37.12,53.7497792 L37.12,54.2327119 C36.6976493,54.3817652 36.2829478,54.5237723 35.8540405,54.6581913 C28.723252,56.8739362 21.0794139,56.8739362 13.9486253,54.6581913 C13.3574436,54.4739072 12.7706328,54.2749888 12.1887395,54.0625201 L12.1887395,53.8072325 L13.776516,49.4494562 C13.776516,49.4494562 13.1186761,48.9741117 12.1816366,48.3708523 L12.1816366,42.1469288 C13.3514334,40.8488101 14.7627296,39.7859246 16.3379394,39.0173516 L16.3379394,47.2992947 L32.9636972,47.2992947 L32.9636972,39.0173516 L32.9636972,38.9327978 L32.9636972,38.4997302 L32.9636972,38.4 C33.4171915,38.5420071 33.8624901,38.6959385 34.3012322,38.8617942 L34.4875474,38.9327978 C35.3836085,39.2818535 36.2556289,39.6899885 37.0986912,40.1528667 Z M12.16,48.3706355 C13.1046888,48.9738949 13.7554258,49.4492394 13.7554258,49.4492394 L12.1671029,53.8070157 L12.16,53.8070157 L12.16,48.3706355 Z\" id=\"Combined-Shape\" fill=\"#3B72B7\"></path><path d=\"M13.3222263,10.5916192 L13.3360267,10.5707537 C12.1282213,10.9896676 10.8740469,11.2742936 9.6,11.4182117 C9.84840603,10.6092745 10.1647097,9.8228079 10.546703,9.06469685 L10.546703,9.02243096 C10.6769781,8.77044062 10.8216056,8.51791528 10.9656811,8.27288009 C13.9101206,3.2646391 19.3524206,0.123587616 25.2981569,0 L25.8910193,0 L25.7822727,7.70523308 C23.857954,6.35165443 22.2620832,4.60591248 21.1067192,2.59212986 C19.9491471,6.29387321 17.0676372,9.25516088 13.3222263,10.5916192 Z M26.042823,0.000107002265 C32.6073663,0.153655252 38.4857569,3.97791619 41.1194128,9.80686456 C41.6675621,11.1829137 42.0434832,12.617279 42.24,14.08 C40.178782,13.8381749 38.1429566,13.4256812 36.1540523,12.8473339 C32.4263059,11.7029447 28.9215728,9.96522791 25.7822727,7.70534008 L25.8915713,0.000107002265 L26.042823,0.000107002265 Z\" id=\"Combined-Shape\" fill=\"#5C432D\"></path><path d=\"M8.32,26.88 C8.09819847,27.0316553 7.88470229,27.1879667 7.68,27.3502646 C7.88519084,27.1853061 8.10259542,27.0369766 8.32,26.88\" id=\"Fill-969\" fill=\"#6D5644\"></path><path d=\"M7.34505567,27.52 L7.04,27.7208768 L7.34505567,27.52 Z\" id=\"Fill-971\" fill=\"#6D5644\"></path><path d=\"M5.30210295,30.08 L5.12,30.2542706 L5.30210295,30.08 Z\" id=\"Fill-999\" fill=\"#6D5644\"></path><path d=\"M6.04777582,28.8 L5.76,29.0261527 L6.04777582,28.8 Z\" id=\"Fill-1001\" fill=\"#6D5644\"></path><path d=\"M44.3007337,47.6424473 L43.4394709,45.848991 C43.2639587,45.5504214 43.067798,45.2589089 42.8716374,44.9749963 L42.6620552,44.6693696 C42.4369866,44.3615715 42.2114018,44.0575734 41.9863333,43.7590037 L41.8784449,43.624376 C41.6482142,43.3540348 41.3983675,43.0912935 41.1485207,42.8285523 L40.9250008,42.5864394 L40.8909308,42.5864394 C40.5806872,42.2813556 40.2559897,41.982786 39.9183868,41.6912735 L39.6948669,41.5061603 C39.4068205,41.2645904 39.1069011,41.0279061 38.7961413,40.7955646 L38.5462946,40.6175086 C38.2076593,40.3808243 37.8607646,40.1435972 37.5050944,39.9074558 L37.3564252,39.8146278 L37.12,39.68 L37.12,53.76 L37.2753799,53.7030003 L37.5727182,53.5819439 C39.7624907,51.2091298 42.6137519,50.4348874 44.3812628,47.6989041 L44.3007337,47.6424473 Z\" id=\"Fill-1063\" fill=\"#FFFFFF\"></path></g></g></g><g id=\"Group-Copy-2\" transform=\"translate(20.000000, 6.000000)\" fill=\"#999999\"><g id=\"Group-9\"><path d=\"M3.41011956,0.275289763 C2.0966752,0.275289763 0.200251995,0.90949071 0.200251995,2.20318018 L0.200251995,2.33507789 L0.200251995,11.0409011 L0.200251995,13.2351732 L0.200251995,15.1989835 L0.200251995,24.1096936 C0.200251995,25.403383 2.0966752,26.1950566 3.41011956,26.1950566 L18.9988136,26.4620029 L21.5763848,28.9743525 L24.1232356,26.4620029 L40.8368966,26.1950566 C42.1500506,26.1950566 42.9525175,25.403383 42.9525175,24.1096936 L42.9525175,2.33507789 C42.9525175,1.04110106 42.1500506,0.275289763 40.8368966,0.275289763 L3.41011956,0.275289763 Z\" id=\"Clip-8\"></path></g></g><g id=\"Group\" filter=\"url(#filter-3)\" transform=\"translate(19.000000, 5.000000)\"><g id=\"Group-9\" fill=\"#FFFFFF\"><path d=\"M3.41011956,0.275289763 C2.0966752,0.275289763 0.200251995,0.90949071 0.200251995,2.20318018 L0.200251995,2.33507789 L0.200251995,11.0409011 L0.200251995,13.2351732 L0.200251995,15.1989835 L0.200251995,24.1096936 C0.200251995,25.403383 2.0966752,26.1950566 3.41011956,26.1950566 L18.9988136,26.4620029 L21.5763848,28.9743525 L24.1232356,26.4620029 L40.8368966,26.1950566 C42.1500506,26.1950566 42.9525175,25.403383 42.9525175,24.1096936 L42.9525175,2.33507789 C42.9525175,1.04110106 42.1500506,0.275289763 40.8368966,0.275289763 L3.41011956,0.275289763 Z\" id=\"Clip-8\"></path></g><polygon id=\"Fill-11\" fill=\"#CCCCCC\" points=\"4.49253731 15.8258652 38.4989759 15.8258652 38.4989759 14.1777778 4.49253731 14.1777778\"></polygon><polygon id=\"Fill-12\" fill=\"#CCCCCC\" points=\"4.49253731 21.6258652 38.4989759 21.6258652 38.4989759 19.9777778 4.49253731 19.9777778\"></polygon></g><g id=\"Group-6\" transform=\"translate(32.000000, 0.000000)\"><g id=\"Group-37\"><mask id=\"mask-5\" fill=\"white\"><use xlink:href=\"#path-4\"></use></mask><g id=\"Clip-36\"></g><polygon id=\"Fill-35\" fill=\"#FF9EF6\" mask=\"url(#mask-5)\" points=\"-1.40956444 16.2912977 18.3093778 16.2912977 18.3093778 -1.27463684 -1.40956444 -1.27463684\"></polygon></g></g></g></g></svg>"

/***/ }),

/***/ "./src/components/ThankingDonors/thankMessageValidation.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");

var rules = {
    thankYouMessage: [Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["f" /* minLength */])(3), Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["d" /* maxLength */])(200)],
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(rules));


/***/ }),

/***/ "./src/components/Totaliser/Totaliser.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_totaliser__ = __webpack_require__("./node_modules/@justgiving/totaliser/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");



var Totaliser = function (_a) {
    var percentage = _a.percentage, requestedSize = _a.requestedSize;
    var size = requestedSize
        ? requestedSize
        : Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_browser__["h" /* isMobileUserAgent */])()
            ? 'medium'
            : 'large';
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-center-block" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__justgiving_totaliser__["a" /* Totaliser */], { percent: percentage, size: size })));
};
/* harmony default export */ __webpack_exports__["a"] = (Totaliser);


/***/ }),

/***/ "./src/components/Transitions/RevealTransition.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transition__ = __webpack_require__("./src/components/Transitions/Transition.tsx");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var RevealTransition = function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Transition__["a" /* default */], __assign({ property: "opacity", before: { opacity: 0 }, after: { opacity: 1 } }, props))); };
/* harmony default export */ __webpack_exports__["a"] = (RevealTransition);


/***/ }),

/***/ "./src/components/Transitions/Transition.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Transition = /** @class */ (function (_super) {
    __extends(Transition, _super);
    function Transition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTransitionEnd = function () {
            var _a = _this.props, willChange = _a.willChange, onComplete = _a.onComplete;
            if (willChange) {
                _this.element.style.willChange = 'auto';
            }
            if (onComplete) {
                onComplete();
            }
            _this.element.removeEventListener('transitionend', _this.handleTransitionEnd);
        };
        return _this;
    }
    Transition.prototype.componentDidMount = function () {
        var _this = this;
        if (this.element && this.props.active) {
            this.startTransition(this.props);
            Object.keys(this.props.after || {}).forEach(function (p) {
                _this.element.style[p] = (_this.props.after || {})[p];
            });
        }
    };
    Transition.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.active !== this.props.active) {
            this.startTransition(nextProps);
        }
    };
    Transition.prototype.startTransition = function (_a) {
        var willChange = _a.willChange, onComplete = _a.onComplete;
        if (true && this.element) {
            if (willChange) {
                this.element.style.willChange = willChange;
            }
            if (willChange || onComplete) {
                this.element.addEventListener('transitionend', this.handleTransitionEnd);
            }
        }
    };
    Transition.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, active = _a.active, before = _a.before, after = _a.after, property = _a.property, delay = _a.delay, duration = _a.duration, timingFunction = _a.timingFunction;
        var style = __assign({ transitionProperty: property, transitionDelay: delay, transitionDuration: duration, transitionTimingFunction: timingFunction }, (active ? after : before));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { ref: function (r) {
                _this.element = r;
            }, style: style }, children));
    };
    Transition.defaultProps = {
        active: false,
        before: {},
        after: {},
        property: 'all',
        delay: '0s',
        duration: '1s',
        timingFunction: 'ease',
    };
    return Transition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Transition);


/***/ }),

/***/ "./src/components/Transitions/TranslateXTransition.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transition__ = __webpack_require__("./src/components/Transitions/Transition.tsx");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var TranslateXTransition = function (_a) {
    var startOffset = _a.startOffset, endOffset = _a.endOffset, before = _a.before, after = _a.after, props = __rest(_a, ["startOffset", "endOffset", "before", "after"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Transition__["a" /* default */], __assign({ property: "transform", willChange: "transform", before: createTransform(startOffset, before || {}), after: createTransform(endOffset, after || {}) }, props)));
};
TranslateXTransition.defaultProps = {
    startOffset: 0,
    endOffset: 0,
};
function createTransform(offset, style) {
    if (offset === 0) {
        return style;
    }
    var transform = "translateX(" + offset + "px)";
    return __assign({}, style, { transform: transform, msTransform: transform, WebkitTransform: transform });
}
/* harmony default export */ __webpack_exports__["a"] = (TranslateXTransition);


/***/ }),

/***/ "./src/components/Transitions/TranslateYTransition.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transition__ = __webpack_require__("./src/components/Transitions/Transition.tsx");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var TranslateYTransition = function (_a) {
    var startOffset = _a.startOffset, endOffset = _a.endOffset, before = _a.before, after = _a.after, props = __rest(_a, ["startOffset", "endOffset", "before", "after"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Transition__["a" /* default */], __assign({ property: "transform", willChange: "transform", before: createTransform(startOffset || 0, before || {}), after: createTransform(endOffset || 0, after || {}) }, props)));
};
function createTransform(offset, style) {
    if (offset === 0) {
        return style;
    }
    var transform = "translateY(" + offset + "px)";
    return __assign({}, style, { transform: transform, msTransform: transform, WebkitTransform: transform });
}
TranslateYTransition.defaultProps = {
    startOffset: 0,
    endOffset: 0,
};
/* harmony default export */ __webpack_exports__["a"] = (TranslateYTransition);


/***/ }),

/***/ "./src/components/Transitions/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transition__ = __webpack_require__("./src/components/Transitions/Transition.tsx");
/* unused harmony reexport Transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TranslateXTransition__ = __webpack_require__("./src/components/Transitions/TranslateXTransition.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__TranslateXTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TranslateYTransition__ = __webpack_require__("./src/components/Transitions/TranslateYTransition.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__TranslateYTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RevealTransition__ = __webpack_require__("./src/components/Transitions/RevealTransition.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__RevealTransition__["a"]; });






/***/ }),

/***/ "./src/components/Updates/Updates.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1y7m9","date":"_1lIVB","updates-list":"_2pZ8k","updates-timeline-container":"_2N75O","updates-first-item-container":"_3ve0E","updates-timeline-marker":"_19TEN","updates-first-item-marker-container":"_1qmZt","updates-first-item-description":"_3qUxc","updates-first-item-marker":"QLO8P","avatar-container":"_1f6-w","avatar-image":"_3xRED","supporters":"_3jfuW","supporter":"_1G7cE","action":"FLi3S","action-box":"CHj_R","item":"LRyXQ"};

/***/ }),

/***/ "./src/components/Updates/Updates.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__("./node_modules/react-scroll/modules/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_LoadingButton___ = __webpack_require__("./src/components/LoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Updates_scss__ = __webpack_require__("./src/components/Updates/Updates.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Updates_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Updates_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_RichUpdates_RichUpdatesCreator__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesCreator/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesTimelineItem/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_RichUpdates_RichUpdatesPlaceholder__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesPlaceholder/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_RichUpdates_RichUpdatesItem__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var Updates = /** @class */ (function (_super) {
    __extends(Updates, _super);
    function Updates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleLoadUpdates = function (e) {
            e.preventDefault();
            var _a = _this.props, id = _a.id, updatesPageNo = _a.updatesPageNo, loadUpdates = _a.loadUpdates;
            var pageSize = 3;
            var loadDetails = {
                pageId: id,
                pageNo: updatesPageNo + 1,
                pageSize: pageSize,
            };
            loadUpdates(loadDetails);
        };
        _this.hasUpdates = function (updates) { return !!(updates && updates.length > 0); };
        _this.renderReport = function () {
            var _a = _this.props, ownerName = _a.ownerName, profileImage = _a.profileImage, finishedAt = _a.finishedAt, completeImage = _a.completeImage, report = _a.report, isOwner = _a.isOwner, deleteRichUpdate = _a.deleteRichUpdate, watchingVideoToggle = _a.watchingVideoToggle;
            var reportDate = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_date__["f" /* distanceInWordsToNow */])(finishedAt);
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { id: "0", className: __WEBPACK_IMPORTED_MODULE_5__Updates_scss___default.a.item },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__["a" /* default */], { ownerProfileImageUrl: profileImage, ownerName: ownerName, date: reportDate },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_RichUpdates_RichUpdatesItem__["a" /* default */], { id: 0, ownerProfileImageUrl: profileImage, date: reportDate, media: [{ type: 1, path: completeImage || '' }], message: report || '', ownerName: ownerName, isOwner: isOwner, isLowReachAlertVisible: false, deleteRichUpdate: deleteRichUpdate, watchingVideoToggle: watchingVideoToggle }))));
        };
        _this.renderUpdatesList = function (updates) {
            var _a = _this.props, ownerName = _a.ownerName, isOwner = _a.isOwner, deleteRichUpdate = _a.deleteRichUpdate, profileImage = _a.profileImage, watchingVideoToggle = _a.watchingVideoToggle;
            return updates.map(function (update, index) {
                var updateDate = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_date__["f" /* distanceInWordsToNow */])(update.createdAt);
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { key: index, id: update.id.toString(), className: __WEBPACK_IMPORTED_MODULE_5__Updates_scss___default.a.item },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__["a" /* default */], { ownerProfileImageUrl: profileImage, ownerName: ownerName, date: updateDate },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_RichUpdates_RichUpdatesItem__["a" /* default */], { date: updateDate, deleteRichUpdate: deleteRichUpdate, id: update.id, isLowReachAlertVisible: update.sharedToFacebook !== undefined &&
                                !update.sharedToFacebook &&
                                index === 0, isOwner: isOwner, message: update.message, media: update.media, ownerName: ownerName, ownerProfileImageUrl: profileImage, type: update.type, watchingVideoToggle: watchingVideoToggle }))));
            });
        };
        return _this;
    }
    Updates.prototype.allUpdatesShowing = function () {
        var _a = this.props, updates = _a.updates, totalCountUpdates = _a.totalCountUpdates, isLoadingUpdates = _a.isLoadingUpdates;
        var hasMore = updates.length < totalCountUpdates;
        return (hasMore && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "action-box" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_LoadingButton___["a" /* default */], { loading: isLoadingUpdates, onClick: this.handleLoadUpdates, className: ['jg-btn--ghost', __WEBPACK_IMPORTED_MODULE_5__Updates_scss___default.a.action], color: "purple", value: "Show more" }))));
    };
    Updates.prototype.renderLatestTimelineItem = function () {
        var _a = this.props, page = _a.page, profileImage = _a.profileImage, isActive = _a.isActive, isClosed = _a.isClosed, updates = _a.updates, ownerName = _a.ownerName;
        if (page.isOwnerRequested) {
            if (Object(__WEBPACK_IMPORTED_MODULE_10_src_helpers_page__["b" /* canPostUpdates */])(page)) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__["a" /* default */], { ownerProfileImageUrl: profileImage, ownerName: ownerName },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_RichUpdates_RichUpdatesCreator__["a" /* default */], { pageName: page.name, avatarImageUrl: profileImage })));
            }
            else if (!isActive && !isClosed) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__["a" /* default */], { ownerProfileImageUrl: profileImage, ownerName: ownerName },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_RichUpdates_RichUpdatesPlaceholder__["a" /* default */], { title: "No updates yet", subtitle: "You will be able to write updates here once your page is live" })));
            }
        }
        else {
            if (!this.hasUpdates(updates)) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdatesTimelineItem__["a" /* default */], { ownerProfileImageUrl: profileImage, ownerName: ownerName },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_RichUpdates_RichUpdatesPlaceholder__["a" /* default */], { title: "Updates appear here" })));
            }
        }
        return null;
    };
    Updates.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.scrollTo) {
            __WEBPACK_IMPORTED_MODULE_1_react_scroll__["scroller"].scrollTo('updates', {
                duration: 800,
                smooth: true,
            });
            nextProps.scrolledToUpdate();
        }
    };
    Updates.prototype.render = function () {
        var _a = this.props, activatedAt = _a.activatedAt, status = _a.status, ownerName = _a.ownerName, updates = _a.updates, totalCountUpdates = _a.totalCountUpdates;
        // TODO: Refactor once final thank you is part of the updates list
        var hasPostedFinalUpdate = status === 'ReportGenerated';
        var updatesCount = totalCountUpdates + (hasPostedFinalUpdate ? 1 : 0);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Element"], { name: "updates" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container", className: "jg-space-phms@md" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-display-flex jg-space-pvms jg-space-pbn@md jg-space-mbmd@md" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2 jg-flex-g1" }, "Updates"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h2" }, updatesCount)),
                this.renderLatestTimelineItem(),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "updates-list" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "col-sm-3 col-lg-2", styleName: "updates-timeline-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { styleName: "updates-timeline-marker" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "updates-list" },
                        hasPostedFinalUpdate && this.renderReport(),
                        this.hasUpdates(updates) && this.renderUpdatesList(updates)),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "updates-first-item-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "updates-first-item-marker-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { styleName: "updates-first-item-marker" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall-light", styleName: "date" }, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_date__["f" /* distanceInWordsToNow */])(activatedAt))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "updates-first-item-description" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ownerName),
                                " started crowdfunding")))),
                this.allUpdatesShowing())));
    };
    return Updates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Updates, __WEBPACK_IMPORTED_MODULE_5__Updates_scss___default.a));


/***/ }),

/***/ "./src/components/WhatIsCrowdfunding/WhatIsCrowdfunding.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");



var WhatIsCrowdfunding = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "jg-h4" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: "/", className: "jg-text--link" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "WhatIsCrowdfunding.title" }, "What is crowdfunding?"))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "WhatIsCrowdfunding.description" }, "Crowdfunding is a new type of fundraising where you can raise funds for your own personal cause, even if you're not a registered charity.")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--small-light jg-space-mbn" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "WhatIsCrowdfunding.funds" }, "The page owner is responsible for the distribution of funds raised."))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["c" /* withI18n */])()(WhatIsCrowdfunding));


/***/ }),

/***/ "./src/constants/experiments.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return experiments; });
// Can use as const when typescript is updated past 3.4
// Used to narrow type to its literal value when passed into things like Object.values
// otherwise the output of Object.values would be string[] instead of ('a' | 'b')[] for example
var experiments = {
    b2c_interstitial_option_copy_change: 'b2c_interstitial_option_copy_change',
};


/***/ }),

/***/ "./src/containers/App.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_renderRoutes__ = __webpack_require__("./src/helpers/renderRoutes.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_styles_crowdfunding_less__ = __webpack_require__("./src/styles/crowdfunding.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_styles_crowdfunding_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_styles_crowdfunding_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_styles_app_scss__ = __webpack_require__("./src/styles/app.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_src_styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_routes__ = __webpack_require__("./src/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_AppErrorBoundary__ = __webpack_require__("./src/components/AppErrorBoundary/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__justgiving_chrome_react__ = __webpack_require__("./node_modules/@justgiving/chrome-react/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    };
    App.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_components_AppErrorBoundary__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, { title: "Crowdfunding for Good from JustGiving", meta: [
                    { name: 'title', content: 'Crowdfunding For Good From JustGiving' },
                    {
                        name: 'description',
                        content: 'With JustGiving Crowdfunding, anyone can raise money to fund their own project. If it benefits a friend in need, or a local or overseas community.',
                    },
                    {
                        name: 'keywords',
                        content: 'donate,charity,fundraise,donation,raise,money,giftaid,justgiving',
                    },
                    { property: 'fb:app_id', content: __WEBPACK_IMPORTED_MODULE_5_config__["FB_APP_ID"] },
                    { property: 'og:title', content: 'JustGiving' },
                    { property: 'og:site_name', content: 'JustGiving' },
                    {
                        property: 'og:description',
                        content: 'Raise money, support your friends, give to a cause. Show you care.',
                    },
                    { property: 'og:url', content: __WEBPACK_IMPORTED_MODULE_5_config__["CROWDFUNDING_BASE_URI"] },
                    {
                        property: 'og:image',
                        content: 'https://www.justgiving.com/favicon-194x194.png',
                    },
                    { name: 'twitter:card', content: 'summary' },
                    { name: 'twitter:site', content: 'justgiving' },
                    { name: 'twitter:title', content: 'Join the JustGiving community' },
                    {
                        name: 'twitter:description',
                        content: 'Raise money, support your friends, give to a cause. Show you care.',
                    },
                    {
                        name: 'twitter:image:src',
                        content: 'https://www.justgiving.com/favicon-194x194.png',
                    },
                    { name: 'twitter:domain', content: 'justgiving.com' },
                    { name: 'twitter:app:country', content: 'GB' },
                    { name: 'twitter:app:name:iphone', content: 'JustGiving' },
                    { name: 'twitter:app:id:iphone', content: '365315851' },
                    { name: 'twitter:app:name:ipad', content: 'JustGiving' },
                    { name: 'twitter:app:id:ipad', content: '365315851' },
                    {
                        name: 'twitter:app:id:googleplay',
                        content: 'com.justgiving.app',
                    },
                    {
                        name: 'apple-mobile-web-app-title',
                        content: 'JustGiving Crowdfunding',
                    },
                    { name: 'application-name', content: 'JustGiving Crowdfunding' },
                    { name: 'msapplication-TileColor', content: '#ffffff' },
                    { name: 'theme-color', content: '#ffffff' },
                    {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, user-scalable=no',
                    },
                ], link: [
                    {
                        rel: 'apple-touch-icon',
                        sizes: '180x180',
                        href: '/apple-touch-icon.png',
                    },
                    {
                        rel: 'icon',
                        sizes: '32x32',
                        type: 'image/png',
                        href: 'https://www.jg-cdn.com/favicons/favicon-32x32.png',
                    },
                    {
                        rel: 'icon',
                        sizes: '194x194',
                        type: 'image/png',
                        href: 'https://www.jg-cdn.com/favicons/favicon-194x194.png',
                    },
                    {
                        rel: 'icon',
                        sizes: '192x192',
                        type: 'image/png',
                        href: 'https://www.jg-cdn.com/favicons/android-chrome-192x192.png',
                    },
                    {
                        rel: 'icon',
                        sizes: '16x16',
                        type: 'image/png',
                        href: 'https://www.jg-cdn.com/favicons/favicon-16x16.png',
                    },
                    {
                        rel: 'manifest',
                        href: 'https://www.jg-cdn.com/favicons/manifest.json',
                    },
                    {
                        rel: 'mask-icon',
                        href: 'https://www.jg-cdn.com/favicons/safari-pinned-tab.svg',
                        color: '#7a04dd',
                    },
                ] }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__justgiving_chrome_react__["a" /* default */], { headerVariant: "consumer-crowdfunding", footerVariant: "full" }),
            Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_renderRoutes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8_src_routes__["a" /* default */])));
    };
    App.propTypes = {
        location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    };
    return App;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["f" /* withRouter */])(App));


/***/ }),

/***/ "./src/containers/NotFoundView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Error_Error__ = __webpack_require__("./src/components/Error/Error.tsx");


var NotFoundView = function () { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Error_Error__["a" /* default */], { error: "404" }); };
/* harmony default export */ __webpack_exports__["a"] = (NotFoundView);


/***/ }),

/***/ "./src/containers/forms/PersonalIdNumberContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___ = __webpack_require__("./src/components/AdditionalDetails/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/actions.ts");




function mapDispatchToProps(dispatch, ownProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        updateStripeAccountDetails: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__["f" /* updateStripeAccountDetails */],
    }, dispatch);
}
var PersonalIdNumberContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___["a" /* PersonalIdNumberForm */]);
/* harmony default export */ __webpack_exports__["a"] = (PersonalIdNumberContainer);


/***/ }),

/***/ "./src/containers/forms/SSNLastFourContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___ = __webpack_require__("./src/components/AdditionalDetails/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/actions.ts");




function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        updateStripeAccountDetails: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__["f" /* updateStripeAccountDetails */],
    }, dispatch);
}
var SSNLastFourContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___["b" /* SSNLastFourForm */]);
/* harmony default export */ __webpack_exports__["a"] = (SSNLastFourContainer);


/***/ }),

/***/ "./src/containers/forms/StripeVerificationDocumentContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___ = __webpack_require__("./src/components/AdditionalDetails/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_photoEditor__ = __webpack_require__("./src/redux/modules/photoEditor.ts");





function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        submitStripeVerificationDocument: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_stripeVirtualAccount_actions__["e" /* submitStripeVerificationDocument */],
        updateCrop: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_photoEditor__["e" /* updateCrop */].bind(null, 'stripeVerification'),
        rotateImage: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_photoEditor__["d" /* rotateImage */].bind(null, 'stripeVerification'),
        removeImage: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_photoEditor__["c" /* removeImage */].bind(null, 'stripeVerification'),
    }, dispatch);
}
function mapStateToProps(state) {
    return {
        cropData: state.editStripeVerificationDocument.cropData,
    };
}
var StripeVerificationDocumentContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_AdditionalDetails___["c" /* StripeVerificationDocumentForm */]);
/* harmony default export */ __webpack_exports__["a"] = (StripeVerificationDocumentContainer);


/***/ }),

/***/ "./src/containers/page/AboutFundraiserContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_AboutFundraiser_AboutFundraiser__ = __webpack_require__("./src/components/AboutFundraiser/AboutFundraiser.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_censures__ = __webpack_require__("./src/redux/modules/censures.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





function mapStateToProps(state) {
    return {
        id: state.page.id,
        location: state.page.locationText,
        isContactingOwnerWindowOpen: state.page.isContactingOwnerWindowOpen ||
            state.page.isFeedbackOwnerWindowOpen,
        isFeedbackOwnerWindowOpen: state.page.isFeedbackOwnerWindowOpen,
        contactOwnerPageViewSection: state.page.contactOwnerPageViewSection,
        contactOwnerPageSection: state.page.contactOwnerPageSection,
        contactOwnerSubjectPlaceHolder: state.page.contactOwnerSubjectPlaceHolder,
        contactOwnerMessagePlaceholder: state.page.contactOwnerMessagePlaceholder,
        ownerBio: state.page.ownerBio,
        ownerName: state.page.ownerName,
        profileImage: state.page.ownerProfileImageUrl,
        recaptcha: state.page.recaptcha,
        pageName: state.page.name,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
        addCensure: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_censures__["a" /* addCensure */],
        clearRecaptcha: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["c" /* clearRecaptcha */],
        setRecaptcha: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["p" /* setRecaptcha */],
        closeContactOwner: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["d" /* closeContactOwner */],
        openFeedbackThankYou: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["n" /* openFeedbackThankYou */],
        onMessageSent: function () { },
        openContactOwner: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["m" /* openContactOwner */],
        contactOwner: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_page__["f" /* contactOwner */],
    }, dispatch);
}
var mergeProps = function (stateProps, dispatchProps) {
    return __assign({}, stateProps, dispatchProps, { onMessageSent: stateProps.isFeedbackOwnerWindowOpen
            ? dispatchProps.openFeedbackThankYou
            : undefined });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps, mergeProps)(__WEBPACK_IMPORTED_MODULE_1_src_components_AboutFundraiser_AboutFundraiser__["a" /* default */]));


/***/ }),

/***/ "./src/containers/page/AlternativeProjectsContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_avatars__ = __webpack_require__("./src/redux/modules/avatars.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_AlternativeProjects__ = __webpack_require__("./src/components/AlternativeProjects/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_alternativeProjects__ = __webpack_require__("./src/redux/modules/alternativeProjects.ts");





function mapStateToProps(state) {
    return {
        alternativeProjects: state.alternativeProjects,
        avatars: state.avatars.avatars,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        loadAvatars: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_avatars__["b" /* loadAvatars */],
        renderAlternativeProjectCard: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_alternativeProjects__["d" /* renderAlternativeProjectCard */],
        clickOnAlternativeProjectCard: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_alternativeProjects__["a" /* clickOnAlternativeProjectCard */],
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_src_components_AlternativeProjects__["a" /* default */]));


/***/ }),

/***/ "./src/containers/page/EncourageShareContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EncourageShareContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_EncourageShare_EncourageShare__ = __webpack_require__("./src/components/EncourageShare/EncourageShare.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var propertyName = 'isSharePromptDismissed';
function mapStateToProps(state) {
    return {
        id: state.page.id,
        status: state.page.status,
        ownerName: state.page.ownerName,
        socialShareUrl: state.page.socialShareUrl,
        targetAmount: state.page.targetAmount,
        pitchFor: state.page.pitchFor,
        targetCurrency: state.page.targetCurrency,
        renderAfter: state.page.renderAfter,
        isOwner: state.page.isOwnerRequested,
        pageName: state.page.name,
        ownerProfileImage: state.page.ownerProfileImageUrl,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        analyticsClick: __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_analytics__["a" /* analyticsClick */],
        shareByWhatsApp: __WEBPACK_IMPORTED_MODULE_7_src_redux_modules_page__["t" /* shareByWhatsApp */],
        shareBySms: __WEBPACK_IMPORTED_MODULE_7_src_redux_modules_page__["s" /* shareBySms */],
    }, dispatch);
}
var EncourageShareContainer = /** @class */ (function (_super) {
    __extends(EncourageShareContainer, _super);
    function EncourageShareContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showEncourageShareModal: false,
            currentShowModalTimeout: undefined,
        };
        _this.handleModalClose = function () {
            var id = _this.props.id;
            if (Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__["k" /* isSessionStorageAvailable */])() && Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__["g" /* isLocalStorageAvailable */])()) {
                window.localStorage.setItem(propertyName + ":" + id, 'true');
                window.sessionStorage.setItem(propertyName, 'true');
            }
            _this.setState({
                showEncourageShareModal: false,
            });
            _this.props.analyticsClick({
                event: 'click',
                subtype: 'skip > share prompt',
                pageSection: 'page > share prompt',
                eventValue: 'dismiss',
            });
        };
        return _this;
    }
    EncourageShareContainer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.startNewShowModalTimeout();
                return [2 /*return*/];
            });
        });
    };
    EncourageShareContainer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Start new timeout every time the isEnabled flag is toggled
                if (this.props.isEnabled !== prevProps.isEnabled) {
                    // When the share container isEnabled then start new timeout
                    // Else clear the current timeout when disabled
                    if (this.props.isEnabled) {
                        this.startNewShowModalTimeout();
                    }
                    else {
                        clearTimeout(this.state.currentShowModalTimeout);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    EncourageShareContainer.prototype.startNewShowModalTimeout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, status, id, isOwner, pageName, pathname, renderAfter, newShowModalTimeout;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.props, status = _a.status, id = _a.id, isOwner = _a.isOwner, pageName = _a.pageName, pathname = _a.location.pathname, renderAfter = _a.renderAfter;
                clearTimeout(this.state.currentShowModalTimeout);
                newShowModalTimeout = setTimeout(function () {
                    _this.setState({
                        showEncourageShareModal: !Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_browser__["i" /* isPropertyInLocalAndSessionStorage */])({
                            localPropertyName: propertyName + ":" + id,
                            sessionPropertyName: propertyName,
                        }) &&
                            status === 'Active' &&
                            !isOwner &&
                            pathname === "/" + pageName &&
                            _this.props.isEnabled,
                    });
                }, renderAfter);
                this.setState({ currentShowModalTimeout: newShowModalTimeout });
                return [2 /*return*/];
            });
        });
    };
    EncourageShareContainer.prototype.render = function () {
        var _a = this.props, ownerName = _a.ownerName, socialShareUrl = _a.socialShareUrl, targetAmount = _a.targetAmount, pitchFor = _a.pitchFor, targetCurrency = _a.targetCurrency, shareByWhatsApp = _a.shareByWhatsApp, shareBySms = _a.shareBySms, ownerProfileImage = _a.ownerProfileImage;
        var showEncourageShareModal = this.state.showEncourageShareModal;
        if (!showEncourageShareModal) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Modal__["a" /* default */], { isOpen: true, onClose: this.handleModalClose, colorTheme: "dark", large: true, maintainPosition: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_EncourageShare_EncourageShare__["a" /* default */], { ownerName: ownerName, socialShareUrl: socialShareUrl, targetAmount: targetAmount, pitchFor: pitchFor, targetCurrency: targetCurrency, onCloseModal: this.handleModalClose, shareByWhatsApp: shareByWhatsApp, shareBySms: shareBySms, ownerProfileImage: ownerProfileImage })));
    };
    return EncourageShareContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(EncourageShareContainer)));


/***/ }),

/***/ "./src/containers/page/ErrorPageView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Error_Error__ = __webpack_require__("./src/components/Error/Error.tsx");




var ErrorPageView = function (_a) {
    var error = _a.error;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Error_Error__["a" /* default */], { error: error });
};
ErrorPageView.propTypes = {
    error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) { return ({ error: state.page.failType }); })(ErrorPageView));


/***/ }),

/***/ "./src/containers/page/MetaContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");







function mapStateToProps(state) {
    return {
        pitchFor: state.page.pitchFor,
        targetCurrency: state.page.targetCurrency,
        targetAmount: state.page.targetAmount,
        socialShareUrl: state.page.socialShareUrl,
        ownerName: state.page.ownerName,
        finishedAt: state.page.finishedAt,
        longitude: state.page.longitude,
        latitude: state.page.latitude,
        activatedAt: state.page.activatedAt,
        initialImage: state.page.initialImage,
        socialShareImage: state.page.socialShareImage,
        updateImageUrl: state.richUpdates.linkedUpdate &&
            state.richUpdates.linkedUpdate.media &&
            (state.richUpdates.linkedUpdate.media.length > 0
                ? state.richUpdates.linkedUpdate.media[0].path
                : ''),
    };
}
var MetaContainer = function (_a) {
    var pitchFor = _a.pitchFor, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, socialShareUrl = _a.socialShareUrl, initialImage = _a.initialImage, socialShareImage = _a.socialShareImage, ownerName = _a.ownerName, latitude = _a.latitude, longitude = _a.longitude, finishedAt = _a.finishedAt, activatedAt = _a.activatedAt, match = _a.match, updateImageUrl = _a.updateImageUrl;
    var socialShareImageUrl = updateImageUrl || (socialShareImage && Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_image__["g" /* getImageUrl */])(socialShareImage));
    var updateId = match.params.updateId;
    var pageUrl = updateId
        ? socialShareUrl + "/updates/" + updateId
        : socialShareUrl;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], { title: "Crowdfunding to " + pitchFor + " on JustGiving", meta: [
            {
                content: "Help raise " + (__WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                    '£') + targetAmount + " to " + pitchFor + " \u2013 JustGiving Crowdfunding",
            },
            {
                name: 'description',
                content: "We\u02BCre raising money to " + pitchFor + ". Support this JustGiving Crowdfunding Page.",
            },
            { property: 'fb:app_id', content: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_ID"] },
            {
                property: 'og:title',
                content: "Help raise " + (__WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                    '£') + targetAmount + " to " + pitchFor,
            },
            {
                property: 'og:description',
                content: "We\u02BCre raising money to " + pitchFor + ". Support this JustGiving Crowdfunding Page.",
            },
            {
                property: 'og:type',
                content: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":yimby_project",
            },
            { property: 'og:url', content: pageUrl },
            {
                property: 'og:image',
                content: socialShareImageUrl,
            },
            {
                property: 'og:image:width',
                // TODO: width will be set for old projects only, at some point we should remove this
                content: (initialImage && initialImage.width) || 800,
            },
            {
                property: 'og:image:height',
                // TODO: height will be set for old projects only, at some point we should remove this
                content: (initialImage && initialImage.height) || 450,
            },
            {
                property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":project_owner",
                content: ownerName,
            },
            { property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":pitchfor", content: pitchFor },
            { property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":pitchbecause" },
            {
                property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":targetamount",
                content: targetAmount,
            },
            {
                property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":location:latitude",
                content: latitude,
            },
            {
                property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":location:longitude",
                content: longitude,
            },
            { property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":enddate", content: finishedAt },
            {
                property: __WEBPACK_IMPORTED_MODULE_4_config__["FB_APP_NAMESPACE"] + ":activationdate",
                content: activatedAt,
            },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: "Donate to " + pitchFor },
            {
                name: 'twitter:description',
                content: "We\u02BCre raising money to " + pitchFor + ". Support this JustGiving Crowdfunding Page.",
            },
            {
                name: 'twitter:image',
                content: socialShareImageUrl,
            },
            {
                name: 'twitter:image:src',
                content: socialShareImageUrl,
            },
            {
                name: 'twitter:image:alt',
                content: pitchFor,
            },
        ] }));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(MetaContainer)));


/***/ }),

/***/ "./src/containers/page/OwnerPageView.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OwnerPageView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__ = __webpack_require__("./src/helpers/renderRoutes.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_TabView_TabViewLinks_TabViewLinks__ = __webpack_require__("./src/components/TabView/TabViewLinks/TabViewLinks.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__ = __webpack_require__("./src/components/TabView/TabLink.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_TabView_TabViewContent__ = __webpack_require__("./src/components/TabView/TabViewContent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdateNavLink__ = __webpack_require__("./src/components/RichUpdates/RichUpdateNavLink/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_helpers_analytics__ = __webpack_require__("./src/helpers/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_redux_modules_dashboard__ = __webpack_require__("./src/redux/modules/dashboard/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_containers_page_SharePromptsContainer__ = __webpack_require__("./src/containers/page/SharePromptsContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_containers_page_ShareWithFriendsPromptsContainer__ = __webpack_require__("./src/containers/page/ShareWithFriendsPromptsContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_helpers_alerts_index_ts__ = __webpack_require__("./src/helpers/alerts/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_redux_modules_sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_TabView_TabShareButton_TabShareButton__ = __webpack_require__("./src/components/TabView/TabShareButton/TabShareButton.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PageOwnerNavbarContainer__ = __webpack_require__("./src/containers/page/PageOwnerNavbarContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_FeatureToggle_FeatureToggle__ = __webpack_require__("./src/components/FeatureToggle/FeatureToggle.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_config__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




















function mapStateToProps(state) {
    var page = state.page, payment = state.payment;
    return {
        badgeCount: getBadgeCount(state),
        page: page,
        paypal: payment.paypal,
        appState: state,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    var location = ownProps.location.pathname.split('/')[2] || 'page';
    return __assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        showPayment: __WEBPACK_IMPORTED_MODULE_10_src_redux_modules_page__["q" /* setUpBankDetails */],
        openSharePrompts: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_15_src_redux_modules_sharePrompts__["c" /* openSharePrompts */])(location + " > sticky owner nav");
        },
    }, dispatch), { dispatch: dispatch });
}
function getBadgeCount(state) {
    var tipsState = Object(__WEBPACK_IMPORTED_MODULE_11_src_redux_modules_dashboard__["f" /* getTipsState */])(state);
    var totalTips = Object.keys(tipsState).length;
    var completedTips = Object.values(tipsState).filter(function (t) { return t; }).length;
    return totalTips - completedTips;
}
var OwnerPageView = /** @class */ (function (_super) {
    __extends(OwnerPageView, _super);
    function OwnerPageView(props) {
        var _this = _super.call(this, props) || this;
        _this.getAlert = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_14_src_helpers_alerts_index_ts__["a" /* default */])(_this.props.appState, {
                onClose: function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _a = this.setState;
                                _b = {};
                                return [4 /*yield*/, this.getAlert()];
                            case 1:
                                _a.apply(this, [(_b.alert = _c.sent(), _b)]);
                                return [2 /*return*/];
                        }
                    });
                }); },
                dispatch: _this.props.dispatch,
                pageSection: Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_analytics__["a" /* getPageSection */])(_this.props.location.pathname),
            });
        };
        _this.state = { alert: null };
        return _this;
    }
    OwnerPageView.prototype.shouldDisplayEditTab = function () {
        return !Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["d" /* isClosed */])(this.props.page);
    };
    OwnerPageView.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAlert()];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, this.setState({ alert: alert })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OwnerPageView.prototype.componentDidUpdate = function (_, prevState) {
        return __awaiter(this, void 0, void 0, function () {
            var newAlert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAlert()];
                    case 1:
                        newAlert = _a.sent();
                        if (newAlert === null) {
                            return [2 /*return*/];
                        }
                        if (!newAlert && this.state.alert) {
                            this.setState({ alert: null });
                            return [2 /*return*/];
                        }
                        if (!prevState.alert ||
                            (newAlert && prevState.alert.props.id !== newAlert.props.id)) {
                            this.setState({ alert: newAlert });
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OwnerPageView.prototype.render = function () {
        var _a = this.props, badgeCount = _a.badgeCount, route = _a.route, page = _a.page;
        var alert = this.state.alert;
        var tabContents = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__["a" /* default */])(route.routes);
        var pageSection = Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_analytics__["a" /* getPageSection */])(this.props.location.pathname);
        var isPageOwnerOptimisationOn = __WEBPACK_IMPORTED_MODULE_19_config___default.a.FEATURE.PAGE_OWNER_ADMIN;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_src_components_FeatureToggle_FeatureToggle__["a" /* FeatureToggle */], { featureFlag: isPageOwnerOptimisationOn, isTrue: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_TabView_TabViewLinks_TabViewLinks__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_RichUpdates_RichUpdateNavLink__["a" /* RichUpdateNavLink */], { path: "/" + page.name + "/update", disabled: !Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["b" /* canPostUpdates */])(page), pageSection: pageSection }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__["a" /* default */], { heading: "Page view", path: "/" + page.name, exact: true }),
                    !Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["f" /* isPendingApproval */])(this.props.page) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__["a" /* default */], { heading: "Dashboard", path: "/" + page.name + "/dashboard", badgeCount: badgeCount })),
                    !this.props.page.refundedDate && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__["a" /* default */], { heading: "Funds", path: Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["e" /* isEligibleForFlexiblePayments */])(this.props.page)
                            ? "/" + page.name + "/funds"
                            : "/" + page.name + "/funds/account" })),
                    this.shouldDisplayEditTab() && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__["a" /* default */], { heading: "Edit", path: "/" + page.name + "/edit", exact: true })),
                    !Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["f" /* isPendingApproval */])(this.props.page) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_TabView_TabLink__["a" /* default */], { heading: "Page settings", path: "/" + page.name + "/settings", exact: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_src_components_TabView_TabShareButton_TabShareButton__["a" /* default */], { isActive: Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_page__["c" /* isActive */])(page), openSharePrompt: this.props.openSharePrompts, pageSection: pageSection }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_src_components_FeatureToggle_FeatureToggle__["a" /* FeatureToggle */], { featureFlag: isPageOwnerOptimisationOn, isTrue: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PageOwnerNavbarContainer__["a" /* default */], { page: page, pageSection: pageSection })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_TabView_TabViewContent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_src_containers_page_SharePromptsContainer__["a" /* default */], null),
                alert,
                tabContents),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_src_containers_page_ShareWithFriendsPromptsContainer__["a" /* default */], null)));
    };
    return OwnerPageView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(OwnerPageView));


/***/ }),

/***/ "./src/containers/page/PageFooterContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Page_PageFooter__ = __webpack_require__("./src/components/Page/PageFooter.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






function mapStateToProps(state) {
    var pageClosed = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["d" /* isClosed */])(state.page);
    return {
        isClosed: pageClosed,
        isActive: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["c" /* isActive */])(state.page),
        canPageReceiveDonations: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["a" /* canPageReceiveDonations */])(state.page),
        page: state.page,
        raised: (pageClosed ? state.page.amountRaised : state.page.amountPledged) || 0,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        donate: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["j" /* donate */],
    }, dispatch);
}
var PageFooterContainer = /** @class */ (function (_super) {
    __extends(PageFooterContainer, _super);
    function PageFooterContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageFooterContainer.prototype.render = function () {
        return !this.props.isActive || this.props.isClosed ? null : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Page_PageFooter__["a" /* default */], { page: this.props.page, canPageReceiveDonations: this.props.canPageReceiveDonations, donate: this.props.donate, handleShareButtonClick: this.props.handleShareButtonClick }));
    };
    return PageFooterContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageFooterContainer));


/***/ }),

/***/ "./src/containers/page/PageHeaderContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Page_PageHeader__ = __webpack_require__("./src/components/Page/PageHeader/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_supportersAvatar__ = __webpack_require__("./src/redux/modules/supportersAvatar.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");






function mapStateToProps(state) {
    var page = state.page, supportersAvatar = state.supportersAvatar, settings = state.settings;
    var pageClosed = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["d" /* isClosed */])(page);
    return {
        categories: state.categories,
        isActive: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["c" /* isActive */])(page),
        canPageReceiveDonations: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["a" /* canPageReceiveDonations */])(page),
        isClosed: pageClosed,
        page: page,
        raised: (pageClosed ? page.amountRaised : page.amountPledged) || 0,
        totalCountSupporters: state.supporters.totalCount,
        supportersAvatar: supportersAvatar,
        recaptcha: page.recaptcha,
        profileImage: page.ownerProfileImageUrl,
        location: page.locationText,
        supportsRecurringDonations: settings.supportsRecurringDonations,
        charity: state.charity,
        recurringDonationsPitch: state.page.recurringDonationsPitch,
        isDonationRemindLaterAvailable: settings.isDonationRemindLaterAvailable,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        goEdit: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["k" /* goEdit */],
        donate: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["j" /* donate */],
        loadSupportersAvatar: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_supportersAvatar__["b" /* loadSupportersAvatar */],
        clearRecaptcha: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["c" /* clearRecaptcha */],
        contactOwner: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["f" /* contactOwner */],
        sharePageLink: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["A" /* sharePageLink */],
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_Page_PageHeader__["a" /* default */]));


/***/ }),

/***/ "./src/containers/page/PageOwnerNavbarContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_PageOwner_PageOwnerNavbar__ = __webpack_require__("./src/components/PageOwner/PageOwnerNavbar.tsx");




function mapDispatchToProps(dispatch, ownProps) {
    var pageSection = ownProps.pageSection;
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        openSharePrompts: function () { return Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_sharePrompts__["c" /* openSharePrompts */])(pageSection); },
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(undefined, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_src_components_PageOwner_PageOwnerNavbar__["a" /* PageOwnerNavbar */]));


/***/ }),

/***/ "./src/containers/page/PageView.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_renderRoutes__ = __webpack_require__("./src/helpers/renderRoutes.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_containers_page_AboutFundraiserContainer__ = __webpack_require__("./src/containers/page/AboutFundraiserContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_containers_page_AlternativeProjectsContainer__ = __webpack_require__("./src/containers/page/AlternativeProjectsContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_CrossSellBanner_CrossSellBanner__ = __webpack_require__("./src/components/CrossSellBanner/CrossSellBanner.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_containers_page_EncourageShareContainer__ = __webpack_require__("./src/containers/page/EncourageShareContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_LastUpdated_LastUpdated__ = __webpack_require__("./src/components/LastUpdated/LastUpdated.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_containers_page_MetaContainer__ = __webpack_require__("./src/containers/page/MetaContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Page_PageContent__ = __webpack_require__("./src/components/Page/PageContent/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Page_PageContentWrapper__ = __webpack_require__("./src/components/Page/PageContentWrapper/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_containers_page_PageFooterContainer__ = __webpack_require__("./src/containers/page/PageFooterContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_containers_page_PageHeaderContainer__ = __webpack_require__("./src/containers/page/PageHeaderContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Page_PageSidebar__ = __webpack_require__("./src/components/Page/PageSidebar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Page_PageWrapper__ = __webpack_require__("./src/components/Page/PageWrapper/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_containers_page_RecurringDonationsAwarenessBannerContainer__ = __webpack_require__("./src/containers/page/RecurringDonationsAwarenessBannerContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_RichStory__ = __webpack_require__("./src/components/RichStory/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_ShareModal_ShareModal__ = __webpack_require__("./src/components/ShareModal/ShareModal.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_containers_page_SocialShareContainer__ = __webpack_require__("./src/containers/page/SocialShareContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_containers_page_StickyHeaderDonorContainer__ = __webpack_require__("./src/containers/page/StickyHeaderDonorContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_SupportMessage_SupportMessage__ = __webpack_require__("./src/components/SupportMessage/SupportMessage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_containers_page_SupportersContainer__ = __webpack_require__("./src/containers/page/SupportersContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Transitions__ = __webpack_require__("./src/components/Transitions/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__updates_UpdateModalView__ = __webpack_require__("./src/containers/updates/UpdateModalView.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_containers_page_UpdatesContainer__ = __webpack_require__("./src/containers/page/UpdatesContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_WhatIsCrowdfunding_WhatIsCrowdfunding__ = __webpack_require__("./src/components/WhatIsCrowdfunding/WhatIsCrowdfunding.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_redux_modules_sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_redux_modules_charity_actions__ = __webpack_require__("./src/redux/modules/charity/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_helpers_analytics__ = __webpack_require__("./src/helpers/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_redux_modules_settings_actions__ = __webpack_require__("./src/redux/modules/settings/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_redux_modules_richUpdates__ = __webpack_require__("./src/redux/modules/richUpdates/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_helpers_prompts__ = __webpack_require__("./src/helpers/prompts/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_redux_modules_richUpdates_actions__ = __webpack_require__("./src/redux/modules/richUpdates/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









































var mapStateToProps = function (state, props) {
    return {
        id: state.page.id,
        isPageClosed: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["d" /* isClosed */])(state.page),
        page: state.page,
        supporters: state.supporters.items,
        socialShareUrl: state.page.socialShareUrl,
        isLoadingUpdates: state.richUpdates.isLoading,
        updates: Object(__WEBPACK_IMPORTED_MODULE_36_src_redux_modules_richUpdates__["c" /* getUpdates */])(state.richUpdates),
        isSharePromptsOpen: state.sharePrompts.isSharePromptsOpen,
        isShareWithFriendsPromptsOpen: state.shareWithFriendsPrompts.isShareWithFriendsPromptsOpen,
        richStory: state.page.richStory,
        isOwnerRequested: state.page.isOwnerRequested,
        appState: state,
        isCreateWizardOpen: state.page.isCreateWizardOpen,
        supportsRecurringDonations: state.settings.supportsRecurringDonations,
        ownerProfileImageUrl: state.page.ownerProfileImageUrl,
        ownerName: state.page.ownerName,
        pitchFor: state.page.pitchFor,
        isActive: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["c" /* isActive */])(state.page),
        targetAmount: Math.floor(state.page.targetAmount),
        pageName: state.page.name,
        totalCountSupporters: state.supporters.totalCount,
        areDonationsEnabled: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["a" /* canPageReceiveDonations */])(state.page),
    };
};
var mapDispatchToProps = function (dispatch, props) {
    return __assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        // TODO: remove once analytics middleware gets enabled server-side
        onPageMount: function (page) { return ({ type: 'PAGE_MOUNT', payload: page }); },
        tipsPromptClosed: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["C" /* tipsPromptClosed */],
        createPageLikeThis: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["g" /* createPageLikeThis */],
        crossSellBannerImpression: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["h" /* crossSellBannerImpression */],
        scrollToUpdate: __WEBPACK_IMPORTED_MODULE_39_src_redux_modules_richUpdates_actions__["h" /* scrollToUpdate */],
        getPageSettings: __WEBPACK_IMPORTED_MODULE_35_src_redux_modules_settings_actions__["a" /* getPageSettings */],
        getCharityInfo: __WEBPACK_IMPORTED_MODULE_33_src_redux_modules_charity_actions__["a" /* getCharityInfo */],
        analyticsClick: __WEBPACK_IMPORTED_MODULE_0_src_redux_modules_analytics__["a" /* analyticsClick */],
        shareOnTwitter: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["z" /* shareOnTwitter */],
        shareByEmail: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["r" /* shareByEmail */],
        shareByWhatsApp: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["t" /* shareByWhatsApp */],
        shareOnMessenger: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["y" /* shareOnMessenger */],
        shareOnLinkedIn: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["x" /* shareOnLinkedIn */],
        sharePageLink: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["A" /* sharePageLink */],
        shareQrCode: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["B" /* shareQrCode */],
        closeSharePrompts: __WEBPACK_IMPORTED_MODULE_31_src_redux_modules_sharePrompts__["a" /* closeSharePrompts */],
        push: __WEBPACK_IMPORTED_MODULE_38_react_router_redux__["b" /* push */],
        shareBySms: __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page__["s" /* shareBySms */],
    }, dispatch), { dispatch: dispatch });
};
var PageView = /** @class */ (function (_super) {
    __extends(PageView, _super);
    function PageView(props) {
        var _this = _super.call(this, props) || this;
        _this.activatePromptTransition = function (_a) {
            var height = _a.height;
            _this.setState({ promptTransitionActive: true, promptHeight: height });
        };
        _this.closePrompt = function () {
            _this.props.tipsPromptClosed();
            _this.setState({ promptTransitionActive: false });
        };
        _this.handleShareModalClose = function () {
            _this.props.analyticsClick({
                event: 'click',
                subtype: 'button',
                eventValue: 'close share modal',
                pageSection: _this.state.shareModalOpenPageSection,
            });
            _this.setState({ shareModalOpen: false, shareModalOpenPageSection: '' });
        };
        _this.handleShareButtonClick = function (pageSection) {
            _this.props.analyticsClick({
                event: 'click',
                eventValue: 'open share modal',
                pageSection: pageSection,
                subtype: 'button',
            });
            _this.setState({
                shareModalOpen: true,
                shareModalOpenPageSection: pageSection,
            });
        };
        _this.state = {
            shareModalOpen: false,
            shareModalOpenPageSection: '',
            isSetReminderModalOpen: false,
            updateImageUrl: '',
        };
        return _this;
    }
    PageView.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, page, onPageMount, match, scrollToUpdate, isPageClosed;
            return __generator(this, function (_b) {
                _a = this.props, page = _a.page, onPageMount = _a.onPageMount, match = _a.match, scrollToUpdate = _a.scrollToUpdate, isPageClosed = _a.isPageClosed;
                // This is used by analytics for server-side rendered pages, which don't
                // receive PAGE_SUCCESS on the first page load on the client, but still
                // need to send analytics events like "page view".
                // TODO: remove once analytics middleware gets enabled server-side
                onPageMount(page);
                if (match.params.updateId !== undefined) {
                    Object(__WEBPACK_IMPORTED_MODULE_40_src_helpers_browser__["l" /* setScrollRestoration */])('manual');
                    scrollToUpdate();
                }
                if (!isPageClosed) {
                    this.props.getPageSettings();
                }
                if (page.charityId) {
                    this.props.getCharityInfo(page.charityId);
                }
                return [2 /*return*/];
            });
        });
    };
    PageView.prototype.componentWillUnmount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_40_src_helpers_browser__["l" /* setScrollRestoration */])('auto');
    };
    PageView.prototype.render = function () {
        var _this = this;
        var _a = this.props, page = _a.page, route = _a.route, isPageClosed = _a.isPageClosed, socialShareUrl = _a.socialShareUrl, richStory = _a.richStory, isOwnerRequested = _a.isOwnerRequested, supporters = _a.supporters, updates = _a.updates, isCreateWizardOpen = _a.isCreateWizardOpen, supportsRecurringDonations = _a.supportsRecurringDonations;
        var _b = this.state, promptTransitionActive = _b.promptTransitionActive, promptHeight = _b.promptHeight;
        var showStickyHeader = !isOwnerRequested && !isPageClosed;
        var prompt = Object(__WEBPACK_IMPORTED_MODULE_37_src_helpers_prompts__["a" /* default */])(this.props.appState, isOwnerRequested, {
            dispatch: this.props.dispatch,
            pageSection: Object(__WEBPACK_IMPORTED_MODULE_34_src_helpers_analytics__["a" /* getPageSection */])(this.props.location.pathname),
            activatePromptTransition: this.activatePromptTransition,
            closePrompt: this.closePrompt,
            promptTransitionActive: this.state.promptTransitionActive,
        });
        return (__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_src_containers_page_MetaContainer__["a" /* default */], null),
            showStickyHeader && (__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_src_containers_page_StickyHeaderDonorContainer__["a" /* default */], { handleShareButtonClick: function () {
                    return _this.handleShareButtonClick('page > share and donate fixed header');
                } })),
            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { style: { marginBottom: promptHeight } },
                !isCreateWizardOpen && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("section", null, prompt),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_src_components_Transitions__["c" /* TranslateYTransition */], { active: promptTransitionActive, endOffset: promptHeight, duration: "0.5s", timingFunction: "ease-in-out" },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_src_components_Page_PageWrapper__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_src_containers_page_PageHeaderContainer__["a" /* default */], { handleShareButtonClick: function () {
                                return _this.handleShareButtonClick('page > top');
                            }, handleReminderModalToggle: function (isOpen) {
                                return _this.setState({ isSetReminderModalOpen: isOpen });
                            } }),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_src_components_Page_PageContentWrapper__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_src_components_Page_PageContent__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_src_components_RichStory__["a" /* default */], { storyNodes: richStory }),
                                supportsRecurringDonations && (__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: "jg-space-mhmd jg-space-mhxl@lg jg-space-mbml jg-space-mbsm@lg" },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_src_containers_page_RecurringDonationsAwarenessBannerContainer__["a" /* default */], null))),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_src_containers_page_SocialShareContainer__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_src_containers_page_UpdatesContainer__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_src_components_SupportMessage_SupportMessage__["a" /* default */], { socialShareUrl: socialShareUrl }),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_src_components_LastUpdated_LastUpdated__["a" /* default */], { createdAt: page.createdAt, activatedAt: page.activatedAt, supporters: supporters, updates: updates })),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_src_components_Page_PageSidebar__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_src_containers_page_SupportersContainer__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_src_components_WhatIsCrowdfunding_WhatIsCrowdfunding__["a" /* default */], { className: "jg-bdt jg-bd--solid jg-bd--very-light-grey jg-space-ptlg jg-space-pmd jg-space-mtlg jg-space-mbmd" })))),
                    __WEBPACK_IMPORTED_MODULE_10_config__["FEATURE"].ALTERNATIVE_PROJECTS && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_containers_page_AlternativeProjectsContainer__["a" /* default */], null),
                    isPageClosed && (__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_components_CrossSellBanner_CrossSellBanner__["a" /* default */], { crossSellBannerImpression: this.props.crossSellBannerImpression, createPageLikeThis: this.props.createPageLikeThis })),
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div", { className: "jg-bdt jg-bd--solid jg-bd--very-light-grey jg-space-pms jg-space-pblg" },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_containers_page_AboutFundraiserContainer__["a" /* default */], null)),
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_src_containers_page_EncourageShareContainer__["a" /* default */], { isEnabled: !this.state.shareModalOpen && !this.state.isSetReminderModalOpen })),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_src_containers_page_PageFooterContainer__["a" /* default */], { handleShareButtonClick: function () {
                        return _this.handleShareButtonClick('page > sticky footer');
                    } })),
            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__updates_UpdateModalView__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_src_components_ShareModal_ShareModal__["a" /* default */], { pageSection: this.state.shareModalOpenPageSection, ownerProfileImageUrl: this.props.ownerProfileImageUrl, ownerName: this.props.ownerName, handleModalClose: this.handleShareModalClose, showModal: this.state.shareModalOpen, shareOnTwitter: this.props.shareOnTwitter, shareByEmail: this.props.shareByEmail, shareByWhatsApp: this.props.shareByWhatsApp, shareOnMessenger: this.props.shareOnMessenger, shareOnLinkedIn: this.props.shareOnLinkedIn, shareQrCode: this.props.shareQrCode, sharePageLink: this.props.sharePageLink, shareBySms: this.props.shareBySms, pitchFor: this.props.pitchFor, isOwner: this.props.isOwnerRequested, isActive: this.props.isActive, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, targetCurrency: this.props.page.targetCurrency, closeSharePrompts: this.props.closeSharePrompts, pageName: this.props.pageName, push: this.props.push }),
            Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_renderRoutes__["a" /* default */])(route.routes)));
    };
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_32_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageView)));


/***/ }),

/***/ "./src/containers/page/RecurringDonationsAwarenessBannerContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_RecurringDonations_RecurringDonationsAwarenessBanner__ = __webpack_require__("./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var mapStateToProps = function (state) {
    return {
        isOwnerRequested: state.page.isOwnerRequested,
        ownerAvatarImage: state.page.ownerProfileImageUrl,
        ownerName: state.page.ownerName,
        pageName: state.page.name,
        recurringDonationsPitch: state.page.recurringDonationsPitch,
    };
};
var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        updatePage: __WEBPACK_IMPORTED_MODULE_1_src_redux_modules_page__["D" /* updatePage */],
    }, dispatch);
};
var RecurringDonationsAwarenessBannerContainer = /** @class */ (function (_super) {
    __extends(RecurringDonationsAwarenessBannerContainer, _super);
    function RecurringDonationsAwarenessBannerContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (data, formikBag) { return __awaiter(_this, void 0, void 0, function () {
            var payload, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = __assign({ name: this.props.pageName }, data);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        formikBag.setStatus(null);
                        return [4 /*yield*/, this.props.updatePage(payload, false)];
                    case 2:
                        _a.sent();
                        formikBag.resetForm(data);
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _a.sent();
                        formikBag.setStatus(error_1);
                        return [2 /*return*/, false];
                    case 4:
                        formikBag.setSubmitting(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    RecurringDonationsAwarenessBannerContainer.prototype.render = function () {
        var _a = this.props, isOwnerRequested = _a.isOwnerRequested, ownerAvatarImage = _a.ownerAvatarImage, ownerName = _a.ownerName, pageName = _a.pageName, recurringDonationsPitch = _a.recurringDonationsPitch;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_RecurringDonations_RecurringDonationsAwarenessBanner__["a" /* default */], { isOwnerRequested: isOwnerRequested, ownerAvatarImage: ownerAvatarImage, ownerName: ownerName, pageName: pageName, recurringDonationsPitch: recurringDonationsPitch, submitPitch: this.handleSubmit }));
    };
    return RecurringDonationsAwarenessBannerContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RecurringDonationsAwarenessBannerContainer));


/***/ }),

/***/ "./src/containers/page/RootPageView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_asyncConnect__ = __webpack_require__("./src/helpers/asyncConnect.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__ = __webpack_require__("./src/helpers/renderRoutes.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_containers_page_OwnerPageView__ = __webpack_require__("./src/containers/page/OwnerPageView.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_containers_page_ErrorPageView__ = __webpack_require__("./src/containers/page/ErrorPageView.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_redux_modules_categories__ = __webpack_require__("./src/redux/modules/categories.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var _this = this;








var fetchData = function (dispatch, params) { return __awaiter(_this, void 0, void 0, function () {
    var loadPagePromise, loadCategoriesPromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loadPagePromise = dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_src_redux_modules_page__["l" /* loadPage */])(params.name));
                loadCategoriesPromise = dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_src_redux_modules_categories__["b" /* loadCategories */])());
                return [4 /*yield*/, Promise.all([loadPagePromise, loadCategoriesPromise])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var mapStateToProps = function (_a) {
    var page = _a.page;
    return ({
        isOwnerRequested: !!page.isOwnerRequested,
        failType: page.failType,
    });
};
var RootPageView = /** @class */ (function (_super) {
    __extends(RootPageView, _super);
    function RootPageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RootPageView.prototype.render = function () {
        var _a = this.props, failType = _a.failType, isOwnerRequested = _a.isOwnerRequested, route = _a.route, rest = __rest(_a, ["failType", "isOwnerRequested", "route"]);
        if (failType) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_containers_page_ErrorPageView__["a" /* default */], __assign({}, rest));
        }
        if (isOwnerRequested) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_containers_page_OwnerPageView__["a" /* default */], __assign({ route: route }, rest));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__["a" /* default */])(route.routes);
    };
    return RootPageView;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
RootPageView.propTypes = {
    isOwnerRequested: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    failType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    fetchData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    route: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        routes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
    }),
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_asyncConnect__["a" /* default */])(RootPageView, {
    mapStateToProps: mapStateToProps,
    fetchData: fetchData,
    id: 'ROOT_PAGE_VIEW',
}));


/***/ }),

/***/ "./src/containers/page/SharePromptsContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SharePromptsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_SharePrompts_SharePrompts__ = __webpack_require__("./src/components/SharePrompts/SharePrompts.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









function mapStateToProps(state) {
    return {
        isActive: Object(__WEBPACK_IMPORTED_MODULE_7_src_helpers_page__["c" /* isActive */])(state.page),
        raised: state.page.amountRaised,
        targetAmount: state.page.targetAmount,
        pitchFor: state.page.pitchFor,
        ownerName: state.page.ownerName,
        isOwner: state.page.isOwnerRequested,
        isSharePromptsOpen: state.sharePrompts.isSharePromptsOpen,
        socialShareUrl: state.page.socialShareUrl,
        targetCurrency: state.page.targetCurrency,
        pageSection: state.sharePrompts.pageSection,
        avatarImage: state.page.ownerProfileImageUrl,
        pageName: state.page.name,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        shareOnTwitter: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["z" /* shareOnTwitter */],
        shareByEmail: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["r" /* shareByEmail */],
        shareByWhatsApp: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["t" /* shareByWhatsApp */],
        shareBySms: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["s" /* shareBySms */],
        sharePageLink: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["A" /* sharePageLink */],
        closeSharePrompts: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_sharePrompts__["a" /* closeSharePrompts */],
        shareQrCode: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["B" /* shareQrCode */],
        push: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["b" /* push */],
    }, dispatch);
}
var SharePromptsContainer = /** @class */ (function (_super) {
    __extends(SharePromptsContainer, _super);
    function SharePromptsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SharePromptsContainer.prototype.render = function () {
        if (!this.props.isSharePromptsOpen) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_SharePrompts_SharePrompts__["a" /* default */], { isActive: this.props.isActive, raised: this.props.raised, shareByEmail: this.props.shareByEmail, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, targetCurrency: this.props.targetCurrency, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isOwner: this.props.isOwner, shareBySms: this.props.shareBySms, shareByWhatsApp: this.props.shareByWhatsApp, shareOnTwitter: this.props.shareOnTwitter, shareQrCode: this.props.shareQrCode, currencySymbol: __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["e" /* default */][this.props.targetCurrency] || '£', sharePageLink: this.props.sharePageLink, closeSharePrompts: this.props.closeSharePrompts, pageSection: this.props.pageSection, push: this.props.push, pageName: this.props.pageName }));
    };
    return SharePromptsContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SharePromptsContainer));


/***/ }),

/***/ "./src/containers/page/ShareWithFriendsPromptsContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShareWithFriendsPromptsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_shareWithFriendsPrompts__ = __webpack_require__("./src/redux/modules/shareWithFriendsPrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_ShareWithFriendsPrompts_ShareWithFriendsPrompts__ = __webpack_require__("./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









function mapStateToProps(state) {
    return {
        isActive: Object(__WEBPACK_IMPORTED_MODULE_7_src_helpers_page__["c" /* isActive */])(state.page),
        raised: state.page.amountRaised,
        targetAmount: state.page.targetAmount,
        pitchFor: state.page.pitchFor,
        ownerName: state.page.ownerName,
        isOwner: state.page.isOwnerRequested,
        isShareWithFriendsPromptsOpen: state.shareWithFriendsPrompts.isShareWithFriendsPromptsOpen,
        socialShareUrl: state.page.socialShareUrl,
        targetCurrency: state.page.targetCurrency,
        pageSection: state.shareWithFriendsPrompts.pageSection,
        avatarImage: state.page.ownerProfileImageUrl,
        pageName: state.page.name,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        shareByEmail: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["r" /* shareByEmail */],
        shareByWhatsApp: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["t" /* shareByWhatsApp */],
        shareOnMessenger: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["y" /* shareOnMessenger */],
        shareOnTwitter: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["z" /* shareOnTwitter */],
        sharePageLink: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["A" /* sharePageLink */],
        closeShareWithFriendsPrompts: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_shareWithFriendsPrompts__["a" /* closeShareWithFriendsPrompts */],
        push: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["b" /* push */],
    }, dispatch);
}
var ShareWithFriendsPromptsContainer = /** @class */ (function (_super) {
    __extends(ShareWithFriendsPromptsContainer, _super);
    function ShareWithFriendsPromptsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShareWithFriendsPromptsContainer.prototype.render = function () {
        if (!this.props.isShareWithFriendsPromptsOpen) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_ShareWithFriendsPrompts_ShareWithFriendsPrompts__["a" /* default */], { isActive: this.props.isActive, raised: this.props.raised, shareByEmail: this.props.shareByEmail, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, targetCurrency: this.props.targetCurrency, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, isOwner: this.props.isOwner, shareByWhatsApp: this.props.shareByWhatsApp, currencySymbol: __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["e" /* default */][this.props.targetCurrency] || __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["e" /* default */].GBP, sharePageLink: this.props.sharePageLink, closeSharePrompts: this.props.closeShareWithFriendsPrompts, pageSection: this.props.pageSection, push: this.props.push, pageName: this.props.pageName, shareOnMessenger: this.props.shareOnMessenger, shareOnTwitter: this.props.shareOnTwitter }));
    };
    return ShareWithFriendsPromptsContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ShareWithFriendsPromptsContainer));


/***/ }),

/***/ "./src/containers/page/SocialShareContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_SocialShare__ = __webpack_require__("./src/components/SocialShare/SocialShare.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






function mapStateToProps(state) {
    return {
        isClosed: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["d" /* isClosed */])(state.page),
        isActive: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["c" /* isActive */])(state.page),
        socialShareUrl: state.page.socialShareUrl,
        targetAmount: Math.floor(state.page.targetAmount),
        page: state.page,
        pitchFor: state.page.pitchFor,
        ownerName: state.page.ownerName,
        name: state.page.name,
        isOwner: state.page.isOwnerRequested,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        shareOnTwitter: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["z" /* shareOnTwitter */],
        shareByEmail: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["r" /* shareByEmail */],
        shareByWhatsApp: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["t" /* shareByWhatsApp */],
        shareBySms: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["s" /* shareBySms */],
        sharePageLink: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["A" /* sharePageLink */],
    }, dispatch);
}
var SocialShareContainer = /** @class */ (function (_super) {
    __extends(SocialShareContainer, _super);
    function SocialShareContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialShareContainer.prototype.render = function () {
        if (this.props.isClosed) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_SocialShare_SocialShare__["a" /* default */], { shareOnTwitter: this.props.shareOnTwitter, shareByEmail: this.props.shareByEmail, shareByWhatsApp: this.props.shareByWhatsApp, shareBySms: this.props.shareBySms, sharePageLink: this.props.sharePageLink, socialShareUrl: this.props.socialShareUrl, targetAmount: this.props.targetAmount, pitchFor: this.props.pitchFor, ownerName: this.props.ownerName, name: this.props.name, isOwner: this.props.isOwner, isActive: this.props.isActive, page: this.props.page }));
    };
    return SocialShareContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SocialShareContainer));


/***/ }),

/***/ "./src/containers/page/StickyHeaderDonorContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_StickyHeader_StickyHeaderDonor__ = __webpack_require__("./src/components/StickyHeader/StickyHeaderDonor.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");





function mapStateToProps(state) {
    return {
        ownerName: state.page.ownerName,
        ownerProfileImageUrl: state.page.ownerProfileImageUrl,
        pageName: state.page.name,
        canPageReceiveDonations: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["a" /* canPageReceiveDonations */])(state.page),
        disableShare: !Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["c" /* isActive */])(state.page) && !Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_page__["d" /* isClosed */])(state.page),
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        donate: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["j" /* donate */],
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_StickyHeader_StickyHeaderDonor__["a" /* default */]));


/***/ }),

/***/ "./src/containers/page/SupportersContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Supporters_Supporters__ = __webpack_require__("./src/components/Supporters/Supporters.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_supporters__ = __webpack_require__("./src/redux/modules/supporters.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");






function mapStateToProps(state) {
    return {
        page: state.page,
        isActive: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["c" /* isActive */])(state.page),
        isClosed: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["d" /* isClosed */])(state.page),
        canPageReceiveDonations: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["a" /* canPageReceiveDonations */])(state.page),
        ownerName: state.page.ownerName,
        profileImage: state.page.ownerProfileImageUrl,
        pageId: state.page.id,
        supporterPageNo: state.supporters.supporterPageNo,
        supporters: state.supporters,
        isOwner: state.page.isOwnerRequested,
        targetCurrency: state.page.targetCurrency,
        totalCountSupporters: state.supporters.totalCount,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        donate: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_page__["j" /* donate */],
        loadSupporters: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_supporters__["b" /* loadSupporters */],
        thankSupporter: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_supporters__["c" /* thankSupporter */],
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_Supporters_Supporters__["a" /* default */]));


/***/ }),

/***/ "./src/containers/page/UpdatesContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Updates_Updates__ = __webpack_require__("./src/components/Updates/Updates.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_richUpdates__ = __webpack_require__("./src/redux/modules/richUpdates/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_richUpdates_actions__ = __webpack_require__("./src/redux/modules/richUpdates/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");






function mapStateToProps(state) {
    var pageClosed = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["d" /* isClosed */])(state.page);
    return {
        activatedAt: state.page.activatedAt,
        id: state.page.id,
        updatesPageNo: state.richUpdates.updatesPageNo,
        updates: Object(__WEBPACK_IMPORTED_MODULE_3_src_redux_modules_richUpdates__["c" /* getUpdates */])(state.richUpdates),
        totalCountUpdates: state.richUpdates.totalCount,
        profileImage: state.page.ownerProfileImageUrl,
        ownerName: state.page.ownerName,
        report: state.page.report,
        status: state.page.status,
        finishedAt: state.page.finishedAt,
        isLoadingUpdates: state.richUpdates.isLoading,
        isOwner: state.page.isOwnerRequested,
        raised: (pageClosed ? state.page.amountRaised : state.page.amountPledged) || 0,
        isClosed: pageClosed,
        isActive: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_page__["c" /* isActive */])(state.page),
        completeImage: state.page.completeImage,
        page: state.page,
        scrollTo: state.richUpdates.scrollTo,
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        loadUpdates: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_richUpdates__["d" /* loadUpdates */],
        deleteRichUpdate: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_richUpdates__["b" /* deleteRichUpdate */],
        watchingVideoToggle: __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_richUpdates__["e" /* watchingVideoToggle */],
        scrolledToUpdate: __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_richUpdates_actions__["i" /* scrolledToUpdate */],
    }, dispatch);
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_src_components_Updates_Updates__["a" /* default */]));


/***/ }),

/***/ "./src/containers/updates/UpdateModalView.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/containers/updates/UpdateModalView.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateModalView_scss__ = __webpack_require__("./src/containers/updates/UpdateModalView.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateModalView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UpdateModalView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_RichUpdates_RichUpdatesItem_RichUpdatesItemMedia__ = __webpack_require__("./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_richUpdates__ = __webpack_require__("./src/redux/modules/richUpdates/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Avatar__ = __webpack_require__("./src/components/Avatar/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({
        watchingVideoToggle: __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_richUpdates__["e" /* watchingVideoToggle */],
        push: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["b" /* push */],
    }, dispatch);
}
var mapStateToProps = function (state) { return ({
    update: state.richUpdates.linkedUpdate,
    pageName: state.page.name,
    richUpdatesState: state.richUpdates,
    ownerProfileImageUrl: state.page.ownerProfileImageUrl,
    ownerName: state.page.ownerName,
}); };
var UpdateModalView = /** @class */ (function (_super) {
    __extends(UpdateModalView, _super);
    function UpdateModalView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateModalView.prototype.render = function () {
        var _this = this;
        var _a = this.props, update = _a.update, pageName = _a.pageName, richUpdatesState = _a.richUpdatesState, ownerProfileImageUrl = _a.ownerProfileImageUrl, ownerName = _a.ownerName;
        var updateModalNotRequired = !update ||
            update.id === 0 ||
            richUpdatesState.allUpdateIds.find(function (id) { return id === update.id; });
        if (updateModalNotRequired) {
            return null;
        }
        var onModalClose = function () {
            update.id = 0;
            richUpdatesState.scrollTo = true;
            _this.props.push("/" + pageName);
        };
        var noMedia = !update.media || update.media.length === 0;
        var reportDate = Object(__WEBPACK_IMPORTED_MODULE_11_src_helpers_date__["f" /* distanceInWordsToNow */])(update.createdAt);
        var displayMedia = function () {
            var media = update.media;
            if (noMedia) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_RichUpdates_RichUpdatesItem_RichUpdatesItemMedia__["a" /* default */], { type: media[0].type, path: media[0].path, watchingVideoToggle: _this.props.watchingVideoToggle }));
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Analytics__["b" /* AnalyticsPageView */], { eventValue: "update", pageSection: "page > update", subtype: "cfp" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Modal__["a" /* default */], { isOpen: true, onClose: onModalClose, colorTheme: "dark", closeAnalyticsTracking: {
                    event: 'link click',
                    subtype: 'button',
                    eventValue: 'x',
                    pageSection: 'page > update',
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "update-details-avatar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_src_components_Avatar__["b" /* OwnerAvatar */], { src: ownerProfileImageUrl, alt: ownerName, className: __WEBPACK_IMPORTED_MODULE_4__UpdateModalView_scss___default.a.avatar }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-h5 update-details-owner-name" }, ownerName),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--xsmall-light" }, reportDate))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "update-details" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "update-details-content" },
                        update.type !== 1 && displayMedia(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "update-details-text " + (update.type !== 1
                                ? 'update-details-text-bottom'
                                : noMedia
                                    ? 'update-details-text-only'
                                    : '') }, update.message),
                        update.type === 1 && displayMedia())))));
    };
    return UpdateModalView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_9_react_css_modules___default()(UpdateModalView, __WEBPACK_IMPORTED_MODULE_4__UpdateModalView_scss___default.a)));


/***/ }),

/***/ "./src/helpers/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path_to_regexp__ = __webpack_require__("./node_modules/path-to-regexp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_path_to_regexp__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// backported from https://github.com/ReactTraining/react-router/pull/5209/files,
// return to using the original Redirect when that's merged.
/* tslint:disable */



/**
 * The public API for updating the location programatically
 * with a component.
 */
var Redirect = /** @class */ (function (_super) {
    __extends(Redirect, _super);
    function Redirect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Redirect.prototype.isStatic = function () {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function () {
        if (this.isStatic())
            this.perform();
    };
    Redirect.prototype.componentDidMount = function () {
        if (!this.isStatic())
            this.perform();
    };
    Redirect.prototype.computeTo = function (_a) {
        var computedMatch = _a.computedMatch, to = _a.to;
        if (computedMatch) {
            if (typeof to === 'string') {
                return __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default.a.compile(to)(computedMatch.params);
            }
            else {
                return __assign({}, to, { pathname: __WEBPACK_IMPORTED_MODULE_2_path_to_regexp___default.a.compile(to.pathname)(computedMatch.params) });
            }
        }
        return to;
    };
    Redirect.prototype.perform = function () {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) {
            history.push(to);
        }
        else {
            history.replace(to);
        }
    };
    Redirect.prototype.render = function () {
        return null;
    };
    Redirect.propTypes = {
        computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
    };
    Redirect.defaultProps = {
        push: false,
    };
    Redirect.contextTypes = {
        router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
                push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
                replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
            }).isRequired,
            staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        }).isRequired,
    };
    return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Redirect);


/***/ }),

/***/ "./src/helpers/alerts/AdditionalDetailsAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");



var AdditionalDetailsAlert = function (state) {
    var _a = state.stripeVirtualAccount, totalRequiredFields = _a.totalRequiredFields, accountDisabledReason = _a.accountDisabledReason;
    var name = state.page.name;
    var alertKey = 'additional_data';
    if (totalRequiredFields > 0 &&
        (!accountDisabledReason || accountDisabledReason !== 'RejectedFraud')) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Alert___["a" /* default */], { id: alertKey, type: "red", persistent: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                    "Sorry, but we couldn\u2019t verify your details. We need you to",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["d" /* Link */], { to: "/" + name + "/funds/additionaldetails", analyticsOptions: {
                            event: 'link click',
                            eventValue: 'submit some further information',
                            pageSection: 'admin',
                            subtype: 'hyperlink',
                        } }, "submit some further information"),
                    "."))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (AdditionalDetailsAlert);


/***/ }),

/***/ "./src/helpers/alerts/NotificationsPermissionAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts_index_ts__ = __webpack_require__("./src/helpers/alerts/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_pushNotifications__ = __webpack_require__("./src/helpers/pushNotifications.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_settings_actions__ = __webpack_require__("./src/redux/modules/settings/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_ClickableElement__ = __webpack_require__("./src/components/ClickableElement/index.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;











var NotificationsPermissionAlert = function (state, options) { return __awaiter(_this, void 0, Promise, function () {
    var status, alertKey, pageSection, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                status = state.page.status;
                alertKey = 'enable_notifications';
                pageSection = options.pageSection || '';
                if (!__WEBPACK_IMPORTED_MODULE_8_config__["FEATURE"].PUSH_NOTIFICATIONS) return [3 /*break*/, 3];
                _a = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_page__["c" /* isActive */])({ status: status }) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts_index_ts__["b" /* hasDismissedAlert */])(state.page.id, alertKey) &&
                    Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_pushNotifications__["a" /* arePushNotificationsSupported */])();
                if (!_a) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_pushNotifications__["c" /* getSubscription */])()];
            case 1:
                _a = (_b.sent()) === null;
                _b.label = 2;
            case 2:
                if (_a) {
                    return [2 /*return*/, {
                            matched: true,
                            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Alert___["a" /* default */], { id: alertKey, type: "info", onClose: options.onClose, page: state.page },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], { id: "PushNotifications.alert", defaultMessage: "Do you want to be notified about your fundraising activity? {enableLink}", values: {
                                        enableLink: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_src_components_ClickableElement__["a" /* default */], { inline: true, className: "jg-text--link", onClick: function () {
                                                return enableNotifications({
                                                    userId: state.self.id,
                                                    pageId: state.page.id,
                                                    alertKey: alertKey,
                                                    onClose: options.onClose,
                                                    dispatch: options.dispatch,
                                                    pageSection: pageSection,
                                                });
                                            }, analyticsOptions: {
                                                event: 'link click',
                                                eventValue: 'Enable push notifications',
                                                pageSection: pageSection,
                                                subtype: 'hyperlink',
                                            } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], { id: "PushNotifications.alert.enableLink", defaultMessage: "Enable browser push notifications now" }))),
                                    } }))),
                        }];
                }
                _b.label = 3;
            case 3: return [2 /*return*/, { matched: false }];
        }
    });
}); };
function enableNotifications(_a) {
    var userId = _a.userId, pageId = _a.pageId, alertKey = _a.alertKey, onClose = _a.onClose, dispatch = _a.dispatch, pageSection = _a.pageSection;
    return __awaiter(this, void 0, void 0, function () {
        var permissionResult;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_pushNotifications__["b" /* askPermission */])()];
                case 1:
                    permissionResult = _b.sent();
                    if (permissionResult === 'granted') {
                        Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_pushNotifications__["e" /* subscribe */])(userId, pageId);
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_src_redux_modules_settings_actions__["b" /* setNotificationsStatus */])(true));
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_src_redux_modules_analytics__["a" /* analyticsClick */])({
                        event: 'click',
                        eventValue: "" + permissionResult,
                        pageSection: pageSection,
                        subtype: 'browser push notifications',
                    }));
                    dismissAlert(pageId, alertKey, onClose);
                    return [2 /*return*/];
            }
        });
    });
}
function dismissAlert(pageid, key, onClose) {
    if (true && Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_browser__["g" /* isLocalStorageAvailable */])()) {
        localStorage.setItem("alert:" + pageid + "_" + key, 'true');
    }
    onClose();
}
/* harmony default export */ __webpack_exports__["a"] = (NotificationsPermissionAlert);


/***/ }),

/***/ "./src/helpers/alerts/PendingApprovalAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");





var PendingApprovalAlert = function (state, options) {
    var status = state.page.status;
    var alertKey = 'pending_approval';
    if (status === 'PendingApproval') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Alert___["a" /* default */], { id: alertKey, type: "amber", persistent: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbmd" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "PendingApprovalAlert.weNeedToApproveYourPage", defaultMessage: "It looks like we need to approve the content on your page before you can start getting donations. We aim to do this in 2 days." })),
                    state.charity === null && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "PendingApprovalAlert.ifYoureFundraising", defaultMessage: "If you're raising money for a registered charity, you'll need to {fundraisingLink}.", values: {
                                fundraisingLink: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Analytics__["d" /* Link */], { href: __WEBPACK_IMPORTED_MODULE_3_config__["FUNDRAISING_BASE_URI"], rel: "noreferrer noopener", target: "_blank", analyticsOptions: {
                                        event: 'link click',
                                        eventValue: 'create fundraising page',
                                        pageSection: options.pageSection || '',
                                        subtype: 'hyperlink',
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], { id: "PendingApprovalAlert.ifYoureFundraising.createFundraisingPageLink", defaultMessage: "create a Fundraising Page" }))),
                            } })))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (PendingApprovalAlert);


/***/ }),

/***/ "./src/helpers/alerts/StripeBankAccountInvalidAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_api_paymentDetails__ = __webpack_require__("./src/helpers/api/paymentDetails.ts");





var alertKey = 'stripe_bank_account_invalid';
var contactCustomerServiceLink = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__["d" /* Link */], { href: "https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=5342", rel: "noreferrer noopener", target: "_blank" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeBankAccountInvalidAlert.contactCustomerService.link", defaultMessage: "Customer Service" })));
var StripeBankAccountInvalidAlert = function (state) {
    var funds = state.funds, paymentDetails = state.paymentDetails, page = state.page;
    if (paymentDetails.bankAccountStatus &&
        paymentDetails.bankAccountStatus === __WEBPACK_IMPORTED_MODULE_4_src_helpers_api_paymentDetails__["a" /* BankAccountStatus */].Errored) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Alert___["a" /* default */], { id: alertKey, type: "red", page: page },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" }, funds.withdrawalFailureCount < 2 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeBankAccountInvalidAlert.editBankDetails.message", defaultMessage: "We were unable to withdraw funds to your account. Please {editBankDetailsLink} or contact {contactCustomerServiceLink}.", values: {
                        editBankDetailsLink: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Analytics__["d" /* Link */], { to: "/" + page.name + "/funds/account", className: "jg-text--link" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeBankAccountInvalidAlert.editBankDetails.link", defaultMessage: "edit your bank details" }))),
                        contactCustomerServiceLink: contactCustomerServiceLink,
                    } })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "StripeBankAccountInvalidAlert.contactCustomerService.message", defaultMessage: "We were unable to withdraw funds to your account. Please contact {contactCustomerServiceLink}.", values: { contactCustomerServiceLink: contactCustomerServiceLink } }))))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (StripeBankAccountInvalidAlert);


/***/ }),

/***/ "./src/helpers/alerts/StripeUnverifiedAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");


var StripeUnverifiedAlert = function (state) {
    var _a = state.stripeVirtualAccount, legalEntityVerificationStatus = _a.legalEntityVerificationStatus, submittedAllRequiredFields = _a.submittedAllRequiredFields;
    var alertKey = 'verify_manual';
    if (submittedAllRequiredFields &&
        legalEntityVerificationStatus === 'Unverified') {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Alert___["a" /* default */], { id: alertKey, type: "red", persistent: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                    "Unfortunately we weren't able to verify your identity. Please",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=5342", rel: "noreferrer noopener", target: "_blank" }, "contact our customer service team"),
                    ' ',
                    "to continue Crowdfunding."))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (StripeUnverifiedAlert);


/***/ }),

/***/ "./src/helpers/alerts/StripeVerificationPendingAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts__ = __webpack_require__("./src/helpers/alerts/index.ts");



var StripeVerificationPendingAlert = function (state, options) {
    var _a = state.stripeVirtualAccount, legalEntityVerificationStatus = _a.legalEntityVerificationStatus, totalRequiredFields = _a.totalRequiredFields;
    var alertKey = 'stripe_verification_pending';
    if (totalRequiredFields === 0 &&
        legalEntityVerificationStatus === 'Pending' &&
        !Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts__["b" /* hasDismissedAlert */])(state.page.id, alertKey)) {
        return {
            matched: true,
            result: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Alert___["a" /* default */], { id: alertKey, type: "amber", onClose: options.onClose, page: state.page },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" }, "We're just checking your details and we'll let you know if there's anything else you need to do."))),
        };
    }
    return { matched: false };
};
/* harmony default export */ __webpack_exports__["a"] = (StripeVerificationPendingAlert);


/***/ }),

/***/ "./src/helpers/alerts/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasDismissedAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_rulesEngine__ = __webpack_require__("./src/helpers/rulesEngine.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts_StripeUnverifiedAlert__ = __webpack_require__("./src/helpers/alerts/StripeUnverifiedAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_alerts_AdditionalDetailsAlert__ = __webpack_require__("./src/helpers/alerts/AdditionalDetailsAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_alerts_StripeVerificationPendingAlert__ = __webpack_require__("./src/helpers/alerts/StripeVerificationPendingAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_alerts_StripeBankAccountInvalidAlert__ = __webpack_require__("./src/helpers/alerts/StripeBankAccountInvalidAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_alerts_PendingApprovalAlert__ = __webpack_require__("./src/helpers/alerts/PendingApprovalAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_alerts_NotificationsPermissionAlert__ = __webpack_require__("./src/helpers/alerts/NotificationsPermissionAlert.tsx");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;








var alertRulesEngine = function (appState, _a) {
    var onClose = _a.onClose, pageSection = _a.pageSection, dispatch = _a.dispatch;
    return __awaiter(_this, void 0, void 0, function () {
        var alert, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_rulesEngine__["a" /* default */])([
                            __WEBPACK_IMPORTED_MODULE_6_src_helpers_alerts_PendingApprovalAlert__["a" /* default */],
                            __WEBPACK_IMPORTED_MODULE_3_src_helpers_alerts_AdditionalDetailsAlert__["a" /* default */],
                            __WEBPACK_IMPORTED_MODULE_4_src_helpers_alerts_StripeVerificationPendingAlert__["a" /* default */],
                            __WEBPACK_IMPORTED_MODULE_5_src_helpers_alerts_StripeBankAccountInvalidAlert__["a" /* default */],
                            __WEBPACK_IMPORTED_MODULE_2_src_helpers_alerts_StripeUnverifiedAlert__["a" /* default */],
                            __WEBPACK_IMPORTED_MODULE_7_src_helpers_alerts_NotificationsPermissionAlert__["a" /* default */],
                        ], appState, {
                            onClose: onClose,
                            pageSection: pageSection,
                            dispatch: dispatch,
                        })];
                case 1:
                    alert = _b.sent();
                    return [2 /*return*/, alert.matched && alert.result ? alert.result : null];
                case 2:
                    e_1 = _b.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/* harmony default export */ __webpack_exports__["a"] = (alertRulesEngine);
var hasDismissedAlert = function (id, key) {
    return true && Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_browser__["g" /* isLocalStorageAvailable */])()
        ? localStorage.getItem("alert:" + id + "_" + key) === 'true'
        : true;
};


/***/ }),

/***/ "./src/helpers/analytics.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageSection;
var routeAnalyticsMap = {
    dashboard: 'tips',
};
function getPageSection(path) {
    var splitUrl = path.substring(1).split('/');
    if (splitUrl.length === 1) {
        return 'page view';
    }
    var pageSection = splitUrl[1];
    return routeAnalyticsMap[pageSection] || pageSection;
}


/***/ }),

/***/ "./src/helpers/api/ab.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enrol;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("./src/helpers/api/common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_logging__ = __webpack_require__("./src/logging.js");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function enrol(slug) {
    return __awaiter(this, void 0, Promise, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* post */])("api/abtests/" + slug + "/enrol", {}, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_0_config___default.a.AB_API_URI,
                            withCredentials: true,
                            throwOnError: true,
                            serverSideTimeout: 2000,
                            clientSideTimeout: 2000,
                            autoRefreshAccessToken: false,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.body.enrolledIn];
                case 2:
                    err_1 = _a.sent();
                    __WEBPACK_IMPORTED_MODULE_2_src_logging__["a" /* default */].warn({ err: err_1 }, "Unable to get AB variation for " + slug + ".");
                    return [2 /*return*/, 'A'];
                case 3: return [2 /*return*/];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/activities.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSupporters;
/* harmony export (immutable) */ __webpack_exports__["c"] = setSupporterThankYouMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSupporter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function getSupporters(pageId, pageNo, pageSize, minDateTime) {
    return __awaiter(this, void 0, Promise, function () {
        var url, supporters;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = createUrl(pageId, pageNo, pageSize, minDateTime);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])(url, {
                            timingName: 'supporters',
                        })];
                case 1:
                    supporters = _a.sent();
                    if (!supporters) {
                        throw new Error('Supporters not found');
                    }
                    return [2 /*return*/, supporters];
            }
        });
    });
}
function setSupporterThankYouMessage(_a) {
    var pageId = _a.pageId, activityId = _a.activityId, thankYouMessage = _a.thankYouMessage;
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_b) {
            payload = {
                thankYouMessage: thankYouMessage,
            };
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["f" /* patch */])("projects/" + pageId + "/activities/" + activityId, payload)];
        });
    });
}
function createUrl(pageId, pageNo, pageSize, minDateTime) {
    var url = "projects/" + pageId + "/activities?pageNo=" + pageNo + "&pageSize=" + pageSize + "&type=pledge";
    return minDateTime ? url + "&minDateTime=" + minDateTime : url;
}
function getSupporter(pageId, activityHashId) {
    return __awaiter(this, void 0, Promise, function () {
        var url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "projects/" + pageId + "/activities/" + activityHashId;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["d" /* getOrThrow */])(url, {
                            timingName: 'supporter',
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/alternativeProjects.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlternativeProjects;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_math__ = __webpack_require__("./src/helpers/math.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function getAlternativeProjects(projectId) {
    return __awaiter(this, void 0, Promise, function () {
        var url, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "v1/entities/alternativeProjects/" + projectId;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* get */])(url, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_0_config___default.a.DISCOVER_API_URI,
                            timingName: 'alternativeProjects',
                            autoRefreshAccessToken: false,
                        })];
                case 1:
                    result = _a.sent();
                    if (!result._embedded || !result._embedded.alternativeproject) {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, result._embedded.alternativeproject.map(mapCardToProject)];
            }
        });
    });
}
function mapCardToProject(card) {
    var page = {
        targetCurrency: card.TargetCurrency,
        amountRaised: card.AmountRaised,
        progress: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_math__["a" /* calculatePercentage */])(card.AmountRaised, card.TargetAmount),
        pitch: card.What,
        owner: card.Creator.FirstName,
        numberOfSupporters: card.TotalDonations,
        ownerId: card.Creator.UserGuid,
        projectImage: {
            url: card.PhotoUrl,
        },
        projectId: card.AskId,
        projectUrl: card.Url,
    };
    if (card.PhotoDetails) {
        page.projectImage = __assign({}, page.projectImage, { width: card.PhotoDetails.Width, height: card.PhotoDetails.Height, cropArea: {
                left: card.PhotoDetails.CropLeft,
                top: card.PhotoDetails.CropTop,
                width: card.PhotoDetails.CropWidth,
                height: card.PhotoDetails.CropHeight,
            } });
    }
    return page;
}


/***/ }),

/***/ "./src/helpers/api/avatars.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAvatars;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fromPairs__ = __webpack_require__("./node_modules/lodash/fromPairs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fromPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fromPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


function getAvatars(userIds) {
    return __awaiter(this, void 0, Promise, function () {
        var promises, users;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = userIds.map(function (userId) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* getOrThrow */])("users/" + userId);
                    });
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    users = _a.sent();
                    return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_0_lodash_fromPairs___default()(users.map(function (u) { return [u.id, u.profileImage]; }))];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/categories.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function getAll() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])('categories', {
                        timingName: 'categories',
                    })];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        throw new Error('Failed to fetch categories.');
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/censures.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");

function add(pageId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + pageId + "/censures", { projectId: pageId });
}


/***/ }),

/***/ "./src/helpers/api/charity.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCharityInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");

var fetchCharityInfo = function (charityId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["d" /* getOrThrow */])("charities/" + charityId);
};


/***/ }),

/***/ "./src/helpers/api/common.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = get;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOrThrow;
/* harmony export (immutable) */ __webpack_exports__["g"] = post;
/* harmony export (immutable) */ __webpack_exports__["h"] = postRaw;
/* harmony export (immutable) */ __webpack_exports__["f"] = patch;
/* harmony export (immutable) */ __webpack_exports__["i"] = put;
/* unused harmony export putRaw */
/* harmony export (immutable) */ __webpack_exports__["b"] = del;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__("./node_modules/url-join/lib/url-join.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__("./node_modules/superagent/lib/client.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_time__ = __webpack_require__("./src/helpers/time.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_stats__ = __webpack_require__("./src/helpers/stats.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_stats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_helpers_stats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_auth__ = __webpack_require__("./src/helpers/auth.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






function makeRequest(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.autoRefreshAccessToken, autoRefreshAccessToken = _c === void 0 ? true : _c, _d = _b.baseUri, baseUri = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_2_config___default.a.CROWDFUNDING_API_URI : _d, _e = _b.path, path = _e === void 0 ? '' : _e, query = _b.query, data = _b.data, _f = _b.method, method = _f === void 0 ? 'get' : _f, _g = _b.throwOnError, throwOnError = _g === void 0 ? true : _g, _h = _b.withCredentials, withCredentials = _h === void 0 ? true : _h, contentType = _b.contentType, accept = _b.accept, clientSideTimeout = _b.clientSideTimeout, serverSideTimeout = _b.serverSideTimeout, timingName = _b.timingName, header = _b.header, userAgent = _b.userAgent, cookies = _b.cookies, withBearerAuthHeader = _b.withBearerAuthHeader;
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!autoRefreshAccessToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_auth__["c" /* refreshAccessToken */])()];
                case 1:
                    _j.sent();
                    _j.label = 2;
                case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = __WEBPACK_IMPORTED_MODULE_1_superagent___default.a[method](__WEBPACK_IMPORTED_MODULE_0_url_join___default()(baseUri, path));
                        if (query) {
                            request.query(query);
                        }
                        if (data) {
                            request.send(data);
                        }
                        if (false) {
                            prepareServerSideRequest(request, {
                                timeout: serverSideTimeout,
                                forcedUserAgent: userAgent,
                                forcedCookies: cookies,
                            });
                        }
                        if (true) {
                            if (clientSideTimeout) {
                                request.timeout(clientSideTimeout);
                            }
                        }
                        if (withCredentials) {
                            request.withCredentials();
                        }
                        if (contentType) {
                            request.type(contentType);
                        }
                        if (header) {
                            request.set(header);
                        }
                        if (withBearerAuthHeader) {
                            var auth = Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_auth__["a" /* getAuth */])();
                            var authCookie = auth.getParsedAuthCookie();
                            if (authCookie) {
                                request.set('Authorization', "Bearer " + authCookie.accessToken);
                            }
                        }
                        if (accept) {
                            request.accept(accept);
                        }
                        var timer =  false ? createTimer() : null;
                        request.end(function (err, response) {
                            if (timer) {
                                __WEBPACK_IMPORTED_MODULE_4_src_helpers_stats___default.a.timing("apiRequests." + timingName, timer());
                            }
                            if (err) {
                                if (throwOnError || !err.response) {
                                    reject(new ApiError(err));
                                }
                                else {
                                    resolve(err.response);
                                }
                            }
                            else {
                                resolve(response);
                            }
                        });
                    })];
            }
        });
    });
}
function get(path, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(__assign({ path: path, method: 'get', throwOnError: false }, options))];
                case 1:
                    response = _a.sent();
                    if (response.status === 404) {
                        return [2 /*return*/, null];
                    }
                    if (!response.ok) {
                        throw new ApiError({ response: response });
                    }
                    return [2 /*return*/, response.body];
            }
        });
    });
}
function getOrThrow(path, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(__assign({ path: path, method: 'get', throwOnError: false }, options))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new ApiError({ response: response });
                    }
                    return [2 /*return*/, response.body];
            }
        });
    });
}
function post(path, data, options) {
    return makeRequest(__assign({ path: path, data: data ? JSON.stringify(data) : null, method: 'post', contentType: 'application/json' }, options));
}
function postRaw(path, data, options) {
    return makeRequest(__assign({ path: path,
        data: data, method: 'post' }, options));
}
function patch(path, data, options) {
    return makeRequest(__assign({ path: path, data: data ? JSON.stringify(data) : null, method: 'patch', contentType: 'application/json' }, options));
}
function put(path, data, options) {
    return makeRequest(__assign({ path: path, data: data ? JSON.stringify(data) : null, method: 'put', contentType: 'application/json' }, options));
}
function putRaw(path, data, options) {
    return makeRequest(__assign({ path: path,
        data: data, method: 'put' }, options));
}
function del(path, options) {
    return makeRequest(__assign({ path: path, method: 'delete' }, options));
}
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(_a) {
        var message = _a.message, stack = _a.stack, response = _a.response;
        var _this = _super.call(this, message ||
            "Request failed with status: " + (response ? response.status : '???') + ".") || this;
        _this.name = 'ApiError';
        _this.response = response;
        if (stack) {
            _this.stack = stack;
        }
        return _this;
    }
    return ApiError;
}(Error));

function prepareServerSideRequest(request, _a) {
    var timeout = _a.timeout, forcedUserAgent = _a.forcedUserAgent, forcedCookies = _a.forcedCookies;
    // prevent server config and requestStorage modules from leaking into webpack build
    if (false) {
        var requestStorage = require('../../server/requestStorage').default;
        var serverConfig = require('../../../config/server.config');
        var userAgent = forcedUserAgent || requestStorage.get('userAgent');
        if (userAgent) {
            request.set('User-Agent', userAgent);
        }
        var cookies = forcedCookies || requestStorage.get('cookies');
        if (cookies) {
            var passedThruCookies = new Set(serverConfig.passedThruCookies);
            request.set('cookie', createCookieHeaderValue(cookies, passedThruCookies));
        }
        request.timeout(timeout || serverConfig.apiRequestTimeoutMs);
    }
}
function createCookieHeaderValue(cookies, passedThruCookies) {
    var cookie = Object.keys(cookies || {})
        .filter(function (x) { return passedThruCookies.has(x); })
        .map(function (x) { return x + "=" + cookies[x]; })
        .join(';');
    return cookie;
}


/***/ }),

/***/ "./src/helpers/api/completedActions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompletedActions;
/* harmony export (immutable) */ __webpack_exports__["b"] = setActionAsComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function getCompletedActions(pageId) {
    return __awaiter(this, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])("projects/" + pageId + "/completedActions", { timingName: 'completedActions' })];
                case 1:
                    data = _a.sent();
                    if (data === null) {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}
function setActionAsComplete(pageId, key) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + pageId + "/completedActions", { key: key })];
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/discovery.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getPromotedPages;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPopularPages;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPagesNearYou;
/* harmony export (immutable) */ __webpack_exports__["a"] = getActivePagesCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_math__ = __webpack_require__("./src/helpers/math.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var CATEGORY_EVERYTHING_ID = 999;
var PAGE_SIZE = 12;
function getPromotedPages() {
    return __awaiter(this, void 0, Promise, function () {
        var resourceUrl, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resourceUrl = createResourceUrl('promoted', 1);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* get */])(resourceUrl, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_0_config__["DISCOVER_API_URI"],
                            timingName: 'promotedPages',
                            autoRefreshAccessToken: false,
                        })];
                case 1:
                    result = _a.sent();
                    if (!result || !result._embedded || !result._embedded.promoted) {
                        return [2 /*return*/, {
                                items: [],
                            }];
                    }
                    return [2 /*return*/, {
                            items: result._embedded.promoted.map(mapCardToProject),
                        }];
            }
        });
    });
}
function getPopularPages(pageNo, categoryId) {
    return __awaiter(this, void 0, Promise, function () {
        var resourceUrl, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resourceUrl = createResourceUrl('popular', pageNo, categoryId);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* get */])(resourceUrl, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_0_config__["DISCOVER_API_URI"],
                            timingName: 'popularPages',
                            autoRefreshAccessToken: false,
                        })];
                case 1:
                    result = _a.sent();
                    if (!result || !result._embedded || !result._embedded.popular) {
                        return [2 /*return*/, {
                                totalCount: 0,
                                pageNo: 0,
                                items: [],
                            }];
                    }
                    return [2 /*return*/, {
                            totalCount: result.TotalResults,
                            pageNo: result.Page,
                            items: result._embedded.popular.map(mapCardToProject),
                        }];
            }
        });
    });
}
function getPagesNearYou(pageNo, categoryId) {
    return __awaiter(this, void 0, Promise, function () {
        var resourceUrl, result, count;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resourceUrl = createResourceUrl('nearyou', pageNo, categoryId);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* get */])(resourceUrl, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_0_config__["DISCOVER_API_URI"],
                            timingName: 'pagesNearYou',
                            autoRefreshAccessToken: false,
                        })];
                case 1:
                    result = _a.sent();
                    if (!result || !result._embedded || !result._embedded.nearyou) {
                        return [2 /*return*/, {
                                totalCount: 0,
                                pageNo: 0,
                                items: [],
                            }];
                    }
                    count = result._embedded.nearyou.length;
                    return [2 /*return*/, {
                            totalCount: count >= PAGE_SIZE ? result.TotalResults : count,
                            pageNo: result.Page,
                            items: result._embedded.nearyou.map(mapCardToProject),
                        }];
            }
        });
    });
}
function getActivePagesCount() {
    return __awaiter(this, void 0, Promise, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* get */])('v1/stats/active?askType=Project', {
                        baseUri: __WEBPACK_IMPORTED_MODULE_0_config__["DISCOVER_API_URI"],
                        timingName: 'activePagesCount',
                        autoRefreshAccessToken: false,
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.Count];
            }
        });
    });
}
function createResourceUrl(resource, pageNo, categoryId) {
    var resourceUrl = "v1/entities/" + resource + "?askType=Project&page=" + pageNo;
    return typeof categoryId !== 'number' || categoryId === CATEGORY_EVERYTHING_ID
        ? resourceUrl
        : resourceUrl.concat("&categoryId=" + categoryId);
}
function mapCardToProject(card) {
    var page = {
        targetCurrency: card.TargetCurrency,
        amountRaised: card.AmountRaised,
        progress: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_math__["a" /* calculatePercentage */])(card.AmountRaised, card.TargetAmount),
        pitch: card.What,
        owner: card.Creator.FirstName,
        numberOfSupporters: card.TotalDonations,
        ownerId: card.Creator.UserGuid,
        projectImage: {
            url: card.PhotoUrl,
        },
        projectId: card.AskId,
        projectUrl: card.Url,
        projectType: card.CardType,
    };
    if (card.PhotoDetails) {
        page.projectImage = __assign({}, page.projectImage, { width: card.PhotoDetails.Width, height: card.PhotoDetails.Height, cropArea: {
                left: card.PhotoDetails.CropLeft,
                top: card.PhotoDetails.CropTop,
                width: card.PhotoDetails.CropWidth,
                height: card.PhotoDetails.CropHeight,
            } });
    }
    return page;
}


/***/ }),

/***/ "./src/helpers/api/funds.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFundsInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = requestWithdrawal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");

function getFundsInfo(pageId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])("projects/" + pageId + "/funds", { timingName: 'funds' });
}
function requestWithdrawal(pageId, GrossAmount) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + pageId + "/funds/withdraw", { GrossAmount: GrossAmount });
}


/***/ }),

/***/ "./src/helpers/api/iam.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_INVALID_CREDENTIALS */
/* unused harmony export ERROR_EMAIL_ADDRESS_IN_USE */
/* unused harmony export ERROR_NO_CONSUMER_PERMISSIONS */
/* unused harmony export changeName */
/* harmony export (immutable) */ __webpack_exports__["a"] = changeProfilePicture;
/* harmony export (immutable) */ __webpack_exports__["c"] = uploadProfilePicFacebook;
/* harmony export (immutable) */ __webpack_exports__["b"] = isLoggedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__("./node_modules/jwt-decode/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("./src/helpers/api/common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__ = __webpack_require__("./src/helpers/auth.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var ERROR_INVALID_CREDENTIALS = 'ERROR_INVALID_CREDENTIALS';
var ERROR_EMAIL_ADDRESS_IN_USE = 'ERROR_EMAIL_ADDRESS_IN_USE';
var ERROR_NO_CONSUMER_PERMISSIONS = 'ERROR_NO_CONSUMER_PERMISSIONS';
function changeName(userId, _a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    return __awaiter(this, void 0, void 0, function () {
        var auth, refreshToken;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["c" /* refreshAccessToken */])()];
                case 1:
                    _b.sent();
                    auth = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["a" /* getAuth */])();
                    refreshToken = auth.getRefreshToken();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* makeRequest */])({
                            baseUri: __WEBPACK_IMPORTED_MODULE_1_config___default.a.IAM_API_URI,
                            path: "/users/" + userId + "/change-name",
                            method: 'post',
                            throwOnError: true,
                            data: {
                                userGuid: userId,
                                Title: 'Other',
                                FirstName: firstName,
                                LastName: lastName,
                                RefreshToken: refreshToken,
                            },
                            withBearerAuthHeader: true,
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function changeProfilePicture(_a) {
    var userId = _a.userId, imagePayload = _a.imagePayload;
    return __awaiter(this, void 0, Promise, function () {
        var auth, refreshToken, body, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["c" /* refreshAccessToken */])()];
                case 1:
                    _b.sent();
                    auth = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["a" /* getAuth */])();
                    refreshToken = auth.getRefreshToken();
                    body = new FormData();
                    body.append('ProfileImage', imagePayload);
                    body.append('RefreshToken', refreshToken);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* makeRequest */])({
                            baseUri: __WEBPACK_IMPORTED_MODULE_1_config___default.a.IAM_API_URI,
                            path: "/users/" + userId + "/profile-image",
                            method: 'put',
                            throwOnError: true,
                            data: body,
                            withBearerAuthHeader: true,
                        })];
                case 2:
                    res = _b.sent();
                    return [2 /*return*/, res.body.Result];
            }
        });
    });
}
function uploadProfilePicFacebook(_a) {
    var userId = _a.userId, imageUrl = _a.imageUrl;
    return __awaiter(this, void 0, void 0, function () {
        var auth, refreshToken, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["c" /* refreshAccessToken */])()];
                case 1:
                    _b.sent();
                    auth = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["a" /* getAuth */])();
                    refreshToken = auth.getRefreshToken();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* makeRequest */])({
                            baseUri: __WEBPACK_IMPORTED_MODULE_1_config___default.a.IAM_API_URI,
                            path: "/users/" + userId + "/profile-image/url",
                            method: 'put',
                            throwOnError: true,
                            data: {
                                ProfileImageUrl: imageUrl,
                                RefreshToken: refreshToken,
                            },
                            withBearerAuthHeader: true,
                        })];
                case 2:
                    res = _b.sent();
                    return [2 /*return*/, res.body.Result];
            }
        });
    });
}
function isLoggedIn() {
    try {
        var auth = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_auth__["a" /* getAuth */])();
        var authCookie = auth.getParsedAuthCookie();
        return authCookie ? hasConsumerPermissions(authCookie.accessToken) : false;
    }
    catch (_a) {
        return false;
    }
}
function hasConsumerPermissions(acessToken) {
    try {
        var jwt = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(acessToken);
        var permissions = formatPermissions(jwt.permissions);
        return (permissions.find(function (permission) { return permission.groupType === 'consumer'; }) !==
            undefined);
    }
    catch (_a) {
        return false;
    }
}
var formatPermissions = function (permissions) {
    return typeof permissions === 'string'
        ? [parsePermission(permissions)]
        : permissions.map(parsePermission);
};
var parsePermission = function (permission) {
    var _a = permission.split(','), groupGuid = _a[0], groupType = _a[1], groupTypeExternalId = _a[2], role = _a[3];
    return {
        groupGuid: groupGuid,
        groupType: groupType,
        groupTypeExternalId: groupTypeExternalId,
        role: role.split('::'),
    };
};


/***/ }),

/***/ "./src/helpers/api/images.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadImage;
/* harmony export (immutable) */ __webpack_exports__["a"] = uploadCoverImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function uploadImage(file) {
    return __awaiter(this, void 0, Promise, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isFilePayload(file)) return [3 /*break*/, 2];
                    return [4 /*yield*/, uploadFilePayload('images', file)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, uploadRaw('images', file)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    if (response.ok) {
                        return [2 /*return*/, { success: true, data: response.body }];
                    }
                    return [2 /*return*/, getUploadFailureResult(response)];
            }
        });
    });
}
function uploadCoverImage(file) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, uploadRaw('images/cover', file)];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { success: true, data: response.body }];
                    }
                    return [2 /*return*/, getUploadFailureResult(response)];
            }
        });
    });
}
function getUploadFailureResult(response) {
    if (response.status === 415) {
        return {
            success: false,
            message: 'This is an unsupported image. Please upload an image as a JPEG or PNG.',
        };
    }
    return { success: false, message: response.body.message };
}
function uploadFilePayload(path, file) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])(path, file, { throwOnError: false });
}
function uploadRaw(path, file) {
    var body = new FormData();
    body.append('file', file);
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["h" /* postRaw */])(path, body, { throwOnError: false });
}
function isFilePayload(file) {
    return !!file.url;
}


/***/ }),

/***/ "./src/helpers/api/magpie.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageViews;
/* harmony export (immutable) */ __webpack_exports__["b"] = getShares;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days__ = __webpack_require__("./node_modules/date-fns/sub_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var DEFAULT_START_DATE = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days___default()(new Date(), 30), 'YYYYMMDD');
function getPageViews(_a) {
    var projectId = _a.projectId, startDate = _a.startDate, endDate = _a.endDate;
    return __awaiter(this, void 0, Promise, function () {
        var path, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    path = createResourceUrl({
                        resource: 'pageviews',
                        projectId: projectId,
                        startDate: startDate,
                        endDate: endDate,
                    });
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_common__["c" /* get */])(path, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_2_config__["MAGPIE_API_URI"],
                            timingName: 'magpiePageViews',
                            clientSideTimeout: 2000,
                            withCredentials: false,
                            throwOnError: false,
                            withBearerAuthHeader: true,
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, mapMagpieResponse(response)];
            }
        });
    });
}
function getShares(_a) {
    var projectId = _a.projectId, startDate = _a.startDate, endDate = _a.endDate;
    return __awaiter(this, void 0, Promise, function () {
        var path, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    path = createResourceUrl({
                        resource: 'shares',
                        projectId: projectId,
                        startDate: startDate,
                        endDate: endDate,
                    });
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_common__["c" /* get */])(path, {
                            baseUri: __WEBPACK_IMPORTED_MODULE_2_config__["MAGPIE_API_URI"],
                            timingName: 'magpieShares',
                            clientSideTimeout: 2000,
                            withCredentials: false,
                            throwOnError: false,
                            withBearerAuthHeader: true,
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, mapMagpieResponse(response)];
            }
        });
    });
}
function mapMagpieResponse(response) {
    if (response) {
        return response.map(function (event) { return ({
            date: event.EventDay,
            count: event.EventCount,
        }); });
    }
    return [];
}
function createResourceUrl(_a) {
    var resource = _a.resource, projectId = _a.projectId, _b = _a.startDate, startDate = _b === void 0 ? DEFAULT_START_DATE : _b, endDate = _a.endDate;
    var url = "/metrics/cf/" + resource + "/" + projectId + "?startDate=" + startDate;
    return endDate ? url + "&endDate=" + endDate : url;
}


/***/ }),

/***/ "./src/helpers/api/pages.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getByName;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["a"] = activate;
/* harmony export (immutable) */ __webpack_exports__["e"] = patch;
/* harmony export (immutable) */ __webpack_exports__["c"] = delPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_richEditor__ = __webpack_require__("./src/helpers/richEditor.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_string__ = __webpack_require__("./src/helpers/string.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var pageGetServerSideTimeout = getPageRequestTimeout();
function getByName(pageName) {
    return __awaiter(this, void 0, Promise, function () {
        var data, richStory;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])("projects/" + pageName, {
                        serverSideTimeout: pageGetServerSideTimeout,
                        timingName: 'page',
                    })];
                case 1:
                    data = _a.sent();
                    if (!data) {
                        return [2 /*return*/, null];
                    }
                    if (data.richStory) {
                        try {
                            richStory = JSON.parse(data.richStory);
                        }
                        catch (e) {
                            richStory = [];
                        }
                    }
                    else {
                        richStory = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_richEditor__["a" /* convertProblemToRichStory */])(data.problem || '');
                    }
                    return [2 /*return*/, __assign({}, data, { richStory: richStory })];
            }
        });
    });
}
function create(page) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])('projects', __assign({}, page, { pitchFor: Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_string__["a" /* removeNewLines */])(page.pitchFor) }), { throwOnError: false })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.body];
                    }
                    if (response.badRequest) {
                        throw response.body;
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}
function activate(pageId, identityData) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + pageId + "/activations", { projectId: pageId, owner: identityData }, { throwOnError: false })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { activated: true }];
                    }
                    if (response.status === 400 &&
                        response.body &&
                        response.body.message === 'err:project-already-active') {
                        return [2 /*return*/, { activated: false, reason: 'pageAlreadyActive' }];
                    }
                    if (response.status === 403) {
                        return [2 /*return*/, { activated: false, reason: 'riskAnalysisFailed' }];
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}
function patch(page) {
    var data = __assign({}, page);
    if (page.richStory) {
        data.richStory = JSON.stringify(page.richStory);
    }
    if (page.pitchFor) {
        data.pitchFor = Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_string__["a" /* removeNewLines */])(page.pitchFor);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["f" /* patch */])("projects/" + (page.id || page.name), data);
}
function delPage(page) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["b" /* del */])("projects/" + page.name);
}
function getPageRequestTimeout() {
    // prevent server config from leaking into webpack build
    if (false) {
        return require('../../../config/server.config').pageRequestTimeoutMs;
    }
    return null;
}


/***/ }),

/***/ "./src/helpers/api/paymentDetails.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BankAccountStatus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getPaymentDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["New"] = "New";
    BankAccountStatus["Validated"] = "Validated";
    BankAccountStatus["Verified"] = "Verified";
    BankAccountStatus["VerificationFailed"] = "VerificationFailed";
    BankAccountStatus["Errored"] = "Errored";
})(BankAccountStatus || (BankAccountStatus = {}));
function getPaymentDetails(_a) {
    var pageId = _a.pageId;
    return __awaiter(this, void 0, Promise, function () {
        var url, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "projects/" + pageId + "/paymentdetails";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])(url, {
                            timingName: 'paymentDetails',
                            clientSideTimeout: 2000,
                        })];
                case 1:
                    data = _b.sent();
                    if (!data) {
                        throw new Error('Payment details not found');
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/preferencesService.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getConsentStatements;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateUserConsents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var options = {
    baseUri: __WEBPACK_IMPORTED_MODULE_1_config__["PREFERENCES_API_URI"],
    withCredentials: false,
    throwOnError: false,
};
var locale = __WEBPACK_IMPORTED_MODULE_1_config__["USER_CONSENTS"].LOCALE;
function getConsentStatements(collectionLocationId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])("ConsentStatements/" + collectionLocationId + "/" + locale, options);
}
function updateUserConsents(payload) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["i" /* put */])("users/" + payload.userGuid + "/consents", {
                        collectionLocationId: __WEBPACK_IMPORTED_MODULE_1_config__["USER_CONSENTS"].CROWDFUNDING_PAGE_COLLECTION_LOCATION_ID,
                        transactionTypeId: 2,
                        transactionId: payload.pageId,
                        consents: payload.userConsentStatements.map(function (consent) { return ({
                            ConsentStatementId: consent.id,
                            ConsentStatementText: consent.text,
                            EntityType: consent.entityType,
                            ConsentGiven: true,
                        }); }),
                    }, {
                        baseUri: __WEBPACK_IMPORTED_MODULE_1_config__["PREFERENCES_API_URI"],
                        throwOnError: true,
                        withBearerAuthHeader: true,
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.body];
                    }
                    if (response.badRequest) {
                        throw response.body;
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/pushNotifications.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createNotificationsSubscription;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSubscriptionTopic;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteSubscriptionTopic;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSubscriptionTopics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function createNotificationsSubscription(subscriptionData) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["g" /* post */])('subscriptions', subscriptionData)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.body];
            }
        });
    });
}
function addSubscriptionTopic(_a) {
    var topicName = _a.topicName, subscriptionId = _a.subscriptionId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["g" /* post */])("subscriptions/" + subscriptionId + "/topics", {
                        subscriptionId: subscriptionId,
                        topicName: topicName,
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function deleteSubscriptionTopic(_a) {
    var topicName = _a.topicName, subscriptionId = _a.subscriptionId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["b" /* del */])("subscriptions/" + subscriptionId + "/topics/" + topicName)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function getSubscriptionTopics(subscriptionId) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["d" /* getOrThrow */])("subscriptions/" + subscriptionId + "/topics")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.topics];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/self.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");

function isLoggedIn(user) {
    return user.id !== undefined;
}
function get() {
    return __WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */]('self', { timingName: 'self' });
}


/***/ }),

/***/ "./src/helpers/api/settings.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = updateRecurringDonationsThankYouMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateSupportsRecurringDonationsStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function updateRecurringDonationsThankYouMessage(projectId, formData) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["f" /* patch */])("/projects/" + projectId + "/settings", formData)];
        });
    });
}
function updateSupportsRecurringDonationsStatus(pageId, supportsRecurringPayments, thankYouMessage) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["f" /* patch */])("projects/" + pageId + "/settings", {
                    supportsRecurringPayments: supportsRecurringPayments,
                    thankYouMessage: thankYouMessage,
                })];
        });
    });
}
function getSettings(pageId) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["c" /* get */])("projects/" + pageId + "/settings")];
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/stripeVirtualAccount.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getAccountStatus;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateStripeAccount;
/* harmony export (immutable) */ __webpack_exports__["d"] = uploadStripeVerificationDocument;
/* harmony export (immutable) */ __webpack_exports__["a"] = addStripeBankAccount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function getAccountStatus(pageId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["d" /* getOrThrow */])("/projects/" + pageId + "/stripeVirtualAccount/status")];
        });
    });
}
function updateStripeAccount(pageId, payload) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["f" /* patch */])("projects/" + pageId + "/stripeVirtualAccount", payload)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, { payoutScheduleInterval: response.body.payoutScheduleInterval }];
            }
        });
    });
}
function uploadStripeVerificationDocument(pageId, file) {
    return __awaiter(this, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            body = new FormData();
            body.append('file', new File([file], 'document.jpg'));
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["h" /* postRaw */])("projects/" + pageId + "/stripeVirtualAccount/images", body)];
        });
    });
}
function addStripeBankAccount(pageId, payload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + pageId + "/stripeVirtualAccount/bankAccount", payload)];
        });
    });
}


/***/ }),

/***/ "./src/helpers/api/subscriptions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsubscribe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");

function unsubscribe(payload) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + payload.projectId + "/subscriptions", payload);
}


/***/ }),

/***/ "./src/helpers/api/updates.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateMediaType; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getUpdates;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUpdate;
/* harmony export (immutable) */ __webpack_exports__["e"] = publishUpdate;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var UpdateMediaType;
(function (UpdateMediaType) {
    UpdateMediaType[UpdateMediaType["Image"] = 1] = "Image";
    UpdateMediaType[UpdateMediaType["Video"] = 2] = "Video";
})(UpdateMediaType || (UpdateMediaType = {}));
function getUpdates(pageId, pageNo, pageSize, updateType) {
    return __awaiter(this, void 0, Promise, function () {
        var url, updates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "projects/" + pageId + "/updates?pageNo=" + pageNo + "&pageSize=" + pageSize;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])(!updateType ? url : url + "&type=" + updateType, {
                            timingName: 'updates',
                        })];
                case 1:
                    updates = _a.sent();
                    if (!updates) {
                        throw new Error('Updates not found');
                    }
                    return [2 /*return*/, updates];
            }
        });
    });
}
function getUpdate(pageId, updateId) {
    return __awaiter(this, void 0, Promise, function () {
        var url, update;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "projects/" + pageId + "/updates/" + updateId;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* get */])(url, { timingName: 'updates' })];
                case 1:
                    update = _a.sent();
                    return [2 /*return*/, update];
            }
        });
    });
}
function publishUpdate(payload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + payload.projectId + "/updates", payload)];
                case 1: return [2 /*return*/, (_a.sent()).body];
            }
        });
    });
}
function deleteUpdate(payload) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common__["b" /* del */])("projects/" + payload.projectId + "/updates/" + payload.updateId);
}


/***/ }),

/***/ "./src/helpers/api/verifications.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = submitPaymentDetails;
/* unused harmony export submitIdentityDocument */
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadIdAndBankStatement;
/* unused harmony export submitAddress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function submitPaymentDetails(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + payload.projectId + "/verifications/v2/paymentDetails", payload, { throwOnError: false, clientSideTimeout: 60000 })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { approved: true }];
                    }
                    if (response.badRequest) {
                        return [2 /*return*/, { approved: false, reason: response.body.message }];
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}
function submitIdentityDocument(pageId, documentType, file) {
    return __awaiter(this, void 0, void 0, function () {
        var body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = new FormData();
                    body.append('documentType', documentType);
                    body.append('file', file);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["h" /* postRaw */])("projects/" + pageId + "/verifications/document", body, { throwOnError: false })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { verified: true }];
                    }
                    if (response.badRequest) {
                        return [2 /*return*/, { verified: false, message: response.body.message }];
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}
function uploadIdAndBankStatement(pageId, file1, file2, optionalEmailAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = new FormData();
                    body.append('id', file1);
                    body.append('bankStatus', file2);
                    body.append('optionalEmailAddress', optionalEmailAddress);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["h" /* postRaw */])("projects/" + pageId + "/verifications/documents", body, { throwOnError: false })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { verified: true }];
                    }
                    if (response.badRequest) {
                        return [2 /*return*/, { verified: false, message: response.body.message }];
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}
function submitAddress(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* post */])("projects/" + payload.projectId + "/verifications/address", payload, { throwOnError: false })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, { verified: true }];
                    }
                    if (response.badRequest) {
                        return [2 /*return*/, { verified: false, message: response.body.message }];
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_0__common__["a" /* ApiError */]({ response: response });
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/async.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wait;
function wait(timeoutMs) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeoutMs);
    });
}


/***/ }),

/***/ "./src/helpers/asyncConnect.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__ = __webpack_require__("./src/redux/modules/asyncConnect/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_LoadingOverlay__ = __webpack_require__("./src/components/LoadingOverlay/index.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




/* harmony default export */ __webpack_exports__["a"] = (function (Component, config) {
    var HOC = /** @class */ (function (_super) {
        __extends(HOC, _super);
        function HOC() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        HOC.prototype.componentDidMount = function () {
            if (!this.props.dataLoaded) {
                this.props.fetchData();
            }
        };
        HOC.prototype.render = function () {
            if (this.props.dataLoaded) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, __assign({}, this.props));
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_LoadingOverlay__["a" /* default */], null);
        };
        HOC.displayName = Component.displayName;
        HOC.fetchData = function (dispatch, params) {
            return new Promise(function (resolve, reject) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__["a" /* beginLoad */])(config.id));
                config.fetchData(dispatch, params).then(function (data) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__["c" /* endLoad */])(config.id));
                    resolve(data);
                }, function (err) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__["c" /* endLoad */])(config.id));
                    reject(err);
                });
            });
        };
        return HOC;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
    var hocMapStateToProps = function (state, ownProps) {
        return Object.assign(config.mapStateToProps ? config.mapStateToProps(state, ownProps) : {}, {
            dataLoaded: state.asyncConnect[config.id] || false,
        });
    };
    var hocDispatchToProps = function (dispatch, ownProps) {
        return Object.assign(config.mapDispatchToProps
            ? config.mapDispatchToProps(dispatch, ownProps)
            : {}, {
            fetchData: HOC.fetchData.bind(null, dispatch, ownProps && ownProps.match && ownProps.match.params),
            beginLoad: function (id) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__["a" /* beginLoad */])(id)); },
            endLoad: function (id) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_asyncConnect__["c" /* endLoad */])(id)); },
        });
    };
    var connected = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(hocMapStateToProps, hocDispatchToProps)(HOC);
    connected.WrapperComponent = Component;
    return connected;
});


/***/ }),

/***/ "./src/helpers/auth.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = refreshAccessToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAuth;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSuperUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__justgiving_auth__ = __webpack_require__("./node_modules/@justgiving/auth/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_logging__ = __webpack_require__("./src/logging.js");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var clientAuth = !false &&
    Object(__WEBPACK_IMPORTED_MODULE_0__justgiving_auth__["a" /* createAuth */])(document, __WEBPACK_IMPORTED_MODULE_1_config__["JWT_BEARER_COOKIE_NAME"], __WEBPACK_IMPORTED_MODULE_1_config__["ACTIVE_GROUPS_COOKIE_NAME"], __WEBPACK_IMPORTED_MODULE_1_config__["IAM_API_URI"] + "/account/refresh-access-token");
function refreshAccessToken() {
    return __awaiter(this, void 0, Promise, function () {
        var auth, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAuth()];
                case 1:
                    auth = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, auth.refreshAccessTokenIfExpired()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    if (err_1.status !== 401) {
                        __WEBPACK_IMPORTED_MODULE_2_src_logging__["a" /* default */].warn({ err: err_1, refreshToken: auth.getRefreshToken() }, 'Unable to refresh access token.');
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getAuth() {
    if (false) {
        var requestStorage = require('../server/requestStorage').default;
        return requestStorage.get('auth');
    }
    return clientAuth;
}
function isSuperUser() {
    var auth = getAuth();
    var token = auth ? auth.getAccessToken() : null;
    return token && token.role && token.role.toLowerCase() === 'superuser';
}


/***/ }),

/***/ "./src/helpers/base64.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (immutable) */ __webpack_exports__["a"] = encodeBase64;
/* unused harmony export decodeBase64 */
function encodeBase64(value) {
    return Buffer.from(value).toString('base64');
}
function decodeBase64(value) {
    return new Buffer(value, 'base64').toString();
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./src/helpers/browser.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectIE;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserAgent;
/* unused harmony export overrideUserAgent */
/* harmony export (immutable) */ __webpack_exports__["g"] = isLocalStorageAvailable;
/* harmony export (immutable) */ __webpack_exports__["k"] = isSessionStorageAvailable;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDesktopViewport;
/* harmony export (immutable) */ __webpack_exports__["h"] = isMobileUserAgent;
/* unused harmony export isDateInputAvailable */
/* harmony export (immutable) */ __webpack_exports__["f"] = isIOSUserAgent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAndroidUserAgent;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEdgeUserAgent;
/* harmony export (immutable) */ __webpack_exports__["l"] = setScrollRestoration;
/* harmony export (immutable) */ __webpack_exports__["j"] = isPropertyInLocalStorage;
/* unused harmony export isPropertyInSessionStorage */
/* harmony export (immutable) */ __webpack_exports__["i"] = isPropertyInLocalAndSessionStorage;
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE(userAgent) {
    var msie = userAgent.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
    }
    var trident = userAgent.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = userAgent.indexOf('rv:');
        return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10);
    }
    // other browser
    return false;
}
var fakeUserAgent;
function getUserAgent() {
    if (true) {
        return navigator.userAgent;
    }
    else if (__SERVER__) {
        var requestStorage = require('../server/requestStorage').default;
        return requestStorage.get('userAgent');
    }
    return fakeUserAgent || '';
}
function overrideUserAgent(userAgent) {
    fakeUserAgent = userAgent;
}
//  is LocalStorage and Session Available
var localAndSessionStorageHelper = function (method) {
    var test = 'isAvailable';
    method.setItem(test, 'true');
    var keyStored = method.getItem(test);
    method.removeItem(test);
    return keyStored && true;
};
function isLocalStorageAvailable() {
    try {
        return localAndSessionStorageHelper(window.localStorage);
    }
    catch (e) {
        return false;
    }
}
function isSessionStorageAvailable() {
    try {
        return localAndSessionStorageHelper(window.sessionStorage);
    }
    catch (e) {
        return false;
    }
}
function isDesktopViewport() {
    return  false ? true : window.matchMedia('(min-width: 768px)').matches;
}
function isMobileUserAgent() {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
    // > In summary, we recommend looking for the string “Mobi” anywhere in the User Agent to detect a mobile device.
    return !!getUserAgent().match(/Mobi/i);
}
function isDateInputAvailable() {
    if (false) {
        return false;
    }
    var input = document.createElement('input');
    input.setAttribute('type', 'date');
    var notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);
    return input.value !== notADateValue;
}
function isIOSUserAgent() {
    return !!getUserAgent().match(/iP(hone|od|ad)/i);
}
function isAndroidUserAgent() {
    return !!getUserAgent().match(/Android/i);
}
function isEdgeUserAgent() {
    return !!getUserAgent().match(/Edge/i);
}
function setScrollRestoration(scrollRestoration) {
    if (true && 'history' in window) {
        history.scrollRestoration = scrollRestoration;
    }
}
function isPropertyInLocalStorage(propertyName) {
    try {
        return !!window.localStorage.getItem(propertyName);
    }
    catch (_a) {
        return false;
    }
}
function isPropertyInSessionStorage(propertyName) {
    try {
        return !!window.sessionStorage.getItem(propertyName);
    }
    catch (_a) {
        return false;
    }
}
function isPropertyInLocalAndSessionStorage(_a) {
    var localPropertyName = _a.localPropertyName, sessionPropertyName = _a.sessionPropertyName;
    return (isPropertyInLocalStorage(localPropertyName) &&
        isPropertyInSessionStorage(sessionPropertyName));
}


/***/ }),

/***/ "./src/helpers/canvas.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = get2dContext;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadImage;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadImages;
/* harmony export (immutable) */ __webpack_exports__["e"] = waitForFont;
/* harmony export (immutable) */ __webpack_exports__["a"] = adjustCanvasSize;
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function get2dContext(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error("Couldn't obtain 2d canvas context");
    }
    return ctx;
}
function loadImage(path) {
    return new Promise(function (resolve, reject) {
        var element = document.createElement('img');
        element.onload = function () {
            resolve(element);
        };
        element.onerror = function () {
            reject(new Error("Failed to load background image " + path));
        };
        element.crossOrigin = 'anonymous';
        element.src = path;
    });
}
function loadImages(paths) {
    return __awaiter(this, void 0, Promise, function () {
        var promises, images;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = Object.entries(paths).map(function (_a) {
                        var name = _a[0], path = _a[1];
                        return __awaiter(_this, void 0, void 0, function () {
                            var image;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, loadImage(path)];
                                    case 1:
                                        image = _b.sent();
                                        return [2 /*return*/, { name: name, image: image }];
                                }
                            });
                        });
                    });
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    images = _a.sent();
                    return [2 /*return*/, images.reduce(function (obj, p) {
                            obj[p.name] = p.image;
                            return obj;
                        }, 
                        // tslint:disable-next-line:no-object-literal-type-assertion
                        {})];
            }
        });
    });
}
var loadedFonts = new Set();
function waitForFont(font, timeout) {
    if (timeout === void 0) { timeout = 5000; }
    return new Promise(function (resolve, reject) {
        if (loadedFonts.has(font)) {
            resolve();
        }
        var canvas = document.createElement('canvas');
        var ctx = get2dContext(canvas);
        var measure = function () { return ctx.measureText('abcdefghijklmnopqrstuvwxyz').width; };
        var scheduleCheck = function () { return setTimeout(check, 50); };
        ctx.font = '10px sans-serif';
        var originalWidth = measure();
        ctx.font = "10px " + font + ", sans-serif";
        var startTime = Date.now();
        function check() {
            if (measure() !== originalWidth) {
                loadedFonts.add(font);
                resolve();
            }
            if (Date.now() - startTime > timeout) {
                reject();
            }
            else {
                scheduleCheck();
            }
        }
        scheduleCheck();
    });
}
function adjustCanvasSize(canvas, context, width, height) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var ctx = context;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
    var ratio = devicePixelRatio / backingStoreRatio;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
}


/***/ }),

/***/ "./src/helpers/countdown.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimeLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__ = __webpack_require__("./node_modules/date-fns/distance_in_words_strict/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months__ = __webpack_require__("./node_modules/date-fns/difference_in_months/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_calendar_days__ = __webpack_require__("./node_modules/date-fns/difference_in_calendar_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_calendar_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_calendar_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_sub_months__ = __webpack_require__("./node_modules/date-fns/sub_months/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_sub_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_sub_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_compare_asc__ = __webpack_require__("./node_modules/date-fns/compare_asc/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_compare_asc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_compare_asc__);






function getTimeLeft(finishDate) {
    if (!finishDate) {
        return __WEBPACK_IMPORTED_MODULE_0_config___default.a.DEFAULT_PAGE_LIFE + " days";
    }
    // if date is in the past
    if (__WEBPACK_IMPORTED_MODULE_5_date_fns_compare_asc___default()(finishDate, Date.now()) === -1) {
        return '0 minutes';
    }
    var monthDiff = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months___default()(finishDate, Date.now());
    // let datefns format days remaining or years
    if (monthDiff === 0 || monthDiff > 12) {
        return __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default()(finishDate, Date.now());
    }
    var result = monthDiff + " " + (monthDiff > 1 ? 'months' : 'month');
    // calculate the amount of days remaining once the months are subtracted
    var daysDiff = __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_calendar_days___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_sub_months___default()(finishDate, monthDiff), Date.now());
    if (daysDiff > 0) {
        result = result + " and " + daysDiff + " " + (daysDiff > 1 ? 'days' : 'day');
    }
    return result;
}


/***/ }),

/***/ "./src/helpers/currencyMap.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currencyMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currencyMapToPenny; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return currencyToCountryCodeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryToCurrencyMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrencyMessage; });
/* unused harmony export isValidCurrency */
var currencyMap = {
    AUD: '$',
    GBP: '£',
    USD: '$',
};
var currencyMapToPenny = {
    AUD: '¢',
    GBP: 'p',
    USD: '¢',
};
var currencyToCountryCodeMap = {
    AUD: 'AU',
    GBP: 'GB',
    USD: 'US',
};
var countryToCurrencyMap = {
    AU: { code: 'AUD', name: '$ - Australian Dollar' },
    GB: { code: 'GBP', name: '£ - Great British Pound' },
    US: { code: 'USD', name: '$ - United States Dollar' },
};
var getCurrencyMessage = function (currencyName) {
    var currencyMessage = {
        GBP: "Raising money in GBP? You'll need a UK personal current account to withdraw your donations.",
        USD: "Raising money in GBP? You'll need a UK personal current account to withdraw your donations.",
        AUD: "Raising money in GBP? You'll need a UK personal current account to withdraw your donations.",
    };
    return currencyMessage[currencyName];
};
var isValidCurrency = function (currency) {
    return currency && currencyToCountryCodeMap[currency];
};
/* harmony default export */ __webpack_exports__["e"] = (currencyMap);


/***/ }),

/***/ "./src/helpers/date.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculateEndDate */
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateMaxEndDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateMinEndDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertDateToUTC;
/* harmony export (immutable) */ __webpack_exports__["f"] = distanceInWordsToNow;
/* harmony export (immutable) */ __webpack_exports__["h"] = getConsentDOB;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDaysRemaining;
/* harmony export (immutable) */ __webpack_exports__["k"] = getLastUpdated;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDistanceInWords;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCalendarDays;
/* harmony export (immutable) */ __webpack_exports__["e"] = countdown;
/* harmony export (immutable) */ __webpack_exports__["g"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days__ = __webpack_require__("./node_modules/date-fns/add_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_days__ = __webpack_require__("./node_modules/date-fns/difference_in_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict__ = __webpack_require__("./node_modules/date-fns/distance_in_words_strict/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_seconds__ = __webpack_require__("./node_modules/date-fns/difference_in_seconds/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day__ = __webpack_require__("./node_modules/date-fns/end_of_day/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_future__ = __webpack_require__("./node_modules/date-fns/is_future/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_future___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_is_future__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_years__ = __webpack_require__("./node_modules/date-fns/sub_years/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_years__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_config__);









var SECONDS_IN_MINUTE = 60;
var MINUTES_IN_HOUR = 60;
var HOURS_IN_DAY = 24;
var DAYS_IN_MONTH = 30;
var MONTHS_IN_YEAR = 12;
function calculateEndDate(activatedAt, duration) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(activatedAt, duration));
}
function calculateMaxEndDate(activatedAt) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(activatedAt, __WEBPACK_IMPORTED_MODULE_8_config___default.a.MAX_PAGE_LIFE));
}
function calculateMinEndDate(activatedAt) {
    var minEndDate = __WEBPACK_IMPORTED_MODULE_4_date_fns_end_of_day___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(activatedAt, 30));
    return __WEBPACK_IMPORTED_MODULE_6_date_fns_is_future___default()(minEndDate) ? minEndDate : new Date();
}
function convertDateToUTC(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
// https://momentjs.com/docs/#/displaying/fromnow/
function distanceInWordsToNow(date) {
    var seconds = Math.abs(__WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_seconds___default()(new Date(), date));
    var minutes = Math.round(seconds / SECONDS_IN_MINUTE);
    var hours = Math.round(minutes / MINUTES_IN_HOUR);
    var days = Math.round(hours / HOURS_IN_DAY);
    var months = Math.round(days / DAYS_IN_MONTH);
    var years = Math.round(months / MONTHS_IN_YEAR);
    if (seconds < 45) {
        return 'Just now';
    }
    else if (seconds >= 45 && seconds < 90) {
        return '1 minute ago';
    }
    else if (seconds >= 90 && minutes < 45) {
        return minutes + " mins ago";
    }
    else if (minutes >= 45 && minutes < 90) {
        return '1 hour ago';
    }
    else if (minutes >= 90 && hours < 22) {
        return hours + " hrs ago";
    }
    else if (hours >= 22 && hours < 36) {
        return '1 day ago';
    }
    else if (hours >= 36 && days < 26) {
        return days + " days ago";
    }
    else if (days >= 26 && days < 45) {
        return '1 month ago';
    }
    else if (days >= 45 && days < 320) {
        return months + " months ago";
    }
    else if (days >= 320 && days < 548) {
        return '1 year ago';
    }
    else {
        return years + " years ago";
    }
}
function getConsentDOB(age) {
    return __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_years___default()(new Date(), age), 'YYYY-MM-DD');
}
function getDaysRemaining(withdrawalAvailableDate) {
    return __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_days___default()(withdrawalAvailableDate, new Date()) + 1;
}
function getLastUpdated(createdAt, activatedAt, supporters, updates) {
    if (!supporters.length && !updates.length) {
        return new Date(activatedAt || createdAt);
    }
    var donationsAndUpdatesCreationDates = supporters
        .concat(updates)
        .map(function (x) { return Date.parse(x.createdAt); });
    var lastUpdated = Math.max.apply(Math, donationsAndUpdatesCreationDates);
    return new Date(lastUpdated);
}
function getDistanceInWords(numberOfDays) {
    var today = new Date();
    var addToToday = __WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(today, numberOfDays);
    return __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict___default()(addToToday, today);
}
// ensure we are adding calendar days excluding time, important for timezone
// changes
function addCalendarDays(date, numberOfDays) {
    return new Date(__WEBPACK_IMPORTED_MODULE_0_date_fns_add_days___default()(new Date(date).setHours(12), numberOfDays).setHours(23));
}
function countdown(date) {
    var countdownDate = new Date(date).getTime();
    var today = new Date().getTime();
    var distance = countdownDate - today;
    var daysRemaining = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hoursRemaining = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutesRemaining = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var secondsRemaining = Math.floor((distance % (1000 * 60)) / 1000);
    var hasCountdownFinished = distance <= 0;
    return {
        daysRemaining: daysRemaining,
        hoursRemaining: hoursRemaining,
        minutesRemaining: minutesRemaining,
        secondsRemaining: secondsRemaining,
        hasCountdownFinished: hasCountdownFinished,
    };
}
function formatDate(date, locale) {
    try {
        return new Intl.DateTimeFormat(locale || 'en-GB').format(date);
    }
    catch (e) {
        return date;
    }
}


/***/ }),

/***/ "./src/helpers/facebook.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = share;
/* unused harmony export fbLogPromise */
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* unused harmony export getTaggableFriends */
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* global FB */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function share(_a) {
    var method = _a.method, link = _a.link, ref = _a.ref, picture = _a.picture, name = _a.name, quote = _a.quote, description = _a.description, mobileIframe = _a.mobileIframe;
    var options;
    switch (method) {
        case 'feed':
            options = {
                method: 'feed',
                link: link,
                ref: ref,
                picture: picture,
                name: name,
                description: description,
                quote: quote,
            };
            break;
        case 'share':
            options = {
                method: 'share',
                href: link,
                ref: ref,
                picture: picture,
                title: name,
                description: description,
                quote: quote,
                mobile_iframe: mobileIframe || true,
            };
            break;
        case 'open_graph':
            options = {
                method: 'share_open_graph',
                action_type: __WEBPACK_IMPORTED_MODULE_0__config__["FB_APP_NAMESPACE"] + ":support",
                action_properties: JSON.stringify({ yimby_project: link }),
            };
            break;
        default:
            throw new Error("Unsupported share method " + method);
    }
    return new Promise(function (resolve, reject) {
        FB.ui(options, function (response) {
            if (response && response.error_message) {
                reject(response.error_message);
            }
            else {
                // It's impossible to reliably tell if the share was succesfull unless
                // the user has authorized our app (more http://stackoverflow.com/questions/5363517),
                // which most of our users won't do - we only as this of owners when
                // they try to post page updates to Facebook.
                // This only tell us that the share window was actually opened,
                // even the error_message might not be there on response in some
                // cases
                resolve();
            }
        });
    });
}
var fbLogPromise = new Promise(function (resolve) {
    if (true) {
        window.fbAsyncInit = function () {
            FB.init({ appId: __WEBPACK_IMPORTED_MODULE_0__config__["FB_APP_ID"], xfbml: true, version: 'v5.0', status: true });
            resolve(FB);
        };
        (function facebookScript(d, s, id) {
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            var js = d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/ /sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }
});
if (true) {
    /* tslint:disable */
    window.ga =
        window.ga ||
            function () {
                (ga.q = ga.q || []).push(arguments);
            };
    ga.l = +new Date();
    window.twttr = (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {};
        if (d.getElementById(id))
            return t;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://platform.twitter.com/widgets.js';
        fjs.parentNode.insertBefore(js, fjs);
        t._e = [];
        t.ready = function (f) {
            t._e.push(f);
        };
        return t;
    })(document, 'script', 'twitter-wjs');
    /* tslint:enable */
}
function isValidResponse(response) {
    return response && !response.error;
}
function getAccessToken(response) {
    return response && response.authResponse
        ? response.authResponse.accessToken
        : null;
}
function getLoggedInUser() {
    return __awaiter(this, void 0, void 0, function () {
        var FB;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbLogPromise];
                case 1:
                    FB = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve) {
                            FB.api('/me?fields=email,first_name,last_name,picture.width(400).height(400)', function (response) {
                                if (isValidResponse(response)) {
                                    resolve(response);
                                }
                                else {
                                    resolve(null);
                                }
                            });
                        })];
            }
        });
    });
}
function requestLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var FB;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbLogPromise];
                case 1:
                    FB = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve) {
                            FB.login(function (response) {
                                if (isValidResponse(response)) {
                                    var accessToken = getAccessToken(response);
                                    resolve(accessToken);
                                }
                                else {
                                    resolve(null);
                                }
                            }, {
                                scope: 'public_profile, user_friends, email, user_photos',
                                return_scopes: true,
                                auth_type: 'rerequest',
                            });
                        })];
            }
        });
    });
}
function createLoggedInUser(accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLoggedInUser()];
                case 1:
                    user = _a.sent();
                    if (!user) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, {
                            accessToken: accessToken,
                            firstName: user.first_name,
                            lastName: user.last_name,
                            emailAddress: user.email,
                            profilePicture: user.picture,
                        }];
            }
        });
    });
}
function requestLoginAndCreateUser() {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestLogin()];
                case 1:
                    accessToken = _a.sent();
                    // The user failed to authenticate or grant required permissions
                    if (!accessToken) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, createLoggedInUser(accessToken)];
            }
        });
    });
}
function login() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, requestLoginAndCreateUser()];
        });
    });
}
function getTaggableFriends() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    // todo: move FB API call to a helper function
                    FB.api('/me/taggable_friends?limit=5000', function (response) {
                        if (response && response.error) {
                            reject(response);
                        }
                        resolve(response);
                    });
                })];
        });
    });
}
function getUserToken() {
    return __awaiter(this, void 0, void 0, function () {
        var userToken;
        var _this = this;
        return __generator(this, function (_a) {
            userToken = '';
            FB.getLoginStatus(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var user;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            userToken = getAccessToken(response);
                            if (!(userToken == null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, login()];
                        case 1:
                            user = _a.sent();
                            userToken = user && user.accessToken;
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/, userToken];
        });
    });
}


/***/ }),

/***/ "./src/helpers/formatter.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = abbreviateNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatCurrency;
/* unused harmony export formatDatePlaceholder */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function abbreviateNumber(num) {
    if (num < 1000) {
        return num.toString();
    }
    else if (num < 1000000) {
        return formatNumber(num, 1000) + "K";
    }
    else if (num < 1000000000) {
        return formatNumber(num, 1000000) + "M";
    }
    return formatNumber(num, 1000000000) + "B";
}
function formatNumber(value, base) {
    if (value % base === 0) {
        return value / base;
    }
    return (value / base).toFixed(1);
}
var currencyLocaleMap = {
    GBP: 'en-GB',
    USD: 'en-US',
    AUD: 'en-AU',
};
function formatCurrency(value, options) {
    var locale = currencyLocaleMap[options.currency];
    return new Intl.NumberFormat(locale, __assign({ style: 'currency' }, options)).format(value);
}
var dateFormatLocaleMap = {
    USD: 'MM / DD / YYYY',
    GBP: 'DD / MM / YYYY',
};
function formatDatePlaceholder(targetCurrency) {
    return dateFormatLocaleMap[targetCurrency] || dateFormatLocaleMap.GBP;
}


/***/ }),

/***/ "./src/helpers/funds.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fundsStatusWhiteList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFundsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportsPaymentSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_after__ = __webpack_require__("./node_modules/date-fns/is_after/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_past__ = __webpack_require__("./node_modules/date-fns/is_past/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_past___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_is_past__);


var fundsStatusWhiteList = [
    'NoFunds',
    'PreviousWithdrawalProcessing',
    'CanWithdraw',
    'NotAvailableYet',
    'ProjectNotActive',
    'ProjectNotReviewed',
    'ProjectNotVerified',
];
var getFundsStatus = function (_a) {
    var amountRaised = _a.amountRaised, finishedAt = _a.finishedAt, fundsResponse = _a.fundsResponse, isAccountConnected = _a.isAccountConnected;
    var hasPageClosed = __WEBPACK_IMPORTED_MODULE_1_date_fns_is_past___default()(finishedAt);
    if (hasPageClosed && amountRaised > 0) {
        var automaticWithdraw = fundsResponse.withdrawals.find(function (withdrawal) {
            return __WEBPACK_IMPORTED_MODULE_0_date_fns_is_after___default()(withdrawal.dateRequested, finishedAt);
        });
        if (automaticWithdraw && automaticWithdraw.status === 'Processing') {
            return 'FinalWithdrawalProcessing';
        }
        var totalAmountWithdrawn = fundsResponse.withdrawals
            .filter(function (withdrawal) { return withdrawal.status === 'Complete'; })
            .reduce(function (total, withdrawal) { return total + withdrawal.grossAmount; }, 0);
        if (totalAmountWithdrawn >= amountRaised) {
            return 'FinalWithdrawalComplete';
        }
        return 'FinalDonationsSettling';
    }
    if (fundsResponse.status !== 'ProjectNotVerified' && amountRaised === 0) {
        return 'NoFirstDonation';
    }
    if (isAccountConnected && fundsResponse.status === 'ProjectNotVerified') {
        return 'BankAccountDetailsPending';
    }
    if (fundsStatusWhiteList.includes(fundsResponse.status)) {
        return fundsResponse.status;
    }
    throw new Error('Status not available');
};
var supportedPaymentSchedules = ['Monthly', 'Weekly'];
var supportsPaymentSchedule = function (paymentSchedule) {
    return supportedPaymentSchedules.includes(paymentSchedule);
};


/***/ }),

/***/ "./src/helpers/graphTransforms.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformStatDataForGraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format__ = __webpack_require__("./node_modules/d3-time-format/index.js");

function transformStatDataForGraph(data) {
    var correctDates = data.map(function (datum) {
        var date = Object(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__["c" /* utcParse */])('%Y%m%d')(datum.date);
        return {
            date: date,
            count: datum.count,
        };
    });
    return correctDates;
}


/***/ }),

/***/ "./src/helpers/hashId.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateHash;
// https://gist.github.com/fiznool/73ee9c7a11d1ff80b81c
var ALPHABET = '23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ';
var ID_LENGTH = 9;
function generateHash() {
    var rtn = '';
    for (var i = 0; i < ID_LENGTH; i++) {
        rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return rtn;
}


/***/ }),

/***/ "./src/helpers/image.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = convertStringToSvg;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertImageToBase64;
/* harmony export (immutable) */ __webpack_exports__["c"] = convertSvgToPngBase64;
/* harmony export (immutable) */ __webpack_exports__["h"] = getImageUrlWithTemplate;
/* harmony export (immutable) */ __webpack_exports__["g"] = getImageUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCoverImageUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = cropImage;
/* unused harmony export getCropAreaRectangle */
/* harmony export (immutable) */ __webpack_exports__["f"] = getImageFromCanvas;
/* harmony export (immutable) */ __webpack_exports__["i"] = processImage;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateImage;
/* unused harmony export getImageName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_images_default_cover_image_svg__ = __webpack_require__("./static/images/default-cover-image.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_images_default_cover_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_images_default_cover_image_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__("./src/helpers/math.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function convertStringToSvg(svgString) {
    var svgDiv = document.createElement('div');
    svgDiv.innerHTML = svgString;
    return svgDiv.firstChild;
}
function convertImageToBase64(imgpath, width, height) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var img = new Image();
                    var canvas = document.createElement('canvas');
                    img.crossOrigin = 'anonymous';
                    img.onload = function () {
                        var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
                        var imageWidth = width || naturalWidth;
                        var imageHeight = height || naturalHeight;
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        canvas.getContext('2d').drawImage(img, 0, 0, imageWidth, imageHeight);
                        var dataUrl = canvas.toDataURL('image/png');
                        resolve(dataUrl);
                    };
                    img.src = imgpath;
                    img.onerror = function () { return reject(new Error('Could not load the image')); };
                })];
        });
    });
}
function convertSvgToPngBase64(svg, width, height, mimeType) {
    return new Promise(function (resolve, reject) {
        var svgData = new XMLSerializer().serializeToString(svg);
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        var img = document.createElement('img');
        img.onload = function () {
            ctx.drawImage(img, 0, 0, width, height);
            var dataUrl = canvas.toDataURL(mimeType);
            resolve(dataUrl);
        };
        img.onerror = function () { return reject(new Error('Could not load the image')); };
        img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
    });
}
function getImageUrlWithTemplate(imageUrl, template) {
    if (!imageUrl) {
        return '';
    }
    if (!template) {
        return imageUrl;
    }
    return imageUrl + "?template=" + template;
}
function getImageUrl(imageName) {
    return __WEBPACK_IMPORTED_MODULE_2_config___default.a.IMAGE_BASE_URI + "/" + imageName;
}
function getCoverImageUrl(projectImage, maxSize, template) {
    if (projectImage && projectImage.name) {
        if (projectImage.width && projectImage.height) {
            return getCroppedCoverImageUrl(projectImage, maxSize);
        }
        return getImageUrlWithTemplate(getImageUrl(projectImage.name), template);
    }
    return __WEBPACK_IMPORTED_MODULE_0__static_images_default_cover_image_svg___default.a;
}
function getCroppedCoverImageUrl(coverImage, maxSize) {
    var imageSize = { width: coverImage.width, height: coverImage.height };
    var cropArea = getCropArea(coverImage);
    var _a = calculateCoverImageProperties(imageSize, cropArea, maxSize), x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2, zoom = _a.zoom;
    return __WEBPACK_IMPORTED_MODULE_2_config___default.a.IMAGE_BASE_URI + "/" + coverImage.name + "?crop=" + x1 + "," + y1 + "," + x2 + "," + y2 + "&zoom=" + zoom;
}
function calculateCoverImageProperties(imageSize, cropArea, maxSize) {
    // This algorithm is very CF specific - it'll assume that we never need anything
    // above or below the crop area, but we need as much as we can (up to maxWidth)
    // to the left and right.
    if (maxSize === void 0) { maxSize = cropArea; }
    // zoom out to make height of the crop area equal to maxHeight, but do
    // not go over 1 which would stretch the image
    var zoom = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* round */])(Math.min(maxSize.height / cropArea.height, 1), 3);
    if (maxSize.width / maxSize.height < cropArea.width / cropArea.height) {
        // edge case: "weird" crop area aspect ratio, just return crop area
        // coordinates without trying to borrow from the sides.
        return {
            zoom: zoom,
            x1: cropArea.left,
            y1: cropArea.top,
            x2: cropArea.left + cropArea.width,
            y2: cropArea.top + cropArea.height,
        };
    }
    var cropX1 = cropArea.left;
    var cropX2 = cropArea.left + cropArea.width;
    // calculate how much we can take from the outside of the crop area to
    // the left and right, without exceeding maxWidth
    var outsideLeft = cropX1;
    var outsideRight = imageSize.width - cropX2;
    // this will always be negative thanks to the width:height ratio check above
    var outsideLimit = (maxSize.width / zoom - cropArea.width) / 2;
    var maxOutside = Math.min(outsideLeft, outsideRight, outsideLimit);
    return {
        zoom: zoom,
        x1: cropX1 - maxOutside,
        y1: cropArea.top,
        x2: cropX2 + maxOutside,
        y2: cropArea.top + cropArea.height,
    };
}
function getCropArea(coverImage) {
    if (coverImage.cropArea &&
        coverImage.cropArea.width &&
        coverImage.cropArea.height) {
        return coverImage.cropArea;
    }
    return {
        left: 0,
        top: 0,
        width: coverImage.width,
        height: coverImage.height,
    };
}
function convertDataUrlToBlob(dataUrl, mimeType) {
    var byteString = atob(dataUrl.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
}
function cropImage(_a) {
    var image = _a.image, position = _a.position, scale = _a.scale, rotate = _a.rotate;
    return __awaiter(this, void 0, Promise, function () {
        var resource, cropRect, canvas, context;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, loadImage(image)];
                case 1:
                    resource = _b.sent();
                    cropRect = getCropAreaRectangle({
                        size: resource,
                        position: position,
                        scale: scale,
                        rotate: rotate,
                    });
                    canvas = document.createElement('canvas');
                    canvas.width = cropRect.width;
                    canvas.height = cropRect.height;
                    context = canvas.getContext('2d');
                    context.fillStyle = '#fff';
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.translate(canvas.width / 2, canvas.height / 2);
                    context.rotate((rotate * Math.PI) / 180);
                    context.translate(-(canvas.width / 2), -(canvas.height / 2));
                    if (rotate % 180 !== 0) {
                        context.translate((canvas.width - canvas.height) / 2, (canvas.height - canvas.width) / 2);
                    }
                    context.drawImage(resource, -cropRect.x, -cropRect.y);
                    return [2 /*return*/, resizeImage(canvas, { width: 800, height: 450 })];
            }
        });
    });
}
function getCropAreaRectangle(_a) {
    var size = _a.size, position = _a.position, scale = _a.scale, rotate = _a.rotate;
    var imageAspect = size.width / size.height;
    var cropAreaAspect = rotate % 180 === 0 ? 16 / 9 : 9 / 16;
    var width = (1 / scale) * Math.min(1, cropAreaAspect / imageAspect);
    var height = (1 / scale) * Math.min(1, imageAspect / cropAreaAspect);
    var x = position.x - width / 2;
    var y = position.y - height / 2;
    // react-avatar-editor does not normalise/clamp the coordinates, so
    // we have to do it here again...
    var xMin = 0;
    var xMax = 1 - width;
    var yMin = 0;
    var yMax = 1 - height;
    if (width > 1 && height > 1) {
        xMin = (1 - width) / 2;
        xMax = (1 - width) / 2;
        yMin = (1 - height) / 2;
        yMax = (1 - height) / 2;
    }
    else if (width > 1) {
        xMin = (1 - width) / 2;
        xMax = (1 - width) / 2;
        yMin = 0;
        yMax = 1 - height;
    }
    else if (height > 1) {
        xMin = 0;
        xMax = 1 - width;
        yMin = (1 - height) / 2;
        yMax = (1 - height) / 2;
    }
    var rectangle = {
        x: Math.round(Math.max(xMin, Math.min(x, xMax)) * size.width),
        y: Math.round(Math.max(yMin, Math.min(y, yMax)) * size.height),
        width: Math.round(width * size.width),
        height: Math.round(height * size.height),
    };
    if (rotate % 180 !== 0) {
        return __assign({}, rectangle, { width: rectangle.height, height: rectangle.width });
    }
    return rectangle;
}
function isDataURL(str) {
    if (str === null) {
        return false;
    }
    var regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i;
    return !!str.match(regex);
}
function loadImage(imageUrl) {
    return new Promise(function (resolve, reject) {
        var imageObj = new Image();
        imageObj.onload = function () { return resolve(imageObj); };
        if (!isDataURL(imageUrl)) {
            imageObj.crossOrigin = 'anonymous';
        }
        imageObj.onerror = reject;
        imageObj.src = imageUrl;
    });
}
function resizeImage(image, size) {
    var canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    var context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, size.width, size.height);
    return getImageFromCanvas(canvas);
}
function getImageFromCanvas(canvas, mimeType) {
    if (mimeType === void 0) { mimeType = 'image/jpeg'; }
    return new Promise(function (resolve, reject) {
        if (canvas.toBlob) {
            canvas.toBlob(function (blob) {
                if (blob) {
                    resolve(blob);
                }
                else {
                    reject(new Error('Failed to convert image to blob'));
                }
            }, mimeType, 0.9);
        }
        else {
            resolve(convertDataUrlToBlob(canvas.toDataURL(mimeType), mimeType));
        }
    });
}
function processImage(pic, options) {
    return new Promise(function (resolve) {
        if (validateImage(pic, options)) {
            var reader_1 = new FileReader();
            reader_1.readAsDataURL(pic);
            reader_1.addEventListener('load', function () {
                resolve({ success: true, image: reader_1.result });
            });
        }
        else {
            resolve({ success: false });
        }
    });
}
function validateImage(image, _a) {
    var maxSize = _a.maxSize;
    if (!/image\/(jpg|jpeg|png)$/.test(image.type)) {
        return false;
    }
    if (maxSize && image.size > maxSize) {
        return false;
    }
    return true;
}
function getImageName(image) {
    if (image) {
        return image.slice(image.lastIndexOf('/'));
    }
    return '';
}


/***/ }),

/***/ "./src/helpers/images/milestoneImage/arm-1.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "78bad6339cbbb0ee9f07cbde862af7fb.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/arm-2.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22704e9e28cb4b009326b7e8cd52a2f2.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/arm-3.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "974694c713a7696df13a93d493ed1e7b.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/background-blue.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "534dbd8ffbad812274a10d64218e2bb0.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/background-green.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b13f2c66aa700629cb7417d4b1d7647e.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/background-orange.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d1987d78f639312cd82cbc907b011a2b.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/background-purple.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5d8f467fa86eb0faa9a7466f5562af09.svg";

/***/ }),

/***/ "./src/helpers/images/milestoneImage/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__milestoneImage__ = __webpack_require__("./src/helpers/images/milestoneImage/milestoneImage.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__milestoneImage__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__milestoneImage__["b"]; });



/***/ }),

/***/ "./src/helpers/images/milestoneImage/milestoneImage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASPECT_RATIO; });
/* unused harmony export getMilestoneImageDescriptor */
/* harmony export (immutable) */ __webpack_exports__["c"] = exportMilestoneImage;
/* harmony export (immutable) */ __webpack_exports__["b"] = drawMilestoneImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__ = __webpack_require__("./src/helpers/canvas.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__background_purple_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/background-purple.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__background_purple_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__background_purple_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_orange_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/background-orange.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__background_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__background_green_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/background-green.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__background_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__background_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_blue_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/background-blue.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__background_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__arm_1_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/arm-1.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__arm_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__arm_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arm_2_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/arm-2.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arm_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__arm_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__arm_3_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/arm-3.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__arm_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__arm_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__totaliser_svg__ = __webpack_require__("./src/helpers/images/milestoneImage/totaliser.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__totaliser_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__totaliser_svg__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};










var ASPECT_RATIO = 1200 / 630;
var presets = {
    purple: {
        background: __WEBPACK_IMPORTED_MODULE_2__background_purple_svg___default.a,
        arm: __WEBPACK_IMPORTED_MODULE_6__arm_1_svg___default.a,
    },
    orange: {
        background: __WEBPACK_IMPORTED_MODULE_3__background_orange_svg___default.a,
        arm: __WEBPACK_IMPORTED_MODULE_8__arm_3_svg___default.a,
    },
    green: {
        background: __WEBPACK_IMPORTED_MODULE_4__background_green_svg___default.a,
        arm: __WEBPACK_IMPORTED_MODULE_6__arm_1_svg___default.a,
    },
    blue: {
        background: __WEBPACK_IMPORTED_MODULE_5__background_blue_svg___default.a,
        arm: __WEBPACK_IMPORTED_MODULE_7__arm_2_svg___default.a,
    },
};
function getMilestoneImageDescriptor(_a) {
    var percentage = _a.percentage, preset = _a.preset;
    var width = 1200;
    var height = 630;
    var totaliserRadius = 240;
    var totaliserX = 600;
    var totaliserY = 35 + totaliserRadius;
    var fillPercentage = Math.min(100, percentage) / 100;
    var fillRadius = totaliserRadius - 45;
    var fillTopY = totaliserY + fillRadius - fillRadius * 2 * fillPercentage;
    var fillTopParam = Math.sqrt(1 - Math.pow((1 - fillPercentage * 2), 2)) * fillRadius;
    var fillTopLeft = -fillTopParam + totaliserX;
    var fillTopRight = fillTopParam + totaliserX;
    var fillStartAngle = fillPercentageToAngle(fillPercentage);
    var fillEndAngle = Math.PI - fillStartAngle;
    var fillWaveCpx1 = fillTopLeft + fillTopParam * 0.8;
    var fillWaveCpy1 = fillTopY - 60 * (1 - Math.abs(percentage - 50) / 50);
    var fillWaveCpx2 = fillTopLeft + fillTopParam * 1.2;
    var fillWaveCpy2 = fillTopY - 10 * (1 - Math.abs(percentage - 50) / 50);
    var armHeight = 137;
    var armWidth = 769;
    var armX = -320;
    var armY = totaliserY - armHeight / 2;
    var percentageSize = 120;
    var targetSize = 32;
    var targetMargin = 20;
    var percentageX = totaliserX;
    var percentageY = totaliserY - (targetSize / 2 + targetMargin / 2);
    var percentageMaxWidth = totaliserRadius * 2 - 180;
    var targetX = percentageX;
    var targetY = percentageY + percentageSize / 2 + targetMargin;
    var targetMaxWidth = totaliserRadius * 2 - 180;
    return {
        width: width,
        height: height,
        images: presets[preset],
        totaliser: {
            radius: totaliserRadius,
            x: totaliserX,
            y: totaliserY,
        },
        fill: {
            x: totaliserX,
            y: totaliserY,
            radius: fillRadius,
            topLeft: fillTopLeft,
            topRight: fillTopRight,
            topY: fillTopY,
            startAngle: fillStartAngle,
            endAngle: fillEndAngle,
            waveCpx1: fillWaveCpx1,
            waveCpy1: fillWaveCpy1,
            waveCpx2: fillWaveCpx2,
            waveCpy2: fillWaveCpy2,
        },
        arm: {
            x: armX,
            y: armY,
            width: armWidth,
            height: armHeight,
        },
        percentage: {
            x: percentageX,
            y: percentageY,
            size: percentageSize,
            maxWidth: percentageMaxWidth,
        },
        target: {
            x: targetX,
            y: targetY,
            size: targetSize,
            maxWidth: targetMaxWidth,
        },
    };
}
function exportMilestoneImage(options) {
    return __awaiter(this, void 0, Promise, function () {
        var canvas, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canvas = document.createElement('canvas');
                    canvas.width = options.width;
                    canvas.height = options.height;
                    ctx = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__["b" /* get2dContext */])(canvas);
                    return [4 /*yield*/, drawMilestoneImage(__assign({ ctx: ctx }, options))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_image__["f" /* getImageFromCanvas */])(canvas, 'image/png')];
            }
        });
    });
}
function drawMilestoneImage(options) {
    return __awaiter(this, void 0, void 0, function () {
        function drawBackground() {
            ctx.drawImage(images.background, 0, 0, imageWidth, imageHeight);
        }
        function drawTotaliser() {
            var _a = descriptor.totaliser, x = _a.x, y = _a.y, radius = _a.radius;
            ctx.drawImage(images.totaliser, x - radius, y - radius, radius * 2, radius * 2);
        }
        function drawFill() {
            var _a = descriptor.fill, x = _a.x, y = _a.y, radius = _a.radius, topLeft = _a.topLeft, topRight = _a.topRight, topY = _a.topY, startAngle = _a.startAngle, endAngle = _a.endAngle, waveCpx1 = _a.waveCpx1, waveCpy1 = _a.waveCpy1, waveCpx2 = _a.waveCpx2, waveCpy2 = _a.waveCpy2;
            ctx.fillStyle = '#ad29b6';
            ctx.beginPath();
            ctx.moveTo(topLeft, topY);
            ctx.bezierCurveTo(waveCpx1, waveCpy1, waveCpx2, waveCpy2, topRight, topY + 1);
            ctx.lineTo(topRight, topY);
            ctx.arc(x, y, radius, startAngle, endAngle);
            ctx.fill();
        }
        function drawArm() {
            var _a = descriptor.arm, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            ctx.drawImage(images.arm, x, y, width, height);
        }
        function drawPercentage() {
            var _a = descriptor.percentage, x = _a.x, y = _a.y, size = _a.size, maxWidth = _a.maxWidth;
            ctx.font = size + "px Roboto-Regular, Roboto, Arial, sans-serif";
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(percentage + "%", x, y, maxWidth);
        }
        function drawTarget() {
            var _a = descriptor.target, x = _a.x, y = _a.y, size = _a.size, maxWidth = _a.maxWidth;
            ctx.font = size + "px Roboto-Regular, Roboto, Arial, sans-serif";
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(" of " + targetAmount + " target", x, y, maxWidth);
        }
        var ctx, canvasWidth, canvasHeight, percentage, targetAmount, descriptor, imageWidth, imageHeight, imagePaths, images;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx = options.ctx, canvasWidth = options.width, canvasHeight = options.height, percentage = options.percentage, targetAmount = options.targetAmount;
                    descriptor = getMilestoneImageDescriptor(options);
                    imageWidth = descriptor.width, imageHeight = descriptor.height, imagePaths = descriptor.images;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__["d" /* loadImages */])(__assign({}, imagePaths, { totaliser: __WEBPACK_IMPORTED_MODULE_9__totaliser_svg___default.a }))];
                case 1:
                    images = _a.sent();
                    ctx.save();
                    try {
                        ctx.scale(canvasWidth / imageWidth, canvasHeight / imageHeight);
                        drawBackground();
                        drawTotaliser();
                        drawFill();
                        drawArm();
                        drawPercentage();
                        drawTarget();
                    }
                    finally {
                        ctx.restore();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function fillPercentageToAngle(fillPercentage) {
    var y = 1 - fillPercentage * 2;
    var x = Math.sqrt(1 - Math.pow(y, 2));
    return Math.atan2(y, x);
}


/***/ }),

/***/ "./src/helpers/images/milestoneImage/totaliser.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/helpers/images/thankYouImage/background-blue.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "28632209c1c567c1aea57d66262ff751.svg";

/***/ }),

/***/ "./src/helpers/images/thankYouImage/background-green.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94638e50294d543c73ee3faffd00f996.svg";

/***/ }),

/***/ "./src/helpers/images/thankYouImage/background-orange.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0fe555b68d2ab94e12b0f4ba287e16ac.svg";

/***/ }),

/***/ "./src/helpers/images/thankYouImage/background-purple.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49a931e83323c39d5f3e1de817d896f0.svg";

/***/ }),

/***/ "./src/helpers/images/thankYouImage/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thankYouImage__ = __webpack_require__("./src/helpers/images/thankYouImage/thankYouImage.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__thankYouImage__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__thankYouImage__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__thankYouImage__["a"]; });
/* unused harmony reexport ThankYouImagePreset */



/***/ }),

/***/ "./src/helpers/images/thankYouImage/thankYouImage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASPECT_RATIO; });
/* unused harmony export getThankYouImageDescriptor */
/* harmony export (immutable) */ __webpack_exports__["c"] = exportThankYouImage;
/* harmony export (immutable) */ __webpack_exports__["b"] = drawThankYouImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__ = __webpack_require__("./src/helpers/canvas.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__background_purple_svg__ = __webpack_require__("./src/helpers/images/thankYouImage/background-purple.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__background_purple_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__background_purple_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_orange_svg__ = __webpack_require__("./src/helpers/images/thankYouImage/background-orange.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__background_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__background_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__background_green_svg__ = __webpack_require__("./src/helpers/images/thankYouImage/background-green.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__background_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__background_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_blue_svg__ = __webpack_require__("./src/helpers/images/thankYouImage/background-blue.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__background_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__background_blue_svg__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var ASPECT_RATIO = 1200 / 630;
var presets = {
    purple: { backgroundImage: __WEBPACK_IMPORTED_MODULE_2__background_purple_svg___default.a },
    orange: { backgroundImage: __WEBPACK_IMPORTED_MODULE_3__background_orange_svg___default.a },
    green: { backgroundImage: __WEBPACK_IMPORTED_MODULE_4__background_green_svg___default.a },
    blue: { backgroundImage: __WEBPACK_IMPORTED_MODULE_5__background_blue_svg___default.a },
};
var width = 1200;
var height = 630;
var boxMargin = 50;
var boxPadding = 20;
var fontSize = 56;
var lineHeight = 60;
function getThankYouImageDescriptor(_a, measureText) {
    var text = _a.text, placeholder = _a.placeholder, caretOffset = _a.caretOffset, drawInputBox = _a.drawInputBox;
    var boxWidth = width - boxMargin * 2;
    var lineMaxWidth = boxWidth - boxPadding * 2;
    var lines = buildLines(text || '', lineMaxWidth, measureText);
    var placeholderLines = !text
        ? buildLines(placeholder || '', lineMaxWidth, measureText)
        : undefined;
    var boxHeight = lineHeight * lines.length + boxPadding * 2;
    var boxOffsetTop = height / 2 - boxHeight / 2 - 40;
    var inputBoxRect = {
        x: boxMargin,
        y: boxOffsetTop,
        width: boxWidth,
        height: boxHeight,
    };
    var textRect = {
        x: boxMargin + boxPadding,
        y: boxOffsetTop + boxPadding,
        width: lineMaxWidth,
        height: boxHeight - boxPadding * 2,
    };
    var lineDescriptors = getLineDescriptors(lines, textRect, measureText);
    var placeholderLineDescriptors = placeholderLines
        ? getLineDescriptors(placeholderLines, textRect, measureText)
        : undefined;
    var caretPosition = typeof caretOffset !== 'undefined'
        ? getCaretPosition(caretOffset, lines, textRect, measureText)
        : undefined;
    return {
        lines: lineDescriptors,
        placeholderLines: placeholderLineDescriptors,
        inputBoxRect: drawInputBox ? inputBoxRect : undefined,
        textRect: textRect,
        caretPosition: caretPosition,
    };
}
function exportThankYouImage(options) {
    return __awaiter(this, void 0, Promise, function () {
        var canvas, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canvas = document.createElement('canvas');
                    canvas.width = options.width;
                    canvas.height = options.height;
                    ctx = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__["b" /* get2dContext */])(canvas);
                    return [4 /*yield*/, drawThankYouImage(__assign({ ctx: ctx }, options))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_image__["f" /* getImageFromCanvas */])(canvas, 'image/png')];
            }
        });
    });
}
function drawThankYouImage(options) {
    return __awaiter(this, void 0, void 0, function () {
        var ctx, canvasWidth, canvasHeight, preset, backgroundImagePath, tasks, backgroundImage, measureText, imageDescriptor;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx = options.ctx, canvasWidth = options.width, canvasHeight = options.height, preset = options.preset;
                    backgroundImagePath = presets[preset].backgroundImage;
                    tasks = [
                        Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__["c" /* loadImage */])(backgroundImagePath),
                        Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_canvas__["e" /* waitForFont */])('Montserrat').catch(function () { }),
                    ];
                    return [4 /*yield*/, Promise.all(tasks)];
                case 1:
                    backgroundImage = (_a.sent())[0];
                    ctx.save();
                    try {
                        ctx.scale(canvasWidth / width, canvasHeight / height);
                        ctx.font = fontSize + "px Montserrat, Roboto-Regular, Roboto, Arial, sans-serif";
                        measureText = function (t) {
                            return ctx.measureText(t).width;
                        };
                        imageDescriptor = getThankYouImageDescriptor(options, measureText);
                        drawBackground(ctx, { width: width, height: height }, backgroundImage);
                        if (imageDescriptor.inputBoxRect) {
                            drawBox(ctx, imageDescriptor.inputBoxRect);
                        }
                        if (imageDescriptor.placeholderLines) {
                            drawLines(ctx, imageDescriptor.placeholderLines, 'rgba(255, 255, 255, 0.6)');
                        }
                        else {
                            drawLines(ctx, imageDescriptor.lines, '#fff');
                        }
                        if (typeof imageDescriptor.caretPosition !== 'undefined') {
                            drawCaret(ctx, imageDescriptor.caretPosition);
                        }
                    }
                    finally {
                        ctx.restore();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function buildLines(text, maxWidth, measureText) {
    var lines = [];
    var currentLineIndex = 0;
    for (var _i = 0, _a = text.split(' '); _i < _a.length; _i++) {
        var word = _a[_i];
        var line = typeof lines[currentLineIndex] !== 'undefined'
            ? lines[currentLineIndex] + ' ' + word
            : word;
        var lineWidth = measureText(line);
        if (lineWidth <= maxWidth) {
            lines[currentLineIndex] = line;
        }
        else {
            currentLineIndex++;
            lines.push(word);
        }
    }
    return lines;
}
function getLineDescriptors(lines, textRect, measureText) {
    var result = [];
    for (var i = 0; i < lines.length; i++) {
        var centerOffset = (textRect.width - measureText(lines[i])) / 2;
        var x = textRect.x + centerOffset;
        var y = textRect.y + lineHeight * i;
        result.push({
            text: lines[i],
            position: { x: x, y: y },
        });
    }
    return result;
}
function getCaretPosition(caretOffset, lines, textRect, measureText) {
    var caretCoords = getCaretCoords(lines, caretOffset);
    var line = lines[caretCoords.lineIndex];
    var lineWidth = measureText(line);
    var centerOffset = (textRect.width - lineWidth) / 2;
    var offset = measureText(line.substr(0, caretCoords.charOffset));
    var caretX = textRect.x + centerOffset + offset;
    var caretY = textRect.y + lineHeight * caretCoords.lineIndex;
    return { x: caretX, y: caretY };
}
function getCaretCoords(lines, caretPosition) {
    var totalLength = 0;
    var lineIndex = 0;
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        var lineLength = line.length + 1;
        if (totalLength + lineLength > caretPosition) {
            return {
                lineIndex: lineIndex,
                charOffset: caretPosition - totalLength,
            };
        }
        totalLength += lineLength;
        lineIndex++;
    }
    return {
        lineIndex: lines.length - 1,
        charOffset: totalLength - 1,
    };
}
function drawBackground(ctx, canvasSize, backgroundImage) {
    ctx.drawImage(backgroundImage, 0, 0, canvasSize.width, canvasSize.height);
}
function drawLines(ctx, lines, color) {
    ctx.fillStyle = color;
    ctx.textBaseline = 'middle';
    for (var _i = 0, lines_2 = lines; _i < lines_2.length; _i++) {
        var line = lines_2[_i];
        ctx.fillText(line.text, line.position.x, line.position.y + lineHeight / 2);
    }
}
function drawCaret(ctx, caretPosition) {
    ctx.fillStyle = '#8f2497';
    ctx.fillRect(caretPosition.x, caretPosition.y, 2, lineHeight);
}
function drawBox(ctx, rect) {
    ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
    ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
}


/***/ }),

/***/ "./src/helpers/loadable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var React = __webpack_require__("./node_modules/react/index.js");
var isWebpackBundle = __webpack_require__("./node_modules/is-webpack-bundle/index.js");
var webpackRequireWeak = __webpack_require__("./node_modules/webpack-require-weak/index.js");
var inspect = __webpack_require__("./node_modules/import-inspector/index.js").inspect;
function capture(fn) {
    var reported = [];
    var stopInspecting = inspect(function (metadata) { return reported.push(metadata); });
    var promise = fn();
    stopInspecting();
    return { promise: promise, reported: reported };
}
function load(loader) {
    var _a = capture(function () {
        return loader();
    }), promise = _a.promise, reported = _a.reported;
    if (reported.length > 1) {
        throw new Error('react-loadable cannot handle more than one import() in each loader');
    }
    var state = {
        loading: true,
        loaded: null,
        error: null,
    };
    var metadata = reported[0] || {};
    try {
        if (isWebpackBundle) {
            if (typeof metadata.webpackRequireWeakId === 'function') {
                state.loading = false;
                state.loaded = webpackRequireWeak(metadata.webpackRequireWeakId());
            }
        }
        else {
            if (typeof metadata.serverSideRequirePath === 'string') {
                state.loading = false;
                state.loaded = module.require(metadata.serverSideRequirePath);
            }
        }
    }
    catch (err) {
        state.error = err;
    }
    state.promise = promise
        .then(function (loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    })
        .catch(function (err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null,
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function (key) {
            var result = load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            }
            else {
                state.loading = true;
            }
            promises.push(result.promise);
            result.promise
                .then(function (res) {
                state.loaded[key] = res;
            })
                .catch(function (err) {
                state.error = err;
            });
        });
    }
    catch (err) {
        error = err;
    }
    state.promise = Promise.all(promises)
        .then(function (res) {
        state.loading = false;
        return res;
    })
        .catch(function (err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function render(loaded, props) {
    return React.createElement(resolve(loaded), props);
}
function createLoadableComponent(loadFn, options) {
    if (!options.loading) {
        throw new Error('react-loadable requires a `loading` component');
    }
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: render,
    }, options);
    var res = null;
    return /** @class */ (function (_super) {
        __extends(LoadableComponent, _super);
        function LoadableComponent(props) {
            var _this = _super.call(this, props) || this;
            // JG-specific: disable caching on server, so imports
            // get reported for use with flushChunks in the renderer.
            if (false || !res) {
                res = loadFn(opts.loader);
            }
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded,
            };
            return _this;
        }
        LoadableComponent.preload = function () {
            if (!res) {
                res = loadFn(opts.loader);
            }
        };
        LoadableComponent.prototype.componentWillMount = function () {
            var _this = this;
            this._mounted = true;
            if (res.loaded) {
                return;
            }
            if (typeof opts.delay === 'number') {
                this._delay = setTimeout(function () {
                    _this.setState({ pastDelay: true });
                }, opts.delay);
            }
            if (typeof opts.timeout === 'number') {
                this._timeout = setTimeout(function () {
                    _this.setState({ timedOut: true });
                }, opts.timeout);
            }
            var update = function () {
                if (!_this._mounted) {
                    return;
                }
                _this.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading,
                });
                _this._clearTimeouts();
            };
            res.promise
                .then(function () {
                update();
            })
                .catch(function (err) {
                update();
                throw err;
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function () {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function () {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function () {
            if (this.state.loading || this.state.error) {
                return React.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                });
            }
            else if (this.state.loaded) {
                return opts.render(this.state.loaded, this.props);
            }
            else {
                return null;
            }
        };
        return LoadableComponent;
    }(React.Component));
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function LoadableMap(opts) {
    if (typeof opts.render !== 'function') {
        throw new Error('LoadableMap requires a `render(loaded, props)` function');
    }
    return createLoadableComponent(loadMap, opts);
}
Loadable.Map = LoadableMap;
// JG-specific: use ES6 syntax
/* harmony default export */ __webpack_exports__["a"] = (Loadable);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./src/helpers/loadableWithFetchData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadableWithFetchData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_LoadingOverlay__ = __webpack_require__("./src/components/LoadingOverlay/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loadable__ = __webpack_require__("./src/helpers/loadable.js");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function loadableWithFetchData(loader) {
    var _this = this;
    var LoadableComponent = Object(__WEBPACK_IMPORTED_MODULE_2__loadable__["a" /* default */])({
        loading: function () { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_LoadingOverlay__["a" /* default */], null); },
        loader: loader,
    });
    LoadableComponent.fetchData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var component, fetchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loader()];
                    case 1:
                        component = _a.sent();
                        fetchData = component.default
                            ? component.default.fetchData
                            : component.fetchData;
                        if (!fetchData) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetchData.apply(void 0, args)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return LoadableComponent;
}


/***/ }),

/***/ "./src/helpers/math.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return round; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return floor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatePercentage; });
var round = function (num, decimalPlaces) {
    return Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
};
var floor = function (num, decimalPlaces) {
    return Math.floor(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
};
var calculatePercentage = function (value, total) {
    return Math.floor((value / total) * 100);
};


/***/ }),

/***/ "./src/helpers/media.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMediaSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_youTubeParser__ = __webpack_require__("./src/helpers/youTubeParser.ts");

function getMediaSource(media) {
    if (media && media.type === 1) {
        return media.path;
    }
    if (media && media.type === 2) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_youTubeParser__["a" /* constructYouTubeThumbnailUrl */])(media.path);
    }
    return null;
}


/***/ }),

/***/ "./src/helpers/page.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isActive;
/* harmony export (immutable) */ __webpack_exports__["a"] = canPageReceiveDonations;
/* harmony export (immutable) */ __webpack_exports__["d"] = isClosed;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEligibleForFlexiblePayments;
/* harmony export (immutable) */ __webpack_exports__["b"] = canPostUpdates;
/* harmony export (immutable) */ __webpack_exports__["f"] = isPendingApproval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc__ = __webpack_require__("./node_modules/date-fns/compare_asc/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc__);

function isActive(page) {
    return [
        'Active',
        'TargetNotReached',
        'FullyFunded',
        'ReportGenerated',
        'Suspended',
        'Stranded',
    ].includes(page.status);
}
function canPageReceiveDonations(page) {
    var isPageActive = page.status === 'Active';
    if (page.finishedAt) {
        var hasFinished = __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default()(page.finishedAt, Date.now()) === -1;
        return isPageActive && !hasFinished;
    }
    return isPageActive;
}
function isClosed(page) {
    return ['FullyFunded', 'TargetNotReached', 'ReportGenerated'].includes(page.status);
}
function isEligibleForFlexiblePayments(page) {
    return page.fundsReleaseMode === 'OnDemand';
}
function canPostUpdates(page) {
    return (page.isOwnerRequested &&
        (page.status === 'Active' ||
            page.status === 'FullyFunded' ||
            page.status === 'Suspended'));
}
function isPendingApproval(page) {
    return page.status === 'PendingApproval';
}


/***/ }),

/***/ "./src/helpers/payment.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAccountConnected;
function isAccountConnected(page, paymentDetails) {
    if (page.stripeVirtualAccountGuid) {
        return (!!paymentDetails.accountNumber &&
            !!paymentDetails.sortCode &&
            paymentDetails.sortCode !== '00-00-00');
    }
    return (page.verificationStatus !== 'UnverifiedPayment' &&
        page.verificationStatus !== 'UnverifiedManual');
}


/***/ }),

/***/ "./src/helpers/prompts/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__ = __webpack_require__("./src/components/Prompt/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_rulesEngine__ = __webpack_require__("./src/helpers/rulesEngine.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Helpers__ = __webpack_require__("./src/components/Helpers/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Transitions__ = __webpack_require__("./src/components/Transitions/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);






// TODO clean when POO feature flag will be removed
var ownerPrompts = __WEBPACK_IMPORTED_MODULE_5_config___default.a
    .FEATURE.PAGE_OWNER_ADMIN
    ? [__WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["s" /* PageStrandedPageOwner */]]
    : [
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["g" /* DonationsRefunded */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["f" /* DocumentsManualVerification */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["d" /* BankDetailsVerified */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["e" /* CountdownToRefunding */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["a" /* ActivateYourPage */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["q" /* PageLive */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["v" /* ShareWithFriends */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["u" /* SayThanks */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["t" /* RecurringDonationsPrompt */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["j" /* PageClosedFullyFundedOwner */],
        __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["l" /* PageClosedTargetNotReachedOwner */],
    ];
var supporterPrompts = [
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["m" /* PageClosedTargetNotReachedSupporter */],
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["k" /* PageClosedFullyFundedSupporter */],
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["h" /* DonationsRefundedSupporter */],
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["p" /* PageFrozenSupporter */],
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["i" /* GiveFeedback */],
    __WEBPACK_IMPORTED_MODULE_0_src_components_Prompt__["r" /* PageStranded */],
];
var promptRulesEngine = function (appState, isOwner, _a) {
    var pageSection = _a.pageSection, dispatch = _a.dispatch, promptTransitionActive = _a.promptTransitionActive, activatePromptTransition = _a.activatePromptTransition, closePrompt = _a.closePrompt;
    try {
        var prompt = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_rulesEngine__["b" /* rulesEngine */])(isOwner ? ownerPrompts.slice() : supporterPrompts.slice(), appState, {
            pageSection: pageSection,
            dispatch: dispatch,
            promptTransitionActive: promptTransitionActive,
            activatePromptTransition: activatePromptTransition,
            closePrompt: closePrompt,
        });
        if (prompt.matched && prompt.result) {
            var style = {
                position: 'absolute',
                width: '100%',
                zIndex: promptTransitionActive ? 0 : -1,
            };
            // hack: without the wrapping section React 16.0.0 tries to merge the transition divs, breaking the layout
            return (__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Helpers__["a" /* MeasureSize */], { style: style, onMeasure: activatePromptTransition },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Transitions__["a" /* RevealTransition */], { active: promptTransitionActive, delay: "0.5s", duration: "1s" }, prompt.result)));
        }
        return null;
    }
    catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (promptRulesEngine);


/***/ }),

/***/ "./src/helpers/pushNotifications.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arePushNotificationsSupported;
/* harmony export (immutable) */ __webpack_exports__["e"] = subscribe;
/* harmony export (immutable) */ __webpack_exports__["f"] = unsubscribe;
/* harmony export (immutable) */ __webpack_exports__["d"] = isPageSubscribed;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSubscription;
/* harmony export (immutable) */ __webpack_exports__["b"] = askPermission;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pushNotifications__ = __webpack_require__("./src/helpers/api/pushNotifications.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


function arePushNotificationsSupported() {
    return  false
        ? false
        : 'serviceWorker' in navigator &&
            'PushManager' in window &&
            navigator.userAgent.match(/Chrome/i) &&
            !navigator.userAgent.match(/Mobile/i);
}
function subscribe(userGuid, pageId) {
    return __awaiter(this, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getOrCreateSubscription(userGuid)];
                case 1:
                    id = (_a.sent()).id;
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pushNotifications__["a" /* addSubscriptionTopic */])({
                            subscriptionId: id,
                            topicName: "cf_" + pageId,
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function unsubscribe(userGuid, pageId) {
    return __awaiter(this, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getOrCreateSubscription(userGuid)];
                case 1:
                    id = (_a.sent()).id;
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pushNotifications__["c" /* deleteSubscriptionTopic */])({
                            subscriptionId: id,
                            topicName: "cf_" + pageId,
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function isPageSubscribed(userGuid, pageId) {
    return __awaiter(this, void 0, void 0, function () {
        var id, topics, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, getOrCreateSubscription(userGuid)];
                case 1:
                    id = (_a.sent()).id;
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pushNotifications__["d" /* getSubscriptionTopics */])(id)];
                case 2:
                    topics = _a.sent();
                    return [2 /*return*/, topics.map(function (topic) { return topic.name; }).includes("cf_" + pageId)];
                case 3: return [2 /*return*/, false];
                case 4:
                    e_1 = _a.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getOrCreateSubscription(userGuid) {
    return __awaiter(this, void 0, void 0, function () {
        var registration, subscribeOptions, subscription, _a, keys, endpoint;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, navigator.serviceWorker.ready];
                case 1:
                    registration = _b.sent();
                    subscribeOptions = {
                        userVisibleOnly: true,
                        applicationServerKey: urlB64ToUint8Array(__WEBPACK_IMPORTED_MODULE_1_config__["PUSH_NOTIFICATIONS_SERVER_KEY"]),
                    };
                    return [4 /*yield*/, registration.pushManager.subscribe(subscribeOptions)];
                case 2:
                    subscription = _b.sent();
                    _a = subscription.toJSON(), keys = _a.keys, endpoint = _a.endpoint;
                    if (!keys) {
                        throw new Error('subscriptionData.keys is not set');
                    }
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pushNotifications__["b" /* createNotificationsSubscription */])({
                            endpoint: endpoint,
                            pushKey: keys.p256dh,
                            authKey: keys.auth,
                            userGuid: userGuid,
                        })];
            }
        });
    });
}
function getSubscription() {
    return __awaiter(this, void 0, void 0, function () {
        var registration, subscription;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.serviceWorker.ready];
                case 1:
                    registration = _a.sent();
                    return [4 /*yield*/, registration.pushManager.getSubscription()];
                case 2:
                    subscription = _a.sent();
                    return [2 /*return*/, subscription];
            }
        });
    });
}
function urlB64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
function askPermission() {
    return new Promise(function (resolve, reject) {
        var permissionResult = Notification.requestPermission(resolve);
        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    });
}


/***/ }),

/***/ "./src/helpers/renderRoutes.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_Redirect__ = __webpack_require__("./src/helpers/Redirect.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



function isRedirect(route) {
    return !!route.redirectTo;
}
var renderRoute = function (i, route, componentProps) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { key: i, path: route.path, exact: route.exact, strict: route.strict, render: function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component, __assign({}, componentProps, props, { route: route }))); } })); };
var renderRedirect = function (i, _a) {
    var path = _a.path, redirectTo = _a.redirectTo;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_helpers_Redirect__["a" /* default */], { key: i, from: path, to: redirectTo }));
};
var renderRoutes = function (routes, componentProps) {
    if (componentProps === void 0) { componentProps = {}; }
    return routes ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Switch */], null, routes.map(function (route, i) {
        return isRedirect(route)
            ? renderRedirect(i, route)
            : renderRoute(i, route, componentProps);
    }))) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (renderRoutes);


/***/ }),

/***/ "./src/helpers/richEditor.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertProblemToRichStory;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertRichStoryToProblem;
/* harmony export (immutable) */ __webpack_exports__["d"] = transformState;
/* harmony export (immutable) */ __webpack_exports__["e"] = transformStateToSave;
/* unused harmony export uploadMediaAndTransformToSave */
/* harmony export (immutable) */ __webpack_exports__["c"] = transformRichStoryToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_images__ = __webpack_require__("./src/helpers/api/images.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten__ = __webpack_require__("./node_modules/lodash/flatten.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_flatten__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function convertProblemToRichStory(problem) {
    if (problem === '') {
        return [];
    }
    return problem.split(/\n{2,}/).map(function (item) {
        return {
            type: 'paragraph',
            nodes: [{ type: 'text', ranges: [{ text: item }] }],
        };
    });
}
function convertRichStoryToProblem(richStory) {
    if (!richStory) {
        return '';
    }
    return richStory
        .reduce(function (p, node) {
        switch (node.type) {
            case 'header':
            case 'quote':
                return p + node.text + '\n\n';
            case 'paragraph':
                return (p +
                    node.nodes.map(function (n) { return n.ranges.map(function (r) { return r.text; }).join(''); }).join('') +
                    '\n\n');
            default:
                return p;
        }
    }, '')
        .trim();
}
function transformState(state) {
    var transformedState = [];
    transformedState = state.document.nodes.map(function (node) {
        var type = node.type;
        switch (type) {
            case 'header':
                return transformHeaderNodeToSave(node);
            case 'paragraph':
                return transformParagraphNodeToSave(node);
            case 'quote':
                return transformQuoteNodeToSave(node);
            case 'image':
                return transformImageNodeToSave(node);
            case 'video':
                return transformVideoNodeToSave(node);
            default:
                throw new Error("Unsupported node type " + type + ".");
        }
    });
    return transformedState;
}
function transformStateToSave(state) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, uploadMediaAndTransformToSave(transformState(state))];
        });
    });
}
function uploadMediaAndTransformToSave(transformedState) {
    return __awaiter(this, void 0, void 0, function () {
        var uploadedImages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, processImages(transformedState)];
                case 1:
                    uploadedImages = _a.sent();
                    transformedState = transformedState.map(function (node) {
                        if (node.type === 'image') {
                            var name = uploadedImages.get(node.src);
                            return { type: 'image', name: name };
                        }
                        return node;
                    });
                    return [2 /*return*/, transformedState];
            }
        });
    });
}
function transformHeaderNodeToSave(node) {
    var firstRange = getFirstChildNodeFirstRange(node);
    if (firstRange) {
        return {
            type: 'header',
            text: firstRange.text,
        };
    }
    return {};
}
function transformParagraphNodeToSave(node) {
    if (node.nodes) {
        var childNodes = node.nodes.map(function (child) {
            switch (child.kind) {
                case 'text':
                    if (child.ranges) {
                        var childRanges = child.ranges.map(function (textRange) {
                            return { text: textRange.text };
                        });
                        return {
                            type: 'text',
                            ranges: childRanges,
                        };
                    }
                case 'inline':
                    if (child.type === 'link') {
                        var link = child;
                        if (!link.nodes || !link.data) {
                            return {};
                        }
                        var linkNodes = link.nodes.map(function (linkNode) {
                            if (linkNode.ranges) {
                                return linkNode.ranges.map(function (linkRange) {
                                    return {
                                        text: linkRange.text,
                                    };
                                });
                            }
                            return {};
                        });
                        return {
                            type: 'link',
                            url: link.data.href,
                            ranges: __WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default()(linkNodes),
                        };
                    }
                default:
                    throw new Error("Unsupported child node kind " + child.kind + ".");
            }
        });
        return {
            type: 'paragraph',
            nodes: childNodes,
        };
    }
    return {};
}
function transformQuoteNodeToSave(node) {
    var firstRange = getFirstChildNodeFirstRange(node);
    if (firstRange) {
        return {
            type: 'quote',
            text: firstRange.text,
        };
    }
    return {};
}
function transformImageNodeToSave(node) {
    if (node.data) {
        if (node.data.src.startsWith('http')) {
            var lastSlash = node.data.src.lastIndexOf('/') + 1;
            var imgName = node.data.src.slice(lastSlash, node.data.src.length);
            return {
                type: 'image',
                src: imgName,
            };
        }
        return {
            type: 'image',
            src: node.data.src,
            pic: node.data.pic,
        };
    }
    return {};
}
function transformVideoNodeToSave(node) {
    if (node.data) {
        if (typeof node.data.href === 'undefined') {
            return {
                type: 'paragraph',
                nodes: [],
            };
        }
        else {
            return {
                type: 'video',
                url: node.data.href,
            };
        }
    }
    return {};
}
// Save richStory helpers
function getFirstChildNodeFirstRange(node) {
    if (node.nodes && node.nodes[0]) {
        var firstNode = node.nodes[0];
        if (firstNode.ranges) {
            return firstNode.ranges[0];
        }
    }
    return undefined;
}
function processImages(state) {
    return __awaiter(this, void 0, void 0, function () {
        var promises, processedImages, _a;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    promises = state
                        .filter(function (x) { return x.type === 'image'; })
                        .map(function (listing) { return __awaiter(_this, void 0, void 0, function () {
                        var uploadedImage;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!listing.pic) return [3 /*break*/, 2];
                                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_images__["b" /* uploadImage */])(listing.pic)];
                                case 1:
                                    uploadedImage = _a.sent();
                                    if (!uploadedImage.success) {
                                        throw new Error(uploadedImage.message);
                                    }
                                    return [2 /*return*/, [listing.src, uploadedImage.data.imageName]];
                                case 2: return [2 /*return*/, [listing.src, listing.src]];
                            }
                        });
                    }); });
                    _a = Map.bind;
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    processedImages = new (_a.apply(Map, [void 0, _b.sent()]))();
                    return [2 /*return*/, processedImages];
            }
        });
    });
}
function transformRichStoryToEdit(richStory) {
    var editorNodes;
    editorNodes = richStory.map(function (savedNode) {
        switch (savedNode.type) {
            case 'header':
                return transformHeaderToEdit(savedNode);
            case 'quote':
                return transformQuoteToEdit(savedNode);
            case 'image':
                return transformImageToEdit(savedNode);
            case 'video':
                return tranformVideoToEdit(savedNode);
            case 'paragraph':
                return transformParagraphToEdit(savedNode);
            default:
                return {};
        }
    });
    return editorNodes;
}
function transformHeaderToEdit(savedNode) {
    return {
        data: {},
        kind: 'block',
        isVoid: false,
        type: savedNode.type,
        nodes: [
            {
                kind: 'text',
                ranges: [
                    {
                        kind: 'range',
                        text: savedNode.text,
                        marks: [],
                    },
                ],
            },
        ],
    };
}
function transformQuoteToEdit(savedNode) {
    return {
        data: {},
        kind: 'block',
        isVoid: false,
        type: savedNode.type,
        nodes: [
            {
                kind: 'text',
                ranges: [
                    {
                        kind: 'range',
                        text: savedNode.text,
                        marks: [],
                    },
                ],
            },
        ],
    };
}
function transformImageToEdit(savedNode) {
    return {
        data: {
            src: __WEBPACK_IMPORTED_MODULE_1_config___default.a.IMAGE_BASE_URI + "/" + savedNode.name,
        },
        kind: 'block',
        isVoid: true,
        type: savedNode.type,
        nodes: [
            {
                kind: 'text',
                ranges: [
                    {
                        kind: 'range',
                        text: ' ',
                        marks: [],
                    },
                ],
            },
        ],
    };
}
function tranformVideoToEdit(savedNode) {
    return {
        data: {
            href: savedNode.url,
        },
        kind: 'block',
        isVoid: true,
        type: savedNode.type,
        nodes: [
            {
                kind: 'text',
                ranges: [
                    {
                        kind: 'range',
                        text: ' ',
                        marks: [],
                    },
                ],
            },
        ],
    };
}
function transformParagraphToEdit(savedNode) {
    var childNodes = savedNode.nodes.map(function (child) {
        if (child.url) {
            var linkRanges = child.ranges.map(function (linkRange) {
                return {
                    kind: 'text',
                    ranges: [
                        {
                            kind: 'range',
                            text: linkRange.text,
                            marks: [],
                        },
                    ],
                };
            });
            return {
                data: {
                    href: child.url,
                },
                kind: 'inline',
                isVoid: false,
                type: child.type,
                nodes: linkRanges,
            };
        }
        var ranges = child.ranges.map(function (range) {
            return {
                kind: 'range',
                text: range.text,
                marks: [],
            };
        });
        return {
            kind: 'text',
            ranges: ranges,
        };
    });
    return {
        data: {},
        kind: 'block',
        isVoid: false,
        type: savedNode.type,
        nodes: childNodes,
    };
}


/***/ }),

/***/ "./src/helpers/rulesEngine.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncRulesEngine;
/* harmony export (immutable) */ __webpack_exports__["b"] = rulesEngine;
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function asyncRulesEngine(rules, state, options) {
    return __awaiter(this, void 0, Promise, function () {
        var _i, rules_1, rule, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, rules_1 = rules;
                    _a.label = 1;
                case 1:
                    if (!(_i < rules_1.length)) return [3 /*break*/, 6];
                    rule = rules_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, rule(state, options)];
                case 3:
                    result = _a.sent();
                    if (result.matched) {
                        return [2 /*return*/, result];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: throw new Error('No rules matched.');
            }
        });
    });
}
function rulesEngine(rules, state, options) {
    for (var _i = 0, rules_2 = rules; _i < rules_2.length; _i++) {
        var rule = rules_2[_i];
        try {
            var result = rule(state, options);
            if (result.matched) {
                return result;
            }
        }
        catch (e) { }
    }
    throw new Error('No rules matched.');
}


/***/ }),

/***/ "./src/helpers/scriptLoader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startLoadingScripts */
/* unused harmony export isDefined */
/* unused harmony export isFunction */
/* unused harmony export noop */
/* unused harmony export newScript */
/* unused harmony export parallel */
/* unused harmony export series */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* tslint:disable */
// Picked up from master branch of https://github.com/leozdgao/react-async-script-loader
// which seems to be no longer maintained and haven't released one of the fixes
// we need that was merged a long time ago.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var loadedScript = [];
var pendingScripts = {};
var failedScript = [];
function startLoadingScripts(scripts, onComplete) {
    if (onComplete === void 0) { onComplete = noop; }
    // sequence load
    var loadNewScript = function (src) {
        if (loadedScript.indexOf(src) < 0) {
            return function (taskComplete) {
                var callbacks = pendingScripts[src] || [];
                callbacks.push(taskComplete);
                pendingScripts[src] = callbacks;
                if (callbacks.length === 1) {
                    return newScript(src)(function (err) {
                        pendingScripts[src].forEach(function (cb) { return cb(err, src); });
                        delete pendingScripts[src];
                    });
                }
            };
        }
    };
    var tasks = scripts.map(function (src) {
        if (Array.isArray(src)) {
            return src.map(loadNewScript);
        }
        else
            return loadNewScript(src);
    });
    series.apply(void 0, tasks)(function (err, src) {
        if (err) {
            failedScript.push(src);
        }
        else {
            if (Array.isArray(src)) {
                src.forEach(addCache);
            }
            else
                addCache(src);
        }
    })(function (err) {
        removeFailedScript();
        onComplete(err);
    });
}
var addCache = function (entry) {
    if (loadedScript.indexOf(entry) < 0) {
        loadedScript.push(entry);
    }
};
var removeFailedScript = function () {
    if (failedScript.length > 0) {
        failedScript.forEach(function (script) {
            var node = document.querySelector("script[src='" + script + "']");
            if (node != null) {
                node.parentNode.removeChild(node);
            }
        });
        failedScript = [];
    }
};
var scriptLoader = function () {
    var scripts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        scripts[_i] = arguments[_i];
    }
    return function (WrappedComponent) {
        var ScriptLoader = /** @class */ (function (_super) {
            __extends(ScriptLoader, _super);
            function ScriptLoader(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.state = {
                    isScriptLoaded: false,
                    isScriptLoadSucceed: false,
                };
                _this._isMounted = false;
                return _this;
            }
            ScriptLoader.prototype.componentDidMount = function () {
                var _this = this;
                this._isMounted = true;
                startLoadingScripts(scripts, function (err) {
                    if (_this._isMounted) {
                        _this.setState({
                            isScriptLoaded: true,
                            isScriptLoadSucceed: !err,
                        }, function () {
                            if (!err) {
                                _this.props.onScriptLoaded();
                            }
                        });
                    }
                });
            };
            ScriptLoader.prototype.componentWillUnmount = function () {
                this._isMounted = false;
            };
            ScriptLoader.prototype.render = function () {
                var props = __assign({}, this.props, this.state);
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, __assign({}, props));
            };
            ScriptLoader.propTypes = {
                onScriptLoaded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
            };
            ScriptLoader.defaultProps = {
                onScriptLoaded: noop,
            };
            return ScriptLoader;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
        return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ScriptLoader, WrappedComponent);
    };
};
var isDefined = function (val) { return val != null; };
var isFunction = function (val) { return typeof val === 'function'; };
var noop = function (_) { };
var newScript = function (src) { return function (cb) {
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () { return cb(null, src); });
    script.addEventListener('error', function () { return cb(true, src); });
    document.body.appendChild(script);
    return script;
}; };
var keyIterator = function (cols) {
    var keys = Object.keys(cols);
    var i = -1;
    return {
        next: function () {
            i++; // inc
            if (i >= keys.length)
                return null;
            else
                return keys[i];
        },
    };
};
// tasks should be a collection of thunk
var parallel = function () {
    var tasks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        tasks[_i] = arguments[_i];
    }
    return function (each) { return function (cb) {
        var hasError = false;
        var successed = 0;
        var ret = [];
        tasks = tasks.filter(isFunction);
        if (tasks.length <= 0)
            cb(null);
        else {
            tasks.forEach(function (task, i) {
                var thunk = task;
                thunk(function (err) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    if (err)
                        hasError = true;
                    else {
                        // collect result
                        if (args.length <= 1)
                            args = args[0];
                        ret[i] = args;
                        successed++;
                    }
                    if (isFunction(each))
                        each.call(null, err, args, i);
                    if (hasError)
                        cb(true);
                    else if (tasks.length === successed) {
                        cb(null, ret);
                    }
                });
            });
        }
    }; };
};
// tasks should be a collection of thunk
var series = function () {
    var tasks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        tasks[_i] = arguments[_i];
    }
    return function (each) { return function (cb) {
        tasks = tasks.filter(function (val) { return val != null; });
        var nextKey = keyIterator(tasks);
        var nextThunk = function () {
            var key = nextKey.next();
            var thunk = tasks[key];
            if (Array.isArray(thunk))
                thunk = parallel.apply(null, thunk).call(null, each);
            return [+key, thunk]; // convert `key` to number
        };
        var key, thunk;
        var next = nextThunk();
        key = next[0];
        thunk = next[1];
        if (thunk == null)
            return cb(null);
        var ret = [];
        var iterator = function () {
            thunk(function (err) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (args.length <= 1)
                    args = args[0];
                if (isFunction(each))
                    each.call(null, err, args, key);
                if (err)
                    cb(err);
                else {
                    // collect result
                    ret.push(args);
                    next = nextThunk();
                    key = next[0];
                    thunk = next[1];
                    if (thunk == null)
                        return cb(null, ret);
                    // finished
                    else
                        iterator();
                }
            });
        };
        iterator();
    }; };
};
/* harmony default export */ __webpack_exports__["a"] = (scriptLoader);


/***/ }),

/***/ "./src/helpers/stats.js":
/***/ (function(module, exports, __webpack_require__) {

if (false) {
    var config = require('../../config/server.config');
    var statsd_1;
    if (config.stats) {
        var Client = require('statsd-client');
        statsd_1 = new Client({
            host: config.statsHost,
            port: config.statsPort,
            prefix: 'jg.crowdfunding.website',
        });
    }
    var Histogram = require('prom-client').Histogram;
    var timingHistogram_1 = new Histogram({
        name: 'app_timing',
        help: "App timing in ms",
        buckets: [1, 5, 15, 50, 100, 200, 300, 400, 500, 1000, 2500, 5000, 10000],
        labelNames: ['timing_category', 'timing_name'],
    });
    module.exports = {
        timing: function (name, value) {
            if (statsd_1) {
                statsd_1.timing(name, value);
            }
            var _a = name.split('.'), timingCategory = _a[0], timingName = _a[1];
            timingHistogram_1.observe({ timing_category: timingCategory, timing_name: timingName }, value);
        },
    };
}
else if (true) {
    var thrower = function () {
        throw new Error('Not supported on the client.');
    };
    module.exports = generateCompatibleObject(thrower);
}
else {
    // for tests
    module.exports = generateCompatibleObject(function () { });
}
function generateCompatibleObject(method) {
    return {
        timing: method,
    };
}


/***/ }),

/***/ "./src/helpers/string.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeNewLines;
/* unused harmony export removeNullCharacters */
function removeNewLines(text) {
    return text
        .replace(/(\r\n|\n|\r)/gm, ' ')
        .replace(/\s\s+/g, ' ')
        .trim();
}
function removeNullCharacters(text) {
    return text.replace(/\0/g, '');
}


/***/ }),

/***/ "./src/helpers/stripe.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryAddressFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countryCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return stripeVirtualAccountRequiredFieldsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stripeVirtualAccountRequiredFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_ConfirmIdentityForm_GBAddress__ = __webpack_require__("./src/components/ConfirmIdentityForm/GBAddress/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_ConfirmIdentityForm_AUAddress__ = __webpack_require__("./src/components/ConfirmIdentityForm/AUAddress/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_containers_forms_PersonalIdNumberContainer__ = __webpack_require__("./src/containers/forms/PersonalIdNumberContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_containers_forms_SSNLastFourContainer__ = __webpack_require__("./src/containers/forms/SSNLastFourContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_containers_forms_StripeVerificationDocumentContainer__ = __webpack_require__("./src/containers/forms/StripeVerificationDocumentContainer.tsx");





var countryAddressFields = {
    GB: __WEBPACK_IMPORTED_MODULE_0_src_components_ConfirmIdentityForm_GBAddress__["a" /* GBAddress */],
    AU: __WEBPACK_IMPORTED_MODULE_1_src_components_ConfirmIdentityForm_AUAddress__["a" /* AUAddress */],
};
var countryCodes = {
    GB: 'United Kingdom',
    US: 'United States',
    AU: 'Australia',
};
var stripeVirtualAccountRequiredFieldsMap = {
    'legal_entity.ssn_last_4': __WEBPACK_IMPORTED_MODULE_3_src_containers_forms_SSNLastFourContainer__["a" /* default */],
    'legal_entity.personal_id_number': __WEBPACK_IMPORTED_MODULE_2_src_containers_forms_PersonalIdNumberContainer__["a" /* default */],
    'legal_entity.verification.document': __WEBPACK_IMPORTED_MODULE_4_src_containers_forms_StripeVerificationDocumentContainer__["a" /* default */],
};
var stripeVirtualAccountRequiredFields = Object.keys(stripeVirtualAccountRequiredFieldsMap).map(function (requiredField) { return requiredField; });


/***/ }),

/***/ "./src/helpers/time.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getTimestamp */
/* unused harmony export createTimer */
function getTimestamp() {
    return Date.now();
}
function createTimer() {
    var startTime = process.hrtime();
    return function () { return convertToMs(process.hrtime(startTime)); };
}
function convertToMs(hrtime) {
    return +(hrtime[0] * 1e3 + hrtime[1] * 1e-6).toFixed(3);
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./src/helpers/url.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildUrl;
/* unused harmony export buildUrlWithHash */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeProtocol; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getQueryFromUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = gotoUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__("./node_modules/url/url.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);


function buildUrl(baseUrl, queryStringParams) {
    return baseUrl + "?" + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(queryStringParams);
}
function buildUrlWithHash(baseUrl, id, queryStringParams) {
    return baseUrl + "?" + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(queryStringParams) + "#" + id;
}
var removeProtocol = function (url) { return url.replace(/^https?:\/\//, ''); };
function getQueryFromUrl(path) {
    var url = __WEBPACK_IMPORTED_MODULE_1_url___default.a.parse(path, true);
    return url.query;
}
function gotoUrl(url) {
    window.location.assign(url);
}


/***/ }),

/***/ "./src/helpers/validation/ValidationResult.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Result = function (_a) {
    var touched = _a.touched, error = _a.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, touched &&
        error &&
        error.trim().length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { role: "alert", className: "jg-form-error-copy" }, error))));
};
/* harmony default export */ __webpack_exports__["a"] = (Result);


/***/ }),

/***/ "./src/helpers/validation/createValidator.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createValidator;
/* unused harmony export createValidatorWithTranslations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate__ = __webpack_require__("./src/helpers/validation/validate.ts");

function createValidator(rules) {
    return function (values) { return Object(__WEBPACK_IMPORTED_MODULE_0__validate__["a" /* default */])(rules, values); };
}
function createValidatorWithTranslations(rules) {
    return function (values, props) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__validate__["a" /* default */])(rules(props.t), values);
    };
}


/***/ }),

/***/ "./src/helpers/validation/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValidator__ = __webpack_require__("./src/helpers/validation/createValidator.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createValidator__["a"]; });
/* unused harmony reexport createValidatorWithTranslations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__("./src/helpers/validation/validate.ts");
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationResult__ = __webpack_require__("./src/helpers/validation/ValidationResult.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ValidationResult__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules__ = __webpack_require__("./src/helpers/validation/rules.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["c"]; });
/* unused harmony reexport minDate */
/* unused harmony reexport maxDate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["f"]; });
/* unused harmony reexport betweenDates */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__rules__["l"]; });






/***/ }),

/***/ "./src/helpers/validation/rules.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = required;
/* harmony export (immutable) */ __webpack_exports__["g"] = oneOfRequired;
/* harmony export (immutable) */ __webpack_exports__["d"] = minLength;
/* harmony export (immutable) */ __webpack_exports__["b"] = maxLength;
/* harmony export (immutable) */ __webpack_exports__["h"] = pattern;
/* harmony export (immutable) */ __webpack_exports__["e"] = minNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = maxNumber;
/* unused harmony export minDate */
/* unused harmony export maxDate */
/* unused harmony export betweenDates */
/* harmony export (immutable) */ __webpack_exports__["f"] = notEqual;
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidYoutubeLink;
/* harmony export (immutable) */ __webpack_exports__["j"] = under18;
/* harmony export (immutable) */ __webpack_exports__["k"] = validDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = validImageSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc__ = __webpack_require__("./node_modules/date-fns/compare_asc/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid__ = __webpack_require__("./node_modules/date-fns/is_valid/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_youTubeParser__ = __webpack_require__("./src/helpers/youTubeParser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");





function isEmpty(value) {
    return (value === null ||
        typeof value === 'undefined' ||
        (typeof value === 'string' && value.trim() === '') ||
        (typeof value === 'boolean' && value === false));
}
function required(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.message, message = _c === void 0 ? 'Required' : _c, _d = _b.emptyValues, emptyValues = _d === void 0 ? [] : _d;
    return function (value) {
        return isEmpty(value) || emptyValues.indexOf(value) !== -1 ? message : null;
    };
}
function oneOfRequired(id, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.message, message = _c === void 0 ? 'One of the fields is required' : _c, _d = _b.emptyValues, emptyValues = _d === void 0 ? [] : _d;
    return function (value) { return ({
        id: id,
        message: message,
        failed: isEmpty(value) || emptyValues.indexOf(value) !== -1,
    }); };
}
function minLength(length, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Please enter at least " + length + " characters" : _b;
    return function (value) { return (!isEmpty(value) && value.length < length ? message : null); };
}
function maxLength(length, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Please enter at most " + length + " characters" : _b;
    return function (value) { return (!isEmpty(value) && value.length > length ? message : null); };
}
function pattern(expression, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'Invalid value' : _b;
    return function (value) { return (!isEmpty(value) && !expression.test(value) ? message : null); };
}
function minNumber(min, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Number must be at least " + min : _b;
    return function (value) {
        return !isEmpty(value) && parseInt(value, 10) < min ? message : null;
    };
}
function maxNumber(max, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Number must be at most " + max : _b;
    return function (value) {
        return !isEmpty(value) && parseInt(value, 10) > max ? message : null;
    };
}
function minDate(min, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Date must be same or after " + __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(min) : _b;
    return function (value) {
        var dob = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_date__["d" /* convertDateToUTC */])(new Date(value));
        return !dob || (!isEmpty(value) && __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default()(dob, min) === -1)
            ? message
            : null;
    };
}
function maxDate(max, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Date must be same or before " + __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(max) : _b;
    return function (value) {
        var dob = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_date__["d" /* convertDateToUTC */])(new Date(value));
        return !dob || (!isEmpty(value) && __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default()(dob, max) === 1)
            ? message
            : null;
    };
}
function betweenDates(min, max, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? "Date should be between" : _b;
    return function (value) {
        if (isEmpty(value)) {
            return message;
        }
        return minDate(min, { message: message })(value) !== null &&
            maxDate(max, { message: message })(value) !== null
            ? message
            : null;
    };
}
function notEqual(col, _a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'This value is reserved and cannot be used' : _b;
    return function (value) {
        return !isEmpty(value) &&
            col.filter(function (x) { return x.toLowerCase() === value.toLowerCase(); }).length >= 1
            ? message
            : null;
    };
}
function isValidYoutubeLink(_a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'Please paste your YouTube link' : _b;
    return function (value) { return (isEmpty(value) || !Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_youTubeParser__["b" /* getVideoId */])(value) ? message : null); };
}
function under18(_a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'under 18 years of age' : _b;
    return function (value) {
        return value && __WEBPACK_IMPORTED_MODULE_0_date_fns_compare_asc___default()(new Date(value), Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_date__["h" /* getConsentDOB */])(18)) === 1
            ? message
            : null;
    };
}
function validDate(_a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'Please enter a valid date' : _b;
    return function (value) {
        if (!value) {
            return message;
        }
        var _a = value.split('/'), day = _a[0], month = _a[1], year = _a[2];
        var d = new Date(year + '/' + month + '/' + day);
        // @ts-ignore
        // tslint:disable-next-line:triple-equals
        var isValidDate = Boolean(+d) && d.getDate() == day;
        return !isValidDate && !__WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid___default()(new Date(value)) ? message : null;
    };
}
var MAX_FILE_SIZE = 3 * 1024 * 1024;
function validImageSize(_a) {
    var _b = (_a === void 0 ? {} : _a).message, message = _b === void 0 ? 'Try to upload a smaller file. The limit is 3MB' : _b;
    return function (value) {
        if (value && value.size >= MAX_FILE_SIZE) {
            return message;
        }
        else {
            return null;
        }
    };
}


/***/ }),

/***/ "./src/helpers/validation/validate.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function isOneOfRuleResult(result) {
    return !!result && typeof result === 'object' && !!result.id;
}
function validate(rules, values) {
    if (!rules || typeof rules !== 'object') {
        throw new Error('rules must be an object');
    }
    if (!values || typeof values !== 'object') {
        throw new Error('values must be an object');
    }
    var errors = {};
    var oneOfErrors = {};
    for (var _i = 0, _a = Object.entries(rules); _i < _a.length; _i++) {
        var _b = _a[_i], propName = _b[0], rulesForProp = _b[1];
        var value = values[propName];
        if (Array.isArray(rulesForProp)) {
            var result = evaluateRules(rulesForProp, value);
            if (isOneOfRuleResult(result)) {
                if (!oneOfErrors[result.id]) {
                    oneOfErrors[result.id] = [];
                }
                oneOfErrors[result.id].push(__assign({}, result, { propName: propName, value: value }));
            }
            else {
                errors[propName] = getErrorMessage(result, value, values);
            }
        }
        else if (typeof rulesForProp === 'object') {
            errors[propName] = validate(rulesForProp, value || {});
        }
        else {
            throw new Error("Invalid validation rules object. " + propName + " is of type" +
                (typeof rulesForProp + " but only arrays and objects are valid."));
        }
    }
    for (var _c = 0, _d = Object.values(oneOfErrors); _c < _d.length; _c++) {
        var group = _d[_c];
        if (group.every(function (a) { return a.failed; })) {
            for (var _e = 0, group_1 = group; _e < group_1.length; _e++) {
                var err = group_1[_e];
                errors[err.propName] = getErrorMessage(err.message, err.value, values);
            }
        }
    }
    // Clean up any null errors
    return Object.keys(errors).reduce(function (errorAccum, key) {
        var error = errors[key];
        if (error !== null) {
            errorAccum[key] = error;
        }
        return errorAccum;
    }, {});
}
function evaluateRules(rules, value) {
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var rule = rules_1[_i];
        var result = rule(value);
        if (result !== null) {
            return result;
        }
    }
    return null;
}
function getErrorMessage(result, value, values) {
    if (typeof result === 'function') {
        return result(value, values);
    }
    return result;
}


/***/ }),

/***/ "./src/helpers/window.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openCenteredPopup;
function openCenteredPopup(url, popupWidth, popupHeight) {
    // Fixes dual-screen position       Most browsers        Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width;
    var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height;
    var systemZoom = width / window.screen.availWidth;
    var left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    var top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    var newWindow = window.open(url, '_blank', 'scrollbars=yes, width=' +
        popupWidth / systemZoom +
        ', height=' +
        popupHeight / systemZoom +
        ', top=' +
        top +
        ', left=' +
        left);
    // Puts focus on the newWindow
    if (window.focus !== undefined && newWindow) {
        newWindow.focus();
    }
}


/***/ }),

/***/ "./src/helpers/youTubeParser.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addHttp */
/* harmony export (immutable) */ __webpack_exports__["b"] = getVideoId;
/* unused harmony export constructYouTubeVideoUrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = constructYouTubeThumbnailUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url__ = __webpack_require__("./node_modules/url/url.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url__);

function addHttp(videoURL) {
    return "https://" + videoURL;
}
function getVideoId(fullVideoUrl) {
    var url = fullVideoUrl;
    var urlParsed = __WEBPACK_IMPORTED_MODULE_0_url___default.a.parse(fullVideoUrl);
    if (!(urlParsed.protocol === 'http:' || urlParsed.protocol === 'https:')) {
        url = addHttp(fullVideoUrl);
        urlParsed = __WEBPACK_IMPORTED_MODULE_0_url___default.a.parse(url);
    }
    var urlHost = urlParsed.host;
    if (urlHost.indexOf('youtube.com') > -1) {
        var parsedUrl = __WEBPACK_IMPORTED_MODULE_0_url___default.a.parse(url, true).query.v;
        return parsedUrl;
    }
    if (urlParsed.host === 'youtu.be') {
        var urlPath = __WEBPACK_IMPORTED_MODULE_0_url___default.a.parse(url).pathname;
        var parsedUrl = urlPath.slice(1);
        return parsedUrl;
    }
    return undefined;
}
function constructYouTubeVideoUrl(videoId) {
    return "http://www.youtube.com/v/" + videoId;
}
function constructYouTubeThumbnailUrl(videoId) {
    return "http://img.youtube.com/vi/" + videoId + "/0.jpg";
}


/***/ }),

/***/ "./src/i18n/client.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__("./node_modules/i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/i18n/config.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].init(__assign({}, __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */]), function (err) {
    if (err) {
        // tslint:disable-next-line:no-console
        console.log('something went wrong loading', err);
    }
});
__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].changeLanguage(window.__i18n.locale);
__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].addResourceBundle(window.__i18n.locale, 'common', window.__i18n.resources, true);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);


/***/ }),

/***/ "./src/i18n/config.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var i18nConfig = {
    whitelist: ['en', 'en-GB', 'en-US'],
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    keySeparator: false,
    debug: false,
};
/* harmony default export */ __webpack_exports__["a"] = (i18nConfig);


/***/ }),

/***/ "./src/logging.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__justgiving_logger__ = __webpack_require__("./node_modules/@justgiving/logger/es/client.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);


if (false) {
    var serverConfig = require('config/server.config');
    log.level(serverConfig.logLevel);
    if (serverConfig.logstashEndpoint) {
        var logstash = require('bunyan-logstash-tcp');
        var _a = serverConfig.logstashEndpoint.split(':'), host = _a[0], port = _a[1];
        log.addStream({
            name: 'logstash',
            level: 'info',
            type: 'raw',
            stream: logstash.createStream({ host: host, port: port }).on('error', console.log),
        });
    }
}
if (true) {
    __WEBPACK_IMPORTED_MODULE_0__justgiving_logger__["a" /* default */].level(__WEBPACK_IMPORTED_MODULE_1_config___default.a.LOG_LEVEL);
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__justgiving_logger__["a" /* default */]);


/***/ }),

/***/ "./src/redux/middleware/analytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__justgiving_koala_front_end_analytics__ = __webpack_require__("./node_modules/@justgiving/koala-front-end-analytics/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__justgiving_koala_front_end_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__justgiving_koala_front_end_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_logging__ = __webpack_require__("./src/logging.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ __webpack_exports__["a"] = (function (_a) {
    var getState = _a.getState;
    return function (next) { return function (action) {
        if (action.meta && action.meta.analytics) {
            var event = enhance(getState(), action.meta.analytics);
            track(event);
        }
        next(action);
    }; };
});
function enhance(state, event) {
    var enhancedEvent = __assign({ page_type: 'crowdfunding page' }, event);
    if (enhancedEvent.social_type) {
        enhancedEvent = __assign({}, enhancedEvent, { event: 'click', subtype: enhancedEvent.subtype || 'share', social_id: '', social_email: '', activity_type: 'crowdfunding_guid', actor_source: 'ownerUserId' });
    }
    if (state.page && state.page.id) {
        var page = state.page;
        if (enhancedEvent.content_type) {
            enhancedEvent.content_id = page.id || '';
        }
        if (enhancedEvent.activity_type) {
            enhancedEvent.activity_id = page.id || '';
        }
        if (enhancedEvent.actor_source) {
            enhancedEvent.actor_id = page.ownerUserId || '';
        }
    }
    return enhancedEvent;
}
function track(event) {
    trackKoala(event);
}
function trackKoala(trackedInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var analytics, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    analytics = getKoalaClient();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, analytics.track(__assign({}, trackedInfo))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    __WEBPACK_IMPORTED_MODULE_2_src_logging__["a" /* default */].warn(err_1, "Could not send event '" + trackedInfo.event + "/" + trackedInfo.subtype + "' to Koala");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var clientAnalytics;
function getKoalaClient() {
    if (true) {
        if (!clientAnalytics) {
            clientAnalytics = new __WEBPACK_IMPORTED_MODULE_0__justgiving_koala_front_end_analytics___default.a({ apiUrl: __WEBPACK_IMPORTED_MODULE_1_config__["KOALA_API_URI"] });
        }
        return clientAnalytics;
    }
    if (false) {
        var requestStorage = require('../../server/requestStorage').default;
        return requestStorage.get('analytics');
    }
    throw new Error('Koala not supported in current env');
}


/***/ }),

/***/ "./src/redux/middleware/errorLogger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_logging__ = __webpack_require__("./src/logging.js");

/* harmony default export */ __webpack_exports__["a"] = (function () { return function (next) { return function (action) {
    if (action.error) {
        // exclude 404 errors for pages, as these are indicated by the response
        // status and logged at the fleet level
        if (action.type === 'PAGE_FAILURE' &&
            action.payload &&
            (action.payload.type === '404' || action.payload.type === '302')) {
            __WEBPACK_IMPORTED_MODULE_0_src_logging__["a" /* default */].debug({ err: action.payload }, action.type);
            return next(action);
        }
        __WEBPACK_IMPORTED_MODULE_0_src_logging__["a" /* default */].error({ err: action.payload }, action.type);
    }
    else {
        __WEBPACK_IMPORTED_MODULE_0_src_logging__["a" /* default */].debug(action, action.type);
    }
    return next(action);
}; }; });


/***/ }),

/***/ "./src/redux/middleware/googleAnalytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* global ga */

if (true) {
    window.addEventListener('CookiebotOnAccept', function (e) {
        if (Cookiebot.consent && Cookiebot.consent.statistics) {
            if (true && window._kiq) {
                var $script = __webpack_require__("./node_modules/scriptjs/dist/script.js");
                $script('//www.google-analytics.com/analytics.js');
                window.ga =
                    window.ga ||
                        function google() {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            (ga.q = ga.q || []).push(args);
                        };
                ga.l = +new Date();
                ga('create', __WEBPACK_IMPORTED_MODULE_0__config__["GOOGLE_ANALYTICS_KEY"], 'auto');
            }
        }
    });
}
function gaPageView(location) {
    ga('set', 'page', location);
    // Static title is 'Good Enough' for now
    ga('set', 'title', 'Crowdfunding');
    ga('send', 'pageview');
}
var googleAnalytics = function (_a) {
    var getState = _a.getState;
    return function (next) { return function (action) {
        var state = getState();
        var pagePath = state.routing.location
            ? state.routing.location.pathname
            : '';
        var pagePathSlice = pagePath.slice(0, pagePath.lastIndexOf('/'));
        switch (action.type) {
            case 'PAGE_SUCCESS':
                gaPageView(pagePath);
                break;
            case 'BANK_SUCCESS':
                if (action.approved === true) {
                    gaPageView(pagePathSlice + "/pagecomplete");
                }
                else {
                    gaPageView(pagePathSlice + "/pagepending");
                }
                break;
            case 'BANK_FAILURE':
                gaPageView(pagePathSlice + "/bankfailure");
                break;
            case 'ACTIVATE_SUCCESS':
                gaPageView(pagePath + "/pageactive");
                break;
            case 'CREATE_START':
                gaPageView('/create');
                break;
            default:
                break;
        }
        return next(action);
    }; };
};
/* harmony default export */ __webpack_exports__["a"] = (googleAnalytics);


/***/ }),

/***/ "./src/redux/middleware/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_co__ = __webpack_require__("./node_modules/redux-co/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_co___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_co__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__("./node_modules/redux-thunk/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__("./src/redux/middleware/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errorLogger__ = __webpack_require__("./src/redux/middleware/errorLogger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__googleAnalytics__ = __webpack_require__("./src/redux/middleware/googleAnalytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__qualaroo__ = __webpack_require__("./src/redux/middleware/qualaroo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_middleware_pageViewAnalytics__ = __webpack_require__("./src/redux/middleware/pageViewAnalytics.js");







var middleware = [__WEBPACK_IMPORTED_MODULE_0_redux_co___default.a, __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a];
if (true) {
    middleware.push(__WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* default */]);
}
if (true) {
    middleware.push(__WEBPACK_IMPORTED_MODULE_3__errorLogger__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__googleAnalytics__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__qualaroo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_src_redux_middleware_pageViewAnalytics__["a" /* default */]);
}
if (false) {
    middleware.push(errorLogger);
}
/* harmony default export */ __webpack_exports__["a"] = (middleware);


/***/ }),

/***/ "./src/redux/middleware/pageViewAnalytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var PAGE_VIEW = 'PAGE_VIEW';
/* harmony default export */ __webpack_exports__["a"] = (function (options) { return function (next) { return function (action) {
    if (action.type === 'PAGE_SUCCESS' || action.type === 'PAGE_MOUNT') {
        handlePageView(action.payload, options);
    }
    next(action);
}; }; });
var creationProcessPages = [
    'coverphoto',
    'story',
    'pagelink',
    'confirmidentity',
];
function handlePageView(page, _a) {
    var getState = _a.getState, dispatch = _a.dispatch;
    var state = getState();
    var _b = state.routing.location, pathname = _b.pathname, search = _b.search;
    var query = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(search ? search.substr(1) : '');
    // Don't track second level sub path page views, i.e. /tiger/dashboard/target
    if (pathname.split('/').length > 3) {
        return;
    }
    var path = pathname.split('/').pop();
    // creation pages have their page view handling code
    if (creationProcessPages.includes(path)) {
        return;
    }
    var analytics = {
        event: 'page view',
        activity_id: page.id || '',
        activity_type: 'crowdfunding_guid',
        social_utm_term: (query && query.utm_term) || '',
        content_id: page.id || '',
        content_type: 'crowdfunding_guid',
    };
    if (page.isOwnerRequested) {
        analytics = __assign({}, analytics, { subtype: 'admin', event_value: 'page view', page_section: "admin > page view" });
    }
    else {
        analytics = __assign({}, analytics, { subtype: 'cfp' });
    }
    var alternativeProjects = state.alternativeProjects.items;
    var hasAlternatePages = alternativeProjects && alternativeProjects.length > 0;
    analytics = __assign({}, analytics, { version_id: hasAlternatePages ? '1' : '', version_type: hasAlternatePages ? 'crowdfunding page' : '' });
    dispatch({
        type: PAGE_VIEW,
        meta: {
            analytics: analytics,
        },
    });
}


/***/ }),

/***/ "./src/redux/middleware/qualaroo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_difference_in_days__ = __webpack_require__("./node_modules/date-fns/difference_in_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_difference_in_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");


function setUserProperties(properties) {
    if (true && window._kiq) {
        window._kiq.push(['set', properties]);
    }
}
function yesOrNo(bool) {
    return bool ? 'Yes' : 'No';
}
var qualaroo = function () { return function (next) { return function (action) {
    if (action.type === 'PAGE_SUCCESS' || action.type === 'PAGE_MOUNT') {
        var _a = action.payload, activatedAt = _a.activatedAt, amountPledged = _a.amountPledged, amountRaised = _a.amountRaised, categoryId = _a.categoryId, finishedAt = _a.finishedAt, id = _a.id, isOwnerRequested = _a.isOwnerRequested, verificationStatus = _a.verificationStatus, status = _a.status, targetAmount = _a.targetAmount;
        var pageClosed = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_page__["d" /* isClosed */])(status);
        var amountRaised = (pageClosed ? amountRaised : amountPledged) || 0;
        var daysSinceActivation = activatedAt
            ? __WEBPACK_IMPORTED_MODULE_0_date_fns_difference_in_days___default()(new Date(), activatedAt)
            : 0;
        var customProperties = {
            GUID: id,
            activated_under_7_days: yesOrNo(daysSinceActivation < 7),
            activated_under_30_days: yesOrNo(daysSinceActivation < 30),
            activated_under_60_days: yesOrNo(daysSinceActivation < 60),
            activated_under_90_days: yesOrNo(daysSinceActivation < 90),
            activated_under_120_days: yesOrNo(daysSinceActivation < 120),
            bank_account_verified: yesOrNo(verificationStatus === 'Verified'),
            crowdfunding_page_owner: yesOrNo(isOwnerRequested),
            page_category_id: categoryId,
            page_status: status,
            raised_0: yesOrNo(amountRaised === 0),
            raised_under_500: yesOrNo(amountRaised <= 500),
            raised_under_1000: yesOrNo(amountRaised <= 1000),
            raised_under_1500: yesOrNo(amountRaised <= 1500),
            raised_under_2000: yesOrNo(amountRaised <= 2000),
            raised_over_2000: yesOrNo(amountRaised > 2000),
            target_reached: yesOrNo(amountRaised >= targetAmount),
        };
        setUserProperties(customProperties);
    }
    return next(action);
}; }; };
/* harmony default export */ __webpack_exports__["a"] = (qualaroo);


/***/ }),

/***/ "./src/redux/modules/ab.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enrol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_ab__ = __webpack_require__("./src/helpers/api/ab.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;

var enrol = function (slug) { return function (dispatch, getState) { return __awaiter(_this, void 0, Promise, function () {
    var state, enrolledIn, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = getState();
                if (state.ab[slug]) {
                    return [2 /*return*/];
                }
                dispatch({ type: 'AB_ENROL_REQUEST', payload: slug });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_ab__["a" /* enrol */])("cf_" + slug)];
            case 2:
                enrolledIn = _a.sent();
                dispatch({ type: 'AB_ENROL_SUCCESS', payload: { slug: slug, enrolledIn: enrolledIn } });
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                dispatch({ type: 'AB_ENROL_FAILURE', payload: { slug: slug, err: err_1 } });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    if (state === void 0) { state = {}; }
    var _a, _b;
    switch (action.type) {
        case 'AB_ENROL_SUCCESS':
            return __assign({}, state, (_a = {}, _a[action.payload.slug] = action.payload.enrolledIn, _a));
        case 'AB_ENROL_FAILURE':
            return __assign({}, state, (_b = {}, _b[action.payload.slug] = 'A', _b));
        default:
            return state;
    }
});


/***/ }),

/***/ "./src/redux/modules/alternativeProjects.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = loadAlternativeProjects;
/* harmony export (immutable) */ __webpack_exports__["a"] = clickOnAlternativeProjectCard;
/* harmony export (immutable) */ __webpack_exports__["d"] = renderAlternativeProjectCard;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_alternativeProjects__ = __webpack_require__("./src/helpers/api/alternativeProjects.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadAlternativeProjects(id) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'ALTERNATIVE_PROJECTS_REQUEST', payload: { id: id } });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_alternativeProjects__["a" /* default */])(id)];
                case 2:
                    data = _a.sent();
                    dispatch({
                        type: 'ALTERNATIVE_PROJECTS_SUCCESS',
                        payload: data,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'ALTERNATIVE_PROJECTS_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function clickOnAlternativeProjectCard(details) {
    return {
        type: 'CLICK_ON_ALTERNATIVE_PROJECTS_CARD',
        meta: {
            analytics: {
                event: 'card click',
                subtype: 'stories you may like',
                page_section: 'stories you may like',
                content_type: 'crowdfunding_guid',
                card_id: details.projectId,
                card_rank: details.cardRank,
                card_count: details.cardCount,
                card_url: details.cardUrl,
                version_id: '1',
                version_type: 'stories you may like',
                actor_sources: 'match score',
                activity_type: 'project interestingness score',
                request_id: '',
                request_type: 'matching API',
            },
        },
    };
}
function renderAlternativeProjectCard(details) {
    return {
        type: 'RENDER_ALTERNATIVE_PROJECT_CARD',
        meta: {
            analytics: {
                event: 'card rendered',
                subtype: 'stories you may like',
                page_section: 'stories you may like',
                content_type: 'crowdfunding_guid',
                card_id: details.projectId,
                card_rank: details.cardRank,
                card_count: details.cardCount,
                version_id: '1',
                version_type: 'stories you may like',
                actor_sources: 'match score',
                activity_type: 'project interestingness score',
                request_id: '',
                request_type: 'matching API',
            },
        },
    };
}
function reducer(state, action) {
    if (state === void 0) { state = {
        items: [],
        isRequesting: false,
    }; }
    switch (action.type) {
        case 'ALTERNATIVE_PROJECTS_REQUEST':
            return __assign({}, state, { isRequesting: true });
        case 'ALTERNATIVE_PROJECTS_SUCCESS':
            return __assign({}, state, { isRequesting: false, items: action.payload });
        case 'ALTERNATIVE_PROJECTS_FAILURE':
            return __assign({}, state, { isRequesting: false, error: action.payload });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/analytics.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = analyticsClick;
/* harmony export (immutable) */ __webpack_exports__["b"] = analyticsPageView;
function analyticsClick(_a) {
    var event = _a.event, eventValue = _a.eventValue, subtype = _a.subtype, pageSection = _a.pageSection;
    return {
        type: 'ANALYTICS_CLICK',
        meta: {
            analytics: {
                event: event,
                subtype: subtype,
                event_value: eventValue,
                page_section: pageSection,
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function analyticsPageView(_a) {
    var eventValue = _a.eventValue, pageSection = _a.pageSection, subtype = _a.subtype, actorSource = _a.actorSource;
    return {
        type: 'ANALYTICS_PAGE_VIEW',
        meta: {
            analytics: {
                event: 'page view',
                subtype: subtype,
                event_value: eventValue,
                page_section: pageSection,
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
                actor_source: actorSource,
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/asyncConnect/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beginLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endLoad; });
var beginLoad = function (id) { return ({
    type: '@jg/AsyncConnectBeginLoad',
    payload: id,
}); };
var endLoad = function (id) { return ({
    type: '@jg/AsyncConnectEndLoad',
    payload: id,
}); };


/***/ }),

/***/ "./src/redux/modules/asyncConnect/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/asyncConnect/reducer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/asyncConnect/actions.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);



/***/ }),

/***/ "./src/redux/modules/asyncConnect/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initalState = {};
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    if (state === void 0) { state = initalState; }
    var _a, _b;
    switch (action.type) {
        case '@jg/AsyncConnectBeginLoad':
            return __assign({}, state, (_a = {}, _a[action.payload] = false, _a));
        case '@jg/AsyncConnectEndLoad':
            return __assign({}, state, (_b = {}, _b[action.payload] = true, _b));
        default:
            return state;
    }
});


/***/ }),

/***/ "./src/redux/modules/avatars.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadAvatars;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_avatars__ = __webpack_require__("./src/helpers/api/avatars.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadAvatars(userIds) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var storedAvatars_1, userIdsToFetch, avatars, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'AVATARS_REQUEST', payload: userIds });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    storedAvatars_1 = getState().avatars.avatars;
                    userIdsToFetch = userIds.filter(function (x) { return !storedAvatars_1[x]; });
                    if (!(userIdsToFetch.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_avatars__["a" /* getAvatars */])(userIdsToFetch)];
                case 2:
                    avatars = _a.sent();
                    dispatch({
                        type: 'AVATARS_SUCCESS',
                        payload: avatars,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    dispatch({
                        type: 'AVATARS_SUCCESS',
                        payload: {},
                    });
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'AVATARS_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
function reducer(state, action) {
    if (state === void 0) { state = { avatars: {} }; }
    switch (action.type) {
        case 'AVATARS_REQUEST':
            return __assign({}, state);
        case 'AVATARS_SUCCESS':
            return __assign({}, state, { avatars: __assign({}, action.payload, state.avatars) });
        case 'AVATARS_FAILURE':
            return __assign({}, state, { errorMessage: action.payload.message });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/bank.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addBankAccount;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_verifications__ = __webpack_require__("./src/helpers/api/verifications.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_redux_modules_paymentDetails__ = __webpack_require__("./src/redux/modules/paymentDetails.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_date__ = __webpack_require__("./src/helpers/date.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var mapAccountToPayload = function (account) {
    return {
        title: account.title,
        firstName: account.firstName,
        lastName: account.lastName,
        addressLine1: account.addressLine1,
        addressLine2: account.addressLine2,
        town: account.town,
        postCode: account.postCode,
        dateOfBirth: Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_date__["d" /* convertDateToUTC */])(new Date(account.dob)),
    };
};
function addBankAccount(account) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var recipientExist, payload, payloadRecipient, result, error_1, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'BANK_REQUEST',
                        payload: account,
                    });
                    recipientExist = account.bankAccountVerification === 'recipient';
                    payload = {
                        projectId: account.pageId,
                        sortCode: account.sortCode,
                        accountNumber: account.accountNumber,
                        pageOwner: mapAccountToPayload(account.pageOwner),
                    };
                    payloadRecipient = {
                        recipient: mapAccountToPayload(account.recipient),
                    };
                    payload = recipientExist ? __assign({}, payload, payloadRecipient) : payload;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_verifications__["a" /* submitPaymentDetails */])(payload)];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'BANK_FAILURE',
                        error: true,
                        payload: { message: 'serverError', error: error_1 },
                    });
                    throw new Error('serverError');
                case 4:
                    if (result.approved) {
                        status = getState().page.status;
                        dispatch({ type: 'BANK_SUCCESS', payload: { approved: true } });
                        dispatch({
                            type: 'UPDATE_SUCCESS',
                            payload: {
                                verificationStatus: 'Verified',
                                status: status === 'Suspended' ? 'Active' : status,
                            },
                        });
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_src_redux_modules_paymentDetails__["b" /* loadPaymentDetails */])());
                    }
                    else {
                        dispatch({
                            type: 'BANK_FAILURE',
                            error: true,
                            payload: { message: result.reason },
                        });
                        throw new Error(result.reason);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
function reducer(state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'BANK_REQUEST':
            return __assign({}, state, { isRequesting: true, errorMessage: null });
        case 'BANK_SUCCESS':
            return __assign({}, state, { isRequesting: false, lastRequested: Date.now(), errorMessage: null });
        case 'BANK_FAILURE':
            return __assign({}, state, { isRequesting: false, errorMessage: action.payload.message });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/carousel.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = slideCarousel;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function slideCarousel(_a) {
    var location = _a.location, event = _a.event;
    // default to system
    var analytics = {
        event: 'system',
        subtype: 'auto',
        event_value: "carousel slide",
        page_section: location,
        activity_type: 'crowdfunding_guid',
    };
    // if there is an event & element attached
    if (event && event.currentTarget) {
        var value = event.currentTarget.getAttribute('data-jqa-event-value');
        analytics = __assign({}, analytics, { event: 'click', subtype: 'button', event_value: value || '' });
    }
    return {
        type: 'SLIDE_CAROUSEL',
        meta: {
            analytics: analytics,
        },
    };
}
function reducer(state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'SLIDE_CAROUSEL':
        // fallthrough
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/categories.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadCategories;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_categories__ = __webpack_require__("./src/helpers/api/categories.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadCategories() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'CATEGORIES_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_categories__["a" /* getAll */])()];
                case 2:
                    data = _a.sent();
                    dispatch({
                        type: 'CATEGORIES_SUCCESS',
                        payload: { categories: data.categories },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'CATEGORIES_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function reducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'CATEGORIES_SUCCESS':
            return action.payload.categories;
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/censures.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addCensure;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_censures__ = __webpack_require__("./src/helpers/api/censures.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function addCensure() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var pageId, key, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'ADD_CENSURE_REQUEST',
                        meta: {
                            analytics: {
                                event: 'link click',
                                subtype: 'button',
                                event_value: 'Report this page',
                                page_section: 'page > footer',
                                activity_type: 'crowdfunding_guid',
                            },
                        },
                    });
                    pageId = getState().page.id;
                    key = "Censure:" + pageId;
                    if (!isSessionStorageAvailable()) {
                        return [2 /*return*/];
                    }
                    if (window.sessionStorage.getItem(key)) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_censures__["a" /* add */])(pageId)];
                case 2:
                    _a.sent();
                    dispatch({ type: 'ADD_CENSURE_SUCCESS' });
                    window.sessionStorage.setItem(key, JSON.stringify(true));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'ADD_CENSURE_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function isSessionStorageAvailable() {
    try {
        window.sessionStorage.setItem('sessionStorage', '1');
        window.sessionStorage.removeItem('sessionStorage');
        return true;
    }
    catch (e) {
        return false;
    }
}
function reducer(state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/charity/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCharityInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_charity__ = __webpack_require__("./src/helpers/api/charity.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function getCharityInfo(id) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch({ type: 'GET_CHARITY_INFO_REQUEST' });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_charity__["a" /* fetchCharityInfo */])(id)];
                case 2:
                    result = _b.sent();
                    if (result !== null) {
                        dispatch({
                            type: 'GET_CHARITY_INFO_SUCCESS',
                            payload: result,
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    dispatch({ type: 'GET_CHARITY_INFO_FAILURE' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),

/***/ "./src/redux/modules/charity/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/charity/reducer.ts");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);


/***/ }),

/***/ "./src/redux/modules/charity/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case 'GET_CHARITY_INFO_SUCCESS':
            return __assign({}, state, action.payload);
        default:
            return state;
    }
});


/***/ }),

/***/ "./src/redux/modules/completedActions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = loadCompletedActions;
/* harmony export (immutable) */ __webpack_exports__["a"] = completeAction;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_completedActions__ = __webpack_require__("./src/helpers/api/completedActions.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadCompletedActions() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var pageId, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'LOAD_COMPLETED_ACTIONS_REQUEST',
                    });
                    pageId = getState().page.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_completedActions__["a" /* getCompletedActions */])(pageId)];
                case 2:
                    data = _a.sent();
                    dispatch({
                        type: 'LOAD_COMPLETED_ACTIONS_SUCCESS',
                        payload: data,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'LOAD_COMPLETED_ACTIONS_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function completeAction(pageId, key) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'COMPLETE_ACTION_REQUEST',
                        payload: {
                            pageId: pageId,
                            key: key,
                        },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_completedActions__["b" /* setActionAsComplete */])(pageId, key)];
                case 2:
                    _a.sent();
                    dispatch({
                        type: 'COMPLETE_ACTION_SUCCESS',
                        payload: { key: key },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    dispatch({
                        type: 'COMPLETE_ACTION_FAILURE',
                        error: true,
                        payload: err_2,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var initialState = {
    isLoading: false,
    loaded: false,
    keys: [],
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'LOAD_COMPLETED_ACTIONS_REQUEST':
            return __assign({}, state, { isLoading: true, loaded: false });
        case 'LOAD_COMPLETED_ACTIONS_SUCCESS':
            return __assign({}, state, { keys: action.payload.map(function (item) { return item.key; }), isLoading: false, loaded: true });
        case 'LOAD_COMPLETED_ACTIONS_FAILURE':
            return __assign({}, state, { isLoading: false, loaded: true });
        case 'COMPLETE_ACTION_SUCCESS':
            return __assign({}, state, { keys: state.keys.concat([action.payload.key]) });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/consents/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getConsents */
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserConsents;
/* unused harmony export updateUserConsent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_preferencesService__ = __webpack_require__("./src/helpers/api/preferencesService.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


function getConsents() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'GET_CONSENT_STATEMENTS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_preferencesService__["a" /* getConsentStatements */])(__WEBPACK_IMPORTED_MODULE_1_config__["USER_CONSENTS"].COLLECTION_LOCATION_ID)];
                case 2:
                    result = _a.sent();
                    if (!result) {
                        throw new Error('No result from preferences service request.');
                    }
                    dispatch({
                        type: 'GET_CONSENT_STATEMENTS_SUCCESS',
                        payload: result,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    dispatch({
                        type: 'GET_CONSENT_STATEMENTS_FAILURE',
                        payload: e_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function getUserConsents() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'GET_USER_CONSENT_STATEMENTS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_preferencesService__["a" /* getConsentStatements */])(__WEBPACK_IMPORTED_MODULE_1_config__["USER_CONSENTS"].CROWDFUNDING_PAGE_COLLECTION_LOCATION_ID)];
                case 2:
                    result = _a.sent();
                    if (!result) {
                        throw new Error('No result from preferences service request.');
                    }
                    dispatch({
                        type: 'GET_USER_CONSENT_STATEMENTS_SUCCESS',
                        payload: result,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    dispatch({
                        type: 'GET_USER_CONSENT_STATEMENTS_FAILURE',
                        payload: e_2,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function updateUserConsent(data) {
    return {
        type: 'UPDATE_USER_CONSENT',
        payload: data,
    };
}


/***/ }),

/***/ "./src/redux/modules/consents/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/consents/reducer.ts");
/* unused harmony reexport ConsentsState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/consents/actions.ts");
/* unused harmony reexport getConsents */
/* unused harmony reexport getUserConsents */
/* unused harmony reexport updateUserConsent */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);




/***/ }),

/***/ "./src/redux/modules/consents/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    consentStatements: [],
    userConsentStatements: [],
    isLoading: false,
    error: null,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'GET_CONSENT_STATEMENTS_REQUEST':
        case 'GET_USER_CONSENT_STATEMENTS_REQUEST':
            return __assign({}, state, { error: null, isLoading: true });
        case 'GET_CONSENT_STATEMENTS_SUCCESS':
            return __assign({}, state, { isLoading: false, consentStatements: action.payload, error: null });
        case 'GET_USER_CONSENT_STATEMENTS_SUCCESS':
            return __assign({}, state, { isLoading: false, userConsentStatements: action.payload, error: null });
        case 'GET_CONSENT_STATEMENTS_FAILURE':
        case 'GET_USER_CONSENT_STATEMENTS_FAILURE':
            return __assign({}, state, { error: action.payload, isLoading: false });
        case 'UPDATE_USER_CONSENT':
            var consentStatements = state.consentStatements;
            return __assign({}, state, { consentStatements: consentStatements.map(function (consentStatement, index) {
                    return index === parseInt(action.payload.index, 10)
                        ? __assign({}, consentStatement, { consentGiven: action.payload.checked }) : consentStatement;
                }) });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/coverPhoto.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = submitCover;
/* harmony export (immutable) */ __webpack_exports__["b"] = resetCover;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_images__ = __webpack_require__("./src/helpers/api/images.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





function submitCover(pageName, image, cropData, zoomAdjusted) {
    var _this = this;
    if (zoomAdjusted === void 0) { zoomAdjusted = false; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var croppedImage, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SUBMIT_COVER_REQUEST',
                        meta: {
                            analytics: {
                                event: 'link click',
                                subtype: 'button',
                                event_value: 'save and continue',
                                page_section: 'page creation > add cover photo',
                                activity_type: 'crowdfunding_guid',
                                actor_id: zoomAdjusted ? 1 : 0,
                                actor_sources: 'cover photo zoom adjusted',
                            },
                        },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_image__["d" /* cropImage */])(__assign({ image: image }, cropData))];
                case 2:
                    croppedImage = _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_images__["a" /* uploadCoverImage */])(croppedImage)];
                case 3:
                    response = _a.sent();
                    if (!response.success) {
                        dispatch({
                            type: 'SUBMIT_COVER_FAILURE',
                            error: true,
                            payload: { message: response.message },
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_pages__["e" /* patch */])({
                            name: pageName,
                            initialImage: { name: response.data.imageName },
                            socialShareImage: { name: response.data.socialShareImageName },
                        })];
                case 4:
                    _a.sent();
                    dispatch({
                        type: 'UPDATE_SUCCESS',
                        payload: {
                            initialImage: { name: response.data.imageName },
                            socialShareImage: { name: response.data.socialShareImageName },
                        },
                    });
                    dispatch({ type: 'SUBMIT_COVER_SUCCESS' });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["b" /* push */])("/" + pageName + "/story"));
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    dispatch({ type: 'SUBMIT_COVER_FAILURE', error: true, payload: error_1 });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
function resetCover(pageName) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SUBMIT_COVER_REQUEST',
                        meta: {
                            analytics: {
                                event: 'click',
                                subtype: 'button',
                                event_value: 'save and continue',
                                page_section: 'page creation > bottom',
                                activity_type: 'crowdfunding_guid',
                            },
                        },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_pages__["e" /* patch */])({
                            name: pageName,
                            initialImage: { name: __WEBPACK_IMPORTED_MODULE_2_config___default.a.DEFAULT_IMAGE_NAME },
                            socialShareImage: { name: __WEBPACK_IMPORTED_MODULE_2_config___default.a.DEFAULT_IMAGE_NAME },
                        })];
                case 2:
                    _a.sent();
                    dispatch({ type: 'SUBMIT_COVER_SUCCESS' });
                    dispatch({
                        type: 'UPDATE_SUCCESS',
                        payload: {
                            initialImage: { name: __WEBPACK_IMPORTED_MODULE_2_config___default.a.DEFAULT_IMAGE_NAME },
                            socialShareImage: { name: __WEBPACK_IMPORTED_MODULE_2_config___default.a.DEFAULT_IMAGE_NAME },
                        },
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["b" /* push */])("/" + pageName + "/story"));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    dispatch({ type: 'SUBMIT_COVER_FAILURE', error: true, payload: error_2 });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var initialState = {
    isRequesting: false,
    hasError: false,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'SUBMIT_COVER_REQUEST':
            return __assign({}, state, { isRequesting: true, hasError: false });
        case 'SUBMIT_COVER_SUCCESS':
            return __assign({}, state, { isRequesting: false, hasError: false });
        case 'SUBMIT_COVER_FAILURE':
            return __assign({}, state, { isRequesting: false, hasError: true });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/create.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATE_START */
/* harmony export (immutable) */ __webpack_exports__["c"] = createPageStarted;
/* harmony export (immutable) */ __webpack_exports__["b"] = createPage;
/* harmony export (immutable) */ __webpack_exports__["a"] = categoryChanged;
/* harmony export (immutable) */ __webpack_exports__["d"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_self__ = __webpack_require__("./src/helpers/api/self.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_preferencesService__ = __webpack_require__("./src/helpers/api/preferencesService.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_api_iam__ = __webpack_require__("./src/helpers/api/iam.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var CREATE_START = 'CREATE_START';
function createPageStarted() {
    return {
        type: CREATE_START,
        meta: {
            analytics: {
                event: 'page view',
                subtype: 'create',
            },
        },
    };
}
function createPage(page, isCharityEndorsed) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var analytics, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    analytics = __assign({ event: 'link click', subtype: 'button', event_value: 'continue', page_section: 'page creation > bottom' }, (isCharityEndorsed
                        ? {
                            actor_sources: 'charity endorsed checkbox',
                            actor_id: page.charityId
                                ? page.commitmentType
                                : 'checkbox not ticked',
                        }
                        : {}));
                    dispatch({
                        type: 'CREATE_REQUEST',
                        payload: page,
                        meta: {
                            analytics: analytics,
                        },
                    });
                    dispatch({
                        type: 'CREATE_CHECKPOINT',
                        payload: page,
                    });
                    if (true && !Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_api_iam__["b" /* isLoggedIn */])()) {
                        dispatch({ type: 'CREATE_ABORTED' });
                        Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_url__["c" /* gotoUrl */])(__WEBPACK_IMPORTED_MODULE_5_config__["LOGIN_URI_SSO"] + "?returnUrl=" + encodeURI(window.location.href));
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, advance(dispatch, getState)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'CREATE_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function advance(dispatch, getState, beforeRedirect) {
    return __awaiter(this, void 0, void 0, function () {
        var user, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_self__["a" /* get */])()];
                case 1:
                    user = _a.sent();
                    if (!user || !Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_self__["b" /* isLoggedIn */])(user)) {
                        throw new Error('Expected user to be logged in when advancing page creation.');
                    }
                    return [4 /*yield*/, finishPageCreation(dispatch, getState)];
                case 2:
                    data = _a.sent();
                    if (beforeRedirect) {
                        beforeRedirect();
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + data.name + "/coverphoto"));
                    return [2 /*return*/];
            }
        });
    });
}
function finishPageCreation(dispatch, getState) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, page, userConsentStatements, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getState(), page = _a.create.page, userConsentStatements = _a.consents.userConsentStatements;
                    if (!page) {
                        throw new Error("Can't finish page creation, page data not in store");
                    }
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__["b" /* create */])(page)];
                case 1:
                    data = _b.sent();
                    /**
                     * updateUserConsents is called in the background
                     * no need for error handling and waiting for the response
                     */
                    Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_preferencesService__["b" /* updateUserConsents */])({
                        userConsentStatements: userConsentStatements,
                        userGuid: data.ownerUserId,
                        pageId: data.id,
                    });
                    dispatch({ type: 'CREATE_SUCCESS', payload: data });
                    return [2 /*return*/, data];
            }
        });
    });
}
function categoryChanged(_a) {
    var categoryName = _a.categoryName;
    return {
        type: 'CREATE_CATEGORY_CHANGED',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'drop down',
                event_value: 'category',
                page_section: 'page creation',
                actor_id: categoryName,
                actor_source: 'drop_down',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
var initialState = {
    isStateVerified: false,
    emailAddress: null,
    errorMessage: null,
    isRequesting: false,
    isRequestingFacebook: false,
    page: null,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'CREATE_REQUEST':
            return __assign({}, state, { isRequesting: true });
        case 'CREATE_CHECKPOINT':
            return __assign({}, state, { page: action.payload });
        case 'CREATE_ABORTED':
            return __assign({}, state, { isRequesting: false });
        case 'CREATE_SUCCESS':
            return __assign({}, state, { page: null, isRequesting: false });
        case 'CREATE_FAILURE':
            return __assign({}, state, { isRequesting: false, hasError: true, errorMessage: action.payload.message });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/dashboard/actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getTipsState;
/* harmony export (immutable) */ __webpack_exports__["h"] = tipClick;
/* harmony export (immutable) */ __webpack_exports__["i"] = uploadProfilePhoto;
/* unused harmony export activeTipClick */
/* unused harmony export inactiveTipClick */
/* harmony export (immutable) */ __webpack_exports__["g"] = skipSlide;
/* harmony export (immutable) */ __webpack_exports__["j"] = viewSlide;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeShareModal;
/* unused harmony export openFundsModal */
/* unused harmony export closeFundsModal */
/* unused harmony export modifyTarget */
/* unused harmony export moreAboutFees */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculcateTotalCount; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getPageViews;
/* harmony export (immutable) */ __webpack_exports__["e"] = getShares;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDonations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days__ = __webpack_require__("./node_modules/date-fns/sub_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_magpie__ = __webpack_require__("./src/helpers/api/magpie.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_activities__ = __webpack_require__("./src/helpers/api/activities.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_payment__ = __webpack_require__("./src/helpers/payment.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("./src/redux/modules/dashboard/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_graphTransforms__ = __webpack_require__("./src/helpers/graphTransforms.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







function getTipsState(_a) {
    var page = _a.page, completedActions = _a.completedActions, paymentDetails = _a.paymentDetails;
    return {
        publish: [
            'Active',
            'Suspended',
            'TargetNotReached',
            'FullyFunded',
            'ReportGenerated',
        ].includes(page.status),
        personalise: !!page.ownerProfileImageUrl &&
            !!page.ownerBio &&
            !!page.locationText &&
            !!page.categoryId,
        promote: completedActions.keys.includes('tip_promote'),
        account: Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_payment__["a" /* isAccountConnected */])(page, paymentDetails),
        page_duration: completedActions.keys.includes('tip_page_duration'),
        advertise_cause: completedActions.keys.includes('tip_advertise_cause'),
        personalise_image: completedActions.keys.includes('tip_personalise_image'),
    };
}
function tipClick(tipName, isComplete) {
    return isComplete ? inactiveTipClick(tipName) : activeTipClick(tipName);
}
function uploadProfilePhoto(type) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["k" /* UPLOAD_PROFILE_PHOTO */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: type,
                page_section: 'admin > tips > profile photo',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function activeTipClick(tipName) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* TIP_SELECTED */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: tipName,
                page_section: 'admin > tips',
                actor_id: 'on',
                actor_sources: 'check box',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function inactiveTipClick(tipName) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* TIP_SELECTED */],
        meta: {
            analytics: {
                event: 'click',
                subtype: 'inactive button',
                event_value: tipName,
                page_section: 'admin > tips',
                actor_id: 'off',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function skipSlide(slideName) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* SKIP_SLIDE */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: 'skip this',
                page_section: "admin > tips > " + slideName,
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function viewSlide(slideName) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* VIEW_SLIDE */],
        meta: {
            analytics: {
                event: 'page view',
                subtype: 'admin',
                event_value: slideName,
                page_section: 'admin > tips',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function closeShareModal(pageSection) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* CLOSE_SHARE_MODAL */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: 'x',
                page_section: "admin > tips > " + pageSection,
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function openFundsModal() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* OPEN_FUNDS_MODAL */],
        meta: {
            analytics: {
                event: 'page view',
                subtype: 'admin',
                event_value: 'understand funds',
                page_section: 'admin > tips',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function closeFundsModal(eventValue) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CLOSE_FUNDS_MODAL */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: eventValue,
                page_section: 'admin > tips > understand funds',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function modifyTarget() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* MODIFY_TARGET */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'hyperlink',
                event_value: 'modify your target',
                page_section: 'admin > tips > understand funds',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function moreAboutFees() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MORE_ABOUT_FEES */],
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'hyperlink',
                event_value: 'more about fees',
                page_section: 'admin > tips > understand funds',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
var calculcateTotalCount = function (events) {
    return events.reduce(function (acc, event) { return acc + event.count; }, 0);
};
function getStat(_a, apiCall) {
    var _this = this;
    var type = _a.type, startDate = _a.startDate, endDate = _a.endDate;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, result, cleanedData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* STAT_REQUEST */] });
                    id = getState().page.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiCall({ projectId: id, startDate: startDate, endDate: endDate })];
                case 2:
                    result = _a.sent();
                    cleanedData = Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_graphTransforms__["a" /* transformStatDataForGraph */])(result);
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* STAT_REQUEST_SUCCESS */],
                        payload: {
                            type: type,
                            value: calculcateTotalCount(result),
                            data: cleanedData,
                        },
                    });
                    return [2 /*return*/, result];
                case 3:
                    e_1 = _a.sent();
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* STAT_REQUEST_FAILURE */],
                        payload: {
                            type: type,
                        },
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function getPageViews(_a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    return getStat({ type: 'views', startDate: startDate, endDate: endDate }, __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_magpie__["a" /* getPageViews */]);
}
function getShares(_a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    return getStat({ type: 'shares', startDate: startDate, endDate: endDate }, __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_magpie__["b" /* getShares */]);
}
var DEFAULT_START_DATE = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_1_date_fns_sub_days___default()(new Date(), 30), 'YYYY-MM-DD');
function getDonations(_a) {
    var _this = this;
    var _b = _a.startDate, startDate = _b === void 0 ? DEFAULT_START_DATE : _b;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* STAT_REQUEST */] });
                    id = getState().page.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_activities__["b" /* getSupporters */])(id, 1, 1, startDate)];
                case 2:
                    result = _a.sent();
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* STAT_REQUEST_SUCCESS */],
                        payload: {
                            type: 'donations',
                            value: result.totalCount,
                        },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* STAT_REQUEST_FAILURE */],
                        payload: {
                            type: 'donations',
                        },
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),

/***/ "./src/redux/modules/dashboard/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TIP_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SKIP_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_SHARE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return VIEW_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPEN_FUNDS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_FUNDS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODIFY_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MORE_ABOUT_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STAT_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STAT_REQUEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPLOAD_PROFILE_PHOTO; });
var TIP_SELECTED = 'TIP_SELECTED';
var SKIP_SLIDE = 'SKIP_SLIDE';
var CLOSE_SHARE_MODAL = 'CLOSE_SHARE_MODAL';
var VIEW_SLIDE = 'VIEW_SLIDE';
var OPEN_FUNDS_MODAL = 'OPEN_FUNDS_MODAL';
var CLOSE_FUNDS_MODAL = 'CLOSE_FUNDS_MODAL';
var MODIFY_TARGET = 'MODIFY_TARGET';
var MORE_ABOUT_FEES = 'MORE_ABOUT_FEES';
var STAT_REQUEST = 'STAT_REQUEST';
var STAT_REQUEST_SUCCESS = 'STAT_REQUEST_SUCCESS';
var STAT_REQUEST_FAILURE = 'STAT_REQUEST_FAILURE';
var UPLOAD_PROFILE_PHOTO = 'UPLOAD_PROFILE_PHOTO';


/***/ }),

/***/ "./src/redux/modules/dashboard/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/dashboard/reducer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/dashboard/actions.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["h"]; });
/* unused harmony reexport activeTipClick */
/* unused harmony reexport inactiveTipClick */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });
/* unused harmony reexport openFundsModal */
/* unused harmony reexport closeFundsModal */
/* unused harmony reexport modifyTarget */
/* unused harmony reexport moreAboutFees */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["i"]; });

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);



/***/ }),

/***/ "./src/redux/modules/dashboard/reducer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/redux/modules/dashboard/constants.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var inititalState = {
    views: null,
    shares: null,
    donations: null,
};
function reducer(state, action) {
    if (state === void 0) { state = inititalState; }
    var _a, _b, _c;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* STAT_REQUEST_SUCCESS */]:
            var type = action.payload.type;
            var dataArrayType = type + "Data";
            return __assign({}, state, (_a = {}, _a[type] = action.payload.value, _a[dataArrayType] = action.payload.data, _a));
        case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STAT_REQUEST_FAILURE */]:
            var type = action.payload.type;
            var dataArrayType = type + "Data";
            if (type !== 'donations') {
                return __assign({}, state, (_b = {}, _b[type] = '-', _b[dataArrayType] = [], _b));
            }
            return __assign({}, state, (_c = {}, _c[type] = '-', _c));
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/friends.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFriends */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function getFriends() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'FRIENDS_REQUEST' });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getTaggableFriends()];
                case 2:
                    response = _a.sent();
                    dispatch({ type: 'FRIENDS_SUCCESS', payload: response.data });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({ type: 'FRIENDS_FAILURE', error: true, payload: error_1 });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function getTaggableFriends() {
    return new Promise(function (resolve, reject) {
        // todo: move FB API call to a helper function
        FB.api('/me/taggable_friends?limit=5000', function (response) {
            if (response && response.error) {
                reject(response);
            }
            resolve(response);
        });
    });
}
var initialState = {
    items: [],
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'FRIENDS_SUCCESS':
            return __assign({}, state, { items: action.payload.map(function (friend) { return ({
                    avatar: friend.picture.data.url,
                    name: friend.name,
                    friendId: friend.id,
                }); }) });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/funds/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getFundsData;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeWithdrawalSuccessfulAlert;
/* harmony export (immutable) */ __webpack_exports__["e"] = withdrawFunds;
/* harmony export (immutable) */ __webpack_exports__["d"] = openConfirmationModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeConfirmationModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_funds__ = __webpack_require__("./src/helpers/api/funds.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_funds__ = __webpack_require__("./src/helpers/funds.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_payment__ = __webpack_require__("./src/helpers/payment.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function getFundsData() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, _a, amountRaised, id, fundsReleaseMode, finishedAt, result, fundsStatus, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    _a = state.page, amountRaised = _a.amountRaised, id = _a.id, fundsReleaseMode = _a.fundsReleaseMode, finishedAt = _a.finishedAt;
                    // Funds data cannot be obtained for pre flexible payments projects
                    if (fundsReleaseMode === 'OnCompletion') {
                        return [2 /*return*/];
                    }
                    dispatch({ type: 'FUNDS_INFO_REQUEST' });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_funds__["a" /* getFundsInfo */])(id)];
                case 2:
                    result = _b.sent();
                    fundsStatus = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_funds__["a" /* getFundsStatus */])({
                        fundsResponse: result,
                        finishedAt: finishedAt,
                        amountRaised: amountRaised,
                        isAccountConnected: Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_payment__["a" /* isAccountConnected */])(state.page, state.paymentDetails),
                    });
                    if (!result) {
                        throw new Error('No result from funds request.');
                    }
                    dispatch({
                        type: 'FUNDS_INFO_SUCCESS',
                        payload: __assign({}, result, { status: fundsStatus }),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    dispatch({
                        type: 'FUNDS_INFO_FAILURE',
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function closeWithdrawalSuccessfulAlert() {
    return { type: 'CLOSE_WITHDRAWAL_SUCCESSFUL_ALERT' };
}
function withdrawFunds() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'WITHDRAW_FUNDS_REQUEST',
                    });
                    state = getState();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_funds__["b" /* requestWithdrawal */])(state.page.id, state.funds.amountAvailable)];
                case 2:
                    _a.sent();
                    dispatch({
                        type: 'WITHDRAW_FUNDS_SUCCESS',
                    });
                    dispatch(getFundsData());
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    dispatch({
                        type: 'WITHDRAW_FUNDS_FAILURE',
                        payload: e_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function openConfirmationModal() {
    return {
        type: 'OPEN_CONFIRMATION_MODAL',
    };
}
function closeConfirmationModal() {
    return {
        type: 'CLOSE_CONFIRMATION_MODAL',
    };
}


/***/ }),

/***/ "./src/redux/modules/funds/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/funds/reducer.ts");
/* unused harmony reexport FundsState */
/* unused harmony reexport FundsStatus */
/* unused harmony reexport Withdrawal */
/* unused harmony reexport WithdrawalStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/funds/actions.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);




/***/ }),

/***/ "./src/redux/modules/funds/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    confirmationModalOpen: false,
    amountAvailable: 0,
    isLoading: true,
    status: 'NoFunds',
    withdrawals: [],
    withdrawalRequestLoading: false,
    withdrawalSuccessful: false,
    withdrawalFailureCount: 0,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'OPEN_CONFIRMATION_MODAL':
            return __assign({}, state, { confirmationModalOpen: true });
        case 'CLOSE_CONFIRMATION_MODAL':
            return __assign({}, state, { confirmationModalOpen: false });
        case 'FUNDS_INFO_REQUEST':
            return __assign({}, state, { error: undefined, isLoading: true });
        case 'FUNDS_INFO_SUCCESS':
            return __assign({}, state, { isLoading: false, status: action.payload.status, amountAvailable: action.payload.amountAvailable, withdrawalAvailableDate: action.payload.withdrawalAvailableDate, withdrawals: action.payload.withdrawals, withdrawalFailureCount: action.payload.withdrawals.filter(function (x) { return x.status === 'Failed'; }).length });
        case 'FUNDS_INFO_FAILURE':
            return __assign({}, state, { error: action.payload, isLoading: false });
        case 'CLOSE_WITHDRAWAL_SUCCESSFUL_ALERT':
            return __assign({}, state, { withdrawalSuccessful: false });
        case 'WITHDRAW_FUNDS_REQUEST':
            return __assign({}, state, { withdrawalRequestLoading: true });
        case 'WITHDRAW_FUNDS_SUCCESS':
            return __assign({}, state, { withdrawalRequestLoading: false, confirmationModalOpen: false, withdrawalSuccessful: true });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/home/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_EVERYTHING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadFilteredPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changePagesFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadCategoryPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return seeMoreFaq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_discovery__ = __webpack_require__("./src/helpers/api/discovery.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;

var loadHome = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var loadCarousel, loadFiltered, loadActiveCount, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loadCarousel = dispatch(loadCarouselPages());
                loadFiltered = dispatch(loadFilteredPages({ pageNo: 1 }));
                loadActiveCount = dispatch(loadActivePagesCount());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch({
                    type: 'HOME_REQUEST',
                });
                return [4 /*yield*/, Promise.all([loadCarousel, loadFiltered, loadActiveCount])];
            case 2:
                _a.sent();
                dispatch({
                    type: 'HOME_SUCCESS',
                });
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                dispatch({
                    type: 'HOME_FAILURE',
                    payload: e_1,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var loadCarouselPages = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({
                    type: 'CAROUSEL_PAGES_REQUEST',
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_discovery__["d" /* getPromotedPages */])()];
            case 2:
                data = _a.sent();
                dispatch({
                    type: 'CAROUSEL_PAGES_SUCCESS',
                    payload: __assign({}, data),
                });
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                dispatch({ type: 'CAROUSEL_PAGES_FAILURE', error: true, payload: err_1 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var CATEGORY_EVERYTHING_ID = 999;
var loadFilteredPages = function (_a) {
    var _b = _a.pageNo, pageNo = _b === void 0 ? 1 : _b, _c = _a.categoryId, categoryId = _c === void 0 ? CATEGORY_EVERYTHING_ID : _c, _d = _a.locationId, locationId = _d === void 0 ? 0 : _d;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var analytics, data, _a, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (pageNo > 1) {
                        analytics = {
                            event: 'click',
                            subtype: 'button',
                            event_value: 'see more',
                            page_section: 'home > show me',
                        };
                    }
                    dispatch({
                        type: 'FILTERED_PAGES_REQUEST',
                        payload: { pageNo: pageNo, categoryId: categoryId, locationId: locationId },
                        meta: { analytics: analytics },
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!(!locationId || locationId === 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_discovery__["c" /* getPopularPages */])(pageNo, categoryId)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_discovery__["b" /* getPagesNearYou */])(pageNo, categoryId)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    data = _a;
                    dispatch({ type: 'FILTERED_PAGES_SUCCESS', payload: __assign({}, data) });
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _b.sent();
                    dispatch({ type: 'FILTERED_PAGES_FAILURE', error: true, payload: err_2 });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
};
var CATEGORY_PAGE_REQUEST = 'CATEGORY_PAGE_REQUEST';
var GET_STARTED_REQUEST = 'GET_STARTED_REQUEST';
var SEE_MORE_FAQ_REQUEST = 'SEE_MORE_FAQ_REQUEST';
var HOME_PAGE_CARD_SELECTED = 'HOME_PAGE_CARD_SELECTED';
var changePagesFilter = function (selection) { return function (dispatch) {
    var category = selection.category, type = selection.type, location = selection.location;
    dispatch({
        type: 'CHANGE_PAGES_FILTER',
        payload: {
            filter: {
                categoryId: category.id,
                typeId: type.id,
                locationId: location.id,
            },
        },
        meta: {
            analytics: {
                event: 'click',
                subtype: 'button',
                event_value: category.value.toLowerCase() + " > " + type.value.toLowerCase() + " > " + location.value.toLowerCase(),
                page_section: 'home > show me',
            },
        },
    });
    if (type.id === 0) {
        dispatch(loadCarouselPages());
    }
    dispatch(loadFilteredPages({
        pageNo: 1,
        categoryId: category.id,
        locationId: location.id,
    }));
}; };
var loadActivePagesCount = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var data, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: 'ACTIVE_PAGES_COUNT_REQUEST' });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_discovery__["a" /* getActivePagesCount */])()];
            case 2:
                data = _a.sent();
                dispatch({
                    type: 'ACTIVE_PAGES_COUNT_SUCCESS',
                    payload: { activePagesCount: data },
                });
                return [3 /*break*/, 4];
            case 3:
                err_3 = _a.sent();
                dispatch({ type: 'ACTIVE_PAGES_COUNT_FAILURE', error: true, payload: err_3 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var loadCategoryPage = function (_a) {
    var name = _a.name;
    return ({
        type: CATEGORY_PAGE_REQUEST,
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: name.toLowerCase(),
                page_section: 'home',
            },
        },
    });
};
var getStarted = function (_a) {
    var location = _a.location;
    return ({
        type: GET_STARTED_REQUEST,
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: 'get started',
                page_section: location,
            },
        },
    });
};
var seeMoreFaq = function () { return ({
    type: SEE_MORE_FAQ_REQUEST,
    meta: {
        analytics: {
            event: 'link click',
            subtype: 'button',
            event_value: 'see more',
            page_section: 'home > faqs',
        },
    },
}); };
var selectCard = function (_a) {
    var id = _a.id, type = _a.type, url = _a.url, rank = _a.rank, totalCount = _a.totalCount;
    return ({
        type: HOME_PAGE_CARD_SELECTED,
        meta: {
            analytics: {
                event: 'click',
                subtype: 'card',
                event_value: 'crowdfunding card',
                page_section: 'home > show me',
                activity_id: id,
                activity_type: 'crowdfunding_guid',
                content_id: id,
                content_type: 'crowdfunding_guid',
                card_id: type + "-" + id,
                card_url: url,
                card_rank: rank,
                card_count: totalCount,
            },
        },
    });
};


/***/ }),

/***/ "./src/redux/modules/home/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/home/reducer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/home/actions.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);



/***/ }),

/***/ "./src/redux/modules/home/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./src/redux/modules/home/actions.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var initialState = {
    carouselPages: [],
    filteredPages: {
        totalCount: 0,
        pageNo: 1,
        items: [],
    },
    filter: {
        categoryId: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CATEGORY_EVERYTHING_ID */],
        typeId: 0,
        locationId: 0,
    },
    activePagesCount: 0,
    isLoading: false,
    loaded: false,
    error: null,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'HOME_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'HOME_SUCCESS':
            return __assign({}, state, { isLoading: false, loaded: true });
        case 'HOME_FAILURE':
            return __assign({}, state, { isLoading: false, loaded: false, error: action.payload });
        case 'CAROUSEL_PAGES_SUCCESS': {
            var items = action.payload.items || [];
            return __assign({}, state, { carouselPages: items.slice(0, 5) });
        }
        case 'FILTERED_PAGES_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'FILTERED_PAGES_SUCCESS':
            return __assign({}, state, { isLoading: false, filteredPages: {
                    totalCount: action.payload.totalCount,
                    pageNo: action.payload.pageNo,
                    items: action.payload.pageNo === 1
                        ? action.payload.items
                        : state.filteredPages.items.concat(action.payload.items),
                } });
        case 'FILTERED_PAGES_FAILURE':
            return __assign({}, state, { isLoading: false });
        case 'CHANGE_PAGES_FILTER':
            return __assign({}, state, { filter: action.payload.filter });
        case 'ACTIVE_PAGES_COUNT_SUCCESS':
            return __assign({}, state, { activePagesCount: action.payload.activePagesCount });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__supportersAvatar__ = __webpack_require__("./src/redux/modules/supportersAvatar.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ab__ = __webpack_require__("./src/redux/modules/ab.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__friends__ = __webpack_require__("./src/redux/modules/friends.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bank__ = __webpack_require__("./src/redux/modules/bank.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__create__ = __webpack_require__("./src/redux/modules/create.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pageLink__ = __webpack_require__("./src/redux/modules/pageLink.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__story__ = __webpack_require__("./src/redux/modules/story.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__coverPhoto__ = __webpack_require__("./src/redux/modules/coverPhoto.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__photoEditor__ = __webpack_require__("./src/redux/modules/photoEditor.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page__ = __webpack_require__("./src/redux/modules/page/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__richUpdates__ = __webpack_require__("./src/redux/modules/richUpdates/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__supporters__ = __webpack_require__("./src/redux/modules/supporters.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__categories__ = __webpack_require__("./src/redux/modules/categories.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sharePrompts__ = __webpack_require__("./src/redux/modules/sharePrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shareWithFriendsPrompts__ = __webpack_require__("./src/redux/modules/shareWithFriendsPrompts.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__completedActions__ = __webpack_require__("./src/redux/modules/completedActions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__self__ = __webpack_require__("./src/redux/modules/self.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__subscriptions__ = __webpack_require__("./src/redux/modules/subscriptions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__paymentDetails__ = __webpack_require__("./src/redux/modules/paymentDetails.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__alternativeProjects__ = __webpack_require__("./src/redux/modules/alternativeProjects.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__censures__ = __webpack_require__("./src/redux/modules/censures.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__avatars__ = __webpack_require__("./src/redux/modules/avatars.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__home__ = __webpack_require__("./src/redux/modules/home/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__carousel__ = __webpack_require__("./src/redux/modules/carousel.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__dashboard__ = __webpack_require__("./src/redux/modules/dashboard/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__funds__ = __webpack_require__("./src/redux/modules/funds/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__asyncConnect__ = __webpack_require__("./src/redux/modules/asyncConnect/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__stripeVirtualAccount__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__settings__ = __webpack_require__("./src/redux/modules/settings/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__consents__ = __webpack_require__("./src/redux/modules/consents/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__charity__ = __webpack_require__("./src/redux/modules/charity/index.ts");


































var appReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    ab: __WEBPACK_IMPORTED_MODULE_4__ab__["a" /* default */],
    routing: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* routerReducer */],
    form: __WEBPACK_IMPORTED_MODULE_2_redux_form__["g" /* reducer */],
    page: __WEBPACK_IMPORTED_MODULE_12__page__["i" /* default */],
    create: __WEBPACK_IMPORTED_MODULE_7__create__["d" /* default */],
    coverPhoto: __WEBPACK_IMPORTED_MODULE_10__coverPhoto__["a" /* default */],
    createCoverPhotoEditor: __WEBPACK_IMPORTED_MODULE_11__photoEditor__["b" /* default */].bind(null, 'create'),
    editCoverPhotoEditor: __WEBPACK_IMPORTED_MODULE_11__photoEditor__["b" /* default */].bind(null, 'edit'),
    editStripeVerificationDocument: __WEBPACK_IMPORTED_MODULE_11__photoEditor__["b" /* default */].bind(null, 'stripeVerification'),
    story: __WEBPACK_IMPORTED_MODULE_9__story__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_6__bank__["b" /* default */],
    pageLink: __WEBPACK_IMPORTED_MODULE_8__pageLink__["a" /* default */],
    richUpdates: __WEBPACK_IMPORTED_MODULE_13__richUpdates__["a" /* default */],
    supporters: __WEBPACK_IMPORTED_MODULE_14__supporters__["a" /* default */],
    supportersAvatar: __WEBPACK_IMPORTED_MODULE_3__supportersAvatar__["a" /* default */],
    categories: __WEBPACK_IMPORTED_MODULE_15__categories__["a" /* default */],
    sharePrompts: __WEBPACK_IMPORTED_MODULE_16__sharePrompts__["b" /* default */],
    shareWithFriendsPrompts: __WEBPACK_IMPORTED_MODULE_17__shareWithFriendsPrompts__["b" /* default */],
    self: __WEBPACK_IMPORTED_MODULE_19__self__["a" /* default */],
    subscriptions: __WEBPACK_IMPORTED_MODULE_20__subscriptions__["a" /* default */],
    paymentDetails: __WEBPACK_IMPORTED_MODULE_21__paymentDetails__["a" /* default */],
    alternativeProjects: __WEBPACK_IMPORTED_MODULE_22__alternativeProjects__["b" /* default */],
    friends: __WEBPACK_IMPORTED_MODULE_5__friends__["a" /* default */],
    censures: __WEBPACK_IMPORTED_MODULE_23__censures__["b" /* default */],
    avatars: __WEBPACK_IMPORTED_MODULE_24__avatars__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_25__home__["b" /* default */],
    carousel: __WEBPACK_IMPORTED_MODULE_26__carousel__["a" /* default */],
    completedActions: __WEBPACK_IMPORTED_MODULE_18__completedActions__["b" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_27__dashboard__["b" /* default */],
    funds: __WEBPACK_IMPORTED_MODULE_28__funds__["b" /* default */],
    stripeVirtualAccount: __WEBPACK_IMPORTED_MODULE_30__stripeVirtualAccount__["a" /* default */],
    asyncConnect: __WEBPACK_IMPORTED_MODULE_29__asyncConnect__["b" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_31__settings__["a" /* default */],
    consents: __WEBPACK_IMPORTED_MODULE_32__consents__["a" /* default */],
    charity: __WEBPACK_IMPORTED_MODULE_33__charity__["a" /* default */],
    // these reducers are needed so we can inject values into the store during
    // server-side rendering
    location: function (s) {
        if (s === void 0) { s = {}; }
        return s;
    },
});
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    if (action.type === 'DELETE_PAGE_SUCCESS') {
        return appReducer({ routing: state.routing }, action);
    }
    return appReducer(state, action);
});


/***/ }),

/***/ "./src/redux/modules/page/activatePage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = activatePage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_completedActions__ = __webpack_require__("./src/helpers/api/completedActions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__ = __webpack_require__("./src/redux/modules/page/index.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




function activatePage(identityData) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var page, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'ACTIVATE_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    page = getState().page;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_pages__["a" /* activate */])(page.id, identityData)];
                case 2:
                    result = _a.sent();
                    if (!result.activated) return [3 /*break*/, 4];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_completedActions__["b" /* setActionAsComplete */])(page.id, 'tip_publish')];
                case 3:
                    _a.sent();
                    dispatch({ type: 'ACTIVATE_SUCCESS' });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch({
                        type: 'ACTIVATE_FAILURE',
                        error: true,
                        payload: { message: result.reason },
                    });
                    _a.label = 5;
                case 5:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_src_redux_modules_page__["l" /* loadPage */])(page.name));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'ACTIVATE_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    throw new Error('An error has occurred. Please try again.');
                case 7: return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),

/***/ "./src/redux/modules/page/contactOwner.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = openContactOwner;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeContactOwner;
/* harmony export (immutable) */ __webpack_exports__["f"] = openFeedbackThankYou;
/* harmony export (immutable) */ __webpack_exports__["c"] = closeFeedbackThankYou;
/* harmony export (immutable) */ __webpack_exports__["d"] = contactOwner;
/* harmony export (immutable) */ __webpack_exports__["g"] = setRecaptcha;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearRecaptcha;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_iam__ = __webpack_require__("./src/helpers/api/iam.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function openContactOwner(returnRoute, pageViewSection, pageSection, friendFeedback, subjectPlaceHolder, messagePlaceholder) {
    if (friendFeedback === void 0) { friendFeedback = false; }
    if (true && !Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_iam__["b" /* isLoggedIn */])()) {
        var returnUrl = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_config__["CROWDFUNDING_BASE_URI"] + "/" + returnRoute);
        window.location.replace(__WEBPACK_IMPORTED_MODULE_0_config__["LOGIN_URI_SSO"] + "?returnUrl=" + returnUrl);
        return { type: 'LOGIN_CONTACT_OWNER' };
    }
    return {
        type: friendFeedback ? 'OPEN_FEEDBACK_OWNER' : 'OPEN_CONTACT_OWNER',
        payload: {
            pageViewSection: pageViewSection,
            pageSection: pageSection,
            subjectPlaceHolder: subjectPlaceHolder,
            messagePlaceholder: messagePlaceholder,
        },
    };
}
function closeContactOwner() {
    return { type: 'CLOSE_CONTACT_OWNER' };
}
function openFeedbackThankYou() {
    return { type: 'OPEN_FEEDBACK_THANK_YOU' };
}
function closeFeedbackThankYou() {
    return { type: 'CLOSE_FEEDBACK_THANK_YOU' };
}
function contactOwner(_a) {
    var _this = this;
    var id = _a.id, email = _a.email, message = _a.message, subject = _a.subject, recaptcha = _a.recaptcha;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'CONTACT_OWNER_REQUEST' });
                    message = "Email: " + (email || 'N/A') + "<br/><br/>Message:<br/><br/>" + message;
                    payload = {
                        projectId: id,
                        subject: subject,
                        message: message,
                        reCaptchaResponse: recaptcha,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_common__["g" /* post */])("/projects/" + id + "/emails", payload, {
                            withCredentials: true,
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        dispatch({ type: 'CONTACT_OWNER_FAILURE' });
                    }
                    else {
                        dispatch({ type: 'CONTACT_OWNER_SUCCESS' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({ type: 'CONTACT_OWNER_FAILURE' });
                    throw err_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function setRecaptcha(response) {
    return { type: 'SET_RECAPTCHA', response: response };
}
function clearRecaptcha() {
    return { type: 'CLEAR_RECAPTCHA' };
}


/***/ }),

/***/ "./src/redux/modules/page/deletePage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = openDeletePageModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeDeletePageModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = deletePage;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeDeletePageSuccessAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


function openDeletePageModal() {
    return {
        type: 'OPEN_DELETE_PAGE_MODAL',
        meta: {
            analytics: {
                event: 'page view',
                subtype: 'admin',
                event_value: 'delete my page',
                page_section: 'admin > edit',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function closeDeletePageModal(_a) {
    var eventValue = _a.eventValue;
    return {
        type: 'CLOSE_DELETE_PAGE_MODAL',
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: eventValue,
                page_section: 'admin > edit > delete my page',
                content_type: 'crowdfunding_guid',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function deletePage() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, name, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'DELETE_PAGE_REQUEST' });
                    state = getState();
                    name = state.page.name;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_pages__["c" /* delPage */])({ name: name })];
                case 2:
                    _a.sent();
                    dispatch({ type: 'DELETE_PAGE_SUCCESS' });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])('/'));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'DELETE_PAGE_FAILURE',
                        payload: err_1,
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function closeDeletePageSuccessAlert() {
    return { type: 'CLOSE_DELETE_PAGE_SUCCESS_ALERT' };
}


/***/ }),

/***/ "./src/redux/modules/page/donate.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = donate;
function donate() {
    return {
        type: 'DONATE',
        meta: {
            analytics: {
                omitKinesis: true,
                event: 'link click',
                subtype: 'button',
                event_value: 'donate',
                page_section: '',
                activity_type: 'crowdfunding_guid',
                actor_source: 'ownerUserId',
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/page/encourageShare.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export openEncourageShare */
/* unused harmony export closeEncourageShare */
function openEncourageShare() {
    return {
        type: 'OPEN_ENCOURAGE_SHARE',
        meta: {
            analytics: {
                event: 'page view',
                subtype: 'share prompt',
                activity_type: 'crowdfunding_guid',
                page_section: 'page > share prompt',
            },
        },
    };
}
function closeEncourageShare() {
    return {
        type: 'CLOSE_ENCOURAGE_SHARE',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'dismiss',
                event_value: 'Skip > share prompt',
                page_section: 'page > share prompt',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/page/impressions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pageClosedPromptOpened */
/* harmony export (immutable) */ __webpack_exports__["a"] = crossSellBannerImpression;
function pageClosedPromptOpened() {
    return {
        type: 'PAGE_CLOSED_PROMPT_OPENED',
        meta: {
            analytics: {
                event: 'impression',
                subtype: 'banner',
                event_value: 'inspired',
                page_section: 'page > page banner > inspired',
                version_id: 'active',
                version_type: 'banner type',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function crossSellBannerImpression() {
    return {
        type: 'CROSS_SELL_BANNER_IMPRESSION',
        meta: {
            analytics: {
                event: 'impression',
                subtype: 'banner',
                event_value: 'inspired',
                page_section: 'page > page banner > inspired',
                version_id: 'cross sell',
                version_type: 'banner type',
                activity_type: 'crowdfunding_guid',
                content_type: 'crowdfunding_guid',
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/page/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/page/reducer.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* unused harmony reexport PageState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activatePage__ = __webpack_require__("./src/redux/modules/page/activatePage.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__activatePage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contactOwner__ = __webpack_require__("./src/redux/modules/page/contactOwner.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__contactOwner__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__donate__ = __webpack_require__("./src/redux/modules/page/donate.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__donate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__encourageShare__ = __webpack_require__("./src/redux/modules/page/encourageShare.ts");
/* unused harmony reexport openEncourageShare */
/* unused harmony reexport closeEncourageShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__impressions__ = __webpack_require__("./src/redux/modules/page/impressions.ts");
/* unused harmony reexport pageClosedPromptOpened */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__impressions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loadPage__ = __webpack_require__("./src/redux/modules/page/loadPage.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__loadPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation__ = __webpack_require__("./src/redux/modules/page/navigation.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["a"]; });
/* unused harmony reexport scrollTo */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__navigation__["f"]; });
/* unused harmony reexport viewProTips */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__profilePicture__ = __webpack_require__("./src/redux/modules/page/profilePicture.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_8__profilePicture__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_8__profilePicture__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__share__ = __webpack_require__("./src/redux/modules/page/share.ts");
/* unused harmony reexport ShareActionOptions */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_9__share__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shareMenu__ = __webpack_require__("./src/redux/modules/page/shareMenu.ts");
/* unused harmony reexport openShareMenu */
/* unused harmony reexport closeShareMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__updatePage__ = __webpack_require__("./src/redux/modules/page/updatePage.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__updatePage__["c"]; });
/* unused harmony reexport PatchPageData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__verification__ = __webpack_require__("./src/redux/modules/page/verification.ts");
/* unused harmony reexport verificationStatusUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deletePage__ = __webpack_require__("./src/redux/modules/page/deletePage.ts");
/* unused harmony reexport openDeletePageModal */
/* unused harmony reexport closeDeletePageModal */
/* unused harmony reexport deletePage */
/* unused harmony reexport closeDeletePageSuccessAlert */
















/***/ }),

/***/ "./src/redux/modules/page/loadPage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_redux_modules_self__ = __webpack_require__("./src/redux/modules/self.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_paymentDetails__ = __webpack_require__("./src/redux/modules/paymentDetails.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_alternativeProjects__ = __webpack_require__("./src/redux/modules/alternativeProjects.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_redux_modules_completedActions__ = __webpack_require__("./src/redux/modules/completedActions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_richUpdates__ = __webpack_require__("./src/redux/modules/richUpdates/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_modules_supporters__ = __webpack_require__("./src/redux/modules/supporters.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_redux_modules_stripeVirtualAccount_actions__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_redux_modules_funds__ = __webpack_require__("./src/redux/modules/funds/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_last__ = __webpack_require__("./node_modules/lodash/last.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_helpers_api_categories__ = __webpack_require__("./src/helpers/api/categories.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_redux_modules_ab__ = __webpack_require__("./src/redux/modules/ab.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};















function loadPage(name) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data_1, categoriesResponse, chosenCategory, pathname, state, promises, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'PAGE_REQUEST',
                        payload: { name: name },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_7_src_helpers_api_pages__["d" /* getByName */])(name)];
                case 2:
                    data_1 = _a.sent();
                    if (!(!data_1 ||
                        data_1.status === 'Declined' ||
                        data_1.status === 'Cancelled' ||
                        data_1.status === 'Abandoned' ||
                        data_1.sunset)) return [3 /*break*/, 6];
                    if (!(data_1 && data_1.categoryId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_12_src_helpers_api_categories__["a" /* getAll */])()];
                case 3:
                    categoriesResponse = _a.sent();
                    chosenCategory = categoriesResponse.categories.find(function (category) { return category.id === data_1.categoryId; });
                    if (!chosenCategory) {
                        dispatch({
                            type: 'PAGE_FAILURE',
                            error: true,
                            payload: {
                                message: "Page " + name + " is not available",
                                type: '404',
                                reason: data_1 ? (data_1.sunset ? 'sunset' : data_1.status) : '404',
                            },
                        });
                    }
                    else {
                        dispatch({
                            type: 'PAGE_FAILURE',
                            error: true,
                            payload: {
                                message: "Page " + name + " is not available",
                                type: '302',
                                reason: data_1 ? (data_1.sunset ? 'sunset' : data_1.status) : '302',
                            },
                        });
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])(chosenCategory.url, true));
                    }
                    return [2 /*return*/];
                case 4:
                    dispatch({
                        type: 'PAGE_FAILURE',
                        error: true,
                        payload: {
                            message: "Page " + name + " is not available",
                            type: '404',
                            reason: data_1 ? (data_1.sunset ? 'sunset' : data_1.status) : '404',
                        },
                    });
                    _a.label = 5;
                case 5: return [2 /*return*/];
                case 6:
                    pathname = getState().routing.location.pathname;
                    if (detectRedirects(data_1, pathname, dispatch)) {
                        return [2 /*return*/];
                    }
                    state = __assign({}, data_1);
                    state.isCreateWizardOpen = isCreateWizardOpen(pathname);
                    state.rateLimitReached =
                        (data_1.totalVerificationsFailed || 0) >= __WEBPACK_IMPORTED_MODULE_13_config__["BANK_VERIFICATION_RATE_LIMIT"];
                    dispatch({ type: 'PAGE_SUCCESS', payload: state });
                    promises = [
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_src_redux_modules_supporters__["b" /* loadSupporters */])({ pageId: data_1.id })),
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_src_redux_modules_richUpdates__["d" /* loadUpdates */])({ pageId: data_1.id })),
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_src_redux_modules_self__["b" /* loadUserDetails */])()),
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_src_redux_modules_alternativeProjects__["c" /* loadAlternativeProjects */])(data_1.id)),
                    ];
                    // HACK enroll only new new pages owners delete after finishing the AB test.
                    if (data_1.isOwnerRequested) {
                        promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_src_redux_modules_completedActions__["c" /* loadCompletedActions */])()));
                        promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_src_redux_modules_ab__["b" /* enrol */])('growth_share_with_friends_prompt')));
                        if (data_1.verificationStatus !== 'UnverifiedPayment' ||
                            data_1.stripeVirtualAccountGuid) {
                            promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_src_redux_modules_paymentDetails__["b" /* loadPaymentDetails */])()));
                        }
                        if (data_1.stripeVirtualAccountGuid) {
                            promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_src_redux_modules_stripeVirtualAccount_actions__["b" /* getVirtualAccountStatus */])()));
                        }
                        promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_src_redux_modules_funds__["c" /* getFundsData */])()));
                    }
                    else {
                        promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_src_redux_modules_ab__["b" /* enrol */])('growth_give_feedback_prompt')));
                    }
                    // All the promises have their own *_FAILURE actions, so we can
                    // safely ignore all errors here. However, we want to wait for
                    // all promises to execute to completion until we resolve
                    // from this function, hence we catch and swallow all
                    // exceptions on the individual promise level.
                    return [4 /*yield*/, Promise.all(promises.map(function (p) { return p.catch(function () { }); }))];
                case 7:
                    // All the promises have their own *_FAILURE actions, so we can
                    // safely ignore all errors here. However, we want to wait for
                    // all promises to execute to completion until we resolve
                    // from this function, hence we catch and swallow all
                    // exceptions on the individual promise level.
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    err_1 = _a.sent();
                    if (err_1.status === '404') {
                        dispatch({
                            type: 'PAGE_FAILURE',
                            error: true,
                            payload: { message: 'Page is not available', type: '404' },
                        });
                    }
                    else {
                        dispatch({
                            type: 'PAGE_FAILURE',
                            error: true,
                            payload: err_1,
                        });
                    }
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
}
function isCreateWizardOpen(pathname) {
    var paths = ['coverphoto', 'story', 'pagelink'];
    return pathname.split('/').some(function (p) { return paths.includes(p); });
}
function detectRedirects(page, pathname, dispatch) {
    // redirect from /{pageName} to /{pageName}/coverphoto for pages in "Lead" status
    if (page.isOwnerRequested &&
        page.status === 'Lead' &&
        !isWizardPath(pathname)) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name + "/coverphoto"));
        return true;
    }
    if (page.isOwnerRequested &&
        !page.problem &&
        !page.richStory &&
        !isOneOfWizardSteps(pathname, ['coverphoto', 'story'])) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name + "/story"));
        return true;
    }
    var pathSegments = pathname.split('/').filter(function (p) { return p.length > 0; });
    // redirect from /{pageName}/payment to /{pageName} for pages not in UnverifiedPayment verification status
    if (pathSegments.includes('payment') &&
        page.verificationStatus !== 'UnverifiedPayment') {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    if (!page.isOwnerRequested &&
        (isWizardPath(pathname) || isOwnerTabPath(pathname))) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    if (pathSegments.includes('edit') && !canNavigateToEdit(page)) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    if (__WEBPACK_IMPORTED_MODULE_11_lodash_last___default()(pathSegments) === 'funds' && !canNavigateToFunds(page)) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    if ((pathSegments.includes('dashboard') || pathSegments.includes('settings')) &&
        Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_page__["f" /* isPendingApproval */])(page)) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    if (pathSegments.includes('update') && !Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_page__["b" /* canPostUpdates */])(page)) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
        return true;
    }
    return false;
}
function isWizardPath(pathname) {
    var segments = pathname.split('/').filter(function (p) { return p.length > 0; });
    var wizardSteps = ['coverphoto', 'story', 'pagelink', 'confirmidentity'];
    return segments.some(function (s) { return wizardSteps.includes(s); });
}
function isOneOfWizardSteps(pathname, steps) {
    var segments = pathname.split('/').filter(function (p) { return p.length > 0; });
    return segments.some(function (s) { return steps.includes(s); });
}
function isOwnerTabPath(pathname) {
    var segments = pathname.split('/').filter(function (p) { return p.length > 0; });
    var ownerTabs = ['edit', 'dashboard', 'settings', 'funds'];
    return segments.some(function (s) { return ownerTabs.includes(s); });
}
function canNavigateToEdit(page) {
    return page.isOwnerRequested && !Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_page__["d" /* isClosed */])(page);
}
function canNavigateToFunds(page) {
    return (page.isOwnerRequested &&
        Object(__WEBPACK_IMPORTED_MODULE_8_src_helpers_page__["e" /* isEligibleForFlexiblePayments */])(page) &&
        !page.refundedDate);
}


/***/ }),

/***/ "./src/redux/modules/page/navigation.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changeMode;
/* unused harmony export scrollTo */
/* harmony export (immutable) */ __webpack_exports__["d"] = resetScroll;
/* harmony export (immutable) */ __webpack_exports__["c"] = goEdit;
/* harmony export (immutable) */ __webpack_exports__["b"] = createPageLikeThis;
/* harmony export (immutable) */ __webpack_exports__["e"] = setUpBankDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = tipsPromptClosed;
/* unused harmony export viewProTips */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");

var modeMapping = ['page view', 'edit', 'page settings'];
function changeMode(mode) {
    return {
        type: 'CHANGE_MODE',
        mode: mode,
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: modeMapping[mode],
                page_section: "admin page > " + modeMapping[mode],
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function scrollTo(name) {
    return {
        type: 'SCROLL_TO',
        name: name,
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: "add project " + name,
                page_section: "admin page > add project " + name,
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function resetScroll() {
    return {
        type: 'RESET_SCROLL',
    };
}
function goEdit(scrollToElement) {
    return function (dispatch, getState) {
        var state = getState();
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + state.page.name + "/edit"));
        if (scrollToElement) {
            dispatch(scrollTo(scrollToElement));
        }
    };
}
function createPageLikeThis() {
    return {
        type: 'CREATE_PAGE_LIKE_THIS_REQUEST',
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: 'create your page',
                page_section: 'page > page banner > inspired',
                version_id: 'active',
                version_type: 'banner type',
                activity_type: 'crowdfunding_guid',
                content_type: 'crowdfunding_guid',
            },
        },
    };
}
function setUpBankDetails() {
    return function (dispatch, getState) {
        var state = getState();
        dispatch({
            type: 'SET_UP_BANK_DETAILS',
            meta: {
                analytics: {
                    event: 'click',
                    subtype: 'button',
                    event_value: 'set up funds',
                    page_section: 'page creation > set up funds',
                    activity_type: 'crowdfunding_guid',
                },
            },
        });
        Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + state.page.name + "/payment");
    };
}
function tipsPromptClosed() {
    return {
        type: 'TIPS_PROMPT_CLOSED',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'button',
                event_value: 'x',
                page_section: 'page > tip prompt',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function viewProTips() {
    return {
        type: 'VIEW_PRO_TIPS',
        meta: {
            analytics: {
                event: 'link click',
                subtype: 'button',
                event_value: 'go to pro tips',
                page_section: 'page > tip prompt',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/page/profilePicture.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateProfilePicture;
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadFacebookProfilePicture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_iam__ = __webpack_require__("./src/helpers/api/iam.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function updateProfilePicture(imagePayload) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var userId, newProfileImage, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'PROFILE_IMAGE_REQUEST',
                        meta: {
                            analytics: {
                                event: 'link click',
                                subtype: 'button',
                                event_value: 'save and continue',
                                page_section: 'admin > tips > profile photo',
                                activity_type: 'crowdfunding_guid',
                                content_type: 'crowdfunding_guid',
                            },
                        },
                    });
                    userId = getState().page.ownerUserId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_iam__["a" /* changeProfilePicture */])({
                            userId: userId,
                            imagePayload: imagePayload,
                        })];
                case 2:
                    newProfileImage = _a.sent();
                    dispatch({
                        type: 'PROFILE_IMAGE_SUCCESS',
                        payload: newProfileImage,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'PROFILE_IMAGE_FAILURE',
                        payload: err_1,
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function uploadFacebookProfilePicture(imageUrl) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var userId, newProfileImage, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'PROFILE_IMAGE_REQUEST',
                        meta: {
                            analytics: {
                                event: 'link click',
                                subtype: 'button',
                                event_value: 'save and continue',
                                page_section: 'admin > tips > profile photo',
                                activity_type: 'crowdfunding_guid',
                                content_type: 'crowdfunding_guid',
                            },
                        },
                    });
                    userId = getState().page.ownerUserId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_iam__["c" /* uploadProfilePicFacebook */])({
                            userId: userId,
                            imageUrl: imageUrl,
                        })];
                case 2:
                    newProfileImage = _a.sent();
                    dispatch({
                        type: 'PROFILE_IMAGE_SUCCESS',
                        payload: newProfileImage,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    dispatch({
                        type: 'PROFILE_IMAGE_FAILURE',
                        payload: err_2,
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),

/***/ "./src/redux/modules/page/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var initialState = {
    id: '',
    name: '',
    status: 'Lead',
    createdAt: '',
    latitude: 0,
    longitude: 0,
    isOwnerRequested: false,
    ownerUserId: '',
    ownerEmailAddress: '',
    ownerName: '',
    pitchBecause: '',
    pitchFor: '',
    targetAmount: 0,
    sunset: false,
    socialShareUrl: '',
    facebookCommentsUrl: '',
    verificationStatus: 'UnverifiedPayment',
    donationCauseId: '',
    fundsReleaseMode: 'OnDemand',
    isReviewed: false,
    isUpdating: false,
    isDeletePageModalOpen: false,
    hasPageDeletionFailed: false,
    isCreateWizardOpen: false,
    isRequesting: false,
    isActivating: false,
    isShareMenuOpen: false,
    isContactingOwnerWindowOpen: false,
    isFeedbackOwnerWindowOpen: false,
    isFeedbackThankYouWindowOpen: false,
    contactOwnerPageViewSection: '',
    contactOwnerPageSection: '',
    hasPageBeenDeleted: false,
    mode: 0,
    amountRaised: 0,
    amountPledged: 0,
    targetCurrency: 'GBP',
    isEncourageShareOpen: false,
    renderAfter: 28000,
    country: __WEBPACK_IMPORTED_MODULE_0_src_helpers_currencyMap__["d" /* currencyToCountryCodeMap */].GBP,
    richStory: [],
    charityId: null,
    tipScheme: null,
    rateLimitReached: false,
    pageOwnerOptimizationFeatureToggle: false,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'CREATE_START':
            return initialState;
        case 'PAGE_REQUEST':
            return __assign({}, state, { isRequesting: true, failType: undefined });
        case 'PAGE_SUCCESS': {
            var page = __assign({}, action.payload, { story: action.payload.problem });
            return __assign({}, state, page, { country: __WEBPACK_IMPORTED_MODULE_0_src_helpers_currencyMap__["d" /* currencyToCountryCodeMap */][page.targetCurrency], isRequesting: false });
        }
        case 'PAGE_FAILURE':
            return __assign({}, state, { isRequesting: false, failType: action.payload.type || '500', categoryId: action.payload.categoryId });
        case 'ACTIVATE_REQUEST':
            return __assign({}, state, { isActivating: true });
        case 'ACTIVATE_SUCCESS':
            return __assign({}, state, { mode: 0, status: 'Active', isActivating: false });
        case 'ACTIVATE_FAILURE':
            return __assign({}, state, { isActivating: false, error: action.error });
        case 'CHANGE_MODE':
            return __assign({}, state, { mode: action.mode });
        case 'SCROLL_TO':
            return __assign({}, state, { scrollTo: action.name });
        case 'RESET_SCROLL':
            return __assign({}, state, { scrollTo: undefined });
        case 'UPDATE_REQUEST':
            return __assign({}, state, { isUpdating: true });
        case 'UPDATE_SUCCESS':
            return __assign({}, state, action.payload, { mode: 0, isUpdating: false, socialShareImage: action.payload.socialShareImage &&
                    action.payload.socialShareImage.name });
        case 'UPDATE_FAILURE':
            return __assign({}, state, { isUpdating: false, error: 'Please write your story' });
        case 'OPEN_SHARE_MENU':
            return __assign({}, state, { isShareMenuOpen: true });
        case 'CLOSE_SHARE_MENU':
            return __assign({}, state, { isShareMenuOpen: false });
        case 'CONTACT_OWNER_REQUEST':
            return __assign({}, state);
        case 'CONTACT_OWNER_SUCCESS':
            return __assign({}, state, { isContactingOwnerWindowOpen: false, isFeedbackOwnerWindowOpen: false });
        case 'CONTACT_OWNER_FAILURE':
            return __assign({}, state);
        case 'OPEN_CONTACT_OWNER':
            return __assign({}, state, { isContactingOwnerWindowOpen: true, isFeedbackOwnerWindowOpen: false, contactOwnerPageViewSection: action.payload.pageViewSection, contactOwnerPageSection: action.payload.pageSection, contactOwnerSubjectPlaceHolder: action.payload.subjectPlaceHolder, contactOwnerMessagePlaceholder: action.payload.messagePlaceholder });
        case 'OPEN_FEEDBACK_OWNER':
            return __assign({}, state, { isContactingOwnerWindowOpen: false, isFeedbackOwnerWindowOpen: true, contactOwnerPageViewSection: action.payload.pageViewSection, contactOwnerPageSection: action.payload.pageSection, contactOwnerSubjectPlaceHolder: action.payload.subjectPlaceHolder, contactOwnerMessagePlaceholder: action.payload.messagePlaceholder });
        case 'CLOSE_CONTACT_OWNER':
            return __assign({}, state, { isContactingOwnerWindowOpen: false, isFeedbackOwnerWindowOpen: false });
        case 'OPEN_FEEDBACK_THANK_YOU':
            return __assign({}, state, { isFeedbackThankYouWindowOpen: true });
        case 'CLOSE_FEEDBACK_THANK_YOU':
            return __assign({}, state, { isFeedbackThankYouWindowOpen: false });
        case 'CLOSE_ENCOURAGE_SHARE':
            return __assign({}, state, { isEncourageShareOpen: false });
        case 'OPEN_ENCOURAGE_SHARE':
            return __assign({}, state, { isEncourageShareOpen: true });
        case 'SET_RECAPTCHA':
            return __assign({}, state, { recaptcha: action.response });
        case 'CLEAR_RECAPTCHA':
            return __assign({}, state, { recaptcha: '' });
        case 'SHARE_ON_FB':
            return __assign({}, state, { details: action.payload.details });
        case 'PROFILE_IMAGE_SUCCESS':
            return __assign({}, state, { ownerProfileImageUrl: action.payload });
        case 'UPDATE_VERIFICATION_STATUS':
            return __assign({}, state, { verificationStatus: action.payload });
        case 'OPEN_DELETE_PAGE_MODAL':
            return __assign({}, state, { isDeletePageModalOpen: true, hasPageDeletionFailed: false });
        case 'CLOSE_DELETE_PAGE_MODAL':
            return __assign({}, state, { isDeletePageModalOpen: false });
        case 'DELETE_PAGE_SUCCESS':
            return __assign({}, state, { status: 'Cancelled', isDeletePageModalOpen: false, hasPageBeenDeleted: true });
        case 'DELETE_PAGE_FAILURE':
            return __assign({}, state, { isDeletePageModalOpen: false, hasPageDeletionFailed: true });
        case 'CLOSE_DELETE_PAGE_SUCCESS_ALERT':
            return __assign({}, state, { hasPageBeenDeleted: false });
        case 'LINK_SUCCESS':
            return __assign({}, state, { name: action.payload.name });
        case 'BANK_FAILURE':
            return __assign({}, state, { rateLimitReached: action.payload.message === 'rateLimitReached' });
        case 'SUBMIT_ID_AND_BANK_STATEMENT':
            return __assign({}, state, { isRequesting: true });
        case 'SUBMIT_ID_AND_BANK_STATEMENT_SUCCESS':
            return __assign({}, state, { verificationStatus: action.payload, isRequesting: false });
        case 'SUBMIT_ID_AND_BANK_STATEMENT_FAILURE':
            return __assign({}, state, { error: action.error, isRequesting: false });
        case 'REMOVE_ERRORS_AFTER_MODAL_CLOSING':
            return __assign({}, state, { error: false });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/page/share.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = shareOnFacebook;
/* harmony export (immutable) */ __webpack_exports__["f"] = shareOnFacebookOpened;
/* harmony export (immutable) */ __webpack_exports__["e"] = shareOnFacebookCancelled;
/* harmony export (immutable) */ __webpack_exports__["i"] = shareOnTwitter;
/* harmony export (immutable) */ __webpack_exports__["a"] = shareByEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = shareByWhatsApp;
/* harmony export (immutable) */ __webpack_exports__["b"] = shareBySms;
/* harmony export (immutable) */ __webpack_exports__["h"] = shareOnMessenger;
/* harmony export (immutable) */ __webpack_exports__["j"] = sharePageLink;
/* harmony export (immutable) */ __webpack_exports__["k"] = shareQrCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = shareOnLinkedIn;
// TODO: type details
function shareOnFacebook(details) {
    return function (dispatch) {
        dispatch({ type: 'INCREMENT_FACEBOOK_SHARE_COUNT' });
        dispatch({
            type: 'SHARE_ON_FB',
            payload: details,
            meta: {
                analytics: {
                    social_type: 'facebook',
                    event_value: details.eventValue || 'share on facebook',
                    page_section: details.location,
                    social_utm_term: details.shareHash,
                },
            },
        });
    };
}
// TODO: rename to Closed? or should it be the other way around...
// TODO: type details
function shareOnFacebookOpened(details) {
    return {
        type: 'SHARE_ON_FB_CLOSED',
        payload: details,
        meta: {
            analytics: {
                social_type: 'facebook',
                event_value: 'share on facebook closed',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
// TODO: type details
function shareOnFacebookCancelled(details) {
    return function (dispatch) {
        dispatch({ type: 'DECREMENT_FACEBOOK_SHARE_COUNT', details: details });
    };
}
// TODO: type details
function shareOnTwitter(details) {
    return {
        type: 'SHARE_ON_TW',
        payload: details,
        meta: {
            analytics: {
                social_type: 'twitter',
                event_value: 'share on twitter',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function shareByEmail(details) {
    return {
        type: 'SHARE_BY_EMAIL',
        payload: details,
        meta: {
            analytics: {
                social_type: 'email',
                event_value: details.eventValue || 'share on email',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function shareByWhatsApp(details) {
    return {
        type: 'SHARE_BY_WHATSAPP',
        payload: details,
        meta: {
            analytics: {
                social_type: 'whatsapp',
                event_value: 'share on whatsApp',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function shareBySms(details) {
    return {
        type: 'SHARE_BY_SMS',
        payload: details,
        meta: {
            analytics: {
                social_type: 'sms',
                event_value: 'share on sms',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function shareOnMessenger(details) {
    return {
        type: 'SHARE_ON_MESSENGER',
        payload: details,
        meta: {
            analytics: {
                social_type: 'messenger',
                event_value: 'share on Messenger',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function sharePageLink(details) {
    return {
        type: 'SHARE_PAGE_LINK',
        meta: {
            analytics: {
                social_type: 'copy link',
                event_value: 'copy link',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
        details: details,
    };
}
function shareQrCode(details) {
    return {
        type: 'SHARE_QR_CODE',
        payload: details,
        meta: {
            analytics: {
                social_type: 'Qr',
                event_value: 'share QR code',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}
function shareOnLinkedIn(details) {
    return {
        type: 'SHARE_BY_LINKEDIN',
        payload: details,
        meta: {
            analytics: {
                social_type: 'linkedin',
                event_value: 'share on linkedin',
                page_section: details.location,
                social_utm_term: details.shareHash,
            },
        },
    };
}


/***/ }),

/***/ "./src/redux/modules/page/shareMenu.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export openShareMenu */
/* unused harmony export closeShareMenu */
function openShareMenu() {
    return { type: 'OPEN_SHARE_MENU' };
}
function closeShareMenu() {
    return { type: 'CLOSE_SHARE_MENU' };
}


/***/ }),

/***/ "./src/redux/modules/page/updatePage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SubmissionError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RichStoryError; });
/* harmony export (immutable) */ __webpack_exports__["c"] = updatePage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_images__ = __webpack_require__("./src/helpers/api/images.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_richEditor__ = __webpack_require__("./src/helpers/richEditor.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var SubmissionError = /** @class */ (function (_super) {
    __extends(SubmissionError, _super);
    function SubmissionError() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, SubmissionError);
        }
        _this.type = 'SubmissionError';
        return _this;
    }
    return SubmissionError;
}(Error));

var RichStoryError = /** @class */ (function (_super) {
    __extends(RichStoryError, _super);
    function RichStoryError() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, RichStoryError);
        }
        _this.type = 'RichStoryError';
        return _this;
    }
    return RichStoryError;
}(Error));

function updatePage(page, redirect) {
    var _this = this;
    if (redirect === void 0) { redirect = true; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, _a, _b, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({
                        type: 'UPDATE_REQUEST',
                        payload: { page: page },
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 10, , 11]);
                    payload = {
                        name: page.name,
                        id: page.id,
                        targetAmount: page.targetAmount,
                        targetCurrency: page.targetCurrency,
                        care: page.care,
                        deadline: page.deadline,
                        money: page.money,
                        problem: page.problem,
                        completeImage: page.completeImage,
                        report: page.report,
                        thankYou: page.thankYou,
                        finishedAt: page.finishedAt,
                        latitude: page.latitude,
                        longitude: page.longitude,
                        locationText: page.locationText,
                        ownerName: page.ownerName,
                        ownerBio: page.ownerBio,
                        pitchFor: page.pitchFor,
                        recurringDonationsPitch: page.recurringDonationsPitch,
                    };
                    // properties with undefined values will override the state and need to be removed
                    removeUndefinedProperties(payload);
                    if (page.categoryId) {
                        // HACK: it might come back as a string, despite the typing,
                        //       as there's still some JS in there...
                        payload.categoryId = parseInt(page.categoryId, 10);
                    }
                    if (!(page.image && page.image.changed)) return [3 /*break*/, 4];
                    if (!page.image.blob) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_images__["a" /* uploadCoverImage */])(page.image.blob)];
                case 2:
                    response = _c.sent();
                    if (response.success) {
                        payload.initialImage = { name: response.data.imageName };
                        payload.socialShareImage = {
                            name: response.data.socialShareImageName,
                        };
                    }
                    return [3 /*break*/, 4];
                case 3:
                    payload.initialImage = { name: __WEBPACK_IMPORTED_MODULE_1_config__["DEFAULT_IMAGE_NAME"] };
                    payload.socialShareImage = { name: __WEBPACK_IMPORTED_MODULE_1_config__["DEFAULT_IMAGE_NAME"] };
                    _c.label = 4;
                case 4:
                    if (!page.richStory) return [3 /*break*/, 8];
                    _a = payload;
                    if (!(typeof page.richStory === 'string')) return [3 /*break*/, 5];
                    _b = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_richEditor__["a" /* convertProblemToRichStory */])(page.richStory);
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_richEditor__["e" /* transformStateToSave */])(page.richStory)];
                case 6:
                    _b = _c.sent();
                    _c.label = 7;
                case 7:
                    _a.richStory = _b;
                    _c.label = 8;
                case 8: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__["e" /* patch */])(payload)];
                case 9:
                    _c.sent();
                    // HACK: 0 is a special value to let the server know that the value needs to be reset,
                    // for the state purposes the lack of category is denoted by categoryId equal to null.
                    if (payload.categoryId === 0) {
                        payload.categoryId = null;
                    }
                    dispatch({ type: 'UPDATE_SUCCESS', payload: payload });
                    if (redirect) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name));
                    }
                    return [3 /*break*/, 11];
                case 10:
                    err_1 = _c.sent();
                    dispatch({
                        type: 'UPDATE_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    if (err_1.response &&
                        err_1.response.badRequest &&
                        err_1.response.body &&
                        err_1.response.body.message === 'emptyStory') {
                        throw new RichStoryError('Please write your story');
                    }
                    throw new SubmissionError('An error has occurred. Please try again.');
                case 11: return [2 /*return*/];
            }
        });
    }); };
}
function removeUndefinedProperties(obj) {
    return Object.keys(obj).forEach(function (key) { return obj[key] === undefined && delete obj[key]; });
}


/***/ }),

/***/ "./src/redux/modules/page/verification.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export verificationStatusUpdate */
function verificationStatusUpdate(payload) {
    return {
        type: 'UPDATE_VERIFICATION_STATUS',
        payload: payload,
    };
}


/***/ }),

/***/ "./src/redux/modules/pageLink.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = submitLink;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function submitLink(_a) {
    var _this = this;
    var pageLink = _a.pageLink;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, id, name, page, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getState().page, id = _a.id, name = _a.name;
                    dispatch({ type: 'LINK_REQUEST' });
                    page = {
                        id: id,
                        projectId: id,
                        name: pageLink,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    if (!(name !== pageLink)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_src_helpers_api_pages__["e" /* patch */])(page)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    dispatch({
                        type: 'LINK_SUCCESS',
                        payload: { name: page.name },
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + page.name + "/confirmidentity"));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    dispatch({ type: 'LINK_FAILURE' });
                    throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["c" /* SubmissionError */]({
                        pageLink: 'An error has occurred, please try again.',
                    });
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
var initalState = {
    isRequesting: false,
    hasError: false,
};
function reducer(state, action) {
    if (state === void 0) { state = initalState; }
    switch (action.type) {
        case 'LINK_REQUEST':
            return __assign({}, state, { isRequesting: true });
        case 'LINK_SUCCESS':
            return __assign({}, state, { isRequesting: false });
        case 'LINK_FAILURE':
            return __assign({}, state, { isRequesting: false, hasError: true });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/paymentDetails.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadPaymentDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_paymentDetails__ = __webpack_require__("./src/helpers/api/paymentDetails.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadPaymentDetails() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, paymentDetails, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'LOAD_PAYMENT_DETAILS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    id = getState().page.id;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_paymentDetails__["b" /* getPaymentDetails */])({ pageId: id })];
                case 2:
                    paymentDetails = _a.sent();
                    dispatch({
                        type: 'LOAD_PAYMENT_DETAILS_SUCCESS',
                        payload: paymentDetails,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'LOAD_PAYMENT_DETAILS_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var initialState = {
    isLoading: false,
    accountEmailAddress: '',
    accountHolder: '',
    accountNumber: '',
    bankName: '',
    isPayPal: false,
    sortCode: '',
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'LOAD_PAYMENT_DETAILS_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'LOAD_PAYMENT_DETAILS_SUCCESS':
            return __assign({}, state, { isLoading: false }, action.payload);
        case 'LOAD_PAYMENT_DETAILS_FAILURE':
            return __assign({}, state, { isLoading: false });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/photoEditor.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadImage */
/* unused harmony export rejectImage */
/* unused harmony export loadPreviewImage */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeImage;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateCrop;
/* harmony export (immutable) */ __webpack_exports__["d"] = rotateImage;
/* unused harmony export openGallery */
/* unused harmony export closeGallery */
/* unused harmony export loadGalleryImage */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPhotoEditorActions;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function loadImage(namespace, image) {
    return {
        type: 'LOAD_IMAGE',
        namespace: namespace,
        payload: image,
    };
}
function rejectImage(namespace) {
    return {
        type: 'REJECT_IMAGE',
        namespace: namespace,
        cropData: undefined,
    };
}
function loadPreviewImage(namespace, image) {
    return {
        type: 'LOAD_PREVIEW_IMAGE',
        namespace: namespace,
        payload: image,
    };
}
function removeImage(namespace) {
    return {
        type: 'REMOVE_IMAGE',
        namespace: namespace,
    };
}
function updateCrop(namespace, cropData) {
    return {
        type: 'UPDATE_CROP',
        namespace: namespace,
        payload: cropData,
    };
}
function rotateImage(namespace, cropData) {
    return {
        type: 'ROTATE_IMAGE',
        namespace: namespace,
        payload: cropData,
    };
}
function openGallery(namespace) {
    return {
        type: 'OPEN_GALLERY',
        namespace: namespace,
    };
}
function closeGallery(namespace) {
    return {
        type: 'CLOSE_GALLERY',
        namespace: namespace,
    };
}
function loadGalleryImage(namespace, image) {
    return {
        type: 'LOAD_GALLERY_IMAGE',
        namespace: namespace,
        payload: image,
    };
}
function createPhotoEditorActions(namespace) {
    return {
        loadImage: loadImage.bind(null, namespace),
        rejectImage: rejectImage.bind(null, namespace),
        loadPreviewImage: loadPreviewImage.bind(null, namespace),
        removeImage: removeImage.bind(null, namespace),
        updateCrop: updateCrop.bind(null, namespace),
        rotateImage: rotateImage.bind(null, namespace),
        openGallery: openGallery.bind(null, namespace),
        closeGallery: closeGallery.bind(null, namespace),
        loadGalleryImage: loadGalleryImage.bind(null, namespace),
    };
}
var initialCropData = {
    position: { x: 0.5, y: 0.5 },
    scale: 1,
    rotate: 0,
};
var initialState = {
    mode: 'pick',
    cropData: initialCropData,
};
function reducer(namespace, state, action) {
    if (state === void 0) { state = initialState; }
    if (action.namespace !== namespace) {
        return state;
    }
    switch (action.type) {
        case 'LOAD_IMAGE':
            return __assign({}, state, { mode: 'edit', image: action.payload, cropData: initialCropData, imageRejected: false });
        case 'REJECT_IMAGE':
            return __assign({}, state, { imageRejected: true, cropData: undefined });
        case 'REMOVE_IMAGE':
            return __assign({}, state, { mode: 'pick', image: undefined, cropData: initialCropData });
        case 'UPDATE_CROP':
            return __assign({}, state, { cropData: action.payload });
        case 'ROTATE_IMAGE':
            return __assign({}, state, { cropData: __assign({}, action.payload, { scale: 1 }) });
        case 'OPEN_GALLERY':
            return __assign({}, state, { galleryOpen: true });
        case 'CLOSE_GALLERY':
            return __assign({}, state, { galleryOpen: false });
        case 'LOAD_GALLERY_IMAGE':
            return __assign({}, state, { galleryOpen: false, mode: 'edit', image: action.payload, cropData: initialCropData });
        case 'LOAD_PREVIEW_IMAGE':
            return __assign({}, state, { mode: 'preview', image: action.payload });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/richUpdates/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clearRichUpdatePublishingError;
/* unused harmony export prepareMedia */
/* harmony export (immutable) */ __webpack_exports__["f"] = publishRichUpdate;
/* harmony export (immutable) */ __webpack_exports__["g"] = publishThankUpdate;
/* harmony export (immutable) */ __webpack_exports__["e"] = publishMilestoneUpdate;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadUpdates;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteRichUpdate;
/* harmony export (immutable) */ __webpack_exports__["j"] = watchingVideoToggle;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearUpdateForms;
/* harmony export (immutable) */ __webpack_exports__["i"] = scrolledToUpdate;
/* harmony export (immutable) */ __webpack_exports__["h"] = scrollToUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__ = __webpack_require__("./src/helpers/api/updates.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_api_images__ = __webpack_require__("./src/helpers/api/images.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_youTubeParser__ = __webpack_require__("./src/helpers/youTubeParser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_hashId__ = __webpack_require__("./src/helpers/hashId.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_page__ = __webpack_require__("./src/helpers/page.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_helpers_images_thankYouImage__ = __webpack_require__("./src/helpers/images/thankYouImage/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_helpers_images_milestoneImage__ = __webpack_require__("./src/helpers/images/milestoneImage/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_helpers_facebook__ = __webpack_require__("./src/helpers/facebook.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_logging__ = __webpack_require__("./src/logging.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};














var DEFAULT_PAGE_SIZE = 3;
function clearRichUpdatePublishingError() {
    return {
        type: 'CLEAR_RICH_UPDATE_PUBLISHING_ERROR',
    };
}
function prepareMedia(_a) {
    var mediaType = _a.mediaType, resource = _a.resource;
    return __awaiter(this, void 0, Promise, function () {
        var uploadedMedia, uploadResult, videoId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    uploadedMedia = [];
                    if (!(mediaType === 'image')) return [3 /*break*/, 2];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_api_images__["b" /* uploadImage */])(resource)];
                case 1:
                    uploadResult = _b.sent();
                    if (uploadResult.success) {
                        uploadedMedia.push({
                            path: uploadResult.data.imageName,
                            type: 1,
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    if (mediaType === 'video') {
                        videoId = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_youTubeParser__["b" /* getVideoId */])(resource);
                        if (videoId) {
                            uploadedMedia.push({ path: videoId, type: 2 });
                        }
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/, uploadedMedia];
            }
        });
    });
}
function shareUpdateToFacebook(_a) {
    var link = _a.link, picture = _a.picture, message = _a.message, name = _a.name, description = _a.description, ref = _a.ref, authStatus = _a.authStatus;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            if (!picture) {
                FB.ui({
                    method: 'share',
                    quote: message,
                    href: link,
                }, function () { return void 0; });
            }
            else {
                FB.ui({
                    method: 'share',
                    quote: message,
                    href: link,
                }, function () { return void 0; });
            }
            return [2 /*return*/];
        });
    });
}
function shareUpdateToFacebookSuccess(_a) {
    var type = _a.type, utmHash = _a.utmHash;
    return {
        type: 'SHARE_UPDATE_TO_FACEBOOK_SUCCESS',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'share',
                event_value: 'share to facebook',
                page_section: "admin > update > " + type.toLowerCase(),
                social_type: 'feed',
                activity_type: 'crowdfunding_guid',
                social_utm_term: utmHash,
            },
        },
    };
}
var getImageMediaPath = function (media) {
    if (media && media.type === 1) {
        return media.path;
    }
    return null;
};
var resetUpdateForms = function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["i" /* reset */])('update'));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["i" /* reset */])('thanks'));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["i" /* reset */])('milestone'));
};
function publishRichUpdate(update) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var page, userToken, sharedToFacebook, media, mediaType, result, utmHash, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = getState().page;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_REQUEST',
                    });
                    userToken = null;
                    sharedToFacebook = false;
                    if (!update.shareToFacebook) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_11_src_helpers_facebook__["a" /* getUserToken */])()];
                case 2:
                    userToken = _a.sent();
                    _a.label = 3;
                case 3:
                    media = [];
                    if (!(update.image || update.video)) return [3 /*break*/, 5];
                    mediaType = update.image ? 'image' : 'video';
                    return [4 /*yield*/, prepareMedia({
                            mediaType: mediaType,
                            resource: update.image
                                ? update.image
                                : update.video,
                        })];
                case 4:
                    media = _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["e" /* publishUpdate */])({
                        projectId: page.id,
                        message: update.message,
                        media: media,
                        type: update.type,
                    })];
                case 6:
                    result = _a.sent();
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_SUCCESS',
                        payload: __assign({}, result, { sharedToFacebook: sharedToFacebook }),
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["b" /* push */])("/" + page.name + "/update/share", {
                        updateId: result.id,
                        message: update.message,
                        type: 'update',
                    }));
                    resetUpdateForms(dispatch);
                    if (!(update.shareToFacebook && userToken)) return [3 /*break*/, 8];
                    return [4 /*yield*/, shareToFacebook(page, {
                            userToken: userToken,
                            media: result.media[0],
                            message: update.message,
                            updateId: result.id,
                        })];
                case 7:
                    utmHash = _a.sent();
                    dispatch(shareUpdateToFacebookSuccess({
                        utmHash: utmHash,
                        type: 'update',
                    }));
                    sharedToFacebook = true;
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_FAILURE',
                        payload: error_1,
                        error: true,
                    });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
}
function publishThankUpdate(update) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var page, userToken, sharedToFacebook, image, media, result, utmHash, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = getState().page;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_REQUEST',
                    });
                    userToken = null;
                    sharedToFacebook = false;
                    if (!update.shareToFacebook) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_11_src_helpers_facebook__["a" /* getUserToken */])()];
                case 2:
                    userToken = _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_9_src_helpers_images_thankYouImage__["c" /* exportThankYouImage */])({
                        text: update.text,
                        preset: update.preset,
                        width: 1200,
                        height: 630,
                    })];
                case 4:
                    image = _a.sent();
                    return [4 /*yield*/, prepareMedia({
                            mediaType: 'image',
                            resource: image,
                        })];
                case 5:
                    media = _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["e" /* publishUpdate */])({
                            projectId: page.id,
                            message: update.message,
                            media: media,
                            type: 'Thanks',
                        })];
                case 6:
                    result = _a.sent();
                    if (!(update.shareToFacebook && userToken)) return [3 /*break*/, 8];
                    return [4 /*yield*/, shareToFacebook(page, {
                            userToken: userToken,
                            media: result.media[0],
                            message: update.message,
                            updateId: result.id,
                        })];
                case 7:
                    utmHash = _a.sent();
                    dispatch(shareUpdateToFacebookSuccess({
                        utmHash: utmHash,
                        type: 'thanks',
                    }));
                    sharedToFacebook = true;
                    _a.label = 8;
                case 8:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["b" /* push */])("/" + page.name + "/update/share", {
                        updateId: result.id,
                        message: update.message,
                        type: 'thank',
                    }));
                    resetUpdateForms(dispatch);
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_SUCCESS',
                        payload: __assign({}, result, { sharedToFacebook: sharedToFacebook }),
                    });
                    return [3 /*break*/, 10];
                case 9:
                    error_2 = _a.sent();
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_FAILURE',
                        payload: error_2,
                        error: true,
                    });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
}
function publishMilestoneUpdate(update) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var page, userToken, sharedToFacebook, image, media, result, utmHash, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = getState().page;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_REQUEST',
                    });
                    userToken = null;
                    sharedToFacebook = false;
                    if (!update.shareToFacebook) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_11_src_helpers_facebook__["a" /* getUserToken */])()];
                case 2:
                    userToken = _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_10_src_helpers_images_milestoneImage__["b" /* exportMilestoneImage */])({
                        width: 1200,
                        height: 630,
                        preset: update.preset,
                        percentage: update.percentage,
                        targetAmount: update.targetAmount,
                    })];
                case 4:
                    image = _a.sent();
                    return [4 /*yield*/, prepareMedia({
                            mediaType: 'image',
                            resource: image,
                        })];
                case 5:
                    media = _a.sent();
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["e" /* publishUpdate */])({
                            projectId: page.id,
                            message: update.message,
                            media: media,
                            type: 'Milestone',
                        })];
                case 6:
                    result = _a.sent();
                    if (!(update.shareToFacebook && userToken)) return [3 /*break*/, 8];
                    return [4 /*yield*/, shareToFacebook(page, {
                            userToken: userToken,
                            media: result.media[0],
                            message: update.message,
                            updateId: result.id,
                        })];
                case 7:
                    utmHash = _a.sent();
                    dispatch(shareUpdateToFacebookSuccess({
                        utmHash: utmHash,
                        type: 'milestone',
                    }));
                    sharedToFacebook = true;
                    _a.label = 8;
                case 8:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["b" /* push */])("/" + page.name + "/update/share", {
                        updateId: result.id,
                        message: update.message,
                        type: 'milestone',
                    }));
                    resetUpdateForms(dispatch);
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_SUCCESS',
                        payload: __assign({}, result, { sharedToFacebook: sharedToFacebook }),
                    });
                    return [3 /*break*/, 10];
                case 9:
                    error_3 = _a.sent();
                    dispatch({
                        type: 'PUBLISH_RICH_UPDATE_FAILURE',
                        payload: error_3,
                        error: true,
                    });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
}
function shareToFacebook(page, _a) {
    var _this = this;
    var userToken = _a.userToken, media = _a.media, message = _a.message, updateId = _a.updateId;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var isPageClosed, targetCurrency, amountRaised, pitchFor, socialShareUrl, utmHash, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isPageClosed = Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_page__["d" /* isClosed */])(page);
                    targetCurrency = page.targetCurrency, amountRaised = page.amountRaised, pitchFor = page.pitchFor, socialShareUrl = page.socialShareUrl;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    utmHash = Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_hashId__["a" /* generateHash */])();
                    return [4 /*yield*/, shareUpdateToFacebook({
                            authStatus: userToken,
                            picture: getImageMediaPath(media) || null,
                            message: message,
                            link: Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_url__["a" /* buildUrl */])(socialShareUrl + "/updates/" + updateId.toString(16), {
                                utm_term: utmHash,
                            }),
                            name: isPageClosed
                                ? "Together we've raised " + (__WEBPACK_IMPORTED_MODULE_7_src_helpers_currencyMap__["e" /* default */][targetCurrency] ||
                                    '£') + amountRaised + " on JustGiving to " + pitchFor
                                : null,
                            description: isPageClosed ? 'Thank you for your support' : null,
                            ref: null,
                        })];
                case 2:
                    _a.sent();
                    resolve(utmHash);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    reject();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
}
function getLinkedUpdateId(state) {
    var path = state.routing && state.routing.location && state.routing.location.pathname;
    var updateId = 0;
    if (path) {
        var match = Object(__WEBPACK_IMPORTED_MODULE_12_react_router__["e" /* matchPath */])(path, {
            path: '/:name/updates/:updateId',
        });
        if (match) {
            try {
                updateId = parseInt(match.params.updateId, 16);
            }
            catch (error) {
                __WEBPACK_IMPORTED_MODULE_13_src_logging__["a" /* default */].error({ error: error }, 'invalid update id');
            }
        }
    }
    return updateId;
}
function loadUpdates(_a) {
    var _this = this;
    var pageId = _a.pageId, _b = _a.pageNo, pageNo = _b === void 0 ? 1 : _b, _c = _a.pageSize, pageSize = _c === void 0 ? DEFAULT_PAGE_SIZE : _c;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, currentPageNo, data, allUpdateIds_1, updatesById, linkedUpdate, linekdUpdateId, update, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'RICH_UPDATES_REQUEST',
                    });
                    state = getState();
                    currentPageNo = state.richUpdates.updatesPageNo || 0;
                    if (pageNo !== 1 && pageNo <= currentPageNo) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["d" /* getUpdates */])(pageId, pageNo, pageSize)];
                case 2:
                    data = _a.sent();
                    allUpdateIds_1 = [];
                    updatesById = data.updates.reduce(function (object, update) {
                        object[update.id] = update;
                        allUpdateIds_1.push(update.id);
                        return object;
                    }, {});
                    linkedUpdate = {
                        createdAt: '',
                        friends: [],
                        id: 0,
                        media: [],
                        message: '',
                        projectId: '',
                        type: 0,
                    };
                    linekdUpdateId = getLinkedUpdateId(state);
                    if (!(linekdUpdateId > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["c" /* getUpdate */])(pageId, linekdUpdateId)];
                case 3:
                    update = _a.sent();
                    if (update !== null) {
                        linkedUpdate = update;
                    }
                    _a.label = 4;
                case 4:
                    dispatch({
                        type: 'RICH_UPDATES_SUCCESS',
                        payload: {
                            pageNo: data.pageNo,
                            pageSize: data.pageSize,
                            totalCount: data.totalCount,
                            updatesById: updatesById,
                            allUpdateIds: allUpdateIds_1,
                            linkedUpdate: linkedUpdate,
                        },
                    });
                    return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    dispatch({
                        type: 'RICH_UPDATES_FAILURE',
                        error: true,
                        payload: err_2,
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
function deleteRichUpdate(updateId) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, pageId, pageNo, count, nextUpdate, newPage, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'RICH_UPDATES_DELETE_UPDATE_REQUEST',
                        payload: { updateId: updateId },
                        meta: {
                            analytics: {
                                event: 'click',
                                subtype: 'button',
                                event_value: 'delete post',
                                page_section: 'updates',
                                card_id: updateId,
                                actor_source: 'page owner update',
                            },
                        },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    state = getState();
                    pageId = state.page.id;
                    pageNo = state.richUpdates.updatesPageNo;
                    count = state.richUpdates.totalCount;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["b" /* deleteUpdate */])({ projectId: pageId, updateId: updateId })];
                case 2:
                    _a.sent();
                    nextUpdate = null;
                    if (!(count > DEFAULT_PAGE_SIZE)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_updates__["d" /* getUpdates */])(pageId, pageNo, DEFAULT_PAGE_SIZE)];
                case 3:
                    newPage = _a.sent();
                    nextUpdate =
                        newPage.updates.length === DEFAULT_PAGE_SIZE
                            ? newPage.updates.pop()
                            : null;
                    _a.label = 4;
                case 4:
                    dispatch({
                        type: 'RICH_UPDATES_DELETE_UPDATE_SUCCESS',
                        payload: {
                            updateId: updateId,
                            nextUpdate: nextUpdate,
                        },
                    });
                    return [3 /*break*/, 6];
                case 5:
                    error_4 = _a.sent();
                    dispatch({
                        type: 'RICH_UPDATES_DELETE_UPDATE_FAILURE',
                        error: true,
                        payload: error_4,
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
function watchingVideoToggle() {
    return { type: 'WATCHING_VIDEO_TOGGLE' };
}
/*-------------------------------------------------
  CLear update forms
-------------------------------------------------*/
function clearUpdateForms() {
    return function (dispatch) {
        resetUpdateForms(dispatch);
    };
}
function scrolledToUpdate() {
    return {
        type: 'SCROLLED_TO_UPDATE',
    };
}
function scrollToUpdate() {
    return {
        type: 'SCROLL_TO_UPDATE',
    };
}


/***/ }),

/***/ "./src/redux/modules/richUpdates/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/richUpdates/reducer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./src/redux/modules/richUpdates/actions.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["d"]; });
/* unused harmony reexport publishRichUpdate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["j"]; });
/* unused harmony reexport clearUpdateForms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./src/redux/modules/richUpdates/selectors.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__selectors__["a"]; });

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);




/***/ }),

/***/ "./src/redux/modules/richUpdates/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_union__ = __webpack_require__("./node_modules/lodash/union.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_union__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var DEFAULT_PAGE_SIZE = 3;
var initialState = {
    isPublishing: false,
    publishingError: null,
    totalCount: 0,
    updatesPageNo: 0,
    isLoading: false,
    allUpdateIds: [],
    updatesById: {},
    isWatchingVideo: false,
    scrollTo: false,
    linkedUpdate: {
        createdAt: '',
        friends: [],
        id: 0,
        media: [],
        message: '',
        projectId: '',
        type: 0,
    },
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    switch (action.type) {
        case 'PUBLISH_RICH_UPDATE_REQUEST':
            return __assign({}, state, { isPublishing: true, publishingError: null });
        case 'PUBLISH_RICH_UPDATE_SUCCESS':
            return __assign({}, state, { isPublishing: false, publishingError: null, updatesById: __assign({}, state.updatesById, (_a = {}, _a[action.payload.id] = action.payload, _a)), allUpdateIds: [action.payload.id].concat(state.allUpdateIds), totalCount: state.totalCount + 1, scrollTo: true });
        case 'SCROLLED_TO_UPDATE':
            return __assign({}, state, { scrollTo: false });
        case 'SCROLL_TO_UPDATE':
            return __assign({}, state, { scrollTo: true });
        case 'PUBLISH_RICH_UPDATE_FAILURE':
            return __assign({}, state, { isPublishing: false, publishingError: action.payload });
        case 'CLEAR_RICH_UPDATE_PUBLISHING_ERROR':
            return __assign({}, state, { publishingError: null });
        case 'RICH_UPDATES_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'RICH_UPDATES_SUCCESS':
            return __assign({}, state, { updatesById: __assign({}, state.updatesById, action.payload.updatesById), allUpdateIds: __WEBPACK_IMPORTED_MODULE_0_lodash_union___default()(state.allUpdateIds, action.payload.allUpdateIds), updatesPageNo: action.payload.pageNo, totalCount: action.payload.totalCount, isLoading: false, linkedUpdate: action.payload.linkedUpdate });
        case 'RICH_UPDATES_FAILURE':
            return __assign({}, state, { isLoading: false });
        case 'RICH_UPDATES_DELETE_UPDATE_SUCCESS':
            var filteredAllUpdateIds = state.allUpdateIds.filter(function (id) { return id !== action.payload.updateId; });
            if (action.payload &&
                action.payload.nextUpdate &&
                !filteredAllUpdateIds.includes(action.payload.nextUpdate.id)) {
                filteredAllUpdateIds.push(action.payload.nextUpdate.id);
            }
            var newUpdatesById = filteredAllUpdateIds.reduce(function (object, id) {
                // If nextUpdate isn't in the store, add it to the list
                object[id] = state.updatesById[id] || action.payload.nextUpdate;
                return object;
            }, {});
            return __assign({}, state, { updatesById: newUpdatesById, allUpdateIds: filteredAllUpdateIds, updatesPageNo: Math.max(Math.ceil(filteredAllUpdateIds.length / DEFAULT_PAGE_SIZE), 1), totalCount: state.totalCount - 1 });
        case 'WATCHING_VIDEO_TOGGLE':
            return __assign({}, state, { isWatchingVideo: !state.isWatchingVideo });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/richUpdates/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdates;
function getUpdates(richUpdates) {
    return richUpdates.allUpdateIds.map(function (id) {
        return richUpdates.updatesById[id];
    });
}


/***/ }),

/***/ "./src/redux/modules/self.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadUserDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_self__ = __webpack_require__("./src/helpers/api/self.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadUserDetails() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var userDetails, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'LOAD_USER_DETAILS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getUserDetails()];
                case 2:
                    userDetails = _a.sent();
                    dispatch({
                        type: 'LOAD_USER_DETAILS_SUCCESS',
                        payload: userDetails,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'LOAD_USER_DETAILS_FAILURE',
                        payload: new Error(error_1),
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function getUserDetails() {
    return __awaiter(this, void 0, Promise, function () {
        var data, locale, userDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_self__["a" /* get */])()];
                case 1:
                    data = _a.sent();
                    if (!data) {
                        throw new Error('User not found');
                    }
                    locale = {
                        country: data.country,
                        isoCode: data.isoCode,
                    };
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_self__["b" /* isLoggedIn */])(data)) {
                        return [2 /*return*/, { locale: locale }];
                    }
                    userDetails = {
                        title: data.title,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        address: {
                            town: data.town,
                            postCode: data.postCode,
                            addressLine1: data.addressLine1,
                            addressLine2: data.addressLine2,
                            street: data.street,
                            subStreet: data.subStreet,
                            buildingName: data.buildingName,
                            buildingNumber: data.buildingNumber,
                            flatNumber: data.flatNumber,
                        },
                    };
                    return [2 /*return*/, { id: data.id, userDetails: userDetails, locale: locale }];
            }
        });
    });
}
function reducer(state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'LOAD_USER_DETAILS_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'LOAD_USER_DETAILS_SUCCESS':
            return __assign({}, state, { isLoading: false, lastRequested: Date.now() }, action.payload);
        case 'LOAD_USER_DETAILS_FAILURE':
            return __assign({}, state, { isLoading: false });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/settings/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageSettings;
/* harmony export (immutable) */ __webpack_exports__["c"] = setRecurringDonationsStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateThankYouMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = setNotificationsStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_settings__ = __webpack_require__("./src/helpers/api/settings.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

function getPageSettings() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, response, supportsRecurringPayments, payload, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'GET_PAGE_SETTINGS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    id = getState().page.id;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_settings__["a" /* getSettings */])(id)];
                case 2:
                    response = _a.sent();
                    if (!response) {
                        throw new Error('Empty response');
                    }
                    supportsRecurringPayments = response.supportsRecurringPayments, payload = __rest(response, ["supportsRecurringPayments"]);
                    dispatch({
                        type: 'GET_PAGE_SETTINGS_SUCCESS',
                        payload: __assign({}, payload, { supportsRecurringDonations: supportsRecurringPayments, isDonationRemindLaterAvailable: !supportsRecurringPayments }),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    dispatch({
                        type: 'GET_PAGE_SETTINGS_FAILURE',
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function setRecurringDonationsStatus(shouldRecurringDonationsBeEnabled) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, thankYouMessage, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SET_RECURRING_DONATIONS_STATUS_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    id = getState().page.id;
                    thankYouMessage = getState().settings.thankYouMessage;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_settings__["c" /* updateSupportsRecurringDonationsStatus */])(id, shouldRecurringDonationsBeEnabled, thankYouMessage)];
                case 2:
                    _a.sent();
                    dispatch({
                        type: 'SET_RECURRING_DONATIONS_STATUS_SUCCESS',
                        payload: shouldRecurringDonationsBeEnabled,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'SET_RECURRING_DONATIONS_STATUS_FAILURE',
                        payload: false,
                    });
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function updateThankYouMessage(payload) {
    return {
        type: 'UPDATE_THANK_YOU_MESSAGE',
        payload: payload,
    };
}
function setNotificationsStatus(payload) {
    return {
        type: 'SET_NOTIFICATIONS_STATUS',
        payload: payload,
    };
}


/***/ }),

/***/ "./src/redux/modules/settings/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/settings/reducer.ts");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* default */]);


/***/ }),

/***/ "./src/redux/modules/settings/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initalState = {
    supportsRecurringDonations: false,
    thankYouMessage: 'Thank you so much for donating to my cause. Your monthly support really means the world to me.',
    notificationsEnabled: false,
    isDonationRemindLaterAvailable: false,
};
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    if (state === void 0) { state = initalState; }
    switch (action.type) {
        case 'SET_RECURRING_DONATIONS_STATUS_SUCCESS':
            return __assign({}, state, { supportsRecurringDonations: action.payload, isDonationRemindLaterAvailable: !action.payload });
        case 'SET_RECURRING_DONATIONS_STATUS_FAILURE':
            return __assign({}, state, { isDonationRemindLaterAvailable: true });
        case 'GET_PAGE_SETTINGS_SUCCESS':
            return __assign({}, state, action.payload);
        case 'GET_PAGE_SETTINGS_FAILURE':
            return __assign({}, state, { supportsRecurringDonations: false, isDonationRemindLaterAvailable: true });
        case 'UPDATE_THANK_YOU_MESSAGE':
            return __assign({}, state, { thankYouMessage: action.payload });
        case 'SET_NOTIFICATIONS_STATUS':
            return __assign({}, state, { notificationsEnabled: action.payload });
        default:
            return state;
    }
});


/***/ }),

/***/ "./src/redux/modules/sharePrompts.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = openSharePrompts;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeSharePrompts;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function openSharePrompts(pageSection) {
    return {
        type: 'OPEN_SHARE_PROMPTS',
        payload: pageSection,
    };
}
function closeSharePrompts() {
    return {
        type: 'CLOSE_SHARE_PROMPTS',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'dismiss',
                event_value: 'Go to my page',
                page_section: 'page > page creation > share prompt > All done',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function reducer(state, action) {
    if (state === void 0) { state = {
        isSharePromptsOpen: false,
        hasShared: false,
        pageSection: '',
    }; }
    switch (action.type) {
        case 'OPEN_SHARE_PROMPTS':
            return __assign({}, state, { isSharePromptsOpen: true, hasShared: false, pageSection: action.payload });
        case 'CLOSE_SHARE_PROMPTS':
            return __assign({}, state, { isSharePromptsOpen: false, hasShared: true, pageSection: '' });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/shareWithFriendsPrompts.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = openShareWithFriendsPrompts;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeShareWithFriendsPrompts;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function openShareWithFriendsPrompts(pageSection) {
    return {
        type: 'OPEN_SHARE_WITH_FRIENDS_PROMPTS',
        payload: pageSection,
    };
}
function closeShareWithFriendsPrompts() {
    return {
        type: 'CLOSE_SHARE_WITH_FRIENDS_PROMPTS',
        meta: {
            analytics: {
                event: 'click',
                subtype: 'dismiss',
                event_value: 'Go to my page',
                page_section: 'page > page creation > share with friends prompt > All done',
                activity_type: 'crowdfunding_guid',
            },
        },
    };
}
function reducer(state, action) {
    if (state === void 0) { state = {
        isShareWithFriendsPromptsOpen: false,
        hasShared: false,
        pageSection: '',
    }; }
    switch (action.type) {
        case 'OPEN_SHARE_WITH_FRIENDS_PROMPTS':
            return __assign({}, state, { isShareWithFriendsPromptsOpen: true, hasShared: false, pageSection: action.payload });
        case 'CLOSE_SHARE_WITH_FRIENDS_PROMPTS':
            return __assign({}, state, { isShareWithFriendsPromptsOpen: false, hasShared: true, pageSection: '' });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/story.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = submitStory;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pages__ = __webpack_require__("./src/helpers/api/pages.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_richEditor__ = __webpack_require__("./src/helpers/richEditor.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page_updatePage__ = __webpack_require__("./src/redux/modules/page/updatePage.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function submitStory(story) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var page, storyPayload, _a, _b, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: 'STORY_REQUEST', payload: story });
                    page = getState().page;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, , 7]);
                    _a = {
                        id: page.id,
                        name: page.name
                    };
                    if (!(typeof story === 'string')) return [3 /*break*/, 2];
                    _b = Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_richEditor__["a" /* convertProblemToRichStory */])(story);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_richEditor__["e" /* transformStateToSave */])(story)];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    storyPayload = (_a.richStory = _b,
                        _a);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_pages__["e" /* patch */])(storyPayload)];
                case 5:
                    _c.sent();
                    dispatch({ type: 'STORY_SUCCESS' });
                    dispatch({ type: 'UPDATE_SUCCESS', payload: storyPayload });
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _c.sent();
                    dispatch({
                        type: 'STORY_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    if (err_1.response &&
                        err_1.response.badRequest &&
                        err_1.response.body &&
                        err_1.response.body.message === 'emptyStory') {
                        throw new __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page_updatePage__["a" /* RichStoryError */]('Please write your story');
                    }
                    throw new __WEBPACK_IMPORTED_MODULE_2_src_redux_modules_page_updatePage__["b" /* SubmissionError */]('An error has occurred. Please try again.');
                case 7: return [2 /*return*/];
            }
        });
    }); };
}
var initalState = {
    isRequesting: false,
    hasError: false,
};
function reducer(state, action) {
    if (state === void 0) { state = initalState; }
    switch (action.type) {
        case 'STORY_REQUEST':
            return __assign({}, state, { isRequesting: true, hasError: false });
        case 'STORY_SUCCESS':
            return __assign({}, state, { isRequesting: false, hasError: false });
        case 'STORY_FAILURE':
            return __assign({}, state, { isRequesting: false, hasError: true });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/stripeVirtualAccount/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVirtualAccountStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return submitField; });
/* harmony export (immutable) */ __webpack_exports__["f"] = updateStripeAccountDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = submitStripeVerificationDocument;
/* harmony export (immutable) */ __webpack_exports__["d"] = submitStripeBankAccountDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSubmissionError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_stripeVirtualAccount__ = __webpack_require__("./src/helpers/api/stripeVirtualAccount.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_stripe__ = __webpack_require__("./src/helpers/stripe.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_redux_modules_paymentDetails__ = __webpack_require__("./src/redux/modules/paymentDetails.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var getVirtualAccountStatus = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var id, accountDetails, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                id = getState().page.id;
                dispatch({
                    type: 'STRIPE_VIRTUAL_ACCOUNT_STATUS_REQUEST',
                });
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_stripeVirtualAccount__["b" /* getAccountStatus */])(id)];
            case 1:
                accountDetails = _a.sent();
                dispatch({
                    type: 'STRIPE_VIRTUAL_ACCOUNT_STATUS_SUCCESS',
                    payload: {
                        payoutsEnabled: accountDetails.payoutsEnabled,
                        requiredFields: accountDetails.requiredFields.filter(function (requiredField) {
                            return __WEBPACK_IMPORTED_MODULE_2_src_helpers_stripe__["c" /* stripeVirtualAccountRequiredFields */].includes(requiredField);
                        }),
                        submittedAllRequiredFields: accountDetails.requiredFields.length === 0,
                        legalEntityVerificationStatus: accountDetails.legalEntityVerificationStatus,
                        accountDisabledReason: accountDetails.accountDisabledReason,
                        payoutScheduleInterval: accountDetails.payoutScheduleInterval,
                    },
                });
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                dispatch({
                    type: 'STRIPE_VIRTUAL_ACCOUNT_STATUS_FAILURE',
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var submitField = function (submittedField) { return ({
    type: 'SUBMIT_FIELD_ACTION',
    payload: submittedField,
}); };
function updateStripeAccountDetails(payload) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'UPDATE_STRIPE_ACCOUNT_REQUEST',
                        payload: payload,
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    id = getState().page.id;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_stripeVirtualAccount__["c" /* updateStripeAccount */])(id, payload)];
                case 2:
                    result = _a.sent();
                    dispatch({
                        type: 'UPDATE_STRIPE_ACCOUNT_SUCCESS',
                        payload: {
                            payoutScheduleInterval: result.payoutScheduleInterval,
                        },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'UPDATE_STRIPE_ACCOUNT_FAILURE',
                        payload: error_1,
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function submitStripeVerificationDocument(image, cropData) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var croppedImage, id, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SUBMIT_STRIPE_VERIFICATION_DOCUMENT_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_image__["d" /* cropImage */])(__assign({ image: image }, cropData))];
                case 2:
                    croppedImage = _a.sent();
                    id = getState().page.id;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_stripeVirtualAccount__["d" /* uploadStripeVerificationDocument */])(id, croppedImage)];
                case 3:
                    _a.sent();
                    dispatch({
                        type: 'SUBMIT_STRIPE_VERIFICATION_DOCUMENT_SUCCESS',
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    dispatch({
                        type: 'SUBMIT_STRIPE_VERIFICATION_DOCUMENT_FAILURE',
                        payload: error_2,
                        error: true,
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
function submitStripeBankAccountDetails(payload) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var id, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    id = getState().page.id;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_stripeVirtualAccount__["a" /* addStripeBankAccount */])(id, payload)];
                case 2:
                    _a.sent();
                    dispatch({
                        type: 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_SUCCESS',
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_src_redux_modules_paymentDetails__["b" /* loadPaymentDetails */])());
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    dispatch({
                        type: 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_FAILURE',
                        payload: error_3,
                        error: true,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var clearSubmissionError = function () {
    return function (dispatch) {
        dispatch({
            type: 'CLEAR_STRIPE_BANK_ACCOUNT_SUBMISSION_ERROR',
        });
    };
};


/***/ }),

/***/ "./src/redux/modules/stripeVirtualAccount/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("./src/redux/modules/stripeVirtualAccount/reducer.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* unused harmony reexport StripeState */



/***/ }),

/***/ "./src/redux/modules/stripeVirtualAccount/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    isRequesting: false,
    payoutsEnabled: false,
    requiredFields: [],
    submittedAllRequiredFields: false,
    totalRequiredFields: 0,
    error: null,
    payoutScheduleInterval: 'Weekly',
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'STRIPE_VIRTUAL_ACCOUNT_STATUS_REQUEST':
            return __assign({}, state, { isRequesting: true });
        case 'STRIPE_VIRTUAL_ACCOUNT_STATUS_FAILURE':
            return __assign({}, state, { isRequesting: false });
        case 'STRIPE_VIRTUAL_ACCOUNT_STATUS_SUCCESS':
            return __assign({}, state, { isRequesting: false, payoutsEnabled: action.payload.payoutsEnabled, requiredFields: action.payload.requiredFields, submittedAllRequiredFields: action.payload.submittedAllRequiredFields, totalRequiredFields: action.payload.requiredFields.length, legalEntityVerificationStatus: action.payload.legalEntityVerificationStatus, accountDisabledReason: action.payload.accountDisabledReason, payoutScheduleInterval: action.payload.payoutScheduleInterval });
        case 'SUBMIT_FIELD_ACTION':
            return __assign({}, state, { requiredFields: state.requiredFields.filter(function (requiredField) { return requiredField !== action.payload; }), totalRequiredFields: Math.max(state.requiredFields.length - 1, 0) });
        case 'UPDATE_STRIPE_ACCOUNT_SUCCESS':
            return __assign({}, state, { legalEntityVerificationStatus: 'Pending', payoutScheduleInterval: action.payload.payoutScheduleInterval });
        case 'SUBMIT_STRIPE_VERIFICATION_DOCUMENT_SUCCESS':
            return __assign({}, state, { legalEntityVerificationStatus: 'Pending' });
        case 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_REQUEST':
            return __assign({}, state, { error: null });
        case 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_SUCCESS':
            return __assign({}, state, { error: null });
        case 'SUBMIT_STRIPE_BANK_ACCOUNT_INFORMATION_FAILURE':
            return __assign({}, state, { error: action.payload });
        case 'CLEAR_STRIPE_BANK_ACCOUNT_SUBMISSION_ERROR':
            return __assign({}, state, { error: null });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/subscriptions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = unsubscribe;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_api_subscriptions__ = __webpack_require__("./src/helpers/api/subscriptions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_async__ = __webpack_require__("./src/helpers/async.js");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function unsubscribe(_a) {
    var _this = this;
    var pageId = _a.pageId, pageName = _a.pageName, emailAddress = _a.emailAddress, consumerId = _a.consumerId;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'UNSUBSCRIBE_REQUEST' });
                    payload = {
                        projectId: pageId,
                        projectName: pageName,
                        emailAddress: emailAddress,
                        consumerId: consumerId,
                    };
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__helpers_api_subscriptions__["a" /* unsubscribe */])(payload)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'UNSUBSCRIBE_SUCCESS' });
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__helpers_async__["a" /* wait */])(5000)];
                case 2:
                    _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])("/" + pageName));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'UNSUBSCRIBE_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function reducer(state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'UNSUBSCRIBE_REQUEST':
            return {
                unsubscribed: false,
                isUnsubscribing: true,
            };
        case 'UNSUBSCRIBE_SUCCESS':
            return {
                unsubscribed: true,
                isUnsubscribing: false,
            };
        case 'UNSUBSCRIBE_FAILURE':
            return {
                unsubscribed: false,
                isUnsubscribing: false,
                error: action.payload,
            };
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/supporters.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = thankSupporter;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadSupporters;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_activities__ = __webpack_require__("./src/helpers/api/activities.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function thankSupporter(supporterId, thankYouMessage) {
    return {
        type: 'SUPPORTER_THANKED',
        payload: { supporterId: supporterId, thankYouMessage: thankYouMessage },
    };
}
function loadSupporters(_a) {
    var _this = this;
    var pageId = _a.pageId, _b = _a.pageNo, pageNo = _b === void 0 ? 1 : _b, _c = _a.pageSize, pageSize = _c === void 0 ? 7 : _c;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var meta, currentPageNo, supporters, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (pageNo > 1) {
                        meta = {
                            event: 'link click',
                            subtype: 'button',
                            event_value: 'Show more',
                            page_section: 'page > supporters',
                            activity_type: 'crowdfunding_guid',
                        };
                    }
                    currentPageNo = getState().supporters.supporterPageNo || 0;
                    if (pageNo !== 1 && pageNo <= currentPageNo) {
                        return [2 /*return*/];
                    }
                    dispatch({
                        type: 'SUPPORTERS_REQUEST',
                        payload: { pageId: pageId, pageNo: pageNo, pageSize: pageSize },
                        meta: meta,
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_activities__["b" /* getSupporters */])(pageId, pageNo, pageSize)];
                case 2:
                    supporters = _a.sent();
                    dispatch({
                        type: 'SUPPORTERS_SUCCESS',
                        payload: supporters,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'SUPPORTERS_FAILURE',
                        error: true,
                        payload: err_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var initialState = {
    totalCount: 0,
    items: [],
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'SUPPORTERS_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'SUPPORTERS_SUCCESS':
            if (!action.payload) {
                return state;
            }
            var supporters = action.payload;
            return __assign({}, state, { items: supporters.pageNo === 1
                    ? supporters.activities
                    : state.items.concat(supporters.activities), totalCount: supporters.totalCount, supporterPageNo: supporters.pageNo, isLoading: false });
        case 'SUPPORTERS_FAILURE':
            return __assign({}, state, { isLoading: false });
        case 'SUPPORTER_THANKED':
            var updatedItems = state.items.map(function (item) {
                if (item.id === action.payload.supporterId) {
                    return __assign({}, item, { thankYouMessage: action.payload.thankYouMessage });
                }
                return item;
            });
            return __assign({}, state, { items: updatedItems });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/redux/modules/supportersAvatar.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadSupportersAvatar;
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_activities__ = __webpack_require__("./src/helpers/api/activities.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadSupportersAvatar(_a) {
    var _this = this;
    var pageId = _a.pageId, size = _a.size;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: 'SUPPORTERS_AVATAR_REQUEST',
                    });
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_activities__["b" /* getSupporters */])(pageId, 1, size)];
                case 1:
                    data = _a.sent();
                    dispatch({
                        type: 'SUPPORTERS_AVATAR_SUCCESS',
                        payload: data,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'SUPPORTERS_AVATAR_FAILURE',
                        error: true,
                        payload: error_1,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
function reducer(state, action) {
    if (state === void 0) { state = {
        items: [],
    }; }
    switch (action.type) {
        case 'SUPPORTERS_AVATAR_REQUEST':
            return __assign({}, state, { isLoading: true });
        case 'SUPPORTERS_AVATAR_SUCCESS':
            return __assign({}, state, { items: action.payload.activities, isLoading: false });
        case 'SUPPORTERS_AVATAR_FAILURE':
            return __assign({}, state, { isLoading: false });
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_import_inspector__ = __webpack_require__("./node_modules/import-inspector/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_import_inspector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_import_inspector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__ = __webpack_require__("./src/helpers/loadableWithFetchData.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_containers_page_RootPageView__ = __webpack_require__("./src/containers/page/RootPageView.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_containers_page_PageView__ = __webpack_require__("./src/containers/page/PageView.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_containers_NotFoundView__ = __webpack_require__("./src/containers/NotFoundView.js");





var routes = [
    {
        path: '/',
        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "./src/containers/HomeView.js")), {
                webpackRequireWeakId: function () {
                    return /*require.resolve*/("./src/containers/HomeView.js");
                },
            });
        }),
        exact: true,
    },
    {
        path: '/create',
        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "./src/containers/CreateView.tsx")), {
                webpackRequireWeakId: function () {
                    return /*require.resolve*/("./src/containers/CreateView.tsx");
                },
            });
        }),
    },
    {
        path: '/page/support',
        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./src/containers/SupportView.js")), {
                webpackRequireWeakId: function () {
                    return /*require.resolve*/("./src/containers/SupportView.js");
                },
            });
        }),
    },
    {
        path: '/page/unsubscribe/:name',
        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./src/containers/UnsubscribeView.tsx")), {
                webpackRequireWeakId: function () {
                    return /*require.resolve*/("./src/containers/UnsubscribeView.tsx");
                },
            });
        }),
    },
    {
        path: '/page/create',
        redirectTo: '/create',
    },
    {
        path: '/:name',
        component: __WEBPACK_IMPORTED_MODULE_2_src_containers_page_RootPageView__["a" /* default */],
        routes: [
            {
                path: '/:name/payment',
                redirectTo: '/:name/dashboard/payment',
            },
            {
                path: '/:name/identity',
                redirectTo: '/:name',
            },
            {
                path: '/:name/address',
                redirectTo: '/:name',
            },
            {
                path: '/:name/tips/payments',
                redirectTo: '/:name/dashboard/payment',
            },
            {
                path: '/:name/dashboard/payment',
                redirectTo: '/:name/funds/account',
            },
            {
                path: '/:name/tips',
                redirectTo: '/:name/dashboard',
            },
            {
                path: '/:name/dashboard',
                component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/DashboardView.js")), {
                        webpackRequireWeakId: function () {
                            return /*require.resolve*/("./src/containers/DashboardView.js");
                        },
                    });
                }),
                routes: [
                    {
                        path: '/:name/dashboard/personalise',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/tips/ProfileView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/tips/ProfileView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/dashboard/promote',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/tips/PromoteView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/tips/PromoteView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/dashboard/advertise',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/tips/AdvertiseCauseView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/tips/AdvertiseCauseView.tsx");
                                },
                            });
                        }),
                    },
                ],
            },
            {
                path: '/:name/funds',
                component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/funds/RootFundsView.tsx")), {
                        webpackRequireWeakId: function () {
                            return /*require.resolve*/("./src/containers/funds/RootFundsView.tsx");
                        },
                    });
                }),
                routes: [
                    {
                        path: '/:name/funds/fees',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/funds/FeesView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/funds/FeesView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/funds/account',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/funds/AccountView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/funds/AccountView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/funds',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/funds/WithdrawView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/funds/WithdrawView.tsx");
                                },
                            });
                        }),
                        routes: [
                            {
                                path: '/:name/funds/additionaldetails',
                                component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                                    return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/AdditionalDetailsContainer.tsx")), {
                                        webpackRequireWeakId: function () {
                                            return /*require.resolve*/("./src/containers/AdditionalDetailsContainer.tsx");
                                        },
                                    });
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                path: '/:name/edit',
                component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/EditView.tsx")), {
                        webpackRequireWeakId: function () {
                            return /*require.resolve*/("./src/containers/EditView.tsx");
                        },
                    });
                }),
            },
            {
                path: '/:name/settings',
                component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/settings/SettingsView.tsx")), {
                        webpackRequireWeakId: function () {
                            return /*require.resolve*/("./src/containers/settings/SettingsView.tsx");
                        },
                    });
                }),
            },
            {
                path: '/:name/updates/:updateId',
                component: __WEBPACK_IMPORTED_MODULE_3_src_containers_page_PageView__["a" /* default */],
            },
            {
                path: '/:name',
                component: __WEBPACK_IMPORTED_MODULE_3_src_containers_page_PageView__["a" /* default */],
                routes: [
                    {
                        path: '/:name/coverphoto',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/CoverPhotoView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/CoverPhotoView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/story',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/StoryView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/StoryView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/pagelink',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/PageLinkView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/PageLinkView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/confirmidentity',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/ConfirmIdentityView.tsx"));
                        }),
                    },
                    {
                        path: '/:name/update',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/updates/UpdateView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/updates/UpdateView.tsx");
                                },
                            });
                        }),
                        exact: true,
                    },
                    {
                        path: '/:name/update/thank',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/updates/ThankView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/updates/ThankView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/update/milestone',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/updates/MilestoneView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/updates/MilestoneView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/update/share',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/updates/ShareView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/updates/ShareView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/thankyou/:activityHashId',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/ThankYouView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/ThankYouView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/qrcode',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/QRView.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/QRView.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/contact',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/contactOwner/ContactOwner.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/contactOwner/ContactOwner.tsx");
                                },
                            });
                        }),
                    },
                    {
                        path: '/:name/feedback/contact',
                        component: Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_loadableWithFetchData__["a" /* default */])(function () {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_import_inspector__["report"])(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./src/containers/contactOwner/GiveFeedback.tsx")), {
                                webpackRequireWeakId: function () {
                                    return /*require.resolve*/("./src/containers/contactOwner/GiveFeedback.tsx");
                                },
                            });
                        }),
                    },
                ],
            },
        ],
    },
    {
        component: __WEBPACK_IMPORTED_MODULE_4_src_containers_NotFoundView__["a" /* default */],
    },
];
/* harmony default export */ __webpack_exports__["a"] = (routes);


/***/ }),

/***/ "./src/styles/app.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/styles/crowdfunding.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./static/images/default-avatar.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./static/images/default-cover-image.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/element-closest/element-closest.js");
__webpack_require__("./src/client/polyfill.ts");
__webpack_require__("./src/client/publicPath.ts");
module.exports = __webpack_require__("./src/client.ts");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// main-bfe451c28c35f209a9e6.js